(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2083],{

/***/ 6003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "APP_SOCIAL_URL": function() { return /* binding */ APP_SOCIAL_URL; },
/* harmony export */   "COOKIES": function() { return /* binding */ COOKIES; },
/* harmony export */   "DEVICE_ID_BRIDGE_STATE": function() { return /* binding */ DEVICE_ID_BRIDGE_STATE; },
/* harmony export */   "DEVICE_MODEL_TYPE": function() { return /* binding */ DEVICE_MODEL_TYPE; },
/* harmony export */   "DOMAIN": function() { return /* binding */ DOMAIN; },
/* harmony export */   "GET_SLT_TOKEN_URL": function() { return /* binding */ GET_SLT_TOKEN_URL; },
/* harmony export */   "LOB_CATEGORY": function() { return /* binding */ LOB_CATEGORY; },
/* harmony export */   "PARTNER": function() { return /* binding */ PARTNER; },
/* harmony export */   "PARTNER_URLS": function() { return /* binding */ PARTNER_URLS; },
/* harmony export */   "PLATFORM": function() { return /* binding */ PLATFORM; },
/* harmony export */   "QUERY_PARAM_KEYS": function() { return /* binding */ QUERY_PARAM_KEYS; },
/* harmony export */   "SESSION_STORAGE_KEYS": function() { return /* binding */ SESSION_STORAGE_KEYS; },
/* harmony export */   "SOURCE": function() { return /* binding */ SOURCE; },
/* harmony export */   "SUB_DOMAIN": function() { return /* binding */ SUB_DOMAIN; },
/* harmony export */   "States": function() { return /* binding */ States; },
/* harmony export */   "URL_PATTERNS": function() { return /* binding */ URL_PATTERNS; },
/* harmony export */   "VALIDATION_MESSAGES": function() { return /* binding */ VALIDATION_MESSAGES; },
/* harmony export */   "camelToSnakeCase": function() { return /* binding */ camelToSnakeCase; },
/* harmony export */   "createSmartNavigator": function() { return /* binding */ createSmartNavigator; },
/* harmony export */   "deepCopy": function() { return /* binding */ deepCopy; },
/* harmony export */   "deleteLocalStorage": function() { return /* binding */ deleteLocalStorage; },
/* harmony export */   "disableEncrytionInWeb": function() { return /* binding */ disableEncrytionInWeb; },
/* harmony export */   "extractVariableValues": function() { return /* binding */ extractVariableValues; },
/* harmony export */   "extractVariables": function() { return /* binding */ extractVariables; },
/* harmony export */   "fetchWithTimeout": function() { return /* binding */ fetchWithTimeout; },
/* harmony export */   "floorWithoutDecimal": function() { return /* binding */ floorWithoutDecimal; },
/* harmony export */   "formatRateForDisplay": function() { return /* binding */ formatRateForDisplay; },
/* harmony export */   "generateUUID": function() { return /* binding */ generateUUID; },
/* harmony export */   "getCookie": function() { return /* binding */ getCookie; },
/* harmony export */   "getDefaultHeaders": function() { return /* binding */ getDefaultHeaders; },
/* harmony export */   "getDeviceId": function() { return /* binding */ getDeviceId; },
/* harmony export */   "getDeviceIdStatus": function() { return /* binding */ getDeviceIdStatus; },
/* harmony export */   "getDeviceIdWeb": function() { return /* binding */ getDeviceIdWeb; },
/* harmony export */   "getDeviceModelType": function() { return /* binding */ getDeviceModelType; },
/* harmony export */   "getDeviceType": function() { return /* binding */ getDeviceType; },
/* harmony export */   "getDeviceTypeV2": function() { return /* binding */ getDeviceTypeV2; },
/* harmony export */   "getHomeUrlByHostname": function() { return /* binding */ getHomeUrlByHostname; },
/* harmony export */   "getHostName": function() { return /* binding */ getHostName; },
/* harmony export */   "getJourneyIdFromCookie": function() { return /* binding */ getJourneyIdFromCookie; },
/* harmony export */   "getLastUrlSegment": function() { return /* binding */ getLastUrlSegment; },
/* harmony export */   "getLocalStorage": function() { return /* binding */ getLocalStorage; },
/* harmony export */   "getPageName": function() { return /* binding */ getPageName; },
/* harmony export */   "getPageUrl": function() { return /* binding */ getPageUrl; },
/* harmony export */   "getPartner": function() { return /* binding */ getPartner; },
/* harmony export */   "getPlatform": function() { return /* binding */ getPlatform; },
/* harmony export */   "getProductTypeFromPath": function() { return /* binding */ getProductTypeFromPath; },
/* harmony export */   "getSessionPiiDataOpts": function() { return /* binding */ getSessionPiiDataOpts; },
/* harmony export */   "getSessionStorageItem": function() { return /* binding */ getSessionStorageItem; },
/* harmony export */   "getUtilOptions": function() { return /* binding */ getUtilOptions; },
/* harmony export */   "getUtmParamsFromCookies": function() { return /* binding */ getUtmParamsFromCookies; },
/* harmony export */   "getVisitorId": function() { return /* binding */ getVisitorId; },
/* harmony export */   "hasCamelCaseKeys": function() { return /* binding */ hasCamelCaseKeys; },
/* harmony export */   "hasSnakeCaseKeys": function() { return /* binding */ hasSnakeCaseKeys; },
/* harmony export */   "hydrateVars": function() { return /* binding */ hydrateVars; },
/* harmony export */   "isApp": function() { return /* binding */ isApp; },
/* harmony export */   "isArray": function() { return /* binding */ isArray; },
/* harmony export */   "isEmptyObject": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "isHostGI": function() { return /* binding */ isHostGI; },
/* harmony export */   "isHostMMT": function() { return /* binding */ isHostMMT; },
/* harmony export */   "isMobile": function() { return /* binding */ isMobile; },
/* harmony export */   "isNull": function() { return /* binding */ isNull; },
/* harmony export */   "isNullOrEmptyValue": function() { return /* binding */ isNullOrEmptyValue; },
/* harmony export */   "isNullOrUndefined": function() { return /* binding */ isNullOrUndefined; },
/* harmony export */   "isObject": function() { return /* binding */ isObject; },
/* harmony export */   "isOnServer": function() { return /* binding */ isOnServer; },
/* harmony export */   "isPartnerHost": function() { return /* binding */ isPartnerHost; },
/* harmony export */   "isUndefined": function() { return /* binding */ isUndefined; },
/* harmony export */   "loadGTM": function() { return /* binding */ loadGTM; },
/* harmony export */   "mergeObjects": function() { return /* binding */ mergeObjects; },
/* harmony export */   "parseSeoUrl": function() { return /* binding */ parseSeoUrl; },
/* harmony export */   "redirectTo": function() { return /* binding */ redirectTo; },
/* harmony export */   "redirectWithDeferredTime": function() { return /* binding */ redirectWithDeferredTime; },
/* harmony export */   "regenerateTokenOnExpiry": function() { return /* binding */ regenerateTokenOnExpiry; },
/* harmony export */   "removeCookie": function() { return /* binding */ removeCookie; },
/* harmony export */   "removeEmptyKeys": function() { return /* binding */ removeEmptyKeys; },
/* harmony export */   "removeNullableField": function() { return /* binding */ removeNullableField; },
/* harmony export */   "removeSessionStorageItem": function() { return /* binding */ removeSessionStorageItem; },
/* harmony export */   "reviewPageViewEvent": function() { return /* binding */ reviewPageViewEvent; },
/* harmony export */   "roundAndIndianFormat": function() { return /* binding */ roundAndIndianFormat; },
/* harmony export */   "roundWithoutDecimal": function() { return /* binding */ roundWithoutDecimal; },
/* harmony export */   "setCookie": function() { return /* binding */ setCookie; },
/* harmony export */   "setJourneyIdCookie": function() { return /* binding */ setJourneyIdCookie; },
/* harmony export */   "setLocalStorage": function() { return /* binding */ setLocalStorage; },
/* harmony export */   "setSeoUtmParamsInSessionStorage": function() { return /* binding */ setSeoUtmParamsInSessionStorage; },
/* harmony export */   "setSessionPiiDataOpts": function() { return /* binding */ setSessionPiiDataOpts; },
/* harmony export */   "setSessionStorageItem": function() { return /* binding */ setSessionStorageItem; },
/* harmony export */   "setUtmParamsInUrl": function() { return /* binding */ setUtmParamsInUrl; },
/* harmony export */   "snakeToCamelCase": function() { return /* binding */ snakeToCamelCase; },
/* harmony export */   "toIndianLocaleFormat": function() { return /* binding */ toIndianLocaleFormat; },
/* harmony export */   "toLocaleStringINRFormat": function() { return /* binding */ toLocaleStringINRFormat; },
/* harmony export */   "transformToCamelCase": function() { return /* binding */ transformToCamelCase; },
/* harmony export */   "transformToSnakeCase": function() { return /* binding */ transformToSnakeCase; }
/* harmony export */ });
/* harmony import */ var _tm_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4178);
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8131);
/* harmony import */ var MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(156);
/* harmony import */ var MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8456);
/* harmony import */ var MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8277);
/* harmony import */ var MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_4__);
// libs/core-utils/src/lib/utils/authUtils/index.ts

async function regenerateTokenOnExpiry() {
  try {
    await (0,_tm_auth__WEBPACK_IMPORTED_MODULE_0__.loginIfPartnerLoggedin)();
    const isNowLoggedIn = await (0,_tm_auth__WEBPACK_IMPORTED_MODULE_0__.isUserLoggedin)();
    if (isNowLoggedIn) {
      console.log("Token regenerated successfully");
      return true;
    } else {
      console.warn("Token regeneration failed - user still not logged in");
      return false;
    }
  } catch (error) {
    console.error("Error during token regeneration:", error);
    return false;
  }
}

// libs/core-utils/src/lib/utils/fetchApi/index.ts
var getUpdatedAuthHeaders = () => {
  const updatedHeaders = {};
  if (typeof document !== "undefined") {
    const cookies = document.cookie.split(";").reduce(
      (acc, cookie) => {
        const [key, value] = cookie.trim().split("=");
        if (key && value) {
          acc[key] = decodeURIComponent(value);
        }
        return acc;
      },
      {}
    );
    if (cookies["mmt-auth"]) {
      updatedHeaders["mmt-auth"] = cookies["mmt-auth"];
    }
    if (cookies["x-tm-auth"]) {
      updatedHeaders["x-tm-auth"] = cookies["x-tm-auth"];
    }
  }
  return updatedHeaders;
};
var fetchWithTimeout = async (url, options, timeout = 1e4) => {
  const controller = new AbortController();
  const { signal } = controller;
  const fetchWithRetry = async (retry, updateAuthHeaders = false) => {
    let fetchOptions = retry ? { ...options, signal, headers: { ...options.headers, retry: "1" } } : { ...options, signal };
    if (updateAuthHeaders) {
      const updatedAuthHeaders = getUpdatedAuthHeaders();
      fetchOptions = {
        ...fetchOptions,
        headers: { ...fetchOptions.headers, ...updatedAuthHeaders }
      };
    }
    const fetchPromise = fetch(url, fetchOptions);
    const timeoutId = setTimeout(() => controller.abort(), timeout);
    try {
      const response2 = await fetchPromise;
      clearTimeout(timeoutId);
      return response2;
    } catch (error) {
      clearTimeout(timeoutId);
      if (error instanceof Error && error.name === "AbortError") {
        throw new Error("failed to fetch");
      }
      throw error;
    }
  };
  const handleTokenExpiryAndRetry = async (response2, context) => {
    try {
      const responseClone = response2.clone();
      const data = await responseClone.json();
      if (data?.apiData?.user?.is_tm_auth_expired === true) {
        console.log(
          `Token expired detected in ${context} response, regenerating...`
        );
        const tokenRegenerated = await regenerateTokenOnExpiry();
        if (tokenRegenerated) {
          console.log("Token regenerated, retrying original request...");
          const newResponse = await fetchWithRetry(true, true);
          return newResponse;
        } else {
          console.warn("Token regeneration failed");
          return response2;
        }
      }
      return response2;
    } catch (error) {
      console.debug(
        `Could not parse ${context} response for token expiry check:`,
        error
      );
      return response2;
    }
  };
  let response = await fetchWithRetry(false);
  if (!response.ok) {
    const responseClone = response.clone();
    const data = await responseClone.json();
    if (data?.apiData?.user?.is_tm_auth_expired) {
      response = await handleTokenExpiryAndRetry(
        response,
        response.ok ? "successful" : "failed"
      );
    } else {
      response = await fetchWithRetry(true);
    }
  } else {
    response = await handleTokenExpiryAndRetry(
      response,
      response.ok ? "successful" : "failed"
    );
  }
  return response;
};

// libs/core-utils/src/lib/constants/partner.ts
var PARTNER = {
  MMT: "mmt",
  GI: "gi",
  TRIPMONEY: "tripmoney",
  UNKNOWN: "unknown"
};

// libs/core-utils/src/lib/utils/hostUtils/index.ts
function isOnServer() {
  if (typeof window === "undefined") {
    return true;
  }
  return false;
}
function isHostMMT() {
  if (isOnServer()) {
    return null;
  }
  if (window?.location?.hostname?.includes("makemytrip")) {
    return true;
  }
  return false;
}
function isHostGI() {
  if (isOnServer()) {
    return null;
  }
  if (window?.location?.hostname?.includes("goibibo")) {
    return true;
  }
  return false;
}
function getHostName() {
  if (isOnServer()) {
    return null;
  }
  return window.location.hostname;
}
var isPartnerHost = (partner) => {
  const hostname = getHostName() || "";
  return hostname.includes(partner);
};
function getPartner() {
  if (isOnServer()) {
    return "";
  }
  if (isHostMMT()) {
    return PARTNER.MMT;
  } else if (isHostGI()) {
    return PARTNER.GI;
  } else {
    return PARTNER.MMT;
  }
}

// libs/core-utils/src/lib/constants/index.ts
var PLATFORM = /* @__PURE__ */ ((PLATFORM2) => {
  PLATFORM2["PWA"] = "pwa";
  PLATFORM2["DESKTOP"] = "desktop";
  PLATFORM2["APP"] = "app";
  return PLATFORM2;
})(PLATFORM || {});
var DEVICE_MODEL_TYPE = /* @__PURE__ */ ((DEVICE_MODEL_TYPE2) => {
  DEVICE_MODEL_TYPE2["APP"] = "App";
  DEVICE_MODEL_TYPE2["WEB"] = "Web";
  return DEVICE_MODEL_TYPE2;
})(DEVICE_MODEL_TYPE || {});
var SOURCE = {
  TRIPMONEY: "tripmoney",
  MAKEMYTRIP: "makemytrip",
  GOIBIBO: "goibibo",
  LOCALHOST: "localhost",
  FOREX_EXPERT: "forexexpert"
};
var COOKIES = {
  MMT_AUTH_KEY: "mmt-auth",
  TM_AUTH_KEY: "x-tm-auth",
  MMT_LOGIN_REDIRECT_KEY: "loginActionDetails",
  TM_MMT_AUTH_KEY: "tm-mmt-auth",
  GI_AUTH_KEY: "OAUTH-GOIBIBO",
  TM_GI_AUTH_KEY: "tm-gi-auth",
  INR_SESSION_COOKIE: "is-initial-landing",
  MMT_DEVICE_ID: "dvid",
  GI_DEVICE_ID: "__gi_vid",
  MMT_FOREX_COOKIE: "mmt_forex",
  CURRENCY_DEEPLOGIN_ALLOWED: "currency_deeplogin_allowed",
  PDT_JOURNEY_ID: "x-jo-id",
  CROSS_SELL_FLOW: "cross_sell_flow",
  CROSS_SELL_NUDGE_SHOWN: "cross_sell_nudge_shown",
  FOREX_AGENT_AUTH_KEY: typeof window !== "undefined" && window?.location?.hostname?.includes("makemytrip") ? "mmt-auth-afftmfxmmtforexexp" : "mmt-auth-afftmfxgiforexexp",
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign"
};
var SUB_DOMAIN = {
  MAKEMYTRIP: ".makemytrip.com",
  GOIBIBO: ".goibibo.com",
  TRIPMONEY: ".tripmoney.com",
  LOCALHOST: "localhost"
};
var DOMAIN = {
  MAKEMYTRIP: "www.makemytrip.com"
};
var SESSION_STORAGE_KEYS = {
  USER_LOCATION_SESSION_KEY: "user_location",
  REQUEST_ID: "request_id",
  IS_FALLBACK_CITY_MODE: "is_fallback_city_mode",
  ITINERARY_ID: "itinerary_id",
  TICKET_ID: "ticket_id",
  FOREX_EXPERIMENTS: "forex_experiments",
  SOURCE_REACT_NATIVE: "rn"
};
var QUERY_PARAM_KEYS = {
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  USER_LOCATION: "user_location"
};
var getSessionPiiDataOpts = { isPiiData: true, shouldParseJson: true };
var setSessionPiiDataOpts = {
  isPiiData: true,
  shouldStringifyJson: true
};
var DEVICE_ID_BRIDGE_STATE = {
  AVAILABLE: "AVAILABLE",
  NOT_AVAILABLE: "NOT_AVAILABLE",
  NON_FUNCTIONAL: "NON_FUNCTIONAL"
};
var LOB_CATEGORY = {
  PC: "PC",
  CN: "CN"
};
var URL_PATTERNS = {
  PRODUCT_TYPE_REGEX: /\/forex\/(pc|cn)\//i
};
var PARTNER_URLS = {
  MMT: {
    FOREX_HOME: "https://www.makemytrip.com/forex"
  },
  GOIBIBO: {
    FOREX_HOME: "https://tripmoney.goibibo.com/partners/gi/forex/listing"
  }
};
var States = /* @__PURE__ */ ((States2) => {
  States2["PRELOADING"] = "PRELOADING";
  States2["LOADING"] = "LOADING";
  States2["SUCCESS"] = "SUCCESS";
  States2["FAILURE"] = "FAILURE";
  return States2;
})(States || {});

// libs/core-utils/src/lib/utils/mmt-ui-utils/cookieUtils.ts


// libs/core-utils/src/lib/utils/mmt-ui-utils/clientStorageUtils.ts



// libs/core-utils/src/lib/utils/deviceUtils/deviceDetection.ts
var isMobile = function() {
  let check = false;
  (function(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      a
    ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|acer|aos|aiko|airn|alav|alca|alco|amoi|anex|anny|anyw|aptu|arch|argo|aste|asus|attw|audi|aurm|aur|avan|beck|bell|bnq|bilb|bird|blac|blaz|brew|bumb|bwn|bwu|c55|capi|ccwa|cdm|cell|chtm|cldc|cmd|comp|cond|craw|dait|dall|dang|dbte|dcs|devi|dica|dmob|doc|dopo|ds12|dsd|el49|elai|eml2|emul|eric|erk0|esl8|ez40|ezos|ezwa|ezze|fetc|fly|g1 u|g560|gene|gf5|gmo|gow|good|grad|grun|haie|hcit|hdm|hdp|hdt|hei|hipt|hita|hpi|hip|hsc|htc|htp|hua|htc|i20|igo|ima|i230|iac|iac|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|jat|java|jbro|jemu|jigs|kddi|keji|kgt|klon|kpt|kwc|kyoc|leno|lexi|lg g|lgk|lgl|lgu|lg50|lg54|libw|lynx|m1w|m3ga|m50|mate|maiu|maxo|mc01|mc21|mca|mcr|merc|meri|mio8|mioa|mits|mmef|mo01|mo02|mobi|mode|modo|mot|mov|mozz|mt50|mtp1|mv|mwbp|mywa|n100|n101|n102|n202|n203|n300|n302|n500|n502|n505|n700|n701|n710|nec|nem|neon|netf|new|nokia|nzph|o2im|opti|opwv|oran|owg1|p800|pana|pand|pant|pdxg|pg13|pg1|pg2|pg3|pg4|pg5|pg6|pg7|pg8|pgc|phil|pire|play|pluc|pn2|pock|port|pose|prox|psio|ptg|qaa|qc07|qc12|qc21|qc32|qc60|qc2|qc3|qc4|qc5|qc6|qc7|qi|qtek|r380|r600|raks|rim9|rove|rozo|s55|sage|sama|samm|sams|sany|sava|sc01|sch|scoo|scp|sdk|sec|sec0|sec1|sec47|secm|send|seri|sgh|shar|siem|sk0|sl45|slid|smal|smar|smb3|smitt|smtt|soft|sony|sp01|sph|spv|spv|sy01|symb|t218|t250|t600|t610|t618|tagt|talk|tcl|tdg|teli|telm|tim|tmo|topl|tosh|ts70|tsm|tsm3|tsm5|tx9|upb|upg1|upsi|utst|v400|v750|veri|virg|vite|vk40|vk50|vk51|vk52|vk53|vkv|vm40|voda|vulc|vx52|vx53|vx60|vx61|vx70|vx80|vx81|vx83|vx85|vx98|w3c|webc|whit|wig|winc|winw|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
      a ? a.substr(0, 4) : null
    ))
      check = true;
  })(
    !isOnServer() ? navigator.userAgent || navigator.vendor || window.opera : null
  );
  return check;
};
var getDeviceType = () => {
  if (isOnServer())
    return null;
  return isMobile() ? "App" /* APP */ : "Web" /* WEB */;
};
var getDeviceTypeV2 = () => {
  if (isOnServer())
    return null;
  if (window?.mmt_android_bridge || window?.app_bridge) {
    return "App" /* APP */;
  }
  return "Web" /* WEB */;
};
function getPlatform() {
  if (isOnServer())
    return null;
  const deviceType = getDeviceTypeV2();
  if (deviceType === "Web" /* WEB */) {
    if (isMobile()) {
      return "pwa" /* PWA */;
    }
    return "desktop" /* DESKTOP */;
  }
  return "app" /* APP */;
}
var isApp = () => {
  if (isOnServer()) {
    return false;
  }
  return window?.app_bridge || window?.webkit?.messageHandlers?.login ? true : false;
};

// libs/core-utils/src/lib/utils/urlUtils/index.ts
function getProductTypeFromPath() {
  if (isOnServer()) {
    return null;
  }
  const urlPath = window.location.pathname;
  const match = urlPath.match(URL_PATTERNS.PRODUCT_TYPE_REGEX);
  if (match) {
    const productCode = match[1].toUpperCase();
    if (Object.values(LOB_CATEGORY)?.includes(productCode)) {
      return productCode;
    }
  }
  return null;
}
function createSmartNavigator(router) {
  return (url) => {
    if (isOnServer()) {
      return;
    }
    if (router) {
      router.push(url);
      return;
    }
    console.warn("Next.js Router not available, using window.location");
    window.location.href = url;
  };
}
function getPageName() {
  if (isOnServer())
    return "";
  const pathname = window.location.pathname;
  function findValidSegment(segments) {
    if (segments.length === 0) {
      return "";
    }
    const lastSegment = segments[segments.length - 1];
    if (/^[a-zA-Z-]+$/.test(lastSegment)) {
      return lastSegment;
    } else {
      segments.pop();
      return findValidSegment(segments);
    }
  }
  try {
    const pathSegments = pathname.split("/").filter((segment) => segment !== "");
    return findValidSegment(pathSegments);
  } catch (e) {
    console.error(e?.message);
  }
  return window.location.pathname;
}
function getPageUrl() {
  if (isOnServer()) {
    return null;
  }
  return window.location.href;
}
var getUtmParamsFromCookies = () => {
  const utm_medium = getCookie(COOKIES.UTM_MEDIUM, false, { path: "/" });
  const utm_source = getCookie(COOKIES.UTM_SOURCE, false, { path: "/" });
  const utm_campaign = getCookie(COOKIES.UTM_CAMPAIGN, false, { path: "/" });
  return { utm_medium, utm_source, utm_campaign };
};
var setUtmParamsInUrl = (url) => {
  const { utm_medium, utm_source, utm_campaign } = getUtmParamsFromCookies();
  const urlObj = new URL(url);
  if (utm_medium)
    urlObj.searchParams.append(QUERY_PARAM_KEYS.UTM_MEDIUM, utm_medium);
  if (utm_source)
    urlObj.searchParams.append(QUERY_PARAM_KEYS.UTM_SOURCE, utm_source);
  if (utm_campaign)
    urlObj.searchParams.append(QUERY_PARAM_KEYS.UTM_CAMPAIGN, utm_campaign);
  return urlObj.toString();
};
function getHomeUrlByHostname() {
  if (isOnServer()) {
    return "/";
  }
  const hostname = window.location.hostname;
  if (hostname.includes("makemytrip.com")) {
    return PARTNER_URLS.MMT.FOREX_HOME;
  } else if (hostname.includes("goibibo.com")) {
    return PARTNER_URLS.GOIBIBO.FOREX_HOME;
  }
  return "/";
}
function getLastUrlSegment(pathname) {
  const currentPath = pathname || (typeof window !== "undefined" ? window.location.pathname : "");
  if (!currentPath)
    return "";
  const pathSegments = currentPath.split("/").filter((segment) => segment.length > 0);
  return pathSegments.at(-1) || "";
}

// libs/core-utils/src/lib/utils/mmt-ui-utils/clientStorageUtils.ts
function disableEncrytionInWeb() {
  return getDeviceType() === "Web" /* WEB */ && isHostMMT();
}
function getUtilOptions(options) {
  return disableEncrytionInWeb() ? { ...options, isPiiData: false } : options;
}
var { ES, N_ES } = MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__.itemType;
function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
}
function setLocalStorage(key, value, isEssential = false, options = {
  shouldStringifyJson: true
}) {
  const transformedOptions = getUtilOptions(options);
  const itemTypeValue = getEssentialItemType(isEssential);
  (0,MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__.setItem)(key, value, transformedOptions, itemTypeValue);
}
function getLocalStorage(key, isEssential = false, options = {
  shouldParseJson: true
}) {
  const transformedOptions = getUtilOptions(options);
  const itemTypeValue = getEssentialItemType(isEssential);
  return (0,MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__.getItem)(key, transformedOptions, itemTypeValue);
}
function deleteLocalStorage(key) {
  (0,MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_1__.removeItem)(key);
}
function setSessionStorageItem(key, value, isEssential = false, options = {
  shouldStringifyJson: true
}) {
  const transformedOptions = getUtilOptions(options);
  const itemTypeValue = getEssentialItemType(isEssential);
  (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2__.setItemBySession)(key, value, transformedOptions, itemTypeValue);
}
function getSessionStorageItem(key, isEssential = false, options = {
  shouldParseJson: true
}) {
  const transformedOptions = getUtilOptions(options);
  const itemTypeValue = getEssentialItemType(isEssential);
  return (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2__.getItemBySession)(key, transformedOptions, itemTypeValue);
}
function removeSessionStorageItem(key) {
  (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_2__.removeItemBySession)(key);
}
function setSeoUtmParamsInSessionStorage(utm_source, utm_medium) {
  if (utm_source) {
    setSessionStorageItem("utm_source", utm_source, false);
  }
  if (utm_medium) {
    setSessionStorageItem("utm_medium", utm_medium, false);
  }
  const lastSegment = getLastUrlSegment();
  if (lastSegment) {
    setSessionStorageItem("utm_campaign", lastSegment, false);
  }
}

// libs/core-utils/src/lib/utils/mmt-ui-utils/cookieUtils.ts
var { ES: ES2, N_ES: N_ES2 } = MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__.itemType;
function getEssentialItemType2(isEssential) {
  return isEssential ? ES2 : N_ES2;
}
function setCookie(name, value, isEssential = false, options) {
  options = getUtilOptions(options);
  (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__.setCookie)(name, value, options, getEssentialItemType2(isEssential));
}
function getCookie(name, isEssential = false, options = {}) {
  options = getUtilOptions(options);
  return (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__.getCookie)(name, options, getEssentialItemType2(isEssential));
}
function removeCookie(name, options = {}) {
  (0,MMT_UI_storages_client_cookieStorage__WEBPACK_IMPORTED_MODULE_3__.removeCookie)(name, options);
}

// libs/core-utils/src/lib/utils/mmt-ui-utils/visitorIdUtils.ts

var { getVisitorId } = (MMT_UI_visitorDvid_visitorDvid_js__WEBPACK_IMPORTED_MODULE_4___default());

// libs/core-utils/src/lib/utils/deviceUtils/index.ts
var getDeviceIdWeb = (partner) => {
  switch (partner) {
    case PARTNER.MMT:
      return getCookie(COOKIES.MMT_DEVICE_ID, true) || getVisitorId();
    case PARTNER.GI:
      return getCookie(COOKIES.GI_DEVICE_ID, true) || null;
    default:
      return null;
  }
};
var getDeviceModelType = () => {
  if (isOnServer())
    return null;
  if (window?.mmt_android_bridge || window?.app_bridge) {
    return "App" /* APP */;
  }
  return "Web" /* WEB */;
};
var getDeviceIdApp = () => {
  if (isOnServer()) {
    return null;
  }
  return window?.app_bridge?.deviceId?.() || null;
};
var getDeviceId = (partner) => {
  if (isOnServer()) {
    return null;
  }
  const deviceType = getDeviceTypeV2();
  if (deviceType === "Web" /* WEB */) {
    return getDeviceIdWeb(partner);
  } else if (deviceType === "App" /* APP */) {
    return getDeviceIdApp();
  }
  return null;
};
var getDeviceIdStatus = () => {
  if (isOnServer()) {
    return null;
  }
  if (isApp()) {
    if (window?.app_bridge?.deviceId) {
      if (window?.app_bridge?.deviceId?.()) {
        return DEVICE_ID_BRIDGE_STATE.AVAILABLE;
      } else {
        return DEVICE_ID_BRIDGE_STATE.NON_FUNCTIONAL;
      }
    } else {
      return DEVICE_ID_BRIDGE_STATE.NOT_AVAILABLE;
    }
  }
  return null;
};

// libs/core-utils/src/lib/utils/objectUtils/index.ts
function removeNullableField(obj) {
  let result = null;
  for (const [key, value] of Object.entries(obj)) {
    if (value != null) {
      if (!result)
        result = {};
      result[key] = value;
    }
  }
  return result;
}
function removeEmptyKeys(obj) {
  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value) {
      result[key] = value;
    }
  }
  return result;
}
function isObject(val) {
  const toStr = Object.prototype.toString;
  return toStr.call(val) === "[object Object]";
}
function isNull(val) {
  return val === null;
}
function isUndefined(val) {
  return val === void 0;
}
function isNullOrUndefined(val) {
  return isNull(val) || isUndefined(val);
}
function isEmptyObject(val) {
  if (!isObject(val)) {
    return false;
  }
  return Object.keys(val).length === 0;
}
function isNullOrEmptyValue(val) {
  return isNull(val) || isUndefined(val) || isEmptyObject(val) || Number.isNaN(val) || val === "";
}
function mergeObjects(obj1, obj2) {
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    return obj1.map((item, index) => {
      if (index < obj2.length) {
        return mergeObjects(item, obj2[index]);
      }
      return item;
    }).concat(obj2.slice(obj1.length));
  } else if (isObject(obj1) && isObject(obj2)) {
    const result = { ...obj1 };
    for (const key in obj2) {
      if (Object.prototype.hasOwnProperty.call(obj2, key)) {
        const val1 = result[key];
        const val2 = obj2[key];
        if (isObject(val1) && isObject(val2)) {
          result[key] = mergeObjects(val1, val2);
        } else if (Array.isArray(val1) && Array.isArray(val2)) {
          result[key] = mergeObjects(val1, val2);
        } else {
          result[key] = val2;
        }
      }
    }
    return result;
  } else {
    return obj2;
  }
}
function hydrateVars(input, overrideVars = {}) {
  if (Array.isArray(input)) {
    return input.map((item) => hydrateVars(item, overrideVars));
  } else if (typeof input === "object" && input !== null) {
    const hydratedObject = {};
    for (const key in input) {
      if (key === "vars" && typeof input[key] === "object") {
        for (const varKey in input[key]) {
          const varValue = overrideVars[varKey] || input[key][varKey];
          for (const innerKey in hydratedObject) {
            if (typeof hydratedObject[innerKey] === "string") {
              hydratedObject[innerKey] = hydratedObject[innerKey].replace(
                `{{${varKey}}}`,
                varValue
              );
            }
          }
        }
      } else {
        hydratedObject[key] = hydrateVars(input[key], overrideVars);
      }
    }
    return hydratedObject;
  } else if (typeof input === "string") {
    return input.replace(
      /\{\{([^}]+)\}\}/g,
      (match, p1) => overrideVars && p1.trim() in overrideVars ? String(overrideVars[p1.trim()]) : match
    );
  }
  return input;
}
function deepCopy(value, seen = /* @__PURE__ */ new WeakMap()) {
  if (value === null || typeof value !== "object") {
    return value;
  }
  if (seen.has(value)) {
    return seen.get(value);
  }
  if (value instanceof Date) {
    return new Date(value.getTime());
  }
  if (value instanceof RegExp) {
    return new RegExp(value.source, value.flags);
  }
  if (value instanceof Map) {
    const copy2 = /* @__PURE__ */ new Map();
    seen.set(value, copy2);
    value.forEach((val, key) => {
      copy2.set(deepCopy(key, seen), deepCopy(val, seen));
    });
    return copy2;
  }
  if (value instanceof Set) {
    const copy2 = /* @__PURE__ */ new Set();
    seen.set(value, copy2);
    value.forEach((val) => {
      copy2.add(deepCopy(val, seen));
    });
    return copy2;
  }
  if (Array.isArray(value)) {
    const copy2 = [];
    seen.set(value, copy2);
    value.forEach((item, index) => {
      copy2[index] = deepCopy(item, seen);
    });
    return copy2;
  }
  const copy = {};
  seen.set(value, copy);
  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      copy[key] = deepCopy(value[key], seen);
    }
  }
  return copy;
}
function snakeToCamelCase(str) {
  return str.replace(/(_\w)/g, (matches) => matches[1].toUpperCase());
}
function camelToSnakeCase(str) {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
function transformToCamelCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => transformToCamelCase(item));
  }
  if (obj !== null && typeof obj === "object") {
    const newObj = {};
    for (const key in obj) {
      const camelKey = snakeToCamelCase(key);
      newObj[camelKey] = transformToCamelCase(obj[key]);
    }
    return newObj;
  }
  return obj;
}
function transformToSnakeCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => transformToSnakeCase(item));
  }
  if (obj !== null && typeof obj === "object") {
    const newObj = {};
    for (const key in obj) {
      const snakeKey = camelToSnakeCase(key);
      newObj[snakeKey] = transformToSnakeCase(obj[key]);
    }
    return newObj;
  }
  return obj;
}
function hasSnakeCaseKeys(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
    return false;
  }
  for (const key in obj) {
    if (key.includes("_")) {
      return true;
    }
    if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
      if (hasSnakeCaseKeys(obj[key])) {
        return true;
      }
    }
  }
  return false;
}
function hasCamelCaseKeys(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
    return false;
  }
  for (const key in obj) {
    if (/[A-Z]/.test(key)) {
      return true;
    }
    if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
      if (hasCamelCaseKeys(obj[key])) {
        return true;
      }
    }
  }
  return false;
}
function extractVariableValues(variables) {
  if (!variables || typeof variables !== "object") {
    return {};
  }
  const result = {};
  for (const [key, variable] of Object.entries(variables)) {
    if (variable && typeof variable === "object" && "value" in variable) {
      result[key] = variable.value;
    }
  }
  return result;
}
function extractVariables(variables) {
  return extractVariableValues(variables);
}

// libs/core-utils/src/lib/utils/currencyUtils/index.ts
var toLocaleStringINRFormat = (currency, maximumFractionDigits = 2, minimumFractionDigits = 2) => {
  if (currency) {
    return Number(currency).toLocaleString("en-IN", {
      minimumFractionDigits: minimumFractionDigits > maximumFractionDigits ? 2 : minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits == 0 ? 0 : maximumFractionDigits > 2 ? maximumFractionDigits : 2
    });
  }
  return "0";
};
var formatRateForDisplay = (rate) => {
  const numericRate = Number(rate);
  if (isNaN(numericRate))
    return "";
  return numericRate > 1 ? numericRate.toFixed(2) : numericRate.toFixed(4);
};
var roundWithoutDecimal = (value) => {
  return Math.round(value);
};
var floorWithoutDecimal = (value) => {
  return Math.floor(value);
};
var toIndianLocaleFormat = (value) => {
  return new Intl.NumberFormat("en-IN").format(value);
};
var roundAndIndianFormat = (value) => {
  return toIndianLocaleFormat(roundWithoutDecimal(value));
};
var generateUUID = () => {
  let d = (/* @__PURE__ */ new Date()).getTime();
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    d += performance.now();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : r & 3 | 8).toString(16);
  });
};
var cityToPincodeMapping = {
  vijaywada: "509132",
  vadodara: "390001",
  thane: "400614",
  surat: "394101",
  ranchi: "829205",
  pune: "410301",
  patna: "800001",
  panvel: "410206",
  panchkula: "133301",
  "greater noida": "201308",
  "navi mumbai": "400702",
  mumbai: "400001",
  mohali: "140103",
  mangalore: "574141",
  ludhiana: "141001",
  lucknow: "226001",
  kozhikode: "673001",
  kolkata: "700001",
  kochi: "686667",
  kanpur: "208001",
  jalandhar: "144001",
  jhansi: "226010",
  jabalpur: "482001",
  hyderabad: "500001",
  guwahati: "781001",
  gurgaon: "122001",
  ghaziabad: "201001",
  faridabad: "121001",
  delhi: "110001",
  cuttack: "752120",
  coimbatore: "641001",
  chennai: "600001",
  chandigarh: "160001",
  bhubaneswar: "751001",
  bhopal: "462001",
  bareilly: "281001",
  bangalore: "560001",
  amritsar: "743001",
  ahmedabad: "380001",
  dehradun: "248199",
  indore: "453001",
  agra: "282001",
  visakhpatnam: "133002",
  rajkot: "380005",
  anand: "387310",
  raipur: "493116",
  jodhpur: "342001",
  karnal: "132001",
  madurai: "625501",
  mysore: "570016",
  nagpur: "440001",
  nasik: "422001",
  nawanshahar: "144514",
  thiruvananthapuram: "695001",
  udaipur: "307025",
  varanasi: "221001",
  aurangal: "506355",
  amaravati: "431151",
  goa: "403503",
  salem: "385102",
  patiala: "147001",
  shimla: "174001",
  jammu: "181152",
  kapurthala: "144001",
  hissar: "335129",
  kota: "324001",
  budaun: "283151",
  rudrapur: "324801"
};
var currencyNameToCodeMapping = {
  // Existing mappings
  "us-dollar": "USD",
  euro: "EUR",
  "canadian-dollar": "CAD",
  pound: "GBP",
  "australian-dollar": "AUD",
  dirham: "AED",
  "uae-dirham": "AED",
  // Alternative key for dirham
  "sri-lankan-rupee": "LKR",
  "south-african-rand": "ZAR",
  "thai-baht": "THB",
  "singapore-dollar": "SGD",
  "swiss-franc": "CHF",
  "hong-kong-dollar": "HKD",
  "saudi-riyal": "SAR",
  "saudi-arabian-riyal": "SAR",
  // Alternative key for saudi-riyal
  "norwegian-krone": "NOK",
  "japanese-yen": "JPY",
  "new-zealand-dollar": "NZD",
  "malaysian-ringgit": "MYR",
  "bahraini-dinar": "BHD",
  "russian-ruble": "RUB",
  "danish-krone": "DKK",
  "indonesian-rupiah": "IDR",
  "philippine-peso": "PHP",
  "vietnamese-dong": "VND",
  "mauritian-rupee": "MUR",
  "bangladeshi-taka": "BDT",
  "polish-zloty": "PLN",
  "korean-won": "KRW",
  "south-korean-won": "KRW",
  // Alternative key for korean-won
  // Additional currencies with proper mappings
  "kuwaiti-dinar": "KWD",
  "omani-rial": "OMR",
  "swedish-krona": "SEK",
  "maldivian-rufiyaa": "MVR",
  "macanese-pataca": "MOP",
  "qatari-riyal": "QAR",
  "turkish-lira": "TRY",
  "chinese-yuan-renminbi": "CNY",
  "egyptian-pound": "EGP",
  "brazilian-real": "BRL",
  "israeli-new-shekel": "ILS",
  "azerbaijani-manat": "AZN",
  "kenyan-shilling": "KES",
  "czech-koruna": "CZK",
  "georgian-lari": "GEL",
  // Currencies with USD fallback (no proper mapping available)
  "indian-rupee": "USD",
  // No mapping found - using USD
  "jordanian-dinar": "USD",
  // No mapping found - using USD
  "pakistani-rupee": "USD",
  // No mapping found - using USD
  "iranian-rial": "USD",
  // No mapping found - using USD
  "nepalese-rupee": "USD",
  // No mapping found - using USD
  "ukrainian-hryvnia": "USD",
  // No mapping found - using USD
  "iraqi-dinar": "USD",
  // No mapping found - using USD
  "mexican-peso": "USD",
  // No mapping found - using USD
  "fiji-dollar": "USD",
  // No mapping found - using USD
  "venezuelan-bolivar": "USD",
  // No mapping found - using USD
  "afghan-afghani": "USD",
  // No mapping found - using USD
  "brunei-dollar": "USD",
  // No mapping found - using USD
  "hungarian-forint": "USD",
  // No mapping found - using USD
  "new-taiwan-dollar": "USD",
  // No mapping found - using USD
  naira: "USD",
  // No mapping found - using USD
  "argentine-peso": "USD",
  // No mapping found - using USD
  "colombian-peso": "USD",
  // No mapping found - using USD
  "chilean-peso": "USD",
  // No mapping found - using USD
  "moroccan-dirham": "USD",
  // No mapping found - using USD
  "bulgarian-lev": "USD",
  // No mapping found - using USD
  "croatian-kuna": "USD",
  // No mapping found - using USD
  "east-caribbean-dollar": "USD",
  // No mapping found - using USD
  "ghana-cedi": "USD",
  // No mapping found - using USD
  "serbian-dinar": "USD",
  // No mapping found - using USD
  "ugandan-shilling": "USD",
  // No mapping found - using USD
  "zambian-kwacha": "USD",
  // No mapping found - using USD
  "belarusian-ruble": "USD",
  // No mapping found - using USD
  "bhutanese-ngultrum": "USD",
  // No mapping found - using USD
  "jamaican-dollar": "USD",
  // No mapping found - using USD
  "kazakhstani-tenge": "USD",
  // No mapping found - using USD
  "lebanese-pound": "USD",
  // No mapping found - using USD
  "romanian-leu": "USD",
  // No mapping found - using USD
  "angolan-kwanza": "USD",
  // No mapping found - using USD
  "bahamian-dollar": "USD",
  // No mapping found - using USD
  "cambodian-riel": "USD",
  // No mapping found - using USD
  "libyan-dinar": "USD",
  // No mapping found - using USD
  "tanzania-shilling": "USD",
  // No mapping found - using USD
  "algerian-dinar": "USD",
  // No mapping found - using USD
  "ethopian-birr": "USD",
  // No mapping found - using USD
  "myanmar-kyat": "USD",
  // No mapping found - using USD
  "dominican-peso": "USD",
  // No mapping found - using USD
  "yemeni-rial": "USD",
  // No mapping found - using USD
  "costa-rican-colon": "USD",
  // No mapping found - using USD
  "uruguayan-peso": "USD",
  // No mapping found - using USD
  "bolivian-boliviano": "USD",
  // No mapping found - using USD
  "guatemalan-quetzal": "USD",
  // No mapping found - using USD
  "honduran-lempira": "USD",
  // No mapping found - using USD
  "nuevo-sol": "USD"
  // No mapping found - using USD
};
var currencyCodeMapping = {
  pln: "PLN",
  // Polish Zloty
  krw: "KRW",
  // Korean Won
  idr: "IDR",
  // Indonesian Rupiah
  php: "PHP",
  // Philippine Peso
  vnd: "VND",
  // Vietnam Dong
  jpy: "JPY",
  // Japanese Yen
  nok: "NOK",
  // Norwegian Krone
  rub: "RUB",
  // Russian Ruble
  nzd: "NZD",
  // New Zealand Dollar
  mur: "MUR",
  // Mauritius Rupee
  thb: "THB",
  // Thai Baht
  aed: "AED",
  // UAE Dirham
  lkr: "LKR",
  // Sri Lankan Rupee
  myr: "MYR",
  // Malaysian Ringgit
  sgd: "SGD",
  // Singapore Dollar
  chf: "CHF",
  // Swiss Franc
  kwd: "KWD",
  // Kuwaiti Dinar
  eur: "EUR",
  // Euro
  zar: "ZAR",
  // South African Rand
  cad: "CAD",
  // Canadian Dollar
  hkd: "HKD",
  // Hong Kong Dollar
  sar: "SAR",
  // Saudi Riyal
  gbp: "GBP",
  // British Pound
  bdt: "BDT",
  // Bangladesh Taka
  bhd: "BHD",
  // Bahraini Dinar
  aud: "AUD",
  // Australian Dollar
  dkk: "DKK"
  // Danish Krone
};
function parseSeoUrl(pathname) {
  if (!pathname) {
    if (typeof window !== "undefined") {
      pathname = window.location.pathname;
    } else {
      return null;
    }
  }
  const cityExchangeMatch = pathname.match(
    /\/tripmoney\/currency-exchange-in-([^/]+)$/
  );
  if (cityExchangeMatch && cityExchangeMatch[1]) {
    const cityName = cityExchangeMatch[1].toLowerCase();
    const pincode = cityToPincodeMapping[cityName] || null;
    return {
      currencyCode: "USD",
      pincode
    };
  }
  const cityAirportExchangeMatch = pathname.match(
    /\/tripmoney\/currency-exchange-in-([^/]+)\/airport$/
  );
  if (cityAirportExchangeMatch && cityAirportExchangeMatch[1]) {
    const cityName = cityAirportExchangeMatch[1].toLowerCase();
    const pincode = cityToPincodeMapping[cityName] || null;
    return {
      currencyCode: "USD",
      pincode
    };
  }
  const cityAreaExchangeMatch = pathname.match(
    /\/tripmoney\/currency-exchange-in-([^/]+)\/([^/]+)$/
  );
  if (cityAreaExchangeMatch && cityAreaExchangeMatch[1]) {
    const cityName = cityAreaExchangeMatch[1].toLowerCase();
    const pincode = cityToPincodeMapping[cityName] || null;
    return {
      currencyCode: "USD",
      pincode
    };
  }
  const currencyRateMatch = pathname.match(/\/tripmoney\/currency\/(.+)-rate$/);
  if (currencyRateMatch && currencyRateMatch[1]) {
    const currencyName = currencyRateMatch[1];
    return {
      currencyCode: currencyNameToCodeMapping[currencyName] || "USD",
      pincode: null
    };
  }
  const currencyMatch = pathname.match(/\/tripmoney\/currency\/([^/]+)$/);
  if (currencyMatch && currencyMatch[1]) {
    const currencyName = currencyMatch[1];
    return {
      currencyCode: currencyNameToCodeMapping[currencyName] || "USD",
      pincode: null
    };
  }
  const converterWithAmountMatch = pathname.match(
    /\/tripmoney\/currency-converter\/([^-]+)-to-inr\/\d+-[^/]+$/
  );
  if (converterWithAmountMatch && converterWithAmountMatch[1]) {
    const currencyCode = converterWithAmountMatch[1].toLowerCase();
    return {
      currencyCode: currencyCodeMapping[currencyCode] || "USD",
      pincode: null
    };
  }
  const converterMatch = pathname.match(
    /\/tripmoney\/currency-converter\/([^-]+)-to-inr$/
  );
  if (converterMatch && converterMatch[1]) {
    const currencyCode = converterMatch[1].toLowerCase();
    return {
      currencyCode: currencyCodeMapping[currencyCode] || "USD",
      pincode: null
    };
  }
  return {
    currencyCode: "USD",
    pincode: null
  };
}

// libs/core-utils/src/lib/utils/headerUtils/index.ts
function getPdtBaseUrl() {
  return "https://pdt.makemytrip.com/dts/s/da/n";
}
function shouldIncludeExternalHeaders(url) {
  if (!url) {
    return false;
  }
  return url?.includes("/pdt") || url?.includes(APP_SOCIAL_URL(getPartner())) || url?.includes(GET_SLT_TOKEN_URL(getPartner())) || url?.includes(getPdtBaseUrl()) ? false : true;
}
function getDefaultHeaders(url) {
  const partner = isHostMMT() ? PARTNER.MMT : PARTNER.GI;
  const headers = {
    partner: getPartner() || "mmt",
    credentials: "include",
    org: getPartner() || "mmt",
    os: "Chrome",
    //'Android',
    // platform: getPlatform(), //'app', //commenting this as it is not required and also not whitelsited at Kong getting CORS error,
    "Content-Type": "application/json",
    deviceid: getDeviceId(partner) || "",
    "mmt-auth": getCookie(COOKIES.MMT_AUTH_KEY, true) || ""
  };
  if (shouldIncludeExternalHeaders(url)) {
    return headers;
  } else if (isPartnerHost(SOURCE.FOREX_EXPERT)) {
    headers["x-agent-auth"] = getCookie(COOKIES.FOREX_AGENT_AUTH_KEY, true) || "";
    headers["x-ticket-id"] = getSessionStorageItem("ticket_id", true) || "";
  } else {
    headers["x-tm-auth"] = getCookie(COOKIES.TM_AUTH_KEY, true) || "";
    headers[COOKIES.PDT_JOURNEY_ID] = getJourneyIdFromCookie(getPartner());
  }
  return headers;
}
var APP_SOCIAL_URL = (partner) => {
  const hostname = isHostMMT() ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
  return `${hostname}/ext/TripMoney/Forex/appSocialLogin`;
};
var GET_SLT_TOKEN_URL = (partner) => {
  const hostname = isHostMMT() ? "https://mapi.makemytrip.com" : "https://mapi.goibibo.com";
  return `${hostname}/ext/web/pwa/jwt/loginToken`;
};
function getJourneyIdFromCookie(partner) {
  if (partner === PARTNER.MMT) {
    return getCookie(COOKIES.PDT_JOURNEY_ID, true, {
      domain: `${SUB_DOMAIN.MAKEMYTRIP}`,
      path: "/"
    });
  } else if (partner === PARTNER.GI) {
    return getCookie(COOKIES.PDT_JOURNEY_ID, true, {
      domain: `${SUB_DOMAIN.GOIBIBO}`,
      path: "/"
    });
  }
  return void 0;
}
function setJourneyIdCookie({
  partner,
  journeyId
}) {
  const journeyIdCookie = getJourneyIdFromCookie(partner);
  if (!journeyIdCookie && journeyId) {
    const currentDate = /* @__PURE__ */ new Date();
    const expirationTime = new Date(currentDate.getTime() + 60 * 60 * 1e3);
    if (partner === PARTNER.MMT) {
      setCookie(COOKIES.PDT_JOURNEY_ID, journeyId, true, {
        expires: expirationTime.toUTCString(),
        domain: SUB_DOMAIN.MAKEMYTRIP,
        path: "/"
      });
    } else if (partner === PARTNER.GI) {
      setCookie(COOKIES.PDT_JOURNEY_ID, journeyId, true, {
        expires: expirationTime.toUTCString(),
        domain: SUB_DOMAIN.GOIBIBO,
        path: "/"
      });
    }
  }
}

// libs/core-utils/src/lib/utils/navigationUtils/index.ts
var redirectTo = (url, transformUrl) => {
  const transformedUrl = transformUrl(url);
  window.location.href = transformedUrl;
};
var redirectWithDeferredTime = (redirectFn, deferTime) => {
  if (deferTime) {
    const timerId = setTimeout(() => {
      redirectFn();
      clearTimeout(timerId);
    }, deferTime);
  } else {
    redirectFn();
  }
};

// libs/core-utils/src/validationMessages.ts
var VALIDATION_MESSAGES = {
  MOBILE: {
    REQUIRED: "Mobile number is required",
    INVALID: "Please enter a valid 10-digit mobile number"
  },
  EMAIL: {
    REQUIRED: "Email is required",
    INVALID: "Please enter a valid email address"
  },
  PAN: {
    REQUIRED: "PAN number is required",
    INVALID: "Please enter a valid PAN number"
  },
  FULL_NAME: {
    REQUIRED: "Full name is required"
  },
  ADDRESS: {
    REQUIRED: "Delivery address is required"
  }
};

// libs/core-utils/src/lib/utils/arrayUtils/index.ts
function isArray(value) {
  return Array.isArray(value);
}

// libs/core-utils/src/lib/utils/scriptLoadutils/index.ts
var getGtmScript = (gtmId) => {
  return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', '${gtmId}');
    `;
};
var loadGTM = () => {
  if (isHostMMT() && typeof window !== "undefined" && !window?.["dataLayer"]) {
    const script = document.createElement("script");
    script.innerHTML = getGtmScript("GTM-NWV3K7C");
    script.defer = true;
    document.head.appendChild(script);
  }
};
function gtmDataLayerPush(data) {
  if (window?.dataLayer) {
    const eventData = {
      ...data
    };
    window.dataLayer.push(eventData);
  } else {
    console.warn("GTM dataLayer is not available");
  }
}
function reviewPageViewEvent(data) {
  gtmDataLayerPush(data);
}



/***/ }),

/***/ 8496:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

if (true) {
  module.exports = __webpack_require__(3205)
} else {}

/***/ }),

/***/ 1983:
/***/ (function(module) {

"use strict";
var ae=Object.defineProperty;var be=Object.getOwnPropertyDescriptor;var Te=Object.getOwnPropertyNames;var Ae=Object.prototype.hasOwnProperty;var Ie=(e,t)=>{for(var r in t)ae(e,r,{get:t[r],enumerable:!0})},De=(e,t,r,n)=>{if(t&&typeof t=="object"||typeof t=="function")for(let i of Te(t))!Ae.call(e,i)&&i!==r&&ae(e,i,{get:()=>t[i],enumerable:!(n=be(t,i))||n.enumerable});return e};var Oe=e=>De(ae({},"__esModule",{value:!0}),e);var Be={};Ie(Be,{Immer:()=>J,applyPatches:()=>Ce,castDraft:()=>Ke,castImmutable:()=>ke,createDraft:()=>ve,current:()=>ne,enableMapSet:()=>ge,enablePatches:()=>xe,finishDraft:()=>Re,freeze:()=>k,immerable:()=>N,isDraft:()=>O,isDraftable:()=>A,nothing:()=>C,original:()=>pe,produce:()=>Fe,produceWithPatches:()=>Ne,setAutoFreeze:()=>je,setUseStrictShallowCopy:()=>ze});module.exports=Oe(Be);var C=Symbol.for("immer-nothing"),N=Symbol.for("immer-draftable"),u=Symbol.for("immer-state");function h(e,...t){throw new Error(`[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`)}var j=Object.getPrototypeOf;function O(e){return!!e&&!!e[u]}function A(e){return e?le(e)||Array.isArray(e)||!!e[N]||!!e.constructor?.[N]||z(e)||K(e):!1}var Me=Object.prototype.constructor.toString();function le(e){if(!e||typeof e!="object")return!1;let t=j(e);if(t===null)return!0;let r=Object.hasOwnProperty.call(t,"constructor")&&t.constructor;return r===Object?!0:typeof r=="function"&&Function.toString.call(r)===Me}function pe(e){return O(e)||h(15,e),e[u].t}function _(e,t){v(e)===0?Reflect.ownKeys(e).forEach(r=>{t(r,e[r],e)}):e.forEach((r,n)=>t(n,r,e))}function v(e){let t=e[u];return t?t.o:Array.isArray(e)?1:z(e)?2:K(e)?3:0}function R(e,t){return v(e)===2?e.has(t):Object.prototype.hasOwnProperty.call(e,t)}function Q(e,t){return v(e)===2?e.get(t):e[t]}function Y(e,t,r){let n=v(e);n===2?e.set(t,r):n===3?e.add(r):e[t]=r}function de(e,t){return e===t?e!==0||1/e===1/t:e!==e&&t!==t}function z(e){return e instanceof Map}function K(e){return e instanceof Set}function T(e){return e.e||e.t}function L(e,t){if(z(e))return new Map(e);if(K(e))return new Set(e);if(Array.isArray(e))return Array.prototype.slice.call(e);let r=le(e);if(t===!0||t==="class_only"&&!r){let n=Object.getOwnPropertyDescriptors(e);delete n[u];let i=Reflect.ownKeys(n);for(let f=0;f<i.length;f++){let l=i[f],c=n[l];c.writable===!1&&(c.writable=!0,c.configurable=!0),(c.get||c.set)&&(n[l]={configurable:!0,writable:!0,enumerable:c.enumerable,value:e[l]})}return Object.create(j(e),n)}else{let n=j(e);if(n!==null&&r)return{...e};let i=Object.create(n);return Object.assign(i,e)}}function k(e,t=!1){return $(e)||O(e)||!A(e)||(v(e)>1&&Object.defineProperties(e,{set:{value:X},add:{value:X},clear:{value:X},delete:{value:X}}),Object.freeze(e),t&&Object.values(e).forEach(r=>k(r,!0))),e}function X(){h(2)}function $(e){return Object.isFrozen(e)}var oe={};function w(e){let t=oe[e];return t||h(0,e),t}function Z(e,t){oe[e]||(oe[e]=t)}var U;function B(){return U}function _e(e,t){return{a:[],i:e,p:t,P:!0,d:0}}function ie(e,t){t&&(w("Patches"),e.f=[],e.h=[],e.b=t)}function V(e){ee(e),e.a.forEach(we),e.a=null}function ee(e){e===U&&(U=e.i)}function se(e){return U=_e(U,e)}function we(e){let t=e[u];t.o===0||t.o===1?t.x():t.m=!0}function ce(e,t){t.d=t.a.length;let r=t.a[0];return e!==void 0&&e!==r?(r[u].s&&(V(t),h(4)),A(e)&&(e=te(t,e),t.i||re(t,e)),t.f&&w("Patches").T(r[u].t,e,t.f,t.h)):e=te(t,r,[]),V(t),t.f&&t.b(t.f,t.h),e!==C?e:void 0}function te(e,t,r){if($(t))return t;let n=t[u];if(!n)return _(t,(i,f)=>he(e,n,t,i,f,r)),t;if(n.n!==e)return t;if(!n.s)return re(e,n.t,!0),n.t;if(!n.c){n.c=!0,n.n.d--;let i=n.e,f=i,l=!1;n.o===3&&(f=new Set(i),i.clear(),l=!0),_(f,(c,b)=>he(e,n,i,c,b,r,l)),re(e,i,!1),r&&e.f&&w("Patches").g(n,r,e.f,e.h)}return n.e}function he(e,t,r,n,i,f,l){if(O(i)){let c=f&&t&&t.o!==3&&!R(t.r,n)?f.concat(n):void 0,b=te(e,i,c);if(Y(r,n,b),O(b))e.P=!1;else return}else l&&r.add(i);if(A(i)&&!$(i)){if(!e.p.y&&e.d<1)return;te(e,i),(!t||!t.n.i)&&typeof n!="symbol"&&(z(r)?r.has(n):Object.prototype.propertyIsEnumerable.call(r,n))&&re(e,i)}}function re(e,t,r=!1){!e.i&&e.p.y&&e.P&&k(t,r)}function me(e,t){let r=Array.isArray(e),n={o:r?1:0,n:t?t.n:B(),s:!1,c:!1,r:{},i:t,t:e,u:null,e:null,x:null,l:!1},i=n,f=ye;r&&(i=[n],f=q);let{revoke:l,proxy:c}=Proxy.revocable(i,f);return n.u=c,n.x=l,c}var ye={get(e,t){if(t===u)return e;let r=T(e);if(!R(r,t))return Ee(e,r,t);let n=r[t];return e.c||!A(n)?n:n===fe(e.t,t)?(ue(e),e.e[t]=W(n,e)):n},has(e,t){return t in T(e)},ownKeys(e){return Reflect.ownKeys(T(e))},set(e,t,r){let n=Se(T(e),t);if(n?.set)return n.set.call(e.u,r),!0;if(!e.s){let i=fe(T(e),t),f=i?.[u];if(f&&f.t===r)return e.e[t]=r,e.r[t]=!1,!0;if(de(r,i)&&(r!==void 0||R(e.t,t)))return!0;ue(e),E(e)}return e.e[t]===r&&(r!==void 0||t in e.e)||Number.isNaN(r)&&Number.isNaN(e.e[t])||(e.e[t]=r,e.r[t]=!0),!0},deleteProperty(e,t){return fe(e.t,t)!==void 0||t in e.t?(e.r[t]=!1,ue(e),E(e)):delete e.r[t],e.e&&delete e.e[t],!0},getOwnPropertyDescriptor(e,t){let r=T(e),n=Reflect.getOwnPropertyDescriptor(r,t);return n&&{writable:!0,configurable:e.o!==1||t!=="length",enumerable:n.enumerable,value:r[t]}},defineProperty(){h(11)},getPrototypeOf(e){return j(e.t)},setPrototypeOf(){h(12)}},q={};_(ye,(e,t)=>{q[e]=function(){return arguments[0]=arguments[0][0],t.apply(this,arguments)}});q.deleteProperty=function(e,t){return q.set.call(this,e,t,void 0)};q.set=function(e,t,r){return ye.set.call(this,e[0],t,r,e[0])};function fe(e,t){let r=e[u];return(r?T(r):e)[t]}function Ee(e,t,r){let n=Se(t,r);return n?"value"in n?n.value:n.get?.call(e.u):void 0}function Se(e,t){if(!(t in e))return;let r=j(e);for(;r;){let n=Object.getOwnPropertyDescriptor(r,t);if(n)return n;r=j(r)}}function E(e){e.s||(e.s=!0,e.i&&E(e.i))}function ue(e){e.e||(e.e=L(e.t,e.n.p.S))}var J=class{constructor(t){this.y=!0;this.S=!1;this.produce=(t,r,n)=>{if(typeof t=="function"&&typeof r!="function"){let f=r;r=t;let l=this;return function(b=f,...a){return l.produce(b,o=>r.call(this,o,...a))}}typeof r!="function"&&h(6),n!==void 0&&typeof n!="function"&&h(7);let i;if(A(t)){let f=se(this),l=W(t,void 0),c=!0;try{i=r(l),c=!1}finally{c?V(f):ee(f)}return ie(f,n),ce(i,f)}else if(!t||typeof t!="object"){if(i=r(t),i===void 0&&(i=t),i===C&&(i=void 0),this.y&&k(i,!0),n){let f=[],l=[];w("Patches").T(t,i,f,l),n(f,l)}return i}else h(1,t)};this.produceWithPatches=(t,r)=>{if(typeof t=="function")return(l,...c)=>this.produceWithPatches(l,b=>t(b,...c));let n,i;return[this.produce(t,r,(l,c)=>{n=l,i=c}),n,i]};typeof t?.autoFreeze=="boolean"&&this.setAutoFreeze(t.autoFreeze),typeof t?.useStrictShallowCopy=="boolean"&&this.setUseStrictShallowCopy(t.useStrictShallowCopy)}createDraft(t){A(t)||h(8),O(t)&&(t=ne(t));let r=se(this),n=W(t,void 0);return n[u].l=!0,ee(r),n}finishDraft(t,r){let n=t&&t[u];(!n||!n.l)&&h(9);let{n:i}=n;return ie(i,r),ce(void 0,i)}setAutoFreeze(t){this.y=t}setUseStrictShallowCopy(t){this.S=t}applyPatches(t,r){let n;for(n=r.length-1;n>=0;n--){let f=r[n];if(f.path.length===0&&f.op==="replace"){t=f.value;break}}n>-1&&(r=r.slice(n+1));let i=w("Patches").A;return O(t)?i(t,r):this.produce(t,f=>i(f,r))}};function W(e,t){let r=z(e)?w("MapSet").I(e,t):K(e)?w("MapSet").D(e,t):me(e,t);return(t?t.n:B()).a.push(r),r}function ne(e){return O(e)||h(10,e),Pe(e)}function Pe(e){if(!A(e)||$(e))return e;let t=e[u],r;if(t){if(!t.s)return t.t;t.c=!0,r=L(e,t.n.p.S)}else r=L(e,!0);return _(r,(n,i)=>{Y(r,n,Pe(i))}),t&&(t.c=!1),r}function xe(){let t="replace",r="add",n="remove";function i(s,S,m,x){switch(s.o){case 0:case 2:return l(s,S,m,x);case 1:return f(s,S,m,x);case 3:return c(s,S,m,x)}}function f(s,S,m,x){let{t:I,r:P}=s,g=s.e;g.length<I.length&&([I,g]=[g,I],[m,x]=[x,m]);for(let y=0;y<I.length;y++)if(P[y]&&g[y]!==I[y]){let d=S.concat([y]);m.push({op:t,path:d,value:p(g[y])}),x.push({op:t,path:d,value:p(I[y])})}for(let y=I.length;y<g.length;y++){let d=S.concat([y]);m.push({op:r,path:d,value:p(g[y])})}for(let y=g.length-1;I.length<=y;--y){let d=S.concat([y]);x.push({op:n,path:d})}}function l(s,S,m,x){let{t:I,e:P}=s;_(s.r,(g,y)=>{let d=Q(I,g),H=Q(P,g),F=y?R(I,g)?t:r:n;if(d===H&&F===t)return;let D=S.concat(g);m.push(F===n?{op:F,path:D}:{op:F,path:D,value:H}),x.push(F===r?{op:n,path:D}:F===n?{op:r,path:D,value:p(d)}:{op:t,path:D,value:p(d)})})}function c(s,S,m,x){let{t:I,e:P}=s,g=0;I.forEach(y=>{if(!P.has(y)){let d=S.concat([g]);m.push({op:n,path:d,value:y}),x.unshift({op:r,path:d,value:y})}g++}),g=0,P.forEach(y=>{if(!I.has(y)){let d=S.concat([g]);m.push({op:r,path:d,value:y}),x.unshift({op:n,path:d,value:y})}g++})}function b(s,S,m,x){m.push({op:t,path:[],value:S===C?void 0:S}),x.push({op:t,path:[],value:s})}function a(s,S){return S.forEach(m=>{let{path:x,op:I}=m,P=s;for(let H=0;H<x.length-1;H++){let F=v(P),D=x[H];typeof D!="string"&&typeof D!="number"&&(D=""+D),(F===0||F===1)&&(D==="__proto__"||D==="constructor")&&h(16+3),typeof P=="function"&&D==="prototype"&&h(16+3),P=Q(P,D),typeof P!="object"&&h(16+2,x.join("/"))}let g=v(P),y=o(m.value),d=x[x.length-1];switch(I){case t:switch(g){case 2:return P.set(d,y);case 3:h(16);default:return P[d]=y}case r:switch(g){case 1:return d==="-"?P.push(y):P.splice(d,0,y);case 2:return P.set(d,y);case 3:return P.add(y);default:return P[d]=y}case n:switch(g){case 1:return P.splice(d,1);case 2:return P.delete(d);case 3:return P.delete(m.value);default:return delete P[d]}default:h(16+1,I)}}),s}function o(s){if(!A(s))return s;if(Array.isArray(s))return s.map(o);if(z(s))return new Map(Array.from(s.entries()).map(([m,x])=>[m,o(x)]));if(K(s))return new Set(Array.from(s).map(o));let S=Object.create(j(s));for(let m in s)S[m]=o(s[m]);return R(s,N)&&(S[N]=s[N]),S}function p(s){return O(s)?o(s):s}Z("Patches",{A:a,g:i,T:b})}function ge(){class e extends Map{constructor(a,o){super();this[u]={o:2,i:o,n:o?o.n:B(),s:!1,c:!1,e:void 0,r:void 0,t:a,u:this,l:!1,m:!1}}get size(){return T(this[u]).size}has(a){return T(this[u]).has(a)}set(a,o){let p=this[u];return l(p),(!T(p).has(a)||T(p).get(a)!==o)&&(r(p),E(p),p.r.set(a,!0),p.e.set(a,o),p.r.set(a,!0)),this}delete(a){if(!this.has(a))return!1;let o=this[u];return l(o),r(o),E(o),o.t.has(a)?o.r.set(a,!1):o.r.delete(a),o.e.delete(a),!0}clear(){let a=this[u];l(a),T(a).size&&(r(a),E(a),a.r=new Map,_(a.t,o=>{a.r.set(o,!1)}),a.e.clear())}forEach(a,o){let p=this[u];T(p).forEach((s,S,m)=>{a.call(o,this.get(S),S,this)})}get(a){let o=this[u];l(o);let p=T(o).get(a);if(o.c||!A(p)||p!==o.t.get(a))return p;let s=W(p,o);return r(o),o.e.set(a,s),s}keys(){return T(this[u]).keys()}values(){let a=this.keys();return{[Symbol.iterator]:()=>this.values(),next:()=>{let o=a.next();return o.done?o:{done:!1,value:this.get(o.value)}}}}entries(){let a=this.keys();return{[Symbol.iterator]:()=>this.entries(),next:()=>{let o=a.next();if(o.done)return o;let p=this.get(o.value);return{done:!1,value:[o.value,p]}}}}[(u,Symbol.iterator)](){return this.entries()}}function t(c,b){return new e(c,b)}function r(c){c.e||(c.r=new Map,c.e=new Map(c.t))}class n extends Set{constructor(a,o){super();this[u]={o:3,i:o,n:o?o.n:B(),s:!1,c:!1,e:void 0,t:a,u:this,a:new Map,m:!1,l:!1}}get size(){return T(this[u]).size}has(a){let o=this[u];return l(o),o.e?!!(o.e.has(a)||o.a.has(a)&&o.e.has(o.a.get(a))):o.t.has(a)}add(a){let o=this[u];return l(o),this.has(a)||(f(o),E(o),o.e.add(a)),this}delete(a){if(!this.has(a))return!1;let o=this[u];return l(o),f(o),E(o),o.e.delete(a)||(o.a.has(a)?o.e.delete(o.a.get(a)):!1)}clear(){let a=this[u];l(a),T(a).size&&(f(a),E(a),a.e.clear())}values(){let a=this[u];return l(a),f(a),a.e.values()}entries(){let a=this[u];return l(a),f(a),a.e.entries()}keys(){return this.values()}[(u,Symbol.iterator)](){return this.values()}forEach(a,o){let p=this.values(),s=p.next();for(;!s.done;)a.call(o,s.value,s.value,this),s=p.next()}}function i(c,b){return new n(c,b)}function f(c){c.e||(c.e=new Set,c.t.forEach(b=>{if(A(b)){let a=W(b,c);c.a.set(b,a),c.e.add(a)}else c.e.add(b)}))}function l(c){c.m&&h(3,JSON.stringify(T(c)))}Z("MapSet",{I:t,D:i})}var M=new J,Fe=M.produce,Ne=M.produceWithPatches.bind(M),je=M.setAutoFreeze.bind(M),ze=M.setUseStrictShallowCopy.bind(M),Ce=M.applyPatches.bind(M),ve=M.createDraft.bind(M),Re=M.finishDraft.bind(M);function Ke(e){return e}function ke(e){return e}0&&(0);
//# sourceMappingURL=immer.cjs.production.js.map

/***/ }),

/***/ 7476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";



if (true) {
  module.exports = __webpack_require__(1983)
} else {}

/***/ }),

/***/ 3157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AssistanceBot": function() { return /* binding */ AssistanceBot; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var _forex_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _lib_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5618);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5505);
/* harmony import */ var _forex_pdt_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7134);







function _tagged_template_literal$1(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject$1() {
    var data = _tagged_template_literal$1([
        "\n  position: fixed;\n  bottom: ",
        ";\n  right: ",
        ";\n  z-index: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject$1 = function _templateObject() {
        return data;
    };
    return data;
}
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject$1(), function(param) {
    var bottom = param.bottom;
    return bottom;
}, function(param) {
    var right = param.right;
    return right;
}, function(param) {
    var zIndex = param.zIndex;
    return zIndex;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
var MyraIcon$1 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var iconUrl = param.iconUrl, _param_bottom = param.bottom, bottom = _param_bottom === void 0 ? '30px' : _param_bottom, _param_right = param.right, right = _param_right === void 0 ? '30px' : _param_right, _param_size = param.size, size = _param_size === void 0 ? '60px' : _param_size, _param_zIndex = param.zIndex, zIndex = _param_zIndex === void 0 ? 12 : _param_zIndex, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
        ref: ref,
        bottom: bottom,
        right: right,
        size: size,
        zIndex: zIndex,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lib_design_system__WEBPACK_IMPORTED_MODULE_3__.Image, {
            src: iconUrl,
            width: size,
            height: size,
            showCursorPointer: true,
            alt: "Myra Assistant"
        })
    });
});

var DEFAULT_ICON_URL$1 = 'https://imgak.mmtcdn.com/flights/assets/media/mobile/listing/3X/myra_new_gif.webp?v=2';
// Spacing and sizing constants
var CHAT_WINDOW_OFFSET = 20;
var DEFAULT_ICON_SIZE = '60';
var DEFAULT_GAP = '30px';
// Z-index constants
var DEFAULT_Z_INDEX = 12;
// Position constants
var DEFAULT_BOTTOM = '30px';
var DEFAULT_RIGHT = '30px';
var CHAT_WINDOW_BOTTOM = '100px';
// Chat window dimensions
var CHAT_WINDOW_WIDTH = '360px';
var CHAT_WINDOW_HEIGHT = '700px';
var CHAT_WINDOW_BORDER_RADIUS = '12px';
var DEFAULT_STYLES$1 = {
    bottom: DEFAULT_BOTTOM,
    right: DEFAULT_RIGHT,
    iconSize: DEFAULT_ICON_SIZE,
    zIndex: DEFAULT_Z_INDEX,
    chatWindowStyle: {
        width: CHAT_WINDOW_WIDTH,
        height: CHAT_WINDOW_HEIGHT,
        borderRadius: CHAT_WINDOW_BORDER_RADIUS,
        boxShadow: 'none',
        position: 'fixed',
        bottom: CHAT_WINDOW_BOTTOM
    }
};

var getAdjustedPosition = function(basePosition, offset) {
    if (!offset) return basePosition;
    var gap = offset.gap || DEFAULT_GAP;
    return offset.position === 'left' ? "calc(".concat(offset.width, " + ").concat(gap, ")") : "calc(".concat(basePosition, " + ").concat(offset.width, " + ").concat(gap, ")");
};
var calculateBottomPosition = function(iconY) {
    return "".concat(window.innerHeight - iconY + CHAT_WINDOW_OFFSET, "px");
};
var calculateHorizontalPosition = function(iconX, windowWidth, iconSize, offsetFromElement) {
    var isRightAligned = iconX > windowWidth / 2;
    if (isRightAligned) {
        var basePosition = "".concat(windowWidth - (iconX + iconSize), "px");
        return {
            right: getAdjustedPosition(basePosition, offsetFromElement)
        };
    }
    return {
        left: "".concat(iconX, "px")
    };
};
var getIconPosition = function(element) {
    return {
        x: element.getBoundingClientRect().left + window.scrollX,
        y: element.getBoundingClientRect().top + window.scrollY
    };
};

function _array_like_to_array$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array$1(arr, i) {
    return _array_with_holes$1(arr) || _iterable_to_array_limit$1(arr, i) || _unsupported_iterable_to_array$1(arr, i) || _non_iterable_rest$1();
}
function _unsupported_iterable_to_array$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$1(o, minLen);
}
var MyraFrame$1 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.lazy)(function() {
    return __webpack_require__.e(/* import() */ 9258).then(__webpack_require__.bind(__webpack_require__, 9258));
});
var DesktopAssistanceBot = function(param) {
    var chatUrl = param.chatUrl, handleMyraMinimized = param.handleMyraMinimized, handleMyraExpand = param.handleMyraExpand, onMessage = param.onMessage, _param_style = param.style, style = _param_style === void 0 ? {} : _param_style, _param_disableBodyScrollOnExpand = param.disableBodyScrollOnExpand, disableBodyScrollOnExpand = _param_disableBodyScrollOnExpand === void 0 ? true : _param_disableBodyScrollOnExpand;
    var _useState = _sliced_to_array$1((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), 2), showChatBot = _useState[0], setShowChatBot = _useState[1];
    var _useState1 = _sliced_to_array$1((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), 2), myraMinimized = _useState1[0], setMyraMinimized = _useState1[1];
    var _useState2 = _sliced_to_array$1((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), 2), iconPosition = _useState2[0], setIconPosition = _useState2[1];
    var iconRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var mergedStyles = _object_spread_props$2(_object_spread$2({}, DEFAULT_STYLES$1, style), {
        right: getAdjustedPosition(style.right || DEFAULT_STYLES$1.right, style.offsetFromElement),
        chatWindowStyle: _object_spread_props$2(_object_spread$2({}, DEFAULT_STYLES$1.chatWindowStyle, style.chatWindowStyle), {
            position: 'fixed'
        })
    });
    var onMyraMinimized = function(min) {
        setMyraMinimized(min);
        if (showChatBot) {
            setShowChatBot(false);
        }
        handleMyraMinimized === null || handleMyraMinimized === void 0 ? void 0 : handleMyraMinimized(min);
    };
    var handleIconClick = function() {
        if (iconRef.current) {
            setIconPosition(getIconPosition(iconRef.current));
        }
        setMyraMinimized(false);
        setShowChatBot(true);
        handleMyraExpand === null || handleMyraExpand === void 0 ? void 0 : handleMyraExpand();
    };
    var getChatWindowPosition = function() {
        if (!iconPosition) return {};
        var windowWidth = window.innerWidth;
        var iconSize = parseInt(mergedStyles.iconSize || DEFAULT_ICON_SIZE);
        return _object_spread$2({
            position: 'fixed',
            bottom: calculateBottomPosition(iconPosition.y)
        }, calculateHorizontalPosition(iconPosition.x, windowWidth, iconSize, style.offsetFromElement));
    };
    var chatPosition = showChatBot ? getChatWindowPosition() : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MyraIcon$1, {
                ref: iconRef,
                iconUrl: (style === null || style === void 0 ? void 0 : style.iconUrl) || DEFAULT_ICON_URL$1,
                bottom: mergedStyles.bottom,
                right: mergedStyles.right,
                size: mergedStyles.iconSize,
                zIndex: mergedStyles.zIndex,
                onClick: handleIconClick
            }),
            showChatBot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MyraFrame$1, {
                    myraAppLink: chatUrl,
                    myraMinimized: myraMinimized,
                    setMyraMinimized: onMyraMinimized,
                    onMessage: onMessage,
                    style: _object_spread$2({}, mergedStyles.chatWindowStyle, chatPosition),
                    disableBodyScrollOnExpand: disableBodyScrollOnExpand
                })
            })
        ]
    });
};

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  bottom: ",
        ";\n  right: ",
        ";\n  z-index: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledMyraIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_lib_design_system__WEBPACK_IMPORTED_MODULE_3__.Image)(_templateObject(), function(props) {
    return props.bottom || '20px';
}, function(props) {
    return props.right || '20px';
}, function(props) {
    return props.zIndex || 12;
}, function(props) {
    return props.size || '48px';
}, function(props) {
    return props.size || '48px';
});

var MyraIcon = function(param) {
    var iconUrl = param.iconUrl, bottom = param.bottom, right = param.right, size = param.size, zIndex = param.zIndex, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledMyraIcon, {
        src: iconUrl,
        alt: "Myra Assistant",
        bottom: bottom,
        right: right,
        size: size,
        zIndex: zIndex,
        onClick: onClick
    });
};

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var MyraFrame = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.lazy)(function() {
    return __webpack_require__.e(/* import() */ 9258).then(__webpack_require__.bind(__webpack_require__, 9258));
});
var DEFAULT_ICON_URL = 'https://imgak.mmtcdn.com/flights/assets/media/mobile/listing/3X/myra_new_gif.webp?v=2';
var DEFAULT_STYLES = {
    bottom: '20px',
    right: '20px',
    iconSize: '48px',
    zIndex: 12,
    chatWindowStyle: {
        width: '100%',
        height: '100vh',
        borderRadius: '0',
        boxShadow: 'none'
    }
};
var MobileAssistanceBot = function(param) {
    var chatUrl = param.chatUrl, handleMyraMinimized = param.handleMyraMinimized, handleMyraExpand = param.handleMyraExpand, onMessage = param.onMessage, _param_style = param.style, style = _param_style === void 0 ? {} : _param_style, _param_disableBodyScrollOnExpand = param.disableBodyScrollOnExpand, disableBodyScrollOnExpand = _param_disableBodyScrollOnExpand === void 0 ? true : _param_disableBodyScrollOnExpand;
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), 2), showChatBot = _useState[0], setShowChatBot = _useState[1];
    var _useState1 = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), 2), myraMinimized = _useState1[0], setMyraMinimized = _useState1[1];
    var mergedStyles = _object_spread_props$1(_object_spread$1({}, DEFAULT_STYLES, style), {
        chatWindowStyle: _object_spread$1({}, DEFAULT_STYLES.chatWindowStyle, style.chatWindowStyle)
    });
    var onMyraMinimized = function(min) {
        setMyraMinimized(min);
        handleMyraMinimized === null || handleMyraMinimized === void 0 ? void 0 : handleMyraMinimized(min);
    };
    var handleIconClick = function() {
        setMyraMinimized(false);
        setShowChatBot(true);
        handleMyraExpand === null || handleMyraExpand === void 0 ? void 0 : handleMyraExpand();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MyraIcon, {
                iconUrl: style.iconUrl || DEFAULT_ICON_URL,
                bottom: mergedStyles.bottom,
                right: mergedStyles.right,
                size: mergedStyles.iconSize,
                zIndex: mergedStyles.zIndex,
                onClick: handleIconClick
            }),
            showChatBot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MyraFrame, {
                    myraAppLink: chatUrl,
                    myraMinimized: myraMinimized,
                    setMyraMinimized: onMyraMinimized,
                    onMessage: onMessage,
                    right: mergedStyles.right,
                    style: mergedStyles.chatWindowStyle,
                    disableBodyScrollOnExpand: disableBodyScrollOnExpand
                })
            })
        ]
    });
};

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var AssistanceBot = function(props) {
    var platform = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_1__.getPlatform)();
    props.userData; props.commonPdtData; var myraIconShownPdtData = props.myraIconShownPdtData, myraChatWindowOpenPdtData = props.myraChatWindowOpenPdtData, myraChatWindowClosedPdtData = props.myraChatWindowClosedPdtData, myraIconClickedPdtData = props.myraIconClickedPdtData;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // Fire PDT event when icon is shown
        if (myraIconShownPdtData) {
            // pdtLogger.sendPdtData(myraIconShownPdtData);
            (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_4__.trackEvent)({
                eventData: myraIconShownPdtData
            });
        }
    }, [
        myraIconShownPdtData
    ]);
    var handleMyraIconClick = function() {
        var _props_handleMyraExpand;
        // Fire PDT event when icon is clicked (bot opened)
        if (myraIconClickedPdtData) {
            (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_4__.trackEvent)({
                eventData: myraIconClickedPdtData
            });
        }
        if (myraChatWindowOpenPdtData) {
            (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_4__.trackEvent)({
                eventData: myraChatWindowOpenPdtData
            });
        }
        (_props_handleMyraExpand = props.handleMyraExpand) === null || _props_handleMyraExpand === void 0 ? void 0 : _props_handleMyraExpand.call(props);
    };
    var handleMyraMinimized = function(minimized) {
        var _props_handleMyraMinimized;
        // Fire PDT event when bot is closed
        if (minimized && myraChatWindowClosedPdtData) {
            (0,_forex_pdt_utils__WEBPACK_IMPORTED_MODULE_4__.trackEvent)({
                eventData: myraChatWindowClosedPdtData
            });
        }
        (_props_handleMyraMinimized = props.handleMyraMinimized) === null || _props_handleMyraMinimized === void 0 ? void 0 : _props_handleMyraMinimized.call(props, minimized);
    };
    if (platform === _forex_core_utils__WEBPACK_IMPORTED_MODULE_1__.PLATFORM.DESKTOP) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopAssistanceBot, _object_spread_props(_object_spread({}, props), {
            handleMyraExpand: handleMyraIconClick,
            handleMyraMinimized: handleMyraMinimized
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileAssistanceBot, _object_spread_props(_object_spread({}, props), {
        handleMyraExpand: handleMyraIconClick,
        handleMyraMinimized: handleMyraMinimized
    }));
};




/***/ }),

/***/ 7134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "COOKIES": function() { return /* binding */ COOKIES; },
/* harmony export */   "EVENT_TYPES": function() { return /* binding */ EVENT_TYPES; },
/* harmony export */   "LOB": function() { return /* binding */ LOB; },
/* harmony export */   "cleanupPdtTracking": function() { return /* binding */ cleanupPdtTracking; },
/* harmony export */   "extractPdtTrackingParams": function() { return /* binding */ extractPdtTrackingParams; },
/* harmony export */   "generateRequestId": function() { return /* binding */ generateRequestId; },
/* harmony export */   "getBookingDetails": function() { return /* binding */ getBookingDetails; },
/* harmony export */   "getBookingInfo": function() { return /* binding */ getBookingInfo; },
/* harmony export */   "getCampaignDetails": function() { return /* binding */ getCampaignDetails; },
/* harmony export */   "getCommonPdtDataV2": function() { return /* binding */ getCommonPdtDataV2; },
/* harmony export */   "getComponentsPdt": function() { return /* binding */ getComponentsPdt; },
/* harmony export */   "getDeliveryDetails": function() { return /* binding */ getDeliveryDetails; },
/* harmony export */   "getDeliveryDetailsPdtSchema": function() { return /* binding */ getDeliveryDetailsPdtSchema; },
/* harmony export */   "getDeviceContext": function() { return /* binding */ getDeviceContext; },
/* harmony export */   "getErrorDetailsItem": function() { return /* binding */ getErrorDetailsItem; },
/* harmony export */   "getEventDetails": function() { return /* binding */ getEventDetails; },
/* harmony export */   "getEventTrackingContext": function() { return /* binding */ getEventTrackingContext; },
/* harmony export */   "getExperimentDetails": function() { return /* binding */ getExperimentDetails; },
/* harmony export */   "getLobCategory": function() { return /* binding */ getLobCategory; },
/* harmony export */   "getPageContext": function() { return /* binding */ getPageContext; },
/* harmony export */   "getPageDetails": function() { return /* binding */ getPageDetails; },
/* harmony export */   "getPdtDataObjV2": function() { return /* binding */ getPdtDataObjV2; },
/* harmony export */   "getPdtHeaders": function() { return /* binding */ getPdtHeaders; },
/* harmony export */   "getPdtLoggerMethodsV2": function() { return /* binding */ getPdtLoggerMethodsV2; },
/* harmony export */   "getPdtUpcomingTripSchema": function() { return /* binding */ getPdtUpcomingTripSchema; },
/* harmony export */   "getRequestIdHeaders": function() { return /* binding */ getRequestIdHeaders; },
/* harmony export */   "getTmUserDetails": function() { return /* binding */ getTmUserDetails; },
/* harmony export */   "getUserContext": function() { return /* binding */ getUserContext; },
/* harmony export */   "getVendorErrorDetails": function() { return /* binding */ getVendorErrorDetails; },
/* harmony export */   "initPdtTracking": function() { return /* binding */ initPdtTracking; },
/* harmony export */   "initSessionStorageUserInfo": function() { return /* binding */ initSessionStorageUserInfo; },
/* harmony export */   "sendPdtErrorEvent": function() { return /* binding */ sendPdtErrorEvent; },
/* harmony export */   "setPageContextHeaders": function() { return /* binding */ setPageContextHeaders; },
/* harmony export */   "setPageContextHeadersV2": function() { return /* binding */ setPageContextHeadersV2; },
/* harmony export */   "setPdtLocationDetectedSchema": function() { return /* binding */ setPdtLocationDetectedSchema; },
/* harmony export */   "shortenHeader": function() { return /* binding */ shortenHeader; },
/* harmony export */   "trackComponentEvent": function() { return /* binding */ trackComponentEvent; },
/* harmony export */   "trackEvent": function() { return /* binding */ trackEvent; },
/* harmony export */   "updateEventName": function() { return /* binding */ updateEventName; },
/* harmony export */   "updatePdtDataDescription": function() { return /* binding */ updatePdtDataDescription; }
/* harmony export */ });
/* harmony import */ var _forex_core_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6003);
/* harmony import */ var _mmt_event_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1099);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6364);
/* harmony import */ var MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5328);
/* harmony import */ var MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_3__);





const LOB = {
    FOREX: 'forex'
};
const shortenHeader = {
    lob: 'lob',
    lob_category: 'lc',
    lob_funnel: 'lf',
    page_name: 'pn',
    prev_page_name: 'ppn',
    funnel_step: 'fs',
    pg_time_interval: 'pti',
    navigation: 'nav',
    utm_source: 'us',
    utm_medium: 'um',
    utm_campaign: 'uc',
    cmp: 'cmp',
    requestId: 'rq-id'
};
const COOKIES = {
    MMT_AUTH_KEY: 'mmt-auth',
    TM_AUTH_KEY: 'x-tm-auth',
    MMT_LOGIN_REDIRECT_KEY: 'loginActionDetails',
    TM_MMT_AUTH_KEY: 'tm-mmt-auth',
    GI_AUTH_KEY: 'OAUTH-GOIBIBO',
    TM_GI_AUTH_KEY: 'tm-gi-auth',
    MMT_DEVICE_ID: 'dvid',
    GI_DEVICE_ID: '__gi_vid',
    MMT_FOREX_COOKIE: 'mmt_forex',
    CURRENCY_DEEPLOGIN_ALLOWED: 'currency_deeplogin_allowed',
    PDT_JOURNEY_ID: 'x-jo-id'
};
const EVENT_TYPES = {
    CLICKED: 'CLICKED',
    RENDERED: 'RENDERED'
};

const setPdtLocationDetectedSchema = (locationSource, permissionDetails, delivery_details)=>{
    const { latitude, longitude, pincode, city } = delivery_details || {};
    return {
        latitude: latitude ? `${latitude}` : null,
        longitude: longitude ? `${longitude}` : null,
        location_source: locationSource || null,
        pincode: pincode ? `${pincode}` : null,
        city: city ? `${delivery_details == null ? void 0 : delivery_details.city}` : null,
        location_permission: permissionDetails || null
    };
};
function getDeliveryDetailsPdtSchema({ deliveryDetails }) {
    const { pincode, city, latitude, longitude } = deliveryDetails || {};
    return {
        pincode: pincode != null ? pincode : null,
        city: city ? `${city}` : '',
        location_permission_given: latitude && longitude ? true : false
    };
}
function getVendorErrorDetails({ error_code, error_type, error_source, vendor_error_code, vendor_error_message, error_message_shown, api_url }) {
    const vendorErrorObj = {
        error_code: error_code ? `${error_code}` : 'NO_CODE_FOUND',
        error_type: error_type || null,
        error_source: error_source || null,
        vendor_error_code: vendor_error_code || null,
        vendor_error_message: vendor_error_message || null,
        error_message_shown: error_message_shown || 'Unknown error',
        api_url: api_url || null
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(vendorErrorObj);
}
function getDeliveryDetails({ eta, pincode, city, is_deliverable, is_prefetched, location_permission_given, deliverable, city_code, locus_city_code, state, state_code, is_valid, is_card_deliverable, is_currency_deliverable, fallback_to_city }) {
    return {
        eta: eta || '',
        pincode: pincode || 0,
        city: city || '',
        is_deliverable: is_deliverable || '',
        is_prefetched: is_prefetched || false,
        location_permission_given: location_permission_given || false,
        deliverable: deliverable || '',
        city_code: city_code || '',
        locus_city_code: locus_city_code || '',
        state: state || '',
        state_code: state_code || '',
        is_valid: is_valid || false,
        is_card_deliverable: is_card_deliverable || false,
        is_currency_deliverable: is_currency_deliverable || false,
        fallback_to_city: fallback_to_city !== undefined ? fallback_to_city : null
    };
}
function getBookingInfo({ amount_details, booking_date, booking_id, booking_parent_id, countries, coupon_details, currency, delivery_city_code, delivery_city_name, document_upload_status, from_date_time, is_coupon_applied, is_partial_amount_paid, is_payment_possible, is_tcs_applied, order_items, order_type_code, payment_status, status, status_description, tm_order_id, to_date_time, trip_purpose, trip_type }) {
    const bookingInfo = {
        amount_details: amount_details || null,
        booking_date: booking_date || null,
        booking_id: booking_id || null,
        booking_parent_id: booking_parent_id || null,
        countries: countries || null,
        coupon_details: coupon_details || null,
        currency: currency || null,
        delivery_city_code: delivery_city_code || null,
        delivery_city_name: delivery_city_name || null,
        document_upload_status: document_upload_status || null,
        from_date_time: from_date_time || null,
        is_coupon_applied: is_coupon_applied || null,
        is_partial_amount_paid: is_partial_amount_paid || null,
        is_payment_possible: is_payment_possible || null,
        is_tcs_applied: is_tcs_applied || null,
        order_items: order_items || null,
        order_type_code: order_type_code || null,
        payment_status: payment_status || null,
        status: status || null,
        status_description: status_description || null,
        tm_order_id: tm_order_id || null,
        to_date_time: to_date_time || null,
        trip_purpose: trip_purpose || null,
        trip_type: trip_type || null
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(bookingInfo);
}
function getBookingDetails({ status, created_at, is_coupon_applied, is_partial_amount_paid, parent_order_id, is_tcs_applied, status_description, document_upload_status, payment_details }) {
    return {
        status: status || null,
        created_at: created_at || null,
        is_coupon_applied: is_coupon_applied || null,
        is_partial_amount_paid: is_partial_amount_paid || null,
        parent_order_id: parent_order_id || null,
        is_tcs_applied: is_tcs_applied || null,
        status_description: status_description || null,
        document_upload_status: document_upload_status || null,
        payment_details: payment_details || null
    };
}
function getTmUserDetails({ tm_uuid, partner, vendor_user_id, vendor_id, multi_cx_card_cust, currency_cust, travel_card_cust, is_pan_verified }) {
    const userObj = {
        tm_uuid: tm_uuid || null,
        partner: partner || null,
        vendor_user_id: vendor_user_id || null,
        vendor_id: vendor_id || null,
        multi_cx_card_cust: multi_cx_card_cust || null,
        currency_cust: currency_cust || null,
        travel_card_cust: travel_card_cust || null,
        is_pan_verified: is_pan_verified || null
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(userObj);
}
function getComponentsPdt({ id, content_details, component_type, share_details, bridge_status }) {
    const componentObj = {
        id: id || null,
        content_details: content_details || null,
        component_type: component_type || null,
        share_details: share_details || null,
        bridge_status: bridge_status || null
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(componentObj);
}
function getEventDetails({ page_details, delivery_details, response_time, vendor_error_details, event_name, event_type = '', event_value, booking_info, components, event_id = '', event_timestamp, user_details, webhook_details, document_details, flow = null, upcoming_trip }) {
    const obj = {
        page_details: page_details || null,
        delivery_details: delivery_details || null,
        response_time: response_time || null,
        vendor_error_details: vendor_error_details || null,
        event_name: event_name || 'NA',
        event_type: event_type || 'NA',
        event_value: event_value || null,
        booking_info: booking_info ? getBookingInfo(booking_info) : null,
        components: components || null,
        event_id: event_id || null,
        event_timestamp: event_timestamp || new Date().getTime(),
        user_details: user_details || null,
        webhook_details: webhook_details || null,
        document_details: document_details || null,
        flow,
        upcoming_trip: upcoming_trip ? getUpcomingTrip(upcoming_trip) : null
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(obj);
}
function getUpcomingTrip({ trip_details, intl_travel }) {
    const upcomingTrip = {
        intl_travel,
        trip_details: getTripDetails(trip_details)
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(upcomingTrip);
}
function getPdtUpcomingTripSchema(upcomingTrip) {
    var _upcomingTripCountries_;
    const { trip_details: upcomingTripCountries, intl_travel = null, start_date = null, end_date = null } = upcomingTrip || {};
    return {
        intl_travel,
        trip_details: [
            {
                country_code: upcomingTripCountries == null ? void 0 : (_upcomingTripCountries_ = upcomingTripCountries[0]) == null ? void 0 : _upcomingTripCountries_.country_code,
                start_date,
                end_date
            }
        ]
    };
}
function getTripDetails(trip_details) {
    const tripDetails = (trip_details != null ? trip_details : []).map((tripDetail)=>{
        return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)({
            dependent_lob: tripDetail.dependent_lob,
            country_code: tripDetail.country_code,
            currency_code: tripDetail.currency_code,
            start_date: tripDetail.start_date,
            end_date: tripDetail.end_date,
            no_of_travellers: tripDetail.no_of_travellers,
            opportunity_type: tripDetail.opportunity_type
        });
    }).filter((tripDetail)=>tripDetail);
    return tripDetails.length ? tripDetails : null;
}
function getPageDetails({ segment_key = null, documentscanfailed = null, secondary_page_name = null, auto_suggest = null, is_pan_autofilled, is_mobile_prefilled, Is_email_prefilled }) {
    const pageDetailsObj = {
        segment_key: segment_key || null,
        documentscanfailed: documentscanfailed || null,
        secondary_page_name: secondary_page_name || null,
        auto_suggest: auto_suggest || null,
        is_pan_autofilled: is_pan_autofilled,
        is_mobile_prefilled: is_mobile_prefilled,
        Is_email_prefilled: Is_email_prefilled
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(pageDetailsObj);
}
function getPageContext({ lob, lob_category, lob_funnel, page_name, prev_page_name, subpage_name, funnel_step, pg_time_interval, navigation, page_url, page_type }) {
    const pageContextObj = {
        lob: lob || LOB.FOREX,
        lob_category: lob_category || null,
        lob_funnel: lob_funnel || null,
        page_name: page_name || null,
        prev_page_name: prev_page_name || null,
        subpage_name: subpage_name || null,
        funnel_step: funnel_step || null,
        pg_time_interval: pg_time_interval != null ? pg_time_interval : null,
        navigation: navigation || null,
        page_url: page_url || null,
        page_type: page_type || null
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(pageContextObj);
}
function getEventTrackingContext({ template_id, topic_name, env, session_id, request_id, journey_id, bu, organisation, funnel_source, funnel_entry, traffic_source, domain_country, domain_currency, domain_language, affiliate_id, timestamp, funnel_medium, funnel_campaign, cmp }) {
    const obj = {
        template_id,
        topic_name,
        env,
        session_id: session_id || null,
        request_id: request_id || null,
        journey_id: journey_id || null,
        bu: bu || null,
        organisation: organisation || null,
        funnel_source: funnel_source || null,
        funnel_entry: funnel_entry || null,
        traffic_source: traffic_source || null,
        domain_country: domain_country || null,
        domain_currency: domain_currency || null,
        domain_language: domain_language || null,
        affiliate_id: affiliate_id || null,
        timestamp,
        funnel_medium: funnel_medium || null,
        funnel_campaign: funnel_campaign || null,
        cmp: cmp || null
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(obj);
}
function getErrorDetailsItem({ code, message, severity, source }) {
    return {
        code,
        message,
        severity: severity || null,
        source: source || null
    };
}
function getUserContext({ uuid, is_logged_in, marketing_cloud_id, login_channel, profile_type, wallet_bal, login_type, loyalty_status, loyalty_type, loyalty_level, user_segment_list, login_required }) {
    const obj = {
        uuid: uuid || null,
        is_logged_in,
        marketing_cloud_id: marketing_cloud_id || null,
        login_channel: login_channel || null,
        profile_type: profile_type || null,
        wallet_bal: wallet_bal || null,
        login_type: login_type || null,
        loyalty_status: loyalty_status || null,
        loyalty_type: loyalty_type || null,
        loyalty_level: loyalty_level || null,
        user_segment_list: user_segment_list || null,
        login_required: login_required || null
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(obj);
}
function getDeviceContext({ device_id, ip_addr, network_type, os_version, user_agent, timezone, platform, country, region, city, lat, long, app_ver, build_ver, os, visitor_id, advertiser_id, vendor_id, device_token }) {
    const obj = {
        device_id: device_id || null,
        ip_addr: ip_addr || null,
        network_type: network_type || null,
        os_version: os_version || '',
        user_agent: user_agent || null,
        timezone: timezone || null,
        platform: platform || 'NA',
        country: country || null,
        region: region || null,
        city: city || null,
        lat: lat || null,
        long: long || null,
        app_ver: app_ver || '',
        build_ver: build_ver || null,
        os: os || '',
        visitor_id: visitor_id || null,
        advertiser_id: advertiser_id || null,
        vendor_id: vendor_id || null,
        device_token: device_token || null
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeNullableField)(obj);
}
function getExperimentDetails({ valid_exp_list, variant_keys, honoured_exp_list }) {
    return {
        valid_exp_list: valid_exp_list || [],
        variant_keys: variant_keys || '',
        honoured_exp_list: honoured_exp_list || []
    };
}
function getCampaignDetails({ campaign_name, campaign_key }) {
    return {
        campaign_name: campaign_name || '',
        campaign_key: campaign_key || ''
    };
}
function getPdtDataObjV2({ page_context, event_tracking_context, error_details_list, user_context, device_context, experiment_details, campaign_details, tracking_info, event_detail, traveller_info, addon_details, search_context }) {
    return {
        page_context,
        event_tracking_context,
        error_details_list: error_details_list || null,
        user_context,
        device_context,
        experiment_details: experiment_details || null,
        campaign_details: campaign_details || null,
        tracking_info: tracking_info || null,
        event_detail,
        traveller_info: traveller_info || null,
        addon_details: addon_details || null,
        search_context: search_context || null
    };
}

function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

function getDeviceOS() {
    const deviceType = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getDeviceType)();
    return deviceType === _forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.DEVICE_MODEL_TYPE.WEB ? 'webos' : deviceType || '';
}
function getDeviceSpecificInfo() {
    const deviceType = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getDeviceType)();
    const deviceInfo = {
        os: getDeviceOS(),
        type: !(0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.isMobile)() ? 'Desktop' : deviceType || ''
    };
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeEmptyKeys)(deviceInfo);
}
function getUtmPdtObj() {
    const utmParams = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getUtmParamsFromCookies)();
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeEmptyKeys)(utmParams);
}

const getCommonPdtDataV2 = ({ userId, puid, partner, lobFunnelType, funnelStep, subpage_name })=>{
    if ((0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.isOnServer)()) return {};
    const { os, user_agent, os_version } = getDeviceSpecificInfo();
    return {
        event_tracking_context: getEventTrackingContext(_extends({}, getUtmPdtObj(), {
            template_id: 167187,
            topic_name: 'tripmoney_forex_b2c_pdt_client_logging',
            timestamp: new Date().getTime(),
            env: 'prod',
            journey_id: (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getCookie)(_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.COOKIES.PDT_JOURNEY_ID, true)
        })),
        event_detail: getEventDetails({
            event_type: 'action',
            event_name: 'NA',
            event_timestamp: new Date().getTime(),
            user_details: getTmUserDetails({
                tm_uuid: `${userId != null ? userId : 'NA'}`,
                partner
            }),
            components: getComponentsPdt({
                //  not required
                bridge_status: (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getDeviceIdStatus)()
            })
        }),
        user_context: getUserContext({
            // TODO - ask if nullable
            uuid: `${puid != null ? puid : 'NA'}`,
            is_logged_in: userId ? true : false
        }),
        device_context: getDeviceContext({
            os,
            os_version,
            user_agent,
            app_ver: 'NA',
            platform: (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getPlatform)() || 'NA',
            // TODO - ask if nullable
            device_id: (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getDeviceId)(partner) || 'NA'
        }),
        page_context: getPageContext({
            // some from server and some from client
            page_name: (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getPageName)(),
            lob: 'forex',
            lob_funnel: lobFunnelType,
            lob_category: getLobCategory(),
            page_url: (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getPageUrl)(),
            funnel_step: funnelStep,
            subpage_name: subpage_name
        })
    };
};
function getLobCategory() {
    if ((0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.isOnServer)()) {
        return 'NA';
    }
    const url = window.location.pathname;
    /**
   * DO NOT CHANGE ORDER OF IF BLOCKS
   * /onboarding regex matches with both card and currency funnel
   */ if (/\/currency/i.test(url)) {
        return _forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.LOB_CATEGORY.CN;
    } else if (/\/onboarding/i.test(url)) {
        return _forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.LOB_CATEGORY.PC;
    } else if (/\/reload\//i.test(url)) {
        // for reload funnel
        return _forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.LOB_CATEGORY.PC;
    } else {
        return '';
    }
}

function getShortHeaders(page_context) {
    const result = {};
    for (const [key, value] of Object.entries(page_context)){
        result['x-' + (shortenHeader[key] || key)] = value;
    }
    return result;
}
function getPdtHeaders({ lobFunnelType }) {
    const partner = 'mmt';
    let { page_context } = getCommonPdtDataV2({
        partner,
        lobFunnelType
    });
    page_context = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.removeEmptyKeys)(page_context);
    page_context = getShortHeaders(page_context);
    const headers = {
        'page-context': page_context
    };
    // const journeyId = getCookie(COOKIES.PDT_JOURNEY_ID, true);
    // if (journeyId) {
    //   headers['x-jo-id'] = journeyId;
    // }
    return headers;
}
function setPdtHeaders(pdtHeader, headers) {
    for (const [headerKey, headerValue] of Object.entries(pdtHeader)){
        if (typeof headerValue === 'object') {
            setPdtHeaders(headerValue, headers);
        } else {
            headers.set(headerKey, headerValue);
        }
    }
}
function setPageContextHeaders(headers, lobFunnelType) {
    try {
        const pdtHeader = getPdtHeaders({
            lobFunnelType
        });
        setPdtHeaders(pdtHeader, headers);
    } catch (e) {
        console.error(e == null ? void 0 : e.message);
    }
}
function setPdtHeadersV2(pdtHeader, headers) {
    for (const [headerKey, headerValue] of Object.entries(pdtHeader)){
        if (typeof headerValue === 'object') {
            setPdtHeadersV2(headerValue, headers);
        } else {
            headers[headerKey] = headerValue;
        }
    }
}
function setPageContextHeadersV2(headers, lobFunnelType) {
    const pdtHeader = getPdtHeaders({
        lobFunnelType
    });
    setPdtHeadersV2(pdtHeader, headers);
    return headers;
}
function updateEventName(eventDetail, pdtEvents) {
    const eventName = (eventDetail == null ? void 0 : eventDetail.event_name) || '';
    if (eventName) {
        eventDetail.event_name = pdtEvents[eventName] || eventName;
    }
}
function getRequestIdHeaders(reqId) {
    const headers = {};
    headers[`x-rq-id`] = reqId || '';
    return headers;
}

let PdtSchemaUpdater = class PdtSchemaUpdater {
    mergeDeviceContext(deviceContext) {
        var _this_data;
        this.data = _extends({}, this.data, {
            device_context: _extends({}, (_this_data = this.data) == null ? void 0 : _this_data.device_context, deviceContext)
        });
        return this;
    }
    mergeEventDetailsData(eventDetail) {
        var _this_data, _this_data_event_detail, _this_data1, _this_data_event_detail1, _this_data2;
        this.data = _extends({}, this.data, {
            event_detail: _extends({}, (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.mergeObjects)((_this_data = this.data) == null ? void 0 : _this_data.event_detail, eventDetail), {
                event_name: eventDetail.event_name || ((_this_data1 = this.data) == null ? void 0 : (_this_data_event_detail = _this_data1.event_detail) == null ? void 0 : _this_data_event_detail.event_name),
                event_type: eventDetail.event_type || ((_this_data2 = this.data) == null ? void 0 : (_this_data_event_detail1 = _this_data2.event_detail) == null ? void 0 : _this_data_event_detail1.event_type)
            })
        });
        return this;
    }
    mergePageContextData(pageContextData) {
        var _this_data, _this_data_page_context;
        this.data = _extends({}, this.data, {
            page_context: _extends({}, (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.mergeObjects)((_this_data = this.data) == null ? void 0 : _this_data.page_context, pageContextData || {}), {
                funnel_step: pageContextData == null ? void 0 : pageContextData.funnel_step,
                lob: (pageContextData == null ? void 0 : pageContextData.lob) || ((_this_data_page_context = this.data.page_context) == null ? void 0 : _this_data_page_context.lob) || ''
            })
        });
        return this;
    }
    mergeEventTrackingContext(eventTrackingContext) {
        var _this_data, _this_data_event_tracking_context, _this_data1;
        var _eventTrackingContext_timestamp, _ref;
        this.data = _extends({}, this.data, {
            event_tracking_context: _extends({}, (_this_data = this.data) == null ? void 0 : _this_data.event_tracking_context, eventTrackingContext, {
                timestamp: (_ref = (_eventTrackingContext_timestamp = eventTrackingContext == null ? void 0 : eventTrackingContext.timestamp) != null ? _eventTrackingContext_timestamp : (_this_data1 = this.data) == null ? void 0 : (_this_data_event_tracking_context = _this_data1.event_tracking_context) == null ? void 0 : _this_data_event_tracking_context.timestamp) != null ? _ref : Date.now()
            })
        });
        return this;
    }
    mergeAdobeAnalytics(adobeAnalytics) {
        var _this_data;
        this.data = _extends({}, this.data, {
            adobe_analytics: _extends({}, (_this_data = this.data) == null ? void 0 : _this_data.adobe_analytics, adobeAnalytics)
        });
        return this;
    }
    getSchema() {
        return this.data;
    }
    constructor(commonPdtData){
        this.data = commonPdtData || {};
    }
};

/// <reference path="./types/mmt-event-logger.d.ts" />
//@typescript-eslint/ban-ts-comment
const AnalyticsSdk = (0,_mmt_event_logger__WEBPACK_IMPORTED_MODULE_1__.initAndGetAnalyticsSdk)({});
function generateRequestId() {
    return (0,uuid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
}
const getPdtLoggerMethodsV2 = ({ lobFunnelType, userId, puid, pdtEvents, funnelStep, subpage_name })=>{
    const partner = 'mmt';
    const sendPdtDataV2 = async ({ event_detail, page_context, event_tracking_context, device_context, shouldFlushEvents = false, adobe_analytics })=>{
        try {
            const commonPdtData = getCommonPdtDataV2({
                partner,
                userId,
                puid,
                lobFunnelType,
                funnelStep,
                subpage_name
            });
            const pdtSchemaUpdater = new PdtSchemaUpdater(commonPdtData);
            AnalyticsSdk.setRuntimeContextProvider({
                getUserContext: ()=>{
                    return commonPdtData.user_context;
                },
                getDeviceContext: ()=>{
                    return commonPdtData.device_context;
                }
            });
            const data = pdtSchemaUpdater.mergeEventDetailsData(event_detail || {}).mergePageContextData(page_context).mergeDeviceContext(device_context).mergeEventTrackingContext(_extends({}, event_tracking_context)).mergeAdobeAnalytics(adobe_analytics).getSchema();
            updateEventName((data == null ? void 0 : data.event_detail) || {}, pdtEvents);
            await AnalyticsSdk.track(data, LOB.FOREX);
            await AnalyticsSdk.pushToAdobeDataLayer(data);
            if (shouldFlushEvents) {
                AnalyticsSdk.flushEvents();
            }
        } catch (e) {
            console.error('sendPdtDataV2: ', e);
        }
    };
    return {
        sendPdtDataV2
    };
};
function sendPdtErrorEvent({ appErrorReducer, sendPdtDataV2 }) {
    try {
        var _appErrorReducer_pdtInfo, _appErrorReducer_pdtInfo1;
        const errorMessage = (appErrorReducer == null ? void 0 : (_appErrorReducer_pdtInfo = appErrorReducer.pdtInfo) == null ? void 0 : _appErrorReducer_pdtInfo.errorDescription) || (appErrorReducer == null ? void 0 : appErrorReducer.errorTitle) || (appErrorReducer == null ? void 0 : appErrorReducer.errorDescription) || (appErrorReducer == null ? void 0 : appErrorReducer.message);
        if (!errorMessage && !(appErrorReducer == null ? void 0 : appErrorReducer.apiUrl)) return;
        sendPdtDataV2({
            event_detail: getEventDetails({
                event_name: 'NA',
                vendor_error_details: getVendorErrorDetails({
                    error_code: (appErrorReducer == null ? void 0 : (_appErrorReducer_pdtInfo1 = appErrorReducer.pdtInfo) == null ? void 0 : _appErrorReducer_pdtInfo1.code) || (appErrorReducer == null ? void 0 : appErrorReducer.code) || 'NO_CODE_FOUND',
                    error_message_shown: errorMessage,
                    api_url: appErrorReducer == null ? void 0 : appErrorReducer.apiUrl
                })
            })
        });
    } catch (e) {
        console.error('sendPdtErrorEvent fn ', e);
    }
}

let PdtCache = class PdtCache {
    static getInstance() {
        if (!PdtCache.instance) {
            PdtCache.instance = new PdtCache();
        }
        return PdtCache.instance;
    }
    set(key, data) {
        this.cache.set(key, data);
    }
    get(key) {
        return this.cache.get(key);
    }
    clear() {
        this.cache.clear();
    }
    has(key) {
        return this.cache.has(key);
    }
    constructor(){
        this.cache = new Map();
    }
};
const pdtCache = PdtCache.getInstance();

const mergePdtData = (base, override)=>{
    return (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.mergeObjects)(base, override);
};
const addRequestId = (data, reqId)=>{
    const result = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.deepCopy)(data);
    const requestId = reqId || generateRequestId();
    result.event_tracking_context = _extends({}, result.event_tracking_context, {
        request_id: requestId
    });
    return result;
};
const extractUserData = (apiResponse, state)=>{
    var _state_userData, _apiResponse_apiData_user, _apiResponse_apiData, _state_userData1, _apiResponse_apiData_user1, _apiResponse_apiData1;
    return {
        userId: (state == null ? void 0 : (_state_userData = state.userData) == null ? void 0 : _state_userData.userId) || (apiResponse == null ? void 0 : (_apiResponse_apiData = apiResponse.apiData) == null ? void 0 : (_apiResponse_apiData_user = _apiResponse_apiData.user) == null ? void 0 : _apiResponse_apiData_user['x-tm-user-id']),
        puid: (state == null ? void 0 : (_state_userData1 = state.userData) == null ? void 0 : _state_userData1.puid) || (apiResponse == null ? void 0 : (_apiResponse_apiData1 = apiResponse.apiData) == null ? void 0 : (_apiResponse_apiData_user1 = _apiResponse_apiData1.user) == null ? void 0 : _apiResponse_apiData_user1['x-puid'])
    };
};
const getFunnelEntry = ()=>{
    const utmParams = getAllUtmWithStorage();
    const funnelSource = utmParams == null ? void 0 : utmParams.utm_source;
    const funnelCampaign = utmParams == null ? void 0 : utmParams.utm_campaign;
    const funnelMedium = utmParams == null ? void 0 : utmParams.utm_medium;
    if (!funnelSource && !funnelCampaign && !funnelMedium) {
        return null;
    }
    return `${funnelSource}|${funnelMedium}|${funnelCampaign}`;
};
const getAllUtmWithStorage = ()=>{
    const defaultResult = {
        utm_source: null,
        utm_campaign: null,
        utm_medium: null
    };
    if ((0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.isOnServer)()) return defaultResult;
    const utmParams = [
        _forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.QUERY_PARAM_KEYS.UTM_SOURCE,
        _forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.QUERY_PARAM_KEYS.UTM_CAMPAIGN,
        _forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.QUERY_PARAM_KEYS.UTM_MEDIUM
    ];
    const getFromStorage = (param)=>(0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getSessionStorageItem)(param);
    try {
        const urlObj = new URL(window.location.href);
        return Object.fromEntries(utmParams.map((param)=>{
            const urlValue = urlObj.searchParams.get(param);
            if (urlValue) {
                (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.setSessionStorageItem)(param, urlValue);
                return [
                    param,
                    urlValue
                ];
            }
            return [
                param,
                getFromStorage(param)
            ];
        }));
    } catch (e) {
        return Object.fromEntries(utmParams.map((param)=>[
                param,
                getFromStorage(param)
            ]));
    }
};
const addUtmFunnelEntry = (data, utmSource)=>{
    const result = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.deepCopy)(data);
    result.event_tracking_context = _extends({}, result.event_tracking_context, {
        funnel_entry: getFunnelEntry()
    });
    return result;
};
const getUtmParameter = (parameterName, url)=>{
    const targetUrl = (typeof window !== 'undefined' ? window.location.href : '');
    if (!targetUrl) return null;
    try {
        const urlObj = new URL(targetUrl);
        return urlObj.searchParams.get(parameterName);
    } catch (error) {
        return null;
    }
};
const getUtmSource = (url)=>{
    return getUtmParameter('utm_source');
};
const replacePipeWithComma = (data)=>{
    var _data_event_detail_components_content_details, _data_event_detail_components, _data_event_detail;
    data == null ? void 0 : (_data_event_detail = data.event_detail) == null ? void 0 : (_data_event_detail_components = _data_event_detail.components) == null ? void 0 : (_data_event_detail_components_content_details = _data_event_detail_components.content_details) == null ? void 0 : _data_event_detail_components_content_details.forEach((item)=>{
        if (typeof item.description === 'string') {
            item.description = item.description.replace(/\|/g, ',');
        }
    });
    return data;
};
const transformComponentData = (components)=>{
    const contentDetails = components == null ? void 0 : components.content_details;
    if (!contentDetails || contentDetails.length === 0) {
        return '';
    }
    const transformedItems = contentDetails.filter((content)=>content !== null).map((content)=>{
        const values = [];
        var _content_id;
        values.push((_content_id = content == null ? void 0 : content.id) != null ? _content_id : '');
        var _content_type;
        values.push((_content_type = content == null ? void 0 : content.type) != null ? _content_type : '');
        values.push('');
        values.push('');
        var _content_description;
        values.push((_content_description = content == null ? void 0 : content.description) != null ? _content_description : '');
        return values.join(':');
    });
    return transformedItems.join(' | ');
};
const transformUpcomingTrip = (upcomingTrip)=>{
    const tripDetails = upcomingTrip == null ? void 0 : upcomingTrip.trip_details;
    if (!(tripDetails == null ? void 0 : tripDetails.length) || !(0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.isArray)(tripDetails)) {
        return '';
    }
    // Transform only the first trip detail
    const firstTrip = tripDetails[0];
    if (!firstTrip) {
        return '';
    }
    const values = [];
    if (firstTrip == null ? void 0 : firstTrip.intent) values.push(`${firstTrip.intent}`);
    if (firstTrip == null ? void 0 : firstTrip.dependent_lob) values.push(`${firstTrip.dependent_lob}`);
    if (firstTrip == null ? void 0 : firstTrip.country_code) values.push(`${firstTrip.country_code}`);
    if (firstTrip == null ? void 0 : firstTrip.rtt) values.push(`${firstTrip.rtt}`);
    if (firstTrip == null ? void 0 : firstTrip.opportunity_type) values.push(`${firstTrip.opportunity_type}`);
    return values.join(':');
};

// Global state to track page exit setup
let isPageExitSetup = false;
let pageExitSent = false;
const setupPageExit = (sendPdtDataV2)=>{
    // If page exit is already setup, don't setup again
    if (isPageExitSetup) {
        return;
    }
    const handlePageExit = async ()=>{
        // Prevent multiple executions
        if (pageExitSent) {
            return;
        }
        try {
            const metadata = pdtCache.get('metadata');
            const pageExitData = pdtCache.get('pageExit');
            if (metadata && pageExitData) {
                const mergedData = mergePdtData(metadata, pageExitData);
                let finalData = addRequestId(mergedData);
                const utmSource = getUtmSource();
                if (utmSource) {
                    finalData = addUtmFunnelEntry(finalData, utmSource);
                }
                try {
                    await sendPdtDataV2(_extends({}, finalData, {
                        shouldFlushEvents: true
                    }));
                    // Only mark as sent after successful sending
                    pageExitSent = true;
                } catch (error) {
                    console.error('Failed to send page exit data:', error);
                // Don't set pageExitSent flag if sending failed
                }
            }
        } catch (error) {
            console.error('Error in page exit handler:', error);
        }
    };
    if (typeof window !== 'undefined') {
        window.addEventListener('beforeunload', handlePageExit);
        window.addEventListener('pagehide', handlePageExit);
        // Mark as setup to prevent future setups
        isPageExitSetup = true;
    }
};

/// <reference path="../types/mmt-ui.d.ts" />
const initSessionStorageUserInfo = async ()=>{
    try {
        return await (0,MMT_UI_getPIIData_client__WEBPACK_IMPORTED_MODULE_3__.getUserInfoPIIClient)();
    } catch (e) {
        console.warn('Failed to get user info (user may not be logged in):', e);
        return null;
    }
};
/**
 * Initializes PDT tracking with the given extracted parameters
 * @param config Configuration object containing extracted analytics data, user info and lobFunnelType
 */ const initPdtTracking = async ({ analytics, requestId, userId, puid, lobFunnelType, isSeo })=>{
    try {
        var _analytics_pageExit_analytics, _analytics_pageExit, _analytics_pageLoad_analytics, _analytics_pageLoad, _finalData_event_detail, _finalData_event_detail1;
        if (userId) {
            pdtCache.set('userId', userId);
        }
        if (puid) {
            pdtCache.set('puid', puid);
        }
        // Cache metadata for later use
        if (analytics == null ? void 0 : analytics.pdtData) {
            pdtCache.set('metadata', analytics.pdtData);
        }
        if (analytics == null ? void 0 : (_analytics_pageExit = analytics.pageExit) == null ? void 0 : (_analytics_pageExit_analytics = _analytics_pageExit.analytics) == null ? void 0 : _analytics_pageExit_analytics.pdtData) {
            pdtCache.set('pageExit', analytics.pageExit.analytics.pdtData);
        }
        pdtCache.set('lobFunnelType', {
            event_detail: {
                event_type: lobFunnelType
            }
        });
        if (isSeo) {
            const subpageName = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getLastUrlSegment)();
            pdtCache.set('subpage_name', subpageName);
        }
        const { sendPdtDataV2 } = getPdtLoggerMethodsV2({
            userId: userId || undefined,
            puid: puid || undefined,
            lobFunnelType,
            pdtEvents: {},
            subpage_name: pdtCache.get('subpage_name')
        });
        //Send page load event
        let pageLoadData = mergePdtData((analytics == null ? void 0 : analytics.pdtData) || {}, (analytics == null ? void 0 : (_analytics_pageLoad = analytics.pageLoad) == null ? void 0 : (_analytics_pageLoad_analytics = _analytics_pageLoad.analytics) == null ? void 0 : _analytics_pageLoad_analytics.pdtData) || {});
        pageLoadData = addUtmFunnelEntry(pageLoadData);
        const finalData = addRequestId(pageLoadData, requestId);
        replacePipeWithComma(finalData);
        const components_l1 = transformComponentData((_finalData_event_detail = finalData.event_detail) == null ? void 0 : _finalData_event_detail.components);
        const upcoming_trip_c50 = transformUpcomingTrip((_finalData_event_detail1 = finalData.event_detail) == null ? void 0 : _finalData_event_detail1.upcoming_trip);
        finalData.adobe_analytics = {
            components_l1,
            upcoming_trip_c50
        };
        await sendPdtDataV2(finalData);
        // Setup page exit tracking
        setupPageExit(sendPdtDataV2);
    } catch (error) {
        console.error('PDT initialization failed:', error);
        throw error;
    }
};
/**
 * Tracks a PDT event with the given event data and state
 * @param config Configuration object containing event data and state
 */ const trackEvent = async ({ eventData, requestId })=>{
    try {
        var _cachedLobFunnelType_event_detail, _finalData_event_detail, _finalData_event_detail1;
        if (!eventData) {
            return;
        }
        const metadata = pdtCache.get('metadata');
        const cachedLobFunnelType = pdtCache.get('lobFunnelType');
        if (!metadata) {
            console.warn('PDT not initialized');
            return;
        }
        const userId = pdtCache.get('userId');
        const puid = pdtCache.get('puid');
        const { sendPdtDataV2 } = getPdtLoggerMethodsV2({
            userId: userId || undefined,
            puid: puid || undefined,
            lobFunnelType: (cachedLobFunnelType == null ? void 0 : (_cachedLobFunnelType_event_detail = cachedLobFunnelType.event_detail) == null ? void 0 : _cachedLobFunnelType_event_detail.event_type) || 'Listing',
            pdtEvents: {},
            subpage_name: pdtCache.get('subpage_name')
        });
        const mergedData = mergePdtData(metadata, eventData);
        let finalData;
        if (requestId) {
            finalData = addRequestId(mergedData, requestId);
        } else {
            finalData = mergedData;
        }
        finalData = addUtmFunnelEntry(finalData);
        replacePipeWithComma(finalData);
        const components_l1 = transformComponentData((_finalData_event_detail = finalData.event_detail) == null ? void 0 : _finalData_event_detail.components);
        const upcoming_trip_c50 = transformUpcomingTrip((_finalData_event_detail1 = finalData.event_detail) == null ? void 0 : _finalData_event_detail1.upcoming_trip);
        finalData.adobe_analytics = {
            components_l1,
            upcoming_trip_c50
        };
        await sendPdtDataV2(finalData);
    } catch (error) {
        console.error('PDT event tracking failed:', error);
        throw error;
    }
};
/**
 * Convenience function for tracking component events
 * @param eventData PDT event data
 * @param state PDT state
 */ const trackComponentEvent = (eventData, state)=>{
    if (eventData) {
        trackEvent({
            eventData}).catch((error)=>{
            console.error('Component event tracking failed:', error);
        });
    }
};
/**
 * Updates the description in the first content detail of PDT data immutably.
 *
 * @param originalPdtData - The original PDT data object.
 * @param newDescription - The new description value to set.
 * @returns A new PDT data object with the updated description.
 */ function updatePdtDataDescription(originalPdtData, newDescription) {
    var _originalPdtData_event_detail, _originalPdtData_event_detail_components_content_details, _originalPdtData_event_detail_components, _originalPdtData_event_detail1;
    if (!originalPdtData) {
        return originalPdtData;
    }
    return _extends({}, originalPdtData, {
        event_detail: _extends({}, originalPdtData.event_detail, {
            components: _extends({}, (_originalPdtData_event_detail = originalPdtData.event_detail) == null ? void 0 : _originalPdtData_event_detail.components, {
                content_details: (_originalPdtData_event_detail1 = originalPdtData.event_detail) == null ? void 0 : (_originalPdtData_event_detail_components = _originalPdtData_event_detail1.components) == null ? void 0 : (_originalPdtData_event_detail_components_content_details = _originalPdtData_event_detail_components.content_details) == null ? void 0 : _originalPdtData_event_detail_components_content_details.map((detail, index)=>index === 0 ? _extends({}, detail, {
                        description: newDescription
                    }) : detail)
            })
        })
    });
}
/**
 * Cleans up PDT tracking by clearing the cache
 */ const cleanupPdtTracking = ()=>{
    pdtCache.clear();
};
/**
 * Helper function to extract parameters from legacy apiResponse and state objects
 * @param apiResponse Legacy API response object
 * @param state Legacy state object
 * @param lobFunnelType LOB funnel type
 * @returns Extracted parameters for initPdtTracking
 */ const extractPdtTrackingParams = (apiResponse, state, lobFunnelType, isSeo)=>{
    const { userId, puid } = extractUserData(apiResponse, state);
    const subpageName = (0,_forex_core_utils__WEBPACK_IMPORTED_MODULE_0__.getLastUrlSegment)();
    return {
        analytics: (apiResponse == null ? void 0 : apiResponse.analytics) || {
            pdtData: undefined,
            pageLoad: undefined,
            pageExit: undefined
        },
        requestId: apiResponse == null ? void 0 : apiResponse.requestId,
        userId,
        puid,
        lobFunnelType,
        isSeo,
        subpage_name: subpageName
    };
};




/***/ }),

/***/ 6401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AnalyticsPluginAdobe; }
/* harmony export */ });
/* harmony import */ var _growth_object_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7106);


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var config = {
  adobeDataLayer: []
};

var formatPageName = function formatPageName(_ref) {
  var pageName = _ref.pageName,
      section = _ref.section,
      lob = _ref.lob;
  return section + ":" + lob + ":" + pageName.toLowerCase();
};

var AnalyticsPluginAdobe = function AnalyticsPluginAdobe(pluginConfig, debug) {
  var name = 'analytics-adobe-omniture';

  var configs = _extends({}, pluginConfig);

  var init = function init() {
    var _window$top;

    if (window.top && !window.top.adobeDataLayer) {
      window.top.adobeDataLayer = [];
    }

    config.adobeDataLayer = (_window$top = window.top) == null ? void 0 : _window$top.adobeDataLayer; // return the created window dataLayer. Helps in testing

    return config.adobeDataLayer;
  };

  var track = function track(_ref2) {
    var payload = _ref2.payload;

    if (typeof config.adobeDataLayer !== 'undefined') {
      var formattedPayload = (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepClone */ .I8)(_extends({}, configs));
      (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepMerge */ .RH)(payload.eventProperties, formattedPayload);

      if (debug) {
        console.log('track payload ', _extends({
          event: payload.event
        }, formattedPayload));
      } // since ctaclick all the parameters are mandatory i.e. why adding check here


      if (payload.event === 'ctaClick') {
        formattedPayload.cta = {
          name: formattedPayload.cta.name || undefined,
          destination: formattedPayload.cta.destination || undefined,
          type: formattedPayload.cta.type || undefined,
          componentName: formattedPayload.cta.componentName || undefined
        };
      } // don't push the event if adobe script is not present


      if (config.adobeDataLayer) config.adobeDataLayer.push(_extends({
        event: payload.event
      }, formattedPayload));
      return formattedPayload;
    }

    return {};
  };

  var pageView = function pageView(pageName, properties) {
    if (typeof config.adobeDataLayer !== 'undefined') {
      var _ref3 = properties || {},
          _ref3$eventProperties = _ref3.eventProperties,
          eventProperties = _ref3$eventProperties === void 0 ? {} : _ref3$eventProperties;

      var formattedPayload = _extends({}, pluginConfig);

      (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepMerge */ .RH)(eventProperties, formattedPayload); // updating the global config data with every pageView Data

      configs = _extends({}, formattedPayload);
      formattedPayload.page.pageInfo.pageName = formattedPayload != null && formattedPayload.doNotFormatPageName ? pageName.toLowerCase() : formatPageName({
        section: formattedPayload.page.pageInfo.section,
        lob: pluginConfig.page.pageInfo.lob,
        pageName: pageName
      });
      var payload = {
        event: 'Page_View',
        eventProperties: formattedPayload
      };
      track({
        payload: payload
      });
      return formattedPayload;
    }

    return {};
  };

  return {
    name: name,
    configs: configs,
    init: init,
    track: track,
    pageView: pageView
  };
};




/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pdtAnalytics; }
});

// EXTERNAL MODULE: ../../node_modules/@growth/location/dist/growth-location.esm.js
var growth_location_esm = __webpack_require__(810);
// EXTERNAL MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js + 1 modules
var growth_visitor_id_browser_esm = __webpack_require__(6939);
;// CONCATENATED MODULE: ../../node_modules/@growth/pdt-schema/schema/dist/growth-pdt-schema-schema.esm.js



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var growth_pdt_schema_schema_esm_CreateWebCommonSchema = function CreateWebCommonSchema(properties) {
  var _navigator, _navigator$connection;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  var event_details = properties.event_details,
      device = properties.device;
  this.values = {
    context: _extends({
      client_timestamp: Date.now(),
      server_timestamp: Date.now(),
      client_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      template_id: '26029',
      topic_name: 'gi_growth_web_logging'
    }, properties == null ? void 0 : properties.context),
    event_details: _extends({
      page_uri: (event_details == null ? void 0 : event_details.page_uri) || window.location.href,
      canonical_host: (event_details == null ? void 0 : event_details.canonical_host) || window.location.origin,
      canonical_url: (event_details == null ? void 0 : event_details.canonical_url) || window.location.pathname,
      page_referrer: (event_details == null ? void 0 : event_details.page_referrer) || document.referrer,
      utm_campaign: (event_details == null ? void 0 : event_details.utm_campaign) || (0,growth_location_esm/* getQueryParam */.Ph)('utm_campaign'),
      utm_medium: (event_details == null ? void 0 : event_details.utm_medium) || (0,growth_location_esm/* getQueryParam */.Ph)('utm_medium'),
      utm_source: (event_details == null ? void 0 : event_details.utm_source) || (0,growth_location_esm/* getQueryParam */.Ph)('utm_source')
    }, properties.event_details),
    user: properties.user,
    device: _extends({
      user_agent: navigator.userAgent,
      network_type: ((_navigator = navigator) == null ? void 0 : (_navigator$connection = _navigator.connection) == null ? void 0 : _navigator$connection.effectiveType) || '',
      visitor_id: (device == null ? void 0 : device.visitor_id) || (0,growth_visitor_id_browser_esm/* getVisitorIdBrowser */.MI)(),
      screen_height: (device == null ? void 0 : device.screen_height) || String(window.screen.height),
      screen_width: (device == null ? void 0 : device.screen_width) || String(window.screen.width)
    }, properties == null ? void 0 : properties.device)
  };
};



// EXTERNAL MODULE: ../../node_modules/@growth/cookies/dist/growth-cookies.esm.js
var growth_cookies_esm = __webpack_require__(2048);
;// CONCATENATED MODULE: ../../node_modules/@growth/pdt-track/dist/growth-pdt-track.esm.js



var isEmptyObject = function isEmptyObject(obj) {
  return obj && Object.keys(obj).length === 0;
};
var DEFAULT_CONFIG = {
  debug: false
};
var PDT_URL = 'https://pdt.goibibo.com/dts/s/da/n';

var sendToPdt = function sendToPdt(_ref) {
  var url = _ref.url,
      analyticsData = _ref.analyticsData,
      debug = _ref.debug,
      customHeaders = _ref.customHeaders;
  var headers = {
    'Content-Type': 'application/json',
    'Request-Data-Encoding': 'json'
  };

  var _ref2 = customHeaders || {},
      dvid = _ref2.dvid,
      gaid = _ref2.gaid;

  if (dvid) headers.dvid = dvid;
  if (gaid) headers.gaid = gaid;
  if (debug) headers['X-DEBUG'] = true;
  return fetch(url, {
    method: 'POST',
    headers: headers,
    credentials: 'omit',
    body: JSON.stringify(analyticsData),
    // @ts-ignore-start
    priority: 'low',
    keepalive: true
  });
};

var pdtTrack = function pdtTrack(eventDetails, configs) {
  if (configs === void 0) {
    configs = DEFAULT_CONFIG;
  }

  if (isEmptyObject(eventDetails)) {
    throw new TypeError("Vaidation error on pdt.track; eventDetails parameter must have event key; eventDetails: " + eventDetails);
  }

  var _configs = configs,
      debug = _configs.debug;
  var allEventDetails = new CreateWebCommonSchema(eventDetails).values;
  /*
    * NOTE: we are not doing any validation on this package, since we want to keep this package size small.
    * For validation and more feature use analytics-plugin-pdt
    *
    * Log final events before sending to pdt
    */

  if (debug) console.log('@growth/pdt-track', allEventDetails);
  var dvid = getItem('__gi_vid');
  var gaid = getItem('_gid');
  return sendToPdt({
    url: PDT_URL,
    analyticsData: [allEventDetails],
    debug: configs.debug,
    customHeaders: {
      dvid: dvid,
      gaid: gaid
    }
  });
};



;// CONCATENATED MODULE: ../../node_modules/@growth/analytics-plugin-pdt/dist/growth-analytics-plugin-pdt.esm.js



function growth_analytics_plugin_pdt_esm_extends() {
  growth_analytics_plugin_pdt_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return growth_analytics_plugin_pdt_esm_extends.apply(this, arguments);
}

var defaultConfig = {
  debug: false,
  pdtUrl: 'https://pdt.goibibo.com/dts/s/da/n',
  validator: function validator(obj) {
    return [];
  },
  batchDelay: 100,
  loadEventBatch: true,
  batchRegex: /(load|growth_non_int)/
};

function pdtAnalytics(pluginConfig) {
  if (pluginConfig === void 0) {
    pluginConfig = {};
  }

  var configs = growth_analytics_plugin_pdt_esm_extends({}, defaultConfig, pluginConfig);

  var loadEventsQueue = [];
  var loadEventScheduled;

  var doTrack = function doTrack(_ref) {
    var payload = _ref.payload;
    var event = payload.event,
        _payload$eventPropert = payload.eventProperties,
        eventProperties = _payload$eventPropert === void 0 ? {} : _payload$eventPropert,
        globalProperties = payload.globalProperties,
        options = payload.options;
    var debug = configs.debug,
        batchDelay = configs.batchDelay,
        loadEventBatch = configs.loadEventBatch,
        batchRegex = configs.batchRegex;
    var commonPayload = {
      context: growth_analytics_plugin_pdt_esm_extends({}, globalProperties == null ? void 0 : globalProperties.context, eventProperties == null ? void 0 : eventProperties.context),
      device: growth_analytics_plugin_pdt_esm_extends({}, globalProperties == null ? void 0 : globalProperties.device, eventProperties == null ? void 0 : eventProperties.device),
      event_details: growth_analytics_plugin_pdt_esm_extends({
        event: event
      }, eventProperties.event_details),
      user: growth_analytics_plugin_pdt_esm_extends({}, globalProperties == null ? void 0 : globalProperties.user, eventProperties == null ? void 0 : eventProperties.user)
    };
    var pdtEvent = new growth_pdt_schema_schema_esm_CreateWebCommonSchema(commonPayload).values; // validation of schema

    if (debug && typeof configs.validator === 'function') {
      var invalidKeys = configs.validator(pdtEvent);

      if (invalidKeys.length) {
        console.error("pdt.track() schema validation failed: Sending event properties {" + invalidKeys + "} which are not a part of schema");
        return;
      }
    }

    var send = function send(events) {
      return sendToPdt({
        url: configs.pdtUrl,
        analyticsData: events,
        customHeaders: options == null ? void 0 : options.pdtApiHeaders,
        debug: debug
      });
    };
    /** Send load events in a bulk to avoid concurrent api calls */


    var isALoadEvent = function isALoadEvent(e) {
      return e.toLowerCase().match(batchRegex);
    };

    if (loadEventBatch && isALoadEvent(event)) {
      // keep the load event in an array
      loadEventsQueue.push(pdtEvent); // send the all load events in a batch after a certain delay

      if (!loadEventScheduled) {
        var scheduleSend = function scheduleSend() {
          if (debug) {
            console.log('LoadEvents Queue', loadEventsQueue.length);
          }

          send(loadEventsQueue); // !!! Important clear the array after events are sents

          loadEventsQueue = []; // reset the schedule

          loadEventScheduled = undefined;
        };

        loadEventScheduled = setTimeout(scheduleSend, batchDelay);
      }

      return;
    }

    send([pdtEvent]);
  };

  return {
    name: 'pdt-analytics-plugin',
    configs: configs,
    init: function init() {
      return configs;
    },
    track: function track(_ref2) {
      var payload = _ref2.payload;
      return doTrack({
        payload: payload
      });
    }
  };
}




/***/ }),

/***/ 1225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uH": function() { return /* binding */ defaultTheme; }
/* harmony export */ });
/* unused harmony exports breakPoints, buildTheme, colors, font, misc, spacing, useTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

// https://html.mmt.com/htmls/projects/HTMLFrontendHub/baseProjects/TypeSystem/gi/index.html

/* NOTE: not using the @React_UI_Lib/GIFontStandard since it does not support the type script
 import Styles from '@React_UI_Lib/GIFontStandard';
*/
// Type - Family and Weight
var fwRegular = {
  fontWeight: 400
};
var fwMedium = {
  fontWeight: 500
};
var fwSemiBold = {
  fontWeight: 600
};
var fwBold = {
  fontWeight: 700
};
var fs32 = {
  fontSize: '32px'
};
var fs24 = {
  fontSize: '24px'
};
var fs18 = {
  fontSize: '18px'
};
var fs16 = {
  fontSize: '16px'
};
var fs14 = {
  fontSize: '14px'
};
var fs12 = {
  fontSize: '12px'
};
var lhAuto = {
  lineHeight: 'auto'
}; //  Font Headings

var xLarge = _extends({}, fwBold, fs32, lhAuto);

var Large = _extends({}, fwBold, fs24, lhAuto);

var Small = _extends({}, fwSemiBold, fs18, lhAuto);

var Base = _extends({}, fwSemiBold, fs16, lhAuto); // Font Labels


var LargeW1 = _extends({}, fwRegular, fs18, lhAuto);

var LargeW2 = _extends({}, fwMedium, fs18, lhAuto);

var LargeW3 = _extends({}, fwSemiBold, fs18, lhAuto);

var MediumW1 = _extends({}, fwRegular, fs16, lhAuto);

var MediumW2 = _extends({}, fwMedium, fs16, lhAuto);

var MediumW3 = _extends({}, fwSemiBold, fs16, lhAuto);

var BaseW1 = _extends({}, fwRegular, fs14, lhAuto);

var BaseW2 = _extends({}, fwMedium, fs14, lhAuto);

var BaseW3 = _extends({}, fwSemiBold, fs14, lhAuto);

var SmallW1 = _extends({}, fwRegular, fs12, lhAuto);

var SmallW2 = _extends({}, fwMedium, fs12, lhAuto);

var SmallW3 = _extends({}, fwSemiBold, fs12, lhAuto);

var giFontStandard = {
  xLarge: xLarge,
  Large: Large,
  Small: Small,
  Base: Base,
  LargeW1: LargeW1,
  LargeW2: LargeW2,
  LargeW3: LargeW3,
  MediumW1: MediumW1,
  MediumW2: MediumW2,
  MediumW3: MediumW3,
  BaseW1: BaseW1,
  BaseW2: BaseW2,
  BaseW3: BaseW3,
  SmallW1: SmallW1,
  SmallW2: SmallW2,
  SmallW3: SmallW3
};

var fontFamilyGenerics = 'Avenir, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
var fontFamilyRubik = "Rubik, " + fontFamilyGenerics;
var defaultFontThemeProperties = {
  fontFamilyDefault: fontFamilyRubik,
  fontFamilyQuicksand: fontFamilyRubik,
  fontFamilyRoboto: fontFamilyRubik,
  fontFamilyHelvetica: fontFamilyRubik,
  token: _extends({}, giFontStandard)
};

var buildFont = function buildFont(fontThemeProperties) {
  if (fontThemeProperties === void 0) {
    fontThemeProperties = defaultFontThemeProperties;
  }

  return _extends({}, fontThemeProperties);
};

var defaultSpacingThemeProperties = {
  unit: 1
};
function buildSpacing(spacingThemeProperties) {
  if (spacingThemeProperties === void 0) {
    spacingThemeProperties = defaultSpacingThemeProperties;
  }

  return {
    nospacing: 0,
    xxsmall: spacingThemeProperties.unit * 0.1 + "rem",
    // 1px | 0.1rem
    xsmall: spacingThemeProperties.unit * 0.2 + "rem",
    // 2px | 0.2rem
    small: spacingThemeProperties.unit * 0.5 + "rem",
    // 5px | 0.5rem
    base: spacingThemeProperties.unit + "rem",
    // 10px | 1rem
    large: spacingThemeProperties.unit * 1.5 + "rem",
    // 15px | 1.5rem
    xlarge: spacingThemeProperties.unit * 2 + "rem",
    // 20px | 2rem
    xxlarge: spacingThemeProperties.unit * 2.5 + "rem",
    // 25px | 2.5rem
    custom: function custom(multiplier // 3px 4px 6px 7px 8px | 0.3rem 0.4rem etc...
    ) {
      return spacingThemeProperties.unit * (multiplier * 0.1) + "rem";
    }
  };
}

var defaultMiscThemeProperties = {
  borderRadius: {
    unit: 0.4,
    unitScale: 0.2
  },
  border: {
    unit: 0.1
  },
  breakpoints: {
    md: 60 + "rem" // 600px

  }
};
function buildMisc(miscThemeProperties) {
  if (miscThemeProperties === void 0) {
    miscThemeProperties = defaultMiscThemeProperties;
  }

  return {
    borderRadius: {
      base: miscThemeProperties.borderRadius.unit + "rem",
      // 4px | 0.4rem
      // 2px | 0.2rem
      small: miscThemeProperties.borderRadius.unit - miscThemeProperties.borderRadius.unitScale + "rem",
      // 6px | 0.6rem
      large: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale + "rem",
      // 8px | 0.8rem
      xlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 2 + "rem",
      // 10px | 1rem
      xxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 3 + "rem",
      // 12px | 1.2rem
      xxxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 4 + "rem",
      round: '50%',
      // 15px | 1.5rem
      custom: function custom(multiplier // 15 - 15px, 20 - 20px
      ) {
        return multiplier * 0.1 + "rem";
      }
    },
    border: {
      base: miscThemeProperties.border.unit + "rem" // 1px

    },
    zIndex: {
      xxsmall: '2',
      xsmall: '3',
      small: '4',
      base: '5',
      large: '6',
      xlarge: '9',
      xxlarge: '99',
      xxxlarge: '999',
      maximum: '1999'
    }
  };
}

var colorPalette = {
  goBrandBlue: {
    base: '#2274E0',
    dark: '#1958B6',
    medium: '#D1E5FF',
    light: '#E8F3FF'
  },
  goBrandOrange: {
    base: '#FF6D38',
    dark: '#D95204',
    medium: '#EB6125',
    light: '#FFF1ED'
  },
  downriver: {
    base: '#141823',
    dark: '#46484d',
    medium: '#777777',
    light: '#C2C2C2'
  },
  goWhite: {
    base: '#FFFFFF',
    dark: 'rgba(255, 255, 255, .8)',
    medium: 'rgba(255, 255, 255, .5)',
    light: 'rgba(255, 255, 255, .2)'
  },
  ash: {
    base: '#647A97',
    dark: '#E1E7EE',
    medium: '#EFF3F8',
    light: '#F4F7FA'
  },
  goGreen: {
    base: '#18A160',
    dark: '#148730',
    medium: '#1ABA32',
    light: '#E9F6EA'
  },
  goTeal: {
    base: '#00a2ad',
    dark: '#008a93',
    medium: '#00B3C6',
    light: '#e1f6f6'
  },
  goYellow: {
    base: '#ffc24a',
    dark: '#FBAC43',
    medium: '#FFEA67',
    light: '#FFFDE9'
  },
  goPurple: {
    base: '#8f22e3',
    dark: '#7022D9',
    medium: '#9D3DE8',
    light: '#FBF1FF'
  },
  goRed: {
    base: '#FF3A5C',
    dark: '#E63148',
    medium: '#F83466',
    light: '#FFF5F7'
  },
  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)'
  },
  black: {
    base: '#000'
  }
};
function buildColors() {
  return colorPalette;
}

function breakPoints$1() {
  return {
    mobileM: '37.5rem',
    mobileL: '42.5rem',
    tablet: '76.8rem',
    laptop: '102.4rem',
    laptopL: '144.0rem',
    desktop: '256.0rem'
  };
}

var font = buildFont();
var spacing = buildSpacing();
var misc = buildMisc();
var colors = buildColors();
var breakPoints = breakPoints$1();
function buildTheme() {
  return {
    font: font,
    spacing: spacing,
    misc: misc,
    colors: colors,
    breakPoints: breakPoints
  };
}
/**
 * always defaultTheme should get consumed all over
 * we might be introducing further customization in buildTheme step
 */

var defaultTheme = buildTheme();
/**
 * to check if theme exists on caller, else return defaultTheme
 */

function useTheme() {
  var theme = useContext(ThemeContext);
  return theme || defaultTheme;
}




/***/ }),

/***/ 7263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tt": function() { return /* binding */ EXISTING_USER_STATUS_CODE; },
  "Wp": function() { return /* binding */ INVALID_OTP_CODE; },
  "XP": function() { return /* binding */ LOGIN_SUCCESS; },
  "Zb": function() { return /* binding */ MOBILE_NUMBER_MAX_LENGTH; },
  "vw": function() { return /* binding */ TRUECALLER_DEEPLINK_DATA; },
  "ti": function() { return /* binding */ clearSendOtpStore; },
  "H": function() { return /* binding */ clearUserTokens; },
  "hM": function() { return /* binding */ fetchLogoutUser; },
  "eR": function() { return /* binding */ getTruecallerDeepLink; },
  "P_": function() { return /* binding */ getUuidFromCookie; },
  "Ju": function() { return /* binding */ isEmailValid; },
  "gR": function() { return /* binding */ isMobileEncoded; },
  "Pz": function() { return /* binding */ isNameValid; },
  "Xv": function() { return /* binding */ isNumberValid; },
  "Tq": function() { return /* binding */ isUserTokenPresent; },
  "lq": function() { return /* binding */ useLoginUserStore; },
  "dt": function() { return /* binding */ usePrefillLoginDetails; },
  "Oz": function() { return /* binding */ useProfileStore; },
  "IR": function() { return /* binding */ useProfileUpdateStore; },
  "Y6": function() { return /* binding */ useSendOtpStore; },
  "W3": function() { return /* binding */ useSignupViaOTPStore; },
  "AJ": function() { return /* binding */ useTruecallerLoginStore; }
});

// UNUSED EXPORTS: ALPHABET_REGEX, BILLING_CATEGORY, EMAIL_REGEX, INVALID_AUTH_TOKEN_CODE, NEW_USER_STATUS_CODE, deleteSessionId, fetchCreateUser, fetchLoginJwtToken, fetchLoginUser, fetchMultipleLogins, fetchProfileDetails, fetchProfileUpdate, fetchRequestEmailVerification, fetchSendDeleteOTP, fetchSendOTP, fetchSignupViaOTP, fetchTruecallerLogin, fetchUpdateProfilePic, fetchVerifyEmail, getAuthToken, getEncryptedUuid, getEssentialHeader, logoutSpecificDevice, mobileValidation, profileViewQuery, setUserTokenAndUuid, useLoginEncryptedJwtToken, useUploadProfileImageStore

// EXTERNAL MODULE: ../../node_modules/@growth/fetch-request/dist/growth-fetch-request.esm.js
var growth_fetch_request_esm = __webpack_require__(6963);
// EXTERNAL MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js + 1 modules
var growth_visitor_id_browser_esm = __webpack_require__(6939);
// EXTERNAL MODULE: ../../node_modules/@growth/user-agents/dist/growth-user-agents.esm.js
var growth_user_agents_esm = __webpack_require__(6253);
// EXTERNAL MODULE: ../../node_modules/@growth/cookies/dist/growth-cookies.esm.js
var growth_cookies_esm = __webpack_require__(2048);
// EXTERNAL MODULE: ../../node_modules/@growth/object-utils/dist/growth-object-utils.esm.js
var growth_object_utils_esm = __webpack_require__(7106);
// EXTERNAL MODULE: ../../node_modules/@growth/ssr-utils/dist/growth-ssr-utils.esm.js
var growth_ssr_utils_esm = __webpack_require__(1917);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/@growth/store-helpers/dist/growth-store-helpers.esm.js
var growth_store_helpers_esm = __webpack_require__(6880);
;// CONCATENATED MODULE: ../../node_modules/@growth/dom-utils/dist/growth-dom-utils.esm.js
var isEnterEvent = function isEnterEvent(event) {
  var keyCode = event.key;
  return keyCode === 'Enter';
};

var isArrowDownKey = function isArrowDownKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowDown';
};

var isArrowUpKey = function isArrowUpKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowUp';
};

var isArrowLeftKey = function isArrowLeftKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowLeft';
};

var isArrowRightKey = function isArrowRightKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowRight';
};

var addScript = function addScript(scriptURl, opts) {
  if (typeof window !== 'undefined') {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptURl;
    script.async = opts.async || false;
    script.onload = opts.onload || null;
    var position = document.querySelector(opts.position || 'body');

    if (position) {
      position.append(script);
    }
  }
};

// this method add delay in resolving the promise
var promiseDelay = function promiseDelay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};



// EXTERNAL MODULE: ../../node_modules/@growth/date-utils/dist/growth-date-utils.esm.js + 1 modules
var growth_date_utils_esm = __webpack_require__(7862);
;// CONCATENATED MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js











var HOST = "//userservice.goibibo.com";
var PATHS = {
  dweb: "ext/web/desktop",
  mweb: "ext/web/pwa"
};

var getApiUrls = function getApiUrls(p) {
  var config = {
    USER_DETAILS: HOST + "/" + PATHS[p] + "/user/details",
    LOGOUT: HOST + "/" + PATHS[p] + "/user/logout",
    MOBILE_DETAILS: HOST + "/" + PATHS[p] + "/send/token/OTP_IS_REG",
    LOGIN: HOST + "/" + PATHS[p] + "/login",
    SIGN_UP: HOST + "/" + PATHS[p] + "/verify/token/SIGNUP_OTP",
    CREATE_NEW_USER: HOST + "/" + PATHS[p] + "/user/create/false",
    UPDATE_PROFILE: HOST + "/" + PATHS[p] + "/user/update",
    GET_EMAIL_TOKEN: HOST + "/" + PATHS[p] + "/send/token/EMAIL",
    VERIFY_EMAIL: HOST + "/" + PATHS[p] + "/verify/token/EMAIL",
    UPDATE_PROFILE_PIC: HOST + "/" + PATHS[p] + "/user/upload/imageclass/displaypic",
    REDIRECT_TO_APP: HOST + "/" + PATHS[p] + "/UserService/send/token/LINK",
    DELETE_OTP: HOST + "/" + PATHS[p] + "/send/token/OTP_DELETE",
    SOCIAL_LOGIN: HOST + "/" + PATHS[p] + "/appSocialLogin",
    JWT_TOKEN: HOST + "/" + PATHS[p] + "/jwt/loginToken",
    LOGOUT_DEVICE: HOST + "/" + PATHS[p] + "/user/logout",
    MULTIPLE_LOGINS: HOST + "/" + PATHS[p] + "/user/activeSessions",
    PREFILL_DETAILS: HOST + "/" + PATHS[p] + "/prefill/login/details"
  };
  return config;
};

var GI_TOKEN_NAME = 'OAUTH-GOIBIBO';
var GA_TOKEN = 'gapauthtoken';
var GI_UUID = 'gitokenid';
var GI_SESSIONID = 'sessionid';

var clearUserTokens = function clearUserTokens() {
  (0,growth_cookies_esm/* removeItem */.cl)(GI_TOKEN_NAME, '/', 'goibibo.com');
  (0,growth_cookies_esm/* removeItem */.cl)(GA_TOKEN, '/', 'goibibo.com');
  (0,growth_cookies_esm/* removeItem */.cl)(GI_UUID, '/', 'goibibo.com');
};

var getAuthToken = function getAuthToken() {
  return (0,growth_cookies_esm/* getItem */.rV)('OAUTH-GOIBIBO');
};

var isUserTokenPresent = function isUserTokenPresent() {
  var authToken = getAuthToken();
  return !!authToken;
};

var getEncryptedUuid = function getEncryptedUuid() {
  return getItem('gapauthtoken');
};

var getUuidFromCookie = function getUuidFromCookie() {
  return (0,growth_cookies_esm/* getItem */.rV)('gitokenid');
};

var setUserTokenAndUuid = function setUserTokenAndUuid(_ref) {
  var _window;

  var authToken = _ref.authToken,
      uuid = _ref.uuid;
  (0,growth_cookies_esm/* setItem */.LS)(GI_TOKEN_NAME, authToken, {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
  (0,growth_cookies_esm/* setItem */.LS)(GA_TOKEN, (_window = window) == null ? void 0 : _window.btoa(uuid), {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
  (0,growth_cookies_esm/* setItem */.LS)(GI_UUID, uuid, {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
};

var deleteSessionId = function deleteSessionId() {
  return removeItem(GI_SESSIONID, '/', 'goibibo.com');
};

var API_AUTH = {
  MWEB: 'h4nhc9jcgpAGIjp',
  DWEB: 'jkO7Ivpwsh4KaQ9',
  HCS: 'cmVzdDoxMjM0NTY='
};

var getUserIdentifierHeader = function getUserIdentifierHeader(_ref) {
  var _getBrowserDetails;

  var platform = _ref.platform;
  return JSON.stringify({
    type: 'auth',
    deviceId: (0,growth_visitor_id_browser_esm/* getVisitorIdBrowser */.MI)() || 'deviceId',
    os: platform === 'mweb' ? 'pwa' : 'desktop',
    osVersion: 'osVersion',
    appVersion: 'appVersion',
    imie: 'imie',
    ipAddress: 'ipAddress',
    timeZone: '+5.30 GMT',
    value: getAuthToken() || '',
    deviceOrBrowserInfo: ((_getBrowserDetails = (0,growth_user_agents_esm/* getBrowserDetails */.hf)()) == null ? void 0 : _getBrowserDetails.browserName) || ''
  });
};

var getEssentialHeader = function getEssentialHeader(_ref2) {
  var platform = _ref2.platform;
  return {
    Authorization: API_AUTH[platform.toUpperCase()],
    'User-Identifier': getUserIdentifierHeader({
      platform: platform
    }),
    'X-request-tracker': (0,growth_visitor_id_browser_esm/* generateVid */.im)(),
    region: 'in',
    currency: 'inr',
    language: 'eng'
  };
};

var profileViewQuery = {
  query: [[{
    name: 'extendedUser',
    keys: ['profileId', 'uuid', 'primaryEmailId', 'userType', 'profileType', 'loginInfoList', 'personalDetails']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'personalDetails',
    keys: ['gender', 'dateOfBirth']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'userImages',
    keys: ['fileUrl', 'imageClass'],
    filters: [{
      name: 'imageClass',
      type: 'string',
      value: 'displaypic'
    }]
  }], [{
    name: 'extendedUser'
  }, {
    name: 'profileCompletionDetails',
    keys: ['ctaDetails', 'completionScore', 'title', 'subText', 'component']
  }], [{
    name: 'loginInfoList',
    keys: ['loginId', 'loginType', 'primary', 'status', 'countryCode', 'verified']
  }], [{
    name: 'miscFields',
    keys: ['altEmailId']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'addressDetails',
    keys: ['addressId', 'city', 'name', 'category', 'houseNo', 'street', 'state', 'country', 'postalCode', 'landMark', 'status', 'lastUpdated', 'address1']
  }]]
};
var BILLING_CATEGORY = 'BILLING';

var fetchProfileDetails = function fetchProfileDetails(_ref) {
  var platform = _ref.platform;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).USER_DETAILS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: profileViewQuery,
    credentials: 'omit'
  }).post();
};

var generateProfileUpdateQuery = function generateProfileUpdateQuery(profileFields) {
  var firstName = profileFields.firstName,
      lastName = profileFields.lastName,
      dob = profileFields.dob,
      gender = profileFields.gender,
      email = profileFields.email,
      addressDetails = profileFields.addressDetails;
  var q = {
    query: [[{
      name: 'extendedUser',
      values: {
        personalDetails: {
          gender: gender,
          name: {
            firstName: firstName,
            lastName: lastName
          },
          dateOfBirth: dob
        },
        miscFields: {
          altEmailId: email
        },
        addressDetails: addressDetails
      }
    }]]
  };
  /* remove all empty keys from query */

  return (0,growth_object_utils_esm/* removeEmptyValues */.ks)(q);
};

var generateUserCreateQuery = function generateUserCreateQuery(fields) {
  var mobileNumber = fields.mobileNumber,
      fullName = fields.fullName,
      email = fields.email,
      _fields$countryCode = fields.countryCode,
      countryCode = _fields$countryCode === void 0 ? '91' : _fields$countryCode;
  var q = {
    query: [[{
      name: 'extendedUser',
      values: {
        profileType: 'PERSONAL',
        personalDetails: {
          name: {
            firstName: fullName
          }
        },
        miscFields: {
          altEmailId: email
        },
        loginInfoList: [{
          loginId: mobileNumber,
          countryCode: countryCode,
          loginType: 'MOBILE'
        }]
      }
    }]]
  };
  /* remove all empty keys from query */

  return (0,growth_object_utils_esm/* removeEmptyValues */.ks)(q);
};

var fetchProfileUpdate = function fetchProfileUpdate(_ref) {
  var platform = _ref.platform,
      data = _ref.data;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).UPDATE_PROFILE, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: generateProfileUpdateQuery(data),
    credentials: 'omit'
  }).post();
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var fetchUpdateProfilePic = function fetchUpdateProfilePic(_ref) {
  var platform = _ref.platform,
      file = _ref.file;
  var formData = new FormData();
  formData.append('file', file);
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).UPDATE_PROFILE_PIC, {
    headers: _extends({}, getEssentialHeader({
      platform: platform
    })),
    body: formData,
    credentials: 'omit'
  }).post();
};

var fetchSendOTP = function fetchSendOTP(_ref) {
  var platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      loginType = _ref.loginType,
      isEncoded = _ref.isEncoded;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).MOBILE_DETAILS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      loginId: mobileNumber,
      countryCode: '91',
      channel: [loginType],
      type: 6,
      isEncoded: isEncoded,
      appHashKey: platform === 'mweb' ? "@" + (0,growth_ssr_utils_esm/* getBaseHostName */.l_)() + " #" : ''
    },
    credentials: 'include'
  }).post();
};

var fetchCreateUser = function fetchCreateUser(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      transactionId = _ref.transactionId,
      mobileNumber = _ref.mobileNumber,
      fullName = _ref.fullName,
      email = _ref.email,
      countryCode = _ref.countryCode;

  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).CREATE_NEW_USER + "?guest=false&trxId=" + transactionId, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: generateUserCreateQuery({
      mobileNumber: mobileNumber,
      fullName: fullName,
      email: email,
      countryCode: countryCode
    })
  }).post();
};

var fetchLoginUser = function fetchLoginUser(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      passwordType = _ref.passwordType,
      password = _ref.password,
      isEncoded = _ref.isEncoded,
      encodedLoginId = _ref.encodedLoginId;

  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).LOGIN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      mobileNumber: isEncoded ? encodedLoginId : mobileNumber,
      countryCode: '91',
      password: password,
      type: 'MOBILE',
      passwordType: passwordType,
      isEncoded: isEncoded,
      query: profileViewQuery.query
    }
  }).post();
};

var fetchSignupViaOTP = function fetchSignupViaOTP(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      _ref$countryCode = _ref.countryCode,
      countryCode = _ref$countryCode === void 0 ? 91 : _ref$countryCode,
      password = _ref.password;

  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).SIGN_UP, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'include',
    body: {
      mobileNumber: mobileNumber,
      countryCode: countryCode,
      type: '6',
      token: password
    }
  }).post();
};

var fetchLogoutUser = function fetchLogoutUser(_ref) {
  var platform = _ref.platform;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).LOGOUT, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit'
  })["delete"]().then(function (res) {
    if (res != null && res.success) {
      clearUserTokens();
    }

    return res;
  })["catch"](function (e) {
    return e;
  });
};

var fetchSendDeleteOTP = function fetchSendDeleteOTP(_ref) {
  var platform = _ref.platform;
  return fetchRequest(getApiUrls(platform).DELETE_OTP, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      type: '16',
      channel: ['MOBILE']
    },
    credentials: 'include'
  }).post();
};

var TRUECALLER_DEEPLINK_DATA = {
  partnerKey: 'YDO2j919392e8b6fa4a059b697fd280503e67',
  partnerName: 'Goibibo',
  lang: 'en',
  privacyUrl: 'https://www.goibibo.com/info/privacy-policy/',
  termsUrl: 'https://www.goibibo.com/info/user-agreement/',
  loginPrefix: 'getstarted',
  loginSuffix: 'signin',
  btnShape: 'rect',
  skipOption: 'manualdetails',
  ctaPrefix: 'use',
  ctaColor: '%23ff6d38',
  ctaTextColor: '%23ffffff',
  PollingDefaultTimeout: 1000,
  PollingIntervalTimeout: {
    "default": 1000,
    stage1: 1500,
    stage2: 2500
  },
  PollingTimeoutCountSessionKey: 'truecaller_timer_count',
  PollingThreshold: 25,
  pollingHitStage: {
    stage1: 8,
    stage2: 15
  },
  skipCtaTruecallerActivate: 5,
  PollingState: {
    pending: 'PROCESSING',
    complete: 'SUCCESS',
    skipped: 'TRUE_CALLER_LOGIN_SKIPPED',
    error: 'error'
  }
};
var getTruecallerDeepLink = function getTruecallerDeepLink(reqId, deepLinkData) {
  return "truecallersdk://truesdk/web_verify?type=btmsheet&requestNonce=" + reqId + "&partnerKey=" + deepLinkData.partnerKey + "&partnerName=" + deepLinkData.partnerName + "&lang=" + deepLinkData.lang + "&skipOption=" + deepLinkData.skipOption + "&btnShape=" + deepLinkData.btnShape + "&loginPrefix=" + deepLinkData.loginPrefix + "&loginSuffix=" + deepLinkData.loginSuffix + "&ctaPrefix=" + deepLinkData.ctaPrefix + "&ctaColor=" + deepLinkData.ctaColor + "&ctaTextColor=" + deepLinkData.ctaTextColor + "&privacyUrl=" + deepLinkData.privacyUrl + "&termsUrl=" + deepLinkData.termsUrl;
};

var INVALID_AUTH_TOKEN_CODE = 5405;
var EXISTING_USER_STATUS_CODE = 4200;
var NEW_USER_STATUS_CODE = 4404;
var INVALID_OTP_CODE = 403;

// used on mweb and dweb both for login success event
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';

var fetchTruecallerLogin = function fetchTruecallerLogin(opts) {
  var platform = opts.platform,
      requestId = opts.requestId;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + getApiUrls(platform).SOCIAL_LOGIN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      accType: 'TRUE_CALLER',
      requestId: requestId,
      query: profileViewQuery.query
    }
  }).post();
};

var fetchVerifyEmail = function fetchVerifyEmail(_ref) {
  var platform = _ref.platform,
      token = _ref.token;
  return fetchRequest(getApiUrls(platform).VERIFY_EMAIL, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      type: '2',
      token: token
    },
    credentials: 'omit'
  }).post();
};

var fetchRequestEmailVerification = function fetchRequestEmailVerification(_ref) {
  var platform = _ref.platform,
      email = _ref.email;
  return fetchRequest(getApiUrls(platform).GET_EMAIL_TOKEN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      loginId: email,
      type: '2',
      channel: ['EMAIL']
    },
    credentials: 'omit'
  }).post();
};

var fetchLoginJwtToken = function fetchLoginJwtToken(_ref) {
  var platform = _ref.platform,
      client = _ref.client;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).JWT_TOKEN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      client: client
    }
  }).post();
};

var fetchMultipleLogins = function fetchMultipleLogins(_ref) {
  var platform = _ref.platform;
  return fetchRequest(getApiUrls(platform).MULTIPLE_LOGINS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit'
  }).post();
};

var logoutSpecificDevice = function logoutSpecificDevice(_ref) {
  var platform = _ref.platform,
      id = _ref.id;
  return fetchRequest(getApiUrls(platform).LOGOUT_DEVICE, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    query: "id=" + id
  })["delete"]();
};

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchFun$7 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _ref3, extendedUser, value;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data, _ref.onError;
            _context.next = 3;
            return fetchProfileUpdate({
              platform: platform,
              data: data
            });

          case 3:
            res = _context.sent;
            _context.next = 6;
            return promiseDelay(1000);

          case 6:
            _ref3 = (res == null ? void 0 : res.result) || {}, extendedUser = _ref3.extendedUser;
            value = extendedUser;
            return _context.abrupt("return", value);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useProfileUpdateStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$7.bind(null, opts),
        onSuccess: opts == null ? void 0 : opts.onSuccess,
        onError: opts == null ? void 0 : opts.onError
      });
    }
  });
});

var fetchFun$6 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _userImages$;

    var platform, res, _ref3, extendedUser, personalDetails, miscFields, userImages, uuid, profileId, profileType, profileCompletionDetails, loginInfoList, addressDetails, _ref4, gender, name, firstName, lastName, middleName, _ref5, _ref5$altEmailId, altEmailId, value;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform;
            _context.next = 3;
            return fetchProfileDetails({
              platform: platform
            });

          case 3:
            res = _context.sent;
            _ref3 = (res == null ? void 0 : res.result) || {}, extendedUser = _ref3.extendedUser;
            personalDetails = extendedUser.personalDetails, miscFields = extendedUser.miscFields, userImages = extendedUser.userImages, uuid = extendedUser.uuid, profileId = extendedUser.profileId, profileType = extendedUser.profileType, profileCompletionDetails = extendedUser.profileCompletionDetails, loginInfoList = extendedUser.loginInfoList, addressDetails = extendedUser.addressDetails;
            _ref4 = personalDetails || {}, gender = _ref4.gender, name = _ref4.name;
            firstName = name.firstName, lastName = name.lastName, middleName = name.middleName;
            _ref5 = miscFields || {}, _ref5$altEmailId = _ref5.altEmailId, altEmailId = _ref5$altEmailId === void 0 ? '' : _ref5$altEmailId;
            value = {
              firstName: !firstName && !middleName && !lastName ? 'TRAVELLER' : firstName,
              middleName: middleName,
              lastName: lastName,
              mobileNumber: '',
              mobileVerified: '',
              email: '',
              emailVerified: '',
              gender: gender,

              /* API gives epoc -> convert it to yyyy-mm-dd */
              dob: personalDetails.dateOfBirth ? (0,growth_date_utils_esm/* epocToDate */.Ow)(personalDetails.dateOfBirth) : undefined,
              profileImage: userImages == null ? void 0 : (_userImages$ = userImages[0]) == null ? void 0 : _userImages$.fileUrl,
              uuid: uuid,
              profileId: profileId,
              profileType: profileType,
              countryCode: '',
              isLoggedIn: !!uuid,
              profileCompletionDetails: (profileCompletionDetails == null ? void 0 : profileCompletionDetails[0]) || {},
              addressDetails: addressDetails
            };
            loginInfoList.forEach(function (item) {
              if ((item == null ? void 0 : item.loginType) === 'MOBILE') {
                var _item$countryCode;

                value.mobileVerified = item == null ? void 0 : item.verified;
                value.countryCode = item == null ? void 0 : item.countryCode;
                value.mobileNumber = item.loginId.slice(item == null ? void 0 : (_item$countryCode = item.countryCode) == null ? void 0 : _item$countryCode.length);
              }

              if (item.loginType === 'EMAIL') {
                value.emailVerified = item.verified;
                value.email = item.loginId;
              }
            });

            if (!value.email) {
              value.email = altEmailId;
            }

            return _context.abrupt("return", value);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useProfileStore = (0,esm/* create */.Ue)()(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$6.bind(null, opts),
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message,
            status: err == null ? void 0 : err.status
          });
        }
      });
    }
  });
});

var fetchFun$5 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, file, res, _ref3, data, success, message;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, file = _ref.file;
            _context.next = 3;
            return fetchUpdateProfilePic({
              platform: platform,
              file: file
            });

          case 3:
            res = _context.sent;
            _ref3 = res || {}, data = _ref3.data, success = _ref3.success, message = _ref3.message;

            if (success) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", {
              error: true,
              errorMsg: message
            });

          case 7:
            return _context.abrupt("return", {
              error: false,
              uploadedImage: data
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useUploadProfileImageStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {
      uploadedImage: '',
      successMsg: '',
      error: false,
      errorMsg: ''
    },
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$5.bind(null, opts),
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});

var loginWithMobileErrors = {
  typeErrorMsg: 'Alphabets and Special Characters are not allowed',
  notAValidMobileNumber: 'Please enter a valid mobile number',
  lengthErrorMsg: 'Please enter a 10 digit mobile number'
};
var MOBILE_NUMBER_REGEX = /^[6-9]\d{9}$/;
var MOBILE_NUMBER_MAX_LENGTH = 10;
var mobileValidation = function mobileValidation(phone) {
  if (phone) {
    if (Number.isNaN(Number(phone))) {
      return {
        valid: false,
        errorMsg: loginWithMobileErrors.typeErrorMsg
      };
    }

    if (typeof phone === 'string') {
      if (phone.length !== MOBILE_NUMBER_MAX_LENGTH) {
        return {
          valid: false,
          errorMsg: loginWithMobileErrors.lengthErrorMsg
        };
      }
    }

    if (MOBILE_NUMBER_REGEX.test(phone)) {
      return {
        valid: true,
        errorMsg: ''
      };
    }
  }

  return {
    valid: false,
    errorMsg: loginWithMobileErrors.notAValidMobileNumber
  };
};
var isMobileEncoded = function isMobileEncoded(mobileNumber, encodedMobileNumber) {
  if (mobileNumber.includes('**') && encodedMobileNumber === mobileNumber) return true;
  return false;
};

var fetchFun$4 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchSendOTP(_extends({
              platform: platform
            }, data, {
              mobileNumber: data.isEncoded ? data.encodedLoginId : data.mobileNumber
            }));

          case 3:
            res = _context.sent;
            return _context.abrupt("return", _extends({}, res, {
              mobileNumber: data.mobileNumber,
              isMobileNumberEncoded: data.isEncoded || false
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var intialState = {
  validation: {
    isValidMobile: false,
    message: ''
  },
  error: {
    errorMsg: '',
    errorDetails: null
  }
};
var useSendOtpStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: _extends({}, intialState),
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$4.bind(null, opts),
        onSuccess: function onSuccess(res) {
          if (res.success) {
            if (opts.onSuccess) opts.onSuccess(res);
          } else {
            set(function (s) {
              return {
                error: true,
                data: _extends({}, s.data, {
                  error: {
                    errorMsg: res.message
                  }
                })
              };
            });
            if (opts.onError) opts.onError();
          }
        },
        onError: function onError(err) {
          set(function (s) {
            return {
              error: true,
              data: _extends({}, s.data, {
                error: {
                  errorMsg: 'Some error occurred, please try again.',
                  errorDetails: err
                }
              })
            };
          });
          if (opts.onError) opts.onError();
        }
      });
    },
    checkValid: function checkValid(mobileNumber, isMobileNumberEncoded) {
      var validDetails = _extends({}, intialState.validation);

      if (isMobileNumberEncoded) {
        validDetails.isValidMobile = true;
      } else {
        var data = mobileValidation(mobileNumber);
        validDetails.isValidMobile = data.valid;
        validDetails.message = data.errorMsg;
      }

      set({
        data: {
          validation: validDetails
        }
      });
      return validDetails.isValidMobile;
    }
  });
});

var clearSendOtpStore = function clearSendOtpStore() {
  return useSendOtpStore.setState({
    data: _extends({}, intialState),
    error: false
  });
};

var fetchFun$3 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _resData$profileLogin;

    var platform, data, res, _ref3, resData, code, message, profileDetails, authToken, _profileDetails$userD, userDetails, _ref4, uuid;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchLoginUser(_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;
            _ref3 = res || {}, resData = _ref3.data, code = _ref3.code, message = _ref3.message;
            /* Error case */

            if (!code) {
              _context.next = 7;
              break;
            }

            throw {
              code: code,
              message: message
            };

          case 7:
            profileDetails = (resData == null ? void 0 : (_resData$profileLogin = resData.profileLoginResponse) == null ? void 0 : _resData$profileLogin[0]) || {};
            authToken = profileDetails.authToken, _profileDetails$userD = profileDetails.userDetails, userDetails = _profileDetails$userD === void 0 ? {} : _profileDetails$userD;
            _ref4 = userDetails.extendedUser || {}, uuid = _ref4.uuid;

            if (authToken && uuid) {
              setUserTokenAndUuid({
                authToken: authToken,
                uuid: uuid
              });
            }

            return _context.abrupt("return", res);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useLoginUserStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$3.bind(null, opts),
        onSuccess: function onSuccess(res) {
          return opts == null ? void 0 : opts.onSuccess(res);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    }
  });
});

var fetchFun$2 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _res$data, trxID;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data, _ref.onError;
            _context.next = 3;
            return fetchSignupViaOTP(_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;

            if (!res.success) {
              _context.next = 7;
              break;
            }

            trxID = (_res$data = res.data) == null ? void 0 : _res$data.trxId;
            return _context.abrupt("return", {
              transactionId: trxID
            });

          case 7:
            if (!res.code) {
              _context.next = 9;
              break;
            }

            throw _extends({}, res);

          case 9:
            return _context.abrupt("return", {});

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useSignupViaOTPStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$2.bind(null, opts),
        onSuccess: function onSuccess(res) {
          return opts == null ? void 0 : opts.onSuccess(res.trxID);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    },
    createUser: function createUser(opts) {
      return fetchCreateUser(opts);
    }
  });
});

var fetchFun$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _ref3, resData, message, _resData$profileLogin, profileDetails, authToken, _profileDetails$userD, userDetails, _ref4, uuid;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchTruecallerLogin(_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;
            _ref3 = res || {}, resData = _ref3.data, _ref3.code, message = _ref3.message;

            if (message === 'SUCCESS') {
              profileDetails = (resData == null ? void 0 : (_resData$profileLogin = resData.profileLoginResponse) == null ? void 0 : _resData$profileLogin[0]) || {};
              authToken = profileDetails.authToken, _profileDetails$userD = profileDetails.userDetails, userDetails = _profileDetails$userD === void 0 ? {} : _profileDetails$userD;
              _ref4 = userDetails.extendedUser || {}, uuid = _ref4.uuid;

              if (authToken && uuid) {
                setUserTokenAndUuid({
                  authToken: authToken,
                  uuid: uuid
                });
              }
            }

            return _context.abrupt("return", res);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useTruecallerLoginStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$1.bind(null, opts),
        onSuccess: function onSuccess(details) {
          return opts == null ? void 0 : opts.onSuccess(details);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    }
  });
});

var fetchFun = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, client;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, client = _ref.client;
            return _context.abrupt("return", fetchLoginJwtToken({
              platform: platform,
              client: client
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useLoginEncryptedJwtToken = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun.bind(null, opts),
        onError: opts.onError,
        onSuccess: opts.onSuccess
      });
    }
  });
});

var fetchPrefillLoginDetails = function fetchPrefillLoginDetails(_ref) {
  var platform = _ref.platform,
      controller = _ref.controller;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).PREFILL_DETAILS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      retryCount: 1
    },
    credentials: 'omit',
    controller: controller
  }).post();
};

var _fetchFun = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, controller, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, controller = _ref.controller;
            _context.next = 3;
            return fetchPrefillLoginDetails({
              platform: platform,
              controller: controller
            });

          case 3:
            res = _context.sent;
            return _context.abrupt("return", {
              encodedMobileNumber: res == null ? void 0 : res.loginId,
              countryCode: res == null ? void 0 : res.countryCode,
              encLoginId: res == null ? void 0 : res.encLoginId
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var usePrefillLoginDetails = (0,esm/* create */.Ue)(function (set) {
  var controller = typeof AbortController === 'function' ? new AbortController() : undefined;
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    controller: controller,
    userInputMobileNumber: null,
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: function fetchFun() {
          return _fetchFun(_extends({}, opts, {
            controller: controller
          }));
        }
      });
    },
    setUserInputMobileNumber: function setUserInputMobileNumber(mobileNumber) {
      return set({
        userInputMobileNumber: mobileNumber
      });
    }
  });
});

var EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

var isEmailValid = function isEmailValid(emailId) {
  if (emailId) return EMAIL_REGEX.test(emailId);
  return false;
};

var ALPHABET_REGEX = /^[a-zA-Z_]+( [a-zA-Z_]+)*$/;

var isNameValid = function isNameValid(fullName) {
  if (fullName) return ALPHABET_REGEX.test(fullName);
  return false;
};

var NUMREGEX = /^[0-9]+$/;
var isNumberValid = function isNumberValid(num) {
  if (num) return NUMREGEX.test(num);
  return false;
};




/***/ }),

/***/ 8132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bW": function() { return /* binding */ getAuthToken; },
/* harmony export */   "zv": function() { return /* binding */ getEncryptedUuid; }
/* harmony export */ });
/* unused harmony exports doLogOut, isExistingUser, isUserTokenPresent */
/* harmony import */ var _growth_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2048);


function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var getAuthToken = function getAuthToken() {
  return (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_0__/* .getItem */ .rV)('OAUTH-GOIBIBO');
}; // TODO: Make it isomorphic


var isUserTokenPresent = function isUserTokenPresent() {
  var authToken = getAuthToken();
  return !!authToken;
};
/**
	if existing user:
	response = { SSK : "RS01F" }

	if new user:
	response = { SSK : "RS02F" }
*/


var isExistingUser = function isExistingUser(k) {
  return k === "RS01F";
};

var doLogOut = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var endpointUrl, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            endpointUrl = '/logoutuser/';
            _context.prev = 1;
            _context.next = 4;
            return fetch("" + endpointUrl);

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 7;
              break;
            }

            throw Error(response.statusText);

          case 7:
            return _context.abrupt("return", response);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", Promise.reject(new Error('Unsuccessful attempt to logout.')));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function doLogOut() {
    return _ref.apply(this, arguments);
  };
}()));

var getEncryptedUuid = function getEncryptedUuid() {
  return (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_0__/* .getItem */ .rV)('gapauthtoken');
};




/***/ }),

/***/ 2927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ docSessionStorage; },
/* harmony export */   "U": function() { return /* binding */ docLocalStorage; }
/* harmony export */ });
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1917);


var BROWSER_STORAGE_TYPE = {
  LOCAL_STORAGE: _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK ? window.localStorage : '',
  SESSION_STORAGE: _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK ? window.sessionStorage : ''
};
var makeExpireTime = function makeExpireTime(sec) {
  if (sec === void 0) {
    sec = 0;
  }
  // take ttl in sec to keep the api same across all other cache utils
  var d = new Date();
  d.setSeconds(d.getSeconds() + sec);
  return d.getTime();
};
var isTimeExpired = function isTimeExpired(time) {
  return new Date().getTime() - time >= 0;
};
function storageAvailable(type) {
  var storage;
  try {
    storage = type;
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}
var storage = function storage(backed) {
  return {
    setItem: function setItem(key, value, expiryTime) {
      if (!storageAvailable(backed)) return null;
      if (value === undefined) {
        backed.removeItem(key);
      } else {
        var storageValue = {
          value: value
        };
        if (expiryTime) {
          storageValue.timeStamp = makeExpireTime(expiryTime);
        }
        backed.setItem(key, JSON.stringify(storageValue));
      }
      return value;
    },
    getItem: function getItem(key) {
      if (!storageAvailable(backed)) return null;
      var value; // undefined
      var str = backed.getItem(key);
      if (str) {
        try {
          var _JSON$parse = JSON.parse(str),
            respValue = _JSON$parse.value,
            timeStamp = _JSON$parse.timeStamp;
          if (timeStamp && isTimeExpired(timeStamp)) {
            backed.removeItem(key);
          } else {
            value = respValue;
          }
        } catch (e) {
          // console.log(`Error parsing storage ['${ key }']`);
          backed.removeItem(key);
        }
      }
      return value;
    },
    removeItem: function removeItem(key) {
      if (!storageAvailable(backed)) return null;
      return backed.removeItem(key);
    }
  };
};
var getLocalStorage = function getLocalStorage() {
  return storage(BROWSER_STORAGE_TYPE.LOCAL_STORAGE);
};
var getSessionStorage = function getSessionStorage() {
  return storage(BROWSER_STORAGE_TYPE.SESSION_STORAGE);
};
var docLocalStorage = getLocalStorage();
var docSessionStorage = getSessionStorage();




/***/ }),

/***/ 4162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ao": function() { return /* binding */ createConfigStore; },
  "a_": function() { return /* binding */ setData; }
});

// UNUSED EXPORTS: getConfigStoreDataClient

// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/@growth/store-helpers/dist/growth-store-helpers.esm.js
var growth_store_helpers_esm = __webpack_require__(6880);
;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/node_modules/@growth/api-calls/dist/pokus-dynamic-config-19800874.esm.js
function pokus_dynamic_config_19800874_esm_extends() {
  pokus_dynamic_config_19800874_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return pokus_dynamic_config_19800874_esm_extends.apply(this, arguments);
}

var pokus_dynamic_config_19800874_esm_generatePokusAssignVariantBodyRequest = function generatePokusAssignVariantBodyRequest(_ref) {
  var lob = _ref.lob,
    isMobile = _ref.isMobile,
    deviceId = _ref.deviceId,
    _ref$extraOptions = _ref.extraOptions,
    extraOptions = _ref$extraOptions === void 0 ? {} : _ref$extraOptions;
  var device = isMobile ? 'mobile' : 'desktop';
  var request = {
    lob: lob,
    user: pokus_dynamic_config_19800874_esm_extends({
      deviceId: deviceId
    }, extraOptions.user),
    attributes: pokus_dynamic_config_19800874_esm_extends({
      device_os: device,
      device_type: device
    }, extraOptions.attributes)
  };
  return {
    request: request
  };
};

var pokus_dynamic_config_19800874_esm_generateSkywalkerBodyRequest = function generateSkywalkerBodyRequest(_ref) {
  var extraReqBody = _ref.extraReqBody;
  var request = pokus_dynamic_config_19800874_esm_extends({
    brand: 'gi',
    user: {
      loginChannel: 'GI'
    }
  }, extraReqBody);
  return request;
};

/**
 *
 * @docs http://confluence.mmt.com/pages/viewpage.action?pageId=823704867
 */

var pokus_dynamic_config_19800874_esm_generatePokusDynamicConfigBodyRequest = function generatePokusDynamicConfigBodyRequest(_ref) {
  var lob = _ref.lob,
    isMobile = _ref.isMobile,
    deviceId = _ref.deviceId,
    _ref$extraOptions = _ref.extraOptions,
    extraOptions = _ref$extraOptions === void 0 ? {} : _ref$extraOptions;
  var device = isMobile ? 'mobile' : 'desktop';
  var configDevice = isMobile ? 'PWA' : 'DESKTOP';
  var request = {
    lob: lob,
    user: pokus_dynamic_config_19800874_esm_extends({
      deviceId: deviceId
    }, extraOptions.user),
    attributes: pokus_dynamic_config_19800874_esm_extends({
      device_os: device,
      device_type: device
    }, extraOptions.attributes),
    scope: pokus_dynamic_config_19800874_esm_extends({
      lob: lob,
      deviceOS: configDevice,
      tags: []
    }, extraOptions.scope)
  };
  var propertiesToAssign = ['productFeatureConfigKeys', 'features', 'applicationProperties', 'experimentIds'];
  propertiesToAssign.forEach(function (property) {
    if (extraOptions[property]) {
      request[property] = extraOptions[property];
    }
  });
  return request;
};



// EXTERNAL MODULE: ../../node_modules/@growth/fetch-request/dist/growth-fetch-request.esm.js
var growth_fetch_request_esm = __webpack_require__(6963);
;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/node_modules/@growth/api-configs/dist/index-530eda38.esm.js
var hosts = {
  goibibo: '//www.goibibo.com',
  pokus: '//pokus.goibibo.com',
  recommendEarnUrl: '//influencer.goibibo.com',
  skywalker: '//mapi.goibibo.com',
  voyagerX: '//voyagerx.goibibo.com',
  voyager: '//voyager.goibibo.com',
  recentSearchPush: '//pdt.goibibo.com',
  gdpr: '//consentmgmt.makemytrip.com',
  appBannerUrl: "//userservice.goibibo.com",
  userGeoLocation: '//mapi.goibibo.com',
  configStore: '//configstore.goibibo.com',
  argus: '//www.goibibo.com',
  loyaltyUserInfo: '//membership-service.goibibo.com',
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: '//www.goibibo.com',
  amigoSyncUp: '//mitra.goibibo.com'
};

var PP = 'pp';
var LOCAL = 'local';
var PROD_PP = 'prodpp';
var PROD = 'prod';
var envs = [PROD, PP, PROD_PP, LOCAL];

var index_530eda38_esm_filterConfigForEnv = function filterConfigForEnv(configs, env) {
  if (env === void 0) {
    env = 'prod';
  }
  var normalizeEnvVar = function normalizeEnvVar(v) {
    var validEnvVar = function validEnvVar(ve) {
      return envs.includes(ve);
    };
    if (!validEnvVar(v)) {
      throw new Error("getConfig:normalizeEnvVar:validEnvVar error, " + v + " is not a valid env");
    }

    // pp & local will get the local hosts.
    // prodpp & prod will get the prod hosts.
    var e = [PP, LOCAL].includes(env) ? LOCAL : PROD;
    return e.toLowerCase();
  };
  var BuildEnv = normalizeEnvVar(env);
  return configs[BuildEnv];
};
var index_530eda38_esm_getConfigValueFromEnv = function getConfigValueFromEnv(key) {
  if (typeof GROWTH_API_CONFIG !== 'undefined') {
    var value = GROWTH_API_CONFIG[key];
    if (value) return value;
  }
  return hosts[key];
};

var index_530eda38_esm_endpoints = {
  appBannerUrlGuest: '/ext/web/pwa/send/token/DEEP_LINK',
  appBannerUrlLoggedIn: '/ext/web/pwa/send/token/LINK',
  pokusAssignVariant: '/experiment/assignVariant',
  userWidget: "/common/userwidget/?random=+" + Math.random(),
  // random to avoid browser cache
  recommendEarnUrl: "/recEarn/infl/details",
  skywalkerV1: '/empeiria/api/v1',
  dsdVoyager: '/api/v1/hotels_search/find_node_by_name',
  appContext: '/api/v2/utils/get_context/',
  recentSearchPush: '/fs/w',
  gdpr: '/ext/hcs/cmp/userconsents/get',
  userGdpr: '/ext/hcs/cmp/userconsents/save',
  userGeoLocation: '/locus/web/v2/graphQl',
  voyagerPagemake: '/pagemaker',
  argus: '/argus/pwa/login_details/save',
  configStore: '/get/configKey',
  getRecentSearch: '/empeiria/api/v1/recentSearchResponseByLob',
  loyaltyUserInfo: '/loyalty/userInfo',
  gocashBalance: '/gocash/v2/get_balance/',
  bookingSummary: '/tripsbackend/v2/bookingsummary',
  pokusImpressionAndHonour: '/measurement/impressionAndHonourConditions',
  pokusDynamicConfigs: '/measurement/getDynamicConfigs',
  amigoGetSyncUp: '/v1/say_thanks/get_privacy_data',
  amigoSetSyncUp: '/v1/say_thanks/post_privacy_data',
  amigoSetSyncUpStatus: '/api/v1/user/status/optin'
};



;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/node_modules/@growth/api-configs/dist/growth-api-configs.esm.js



/** Will reverse proxy/mock all local & pp api via moxy */
var moxy = 'https://newprodpp.goibibo.com/moxy';
var growth_api_configs_esm_hosts = {
  goibibo: '//www.goibibo.com',
  pokus: moxy,
  recommendEarnUrl: moxy,
  skywalker: moxy,
  voyagerX: moxy,
  voyager: moxy,
  recentSearchPush: moxy,
  gdpr: moxy,
  appBannerUrl: moxy,
  userGeoLocation: moxy,
  configStore: '//configstore.goibibo.com',
  argus: moxy,
  loyaltyUserInfo: moxy,
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: moxy,
  amigoSyncUp: moxy
};

/**
 * Default index gives the client side api configs
 * eg:
 * import getConfig from '@growth/api-configs'
 */
var configs = {
  local: growth_api_configs_esm_hosts,
  prod: hosts
};
var getConfig = function getConfig(env) {
  var c = filterConfigForEnv(configs, env);
  return c;
};



// EXTERNAL MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js + 1 modules
var growth_visitor_id_browser_esm = __webpack_require__(6939);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js + 1 modules
var growth_auth_helpers_esm = __webpack_require__(7263);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-utils/dist/growth-auth-utils.esm.js
var growth_auth_utils_esm = __webpack_require__(8132);
;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/node_modules/@growth/api-calls/dist/growth-api-calls.esm.js







var fetchAppOpenUrl = function fetchAppOpenUrl(opts) {
  var isLoggedIn = !!getAuthToken();
  var apiPayload = (opts == null ? void 0 : opts.apiPayload) || {};
  var vid = getVisitorIdBrowser();
  var payload = {
    /*
     * keep the timeout small for this api,
     */
    body: {
      type: '18',
      "deepLink": {
        "data": {
          "c": apiPayload == null ? void 0 : apiPayload.campaign,
          "pid": "mweb2app",
          "deep_link_value": apiPayload == null ? void 0 : apiPayload.tagid,
          "af_web_dp": "https://www.goibibo.com/",
          "af_android_url": "https://play.google.com/store/apps/details?id=com.goibibo",
          "af_ios_url": "https://apps.apple.com/in/app/goibibo-hotel-flight-train/id631927169",
          "deep_link_sub1": _extends({}, apiPayload == null ? void 0 : apiPayload.godata, {
            login_req: (apiPayload == null ? void 0 : apiPayload.loginReq) || false,
            "referral_flow": (apiPayload == null ? void 0 : apiPayload.referral_flow) || false,
            "traffic_source": (apiPayload == null ? void 0 : apiPayload.trafficSource) || undefined,
            "~campaign": apiPayload == null ? void 0 : apiPayload.campaign,
            web_vid: vid
          }),
          "brand_domain": "app.goibibo.com"
        }
      }
    },
    credentials: 'omit',
    headers: getEssentialHeader({
      platform: 'mweb'
    })
  };
  var appBannerHost = getConfigValueFromEnv('appBannerUrl');
  var appBannerEndpoint = isLoggedIn ? endpoints.appBannerUrlLoggedIn : endpoints.appBannerUrlGuest;
  return fetchRequest("" + appBannerHost + appBannerEndpoint, payload).post();
};

var fetchPokusAssignVariantData = function fetchPokusAssignVariantData(opts) {
  var pokusOptions = opts.pokusOptions,
    _opts$extraHeader = opts.extraHeader,
    extraHeader = _opts$extraHeader === void 0 ? {} : _opts$extraHeader,
    timeout = opts.timeout;
  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob || 'COMMON';
  var _generatePokusAssignV = generatePokusAssignVariantBodyRequest({
      isMobile: pokusOptions.isMobile,
      lob: lobName,
      deviceId: deviceId,
      extraOptions: pokusOptions
    }),
    request = _generatePokusAssignV.request;
  var pokusUrl = getConfigValueFromEnv('pokus');
  var authToken = pokusOptions.authToken || getAuthToken$1();
  var headers = {};
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusAssignVariant, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeader),
    timeout: timeout
  }).post().then(function (res) {
    var _res$perLobMap;
    return (_res$perLobMap = res.perLobMap) == null ? void 0 : _res$perLobMap[lobName].metadataValues;
  });
};

var fetchUserDetails = function fetchUserDetails(_ref) {
  var timeout = _ref.timeout;
  var host = getConfigValueFromEnv('goibibo');
  return fetchRequest("" + host + endpoints.userWidget, {
    timeout: timeout
  }).post();
};

var fetchRecommendEarnDetails = function fetchRecommendEarnDetails(details) {
  var recommendEarnUrl = getConfigValueFromEnv('recommendEarnUrl');
  var token = getAuthToken$1();
  var headers = {
    auth: token,
    os: details == null ? void 0 : details.flavour
  };
  return fetchRequest("" + recommendEarnUrl + endpoints.recommendEarnUrl, {
    headers: headers,
    body: {
      hotelId: details.hotelId,
      source: details.source
    },
    credentials: 'omit'
  }).post();
};

var fetchSkywalkerClientData = function fetchSkywalkerClientData(skywalkerOptions, extraHeaders) {
  if (extraHeaders === void 0) {
    extraHeaders = {};
  }
  var endpointPath = skywalkerOptions.endpointPath,
    extraReqBody = skywalkerOptions.extraReqBody;
  var request = generateSkywalkerBodyRequest({
    extraReqBody: extraReqBody
  });
  var skywalkerUrl = getConfigValueFromEnv('skywalker');
  var headers = {
    brand: 'gi',
    deviceid: String
  };
  if (isUserTokenPresent()) {
    headers.auth = getAuthToken$1();
  }
  var dvid = getVisitorIdBrowser();
  if (dvid) {
    headers.deviceid = dvid;
  }
  return fetchRequest("" + skywalkerUrl + endpoints.skywalkerV1 + endpointPath, {
    body: request,
    credentials: 'omit',
    query: 'language=eng&currency=inr&region=in&brand=GI',
    headers: _extends({}, headers, extraHeaders)
  }).post();
};

var fetchAutoSuggetDailyStealDeal = function fetchAutoSuggetDailyStealDeal(userLocation) {
  var dsdVoyagerUrl = getConfigValueFromEnv('voyagerX');
  var userSelectedLocation = userLocation.userVal;
  return fetchRequest("" + dsdVoyagerUrl + endpoints.dsdVoyager, {
    credentials: 'omit',
    query: "search_query=" + userSelectedLocation + "&limit=10&include_t=[\"voy.city\"]"
  }).post();
};

var fetchPushRecentSearch = function fetchPushRecentSearch(searchCollection) {
  var url = getConfigValueFromEnv('recentSearchPush');
  var token = getAuthToken$1();
  var deviceid = getVisitorIdBrowser();
  var headers = {
    'Content-Type': 'application/json',
    'Request-Data-Encoding': 'json'
  };
  if (token) headers['oauth-goibibo'] = token;
  if (deviceid) headers.deviceid = deviceid;
  return fetchRequest("" + url + endpoints.recentSearchPush, {
    headers: headers,
    body: JSON.stringify(searchCollection),
    credentials: 'omit',
    extraOptions: {
      keepalive: true
    }
  }).post();
};

var fetchAppContext = function fetchAppContext(link) {
  var url = getConfigValueFromEnv('voyager') || prod.voyager;
  var raw = "url=" + (link || '');
  return fetchRequest("" + url + endpoints.appContext, {
    body: raw,
    credentials: 'omit'
  }).post();
};

var fetchGdprData = function fetchGdprData() {
  var host = getConfigValueFromEnv('gdpr');
  var token = getAuthToken$1();
  var headers = {};
  if (token) headers.Authorization = JSON.stringify({
    type: 'auth',
    value: token
  });
  return fetchRequest("" + host + endpoints.gdpr, {
    headers: headers,
    body: {
      org: 'GI',
      consent_id: 1,
      profile_type: 0,
      show_meta: true
    },
    credentials: 'omit'
  }).post();
};

var pushUserGdprData = function pushUserGdprData(gdpConsents) {
  var host = getConfigValueFromEnv('gdpr');
  var token = getAuthToken$1();
  var headers = {};
  if (token) headers.Authorization = JSON.stringify({
    type: 'auth',
    value: token
  });
  return fetchRequest("" + host + endpoints.userGdpr, {
    headers: headers,
    body: {
      org: 'GI',
      author: 'USER',
      consents: [_extends({
        status_active: true
      }, gdpConsents)]
    },
    credentials: 'omit'
  }).post();
};

var fetchUserGeoLocation = function fetchUserGeoLocation(_ref) {
  _ref.timeout;
  var host = getConfigValueFromEnv('userGeoLocation');
  return fetchRequest("" + host + endpoints.userGeoLocation, {
    body: "{ locationHierarchy(lat:,lng:) { country { id name centre } state { id name centre } city { id name centre postal_code } area { id name primary_area centre postal_code } } }",
    headers: {
      'Api-key': 'GROWTH-MMTGROWTH-71815232081313207181523208'
    }
  }).post();
};

var fetchConfigStoreData = function fetchConfigStoreData(opts) {
  var fetchOpts = opts.fetchOpts;
  var headers = fetchOpts.headers,
    timeout = fetchOpts.timeout;
  var host = index_530eda38_esm_getConfigValueFromEnv('configStore');
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + host + index_530eda38_esm_endpoints.configStore, {
    headers: pokus_dynamic_config_19800874_esm_extends({
      authorization: 'Tect685j8xMpLJF'
    }, headers),
    body: {
      isAbKey: opts.isAbKey,
      lobList: opts.lobList,
      cfgKeyList: opts.cfgKeyList
      /**
       * below three options helps on more granular query on bacnkend
       * these keys are not part of v1(present) api. Keep it commented
       * */
      // status: string,
      // submodule: string,
      // pgname: string,
    },

    credentials: 'omit',
    timeout: timeout
  }).post();
};

var fetchArgusFingerPrinting = function fetchArgusFingerPrinting(_ref) {
  var asyToken = _ref.asyToken,
    additionalData = _ref.additionalData;
  var url = getConfigValueFromEnv('argus');
  var token = getAuthToken();
  var headers = {
    region: 'in',
    currency: 'inr',
    language: 'eng'
  };
  if (token) headers['oauth-goibibo'] = token;
  fetchRequest("" + url + endpoints.argus, {
    headers: _extends({
      Authorization: 'P0s6jZGIkwMrnS2',
      'X-Request-Tracker': generateVid()
    }, headers),
    credentials: 'omit',
    body: {
      asyToken: asyToken,
      additionalData: additionalData
    }
  }).post();
};

var fetchRecentSearch = function fetchRecentSearch(_ref) {
  var lob = _ref.lob,
    strategy = _ref.strategy;
  var url = getConfigValueFromEnv('skywalker');
  return fetchRequest("" + url + endpoints.getRecentSearch + "?lob=" + lob + "&strategy=" + strategy, {
    headers: {
      'content-type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      user: {
        profile_type: 'PERSONAL',
        uuid: getUuidFromCookie(),
        device_id: getVisitorIdBrowser(),
        domain: {
          country: 'in',
          language: 'eng',
          currency: 'inr'
        }
      }
    })
  }).post();
};

var fetchLoyaltyUserInfo = function fetchLoyaltyUserInfo() {
  var token = getAuthToken$1();
  var headers = {
    "currency": "Rs",
    "language": "eng",
    "org": "GI",
    "Profile-Type": "PERSONAL",
    "region": "in",
    "Authorization": "7NP82fpV0TsA9JrK"
  };
  if (token) headers.Auth = token;
  var bodyData = {
    "lob": "ALL",
    "tier": true,
    "benefit": false,
    "programDetails": false,
    "cards": false,
    "programDetailsTierBenefit": false,
    "source": "PWA",
    "pageType": "PERSONALIZATION"
  };
  return fetchRequest("https://membership-service.goibibo.com/loyalty/userInfo", {
    headers: headers,
    body: bodyData,
    credentials: 'omit'
  }).post();
};

var fetchGoCashBalance = function fetchGoCashBalance() {
  var url = getConfigValueFromEnv('gocashBalance');
  var headers = {
    'oauth-goibibo': getAuthToken$1()
  };
  return fetchRequest("" + url + endpoints.gocashBalance, {
    headers: headers,
    credentials: 'omit'
  }).get();
};

/** List of all bookings */
var fetchBookingSummary = function fetchBookingSummary() {
  var url = getConfigValueFromEnv('bookingSummary');
  var headers = {
    auth: getAuthToken$1()
  };
  return fetchRequest("" + url + endpoints.bookingSummary, {
    headers: headers,
    credentials: 'omit'
  }).get();
};

var fetchPokusImpressionAndHonourDetails = function fetchPokusImpressionAndHonourDetails(opts) {
  var _ref = opts || {},
    analyticsNode = _ref.analyticsNode;
  var host = getConfigValueFromEnv('pokus');
  return fetchRequest("" + host + endpoints.pokusImpressionAndHonour, {
    body: {
      analyticsNode: analyticsNode
    },
    credentials: 'omit'
  }).post();
};

var fetchPokusDynamicConfigs = function fetchPokusDynamicConfigs(opts) {
  var pokusOptions = opts.pokusOptions,
    _opts$extraHeader = opts.extraHeader,
    extraHeader = _opts$extraHeader === void 0 ? {} : _opts$extraHeader,
    timeout = opts.timeout;
  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob;
  var request = generatePokusDynamicConfigBodyRequest({
    isMobile: pokusOptions.isMobile,
    lob: lobName,
    deviceId: deviceId,
    extraOptions: pokusOptions
  });
  var pokusUrl = getConfigValueFromEnv('pokus');
  var authToken = pokusOptions.authToken || getAuthToken$1();
  var headers = {
    region: 'IN',
    language: 'EN'
  };
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusDynamicConfigs, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeader),
    timeout: timeout
  }).post();
};

var fetchAmigoSyncUpContacts = function fetchAmigoSyncUpContacts(_ref) {
  var bookingId = _ref.bookingId,
    lob = _ref.lob;
  var url = prod.amigoSyncUp;
  var headers = {
    'oauth-goibibo': getAuthToken()
  };
  return fetchRequest("" + url + endpoints.amigoGetSyncUp, {
    headers: headers,
    credentials: 'omit',
    query: "bookingId=" + bookingId + "&Lob=" + lob + "&context=TYP"
  }).get();
};

var pushAmigoSyncUpChoice = function pushAmigoSyncUpChoice(_ref) {
  var bookingId = _ref.bookingId,
    lob = _ref.lob,
    isConsentGiven = _ref.isConsentGiven,
    reasonId = _ref.reasonId,
    reason = _ref.reason;
  var url = prod.amigoSyncUp;
  var headers = {
    'oauth-goibibo': getAuthToken(),
    'Content-Type': 'application/json'
  };
  return fetchRequest("" + url + endpoints.amigoSetSyncUp, {
    headers: headers,
    credentials: 'omit',
    body: {
      bookingId: bookingId,
      Lob: lob,
      isConsentGiven: isConsentGiven,
      reasonId: reasonId,
      reason: reason
    }
  }).post();
};



;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/dist/xhr-c6cf95cd.esm.js


function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var formatConfigResp = function formatConfigResp(configKeys) {
  var lobsKey = Object.keys(configKeys);
  var configs = lobsKey.reduce == null ? void 0 : lobsKey.reduce(function (acc, l) {
    var _configKeys$l$reduce, _configKeys$l;
    acc[l] = (_configKeys$l$reduce = (_configKeys$l = configKeys[l]).reduce) == null ? void 0 : _configKeys$l$reduce.call(_configKeys$l, function (kk, k) {
      var cloneKK = Object(kk);
      cloneKK[k.cfgKey] = k.value;
      return cloneKK;
    }, {});
    return acc;
  }, {});
  return configs;
};
var getConfigStoreData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
    var lobs, keys, fetchOpts, initData, lobList, keyList, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          lobs = opts.lobs, keys = opts.keys, fetchOpts = opts.fetchOpts, initData = opts.initData;
          /**
           * Return the initData if present, this helps to use the data passed in
           * SSR and avoid the api calls on client again.
           * */
          if (!initData) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", Promise.resolve(initData));
        case 3:
          lobList = typeof lobs === 'string' ? [lobs] : lobs;
          keyList = typeof keys === 'string' ? [keys] : keys;
          _context.next = 7;
          return fetchConfigStoreData({
            lobList: lobList,
            cfgKeyList: keyList,
            fetchOpts: {
              timeout: fetchOpts.timeout
            }
          });
        case 7:
          data = _context.sent;
          return _context.abrupt("return", formatConfigResp(data == null ? void 0 : data.configKeys));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getConfigStoreData(_x) {
    return _ref.apply(this, arguments);
  };
}();



// EXTERNAL MODULE: ../../node_modules/@growth/browser-storage/dist/growth-browser-storage.esm.js
var growth_browser_storage_esm = __webpack_require__(2927);
;// CONCATENATED MODULE: ../../node_modules/@growth/browser-storage/indexDB/dist/growth-browser-storage-indexDB.esm.js
function growth_browser_storage_indexDB_esm_regeneratorRuntime() {
  growth_browser_storage_indexDB_esm_regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function growth_browser_storage_indexDB_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function growth_browser_storage_indexDB_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        growth_browser_storage_indexDB_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        growth_browser_storage_indexDB_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/*
 https://dev.to/alexeagleson/how-to-use-indexeddb-to-store-data-for-your-web-application-in-the-browser-1o90#browsing-your-database
*/
var requestIndexDB = function requestIndexDB(name, ver) {
  if (!name || !ver) {
    throw new Error('name or ver argument is missing for requestIndexDB');
  }
  var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
  return new Promise(function (resolve, reject) {
    if (!indexedDB) {
      reject(new Error('IndexedDB could not be found in this browser.'));
    }
    var request = indexedDB.open(name, ver);
    resolve(request);
  });
};
var bootstrapDB = /*#__PURE__*/function () {
  var _ref = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee(opts) {
    var dbName, dbVer, objectName, keyPath, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, keyPath = opts.keyPath;
          _context.prev = 1;
          _context.next = 4;
          return requestIndexDB(dbName, dbVer);
        case 4:
          request = _context.sent;
          request.onupgradeneeded = function () {
            var db = request.result;
            var store = db.createObjectStore(objectName, {
              keyPath: keyPath || 'id'
            });
            store.createIndex('expire', 'expire');
          };
          return _context.abrupt("return", request);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", Promise.reject(new Error()));
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 9]]);
  }));
  return function bootstrapDB(_x) {
    return _ref.apply(this, arguments);
  };
}();
var addNewObject = /*#__PURE__*/function () {
  var _ref2 = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee2(opts) {
    var dbName, dbVer, objectName, data, expire, keyPath, id, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, data = opts.data, expire = opts.expire, keyPath = opts.keyPath, id = opts.id;
          _context2.next = 3;
          return bootstrapDB({
            dbName: dbName,
            dbVer: dbVer,
            objectName: objectName,
            keyPath: keyPath
          });
        case 3:
          request = _context2.sent;
          request.onsuccess = function () {
            var db = request.result;
            var transaction = db.transaction(objectName, 'readwrite');
            var store = transaction.objectStore(objectName);
            var expireTS;
            if (expire && typeof (expire == null ? void 0 : expire.getMonth) === 'function') {
              expireTS = new Date(expire).getTime(); // EPOC
            } else {
              var defaultExpMin = 15;
              expireTS = new Date(new Date().getTime() + defaultExpMin * 60000).getTime(); // EPOC
            }

            store.put({
              expire: expireTS,
              id: id,
              value: data
            });
            transaction.oncomplete = function () {
              db.close();
            };
          };
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function addNewObject(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var removeExpiredObjects = function removeExpiredObjects(_ref3) {
  var db = _ref3.db,
    objectName = _ref3.objectName;
  return new Promise(function (resolve, reject) {
    var transaction = db.transaction([objectName], 'readwrite');
    var objectStore = transaction.objectStore(objectName);
    var expirationIndex = objectStore.index('expire');
    var now = new Date().getTime();
    var request = expirationIndex.openCursor(IDBKeyRange.upperBound(now));
    var deletePromises = [];
    request.onsuccess = function (event) {
      var cursor = event.target.result;
      if (cursor) {
        var deleteRequest = objectStore["delete"](cursor.primaryKey);
        deletePromises.push(new Promise(function (resolveDelete, rejectDelete) {
          // console.log('deleting idb', cursor.primaryKey);
          deleteRequest.onsuccess = resolveDelete;
          deleteRequest.onerror = rejectDelete;
        }));
        cursor["continue"]();
      } else {
        // delete all
        Promise.all(deletePromises).then(function () {
          return resolve('deleted');
        })["catch"](reject);
      }
    };
    request.onerror = reject;
  });
};
var getAllObjects = /*#__PURE__*/function () {
  var _ref4 = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee4(opts) {
    var dbName, dbVer, objectName, id, keyPath, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, id = opts.id, keyPath = opts.keyPath;
          if (id) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return", Promise.reject(Error("Argument id is missing for getAllObjects() call")));
        case 3:
          _context4.next = 5;
          return bootstrapDB({
            dbName: dbName,
            dbVer: dbVer,
            objectName: objectName,
            keyPath: keyPath
          });
        case 5:
          request = _context4.sent;
          return _context4.abrupt("return", new Promise(function (resolve, reject) {
            request.onsuccess = /*#__PURE__*/growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee3() {
              var db, transaction, store, records;
              return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    db = request.result; // let's delete all expired records
                    _context3.next = 3;
                    return removeExpiredObjects({
                      db: db,
                      objectName: objectName
                    });
                  case 3:
                    transaction = db.transaction(objectName, 'readonly');
                    store = transaction.objectStore(objectName); // get a record
                    records = store.getAll(id);
                    records.onsuccess = function () {
                      var _records$result;
                      resolve((_records$result = records.result) == null || (_records$result = _records$result[0]) == null ? void 0 : _records$result.value);
                    };
                    request.onerror = function () {
                      reject(records.result);
                    };
                    transaction.oncomplete = function () {
                      db.close();
                    };
                  case 9:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
          }));
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getAllObjects(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
var deleteObject = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee5(opts) {
    var dbName, dbVer, objectName, keyPath, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, keyPath = opts.keyPath;
          _context5.next = 3;
          return bootstrapDB({
            dbName: dbName,
            dbVer: dbVer,
            objectName: objectName
          });
        case 3:
          request = _context5.sent;
          return _context5.abrupt("return", new Promise(function (resolve, reject) {
            request.onsuccess = function () {
              var db = request.result;
              var transaction = db.transaction(objectName, 'readwrite');
              var store = transaction.objectStore(objectName);
              store["delete"](keyPath);
              transaction.oncomplete = function () {
                db.close();
                resolve('delete');
              };
              transaction.onerror = function (e) {
                db.close();
                reject(e);
              };
            };
          }));
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function deleteObject(_x4) {
    return _ref6.apply(this, arguments);
  };
}()));



;// CONCATENATED MODULE: ../../node_modules/@growth/browser-caching/dist/growth-browser-caching.esm.js



function growth_browser_caching_esm_regeneratorRuntime() {
  growth_browser_caching_esm_regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function growth_browser_caching_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var SESSION_STORE = 'sessionStorage';
var LOCAL_STORE = 'localStorage';
var INDEX_DB = 'indexDb';
var INDEX_DB_DETAILS = {
  objectName: 'with-cache',
  keyPath: 'id',
  dbName: 'grow-with-fetch-cache',
  dbVer: 1
};
var withBrowserStorageCaching = /*#__PURE__*/function () {
  var _ref = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee3(opts) {
    var key, asyncMethod, _opts$ttl, ttl, type, _opts$cacheResponseKe, cacheResponseKeys, ignoreCache, revalidate, getLocalStore, isLocalStore, getItem, setItem, cache, res, saveResp;
    return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          key = opts.key, asyncMethod = opts.asyncMethod, _opts$ttl = opts.ttl, ttl = _opts$ttl === void 0 ? 0 : _opts$ttl, type = opts.type, _opts$cacheResponseKe = opts.cacheResponseKeys, cacheResponseKeys = _opts$cacheResponseKe === void 0 ? [] : _opts$cacheResponseKe, ignoreCache = opts.ignoreCache, revalidate = opts.revalidate; // ignore the caching if ignoreCache is true
          if (!ignoreCache) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", asyncMethod());
        case 3:
          if (key) {
            _context3.next = 5;
            break;
          }
          throw new Error('withBrowserStorageCaching: For browser caching key name is mandatory');
        case 5:
          getLocalStore = function getLocalStore() {
            return type === SESSION_STORE ? growth_browser_storage_esm/* docSessionStorage */.F : growth_browser_storage_esm/* docLocalStorage */.U;
          };
          isLocalStore = function isLocalStore(_type) {
            return _type === LOCAL_STORE || _type === SESSION_STORE || _type === undefined;
          };
          getItem = /*#__PURE__*/function () {
            var _ref2 = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee() {
              var store, value, dbName, dbVer, objectName, keyPath, record;
              return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!isLocalStore(opts.type)) {
                      _context.next = 4;
                      break;
                    }
                    store = getLocalStore();
                    value = store.getItem(key);
                    return _context.abrupt("return", value);
                  case 4:
                    if (!(opts.type === INDEX_DB)) {
                      _context.next = 10;
                      break;
                    }
                    dbName = INDEX_DB_DETAILS.dbName, dbVer = INDEX_DB_DETAILS.dbVer, objectName = INDEX_DB_DETAILS.objectName, keyPath = INDEX_DB_DETAILS.keyPath;
                    _context.next = 8;
                    return getAllObjects({
                      dbName: dbName,
                      dbVer: dbVer,
                      objectName: objectName,
                      id: key,
                      keyPath: keyPath
                    });
                  case 8:
                    record = _context.sent;
                    return _context.abrupt("return", record);
                  case 10:
                    return _context.abrupt("return", undefined);
                  case 11:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function getItem() {
              return _ref2.apply(this, arguments);
            };
          }();
          setItem = /*#__PURE__*/function () {
            var _ref3 = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee2(value) {
              var store, dbName, dbVer, objectName, keyPath, res;
              return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!isLocalStore(type)) {
                      _context2.next = 3;
                      break;
                    }
                    store = getLocalStore();
                    return _context2.abrupt("return", store.setItem(key, value, ttl));
                  case 3:
                    if (!(opts.type === INDEX_DB)) {
                      _context2.next = 9;
                      break;
                    }
                    dbName = INDEX_DB_DETAILS.dbName, dbVer = INDEX_DB_DETAILS.dbVer, objectName = INDEX_DB_DETAILS.objectName, keyPath = INDEX_DB_DETAILS.keyPath;
                    _context2.next = 7;
                    return addNewObject({
                      dbName: dbName,
                      dbVer: dbVer,
                      objectName: objectName,
                      keyPath: keyPath,
                      id: key,
                      data: value
                    });
                  case 7:
                    res = _context2.sent;
                    return _context2.abrupt("return", res);
                  case 9:
                    return _context2.abrupt("return", undefined);
                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function setItem(_x2) {
              return _ref3.apply(this, arguments);
            };
          }(); // return from cache if exist and revalidate is not true
          _context3.next = 11;
          return getItem();
        case 11:
          cache = _context3.sent;
          if (!(cache && !revalidate)) {
            _context3.next = 14;
            break;
          }
          return _context3.abrupt("return", cache);
        case 14:
          if (!(typeof asyncMethod === 'function')) {
            _context3.next = 20;
            break;
          }
          _context3.next = 17;
          return asyncMethod();
        case 17:
          res = _context3.sent;
          // keep only few keys in cache instead of whole response.
          if (typeof res === 'object' && cacheResponseKeys.length) {
            saveResp = {};
            cacheResponseKeys.forEach(function (item) {
              saveResp[item] = res == null ? void 0 : res[item];
            });
            setItem(saveResp);
          } else {
            setItem(res);
          }
          return _context3.abrupt("return", res);
        case 20:
          throw new Error('withBrowserStorageCaching: the second parameter should be async method');
        case 21:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function withBrowserStorageCaching(_x) {
    return _ref.apply(this, arguments);
  };
}();



;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js






function growth_config_store_browser_esm_extends() {
  growth_config_store_browser_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return growth_config_store_browser_esm_extends.apply(this, arguments);
}

var getConfigStoreDataClient = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
    var lobs, keys, cacheOpts, fetchOpts, initData, cacheKey, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          lobs = opts.lobs, keys = opts.keys, cacheOpts = opts.cacheOpts, fetchOpts = opts.fetchOpts, initData = opts.initData;
          cacheKey = function cacheKey() {
            // merge the lob and keys to make a cachekey
            var l = typeof lobs === 'string' ? [lobs] : lobs;
            var k = typeof keys === 'string' ? [keys] : keys;
            var ckey = l.join('-') + "-" + k.join('-');
            return ckey.toLowerCase();
          };
          _context.next = 4;
          return withBrowserStorageCaching({
            key: cacheKey(),
            asyncMethod: function asyncMethod() {
              return getConfigStoreData({
                lobs: lobs,
                keys: keys,
                fetchOpts: {
                  timeout: (fetchOpts == null ? void 0 : fetchOpts.timeout) || 2000
                },
                initData: initData
              });
            },
            ttl: (cacheOpts == null ? void 0 : cacheOpts.ttl) || 15 /* minutes */,
            ignoreCache: cacheOpts == null ? void 0 : cacheOpts.ignoreCache,
            revalidate: cacheOpts == null ? void 0 : cacheOpts.revalidate,
            type: 'indexDb'
          });
        case 4:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getConfigStoreDataClient(_x) {
    return _ref.apply(this, arguments);
  };
}();

var createConfigStore = function createConfigStore() {
  return (0,esm/* create */.Ue)()(function (set) {
    return growth_config_store_browser_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
      fetch: function fetch(opts) {
        return (0,growth_store_helpers_esm/* fetchSetter */.x)({
          set: set,
          fetchFun: function fetchFun() {
            return getConfigStoreDataClient({
              lobs: opts.lobs,
              keys: opts.keys,
              cacheOpts: opts == null ? void 0 : opts.cacheOpts,
              initData: opts == null ? void 0 : opts.initData
            });
          },
          onSuccess: opts == null ? void 0 : opts.onSuccess
        });
      }
    });
  });
};
var setData = function setData(store, value) {
  return store.setState(function (s) {
    return {
      data: growth_config_store_browser_esm_extends({}, s.data, value),
      loaded: true
    };
  });
};




/***/ }),

/***/ 2048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
/* unused harmony export keys */
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1917);


/* eslint-disable no-useless-escape */

/**
 * This function well help to get, set, remove and itrate over
 * the cookies the cookies.
 * @methods
 *  getItem
 *  setItem
 *  removeItem
 *  hasItem
 *  keys
 */

var error = function error(x) {
  console.error(new TypeError("key is required for @growth/cookies " + x));
};

var getItem = function getItem(key) {
  if (!_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK) return null;

  if (!key) {
    error('get');
    return null;
  }

  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" +
  /* eslint-disable-next-line no-useless-escape */
  encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + "\\s*\\=\\s*([^;]*).*$)|^.*$"), '$1')) || null;
};
/* eslint-disable-next-line max-params */


var setItem = function setItem(key, value, options) {
  if (!_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK) return false;

  var _ref = options || {},
      expires = _ref.expires,
      path = _ref.path,
      domain = _ref.domain,
      secure = _ref.secure;

  if (!key) {
    error('set');
    return false;
  }

  var sMaxAge = expires ? "; max-age=" + expires : '';
  document.cookie = encodeURIComponent(key) + "=" + value + sMaxAge + (domain ? "; domain=" + domain : '') + (path ? "; path=" + path : '') + (secure ? '; secure' : '');
  return true;
};

var removeItem = function removeItem(key, path, domain) {
  if (!_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK) return false;

  if (!getItem(key)) {
    error('remove');
    return false;
  }

  document.cookie = encodeURIComponent(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (domain ? "; domain=" + domain : '') + (path ? "; path=" + path : '');
  return true;
};

var keys = function keys() {
  if (!isOnClient) return [];
  var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);

  for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx += 1) {
    aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
  }

  return aKeys;
};




/***/ }),

/***/ 3509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useHasMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/**
 * READ THIS! IF YOU ARE A REACT DEVELOPER YOU SHOULD
 *  https://joshwcomeau.com/react/the-perils-of-rehydration
 */

function useHasMounted() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      hasMounted = _useState[0],
      setHasMounted = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
}




/***/ }),

/***/ 7862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ow": function() { return /* binding */ epocToDate; },
  "Zz": function() { return /* binding */ isDateExpired; }
});

// UNUSED EXPORTS: addDays, dateToEPOC, daysInMonth, formatDate, formatDateString, formatDayString, getDateFormat, getTimeZone, getYearsAgoDate, getYearsAgoDateFromNow

;// CONCATENATED MODULE: ../../node_modules/fecha/lib/fecha.js
var token = /d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|Z|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
var twoDigitsOptional = "\\d\\d?";
var twoDigits = "\\d\\d";
var threeDigits = "\\d{3}";
var fourDigits = "\\d{4}";
var word = "[^\\s]+";
var literal = /\[([^]*?)\]/gm;
function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
        newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
}
var monthUpdate = function (arrName) { return function (v, i18n) {
    var lowerCaseArr = i18n[arrName].map(function (v) { return v.toLowerCase(); });
    var index = lowerCaseArr.indexOf(v.toLowerCase());
    if (index > -1) {
        return index;
    }
    return null;
}; };
function fecha_assign(origObj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var obj = args_1[_a];
        for (var key in obj) {
            // @ts-ignore ex
            origObj[key] = obj[key];
        }
    }
    return origObj;
}
var dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var monthNamesShort = shorten(monthNames, 3);
var dayNamesShort = shorten(dayNames, 3);
var defaultI18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ["am", "pm"],
    DoFn: function (dayOfMonth) {
        return (dayOfMonth +
            ["th", "st", "nd", "rd"][dayOfMonth % 10 > 3
                ? 0
                : ((dayOfMonth - (dayOfMonth % 10) !== 10 ? 1 : 0) * dayOfMonth) % 10]);
    }
};
var globalI18n = fecha_assign({}, defaultI18n);
var setGlobalDateI18n = function (i18n) {
    return (globalI18n = fecha_assign(globalI18n, i18n));
};
var regexEscape = function (str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, "\\$&");
};
var pad = function (val, len) {
    if (len === void 0) { len = 2; }
    val = String(val);
    while (val.length < len) {
        val = "0" + val;
    }
    return val;
};
var formatFlags = {
    D: function (dateObj) { return String(dateObj.getDate()); },
    DD: function (dateObj) { return pad(dateObj.getDate()); },
    Do: function (dateObj, i18n) {
        return i18n.DoFn(dateObj.getDate());
    },
    d: function (dateObj) { return String(dateObj.getDay()); },
    dd: function (dateObj) { return pad(dateObj.getDay()); },
    ddd: function (dateObj, i18n) {
        return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function (dateObj, i18n) {
        return i18n.dayNames[dateObj.getDay()];
    },
    M: function (dateObj) { return String(dateObj.getMonth() + 1); },
    MM: function (dateObj) { return pad(dateObj.getMonth() + 1); },
    MMM: function (dateObj, i18n) {
        return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function (dateObj, i18n) {
        return i18n.monthNames[dateObj.getMonth()];
    },
    YY: function (dateObj) {
        return pad(String(dateObj.getFullYear()), 4).substr(2);
    },
    YYYY: function (dateObj) { return pad(dateObj.getFullYear(), 4); },
    h: function (dateObj) { return String(dateObj.getHours() % 12 || 12); },
    hh: function (dateObj) { return pad(dateObj.getHours() % 12 || 12); },
    H: function (dateObj) { return String(dateObj.getHours()); },
    HH: function (dateObj) { return pad(dateObj.getHours()); },
    m: function (dateObj) { return String(dateObj.getMinutes()); },
    mm: function (dateObj) { return pad(dateObj.getMinutes()); },
    s: function (dateObj) { return String(dateObj.getSeconds()); },
    ss: function (dateObj) { return pad(dateObj.getSeconds()); },
    S: function (dateObj) {
        return String(Math.round(dateObj.getMilliseconds() / 100));
    },
    SS: function (dateObj) {
        return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function (dateObj) { return pad(dateObj.getMilliseconds(), 3); },
    a: function (dateObj, i18n) {
        return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function (dateObj, i18n) {
        return dateObj.getHours() < 12
            ? i18n.amPm[0].toUpperCase()
            : i18n.amPm[1].toUpperCase();
    },
    ZZ: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60) * 100 + (Math.abs(offset) % 60), 4));
    },
    Z: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60), 2) +
            ":" +
            pad(Math.abs(offset) % 60, 2));
    }
};
var monthParse = function (v) { return +v - 1; };
var emptyDigits = [null, twoDigitsOptional];
var emptyWord = [null, word];
var amPm = [
    "isPm",
    word,
    function (v, i18n) {
        var val = v.toLowerCase();
        if (val === i18n.amPm[0]) {
            return 0;
        }
        else if (val === i18n.amPm[1]) {
            return 1;
        }
        return null;
    }
];
var timezoneOffset = [
    "timezoneOffset",
    "[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z?",
    function (v) {
        var parts = (v + "").match(/([+-]|\d\d)/gi);
        if (parts) {
            var minutes = +parts[1] * 60 + parseInt(parts[2], 10);
            return parts[0] === "+" ? minutes : -minutes;
        }
        return 0;
    }
];
var parseFlags = {
    D: ["day", twoDigitsOptional],
    DD: ["day", twoDigits],
    Do: ["day", twoDigitsOptional + word, function (v) { return parseInt(v, 10); }],
    M: ["month", twoDigitsOptional, monthParse],
    MM: ["month", twoDigits, monthParse],
    YY: [
        "year",
        twoDigits,
        function (v) {
            var now = new Date();
            var cent = +("" + now.getFullYear()).substr(0, 2);
            return +("" + (+v > 68 ? cent - 1 : cent) + v);
        }
    ],
    h: ["hour", twoDigitsOptional, undefined, "isPm"],
    hh: ["hour", twoDigits, undefined, "isPm"],
    H: ["hour", twoDigitsOptional],
    HH: ["hour", twoDigits],
    m: ["minute", twoDigitsOptional],
    mm: ["minute", twoDigits],
    s: ["second", twoDigitsOptional],
    ss: ["second", twoDigits],
    YYYY: ["year", fourDigits],
    S: ["millisecond", "\\d", function (v) { return +v * 100; }],
    SS: ["millisecond", twoDigits, function (v) { return +v * 10; }],
    SSS: ["millisecond", threeDigits],
    d: emptyDigits,
    dd: emptyDigits,
    ddd: emptyWord,
    dddd: emptyWord,
    MMM: ["month", word, monthUpdate("monthNamesShort")],
    MMMM: ["month", word, monthUpdate("monthNames")],
    a: amPm,
    A: amPm,
    ZZ: timezoneOffset,
    Z: timezoneOffset
};
// Some common format strings
var globalMasks = {
    default: "ddd MMM DD YYYY HH:mm:ss",
    shortDate: "M/D/YY",
    mediumDate: "MMM D, YYYY",
    longDate: "MMMM D, YYYY",
    fullDate: "dddd, MMMM D, YYYY",
    isoDate: "YYYY-MM-DD",
    isoDateTime: "YYYY-MM-DDTHH:mm:ssZ",
    shortTime: "HH:mm",
    mediumTime: "HH:mm:ss",
    longTime: "HH:mm:ss.SSS"
};
var setGlobalDateMasks = function (masks) { return fecha_assign(globalMasks, masks); };
/***
 * Format a date
 * @method format
 * @param {Date|number} dateObj
 * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
 * @returns {string} Formatted date string
 */
var fecha_format = function (dateObj, mask, i18n) {
    if (mask === void 0) { mask = globalMasks["default"]; }
    if (i18n === void 0) { i18n = {}; }
    if (typeof dateObj === "number") {
        dateObj = new Date(dateObj);
    }
    if (Object.prototype.toString.call(dateObj) !== "[object Date]" ||
        isNaN(dateObj.getTime())) {
        throw new Error("Invalid Date pass to format");
    }
    mask = globalMasks[mask] || mask;
    var literals = [];
    // Make literals inactive by replacing them with @@@
    mask = mask.replace(literal, function ($0, $1) {
        literals.push($1);
        return "@@@";
    });
    var combinedI18nSettings = fecha_assign(fecha_assign({}, globalI18n), i18n);
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
        return formatFlags[$0](dateObj, combinedI18nSettings);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/@@@/g, function () { return literals.shift(); });
};
/**
 * Parse a date string into a Javascript Date object /
 * @method parse
 * @param {string} dateStr Date string
 * @param {string} format Date parse format
 * @param {i18n} I18nSettingsOptional Full or subset of I18N settings
 * @returns {Date|null} Returns Date object. Returns null what date string is invalid or doesn't match format
 */
function parse(dateStr, format, i18n) {
    if (i18n === void 0) { i18n = {}; }
    if (typeof format !== "string") {
        throw new Error("Invalid format in fecha parse");
    }
    // Check to see if the format is actually a mask
    format = globalMasks[format] || format;
    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
        return null;
    }
    // Default to the beginning of the year.
    var today = new Date();
    var dateInfo = {
        year: today.getFullYear(),
        month: 0,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        isPm: null,
        timezoneOffset: null
    };
    var parseInfo = [];
    var literals = [];
    // Replace all the literals with @@@. Hopefully a string that won't exist in the format
    var newFormat = format.replace(literal, function ($0, $1) {
        literals.push(regexEscape($1));
        return "@@@";
    });
    var specifiedFields = {};
    var requiredFields = {};
    // Change every token that we find into the correct regex
    newFormat = regexEscape(newFormat).replace(token, function ($0) {
        var info = parseFlags[$0];
        var field = info[0], regex = info[1], requiredField = info[3];
        // Check if the person has specified the same field twice. This will lead to confusing results.
        if (specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " specified twice in format");
        }
        specifiedFields[field] = true;
        // Check if there are any required fields. For instance, 12 hour time requires AM/PM specified
        if (requiredField) {
            requiredFields[requiredField] = true;
        }
        parseInfo.push(info);
        return "(" + regex + ")";
    });
    // Check all the required fields are present
    Object.keys(requiredFields).forEach(function (field) {
        if (!specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " is required in specified format");
        }
    });
    // Add back all the literals after
    newFormat = newFormat.replace(/@@@/g, function () { return literals.shift(); });
    // Check if the date string matches the format. If it doesn't return null
    var matches = dateStr.match(new RegExp(newFormat, "i"));
    if (!matches) {
        return null;
    }
    var combinedI18nSettings = fecha_assign(fecha_assign({}, globalI18n), i18n);
    // For each match, call the parser function for that date part
    for (var i = 1; i < matches.length; i++) {
        var _a = parseInfo[i - 1], field = _a[0], parser = _a[2];
        var value = parser
            ? parser(matches[i], combinedI18nSettings)
            : +matches[i];
        // If the parser can't make sense of the value, return null
        if (value == null) {
            return null;
        }
        dateInfo[field] = value;
    }
    if (dateInfo.isPm === 1 && dateInfo.hour != null && +dateInfo.hour !== 12) {
        dateInfo.hour = +dateInfo.hour + 12;
    }
    else if (dateInfo.isPm === 0 && +dateInfo.hour === 12) {
        dateInfo.hour = 0;
    }
    var dateTZ;
    if (dateInfo.timezoneOffset == null) {
        dateTZ = new Date(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute, dateInfo.second, dateInfo.millisecond);
        var validateFields = [
            ["month", "getMonth"],
            ["day", "getDate"],
            ["hour", "getHours"],
            ["minute", "getMinutes"],
            ["second", "getSeconds"]
        ];
        for (var i = 0, len = validateFields.length; i < len; i++) {
            // Check to make sure the date field is within the allowed range. Javascript dates allows values
            // outside the allowed range. If the values don't match the value was invalid
            if (specifiedFields[validateFields[i][0]] &&
                dateInfo[validateFields[i][0]] !== dateTZ[validateFields[i][1]]()) {
                return null;
            }
        }
    }
    else {
        dateTZ = new Date(Date.UTC(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute - dateInfo.timezoneOffset, dateInfo.second, dateInfo.millisecond));
        // We can't validate dates in another timezone unfortunately. Do a basic check instead
        if (dateInfo.month > 11 ||
            dateInfo.month < 0 ||
            dateInfo.day > 31 ||
            dateInfo.day < 1 ||
            dateInfo.hour > 23 ||
            dateInfo.hour < 0 ||
            dateInfo.minute > 59 ||
            dateInfo.minute < 0 ||
            dateInfo.second > 59 ||
            dateInfo.second < 0) {
            return null;
        }
    }
    // Don't allow invalid dates
    return dateTZ;
}
var fecha = {
    format: fecha_format,
    parse: parse,
    defaultI18n: defaultI18n,
    setGlobalDateI18n: setGlobalDateI18n,
    setGlobalDateMasks: setGlobalDateMasks
};

/* harmony default export */ var lib_fecha = ((/* unused pure expression or super */ null && (fecha)));

//# sourceMappingURL=fecha.js.map

;// CONCATENATED MODULE: ../../node_modules/@growth/date-utils/dist/growth-date-utils.esm.js


var getDateFormat = function getDateFormat(opts) {
  var date = opts.date,
      f = opts.format,
      _opts$seperator = opts.seperator,
      seperator = _opts$seperator === void 0 ? '/' : _opts$seperator;
  var currentDate = new Date();

  if (date && !Number.isNaN(new Date(date).getTime())) {
    currentDate = new Date(date);
  }

  var year = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();

  switch (f) {
    case 'dd mm yyyy':
      return day + seperator + month + seperator + year;

    case 'mm dd yyyy':
      return month + seperator + day + seperator + year;

    case 'YYYY mm dd':
      return year + seperator + month + seperator + day;

    default:
      return year + seperator + month + seperator + day;
  }
};

var dateToEPOC = function dateToEPOC(date) {
  var epoc = new Date(date).valueOf();
  return epoc; // unix timestamp
};

var epocToDate = function epocToDate(epoc) {
  var d = getDateFormat({
    date: epoc
  });
  return d;
};

var getYearsAgoDateFromNow = function getYearsAgoDateFromNow(age) {
  if (age === void 0) {
    age = 0;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();
  return new Date(year + "/" + month + "/" + day);
};

var getYearsAgoDate = function getYearsAgoDate(age, month, day) {
  if (age === void 0) {
    age = 0;
  }

  if (month === void 0) {
    month = 0;
  }

  if (day === void 0) {
    day = 1;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var newMonth = month + 1 < 10 ? "0" + (month + 1) : month + 1;
  var newDay = day < 10 ? "0" + day : day;
  return new Date(year + "/" + newMonth + "/" + newDay);
};

var isDateExpired = function isDateExpired(_ref) {
  var now = _ref.now,
      expire = _ref.expire;
  return now > expire;
};

var formatDate = function formatDate(date, formatStr) {
  if (formatStr === void 0) {
    formatStr = "D MMM'YY dddd";
  }

  return format(date, formatStr);
};

var formatDateString = function formatDateString(date) {
  return date && formatDate(date).split(' ').slice(0, 2).join(' ');
};

var formatDayString = function formatDayString(date) {
  return date && formatDate(date).split(' ').slice(2).join('');
};

var addDays = function addDays(date, days) {
  var currentDate = new Date(date);
  currentDate.setDate(currentDate.getDate() + days);
  return currentDate;
};

var daysInMonth = function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
};

var getTimeZone = function getTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};




/***/ }),

/***/ 3767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ headingSizes; },
/* harmony export */   "iH": function() { return /* binding */ textSizes; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports Box, Heading, breakPoints, buildTheme, colors, defaultTheme, font, misc, spacing, useTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

// https://html.mmt.com/htmls/projects/HTMLFrontendHub/baseProjects/TypeSystem/gi/index.html

/* NOTE: not using the @React_UI_Lib/GIFontStandard since it does not support the type script
 import Styles from '@React_UI_Lib/GIFontStandard';
*/
// Type - Family and Weight
var fwRegular = '400';
var fwMedium = '500';
var fwSemiBold = '600';
var fwBold = '700';
var fs32 = '32px';
var fs24 = '24px';
var fs22 = '22px';
var fs18 = '18px';
var fs16 = '16px';
var fs14 = '14px';
var fs12 = '12px';
var lhAuto = 'normal'; //  Lable

var textSizes = {
  LargeW1: {
    'font-weight': fwRegular,
    'font-size': fs18,
    'line-height': lhAuto
  },
  LargeW2: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwMedium
  },
  LargeW3: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwSemiBold
  },
  MediumW1: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwRegular
  },
  MediumW2: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwMedium
  },
  MediumW3: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwSemiBold
  },
  BaseW1: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwRegular
  },
  BaseW2: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwMedium
  },
  BaseW3: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwSemiBold
  },
  SmallW1: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwRegular
  },
  SmallW2: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwMedium
  },
  SmallW3: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwSemiBold
  }
}; //  Lable

var headingSizes = {
  xLarge: {
    'font-weight': fwBold,
    'font-size': fs32,
    'line-height': lhAuto
  },
  Large: {
    'line-height': lhAuto,
    'font-size': fs24,
    'font-weight': fwBold
  },
  MediumW1: {
    'line-height': lhAuto,
    'font-size': fs22,
    'font-weight': fwSemiBold
  },
  Small: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwSemiBold
  },
  Base: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwSemiBold
  }
};

var fontFamilyGenerics = 'Avenir, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
var fontFamilyRubik = "Rubik, " + fontFamilyGenerics;
var defaultFontThemeProperties = {
  fontFamilyDefault: fontFamilyRubik,
  fontFamilyQuicksand: fontFamilyRubik,
  fontFamilyRoboto: fontFamilyRubik,
  fontFamilyHelvetica: fontFamilyRubik,
  token: {
    label: _extends({}, textSizes),
    heading: _extends({}, headingSizes)
  }
};

var buildFont = function buildFont(fontThemeProperties) {
  if (fontThemeProperties === void 0) {
    fontThemeProperties = defaultFontThemeProperties;
  }

  return _extends({}, fontThemeProperties);
};

// https://www.figma.com/file/pZZHuwNbapoBxoxGJFSyZJ/GI-Foundations?type=design&node-id=25-2&t=pZslRhH1ZwNtrFHa-0
var spacing$1 = {
  '0': 0,
  '2': '2px',
  '4': '4px',
  '8': '8px',
  '12': '12px',
  '20': '20px',
  '24': '24px',
  '28': '28px',
  '32': '32px',
  '40': '40px',
  '48': '48px',
  '56': '56px',
  '64': '64px'
};

var buildSpacing = function buildSpacing() {
  return spacing$1;
};

var defaultMiscThemeProperties = {
  borderRadius: {
    unit: 0.4,
    unitScale: 0.2
  },
  border: {
    unit: 0.1
  },
  breakpoints: {
    md: 60 + "rem" // 600px

  }
};
function buildMisc(miscThemeProperties) {
  if (miscThemeProperties === void 0) {
    miscThemeProperties = defaultMiscThemeProperties;
  }

  return {
    borderRadius: {
      base: miscThemeProperties.borderRadius.unit + "rem",
      // 4px | 0.4rem
      // 2px | 0.2rem
      small: miscThemeProperties.borderRadius.unit - miscThemeProperties.borderRadius.unitScale + "rem",
      // 6px | 0.6rem
      large: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale + "rem",
      // 8px | 0.8rem
      xlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 2 + "rem",
      // 10px | 1rem
      xxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 3 + "rem",
      // 12px | 1.2rem
      xxxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 4 + "rem",
      round: '50%',
      // 15px | 1.5rem
      custom: function custom(multiplier // 15 - 15px, 20 - 20px
      ) {
        return multiplier * 0.1 + "rem";
      }
    },
    border: {
      base: miscThemeProperties.border.unit + "rem" // 1px

    },
    zIndex: {
      xxsmall: '2',
      xsmall: '3',
      small: '4',
      base: '5',
      large: '6',
      xlarge: '9',
      xxlarge: '99',
      xxxlarge: '999',
      maximum: '1999'
    }
  };
}

var colorPalette = {
  goBrandBlue: {
    base: '#2274E0',
    dark: '#1958B6',
    medium: '#D1E5FF',
    light: '#E8F3FF'
  },
  goBrandOrange: {
    base: '#FF6D38',
    dark: '#D95204',
    medium: '#EB6125',
    light: '#FFF1ED'
  },
  downriver: {
    base: '#141823',
    dark: '#46484d',
    medium: '#777777',
    light: '#C2C2C2'
  },
  goWhite: {
    base: '#FFFFFF',
    dark: 'rgba(255, 255, 255, .8)',
    medium: 'rgba(255, 255, 255, .5)',
    light: 'rgba(255, 255, 255, .2)'
  },
  ash: {
    base: '#647A97',
    dark: '#E1E7EE',
    medium: '#EFF3F8',
    light: '#F4F7FA'
  },
  goGreen: {
    base: '#18A160',
    dark: '#148730',
    medium: '#1ABA32',
    light: '#E9F6EA'
  },
  goTeal: {
    base: '#00a2ad',
    dark: '#008a93',
    medium: '#00B3C6',
    light: '#e1f6f6'
  },
  goYellow: {
    base: '#ffc24a',
    dark: '#FBAC43',
    medium: '#FFEA67',
    light: '#FFFDE9'
  },
  goPurple: {
    base: '#8f22e3',
    dark: '#7022D9',
    medium: '#9D3DE8',
    light: '#FBF1FF'
  },
  goRed: {
    base: '#FF3A5C',
    dark: '#E63148',
    medium: '#F83466',
    light: '#FFF5F7'
  },
  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)'
  },
  black: {
    base: '#000'
  }
};
function buildColors() {
  return colorPalette;
}

function breakPoints$1() {
  return {
    mobileM: '37.5rem',
    mobileL: '42.5rem',
    tablet: '76.8rem',
    laptop: '102.4rem',
    laptopL: '144.0rem',
    desktop: '256.0rem'
  };
}

var font = buildFont();
var spacing = buildSpacing();
var misc = buildMisc();
var colors = buildColors();
var breakPoints = breakPoints$1();
function buildTheme() {
  return {
    font: font,
    spacing: spacing,
    misc: misc,
    colors: colors,
    breakPoints: breakPoints
  };
}
/**
 * always defaultTheme should get consumed all over
 * we might be introducing further customization in buildTheme step
 */

var defaultTheme = buildTheme();
/**
 * to check if theme exists on caller, else return defaultTheme
 */

function useTheme() {
  var theme = useContext(ThemeContext);
  return theme || defaultTheme;
}

var Box = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div(function (_ref) {
  var _ref$mr = _ref.mr,
      mr = _ref$mr === void 0 ? '' : _ref$mr,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? '' : _ref$mt,
      _ref$ml = _ref.ml,
      ml = _ref$ml === void 0 ? '' : _ref$ml,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? '' : _ref$mb,
      _ref$my = _ref.my,
      my = _ref$my === void 0 ? '' : _ref$my,
      _ref$mx = _ref.mx,
      mx = _ref$mx === void 0 ? '' : _ref$mx,
      _ref$pt = _ref.pt,
      pt = _ref$pt === void 0 ? '' : _ref$pt,
      _ref$pr = _ref.pr,
      pr = _ref$pr === void 0 ? '' : _ref$pr,
      _ref$pb = _ref.pb,
      pb = _ref$pb === void 0 ? '' : _ref$pb,
      _ref$pl = _ref.pl,
      pl = _ref$pl === void 0 ? '' : _ref$pl,
      _ref$py = _ref.py,
      py = _ref$py === void 0 ? '' : _ref$py,
      _ref$px = _ref.px,
      px = _ref$px === void 0 ? '' : _ref$px;
  return "\n\tmargin-right: " + (spacing$1[mr || mx] || '') + ";\n\tmargin-left: " + (spacing$1[ml || mx] || '') + ";\n\tmargin-top: " + (spacing$1[mt || my] || '') + ";\n\tmargin-bottom: " + (spacing$1[mb || my] || '') + ";\n\tpadding-right: " + (spacing$1[pr || px] || '') + ";\n\tpadding-left: " + (spacing$1[pl || px] || '') + ";\n\tpadding-top: " + (spacing$1[pt || py] || '') + ";\n\tpadding-bottom: " + (spacing$1[pb || py] || '') + ";\n";
});

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$1;
var Text = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].p(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return textSizes[size || 'BaseW1'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});

var _templateObject;
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].h2(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return headingSizes[size || 'Large'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});




/***/ }),

/***/ 3377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DomEventEmitter; }
/* harmony export */ });
var DomEventEmitter = function () {
  return {
    on: function on(eventName, listener) {
      return document.addEventListener(eventName, listener);
    },
    off: function off(eventName, listener) {
      return document.removeEventListener(eventName, listener);
    },
    emit: function emit(eventName, opts) {
      var event = new CustomEvent(eventName, {
        detail: opts,
        cancelable: true
      });
      return document.dispatchEvent(event);
    }
  };
}();




/***/ }),

/***/ 1969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h4": function() { return /* binding */ Header; }
});

// UNUSED EXPORTS: DOM_EVENT_NAME, hideLoginPopOverEvent, showLoginPopOverEvent

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@growth/use-analytics/dist/growth-use-analytics.esm.js
var growth_use_analytics_esm = __webpack_require__(2390);
// EXTERNAL MODULE: ../../node_modules/@growth/dom-event-emitter/dist/growth-dom-event-emitter.esm.js
var growth_dom_event_emitter_esm = __webpack_require__(3377);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js + 1 modules
var growth_auth_helpers_esm = __webpack_require__(7263);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/@growth/store-helpers/dist/growth-store-helpers.esm.js
var growth_store_helpers_esm = __webpack_require__(6880);
// EXTERNAL MODULE: ../../node_modules/@growth/fetch-request/dist/growth-fetch-request.esm.js
var growth_fetch_request_esm = __webpack_require__(6963);
;// CONCATENATED MODULE: ../../node_modules/@growth/data-store/node_modules/@growth/api-configs/dist/index-d83b01ac.esm.js
var hosts = {
  goibibo: '//www.goibibo.com',
  pokus: '//pokus.goibibo.com',
  recommendEarnUrl: '//influencer.goibibo.com',
  skywalker: '//mapi.goibibo.com',
  voyagerX: '//voyagerx.goibibo.com',
  voyager: '//voyager.goibibo.com',
  recentSearchPush: '//pdt.goibibo.com',
  gdpr: '//consentmgmt.makemytrip.com',
  appBannerUrl: "//userservice.goibibo.com",
  userGeoLocation: '//mapi.goibibo.com',
  configStore: '//configstore.goibibo.com',
  argus: '//www.goibibo.com',
  loyaltyUserInfo: '//membership-service.goibibo.com',
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: '//www.goibibo.com',
  amigoSyncUp: '//mitra.goibibo.com'
};

var PP = 'pp';
var LOCAL = 'local';
var PROD_PP = 'prodpp';
var PROD = 'prod';
var envs = [PROD, PP, PROD_PP, LOCAL];

var index_d83b01ac_esm_filterConfigForEnv = function filterConfigForEnv(configs, env) {
  if (env === void 0) {
    env = 'prod';
  }

  var normalizeEnvVar = function normalizeEnvVar(v) {
    var validEnvVar = function validEnvVar(ve) {
      return envs.includes(ve);
    };

    if (!validEnvVar(v)) {
      throw new Error("getConfig:normalizeEnvVar:validEnvVar error, " + v + " is not a valid env");
    } // pp & local will get the local hosts.
    // prodpp & prod will get the prod hosts.


    var e = [PP, LOCAL].includes(env) ? LOCAL : PROD;
    return e.toLowerCase();
  };

  var BuildEnv = normalizeEnvVar(env);
  return configs[BuildEnv];
};

var index_d83b01ac_esm_getConfigValueFromEnv = function getConfigValueFromEnv(key) {
  if (typeof GROWTH_API_CONFIG !== 'undefined') {
    var value = GROWTH_API_CONFIG[key];
    if (value) return value;
  }

  return hosts[key];
};

var index_d83b01ac_esm_endpoints = {
  appBannerUrlGuest: '/ext/web/pwa/send/token/DEEP_LINK',
  appBannerUrlLoggedIn: '/ext/web/pwa/send/token/LINK',
  pokusAssignVariant: '/experiment/assignVariant',
  userWidget: "/common/userwidget/?random=+" + Math.random(),
  // random to avoid browser cache
  recommendEarnUrl: "/recEarn/infl/details",
  skywalkerV1: '/empeiria/api/v1',
  dsdVoyager: '/api/v1/hotels_search/find_node_by_name',
  appContext: '/api/v2/utils/get_context/',
  recentSearchPush: '/fs/w',
  gdpr: '/ext/hcs/cmp/userconsents/get',
  userGdpr: '/ext/hcs/cmp/userconsents/save',
  userGeoLocation: '/locus/web/v2/graphQl',
  voyagerPagemake: '/pagemaker',
  argus: '/argus/pwa/login_details/save',
  configStore: '/get/configKey',
  getRecentSearch: '/empeiria/api/v1/recentSearchResponseByLob',
  loyaltyUserInfo: '/loyalty/userInfoWrapper',
  gocashBalance: '/gocash/v2/get_balance/',
  bookingSummary: '/tripsbackend/v2/bookingsummary',
  pokusImpressionAndHonour: '/measurement/impressionAndHonourConditions',
  pokusDynamicConfigs: '/measurement/getDynamicConfigs',
  amigoGetSyncUp: '/v1/say_thanks/get_privacy_data',
  amigoSetSyncUp: '/v1/say_thanks/post_privacy_data',
  amigoSetSyncUpStatus: '/api/v1/user/status/optin'
};



;// CONCATENATED MODULE: ../../node_modules/@growth/data-store/node_modules/@growth/api-configs/dist/growth-api-configs.esm.js



/** Will reverse proxy/mock all local & pp api via moxy */
var moxy = 'https://newprodpp.goibibo.com/moxy';
var growth_api_configs_esm_hosts = {
  goibibo: '//www.goibibo.com',
  pokus: moxy,
  recommendEarnUrl: moxy,
  skywalker: moxy,
  voyagerX: moxy,
  voyager: moxy,
  recentSearchPush: moxy,
  gdpr: moxy,
  appBannerUrl: moxy,
  userGeoLocation: moxy,
  configStore: moxy,
  argus: moxy,
  loyaltyUserInfo: moxy,
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: moxy,
  amigoSyncUp: moxy
};

/**
 * Default index gives the client side api configs
 * eg:
 * import getConfig from '@growth/api-configs'
 */
var configs = {
  local: growth_api_configs_esm_hosts,
  prod: hosts
};

var getConfig = function getConfig(env) {
  var c = filterConfigForEnv(configs, env);
  return c;
};



// EXTERNAL MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js + 1 modules
var growth_visitor_id_browser_esm = __webpack_require__(6939);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-utils/dist/growth-auth-utils.esm.js
var growth_auth_utils_esm = __webpack_require__(8132);
;// CONCATENATED MODULE: ../../node_modules/@growth/data-store/node_modules/@growth/api-calls/dist/growth-api-calls.esm.js







var fetchAppOpenUrl = function fetchAppOpenUrl(opts) {
  var isLoggedIn = !!getAuthToken();
  var apiPayload = (opts == null ? void 0 : opts.apiPayload) || {};
  var vid = getVisitorIdBrowser();
  var payload = {
    /*
     * keep the timeout small for this api,
     */
    body: {
      type: '18',
      "deepLink": {
        "data": {
          "c": apiPayload == null ? void 0 : apiPayload.campaign,
          "pid": "mweb2app",
          "deep_link_value": apiPayload == null ? void 0 : apiPayload.tagid,
          "af_web_dp": "https://www.goibibo.com/",
          "af_android_url": "https://play.google.com/store/apps/details?id=com.goibibo",
          "af_ios_url": "https://apps.apple.com/in/app/goibibo-hotel-flight-train/id631927169",
          "deep_link_sub1": _extends({}, apiPayload == null ? void 0 : apiPayload.godata, {
            login_req: (apiPayload == null ? void 0 : apiPayload.loginReq) || false,
            "referral_flow": (apiPayload == null ? void 0 : apiPayload.referral_flow) || false,
            "traffic_source": (apiPayload == null ? void 0 : apiPayload.trafficSource) || undefined,
            "~campaign": apiPayload == null ? void 0 : apiPayload.campaign,
            web_vid: vid
          }),
          "brand_domain": "app.goibibo.com"
        }
      }
    },
    credentials: 'omit',
    headers: getEssentialHeader({
      platform: 'mweb'
    })
  };
  var appBannerHost = getConfigValueFromEnv('appBannerUrl');
  var appBannerEndpoint = isLoggedIn ? endpoints.appBannerUrlLoggedIn : endpoints.appBannerUrlGuest;
  return fetchRequest("" + appBannerHost + appBannerEndpoint, payload).post();
};

var fetchPokusAssignVariantData = function fetchPokusAssignVariantData(opts) {
  var pokusOptions = opts.pokusOptions,
    _opts$extraHeader = opts.extraHeader,
    extraHeader = _opts$extraHeader === void 0 ? {} : _opts$extraHeader,
    timeout = opts.timeout;
  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob || 'COMMON';
  var _generatePokusAssignV = generatePokusAssignVariantBodyRequest({
      isMobile: pokusOptions.isMobile,
      lob: lobName,
      deviceId: deviceId,
      extraOptions: pokusOptions
    }),
    request = _generatePokusAssignV.request;
  var pokusUrl = getConfigValueFromEnv('pokus');
  var authToken = pokusOptions.authToken || getAuthToken$1();
  var headers = {};
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusAssignVariant, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeader),
    timeout: timeout
  }).post().then(function (res) {
    var _res$perLobMap;
    return (_res$perLobMap = res.perLobMap) == null ? void 0 : _res$perLobMap[lobName].metadataValues;
  });
};

var fetchUserDetails = function fetchUserDetails(_ref) {
  var timeout = _ref.timeout;
  var host = getConfigValueFromEnv('goibibo');
  return fetchRequest("" + host + endpoints.userWidget, {
    timeout: timeout
  }).post();
};

var fetchRecommendEarnDetails = function fetchRecommendEarnDetails(details) {
  var recommendEarnUrl = getConfigValueFromEnv('recommendEarnUrl');
  var token = getAuthToken$1();
  var headers = {
    auth: token,
    os: details == null ? void 0 : details.flavour
  };
  return fetchRequest("" + recommendEarnUrl + endpoints.recommendEarnUrl, {
    headers: headers,
    body: {
      hotelId: details.hotelId,
      source: details.source
    },
    credentials: 'omit'
  }).post();
};

var fetchSkywalkerClientData = function fetchSkywalkerClientData(skywalkerOptions, extraHeaders) {
  if (extraHeaders === void 0) {
    extraHeaders = {};
  }
  var endpointPath = skywalkerOptions.endpointPath,
    extraReqBody = skywalkerOptions.extraReqBody;
  var request = generateSkywalkerBodyRequest({
    extraReqBody: extraReqBody
  });
  var skywalkerUrl = getConfigValueFromEnv('skywalker');
  var headers = {
    brand: 'gi',
    deviceid: String
  };
  if (isUserTokenPresent()) {
    headers.auth = getAuthToken$1();
  }
  var dvid = getVisitorIdBrowser();
  if (dvid) {
    headers.deviceid = dvid;
  }
  return fetchRequest("" + skywalkerUrl + endpoints.skywalkerV1 + endpointPath, {
    body: request,
    credentials: 'omit',
    query: 'language=eng&currency=inr&region=in&brand=GI',
    headers: _extends({}, headers, extraHeaders)
  }).post();
};

var fetchAutoSuggetDailyStealDeal = function fetchAutoSuggetDailyStealDeal(userLocation) {
  var dsdVoyagerUrl = getConfigValueFromEnv('voyagerX');
  var userSelectedLocation = userLocation.userVal;
  return fetchRequest("" + dsdVoyagerUrl + endpoints.dsdVoyager, {
    credentials: 'omit',
    query: "search_query=" + userSelectedLocation + "&limit=10&include_t=[\"voy.city\"]"
  }).post();
};

var fetchPushRecentSearch = function fetchPushRecentSearch(searchCollection) {
  var url = getConfigValueFromEnv('recentSearchPush');
  var token = getAuthToken$1();
  var deviceid = getVisitorIdBrowser();
  var headers = {
    'Content-Type': 'application/json',
    'Request-Data-Encoding': 'json'
  };
  if (token) headers['oauth-goibibo'] = token;
  if (deviceid) headers.deviceid = deviceid;
  return fetchRequest("" + url + endpoints.recentSearchPush, {
    headers: headers,
    body: JSON.stringify(searchCollection),
    credentials: 'omit',
    extraOptions: {
      keepalive: true
    }
  }).post();
};

var fetchAppContext = function fetchAppContext(link) {
  var url = getConfigValueFromEnv('voyager') || prod.voyager;
  var raw = "url=" + (link || '');
  return fetchRequest("" + url + endpoints.appContext, {
    body: raw,
    credentials: 'omit'
  }).post();
};

var fetchGdprData = function fetchGdprData() {
  var host = getConfigValueFromEnv('gdpr');
  var token = getAuthToken$1();
  var headers = {};
  if (token) headers.Authorization = JSON.stringify({
    type: 'auth',
    value: token
  });
  return fetchRequest("" + host + endpoints.gdpr, {
    headers: headers,
    body: {
      org: 'GI',
      consent_id: 1,
      profile_type: 0,
      show_meta: true
    },
    credentials: 'omit'
  }).post();
};

var pushUserGdprData = function pushUserGdprData(gdpConsents) {
  var host = getConfigValueFromEnv('gdpr');
  var token = getAuthToken$1();
  var headers = {};
  if (token) headers.Authorization = JSON.stringify({
    type: 'auth',
    value: token
  });
  return fetchRequest("" + host + endpoints.userGdpr, {
    headers: headers,
    body: {
      org: 'GI',
      author: 'USER',
      consents: [_extends({
        status_active: true
      }, gdpConsents)]
    },
    credentials: 'omit'
  }).post();
};

var fetchUserGeoLocation = function fetchUserGeoLocation(_ref) {
  _ref.timeout;
  var host = getConfigValueFromEnv('userGeoLocation');
  return fetchRequest("" + host + endpoints.userGeoLocation, {
    body: "{ locationHierarchy(lat:,lng:) { country { id name centre } state { id name centre } city { id name centre postal_code } area { id name primary_area centre postal_code } } }",
    headers: {
      'Api-key': 'GROWTH-MMTGROWTH-71815232081313207181523208'
    }
  }).post();
};

var fetchConfigStoreData = function fetchConfigStoreData(opts) {
  var fetchOpts = opts.fetchOpts;
  var headers = fetchOpts.headers,
    timeout = fetchOpts.timeout;
  var host = getConfigValueFromEnv('configStore');
  return fetchRequest("" + host + endpoints.configStore, {
    headers: _extends({
      authorization: 'Tect685j8xMpLJF'
    }, headers),
    body: {
      isAbKey: opts.isAbKey,
      lobList: opts.lobList,
      cfgKeyList: opts.cfgKeyList
      /**
       * below three options helps on more granular query on bacnkend
       * these keys are not part of v1(present) api. Keep it commented
       * */
      // status: string,
      // submodule: string,
      // pgname: string,
    },

    credentials: 'omit',
    timeout: timeout
  }).post();
};

var fetchArgusFingerPrinting = function fetchArgusFingerPrinting(_ref) {
  var asyToken = _ref.asyToken,
    additionalData = _ref.additionalData;
  var url = getConfigValueFromEnv('argus');
  var token = getAuthToken();
  var headers = {
    region: 'in',
    currency: 'inr',
    language: 'eng'
  };
  if (token) headers['oauth-goibibo'] = token;
  fetchRequest("" + url + endpoints.argus, {
    headers: _extends({
      Authorization: 'P0s6jZGIkwMrnS2',
      'X-Request-Tracker': generateVid()
    }, headers),
    credentials: 'omit',
    body: {
      asyToken: asyToken,
      additionalData: additionalData
    }
  }).post();
};

var fetchRecentSearch = function fetchRecentSearch(_ref) {
  var lob = _ref.lob,
    strategy = _ref.strategy;
  var url = getConfigValueFromEnv('skywalker');
  return fetchRequest("" + url + endpoints.getRecentSearch + "?lob=" + lob + "&strategy=" + strategy, {
    headers: {
      'content-type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      user: {
        profile_type: 'PERSONAL',
        uuid: getUuidFromCookie(),
        device_id: getVisitorIdBrowser(),
        domain: {
          country: 'in',
          language: 'eng',
          currency: 'inr'
        }
      }
    })
  }).post();
};

var fetchLoyaltyUserInfo = function fetchLoyaltyUserInfo() {
  var url = index_d83b01ac_esm_getConfigValueFromEnv('loyaltyUserInfo');
  var token = (0,growth_auth_utils_esm/* getAuthToken */.bW)();
  var headers = {
    'Content-Type': 'application/json',
    authorization: '7NP82fpV0TsA9JrK',
    org: 'GI'
  };
  if (token) headers.auth = token;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + url + index_d83b01ac_esm_endpoints.loyaltyUserInfo, {
    headers: headers,
    body: JSON.stringify({}),
    // empty data object is require for this endpoint
    credentials: 'omit'
  }).post();
};

var fetchGoCashBalance = function fetchGoCashBalance() {
  var url = index_d83b01ac_esm_getConfigValueFromEnv('gocashBalance');
  var headers = {
    'oauth-goibibo': (0,growth_auth_utils_esm/* getAuthToken */.bW)()
  };
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + url + index_d83b01ac_esm_endpoints.gocashBalance, {
    headers: headers,
    credentials: 'omit'
  }).get();
};

/** List of all bookings */
var fetchBookingSummary = function fetchBookingSummary() {
  var url = index_d83b01ac_esm_getConfigValueFromEnv('bookingSummary');
  var headers = {
    auth: (0,growth_auth_utils_esm/* getAuthToken */.bW)()
  };
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + url + index_d83b01ac_esm_endpoints.bookingSummary, {
    headers: headers,
    credentials: 'omit'
  }).get();
};

var fetchPokusImpressionAndHonourDetails = function fetchPokusImpressionAndHonourDetails(opts) {
  var _ref = opts || {},
    analyticsNode = _ref.analyticsNode;
  var host = getConfigValueFromEnv('pokus');
  return fetchRequest("" + host + endpoints.pokusImpressionAndHonour, {
    body: {
      analyticsNode: analyticsNode
    },
    credentials: 'omit'
  }).post();
};

var fetchPokusDynamicConfigs = function fetchPokusDynamicConfigs(opts) {
  var pokusOptions = opts.pokusOptions,
    _opts$extraHeader = opts.extraHeader,
    extraHeader = _opts$extraHeader === void 0 ? {} : _opts$extraHeader,
    timeout = opts.timeout;
  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob;
  var request = generatePokusDynamicConfigBodyRequest({
    isMobile: pokusOptions.isMobile,
    lob: lobName,
    deviceId: deviceId,
    extraOptions: pokusOptions
  });
  var pokusUrl = getConfigValueFromEnv('pokus');
  var authToken = pokusOptions.authToken || getAuthToken$1();
  var headers = {
    region: 'IN',
    language: 'EN'
  };
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusDynamicConfigs, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeader),
    timeout: timeout
  }).post();
};

var fetchAmigoSyncUpContacts = function fetchAmigoSyncUpContacts(_ref) {
  var bookingId = _ref.bookingId,
    lob = _ref.lob;
  var url = prod.amigoSyncUp;
  var headers = {
    'oauth-goibibo': getAuthToken()
  };
  return fetchRequest("" + url + endpoints.amigoGetSyncUp, {
    headers: headers,
    credentials: 'omit',
    query: "bookingId=" + bookingId + "&Lob=" + lob + "&context=TYP"
  }).get();
};

var pushAmigoSyncUpChoice = function pushAmigoSyncUpChoice(_ref) {
  var bookingId = _ref.bookingId,
    lob = _ref.lob,
    isConsentGiven = _ref.isConsentGiven,
    reasonId = _ref.reasonId,
    reason = _ref.reason;
  var url = prod.amigoSyncUp;
  var headers = {
    'oauth-goibibo': getAuthToken(),
    'Content-Type': 'application/json'
  };
  return fetchRequest("" + url + endpoints.amigoSetSyncUp, {
    headers: headers,
    credentials: 'omit',
    body: {
      bookingId: bookingId,
      Lob: lob,
      isConsentGiven: isConsentGiven,
      reasonId: reasonId,
      reason: reason
    }
  }).post();
};



;// CONCATENATED MODULE: ../../node_modules/@growth/data-store/dist/growth-data-store.esm.js




function growth_data_store_esm_extends() {
  growth_data_store_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return growth_data_store_esm_extends.apply(this, arguments);
}

var useBookingSummaryStore = (0,esm/* create */.Ue)()(function (set) {
  return growth_data_store_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchBookingSummary,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});
/** Filter the 'UPCOMING' bookings */

var selectUpcomingBookingsCount = function selectUpcomingBookingsCount(state) {
  var _state$data;

  var bookingList = (state == null ? void 0 : (_state$data = state.data) == null ? void 0 : _state$data.bookingDetails) || [];
  var upcomingList = bookingList.filter(function (item) {
    return (item == null ? void 0 : item.status) === 'UPCOMING';
  });
  return upcomingList.length;
};

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchFun = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var resp, _ref2, success, balance;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchGoCashBalance();

          case 2:
            resp = _context.sent;
            _ref2 = resp || {}, success = _ref2.success, balance = _ref2.total_credits;

            if (!(success || typeof balance !== 'undefined')) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", {
              balance: balance
            });

          case 6:
            return _context.abrupt("return", 0);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun() {
    return _ref.apply(this, arguments);
  };
}();

var useGoCashBalanceStore = (0,esm/* create */.Ue)()(function (set) {
  return growth_data_store_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {
      balance: 0
    },
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});

var useLoyaltyUserInfoStore = (0,esm/* create */.Ue)(function (set) {
  return growth_data_store_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchLoyaltyUserInfo,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
}); // https://github.com/pmndrs/zustand/discussions/387#discussioncomment-6339994

var selectLoyaltyMemberType = function selectLoyaltyMemberType(state) {
  var _state$tribe_header;

  return (state == null ? void 0 : (_state$tribe_header = state.tribe_header) == null ? void 0 : _state$tribe_header.type) || 'non_member';
};



// EXTERNAL MODULE: ../../node_modules/zustand/esm/shallow.mjs
var shallow = __webpack_require__(2532);
// EXTERNAL MODULE: ../../node_modules/@growth/pdt-push/dist/growth-pdt-push.esm.js
var growth_pdt_push_esm = __webpack_require__(3488);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../node_modules/@growth/design-system/dist/growth-design-system.esm.js
var growth_design_system_esm = __webpack_require__(3767);
// EXTERNAL MODULE: ../../node_modules/@growth/custom-hooks/useHasMounted/dist/growth-custom-hooks-useHasMounted.esm.js
var growth_custom_hooks_useHasMounted_esm = __webpack_require__(3509);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/dist/dom-events-c707d33c.esm.js


var dom_events_c707d33c_esm_DOM_EVENT_NAME = {
  LOGOUT: 'hr_l',
  LOGOUT_SUCCESS: 'hr_lls',
  START_LOGIN_FLOW: 'hr_slf',
  HEADER_ITEM_CLICK: 'hr_hic',
  IS_NEW_USER: 'hr_inu',
  SHOW_LOGIN_POP_OVER: 'hr_slpo',
  HIDE_LOGIN_POP_OVER: 'hr_hlpo',
  REFRESH_HEADER_DATA: 'hr_rhr',
  LOGIN_SUCCESS: growth_auth_helpers_esm/* LOGIN_SUCCESS */.XP
};



// EXTERNAL MODULE: ../../node_modules/@growth/gi-dweb-auth/dist/growth-gi-dweb-auth.esm.js + 1 modules
var growth_gi_dweb_auth_esm = __webpack_require__(3858);
// EXTERNAL MODULE: ../../node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js + 7 modules
var growth_config_store_browser_esm = __webpack_require__(4162);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../node_modules/@growth/modal/dist/index-0b639158.esm.js





function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var ModalWrapper = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tmin-width: 560px;\n\tmax-width: 1024px;\n\tposition: fixed;\n\tleft: 50vw;\n\ttop: 50vh;\n\ttransform: translate(-50%, -50%);\n\tbackground-color: #fff;\n\tborder-radius: 16px;\n\tz-index: 1026;\n"])));
var ModalCont = styled_components_browser_esm["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\toverflow: hidden;\n\tposition: relative;\n"])));
var ModalBackdrop = styled_components_browser_esm["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 1024;\n\tbackground: rgba(20, 24, 35, 0.7);\n"])));
var ModalBody = styled_components_browser_esm["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tmax-height: 800px;\n\toverflow-y: auto;\n\t", "\n\n"])), function (p) {
  return p.onClick ? "cursor:pointer" : '';
});
var CloseBtn = styled_components_browser_esm["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\twidth: 28.8px;\n\theight: 28.8px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: absolute;\n\ttop: 32px;\n\tright: 32px;\n\tcursor: pointer;\n\tz-index: 1030;\n\n\t&::before,\n\t&::after {\n\t\tposition: absolute;\n\t\tcontent: ' ';\n\t\theight: 20px;\n\t\twidth: 2px;\n\t\tbackground-color: #647a97;\n\t}\n\n\t&::before {\n\t\ttransform: rotate(45deg);\n\t}\n\n\t&::after {\n\t\ttransform: rotate(-45deg);\n\t}\n"])));

var WithoutPortalModal = function WithoutPortalModal(_ref) {
  var onClose = _ref.onClose,
    rootStyle = _ref.rootStyle,
    contentStyle = _ref.contentStyle,
    children = _ref.children,
    shouldCloseOutSideClick = _ref.shouldCloseOutSideClick,
    closeBtnStyle = _ref.closeBtnStyle,
    closeBtnShow = _ref.closeBtnShow,
    onBodyClick = _ref.onBodyClick;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ModalWrapper, {
    className: "modal-wrapper",
    style: rootStyle,
    "data-id": "dweb-modal"
  }, closeBtnShow && /*#__PURE__*/react.createElement(CloseBtn, {
    style: closeBtnStyle,
    onClick: onClose
  }), /*#__PURE__*/react.createElement(ModalCont, {
    style: contentStyle
  }, /*#__PURE__*/react.createElement(ModalBody, {
    onClick: onBodyClick
  }, children))), /*#__PURE__*/react.createElement(ModalBackdrop, {
    onClick: shouldCloseOutSideClick ? onClose : function () {}
  }));
};
var Modal = function Modal(props) {
  var clientOnly = (0,growth_custom_hooks_useHasMounted_esm/* useHasMounted */.f)();
  (0,react.useEffect)(function () {
    // fixed scrolling when bottom modal is opened
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.removeProperty('overflow');
    };
  }, []);
  var Com = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(WithoutPortalModal, props));
  return clientOnly ? /*#__PURE__*/(0,react_dom.createPortal)(Com, document.body) : null;
};
WithoutPortalModal.defaultProps = {
  rootStyle: {},
  contentStyle: {},
  shouldCloseOutSideClick: true,
  closeBtnStyle: undefined,
  onBodyClick: undefined,
  closeBtnShow: true,
  onClose: undefined
};



;// CONCATENATED MODULE: ../../node_modules/@growth/modal/dist/growth-modal.esm.js






// EXTERNAL MODULE: ../../node_modules/@growth/web-analytics/dist/growth-web-analytics.esm.js
var growth_web_analytics_esm = __webpack_require__(2019);
// EXTERNAL MODULE: ../../node_modules/@growth/ssr-utils/dist/growth-ssr-utils.esm.js
var growth_ssr_utils_esm = __webpack_require__(1917);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-pdt/dist/growth-analytics-plugin-pdt.esm.js + 2 modules
var growth_analytics_plugin_pdt_esm = __webpack_require__(1080);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-adobe/dist/growth-analytics-plugin-adobe.esm.js
var growth_analytics_plugin_adobe_esm = __webpack_require__(6401);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/dist/growth-dweb-header.esm.js




















function growth_dweb_header_esm_regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  growth_dweb_header_esm_regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function growth_dweb_header_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function growth_dweb_header_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        growth_dweb_header_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        growth_dweb_header_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function growth_dweb_header_esm_taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$c, _templateObject2$a, _templateObject3$8, _templateObject4$5, _templateObject5$4, _templateObject6$4, _templateObject7$4, _templateObject8$2;
var bdrAni = (0,styled_components_browser_esm.keyframes)(_templateObject$c || (_templateObject$c = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t\t0% {\n\t\t\twidth: 0;\n\t\t\tleft: 60%; /* Start from the center */\n\t\t\ttransform: translateX(-50%); /* Center the element horizontally */\n\t\t}\n\t\t50% {\n\t\t\twidth: 100%; /* Expand to the right */\n\t\t\tleft: 0; /* Move to the left edge */\n\t\t\ttransform: translateX(0%);\n\t\t}\n\t\t100% {\n\t\t\twidth: 100%; /* Collapse back to the center */\n\t\t\tleft: 50%; /* End at the center */\n\t\t\ttransform: translateX(-50%);\n\t\t}\n"])));
var HappyNav = styled_components_browser_esm["default"].ul(_templateObject2$a || (_templateObject2$a = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\theight: 100%;\n"])));
var HappyNavItem = styled_components_browser_esm["default"].li(_templateObject3$8 || (_templateObject3$8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: transparent;\n\tcursor: pointer;\n\theight: 100%;\n\tposition: relative;\n\t", ";\n\n\t&.active,\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2, function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? '#2274e0' : '#777';
});
var NavLink$1 = styled_components_browser_esm["default"].a(_templateObject4$5 || (_templateObject4$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tcolor: #717171 !important;\n\talign-items: center;\n\tmargin-right: 30px;\n\tpadding: 20px 0px;\n\tposition: relative;\n\theight: 100%;\n\n\t&:visited {\n\t\tcolor: #717171;\n\t}\n\n\t&.active {\n\t\tcolor: #2274e0;\n\t\t&::after {\n\t\t\tposition: absolute;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tcontent: '';\n\t\t\theight: 3px;\n\t\t\twidth: 100%;\n\t\t\tbackground-color: #2274e0;\n\t\t\tborder-radius: 2px;\n\t\t\tanimation: ", " 0.4s 1;\n\t\t}\n\t}\n"])), bdrAni);
var NewLob = styled_components_browser_esm["default"].div(_templateObject5$4 || (_templateObject5$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tborder-radius: 8px;\n\tfont-size: 10px;\n\tpadding: 2px 6px;\n\tcolor: #fff;\n\ttop: -8px;\n\tright: 19px;\n\tbackground: #ff5656;\n\tmargin-left: 5px;\n\tposition: absolute;\n"])));
var NavText = styled_components_browser_esm["default"].span(_templateObject6$4 || (_templateObject6$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var NavLinkSvg = styled_components_browser_esm["default"].div(_templateObject7$4 || (_templateObject7$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\theight: 24px;\n\twidth: 24px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\tmargin-right: 2px;\n"])));
var NavIcon$1 = styled_components_browser_esm["default"].span(_templateObject8$2 || (_templateObject8$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-right: 5px;\n"])));

function growth_dweb_header_esm_extends() {
  growth_dweb_header_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return growth_dweb_header_esm_extends.apply(this, arguments);
}

// We use 'W_' as prefix for writing text constants
var W_GENERICS = {
  loginSignup: 'Login / Sign Up',
  loginSignup2: 'Login/Sign Up',
  internetError: 'Internet is not available. Check your connection.',
  apiErrorMsg: 'Some error occurred, please try again.'
};
var W_LOGIN_POPOVER_PERSUASION_GENERICS = {
  loginSignup: W_GENERICS.loginSignup2,
  coupon: 'Use Coupon : WELCOME'
};
var W_LOGIN_POPOVER_PERSUASION_FLIGHT = growth_dweb_header_esm_extends({
  offerTitle: 'FLAT 12% OFF*',
  offerSubTitle: 'on your first Flight booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_HOTEL = growth_dweb_header_esm_extends({
  offerTitle: 'FLAT 25% OFF* ',
  offerSubTitle: 'on your first Hotel booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_BUS = growth_dweb_header_esm_extends({
  offerTitle: 'FLAT 10% OFF*',
  offerSubTitle: 'on your first Bus booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_CAB = growth_dweb_header_esm_extends({
  offerTitle: ' Upto 10% OFF*',
  offerSubTitle: 'on your first Cab booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_TRAIN = growth_dweb_header_esm_extends({
  offerTitle: 'Zero service fees',
  offerSubTitle: 'on your first Train booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_BANNER_DEFAULT = {
  theme: 'gr-home',
  heading: 'Unlock these benefits',
  subHeading: '',
  benefits: [{
    id: 1,
    heading: 'Earn goCash',
    subHeading: '₹100 on Sign Up & Cashback on Bookings',
    iconClass: 'icGoCash'
  }, {
    id: 2,
    heading: 'Loyalty Benefits',
    subHeading: 'Extra Discounts, Free Seat Selection etc.',
    iconClass: 'icGoTribe'
  }, {
    id: 3,
    heading: 'Exclusive Offers',
    subHeading: 'Daily Steal Deals & Special Discounts',
    iconClass: 'icGiftBlue'
  }],
  offers: W_LOGIN_POPOVER_PERSUASION_FLIGHT
};
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_HOTEL
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_BUS
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_TRAIN
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_CAB
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_FLIGHT
});
var W_USER_PROFILE_DROPDOWN = function W_USER_PROFILE_DROPDOWN(origin) {
  if (origin === void 0) {
    origin = '';
  }

  return {
    login: {
      label: 'Hey Traveller',
      subLabel: 'Get exclusive deals & Manage your trips',
      ctaText: W_GENERICS.loginSignup2
    },
    view_profile: {
      label: 'View your profile',
      url: origin + "/profile/"
    },
    offers: {
      label: 'Offers',
      subLabel: 'Handpicked best deals',
      icon: 'offers',
      url: origin + "/offers/"
    },
    myTrips: {
      label: 'My Trips',
      subLabel: {
        singular: 'Upcoming Trip',
        plural: "Upcoming Trips"
      },
      icon: 'mytrip',
      url: origin + "/travelhistory"
    },
    gotTribe: {
      label: '',
      subLabel: {
        member: 'View membership benefits',
        nonMember: 'Travel more to get enrolled!'
      },
      icon: 'gotribe',
      goTribeIcon: 'gotribeLogo',
      url: origin + "/loyalty/"
    },
    goCash: {
      label: 'goCash',
      subLabel: 'Current Balance : ',
      subLabelGuest: 'Signup to get ₹100 goCash',
      icon: 'gocash',
      url: origin + "/gocash/"
    },
    logout: {
      label: 'Logout',
      icon: 'logout-icon'
    }
  };
};
var W_RUPEE_SIGN = '₹';
var W_MY_TRIPS = function W_MY_TRIPS(origin) {
  if (origin === void 0) {
    origin = '';
  }

  return {
    label: 'My Trips',
    icon: 'mytrip-icon',
    tooltip: 'Access your bookings, easy cancellation, date change and much more',
    manageBooking: 'Manage Booking',
    url: W_USER_PROFILE_DROPDOWN(origin).myTrips.url
  };
};
var W_LOGIN_WIDGET_CTA = [{
  text: 'LOGIN / SIGNUP',
  id: 'text_1'
}, {
  text: 'Exclusive Offers',
  id: 'text_2'
}, {
  text: 'Earn goCash',
  id: 'text_3'
}, {
  text: 'Manage Your Trips',
  id: 'text_4'
}];

var LOBS_NAME = {
  FLIGHTS: 'Flights',
  HOTELS: 'Hotels',
  HOLIDAYS: 'Holidays',
  BUS: 'Bus',
  CABS: 'Cabs',
  TRAINS: 'Trains',
  VISA: 'Visa',
  FOREX: 'Forex',
  INSURANCE: 'Insurance'
};
var LOBS_CATG = {
  FLIGHTS: 'flights',
  HOTELS: 'hotels',
  BUS: 'bus',
  CABS: 'cabs',
  TRAINS: 'trains',
  HOLIDAYS: 'holidays',
  ACTIVITIES: 'activities',
  GROWTH: 'growth',
  COMMON: 'common',
  METRO: 'metro',
  VISA: 'visa',
  FOREX: 'forex',
  INSURANCE: 'Insurance'
};
var GOTRIBE_MEMBER_TYPES = {
  non_member: {
    value: 'non_member',
    label: ''
  },
  member: {
    value: 'member'
  },
  star: {
    value: 'star',
    label: 'Star'
  },
  superstar: {
    value: 'superstar',
    label: 'SuperStar'
  }
};
var DEFAULT_PROFILE_NAME = 'Traveller';

var isActiveLink = function isActiveLink(navLabel, lobName) {
  if (navLabel && lobName) {
    return navLabel.toLowerCase() === lobName.toLowerCase();
  }

  return false;
};

var goTribeMembers = [GOTRIBE_MEMBER_TYPES.star.value, GOTRIBE_MEMBER_TYPES.superstar.value, GOTRIBE_MEMBER_TYPES.member.value];

var isGoTribeMember = function isGoTribeMember(memberType) {
  return goTribeMembers.includes(memberType);
};

var getUserNameInitials = function getUserNameInitials(name) {
  return name.toString().charAt(0).toUpperCase();
};

var NavBar = function NavBar(_ref) {
  var navList = _ref.navList,
      lobName = _ref.lobName;
  var activeClass = (0,react.useCallback)(function (label, lob) {
    return !!isActiveLink(label, lob);
  }, [lobName]);

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
      _useAnalytics.pdt;
      var adobe = _useAnalytics.adobe;

  function navBarGaEvent(item) {
    (0,growth_pdt_push_esm/* pdtPush */.g)("header_click", {
      event_detail: {
        event_type: "click_event|shopper_click",
        event_value: "" + lobName
      }
    });
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: item.category,
        type: 'itemClick',
        destination: item.url,
        componentName: 'header'
      }
    });
  }
  /** Hide the last item in nav if viewport is smaller than  1440px */


  var _useState = (0,react.useState)(true),
      hideLastItem = _useState[0],
      setShowLastItem = _useState[1];

  (0,react.useEffect)(function () {
    var viewport = window.matchMedia('(max-width: 1440px)');
    setShowLastItem(viewport.matches);
    viewport.addEventListener('change', function (e) {
      return setShowLastItem(e.matches);
    });
    return function () {
      viewport.removeEventListener('change', function (e) {
        return setShowLastItem(e.matches);
      });
    };
  }, []);
  var currentNavList = hideLastItem ? navList.slice(0, navList.length - 1) : navList.slice(0, navList.length);
  return /*#__PURE__*/react.createElement(HappyNav, null, currentNavList.map(function (item) {
    var _item$icon, _item$icon2;

    return /*#__PURE__*/react.createElement(HappyNavItem, {
      key: item.label,
      isActive: activeClass(item.category, lobName)
    }, /*#__PURE__*/react.createElement(NavLink$1, {
      href: item.url,
      target: "" + (item.targetBlank ? '_blank' : '_self'),
      className: activeClass(item.category, lobName) ? 'active' : '',
      onClick: function onClick() {
        return navBarGaEvent(item);
      }
    }, ((_item$icon = item.icon) == null ? void 0 : _item$icon.type) === 'svg' ? /*#__PURE__*/react.createElement(NavLinkSvg, null, /*#__PURE__*/react.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: (_item$icon2 = item.icon) == null ? void 0 : _item$icon2.source
      }
    })) : /*#__PURE__*/react.createElement(NavIcon$1, {
      className: "header-sprite nav-icon-" + item.icon
    }), /*#__PURE__*/react.createElement(NavText, null, item.label), item["new"] && /*#__PURE__*/react.createElement(NewLob, null, "NEW")));
  }));
};

var _templateObject$b, _templateObject2$9;
var LogoLink = styled_components_browser_esm["default"].a(_templateObject$b || (_templateObject$b = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\twidth: 151px;\n\tmargin-right: 55px;\n\n\t.special-logo {\n\t\tmargin-left: 0;\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: contain;\n\t}\n\t.gi-logo {\n\t\tmargin-left: 32px;\n\t}\n"])));
var Logo = styled_components_browser_esm["default"].span(_templateObject2$9 || (_templateObject2$9 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: inherit;\n\theight: 65px;\n"])));

var HeaderLogo = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var homeURL = _ref.homeURL,
      lobName = _ref.lobName;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      adobe = _useAnalytics.adobe;

  var addAnalyticsEvent = function addAnalyticsEvent() {
    (0,growth_pdt_push_esm/* pdtPush */.g)("header_click_logo", {
      event_detail: {
        event_type: "click_event|shopper_click",
        event_value: "" + lobName
      }
    });
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: 'logo',
        destination: homeURL,
        type: 'itemClick',
        componentName: 'header'
      }
    });
  };

  return /*#__PURE__*/react.createElement(LogoLink, {
    href: homeURL,
    onClick: addAnalyticsEvent
  }, /*#__PURE__*/react.createElement(Logo, {
    className: "header-sprite logo gi-logo",
    ref: ref
  }));
});
HeaderLogo.displayName = 'HeaderLogo';

var _templateObject$a, _templateObject2$8, _templateObject3$7, _templateObject4$4, _templateObject5$3, _templateObject6$3, _templateObject7$3;
var TabContainer = styled_components_browser_esm["default"].div(_templateObject$a || (_templateObject$a = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tposition: relative;\n\tmin-height: 40px;\n\twidth: 108px;\n\tmargin-right: 20px;\n\n\t&:hover .tooltip {\n\t\tdisplay: block;\n\t\tz-index: 9999999;\n\t}\n"])));
var MyTripTab = (0,styled_components_browser_esm["default"])(TabContainer)(_templateObject2$8 || (_templateObject2$8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 148px;\n"])));
var NavLink = styled_components_browser_esm["default"].a(_templateObject3$7 || (_templateObject3$7 = growth_dweb_header_esm_taggedTemplateLiteralLoose([""])));
var Tooltip = styled_components_browser_esm["default"].div(_templateObject4$4 || (_templateObject4$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tbackground: #fff;\n\tborder: 1px solid #e3e3e3;\n\tborder-radius: 4px;\n\tbox-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);\n\twidth: 250px;\n\tpadding: 10px 12px 10px 30px;\n\ttop: 52px;\n\tleft: -66px;\n\tdisplay: none;\n\tcolor: #46484d;\n\n\t", ":hover & {\n\t\tdisplay: block;\n\t\tz-index: 9999999;\n\t}\n\n\t&::after,\n\t&::before {\n\t\tbottom: 100%;\n\t\tleft: 50%;\n\t\tborder: solid transparent;\n\t\tcontent: '';\n\t\theight: 0;\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t}\n\n\t&::after {\n\t\tborder-color: rgba(255, 255, 255, 0);\n\t\tborder-bottom-color: #fff;\n\t\tborder-width: 8px;\n\t\tmargin-left: -8px;\n\t}\n\n\t&::before {\n\t\tborder-color: rgba(227, 227, 227, 0);\n\t\tborder-bottom-color: #e3e3e3;\n\t\tborder-width: 9px;\n\t\tmargin-left: -9px;\n\t}\n\n\tp::before {\n\t\tcontent: '';\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder-radius: 100%;\n\t\tbackground: #50e3c2;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tleft: 12px;\n\t\ttop: 12px;\n\t}\n"])), MyTripTab);
var NavIcon = styled_components_browser_esm["default"].span(_templateObject5$3 || (_templateObject5$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-right: 10px;\n"])));
var NotificationTag = styled_components_browser_esm["default"].div(_templateObject6$3 || (_templateObject6$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 100%;\n\tbackground: #ffea67;\n\tborder: solid 1px #fba707;\n\tfont-size: 10px;\n\tcolor: #000;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: absolute;\n\ttop: 17px;\n\tleft: 12px;\n"])));
styled_components_browser_esm["default"].div(_templateObject7$3 || (_templateObject7$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tbackground: url(https://gos3.ibcdn.com/gocash-1656061010.png);\n\theight: 24px;\n\twidth: 30px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n"])));

var NavWidgets = function NavWidgets(props) {
  var upcomingTrip = props.upcomingTrip,
      isLoggedIn = props.isLoggedIn,
      navOrigin = props.navOrigin,
      lobName = props.lobName;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
      _useAnalytics.pdt;
      var adobe = _useAnalytics.adobe;

  function sendGAEvent(linkName, url) {
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: linkName,
        type: 'itemClick',
        componentName: 'header',
        destination: url
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)("header_click_" + linkName, {
      event_detail: {
        event_type: "click_event|shopper_click",
        event_value: "" + lobName
      }
    });
  }

  var mytrip = W_MY_TRIPS(navOrigin);
  return /*#__PURE__*/react.createElement(NavLink, {
    href: mytrip.url,
    onClick: function onClick() {
      return sendGAEvent('my_trips', mytrip.url);
    }
  }, /*#__PURE__*/react.createElement(MyTripTab, {
    role: "presentation"
  }, /*#__PURE__*/react.createElement(NavIcon, {
    className: "header-sprite " + mytrip.icon
  }), isLoggedIn && upcomingTrip ? /*#__PURE__*/react.createElement(NotificationTag, null, upcomingTrip) : null, /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW2",
    style: {
      color: isLoggedIn ? '#0074eb' : '#666'
    }
  }, mytrip.label), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "BaseW2",
    style: {
      color: '#333'
    }
  }, mytrip.manageBooking))), /*#__PURE__*/react.createElement(Tooltip, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1"
  }, mytrip.tooltip))));
};

/*
 * You can change the LOBS nav item in header by changing the below array
 * item order
 *
 * If you are adding a new LOB in this list, make sure 'HeaderUrlConfig'
 * must have the require config for that new LOB.
 */

var lobsListInOrder = ['FLIGHTS', 'HOTELS', 'TRAINS', 'CABS', 'BUS', 'HOLIDAYS', 'FOREX', 'INSURANCE'];
var lobsPathName = {
  HOME: '/',
  FLIGHTS: '/flights/',
  HOTELS: '/hotels/',
  TRAINS: '/trains/',
  CABS: '/cars/',
  BUS: '/bus/',
  VISA: '/visa/',
  HOLIDAYS: '/giholidays/',
  INSURANCE: '/insurance?cmp=desktop_header',
  FOREX: 'https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=header_goibibo&utm_medium=desktop'
};
var lobOffersPath = {
  flights: 'flight-offers/',
  hotels: 'hotel-offers/',
  cabs: 'gocar-offers/',
  trains: 'train-offers/',
  bus: 'bus-offers/'
};
/*
 * Assuming as LOBs pages will be in `/`  path of origin(https://goibibo.com/<lobpage>) if not then lobs can
 pass navOrigin as prop to replace it.
 eg:
 navOrigin: "https://www.goibibo.com" if header is integrated in subdomain or other domain than goibibo.com
 */
// @private

function getNavListUrls(origin) {
  if (origin === void 0) {
    origin = '';
  }

  var urls = {
    FLIGHTS: {
      URL: origin + lobsPathName.FLIGHTS,
      LABEL: LOBS_NAME.FLIGHTS,
      CATEGORY: LOBS_CATG.FLIGHTS,
      ICON: 'flights' // sprite icons class name

    },
    HOTELS: {
      URL: origin + lobsPathName.HOTELS,
      LABEL: LOBS_NAME.HOTELS,
      CATEGORY: LOBS_CATG.HOTELS,
      ICON: 'hotels'
    },
    TRAINS: {
      URL: origin + lobsPathName.TRAINS,
      LABEL: LOBS_NAME.TRAINS,
      CATEGORY: LOBS_CATG.TRAINS,
      ICON: 'trains'
    },
    CABS: {
      URL: origin + lobsPathName.CABS,
      LABEL: LOBS_NAME.CABS,
      CATEGORY: LOBS_CATG.CABS,
      ICON: 'cabs'
    },
    BUS: {
      URL: origin + lobsPathName.BUS,
      LABEL: LOBS_NAME.BUS,
      CATEGORY: LOBS_CATG.BUS,
      ICON: 'bus'
    },
    VISA: {
      URL: origin + lobsPathName.VISA,
      LABEL: LOBS_NAME.VISA,
      CATEGORY: LOBS_CATG.VISA,
      ICON: 'visa',
      NEW: false
    },
    FOREX: {
      URL: lobsPathName.FOREX,
      LABEL: LOBS_NAME.FOREX,
      CATEGORY: LOBS_CATG.FOREX,
      ICON: 'forex',
      TARGET_BLANK: true
    },
    HOLIDAYS: {
      URL: origin + lobsPathName.HOLIDAYS,
      LABEL: LOBS_NAME.HOLIDAYS,
      CATEGORY: LOBS_CATG.HOLIDAYS,
      ICON: 'holiday',
      TARGET_BLANK: true
    },
    INSURANCE: {
      URL: origin + lobsPathName.INSURANCE,
      LABEL: LOBS_NAME.INSURANCE,
      CATEGORY: LOBS_CATG.INSURANCE,
      ICON: 'insurance',
      TARGET_BLANK: false
    }
  };
  return urls;
}

function generateMainNavList(list, navUrls) {
  var finalList = [];
  list.forEach(function (item) {
    var l = {
      url: navUrls[item].URL,
      path: navUrls[item].PATHNAME,
      label: navUrls[item].LABEL,
      icon: navUrls[item].ICON,
      "new": navUrls[item].NEW || false,
      targetBlank: navUrls[item].TARGET_BLANK || false,
      category: navUrls[item].CATEGORY
    };
    finalList.push(l);
  });
  return finalList;
}

var lobsNavList = function lobsNavList(origin) {
  return generateMainNavList(lobsListInOrder, getNavListUrls(origin));
};

var _templateObject$9, _templateObject2$7, _templateObject3$6;
var AvatarWrap = styled_components_browser_esm["default"].span(_templateObject$9 || (_templateObject$9 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\tborder-radius: 100%;\n\toverflow: hidden;\n\tmargin-right: 5px;\n\n\timg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 50%;\n\t}\n\t", "\n"])), function (_ref) {
  var image = _ref.image;
  return !image ? (0,styled_components_browser_esm.css)(_templateObject2$7 || (_templateObject2$7 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground: linear-gradient(225deg, #ff3e5e, #ff7f3f);\n\t\t\t  "]))) : '';
});
var ProfileNameChar = styled_components_browser_esm["default"].span(_templateObject3$6 || (_templateObject3$6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\tfont-stretch: normal;\n\tfont-style: normal;\n\tletter-spacing: normal;\n\tcolor: #fff;\n\ttext-align: center;\n\tposition: absolute;\n\ttop: 4px;\n"])));

var _templateObject$8, _templateObject2$6, _templateObject3$5, _templateObject4$3;
var placeHolderShimmer = (0,styled_components_browser_esm.keyframes)(_templateObject$8 || (_templateObject$8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n0% {\n\tbackground-position: -468px 0;\n}\n\n100% {\n\tbackground-position: 468px 0;\n}\n"])));
var Shimmer = styled_components_browser_esm["default"].div(_templateObject2$6 || (_templateObject2$6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tanimation-duration: 1s;\n\tanimation-fill-mode: forwards;\n\tanimation-iteration-count: infinite;\n\tanimation-name: ", ";\n\tanimation-timing-function: linear;\n\tbackground: #f6f7f8;\n\tbackground: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);\n\tbackground-size: 800px 104px;\n\tposition: relative;\n"])), placeHolderShimmer);
var HorizontalShimmer = (0,styled_components_browser_esm["default"])(Shimmer)(_templateObject3$5 || (_templateObject3$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 80%;\n\theight: 15px;\n"])));
var CircularShimmer = (0,styled_components_browser_esm["default"])(Shimmer)(_templateObject4$3 || (_templateObject4$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tborder-radius: 50%;\n\twidth: 30px;\n\theight: 30px;\n"])));

var UserAvatar = function UserAvatar(props) {
  var image = props.image,
      firstName = props.firstName,
      isLoggedIn = props.isLoggedIn,
      loading = props.loading;
  var getNameFirstChar = (0,react.useCallback)(function () {
    return getUserNameInitials(firstName);
  }, [firstName]);

  if (isLoggedIn) {
    return /*#__PURE__*/react.createElement(AvatarWrap, {
      image: image
    }, image ? /*#__PURE__*/react.createElement("img", {
      src: image,
      style: {
        objectFit: 'cover'
      },
      alt: getNameFirstChar()
    }) : /*#__PURE__*/react.createElement(ProfileNameChar, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
      size: "MediumW3"
    }, getNameFirstChar())));
  }

  if (loading) {
    return /*#__PURE__*/react.createElement(CircularShimmer, null);
  }

  if (image) {
    return /*#__PURE__*/react.createElement(AvatarWrap, {
      image: image
    }, /*#__PURE__*/react.createElement("img", {
      src: image,
      style: {
        objectFit: 'cover'
      },
      alt: "avatar"
    }));
  }

  return /*#__PURE__*/react.createElement("span", {
    className: "header-sprite user-icon",
    style: {
      marginRight: '5px'
    }
  });
};

var _templateObject$7, _templateObject2$5, _templateObject3$4, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;
var LoginDropdown = styled_components_browser_esm["default"].div(_templateObject$7 || (_templateObject$7 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tbackground: #fff;\n\tborder: 1px solid #e3e3e3;\n\tborder-radius: 8px;\n\tbox-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);\n\twidth: 250px;\n\tpadding: 10px 20px;\n\tfont-size: 12px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tz-index: 1000;\n\tcolor: #46484d;\n"])));
styled_components_browser_esm["default"].div(_templateObject2$5 || (_templateObject2$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tflex-direction: column;\n\talign-items: flex-start !important;\n"])));
styled_components_browser_esm["default"].div(_templateObject3$4 || (_templateObject3$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-bottom: 1px !important;\n\tcolor: #4e525b;\n"])));
styled_components_browser_esm["default"].div(_templateObject4$2 || (_templateObject4$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcolor: #4e525b;\n\tmargin-bottom: 12px !important;\n"])));
var DropdownListItem = styled_components_browser_esm["default"].a(_templateObject5$2 || (_templateObject5$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: solid 1px #efefef;\n\tpadding: 8px 0;\n\tcursor: pointer;\n\tcolor: #46484d !important;\n\t&:first-of-type {\n\t\tborder-bottom: 0;\n\t}\n\t&:last-of-type {\n\t\tborder-bottom: 0;\n\t}\n\t&:visited {\n\t\tcolor: #46484d;\n\t}\n"])));
var DropdownLoginWrap = styled_components_browser_esm["default"].li(_templateObject6$2 || (_templateObject6$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tlist-style: none;\n\tmargin: 8px 0px;\n"])));
var DropdownLinkUser = styled_components_browser_esm["default"].a(_templateObject7$2 || (_templateObject7$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n"])));
var DropdownLink = styled_components_browser_esm["default"].a(_templateObject8$1 || (_templateObject8$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n"])));
var DropdownLinkWrapLoyalty = styled_components_browser_esm["default"].div(_templateObject9$1 || (_templateObject9$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
styled_components_browser_esm["default"].a(_templateObject10$1 || (_templateObject10$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcolor: #2276e3;\n"])));
styled_components_browser_esm["default"].div(_templateObject11$1 || (_templateObject11$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\n\timg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 50%;\n\t}\n"])));
styled_components_browser_esm["default"].div(_templateObject12$1 || (_templateObject12$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 22px;\n\theight: 22px;\n\ttop: 1px;\n\tfont-size: 14px;\n"])));
styled_components_browser_esm["default"].div(_templateObject13 || (_templateObject13 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\theight: 8px;\n\twidth: 32px;\n\tdisplay: inline-block;\n\tbackground: #e3e3e3;\n"])));
var DropdownMenuWrap = styled_components_browser_esm["default"].div(_templateObject14 || (_templateObject14 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tflex: 1;\n"])));
var DropdownSprite = styled_components_browser_esm["default"].div(_templateObject15 || (_templateObject15 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-right: 20px;\n"])));
var LoginButton = styled_components_browser_esm["default"].button(_templateObject16 || (_templateObject16 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 36px;\n\tborder-radius: 8px;\n\tbackground-color: #2276e3;\n\t", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: #fff;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);
var ProfileItemWrap = styled_components_browser_esm["default"].div(_templateObject17 || (_templateObject17 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tflex: 1 1 0%;\n\tmargin-left: 8px;\n"])));
var ItemLabel = styled_components_browser_esm["default"].p(_templateObject18 || (_templateObject18 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tmargin-bottom: 3px;\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);
var ItemSubLabel = styled_components_browser_esm["default"].p(_templateObject19 || (_templateObject19 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #4e525b;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);

var DropDownItemUserProfile = function DropDownItemUserProfile(_ref) {
  var onViewProfileClick = _ref.onViewProfileClick,
      userImage = _ref.userImage,
      fullName = _ref.fullName,
      isLoggedIn = _ref.isLoggedIn,
      onLoginCtaClick = _ref.onLoginCtaClick,
      navOrigin = _ref.navOrigin;
  var dropDownList = W_USER_PROFILE_DROPDOWN(navOrigin);
  return /*#__PURE__*/react.createElement(DropdownLoginWrap, null, !isLoggedIn ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "MediumW2",
    style: {
      marginBottom: '1px',
      color: '#4e525b'
    }
  }, dropDownList.login.label), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1",
    style: {
      marginBottom: '12px',
      color: '#4e525b'
    }
  }, dropDownList.login.subLabel), /*#__PURE__*/react.createElement(LoginButton, {
    onClick: function onClick() {
      return onLoginCtaClick('login-cta-dropdown');
    },
    type: "button"
  }, dropDownList.login.ctaText)) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(DropdownLinkUser, {
    href: dropDownList.view_profile.url,
    onClick: onViewProfileClick
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: userImage,
    firstName: fullName,
    isLoggedIn: true
  }), /*#__PURE__*/react.createElement(ProfileItemWrap, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#4e525b",
    size: "MediumW2",
    style: {
      marginBottom: '3px',
      textTransform: 'capitalize'
    }
  }, fullName), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1",
    style: {
      color: '#2276e3'
    }
  }, dropDownList.view_profile.label, ' ')))));
};

var _templateObject$6, _templateObject2$4, _templateObject3$3;
var HappyGiHeader = styled_components_browser_esm["default"].header(_templateObject$6 || (_templateObject$6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tbackground: #fff;\n\tdisplay: flex !important;\n\talign-items: center;\n\tpadding: 0px 32px 0 0;\n\tbox-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n\tz-index: 900;\n\tposition: relative;\n\theight: 64px;\n\n\t&.header-sticky {\n\t\tposition: fixed !important;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n\n\t.logo {\n\t\tmargin-right: 35px;\n\t}\n\n\t@media (max-width: 640px) {\n\t\tdisplay: none !important;\n\t}\n"])));
var LoginWidgetWrapper = styled_components_browser_esm["default"].div(_templateObject2$4 || (_templateObject2$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: auto;\n"])));
var GotribeBadge$1 = styled_components_browser_esm["default"].span(_templateObject3$3 || (_templateObject3$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin: 0 0 0 2px;\n\tpadding: 1px 5px 1px 5px;\n\tborder-radius: 7px;\n\tbackground-image: ", ";\n\tcolor: #fff;\n\t", "\n"])), function (_ref) {
  var memberType = _ref.memberType;
  return memberType === GOTRIBE_MEMBER_TYPES.superstar.value ? 'linear-gradient(to right, #e63148 40%, #ff4e00)' : 'linear-gradient(to right, #fa961a 19%, #ffb305 95%)';
}, growth_design_system_esm/* textSizes.SmallW3 */.iH.SmallW3);

var DropDownItemLoyalty = function DropDownItemLoyalty(_ref) {
  var _ref$control = _ref.control,
      control = _ref$control === void 0 ? true : _ref$control,
      memberType = _ref.memberType,
      navOrigin = _ref.navOrigin,
      sendEvent = _ref.sendEvent;
  var dropDownList = W_USER_PROFILE_DROPDOWN(navOrigin);

  var _useState = (0,react.useState)(true),
      show = _useState[0],
      setShow = _useState[1];
  /* GROW-2765
   * to check blacklist gotribe option
   * control true blacklist, control false normal user
   * if there is no cards then it's a control/whitlisted gotribeuser
   */


  (0,react.useEffect)(function () {
    setShow(!!control);
  }, [control]);
  if (!show) return /*#__PURE__*/react.createElement(react.Fragment, null);
  return /*#__PURE__*/react.createElement(DropdownListItem, {
    as: "span"
  }, /*#__PURE__*/react.createElement(DropdownLink, {
    href: dropDownList.gotTribe.url,
    onClick: function onClick() {
      return sendEvent({
        link: 'go_tribe',
        memberType: memberType
      });
    }
  }, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + dropDownList.gotTribe.icon
  }), /*#__PURE__*/react.createElement(DropdownMenuWrap, null, /*#__PURE__*/react.createElement(DropdownLinkWrapLoyalty, null, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + dropDownList.gotTribe.goTribeIcon,
    style: {
      marginLeft: 0,
      marginRight: 0
    }
  }), memberType !== GOTRIBE_MEMBER_TYPES.non_member.value && /*#__PURE__*/react.createElement(GotribeBadge$1, {
    memberType: memberType
  }, GOTRIBE_MEMBER_TYPES[memberType].label)), /*#__PURE__*/react.createElement(ItemSubLabel, null, memberType !== GOTRIBE_MEMBER_TYPES.non_member.value ? dropDownList.gotTribe.subLabel.member : dropDownList.gotTribe.subLabel.nonMember))));
};

var DropDownItemGeneric = function DropDownItemGeneric(_ref) {
  var sendEvent = _ref.sendEvent,
      listItem = _ref.listItem,
      itemChild = _ref.itemChild;
  var url = listItem.url,
      label = listItem.label,
      subLabel = listItem.subLabel,
      icon = listItem.icon;
  return /*#__PURE__*/react.createElement(DropdownListItem, {
    href: url,
    onClick: function onClick() {
      return sendEvent({
        link: label
      });
    }
  }, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + icon
  }), /*#__PURE__*/react.createElement(DropdownMenuWrap, null, /*#__PURE__*/react.createElement(ItemLabel, null, label), /*#__PURE__*/react.createElement(ItemSubLabel, null, itemChild || subLabel)));
};

DropDownItemGeneric.defaultProps = {
  itemChild: undefined
};

var UserDropDown = function UserDropDown(props) {
  var _loyaltyUserInfoData$;

  var userInfo = props.userInfo,
      hideDropDown = props.hideDropDown,
      memberType = props.memberType,
      upcomingTripCount = props.upcomingTripCount,
      isLoggedIn = props.isLoggedIn,
      _onLoginCtaClick = props.onLoginCtaClick,
      lobName = props.lobName,
      navOrigin = props.navOrigin,
      positionStyle = props.positionStyle;
  var dropDownList = W_USER_PROFILE_DROPDOWN(navOrigin);
  var loyaltyUserInfoData = useLoyaltyUserInfoStore(function (s) {
    return s.data;
  }, shallow/* shallow */.X);

  var _useGoCashBalanceStor = useGoCashBalanceStore(),
      gocashData = _useGoCashBalanceStor.data,
      gocashLoading = _useGoCashBalanceStor.loading;

  var balance = gocashData.balance;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;
  /* GROW-2765
   * to check blacklist gotribe option
   * control true blacklist, control false normal user
   * if there is no cards then it's a control/whitlisted gotribeuser
   */


  var control = loyaltyUserInfoData == null ? void 0 : (_loyaltyUserInfoData$ = loyaltyUserInfoData.cards) == null ? void 0 : _loyaltyUserInfoData$.length;

  var handleOutsideClick = function handleOutsideClick(e) {
    var el = e.target;
    var dropdownContainer = el.closest('ul.login__dropdown');

    if (!dropdownContainer) {
      hideDropDown();
    }
  };

  var sendEvent = function sendEvent(eventObj) {
    pdt.track('HAPPY_HEADER_WEBA__CLICK_DROPDOWN_LINK', {
      item_selected: eventObj.link
    });
    adobe.track('ctaClick', {
      cta: {
        name: eventObj.link,
        type: 'itemClick',
        componentName: 'Header Dropdown'
      }
    });
  };

  var handleViewProfile = function handleViewProfile() {
    sendEvent({
      link: 'view_profile'
    });
  };

  (0,react.useEffect)(function () {
    document.addEventListener('click', handleOutsideClick);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  var getOffersUrl = function getOffersUrl() {
    var offersUrl = dropDownList.offers.url;

    if (lobName && lobOffersPath[lobName]) {
      return "" + offersUrl + lobOffersPath[lobName];
    }

    return offersUrl;
  };

  var fullName = userInfo != null && userInfo.firstName ? (userInfo == null ? void 0 : userInfo.firstName) + " " + ((userInfo == null ? void 0 : userInfo.lastName) || '') : DEFAULT_PROFILE_NAME;
  return /*#__PURE__*/react.createElement(LoginDropdown, {
    style: positionStyle,
    "data-id": "header-dropdown"
  }, /*#__PURE__*/react.createElement(DropDownItemUserProfile, {
    onViewProfileClick: handleViewProfile,
    userImage: userInfo == null ? void 0 : userInfo.profileImage,
    fullName: fullName,
    isLoggedIn: isLoggedIn,
    onLoginCtaClick: function onLoginCtaClick() {
      return _onLoginCtaClick({
        name: 'login-cta-dropdown',
        componentName: 'Header Dropdown'
      });
    },
    navOrigin: navOrigin
  }), /*#__PURE__*/react.createElement(DropDownItemLoyalty, {
    control: control,
    memberType: memberType,
    navOrigin: navOrigin,
    sendEvent: sendEvent
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: growth_dweb_header_esm_extends({}, dropDownList.offers, {
      url: getOffersUrl()
    })
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: dropDownList.myTrips,
    itemChild: /*#__PURE__*/react.createElement(react.Fragment, null, upcomingTripCount ? upcomingTripCount + "\n                " + (upcomingTripCount > 1 ? dropDownList.myTrips.subLabel.plural : dropDownList.myTrips.subLabel.singular) : 'Manage your bookings')
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: dropDownList.goCash,
    itemChild: /*#__PURE__*/react.createElement(react.Fragment, null, isLoggedIn ? /*#__PURE__*/react.createElement(react.Fragment, null, dropDownList.goCash.subLabel, /*#__PURE__*/react.createElement("span", {
      className: "gr-bold"
    }, gocashLoading ? /*#__PURE__*/react.createElement("span", {
      className: "gocashLoading"
    }) : /*#__PURE__*/react.createElement(react.Fragment, null, W_RUPEE_SIGN, balance))) : /*#__PURE__*/react.createElement(react.Fragment, null, dropDownList.goCash.subLabelGuest))
  }));
};

var _templateObject$5, _templateObject2$3, _templateObject3$2, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
var LoginTab = styled_components_browser_esm["default"].div(_templateObject$5 || (_templateObject$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 186px;\n\tposition: relative;\n\theight: 44px;\n\tbackground-color: #fff;\n\ttransition: all 0.4s ease;\n\n\t.gr-user {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 100%;\n\t\toverflow: hidden;\n\n\t\timg {\n\t\t\twidth: 28px;\n\t\t\theight: 28px;\n\t\t\tborder-radius: 50%;\n\t\t}\n\n\t\t&.name__text {\n\t\t\tbackground-image: linear-gradient(225deg, #ff3e5e, #ff7f3f);\n\t\t\tfont-size: 16px;\n\t\t\tcolor: #fff;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n\n\t.you-are {\n\t\tvertical-align: bottom;\n\t}\n\n\t.horizontal_shimmer {\n\t\tmargin-left: 12px;\n\t}\n"])));
var UserNameWrap = styled_components_browser_esm["default"].div(_templateObject2$3 || (_templateObject2$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);
var UserNameText = styled_components_browser_esm["default"].span(_templateObject3$2 || (_templateObject3$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmax-width: 70px;\n\tvertical-align: bottom !important;\n\ttext-transform: capitalize;\n\tmargin-left: 4px;\n"])));
var LoginTabWrapper = styled_components_browser_esm["default"].div(_templateObject4$1 || (_templateObject4$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 100%;\n\tborder-radius: 8px;\n\tborder: solid 1px #2276e3;\n\tpadding: 0 8px;\n\tcursor: pointer;\n    overflow: hidden;\n"])));
var ScrollItemWrap = styled_components_browser_esm["default"].div(_templateObject5$1 || (_templateObject5$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var SignUpCtaTextWrap = styled_components_browser_esm["default"].div(_templateObject6$1 || (_templateObject6$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose([""])));
styled_components_browser_esm["default"].div(_templateObject7$1 || (_templateObject7$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 1px;\n\theight: 29px;\n\tborder-right: solid 1px #eff3f8;\n"])));
styled_components_browser_esm["default"].div(_templateObject8 || (_templateObject8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin: 0 0 0 2px;\n\tpadding: 1px 5px 2px 5px;\n\tborder-radius: 7px;\n\tcolor: #fff;\n\tfont-size: 8px;\n\tbackground-image: linear-gradient(to right, #e63148 40%, #ff4e00);\n\n\t&.super {\n\t\tbackground-image: linear-gradient(to right, #fa961a 19%, #ffb305 95%);\n\t}\n"])));
styled_components_browser_esm["default"].div(_templateObject9 || (_templateObject9 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tmax-width: 50px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
styled_components_browser_esm["default"].div(_templateObject10 || (_templateObject10 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmax-width: 70px;\n\tvertical-align: bottom !important;\n"])));
styled_components_browser_esm["default"].div(_templateObject11 || (_templateObject11 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\theight: 24px;\n\twidth: 24px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\tmargin-right: 2px;\n\tmargin-left: 4px;\n"])));
var ArrowIcon = styled_components_browser_esm["default"].div(_templateObject12 || (_templateObject12 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tborder: solid #2274e0;\n\tborder-width: 0 2px 2px 0;\n\tdisplay: inline-block;\n\tpadding: 2px;\n\tmargin-left: auto;\n\n\t&.right {\n\t\ttransform: rotate(-45deg);\n\t\t-webkit-transform: rotate(-45deg);\n\t}\n\n\t&.left {\n\t\ttransform: rotate(135deg);\n\t\t-webkit-transform: rotate(135deg);\n\t}\n\n\t&.up {\n\t\ttransform: rotate(-135deg);\n\t\t-webkit-transform: rotate(-135deg);\n\t}\n\n\t&.down {\n\t\ttransform: rotate(45deg);\n\t\t-webkit-transform: rotate(45deg);\n\t}\n"])));

var _templateObject$4, _templateObject2$2, _templateObject3$1;
var MainWrapper = styled_components_browser_esm["default"].div(_templateObject$4 || (_templateObject$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n    position: relative;\n    overflow: hidden;\n    width: 100vw;\n    max-width: 100%;\n"])));
var List = styled_components_browser_esm["default"].ul(_templateObject2$2 || (_templateObject2$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  /* overflow: hidden; */\n  transform: ", ";\n    transition: transform 300ms ease-in-out;\n    -webkit-transition: transform 300ms ease-in-out;\n"])), function (props) {
  return "translateY(-" + props.height + ")";
});
var ListItem = styled_components_browser_esm["default"].li(_templateObject3$1 || (_templateObject3$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  width: 200px;\n"])));

var Carousal = function Carousal(_ref) {
  var _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      contentHeight = _ref.contentHeight,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? false : _ref$loop,
      _ref$loopCount = _ref.loopCount,
      loopCount = _ref$loopCount === void 0 ? 1 : _ref$loopCount;
  var listCount = list.length;
  var listRef = (0,react.useRef)(null);
  var positionRef = (0,react.useRef)(-contentHeight);
  var duration = 0.5;
  var endPosition = listCount * -contentHeight;
  var RotationCount = (0,react.useRef)(1);
  var timeoutId = (0,react.useRef)();

  function nextSlide() {
    if (!listRef.current) {
      return;
    }

    positionRef.current -= contentHeight;

    if (listRef.current) {
      listRef.current.style.transform = "translateY(" + positionRef.current + "px)";
      listRef.current.style.transitionDuration = duration + "s";
    }
  }

  function rotateSlide() {
    if (!listRef.current) {
      return;
    }

    positionRef.current = -contentHeight;
    setTimeout(function () {
      if (listRef.current) {
        listRef.current.style.transform = "translateY(-" + contentHeight + "px)";
        listRef.current.style.transitionDuration = '0s';
      }
    }, 1000);
  }

  var rotate = function rotate() {
    if (!listRef.current) {
      return;
    }

    if (positionRef.current === endPosition) {
      nextSlide();
      rotateSlide();
      RotationCount.current += 1;
    } else {
      nextSlide();
    }

    if (RotationCount.current <= loopCount) {
      timeoutId.current = setTimeout(function () {
        rotate();
      }, 2000);
    }
  };

  (0,react.useEffect)(function () {
    // if list length is greater than 1 and loop is true make loop 2 times otherwise only once
    if (listCount > 1) {
      if (loop) {
        timeoutId.current = setTimeout(function () {
          rotate();
        }, 2000);
      } else {
        timeoutId.current = setTimeout(function () {
          rotate();
        }, 2000);
      }
    }

    return function () {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  }, [loop, listCount]);

  var isTextItem = function isTextItem(item) {
    return typeof item === 'object' && 'text' in item;
  };

  var lastItem = list[listCount - 1];
  var firstItem = list[0];
  return /*#__PURE__*/react.createElement(MainWrapper, {
    style: {
      height: contentHeight + "px"
    }
  }, /*#__PURE__*/react.createElement(List, {
    ref: listRef,
    height: contentHeight + "px"
  }, /*#__PURE__*/react.createElement(ListItem, {
    style: {
      height: contentHeight + "px"
    }
  }, isTextItem(lastItem) ? lastItem.text : /*#__PURE__*/react.createElement(lastItem.component, lastItem.props)), list.map(function (item, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      react.createElement(ListItem, {
        key: "txt_para_" + index,
        style: {
          height: contentHeight + "px"
        }
      }, isTextItem(item) ? item.text : /*#__PURE__*/react.createElement(item.component, item.props))
    );
  }), /*#__PURE__*/react.createElement(ListItem, {
    style: {
      height: contentHeight + "px"
    }
  }, isTextItem(firstItem) ? firstItem.text : /*#__PURE__*/react.createElement(firstItem.component, firstItem.props))));
};

var GuestDetails = function GuestDetails() {
  var contentToScroll = [].concat(W_LOGIN_WIDGET_CTA);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(UserAvatar, null), /*#__PURE__*/react.createElement(SignUpCtaTextWrap, {
    role: "presentation",
    id: "get_sign_in"
  }, /*#__PURE__*/react.createElement(Carousal, {
    list: contentToScroll,
    contentHeight: 16,
    loop: false,
    loopCount: 1
  })));
};

var _templateObject$3, _templateObject2$1;
var GotribeInfoWrap = styled_components_browser_esm["default"].div(_templateObject$3 || (_templateObject$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var GotribeBadge = styled_components_browser_esm["default"].span(_templateObject2$1 || (_templateObject2$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin: 0 0 0 2px;\n\tpadding: 1px 5px 2px 5px;\n\tborder-radius: 7px;\n\tbackground-image: ", ";\n\n\tcolor: #fff;\n\t", "\n"])), function (_ref) {
  var memberType = _ref.memberType;
  return memberType === GOTRIBE_MEMBER_TYPES.superstar.value ? 'linear-gradient(to right, #fa961a 19%, #ffb305 95%)' : 'linear-gradient(to right, #e63148 40%, #ff4e00)';
}, growth_design_system_esm/* textSizes.SmallW3 */.iH.SmallW3);

var GoTribeMember = function GoTribeMember(props) {
  var memberType = props.memberType;
  return /*#__PURE__*/react.createElement(react.Fragment, null, isGoTribeMember(memberType) ? /*#__PURE__*/react.createElement(GotribeInfoWrap, null, /*#__PURE__*/react.createElement("span", {
    className: "dropdown-sprite gotribeLogo"
  }), /*#__PURE__*/react.createElement(GotribeBadge, {
    memberType: memberType
  }, GOTRIBE_MEMBER_TYPES[memberType].label)) : null);
};

var UserDetails = function UserDetails(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
      loading = _ref.loading,
      profileImage = _ref.profileImage,
      firstName = _ref.firstName,
      loyaltyMemberType = _ref.loyaltyMemberType;
  return /*#__PURE__*/react.createElement(ScrollItemWrap, {
    style: {
      height: '32px'
    }
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: profileImage,
    firstName: firstName,
    isLoggedIn: isLoggedIn,
    loading: loading
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(UserNameWrap, null, /*#__PURE__*/react.createElement("span", null, "Hey"), /*#__PURE__*/react.createElement(UserNameText, null, firstName)), /*#__PURE__*/react.createElement(GoTribeMember, {
    memberType: loyaltyMemberType
  })));
};

var GocashDetails = function GocashDetails(_ref) {
  var balance = _ref.balance,
      gocashLoading = _ref.gocashLoading;
  return /*#__PURE__*/react.createElement(ScrollItemWrap, {
    style: {
      height: '32px'
    }
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: "https://go-assets.ibcdn.com/u/GI/images/1710408879842-gocash-gold.png"
  }), /*#__PURE__*/react.createElement(UserNameWrap, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#000",
    size: "SmallW2"
  }, "Gocash"), !gocashLoading && /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#717171",
    size: "SmallW1",
    as: "span"
  }, "Balance:", /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#717171",
    size: "SmallW3",
    as: "span"
  }, "\u20B9", balance))));
};

var LoggedInDetails = function LoggedInDetails(_ref) {
  var loading = _ref.loading,
      profileImage = _ref.profileImage,
      firstName = _ref.firstName,
      loyaltyMemberType = _ref.loyaltyMemberType;

  var _useGoCashBalanceStor = useGoCashBalanceStore(),
      gocashData = _useGoCashBalanceStor.data,
      gocashLoaded = _useGoCashBalanceStor.loaded,
      gocashLoading = _useGoCashBalanceStor.loading,
      gocashError = _useGoCashBalanceStor.error;

  var balance = gocashData.balance;
  var content = [{
    component: UserDetails,
    props: {
      isLoggedIn: true,
      firstName: firstName,
      loading: loading,
      profileImage: profileImage,
      loyaltyMemberType: loyaltyMemberType
    }
  }];
  /* add items in animation content */
  // Gocash

  if (gocashLoaded && !gocashError) {
    content.push({
      component: GocashDetails,
      props: {
        balance: balance,
        gocashLoading: gocashLoading
      }
    });
  }

  var contentToScroll = [].concat(content);
  return /*#__PURE__*/react.createElement(Carousal, {
    list: contentToScroll,
    contentHeight: 32,
    loop: true,
    loopCount: 2
  });
};

var UserLoginWidget = function UserLoginWidget(props) {
  var _useProfileStore = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return {
      $userDetails: s.data,
      loading: s.loading
    };
  }, shallow/* shallow */.X),
      $userDetails = _useProfileStore.$userDetails,
      loading = _useProfileStore.loading;

  var showLogin = props.showLogin,
      onLogoutSuccess = props.onLogoutSuccess,
      reloadAfterLogout = props.reloadAfterLogout,
      isLoginPopoverVisible = props.isLoginPopoverVisible,
      lobName = props.lobName,
      navOrigin = props.navOrigin,
      upComingTripCounts = props.upComingTripCounts;

  var _useState = (0,react.useState)(false),
      showUserDropDown = _useState[0],
      updateShowUserDropDown = _useState[1];

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
      _useAnalytics.pdt;
      var adobe = _useAnalytics.adobe;

  (0,react.useRef)('');
  var dropDownTimer;
  var hasMounted = (0,growth_custom_hooks_useHasMounted_esm/* useHasMounted */.f)();
  var loyaltyUserInfoData = useLoyaltyUserInfoStore(function (s) {
    return s.data;
  });
  var loyaltyMemberType = selectLoyaltyMemberType(loyaltyUserInfoData);

  var handleLogout = function handleLogout() {
    updateShowUserDropDown(false);
    (0,growth_auth_helpers_esm/* fetchLogoutUser */.hM)({
      platform: 'dweb'
    }).then(function () {
      updateShowUserDropDown(false);
      growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT_SUCCESS);

      if (onLogoutSuccess) {
        growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT_SUCCESS);
        onLogoutSuccess();
      } else if (reloadAfterLogout) window.location.reload();
    });
  };

  (0,react.useEffect)(function () {
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT, function () {
      handleLogout();
    });
    return function () {
      return growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT, function () {
        handleLogout();
      });
    };
  }, []);
  var toggleUserDropDown = (0,react.useCallback)(function () {
    updateShowUserDropDown(!showUserDropDown);
  }, [showUserDropDown]);

  var handleOnLoginWidgetClick = function handleOnLoginWidgetClick(_ref) {
    var name = _ref.name,
        componentName = _ref.componentName;
    if (loading) return;

    if (!$userDetails.isLoggedIn) {
      (0,growth_pdt_push_esm/* pdtPush */.g)("header_click_login_btn", {
        event_detail: {
          event_type: "click_event",
          event_value: lobName
        }
      });
      adobe.track('ctaClick', {
        cta: {
          name: "" + name,
          type: 'itemClick',
          componentName: componentName
        }
      });
      showLogin();
    } else {
      (0,growth_pdt_push_esm/* pdtPush */.g)("header_click_nav_widget", {
        event_detail: {
          event_type: "click_event|shopper_click",
          event_value: lobName + "|" + name
        }
      });
      toggleUserDropDown();
    }
  }; // using this function to show dropdown on hover


  var showDropDown = function showDropDown() {
    if (!isLoginPopoverVisible && !loading) {
      clearTimeout(dropDownTimer);
      updateShowUserDropDown(true);
    }
  }; // function to hide dropdown on mouse leave and
  // adding delay so that when mouse leave user can focus on dropdown list


  var hideDropDown = function hideDropDown() {
    dropDownTimer = setTimeout(function () {
      if (!loading) {
        updateShowUserDropDown(false);
      }
    }, 200);
  };

  var firstName = ($userDetails == null ? void 0 : $userDetails.firstName) || DEFAULT_PROFILE_NAME;
  return /*#__PURE__*/react.createElement(LoginTab, {
    onFocus: showDropDown,
    onMouseOver: showDropDown,
    onMouseLeave: hideDropDown,
    "data-id": "user-info-tab"
  }, /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LoginTabWrapper, {
    role: "presentation",
    onClick: function onClick() {
      return handleOnLoginWidgetClick({
        name: 'login',
        componentName: 'header'
      });
    }
  }, !hasMounted || loading ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(CircularShimmer, null), /*#__PURE__*/react.createElement(HorizontalShimmer, null)) : /*#__PURE__*/react.createElement(react.Fragment, null, $userDetails.isLoggedIn ? /*#__PURE__*/react.createElement(LoggedInDetails, {
    loading: loading,
    profileImage: $userDetails == null ? void 0 : $userDetails.profileImage,
    firstName: firstName,
    loyaltyMemberType: loyaltyMemberType
  }) : /*#__PURE__*/react.createElement(GuestDetails, null), /*#__PURE__*/react.createElement(ArrowIcon, {
    className: "" + (showUserDropDown ? 'up' : 'down')
  }))), showUserDropDown && /*#__PURE__*/react.createElement(UserDropDown, {
    lobName: lobName,
    handleLogout: handleLogout,
    userInfo: $userDetails,
    isLoggedIn: $userDetails.isLoggedIn,
    hideDropDown: function hideDropDown() {
      return updateShowUserDropDown(false);
    },
    memberType: loyaltyMemberType,
    upcomingTripCount: upComingTripCounts,
    onLoginCtaClick: handleOnLoginWidgetClick,
    navOrigin: navOrigin,
    positionStyle: {
      top: '53px',
      left: '-66px'
    }
  })));
};

var _templateObject$2, growth_dweb_header_esm_templateObject2, growth_dweb_header_esm_templateObject3, growth_dweb_header_esm_templateObject4, growth_dweb_header_esm_templateObject5, _templateObject6, _templateObject7;
var bounce = (0,styled_components_browser_esm.keyframes)(_templateObject$2 || (_templateObject$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-30px);\n  }\n  60% {\n    transform: translateY(-15px);\n  }\n"])));
var HappyLsPop = styled_components_browser_esm["default"].div(growth_dweb_header_esm_templateObject2 || (growth_dweb_header_esm_templateObject2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 250px;\n\tposition: absolute;\n\ttop: 65px;\n\tright: 60px;\n\tpadding: 15px 10px;\n\tborder-radius: 10px;\n\tbox-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);\n\tbackground-color: #fff;\n\tz-index: 11;\n\tanimation: ", " 2s 2;\n\n\t&::after {\n\t\tbottom: 100%;\n\t\tleft: 90%;\n\t\tborder: solid transparent;\n\t\tcontent: '';\n\t\theight: 0;\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t\tborder-color: rgba(255, 255, 255, 0);\n\t\tborder-bottom-color: #fff;\n\t\tborder-width: 8px;\n\t\tmargin-left: -8px;\n\t}\n"])), bounce);
var LsPopOffer = styled_components_browser_esm["default"].div(growth_dweb_header_esm_templateObject3 || (growth_dweb_header_esm_templateObject3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tpadding: 11px 10px;\n\tborder-radius: 8px;\n\tbackground-color: rgba(80, 227, 194, 0.1);\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 7px 0 0;\n"])));
var LsPopOfferIcon = styled_components_browser_esm["default"].div(growth_dweb_header_esm_templateObject4 || (growth_dweb_header_esm_templateObject4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\tflex-shrink: 0;\n\tmargin-right: 16px;\n\n\timg {\n\t\tmax-width: 100%;\n\t}\n"])));
var LsPopOfferTitle = styled_components_browser_esm["default"].div(growth_dweb_header_esm_templateObject5 || (growth_dweb_header_esm_templateObject5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcolor: #268570;\n\tfont-size: 14px;\n\n\t> span:nth-child(1) {\n\t\tvertical-align: middle;\n\t}\n"])));
var LsPopOfferSubtitle = styled_components_browser_esm["default"].div(_templateObject6 || (_templateObject6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tmargin-top: 3px;\n"])));
var SignUpButton = styled_components_browser_esm["default"].button(_templateObject7 || (_templateObject7 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 36px;\n\tborder-radius: 8px;\n\tbackground-color: #2276e3;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\t", ";\n\n\t&:hover {\n\t\tcolor: #fff;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);

var LoginSignupPopup = function LoginSignupPopup(_ref) {
  var _persuationsText$sign;

  var onLogin = _ref.onLogin,
      closePopOver = _ref.closePopOver,
      persuationsText = _ref.persuationsText;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  function closePopup(event) {
    if (!event.target.closest('.happy-lsPop')) {
      if (closePopOver) closePopOver();
    }
  }

  (0,react.useEffect)(function () {
    /**
     * this listeners check if popover is shown then if click is outside the popover
     * it closes the popover
     */
    document.addEventListener('click', closePopup);
    pdt.track('growth_non_int_HEADER_POPOVER_LOGIN_VISIBLES');
    return function () {
      document.removeEventListener('click', closePopup);
    };
  }, []);

  var handleCtaClick = function handleCtaClick() {
    pdt.track('growth_int_HEADER_POPOVER_CTA_CLICK');
    adobe.track('ctaClick', {
      cta: {
        name: "Login Popover",
        type: 'itemClick',
        componentName: 'Login Popover',
        destination: 'Login Popup'
      }
    });
    onLogin();
  };

  return /*#__PURE__*/react.createElement(HappyLsPop, {
    "data-id": "header-popover"
  }, /*#__PURE__*/react.createElement(SignUpButton, {
    onClick: handleCtaClick,
    type: "button"
  }, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "BaseW2"
  }, persuationsText == null ? void 0 : (_persuationsText$sign = persuationsText.signUp) == null ? void 0 : _persuationsText$sign.ctaText)), /*#__PURE__*/react.createElement(LsPopOffer, null, /*#__PURE__*/react.createElement(LsPopOfferIcon, null, /*#__PURE__*/react.createElement("img", {
    src: "https://gos3.ibcdn.com/login-gift-1607962961.png",
    alt: "Offer"
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(LsPopOfferTitle, null, /*#__PURE__*/react.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: persuationsText == null ? void 0 : persuationsText.title
    }
  })), /*#__PURE__*/react.createElement(LsPopOfferSubtitle, null, persuationsText == null ? void 0 : persuationsText.subTitle))));
};

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ErrorBoundary, _Component);

  function ErrorBoundary(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }

  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  };

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {// You can also log the error to an error reporting service
    // console.log('Error', error, errorInfo)
  };

  _proto.render = function render() {
    var hasError = this.state.hasError;
    var children = this.props.children;

    if (hasError) {
      // You can render any custom fallback UI
      return null;
    }

    return children;
  };

  return ErrorBoundary;
}(react.Component);

/** Create a new configStore instance for desktop header */

var useConfigStore = (0,growth_config_store_browser_esm/* createConfigStore */.Ao)();

var hasTimeExpired = function hasTimeExpired(expDate) {
  var xDate = new Date(expDate);

  if (!Number.isNaN(xDate.getDate())) {
    var cDate = new Date();
    if (cDate > xDate) return true;
    return false;
  }

  return false;
};

var useFestivalTheme = function useFestivalTheme(_ref) {
  var headerLogoRef = _ref.headerLogoRef;

  var _useConfigStore = useConfigStore(function (s) {
    return s;
  }),
      configStoreData = _useConfigStore.data,
      configStoreDataLoaded = _useConfigStore.loaded;

  (0,react.useEffect)(function () {
    var _configStoreData$COMM, _configData$data;

    var configData = configStoreData == null ? void 0 : (_configStoreData$COMM = configStoreData.COMMON) == null ? void 0 : _configStoreData$COMM[growth_gi_dweb_auth_esm.CONFIG_KEY_DWEB_AUTH];

    if (configData && configStoreDataLoaded && configData != null && (_configData$data = configData.data) != null && _configData$data.festivalTheme) {
      var _themes$date;

      var themes = configData.data.festivalTheme; // we keep expire date for special theme.
      // check if theme is still valid for today
      // date format: MM/DD/YYYY

      var expireTime = themes == null ? void 0 : (_themes$date = themes.date) == null ? void 0 : _themes$date.expire;
      if (expireTime && hasTimeExpired(expireTime)) return; // apply special theme to dom direclty, to avoid rerender
      // goibibo image

      if (themes != null && themes.gi_logo && headerLogoRef.current) {
        var giLogoElm = headerLogoRef.current;
        giLogoElm.style.backgroundImage = "url(" + themes.gi_logo + ")";
        giLogoElm.classList.remove('header-sprite', 'logo', 'gi-logo');
        giLogoElm.classList.add('special-logo');
      }
    }
  }, [configStoreData, configStoreDataLoaded, headerLogoRef]);
};

var LOGIN_POPOVER_TIMEOUT = 10000; // 10sec

var useLoginPopover = function useLoginPopover(_ref) {
  var _configStoreData$COMM;

  var loginPersuation = _ref.loginPersuation,
      loginPersuationTimeout = _ref.loginPersuationTimeout,
      sticky = _ref.sticky,
      lobName = _ref.lobName;

  var _useConfigStore = useConfigStore(function (s) {
    return s;
  }),
      configStoreData = _useConfigStore.data,
      configStoreDataLoaded = _useConfigStore.loaded;

  var configData = configStoreData == null ? void 0 : (_configStoreData$COMM = configStoreData.COMMON) == null ? void 0 : _configStoreData$COMM[growth_gi_dweb_auth_esm.CONFIG_KEY_DWEB_AUTH];

  var _useState = (0,react.useState)(false),
      show = _useState[0],
      setShowLoginPopover = _useState[1];

  var popoverTimerTimeout = (0,react.useRef)(0);

  var closeLogInPopover = function closeLogInPopover() {
    setShowLoginPopover(false);
  };

  var setLoginPopoverTimer = function setLoginPopoverTimer(time) {
    if (popoverTimerTimeout.current) {
      // Exception?
      return;
    } // Remember the timer handle


    popoverTimerTimeout.current = setTimeout(function () {
      closeLogInPopover();
    }, time);
  };

  var showLoginPopOver = function showLoginPopOver(persuationsText) {
    setShowLoginPopover(persuationsText);
    var timeout = loginPersuationTimeout || LOGIN_POPOVER_TIMEOUT;
    setLoginPopoverTimer(timeout);
  };

  var clearLoginPopoverTimer = function clearLoginPopoverTimer() {
    // Is our timer running?
    if (popoverTimerTimeout.current) {
      // Yes, clear it
      clearTimeout(popoverTimerTimeout.current);
    }
  };

  var setLoginPopoverVisiblity = (0,react.useCallback)(function () {
    var _configData$data, _configData$data2;

    if (configData && configStoreDataLoaded && configData != null && (_configData$data = configData.data) != null && _configData$data.loginPopover && configData != null && (_configData$data2 = configData.data) != null && _configData$data2.bookingOffers) {
      var _configData$data3 = configData.data,
          _configData$data3$boo = _configData$data3.bookingOffers,
          bookingOffers = _configData$data3$boo === void 0 ? {} : _configData$data3$boo,
          _configData$data3$log = _configData$data3.loginPopover,
          loginPopover = _configData$data3$log === void 0 ? {} : _configData$data3$log; // lob wise offers text comes from api, select only offer that need to
      // display on current lob

      var persuationsText = growth_dweb_header_esm_extends({}, bookingOffers == null ? void 0 : bookingOffers[lobName], loginPopover);

      if (loginPersuation) {
        var _persuationsText$sign;

        var mandatoryTextToDisplayUI = (persuationsText == null ? void 0 : persuationsText.title) && (persuationsText == null ? void 0 : persuationsText.subTitle) && (persuationsText == null ? void 0 : (_persuationsText$sign = persuationsText.signUp) == null ? void 0 : _persuationsText$sign.ctaText);

        if (!(0,growth_auth_helpers_esm/* isUserTokenPresent */.Tq)() && mandatoryTextToDisplayUI) {
          showLoginPopOver(persuationsText);
        } else {
          closeLogInPopover();
        }
      }
    }
  }, [configStoreDataLoaded, lobName, loginPersuation, sticky]);
  (0,react.useEffect)(function () {
    /**
     * on load don't show login popover in "non sticky" header. It does not fit when user scrolls
     * the page when popover is visible in header
     *
     * NOTE: we allow to show popover for no sticky header also via 'SHOW_LOGIN_POP_OVER' dom event
     */
    if (sticky) {
      setLoginPopoverVisiblity();
    }

    return function () {
      clearLoginPopoverTimer();
    };
  }, [setLoginPopoverVisiblity]);
  (0,react.useEffect)(function () {
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER, setLoginPopoverVisiblity);
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER, closeLogInPopover);
    return function () {
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER, setLoginPopoverVisiblity);
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER, closeLogInPopover);
    };
  }, [setLoginPopoverVisiblity]);
  return {
    closeLogInPopover: closeLogInPopover,
    show: show
  };
};

var Header$1 = function Header(props) {
  var handleOnLoginModalOpen = props.handleOnLoginModalOpen,
      onLogoutSuccess = props.onLogoutSuccess,
      sticky = props.sticky,
      lobName = props.lobName,
      reloadAfterLogout = props.reloadAfterLogout,
      _props$loginPersuatio = props.loginPersuation,
      loginPersuation = _props$loginPersuatio === void 0 ? true : _props$loginPersuatio,
      loginPersuationTimeout = props.loginPersuationTimeout,
      headerStyle = props.headerStyle,
      _props$navOrigin = props.navOrigin,
      navOrigin = _props$navOrigin === void 0 ? '' : _props$navOrigin;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
      _useAnalytics.pdt;

  var isLoggedIn = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return s.data.isLoggedIn;
  });
  var bookingSummaryState = useBookingSummaryStore(function (s) {
    return s;
  });
  var upComingTripCounts = selectUpcomingBookingsCount(bookingSummaryState);
  var headerLogoRef = (0,react.useRef)(null);
  var headerLeftThemeRef = (0,react.useRef)(null);
  /**
   * For any special occasions we change gi logo and few theme images.
   * we get this images from api, right now and apply in client side.
   */

  useFestivalTheme({
    headerLogoRef: headerLogoRef
  });

  var _useLoginPopover = useLoginPopover({
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    sticky: sticky,
    lobName: lobName
  }),
      loginPopover = _useLoginPopover.show,
      closeLogInPopover = _useLoginPopover.closeLogInPopover;

  function popoverLoginHandler() {
    // pdt.track('HAPPY_HEADER_WEBA__CLICK_POPOVER_LOGIN_BTN');
    handleOnLoginModalOpen();
  }

  var giLogoClickTargetUrl = navOrigin + lobsPathName.HOME;
  return /*#__PURE__*/react.createElement(HappyGiHeader, {
    ref: headerLeftThemeRef,
    "data-id": "dweb-header-root",
    className: sticky ? 'header-sticky' : 'header-sticky-nope',
    style: headerStyle
  }, /*#__PURE__*/react.createElement(HeaderLogo, {
    homeURL: giLogoClickTargetUrl,
    ref: headerLogoRef,
    lobName: lobName
  }), /*#__PURE__*/react.createElement(NavBar, {
    navList: lobsNavList(navOrigin),
    lobName: lobName
  }), ' ', /*#__PURE__*/react.createElement(LoginWidgetWrapper, null, /*#__PURE__*/react.createElement(NavWidgets, {
    isLoggedIn: isLoggedIn || false,
    upcomingTrip: upComingTripCounts,
    navOrigin: navOrigin,
    lobName: lobName
  }), /*#__PURE__*/react.createElement(ErrorBoundary, null, /*#__PURE__*/react.createElement(UserLoginWidget, {
    lobName: lobName,
    onLogoutSuccess: onLogoutSuccess,
    showLogin: handleOnLoginModalOpen,
    reloadAfterLogout: reloadAfterLogout,
    isLoginPopoverVisible: loginPopover,
    navOrigin: navOrigin,
    upComingTripCounts: upComingTripCounts
  }))), loginPopover && /*#__PURE__*/react.createElement(LoginSignupPopup, {
    closePopOver: function closePopOver() {
      return closeLogInPopover();
    },
    onLogin: function onLogin() {
      return popoverLoginHandler();
    },
    persuationsText: loginPopover
  }));
};

var AuthFlowModal = function AuthFlowModal(props) {
  var onLoginClose = props.onLoginClose,
      onLoginSuccess = props.onLoginSuccess,
      lobName = props.lobName,
      modalStyle = props.modalStyle,
      shouldShowCloseButton = props.shouldShowCloseButton;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  var handleModalClose = function handleModalClose() {
    onLoginClose();
  };

  (0,react.useEffect)(function () {
    pdt.track('HAPPY_AUTH_WEBA__UX_LOGIN_DIALOG_OPEN', {
      ab_experiment: 'happy-auth'
    });
    adobe.track('Login_Popup_Load');
  }, []);
  return /*#__PURE__*/react.createElement(Modal, {
    rootStyle: growth_dweb_header_esm_extends({
      background: 'transparent'
    }, modalStyle)
    /** dweb-auth have a close button, hide the close button of modal */
    ,
    closeBtnStyle: {
      display: 'none'
    },
    onClose: handleModalClose
  }, /*#__PURE__*/react.createElement(growth_gi_dweb_auth_esm["default"], {
    onClose: handleModalClose,
    lobName: lobName,
    onLoginSuccess: onLoginSuccess,
    showCloseButton: shouldShowCloseButton
  }));
};

var _templateObject$1;
var HeaderContainer$1 = styled_components_browser_esm["default"].div(_templateObject$1 || (_templateObject$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: block;\n\theight: 64px;\n\twidth: 100%;\n"])));

var HeaderContainer = function HeaderContainer(props) {
  var onLoginSuccess = props.onLoginSuccess,
      lobName = props.lobName,
      onLogoutSuccess = props.onLogoutSuccess,
      sticky = props.sticky,
      reloadAfterLogout = props.reloadAfterLogout,
      loginPersuation = props.loginPersuation,
      loginPersuationTimeout = props.loginPersuationTimeout,
      hideHeader = props.hideHeader,
      headerStyle = props.headerStyle,
      modalStyle = props.modalStyle,
      shouldShowCloseButton = props.shouldShowCloseButton,
      navOrigin = props.navOrigin;

  var _useState = (0,react.useState)(false),
      loginModal = _useState[0],
      toggleLoginModal = _useState[1];

  var fetchProfileDetails = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchBookingSummary = useBookingSummaryStore(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchLoyaltyInfo = useLoyaltyUserInfoStore(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchGocash = useGoCashBalanceStore(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
      _useAnalytics.pdt;

  var onProfileDetailsError = function onProfileDetailsError(err) {
    if ((err == null ? void 0 : err.status) === 404) {
      (0,growth_auth_helpers_esm/* clearUserTokens */.H)();
      growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT);
    }
  };

  var fetchAllHeaderData = (0,react.useCallback)(function () {
    var token = (0,growth_auth_helpers_esm/* isUserTokenPresent */.Tq)();

    if (token) {
      var userDetail = fetchProfileDetails({
        platform: 'dweb',
        onError: onProfileDetailsError
      });
      Promise.all([fetchLoyaltyInfo(), fetchBookingSummary(), fetchGocash()]);
      return userDetail;
    }

    return Promise.resolve({});
  }, []); // close the login modal

  var handleOnLoginModalClose = (0,react.useCallback)(function () {
    toggleLoginModal(function () {
      return false;
    });
  }, []); // open the login modal

  var handleOnLoginModalOpen = (0,react.useCallback)(function () {
    toggleLoginModal(function () {
      return true;
    });
  }, []);
  var handleOnLoginSuccess = (0,react.useCallback)(function () {
    if (onLoginSuccess) onLoginSuccess();
    fetchAllHeaderData();
  }, [onLoginSuccess, fetchAllHeaderData]);
  (0,react.useEffect)(function () {
    /** allow refresh the header data from outside
     * usecases:
     * - when new profile image or details are updated in profile page by user we would want to see the
     *   updated info in header as well
     * - when logout happens from somewhere outside the header, we would refresh the data again
     */
    // put all global Header/Auth event listners here.
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.REFRESH_HEADER_DATA, function () {
      fetchAllHeaderData();
    });
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.START_LOGIN_FLOW, handleOnLoginModalOpen);
    return function () {
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.REFRESH_HEADER_DATA, function () {
        fetchAllHeaderData();
      });
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.START_LOGIN_FLOW, handleOnLoginModalOpen);
    };
  }, []);
  (0,react.useEffect)(function () {
    // hydrate store with require data and trigger load events
    function loadInitialData() {
      return _loadInitialData.apply(this, arguments);
    }

    function _loadInitialData() {
      _loadInitialData = growth_dweb_header_esm_asyncToGenerator( /*#__PURE__*/growth_dweb_header_esm_regeneratorRuntime().mark(function _callee() {
        return growth_dweb_header_esm_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  fetchAllHeaderData(); // pdt.setUserVars({
                  // 	user: {
                  // 		uuid: window?.atob(getEncryptedUuid() || ''),
                  // 	},
                  // 	lob: lobName,
                  // });
                  // pdt.track('HEADER_LOADED', {
                  // 	item_position: sticky ? 'sticky' : 'scroll',
                  // });
                } catch (e) {// pdt.setUserVars({
                  // 	user: {
                  // 		uuid: 'error',
                  // 	},
                  // 	lob: lobName,
                  // });
                  // pdt.track('HEADER_LOADED', {
                  // 	item_position: sticky ? 'sticky' : 'scroll',
                  // });
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadInitialData.apply(this, arguments);
    }

    loadInitialData();
  }, []);
  return /*#__PURE__*/react.createElement(react.Fragment, null, !hideHeader && /*#__PURE__*/react.createElement(HeaderContainer$1, null, /*#__PURE__*/react.createElement(Header$1, {
    handleOnLoginModalOpen: handleOnLoginModalOpen,
    lobName: lobName,
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    onLogoutSuccess: onLogoutSuccess,
    sticky: sticky,
    reloadAfterLogout: reloadAfterLogout,
    headerStyle: headerStyle,
    navOrigin: navOrigin
  })), loginModal && /*#__PURE__*/react.createElement(AuthFlowModal, {
    shouldShowCloseButton: shouldShowCloseButton,
    lobName: lobName,
    onLoginSuccess: handleOnLoginSuccess,
    onLoginClose: handleOnLoginModalClose,
    modalStyle: modalStyle
  }));
};

var growth_dweb_header_esm_templateObject;
var Style = styled_components_browser_esm["default"].div(growth_dweb_header_esm_templateObject || (growth_dweb_header_esm_templateObject = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t.header-sprite,\n\t.dropdown-sprite {\n\t\tbackground: url(https://gos3.ibcdn.com/giHeaderSprite-1697090884.png) 0 0 no-repeat;\n\t\tbackground-size: 125px 200px;\n\t\tdisplay: block;\n\t\tflex-shrink: 0;\n\t}\n\n\t.header-sprite.logo {\n\t\twidth: 104px;\n\t\theight: 30px;\n\t\tbackground-position: -2px -1px;\n\t}\n\n\t.header-sprite.nav-icon-flights {\n\t\twidth: 32px;\n\t\theight: 20px;\n\t\tbackground-position: -69px -33px;\n\t}\n\n\t.header-sprite.nav-icon-hotels {\n\t\twidth: 24px;\n\t\theight: 22px;\n\t\tbackground-position: -4px -178px;\n\t}\n\n\t.header-sprite.nav-icon-bus {\n\t\twidth: 32px;\n\t\theight: 14px;\n\t\tbackground-position: -3px -89px;\n\t}\n\n\t.header-sprite.nav-icon-trains {\n\t\twidth: 36px;\n\t\theight: 16px;\n\t\tbackground-position: -3px -52px;\n\t}\n\n\t.header-sprite.nav-icon-cabs {\n\t\twidth: 34px;\n\t\theight: 16px;\n\t\tbackground-position: -1px -69px;\n\t}\n\n\t.header-sprite.nav-icon-holiday {\n\t\twidth: 26px;\n\t\theight: 21px;\n\t\tbackground-position: -3px -105px;\n\t}\n\n\t.header-sprite.nav-icon-forex {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tbackground-position: -5px -131px;\n\t}\n\n\t.header-sprite.nav-icon-insurance {\n\t\twidth: 20px;\n\t\theight: 22px;\n\t\tbackground-position: -5px -153px;\n\t}\n\n\t.header-sprite.user-icon {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tbackground-position: -41px -56px;\n\t}\n\n\t.header-sprite.mytrip-icon {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tbackground-position: -43px -33px;\n\t}\n\t/* -- DropDown Icons sprites -- */\n\t.dropdown-sprite.gotribeLogo {\n\t\twidth: 50px;\n\t\theight: 14px;\n\t\tbackground-position: -38px -86px;\n\t}\n\t.dropdown-sprite.gotribe {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -2px -33px;\n\t}\n\t.dropdown-sprite.offers {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -107px -19px;\n\t}\n\t.dropdown-sprite.mytrip {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -107px -1px;\n\t}\n\t.dropdown-sprite.gocash {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -22px -33px;\n\t}\n\t/* -- CSS Icons -- */\n\t.arrow-icon {\n\t\tborder: solid #2274e0;\n\t\tborder-width: 0 2px 2px 0;\n\t\tdisplay: inline-block;\n\t\tpadding: 2px;\n\t\tmargin-left: auto;\n\t}\n\n\t.arrow-icon.right {\n\t\ttransform: rotate(-45deg);\n\t\t-webkit-transform: rotate(-45deg);\n\t}\n\n\t.arrow-icon.left {\n\t\ttransform: rotate(135deg);\n\t\t-webkit-transform: rotate(135deg);\n\t}\n\n\t.arrow-icon.up {\n\t\ttransform: rotate(-135deg);\n\t\t-webkit-transform: rotate(-135deg);\n\t}\n\n\t.arrow-icon.down {\n\t\ttransform: rotate(45deg);\n\t\t-webkit-transform: rotate(45deg);\n\t}\n"])));

var RootHoc = function RootHoc(Component) {
  var WithHOC = function WithHOC(props) {
    var headerEnv = props.headerEnv,
        lobName = props.lobName,
        adobeLobName = props.adobeLobName,
        configData = props.configData;
    /** Memorize b/c we don't want to call the setData again if there in no change in configData */

    (0,react.useMemo)(function () {
      if (configData) (0,growth_config_store_browser_esm/* setData */.a_)(useConfigStore, configData);
    }, [configData]);
    var fetchConfigStoreData = useConfigStore(function (s) {
      return s.fetch;
    }, shallow/* shallow */.X);
    (0,react.useEffect)(function () {
      fetchConfigStoreData({
        keys: 'growth-dweb-header-config',
        lobs: 'COMMON',
        cacheOpts: {
          ttl: 15 // min

        },
        initData: configData
      });
    }, []); // Analytics plugin initialization

    var pdtInstance = {};
    var adobeInstance = {};

    if (growth_ssr_utils_esm/* isOnClient */.BK) {
      var _window$adobeDataLaye, _window$adobeDataLaye2;

      pdtInstance = new growth_web_analytics_esm/* default */.Z();
      adobeInstance = new growth_web_analytics_esm/* default */.Z();
      pdtInstance.initialize({
        plugin: (0,growth_analytics_plugin_pdt_esm/* default */.Z)({
          debug: false
        }),
        globalProperties: {
          context: {
            environment: headerEnv || 'error'
          },
          eventProperties: {
            lob: lobName
          }
        },
        debug: false
      });
      var pageInfo = (_window$adobeDataLaye = window.adobeDataLayer) == null ? void 0 : _window$adobeDataLaye.getState == null ? void 0 : _window$adobeDataLaye.getState('page.pageInfo');
      var accountInfo = (_window$adobeDataLaye2 = window.adobeDataLayer) == null ? void 0 : _window$adobeDataLaye2.getState == null ? void 0 : _window$adobeDataLaye2.getState('account.accountInfo');
      adobeInstance.initialize({
        plugin: (0,growth_analytics_plugin_adobe_esm/* default */.Z)({
          page: {
            pageInfo: growth_dweb_header_esm_extends({}, pageInfo, {
              lob: adobeLobName || lobName
            })
          },
          account: {
            accountInfo: growth_dweb_header_esm_extends({}, accountInfo, {
              website: 'goibibo'
            })
          }
        }, false),
        debug: false
      });
    }

    return /*#__PURE__*/react.createElement(Style, null, /*#__PURE__*/react.createElement(growth_use_analytics_esm/* AnalyticsContextProvider */.nx, {
      pdtInstance: pdtInstance,
      adobeInstance: adobeInstance
    }, /*#__PURE__*/react.createElement(Component, props)));
  };

  return WithHOC;
};

var HeaderComponent = function HeaderComponent(_ref) {
  var onLoginSuccess = _ref.onLoginSuccess,
      sticky = _ref.sticky,
      onLogoutSuccess = _ref.onLogoutSuccess,
      lobName = _ref.lobName,
      reloadAfterLogout = _ref.reloadAfterLogout,
      headerEnv = _ref.headerEnv,
      loginPersuation = _ref.loginPersuation,
      loginPersuationTimeout = _ref.loginPersuationTimeout,
      hideHeader = _ref.hideHeader,
      headerStyle = _ref.headerStyle,
      modalStyle = _ref.modalStyle,
      shouldShowCloseButton = _ref.shouldShowCloseButton,
      adobeLobName = _ref.adobeLobName,
      navOrigin = _ref.navOrigin,
      configData = _ref.configData;
  return /*#__PURE__*/react.createElement(HeaderContainer, {
    headerEnv: headerEnv,
    adobeLobName: adobeLobName,
    sticky: sticky,
    lobName: lobName,
    hideHeader: hideHeader,
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    onLoginSuccess: onLoginSuccess,
    onLogoutSuccess: onLogoutSuccess,
    reloadAfterLogout: reloadAfterLogout,
    headerStyle: headerStyle,
    modalStyle: modalStyle,
    shouldShowCloseButton: shouldShowCloseButton,
    configData: configData,
    navOrigin: navOrigin
  });
};

var Header = RootHoc(HeaderComponent);

var showLoginPopOverEvent = function showLoginPopOverEvent() {
  return eventEmitter.emit(DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER);
};

var hideLoginPopOverEvent = function hideLoginPopOverEvent() {
  return eventEmitter.emit(DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER);
};




/***/ }),

/***/ 6963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ fetchRequest; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function assertPath(path) {
  var type = typeof path;

  if (type !== 'string') {
    throw new TypeError("The path should be a string, instead received a " + type);
  }
}

var parseResponse = function parseResponse(res) {
  // If a body response exists, parse anx extract the possible properties
  var response = res.json();

  try {
    if (res.status >= 200 && res.status < 300) {
      return Promise.resolve(response);
    }

    if (res.status >= 400 && res.status < 599) {
      return response.then(function (data) {
        var errorResponse = {
          response: data,
          status: res.status,
          statusText: res.statusText
        };
        return Promise.reject(errorResponse);
      });
    }
  } catch (_unused) {
    return response.then(function (data) {
      var errorResponse = {
        response: data,
        status: res.status,
        statusText: res.statusText
      };
      return Promise.reject(errorResponse);
    });
  }

  return Promise.resolve(response);
  /* Add any custom logic related to how you want to handle the response
   *
   * In case success is false,
   * trigger a new expection to capture later on request call site
   */
  // throw new Error(JSON.stringify({response,status:res.status,statusText: res.statusText}));
  // Otherwise, simply resolve the received data
};

var fetchRequest = function fetchRequest(path, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$headers = _options.headers,
      headers = _options$headers === void 0 ? {} : _options$headers,
      _options$query = _options.query,
      query = _options$query === void 0 ? null : _options$query,
      _options$method = _options.method,
      method = _options$method === void 0 ? 'GET' : _options$method,
      _options$timeout = _options.timeout,
      timeout = _options$timeout === void 0 ? null : _options$timeout,
      _options$credentials = _options.credentials,
      credentials = _options$credentials === void 0 ? 'include' : _options$credentials,
      _options$extraOptions = _options.extraOptions,
      extraOptions = _options$extraOptions === void 0 ? {} : _options$extraOptions;
  var _options2 = options,
      body = _options2.body;
  assertPath(path);

  if (body && typeof body === 'object' && !(body instanceof FormData)) {
    body = JSON.stringify(body);
    headers['content-type'] = 'application/json';
  }

  var genericHeaders = {};

  var reqOptions = _extends({
    method: method,
    headers: _extends({}, genericHeaders, headers),
    credentials: credentials
  }, extraOptions, {
    body: body
  });

  var queryString = '';

  if (query) {
    // Convert to encoded string and prepend with ?
    queryString = new URLSearchParams(query).toString();
    queryString = queryString && "?" + queryString;
  }

  var controller;
  var requestTimeout;

  if (timeout) {
    controller = new AbortController();
    requestTimeout = setTimeout(function () {
      return controller.abort();
    }, timeout);
  }

  function makeFetchRequest(requestMethod) {
    var config = _extends({}, reqOptions, {
      method: requestMethod
    });

    if (timeout && controller) {
      config.signal = controller.signal;
    }

    return fetch("" + path + queryString, config).then(function (res) {
      if (timeout && requestTimeout) {
        clearTimeout(requestTimeout);
      }

      return parseResponse(res);
    });
  }

  return {
    get: function get() {
      return makeFetchRequest('GET');
    },
    post: function post() {
      return makeFetchRequest('POST');
    },
    "delete": function _delete() {
      return makeFetchRequest('DELETE');
    }
  };
};




/***/ }),

/***/ 3858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CONFIG_KEY_DWEB_AUTH": function() { return /* binding */ CONFIG_KEY_DWEB_AUTH; },
  "default": function() { return /* binding */ Container; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@growth/use-analytics/dist/growth-use-analytics.esm.js
var growth_use_analytics_esm = __webpack_require__(2390);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../node_modules/@growth/app-theme/dist/growth-app-theme.esm.js
var growth_app_theme_esm = __webpack_require__(1225);
// EXTERNAL MODULE: ../../node_modules/@growth/web-analytics/dist/growth-web-analytics.esm.js
var growth_web_analytics_esm = __webpack_require__(2019);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-adobe/dist/growth-analytics-plugin-adobe.esm.js
var growth_analytics_plugin_adobe_esm = __webpack_require__(6401);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/shallow.mjs
var shallow = __webpack_require__(2532);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js + 1 modules
var growth_auth_helpers_esm = __webpack_require__(7263);
// EXTERNAL MODULE: ../../node_modules/@growth/dom-event-emitter/dist/growth-dom-event-emitter.esm.js
var growth_dom_event_emitter_esm = __webpack_require__(3377);
// EXTERNAL MODULE: ../../node_modules/@growth/pdt-push/dist/growth-pdt-push.esm.js
var growth_pdt_push_esm = __webpack_require__(3488);
// EXTERNAL MODULE: ../../node_modules/@growth/design-system/dist/growth-design-system.esm.js
var growth_design_system_esm = __webpack_require__(3767);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/react-otp-input/lib/index.js
var lib = __webpack_require__(4607);
// EXTERNAL MODULE: ../../node_modules/@growth/loader/dist/growth-loader.esm.js + 1 modules
var growth_loader_esm = __webpack_require__(305);
// EXTERNAL MODULE: ../../node_modules/@growth/tooltip/dist/growth-tooltip.esm.js
var growth_tooltip_esm = __webpack_require__(7792);
// EXTERNAL MODULE: ../../node_modules/@growth/date-utils/dist/growth-date-utils.esm.js + 1 modules
var growth_date_utils_esm = __webpack_require__(7862);
// EXTERNAL MODULE: ../../node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js + 7 modules
var growth_config_store_browser_esm = __webpack_require__(4162);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../node_modules/@growth/toast/dist/growth-toast.esm.js





function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2;
var ToastWrapper = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tposition: fixed;\n\tleft: 50%;\n\tbottom: 70px;\n\tbackground-color: #2a2d31;\n\tcolor: #fff;\n\tmax-height: 80px;\n\ttext-align: center;\n\toverflow: auto;\n\tborder-radius: 8px;\n\ttransform: translateX(-50%);\n\tpadding: 10px 12px;\n\tanimation: slideUp 0.3s ease-in-out forwards;\n\tbox-shadow: 0px 4px 4px rgb(0 0 0 / 9%);\n\tz-index: 1040;\n\n\t@keyframes slideUp {\n\t\tfrom {\n\t\t\tbottom: -100px;\n\t\t\topacity: 0;\n\t\t}\n\n\t\tto {\n\t\t\tbottom: 80px;\n\t\t\topacity: 1;\n\t\t}\n\t}\n"])));
var ToastMessage = styled_components_browser_esm["default"].p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #fff;\n\ttext-align: center;\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);

var Toast = function Toast(props) {
  var message = props.message,
      onClose = props.onClose,
      _props$style = props.style,
      style = _props$style === void 0 ? null : _props$style,
      _props$autoHideDurati = props.autoHideDuration,
      autoHideDuration = _props$autoHideDurati === void 0 ? 2500 : _props$autoHideDurati,
      close = props.close,
      children = props.children;
  (0,react.useEffect)(function () {
    var closeTimmer = setTimeout(function () {
      if (close) close(false);
      if (onClose) onClose();
    }, autoHideDuration);
    return function () {
      if (closeTimmer) clearTimeout(closeTimmer);
    };
  }, [autoHideDuration, close, onClose]);
  return /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/react.createElement(ToastWrapper, {
    style: style
  }, /*#__PURE__*/(0,react.isValidElement)(children) ? children : /*#__PURE__*/react.createElement(ToastMessage, null, message)), document.body);
};

Toast.defaultProps = {
  autoHideDuration: 2500,
  onClose: function onClose() {},
  children: undefined,
  style: undefined
};

var useToast = function useToast() {
  var _useState = useState({}),
      toastData = _useState[0],
      setShowToast = _useState[1];

  var closeToast = function closeToast() {
    setShowToast({
      show: false,
      message: '',
      close: closeToast
    });
  };

  var showToast = function showToast(_ref) {
    var message = _ref.message,
        autoHideDuration = _ref.autoHideDuration;
    setShowToast({
      show: true,
      message: message,
      autoHideDuration: autoHideDuration,
      close: closeToast
    });
  };

  var ToastComponent = function ToastComponent() {
    var _toastData$message = toastData.message,
        message = _toastData$message === void 0 ? '' : _toastData$message,
        show = toastData.show,
        autoHideDuration = toastData.autoHideDuration,
        close = toastData.close;
    return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement(Toast, {
      message: message,
      autoHideDuration: autoHideDuration,
      close: close
    }));
  };

  return {
    ToastComponent: ToastComponent,
    showToast: showToast
  };
};



;// CONCATENATED MODULE: ../../node_modules/@growth/gi-dweb-auth/dist/growth-gi-dweb-auth.esm.js



















function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var initOmnitureAnalytics = function initOmnitureAnalytics(_ref) {
  var _window$adobeDataLaye, _window$adobeDataLaye2;
  var adobeInstance = _ref.adobeInstance,
    lobName = _ref.lobName,
    debug = _ref.debug;
  var pageInfo = (_window$adobeDataLaye = window.adobeDataLayer) == null || _window$adobeDataLaye.getState == null ? void 0 : _window$adobeDataLaye.getState('page.pageInfo');
  var accountInfo = (_window$adobeDataLaye2 = window.adobeDataLayer) == null || _window$adobeDataLaye2.getState == null ? void 0 : _window$adobeDataLaye2.getState('account.accountInfo');
  adobeInstance.initialize({
    plugin: (0,growth_analytics_plugin_adobe_esm/* default */.Z)({
      page: {
        pageInfo: _extends({}, pageInfo, {
          lob: lobName
        })
      },
      account: {
        accountInfo: _extends({}, accountInfo, {
          website: 'goibibo'
        })
      }
    }, debug || false),
    debug: debug || false
  });
};

var initAnalytics = function initAnalytics(_ref) {
  var lobName = _ref.lobName,
    debug = _ref.debug;
  var adobeInstance = new growth_web_analytics_esm/* default */.Z();
  initOmnitureAnalytics({
    adobeInstance: adobeInstance,
    lobName: lobName,
    debug: debug
  });
  return {
    adobeInstance: adobeInstance
  };
};

function growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

var _templateObject$a;
var AuthContainer$1 = styled_components_browser_esm["default"].div(_templateObject$a || (_templateObject$a = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"])));

var _templateObject$9, _templateObject2$7;
var AuthVerificationFlowSection = styled_components_browser_esm["default"].div(_templateObject$9 || (_templateObject$9 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    width: 400px;\n    height: ", ";\n    border-radius: 12px;\n    overflow: hidden;\n    flex-shrink: 0;\n    box-shadow: -5px 0 9px 0 rgba(0, 0, 0, 0.2);\n    background-color: #fff;\n    padding: 50px 50px 30px 50px;\n  position: relative;\n"])), function (props) {
  return props != null && props.height ? props.height : '456px';
});
var AuthVerificationFlowCloseIcon = styled_components_browser_esm["default"].span(_templateObject2$7 || (_templateObject2$7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    right: 22px;\n    top: 22px;\n"])));

var _templateObject$8, _templateObject2$6, _templateObject3$5, _templateObject4$5, _templateObject5$4, _templateObject6$3, _templateObject7$1;
var MobileContainer = styled_components_browser_esm["default"].div(_templateObject$8 || (_templateObject$8 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\theight: 100%;\n\tposition: relative;\n"])));
var MobileHeading = styled_components_browser_esm["default"].h3(_templateObject2$6 || (_templateObject2$6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcolor: rgb(0, 0, 0);\n\t", "\n\tmargin-bottom: 30px;\n"])), growth_design_system_esm/* headingSizes.MediumW1 */.$G.MediumW1);
var MobileInputWrapper = styled_components_browser_esm["default"].div(_templateObject3$5 || (_templateObject3$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 56px;\n\tborder-radius: 4px;\n\tborder: solid 2px #016eff;\n\tposition: relative;\n\tdisplay: flex;\n\t", "\n\t.loginCont__input {\n\t\tbackground: #fff;\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\toutline: 0;\n\t\t", "\n\t\tcolor: #4f525a;\n\t\tpadding-left: 5px;\n\t\tborder-radius: 0 4px 4px 0;\n\t}\n\n\t.loginCont__code {\n\t\tbackground: #fff;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #c2c2c2;\n\t\tdisplay: inline-flex;\n\t\tpadding: 0 5px 0 20px;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t}\n\n\t.loginCont__label {\n\t\tdisplay: inline-flex;\n\t\tposition: absolute;\n\t\tleft: 11px;\n\t\ttop: -11px;\n\t\tbackground-color: #fff;\n\t\tpadding: 3px 8px;\n\t\t", "\n\t\tcolor: #016eff;\n\t}\n\n\t.loginCont__input::placeholder {\n\t\tcolor: #c2c2c2;\n\t\tline-height: 20px !important;\n\t\topacity: 1;\n\t\tfont-weight: 600 !important;\n\t}\n"])), function (props) {
  if (props.error) {
    return "\n    border-color: rgb(229, 52, 66);\n    .loginCont__label{\n    \tcolor: rgb(229, 52, 66) !important;\n    }\n   \n    ";
  }
  if (props.valid) {
    return "\n    border-color: #00962d;\n    .loginCont__label{\n    \tcolor: #00962d !important;\n    }\n   \n    ";
  }
  return null;
}, growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2, growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var LoginSubmitButton = styled_components_browser_esm["default"].button(_templateObject4$5 || (_templateObject4$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 13px 118px 13px 116px;\n\tmargin-top: 22px;\n\tborder-radius: 8px;\n\tbackground-color: #ff6d38;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\t", "\n\n\t&.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var LoginTermsAndCondition = styled_components_browser_esm["default"].p(_templateObject5$4 || (_templateObject5$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var InputMessageIcon = styled_components_browser_esm["default"].span(_templateObject6$3 || (_templateObject6$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tright: 20px;\n\ttop: 17px;\n"])));
var MessageText = styled_components_browser_esm["default"].p(_templateObject7$1 || (_templateObject7$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\n\t", "\n"])), function (props) {
  if (props.error) {
    return "color: rgb(229, 52, 66);\n\t\t\t margin-top: 10px;\n\t\t\t";
  }
  if (props.success) {
    return "\n            color: #00962d;\n            \n             margin-top: 10px;\n            ";
  }
  if (props.loading) {
    return "\n\t\t\t margin-top: 10px;\n\t\t\t ";
  }
  return '';
});

var LOGIN_WITH_MOBILE = {
  heading: 'Login/Signup',
  subHeading: '',
  submitButton: 'Continue',
  label: 'Enter your Mobile Number',
  termsPolicy: 'By proceeding, you agree to GoIbibo’s <a href="https://www.goibibo.com/info/privacy/" target="_blank">Privacy Policy</a>, <a href="https://www.goibibo.com/info/user-agreement/" target="_blank">User Agreement</a> and <a href="https://www.goibibo.com/info/terms-of-services/" target="_blank">Terms of Service</a>'
};

var InputWrapper = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    _ref$inputName = _ref.inputName,
    inputName = _ref$inputName === void 0 ? 'text' : _ref$inputName,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    maxlength = _ref.maxlength,
    _ref$inputType = _ref.inputType,
    inputType = _ref$inputType === void 0 ? 'text' : _ref$inputType,
    inputPrefix = _ref.inputPrefix,
    onChange = _ref.onChange,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? false : _ref$isValid,
    inputClassName = _ref.inputClassName,
    placeholder = _ref.placeholder,
    inputVal = _ref.inputVal,
    _ref$inputDisabled = _ref.inputDisabled,
    inputDisabled = _ref$inputDisabled === void 0 ? false : _ref$inputDisabled,
    onInputClick = _ref.onInputClick;
  var onChangeHandler = function onChangeHandler(e) {
    if (onChange) onChange(e);
  };
  return /*#__PURE__*/react.createElement(MobileInputWrapper, {
    error: isError,
    valid: isValid
  }, /*#__PURE__*/react.createElement("span", {
    className: "loginCont__label"
  }, label), inputPrefix && /*#__PURE__*/react.createElement("span", {
    className: "loginCont__code"
  }, inputPrefix), /*#__PURE__*/react.createElement("input", {
    ref: ref,
    className: inputClassName,
    onChange: onChangeHandler,
    type: inputType,
    maxLength: maxlength,
    name: inputName,
    onClick: onInputClick,
    autoFocus: autoFocus,
    placeholder: placeholder,
    value: inputVal,
    disabled: inputDisabled
  }), (isError || isValid) && /*#__PURE__*/react.createElement(InputMessageIcon, {
    className: "logSprite " + (isError ? 'icInfoPink' : 'icSuccessSmall')
  }));
});
InputWrapper.displayName = 'InputWrapper';

var MobileForm = function MobileForm(_ref) {
  var _data$validation, _data$validation2, _data$validation3, _data$validation4, _data$validation5, _data$validation6;
  var onFormSubmit = _ref.onFormSubmit,
    prefillMobileNumber = _ref.prefillMobileNumber,
    isMobileNumberDisabled = _ref.isMobileNumberDisabled,
    skipMobileScreen = _ref.skipMobileScreen;
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return state;
    }),
    fetch = _useSendOtpStore.fetch,
    data = _useSendOtpStore.data,
    checkValid = _useSendOtpStore.checkValid,
    loading = _useSendOtpStore.loading,
    error = _useSendOtpStore.error;
  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
      return {
        prefillData: s.data,
        prefillfetch: s.fetch,
        prefillDetailsloaded: s.loaded,
        prefillLoading: s.loading,
        prefillError: s.error,
        controller: s.controller,
        setUserInputMobileNumber: s.setUserInputMobileNumber,
        userInputMobileNumber: s.userInputMobileNumber
      };
    }, shallow/* shallow */.X),
    prefillData = _usePrefillLoginDetai.prefillData,
    prefillfetch = _usePrefillLoginDetai.prefillfetch,
    prefillDetailsloaded = _usePrefillLoginDetai.prefillDetailsloaded,
    prefillError = _usePrefillLoginDetai.prefillError,
    controller = _usePrefillLoginDetai.controller,
    prefillLoading = _usePrefillLoginDetai.prefillLoading,
    setUserInputMobileNumber = _usePrefillLoginDetai.setUserInputMobileNumber,
    userInputMobileNumber = _usePrefillLoginDetai.userInputMobileNumber;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useState = (0,react.useState)(true),
    buttonDisabled = _useState[0],
    setButtonDisabled = _useState[1];
  var inputRef = (0,react.useRef)(undefined);
  var onOtpSendSuccess = function onOtpSendSuccess() {
    adobe.track('ctaClick', {
      cta: {
        name: 'Continue_GetOTP_Success',
        type: "itemSuccess",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (onFormSubmit) onFormSubmit();
  };
  var handleFormSubmit = function handleFormSubmit(e) {
    if (e) e.preventDefault();
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_get_otp", {
      event_detail: {
        event_type: "click_event|onboarding_click",
        event_value: "onboarding_flow"
      }
    });
    adobe.track('ctaClick', {
      cta: {
        name: 'Continue_GetOTP_Clicked',
        type: "cardClick",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (!loading) {
      var _inputRef$current;
      var mobileNumber = ((_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.value) || '';
      var isMobileNumberEncoded = (0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(mobileNumber, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
      var isValid = checkValid(mobileNumber, isMobileNumberEncoded);
      if (isValid) {
        setUserInputMobileNumber(mobileNumber);
        fetch({
          platform: 'dweb',
          data: {
            mobileNumber: mobileNumber,
            loginType: 'mobile',
            encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
            isEncoded: isMobileNumberEncoded || undefined
          },
          onSuccess: onOtpSendSuccess
        });
      }
    }
  };
  (0,react.useEffect)(function () {
    if (!prefillMobileNumber && !userInputMobileNumber) {
      prefillfetch({
        platform: 'dweb'
      });
    }
  }, [prefillMobileNumber, userInputMobileNumber]);
  (0,react.useEffect)(function () {
    if (inputRef.current) {
      var prefillMobileNumberViaApi = prefillDetailsloaded && !prefillError ? prefillData == null ? void 0 : prefillData.encodedMobileNumber : null;
      var mobile = prefillMobileNumber || userInputMobileNumber || prefillMobileNumberViaApi;
      if (mobile) {
        inputRef.current.value = mobile;
        setButtonDisabled(false);
      }
      if (prefillMobileNumber && skipMobileScreen) {
        handleFormSubmit();
      }
    }
  }, [prefillMobileNumber, skipMobileScreen, prefillDetailsloaded, prefillError, prefillData, userInputMobileNumber]);

  /**
   *
   * @param e synthetic event
   * auto submit when user enters 10 digit
   */
  var handleInputChange = function handleInputChange(e) {
    var _inputRef$current2;
    setButtonDisabled(true);
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    if (((_inputRef$current2 = inputRef.current) == null || (_inputRef$current2 = _inputRef$current2.value) == null ? void 0 : _inputRef$current2.length) === growth_auth_helpers_esm/* MOBILE_NUMBER_MAX_LENGTH */.Zb) {
      setButtonDisabled(false);
      handleFormSubmit(e);
    }
  };
  var subText = function subText(_ref2) {
    var waiting = _ref2.loading,
      failure = _ref2.error,
      validationMessage = _ref2.validationMessage;
    if (waiting) {
      return 'Sending OTP...';
    }
    if (!waiting && failure) {
      var _data$error;
      return (_data$error = data.error) == null ? void 0 : _data$error.errorMsg;
    }
    if (validationMessage) {
      return validationMessage;
    }
    return '';
  };
  var handleInputClick = function handleInputClick() {
    var _inputRef$current3;
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_entry_mobile", {
      event_detail: {
        event_type: "click_event|onboarding_click",
        event_value: "onboarding_flow|mobileInput"
      }
    });
    if (prefillLoading) {
      controller == null || controller.abort();
    }
    if ((0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(inputRef == null || (_inputRef$current3 = inputRef.current) == null ? void 0 : _inputRef$current3.value, prefillData == null ? void 0 : prefillData.encodedMobileNumber)) {
      inputRef.current.value = '';
      setButtonDisabled(true);
    }
  };
  return /*#__PURE__*/react.createElement("form", {
    onSubmit: handleFormSubmit,
    autoComplete: "on"
  }, /*#__PURE__*/react.createElement(InputWrapper, {
    label: LOGIN_WITH_MOBILE.label,
    maxlength: 10,
    onInputClick: handleInputClick,
    inputPrefix: "+91 -",
    onChange: handleInputChange,
    isError: error || ((_data$validation = data.validation) == null ? void 0 : _data$validation.message),
    isValid: (_data$validation2 = data.validation) == null ? void 0 : _data$validation2.isValidMobile,
    ref: inputRef,
    inputName: "phone",
    inputType: "text",
    inputClassName: "loginCont__input",
    inputDisabled: loading || !((_data$validation3 = data.validation) != null && _data$validation3.message) && isMobileNumberDisabled
  }), /*#__PURE__*/react.createElement(MessageText, {
    success: ((_data$validation4 = data.validation) == null ? void 0 : _data$validation4.isValidMobile) && !loading,
    error: !loading && error || ((_data$validation5 = data.validation) == null ? void 0 : _data$validation5.message),
    loading: loading
  }, subText({
    loading: loading,
    error: error,
    validationMessage: (_data$validation6 = data.validation) == null ? void 0 : _data$validation6.message
  })), /*#__PURE__*/react.createElement(LoginSubmitButton, {
    className: " " + (buttonDisabled ? 'disabled' : ''),
    type: "submit"
  }, LOGIN_WITH_MOBILE.submitButton));
};

var AUTH_FLOW_STEPS = {
  STEP_MOBILE: 'mobile',
  STEP_OTP: 'otp',
  STEP_PASSWORD: 'pwd',
  STEP_POST_AUTH: 'postlogin',
  LOADER: 'loader'
};

var useAuthFlow = (0,esm/* create */.Ue)(function (set) {
  return {
    activeAuthFlow: AUTH_FLOW_STEPS.STEP_MOBILE,
    setActiveAuthFlow: function setActiveAuthFlow(type) {
      return set({
        activeAuthFlow: type
      });
    }
  };
});

var LoginWithMobile = function LoginWithMobile(_ref) {
  var prefillMobileNumber = _ref.prefillMobileNumber,
    isMobileNumberDisabled = _ref.isMobileNumberDisabled,
    skipMobileScreen = _ref.skipMobileScreen;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var setActiveAuthFlow = useAuthFlow(function (state) {
    return state.setActiveAuthFlow;
  });
  var onFormSubmit = function onFormSubmit() {
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_OTP);
  };
  var termsAndConditionClick = function termsAndConditionClick() {
    adobe.track('ctaClick', {
      cta: {
        name: "Login_TNC",
        type: "itemClick",
        componentName: "GI_USER_ONBOARDING"
      }
    });
  };
  return /*#__PURE__*/react.createElement(MobileContainer, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(MobileHeading, null, LOGIN_WITH_MOBILE.heading), /*#__PURE__*/react.createElement(MobileForm, {
    prefillMobileNumber: prefillMobileNumber,
    onFormSubmit: onFormSubmit,
    isMobileNumberDisabled: isMobileNumberDisabled,
    skipMobileScreen: skipMobileScreen
  })), /*#__PURE__*/react.createElement(LoginTermsAndCondition, {
    onClick: termsAndConditionClick,
    "data-id": "terms-condition",
    dangerouslySetInnerHTML: {
      __html: LOGIN_WITH_MOBILE.termsPolicy
    }
  }));
};

var Heading = 'Verify OTP';
var SubHeading$1 = 'Enter 4 digit OTP sent to';
var RESEND_OTP = {
  label: "Didn't get the OTP?",
  timerHeading: 'Resend OTP in'
};
var OTP_TYPE = {
  sms: 'mobile',
  whatsApp: 'whatsapp'
};
var VERIFY_OTP_MSG = {
  verified: 'OTP verified',
  verifying: 'Verifying OTP...',
  invalidOtp: 'Please enter a valid OTP'
};
var TERMS_CONDITION = 'I agree to receive critical messages such as OTP, booking details on WhatsApp.';

var _templateObject$7, _templateObject2$5, _templateObject3$4, _templateObject4$4, _templateObject5$3, _templateObject6$2;
var SubHeading = styled_components_browser_esm["default"].div(_templateObject$7 || (_templateObject$7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-bottom: 30px;\n\tmargin-top: -22px;\n\t", "\n\tspan {\n\t\t", "\n\t}\n\t.icEdit {\n\t\tmargin-left: 3px;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW1 */.iH.BaseW1, growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var OtpWrapper = styled_components_browser_esm["default"].div(_templateObject2$5 || (_templateObject2$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t.verifyOtpCont__otpFiled {\n\t\theight: 56px;\n\t\tborder-radius: 4px;\n\t\tborder: 2px solid rgb(1, 110, 255);\n\t\tcolor: rgb(79, 82, 90);\n\t\toutline: 0px;\n\t\twidth: 60px !important;\n\t\ttext-align: center;\n\t\tpadding: 0;\n\t\t", "\n\t}\n\t&.otpError .verifyOtpCont__otpFiled {\n\t\tborder-color: rgb(229, 52, 66);\n\t}\n\t.verifyOtpCont__message {\n\t\tmin-height: 50px;\n\t}\n\t.verifyOtpCont__otpCont {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var OtpErrorContainer = styled_components_browser_esm["default"].div(_templateObject3$4 || (_templateObject3$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 8px;\n\t.errorIcon {\n\t\tmargin-right: 10px;\n\t}\n\t.errorMessage {\n\t\tcolor: rgb(229, 52, 66);\n\t\t", "\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var ResendOtpTimerContainer = styled_components_browser_esm["default"].div(_templateObject4$4 || (_templateObject4$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tmargin-bottom: 10px;\n\t.gi-resend-timer {\n\t\tmargin-left: 5px;\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var ResendOtpTimer = styled_components_browser_esm["default"].span(_templateObject5$3 || (_templateObject5$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcolor: rgb(0, 0, 0);\n\t", "\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);
var ResendSmsTypeContainer = styled_components_browser_esm["default"].div(_templateObject6$2 || (_templateObject6$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\talign-items: center;\n\t&.disableInfo {\n\t\topacity: 0.3;\n\t\tpointer-events: none;\n\t}\n\t.otpScreen__social {\n\t\tdisplay: flex;\n\t}\n\t.otpScreen__social > li {\n\t\twidth: 94px;\n\t\tmargin: 0 0 0 10px;\n\t\tpadding: 4px 14px 5px 8px;\n\t\tborder-radius: 2px;\n\t\tborder: solid 1px #cecece;\n\t\tbackground-color: #fff;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t}\n\t.otpScreen__social > li .gi-tooltip {\n\t\tdisplay: none;\n\t}\n\t.otpScreen__social > li:hover .gi-tooltip {\n\t\tdisplay: block;\n\t}\n"])));

var OtpInputWrapper = function OtpInputWrapper(_ref) {
  var mobileNumber = _ref.mobileNumber,
    onOtpSuccess = _ref.onOtpSuccess,
    isExistingUser = _ref.isExistingUser;
  var verifyNewUser = (0,growth_auth_helpers_esm/* useSignupViaOTPStore */.W3)(function (state) {
    return state.fetch;
  });
  var fetchLoginDetails = (0,growth_auth_helpers_esm/* useLoginUserStore */.lq)(function (state) {
    return state.fetch;
  });
  var otpData = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
    return state.data;
  });
  var _useState = (0,react.useState)(''),
    otp = _useState[0],
    setOtp = _useState[1];
  var _useState2 = (0,react.useState)(false),
    otpVerifying = _useState2[0],
    setOtpVerifying = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    otpError = _useState3[0],
    setOtpError = _useState3[1];
  var _useState4 = (0,react.useState)(''),
    otpErrorMsg = _useState4[0],
    setOtpErrorMsg = _useState4[1];
  (0,react.useEffect)(function () {
    /**
     * this check if otp is invalid then bring focus to 4th input field
     */
    if (otpError && !otpVerifying) {
      var otpList = document.querySelectorAll('input.verifyOtpCont__otpFiled') || [];
      if (otpList[3]) {
        otpList[3].focus();
      }
    }
  }, [otpError, otpVerifying]);
  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
      return {
        prefillData: s.data
      };
    }, shallow/* shallow */.X),
    prefillData = _usePrefillLoginDetai.prefillData;
  var onOtpVerificationSuccess = function onOtpVerificationSuccess(details) {
    setOtpVerifying(false);
    if (onOtpSuccess) onOtpSuccess(details);
  };
  var onOtpVerificationError = function onOtpVerificationError(_ref2) {
    var code = _ref2.code;
    setOtpVerifying(false);
    if (code && code === growth_auth_helpers_esm/* INVALID_OTP_CODE */.Wp) {
      setOtpError(true);
      setOtpErrorMsg('Please enter a valid OTP');
    } else {
      setOtpError(true);
      setOtpErrorMsg('Some error occurred, please try again.');
    }
  };
  var resetErrorState = function resetErrorState() {
    setOtpError(false);
    setOtpErrorMsg('');
  };
  var submitOtp = function submitOtp(value) {
    setOtpVerifying(true);
    resetErrorState();
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_verify_otp_auto", {
      event_detail: {
        event_type: "click_event",
        event_value: "onboarding_flow|" + (isExistingUser ? "login" : "signup")
      }
    });
    if (isExistingUser) {
      fetchLoginDetails({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          passwordType: 'OTP',
          password: value,
          encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
          isEncoded: otpData.isMobileNumberEncoded || undefined
        },
        onSuccess: onOtpVerificationSuccess,
        onError: onOtpVerificationError
      });
    } else {
      verifyNewUser({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          passwordType: 'OTP',
          password: value
        },
        onSuccess: onOtpVerificationSuccess,
        onError: onOtpVerificationError
      });
    }
  };
  var handleOtpChange = function handleOtpChange(value) {
    setOtpVerifying(false);
    setOtp(value);
    if (value.length === 4) {
      submitOtp(value);
    }
  };
  return /*#__PURE__*/react.createElement(OtpWrapper, {
    className: otpError ? 'otpError' : ''
  }, /*#__PURE__*/react.createElement(lib/* default */.Z, {
    value: otp,
    onChange: handleOtpChange,
    numInputs: 4,
    separator: /*#__PURE__*/react.createElement("span", null, "\xA0"),
    containerStyle: "verifyOtpCont__otpCont",
    inputStyle: otpVerifying ? 'verifyOtpCont__otpFiled disabled' : 'verifyOtpCont__otpFiled',
    isInputNum: true,
    shouldAutoFocus: true,
    isDisabled: otpVerifying
  }), /*#__PURE__*/react.createElement("div", {
    className: "verifyOtpCont__message"
  }, otpVerifying && /*#__PURE__*/react.createElement(OtpErrorContainer, null, /*#__PURE__*/react.createElement(growth_loader_esm/* CircularLoader */.V, {
    theme: "blue"
  }), /*#__PURE__*/react.createElement("p", {
    className: "gr-append-left10 robotoRegular gr-font12"
  }, VERIFY_OTP_MSG.verifying)), otpError && /*#__PURE__*/react.createElement(OtpErrorContainer, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icInfoPink errorIcon"
  }), /*#__PURE__*/react.createElement("p", {
    className: "errorMessage"
  }, otpErrorMsg))));
};

var OTP_RESEND_TIME = 30;
var CONFIG_KEY_DWEB_AUTH = 'growth-dweb-header-config';

var tooltipStyle = {
  width: '250px',
  top: 32
};
var tooltipStyle2 = {
  width: '250px',
  top: 32,
  right: 14
};
var ResendOtp = function ResendOtp(_ref) {
  var isExistingUser = _ref.isExistingUser;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return {
        resendOtpApi: state.fetch,
        apiLoading: state.loading,
        mobileNumber: state.data.mobileNumber
      };
    }, shallow/* shallow */.X),
    resendOtpApi = _useSendOtpStore.resendOtpApi,
    mobileNumber = _useSendOtpStore.mobileNumber,
    apiLoading = _useSendOtpStore.apiLoading;
  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
      return {
        prefillData: s.data
      };
    }, shallow/* shallow */.X),
    prefillData = _usePrefillLoginDetai.prefillData;
  var _useState = (0,react.useState)(OTP_RESEND_TIME),
    resendTimer = _useState[0],
    setResendTimer = _useState[1];
  var _useState2 = (0,react.useState)(true),
    isTimerActive = _useState2[0],
    setIsTimerActive = _useState2[1];
  (0,react.useEffect)(function () {
    var timerInterval;
    if (isTimerActive) {
      if (resendTimer === 0) {
        clearInterval(timerInterval);
        setIsTimerActive(false);
      }
      timerInterval = setInterval(function () {
        setResendTimer(function (timer) {
          return timer - 1;
        });
      }, 1000);
    }
    return function () {
      clearInterval(timerInterval);
    };
  }, [isTimerActive, resendTimer]);
  var resendOtp = function resendOtp(type) {
    if (!apiLoading) {
      (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_resend_otp|" + type, {
        event_detail: {
          event_type: "click_event|onboarding_click",
          event_value: "onboarding_flow|" + (isExistingUser ? "login" : "signup")
        }
      });
      adobe.track('ctaClick', {
        cta: {
          name: "resend_otp",
          type: "cardClick|method:" + type + "|flow:" + (isExistingUser ? 'login' : 'signup'),
          componentName: 'GI_USER_ONBOARDING'
        }
      });
      setResendTimer(OTP_RESEND_TIME);
      setIsTimerActive(true);
      var isMobileNumberEncoded = (0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(mobileNumber, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
      resendOtpApi({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          loginType: type,
          encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
          isEncoded: isMobileNumberEncoded || undefined
        }
      });
    }
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ResendOtpTimerContainer, null, RESEND_OTP.label, ' ', resendTimer ? /*#__PURE__*/react.createElement("span", null, RESEND_OTP.timerHeading, /*#__PURE__*/react.createElement(ResendOtpTimer, {
    className: "gi-resend-timer"
  }, resendTimer < 10 ? "00:0" + resendTimer : "00:" + resendTimer)) : null), /*#__PURE__*/react.createElement(ResendSmsTypeContainer, {
    className: "" + (resendTimer ? 'disableInfo' : '')
  }, /*#__PURE__*/react.createElement(ResendOtpTimer, null, "Resend via :"), /*#__PURE__*/react.createElement("ul", {
    className: "otpScreen__social"
  }, /*#__PURE__*/react.createElement("li", {
    onClick: function onClick() {
      return resendOtp(OTP_TYPE.whatsApp);
    },
    role: "presentation"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icWhatsapp gr-append-right5"
  }), /*#__PURE__*/react.createElement("span", {
    className: "gr-quicksand gr-quickSandBold gr-font12 gr-blackText"
  }, "WhatsApp"), /*#__PURE__*/react.createElement(growth_tooltip_esm/* ToolTip */.e, {
    customClass: "gi-tooltip",
    customStyle: tooltipStyle,
    notchPosition: "middle"
  }, /*#__PURE__*/react.createElement("p", {
    className: "gr-font12"
  }, "Please ensure that you have entered your WhatsApp number for OTP"))), /*#__PURE__*/react.createElement("li", {
    onClick: function onClick() {
      return resendOtp(OTP_TYPE.sms);
    },
    role: "presentation"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSms gr-appendRight10"
  }), /*#__PURE__*/react.createElement("span", {
    className: "gr-quicksand gr-quickSandBold gr-font12 gr-blackText"
  }, "SMS"), /*#__PURE__*/react.createElement(growth_tooltip_esm/* ToolTip */.e, {
    customClass: "gi-tooltip",
    customStyle: tooltipStyle2,
    notchPosition: "right"
  }, /*#__PURE__*/react.createElement("p", {
    className: "gr-font12"
  }, "Please don\u2019t share your OTP with anyone"))))));
};

var LoginWithOtp = function LoginWithOtp(_ref) {
  var isMobileNumberDisabled = _ref.isMobileNumberDisabled;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return state.data;
    }),
    mobileNumber = _useSendOtpStore.mobileNumber,
    data = _useSendOtpStore.data;
  var _useAuthFlow = useAuthFlow(function (state) {
      return state;
    }),
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow;
  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'OTP_Screen_Loaded',
        type: "itemLoaded|flow:" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_otp", {
      event_detail: {
        event_type: "load_event|onboarding_click",
        event_value: "onboarding_flow|" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup')
      }
    });
  }, []);
  var onEditMobile = function onEditMobile() {
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
    adobe.track('ctaClick', {
      cta: {
        name: "Edit_Phone_Number",
        destination: 'Login_Popup_Load',
        type: "itemClick|flow:" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
  };
  var onOtpSuccess = function onOtpSuccess() {
    adobe.track('User_Login', {
      account: {
        accountInfo: {
          flow: "" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup')
        }
      },
      cta: {
        type: 'manual',
        name: "Onboarding_" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'Login' : 'Signup') + "_Success",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_POST_AUTH);
  };
  return /*#__PURE__*/react.createElement(MobileContainer, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(MobileHeading, null, Heading), /*#__PURE__*/react.createElement(SubHeading, null, SubHeading$1, /*#__PURE__*/react.createElement("span", null, " ", mobileNumber), !isMobileNumberDisabled && /*#__PURE__*/react.createElement("span", {
    className: "logSprite icEdit",
    onClick: onEditMobile,
    role: "presentation"
  })), /*#__PURE__*/react.createElement(OtpInputWrapper, {
    mobileNumber: mobileNumber,
    onOtpSuccess: onOtpSuccess,
    isExistingUser: data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt
  }), /*#__PURE__*/react.createElement(ResendOtp, {
    isExistingUser: data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt
  })), /*#__PURE__*/react.createElement(LoginTermsAndCondition, null, TERMS_CONDITION));
};

var _templateObject$6, _templateObject2$4, _templateObject3$3, _templateObject4$3, _templateObject5$2, _templateObject6$1, _templateObject7;
var PostAuthContainer = styled_components_browser_esm["default"].div(_templateObject$6 || (_templateObject$6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tjustify-content: flex-start;\n\tmargin: -31px -37px -18px -37px !important;\n\theight: 486px;\n\tinput.loginCont__input {\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\toutline: 0;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #4f525a;\n\t\tborder-radius: 4px;\n\t\tpadding: 0 20px;\n\t}\n\n\t.loginCont__input::placeholder {\n\t\tcolor: #c2c2c2;\n\t\tline-height: 20px !important;\n\t\topacity: 1;\n\t\tfont-weight: 600 !important;\n\t}\n"])));
var PostAuthHeader = styled_components_browser_esm["default"].div(_templateObject2$4 || (_templateObject2$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tbackground-color: #e5f2ff;\n\tcolor: #2d67b2;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 24px 16px;\n\tborder-radius: 10px;\n\tspan {\n\t\tmargin-right: 20px;\n\t}\n\n\t.successMsg__title {\n\t\tfont-size: 22px;\n\t\tline-height: 27px;\n\t\tcolor: #00962d;\n\n\t\tfont-weight: 500;\n\t}\n\n\t.successMsg__subTitle {\n\t\tfont-size: 18px;\n\t\tline-height: 27px;\n\t\tcolor: #4f525a;\n\n\t\tfont-weight: 500;\n\t}\n"])));
var postAuthForms = styled_components_browser_esm["default"].div(_templateObject3$3 || (_templateObject3$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin: 30px 27px 15px 37px;\n\twidth: 300px;\n\t.gi-marginBottom25 {\n\t\tmargin-bottom: 25px;\n\t}\n"])));
var postAuthFormHeading = styled_components_browser_esm["default"].p(_templateObject4$3 || (_templateObject4$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 13px;\n\tmargin-bottom: 20px;\n\tline-height: 18px !important;\n"])));
var PostAuthSubmitButton = styled_components_browser_esm["default"].button(_templateObject5$2 || (_templateObject5$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 13px 118px 13px 116px;\n\tmargin-top: 22px;\n\tborder-radius: 8px;\n\tbackground-color: #ff6d38;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\n\t&.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n"])));
var SkipUpdate = styled_components_browser_esm["default"].div(_templateObject6$1 || (_templateObject6$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\ttext-align: center;\n\tmargin-top: 30px;\n\n\tbutton {\n\t\tcolor: #008cff !important;\n\t\tcursor: pointer;\n\t\tborder: 0;\n\t\tbackground-color: transparent;\n\t\ttext-decoration: none;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t}\n"])));
var ErrorMsg = styled_components_browser_esm["default"].p(_templateObject7 || (_templateObject7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tmargin-top: 10px !important;\n\n\tcolor: #e53442;\n"])));

var SIGNUP_SUCCESS_TOAST = {
  title: 'Congratulations',
  subTitle: 'Account created successfully'
};
var LOGIN_SUCCESS_TOAST = {
  title: 'Congratulations',
  subTitle: 'You have successfully logged in'
};
var DO_IT_LATER = {
  title: 'I’ll do it later'
};
var VALIDATION_MSG = {
  email: {
    invalid: "Enter a valid email"
  },
  name: {
    invalid: "Please enter valid name using only alphabets"
  }
};

var UpdateDetailsForm = function UpdateDetailsForm(_ref) {
  var firstName = _ref.firstName,
    primaryEmailId = _ref.primaryEmailId,
    handleUserUpdate = _ref.handleUserUpdate,
    handleDoItLaterClick = _ref.handleDoItLaterClick,
    apiFailureMsg = _ref.apiFailureMsg,
    isExistingUser = _ref.isExistingUser;
  var _useState = (0,react.useState)(false),
    isFormValid = _useState[0],
    setIsFormValid = _useState[1];
  var _useState2 = (0,react.useState)(''),
    name = _useState2[0],
    setName = _useState2[1];
  var _useState3 = (0,react.useState)(''),
    email = _useState3[0],
    setEmail = _useState3[1];
  var _useState4 = (0,react.useState)(false),
    isError = _useState4[0],
    setIsError = _useState4[1];
  var _useState5 = (0,react.useState)(''),
    errorMsg = _useState5[0],
    setErrorMsg = _useState5[1];
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  (0,react.useEffect)(function () {
    setErrorMsg(apiFailureMsg);
    setIsError(!!apiFailureMsg);
  }, [apiFailureMsg]);
  var handleNameChange = function handleNameChange(e) {
    setName(e.target.value);
  };
  var handleEmailChange = function handleEmailChange(e) {
    setEmail(e.target.value);
  };
  var validateProfileUpdate = function validateProfileUpdate(_ref2) {
    var _ref2$fullName = _ref2.fullName,
      fullName = _ref2$fullName === void 0 ? '' : _ref2$fullName,
      _ref2$inputEmail = _ref2.inputEmail,
      inputEmail = _ref2$inputEmail === void 0 ? '' : _ref2$inputEmail;
    if (fullName && email) {
      if (!(0,growth_auth_helpers_esm/* isEmailValid */.Ju)(inputEmail)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.email.invalid
      };
      if (!(0,growth_auth_helpers_esm/* isNameValid */.Pz)(fullName)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.name.invalid
      };
    }
    if (!fullName && inputEmail) {
      if (!(0,growth_auth_helpers_esm/* isEmailValid */.Ju)(inputEmail)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.email.invalid
      };
    }
    if (!inputEmail && fullName) {
      if (!(0,growth_auth_helpers_esm/* isNameValid */.Pz)(fullName)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.name.invalid
      };
    }
    return {
      isValid: true,
      errorMessage: ''
    };
  };
  var onUserUpdate = function onUserUpdate() {
    var _validateProfileUpdat = validateProfileUpdate({
        fullName: name,
        inputEmail: email
      }),
      isValid = _validateProfileUpdat.isValid,
      errorMessage = _validateProfileUpdat.errorMessage;
    if (isValid) {
      if (handleUserUpdate) handleUserUpdate({
        fullName: name,
        email: email
      });
    } else {
      setErrorMsg(errorMessage);
      setIsError(true);
    }
  };
  var onSkipClick = function onSkipClick() {
    if (handleDoItLaterClick) handleDoItLaterClick();
  };
  (0,react.useEffect)(function () {
    if (name || email) {
      setIsFormValid(true);
    } else {
      setIsError(false);
      setErrorMsg('');
    }
  }, [name, email]);
  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'Profile_Update_Screen_Loaded',
        type: "itemLoaded|flow:" + (isExistingUser ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
  }, []);
  return /*#__PURE__*/react.createElement(postAuthForms, null, /*#__PURE__*/react.createElement(postAuthFormHeading, null, "Just one more thing."), /*#__PURE__*/react.createElement("div", {
    className: "gi-marginBottom25"
  }, !firstName ? /*#__PURE__*/react.createElement(InputWrapper, {
    type: "text",
    name: "name",
    label: "What do we call you?",
    placeholder: "Enter your full name",
    inputClassName: "loginCont__input",
    inputVal: name,
    onChange: handleNameChange
  }) : null), !primaryEmailId ? /*#__PURE__*/react.createElement(InputWrapper, {
    type: "email",
    name: "Email",
    label: "What's your email id?",
    placeholder: "Enter your email address",
    inputClassName: "loginCont__input",
    inputVal: email,
    onChange: handleEmailChange
  }) : null, isError && /*#__PURE__*/react.createElement(ErrorMsg, null, errorMsg, " "), /*#__PURE__*/react.createElement(PostAuthSubmitButton, {
    type: "button",
    className: !isFormValid ? 'disabled' : '',
    onClick: onUserUpdate
  }, "Lets Go"), /*#__PURE__*/react.createElement(SkipUpdate, null, /*#__PURE__*/react.createElement("button", {
    type: "button",
    onClick: onSkipClick || null
  }, DO_IT_LATER.title)));
};

var CloseIcon = function CloseIcon(_ref) {
  var closeAuth = _ref.closeAuth;
  return /*#__PURE__*/react.createElement(AuthVerificationFlowCloseIcon, {
    "aria-hidden": "true"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icClose",
    onClick: closeAuth,
    role: "presentation"
  }));
};

var UpdateProfile = function UpdateProfile(props) {
  var _userDetails$data;
  var closeAndLogin = props.closeAndLogin,
    onProfileComplete = props.onProfileComplete,
    onLoginComplete = props.onLoginComplete;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useState = (0,react.useState)(''),
    apiFailureMsg = _useState[0],
    setApiFailureMsg = _useState[1];
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return state.data;
    }),
    mobileNumber = _useSendOtpStore.mobileNumber,
    data = _useSendOtpStore.data;
  var _useLoginUserStore = (0,growth_auth_helpers_esm/* useLoginUserStore */.lq)(function (s) {
      return {
        userDetails: s.data,
        fetchLoginDetails: s.fetch
      };
    }, shallow/* shallow */.X),
    userDetails = _useLoginUserStore.userDetails,
    fetchLoginDetails = _useLoginUserStore.fetchLoginDetails;
  var _useSignupViaOTPStore = (0,growth_auth_helpers_esm/* useSignupViaOTPStore */.W3)(function (s) {
      var _s$data;
      return {
        transactionId: (_s$data = s.data) == null ? void 0 : _s$data.transactionId,
        createNewUser: s.createUser
      };
    }, shallow/* shallow */.X),
    transactionId = _useSignupViaOTPStore.transactionId,
    createNewUser = _useSignupViaOTPStore.createNewUser;
  var updateUserDetails = (0,growth_auth_helpers_esm/* useProfileUpdateStore */.IR)(function (s) {
    return s.fetch;
  });
  var profileDetails = (userDetails == null || (_userDetails$data = userDetails.data) == null || (_userDetails$data = _userDetails$data.profileLoginResponse) == null ? void 0 : _userDetails$data[0]) || {};
  var _ref = profileDetails.userDetails || {},
    _ref$extendedUser = _ref.extendedUser,
    extendedUser = _ref$extendedUser === void 0 ? {} : _ref$extendedUser;
  var _extendedUser$persona = extendedUser.personalDetails,
    personalDetails = _extendedUser$persona === void 0 ? {} : _extendedUser$persona,
    _extendedUser$loginIn = extendedUser.loginInfoList,
    loginInfoList = _extendedUser$loginIn === void 0 ? [] : _extendedUser$loginIn,
    _extendedUser$miscFie = extendedUser.miscFields,
    miscFields = _extendedUser$miscFie === void 0 ? {} : _extendedUser$miscFie;
  var _personalDetails$name = personalDetails.name,
    name = _personalDetails$name === void 0 ? {} : _personalDetails$name;
  var isExistingUser = data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt;
  var primaryEmailId = '';
  loginInfoList.forEach(function (item) {
    if (item.loginType === 'EMAIL') {
      primaryEmailId = item.loginId;
    }
  });
  if (!primaryEmailId) {
    primaryEmailId = miscFields == null ? void 0 : miscFields.altEmailId;
  }
  var onLoginSuccess = function onLoginSuccess() {
    // adding timeout as api take some time to remove cache and update user details
    if (onLoginComplete) onLoginComplete(userDetails);
  };
  var onLoginError = function onLoginError() {
    setApiFailureMsg('Something went wrong, please try again.');
  };
  var onUserUpdate = function onUserUpdate(_ref2) {
    var fullName = _ref2.fullName,
      email = _ref2.email;
    setApiFailureMsg('');
    adobe.track('Profile_Completion');
    if (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt) {
      var details = {
        mobileNumber: mobileNumber
      };
      if (fullName) details.firstName = fullName;
      if (email) details.email = email;
      updateUserDetails({
        data: details,
        platform: 'dweb',
        onSuccess: onLoginSuccess,
        onError: onLoginError
      });
    } else if (!isExistingUser) {
      createNewUser({
        platform: 'dweb',
        fullName: fullName,
        email: email,
        mobileNumber: mobileNumber,
        transactionId: transactionId
      }).then(function (res) {
        var _res$result;
        if (res != null && (_res$result = res.result) != null && _res$result.success) {
          fetchLoginDetails({
            platform: 'dweb',
            data: {
              mobileNumber: mobileNumber,
              passwordType: 'TRANSITION_ID',
              password: transactionId
            },
            onSuccess: onLoginSuccess,
            onError: onLoginError
          });
        }
      })["catch"](function () {
        return onLoginError();
      });
    }
  };
  var handleDoItLaterClick = function handleDoItLaterClick() {
    adobe.track('ctaClick', {
      cta: {
        name: 'skip-profile-update',
        type: "itemClick|flow:" + (isExistingUser ? 'login' : 'signup'),
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (isExistingUser) {
      if (closeAndLogin) closeAndLogin();
    } else {
      onUserUpdate({
        fullName: '',
        email: ''
      });
    }
  };
  (0,react.useEffect)(function () {
    if (isExistingUser) {
      if (name.firstName && primaryEmailId) {
        onProfileComplete();
      }
    }
  }, [isExistingUser, name, primaryEmailId]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(CloseIcon, {
    closeAuth: handleDoItLaterClick
  }), /*#__PURE__*/react.createElement(PostAuthContainer, null, /*#__PURE__*/react.createElement(PostAuthHeader, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSuccessBig"
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h3", {
    className: "successMsg__title"
  }, LOGIN_SUCCESS_TOAST.title), /*#__PURE__*/react.createElement("p", {
    className: "successMsg__subTitle"
  }, isExistingUser ? LOGIN_SUCCESS_TOAST.subTitle : SIGNUP_SUCCESS_TOAST.subTitle))), /*#__PURE__*/react.createElement(UpdateDetailsForm, {
    apiFailureMsg: apiFailureMsg,
    firstName: name.firstName,
    primaryEmailId: primaryEmailId,
    handleUserUpdate: onUserUpdate,
    handleDoItLaterClick: handleDoItLaterClick,
    isExistingUser: isExistingUser
  })));
};

/** Create a new configStore instance for dweb-auth */
var useConfigStore = (0,growth_config_store_browser_esm/* createConfigStore */.Ao)();

var _templateObject$5, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$1;
var AuthOfferStyle = styled_components_browser_esm["default"].div(_templateObject$5 || (_templateObject$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 343px;\n\theight: 432px;\n\tbackground-color: rgb(255, 255, 255);\n\tborder-radius: 20px 0px 0px 20px;\n\tflex-shrink: 0;\n\toverflow: hidden;\n\tpadding: 22px 20px 30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\t", "\n\tcursor: ", ";\n"])), function (_ref) {
  var bg = _ref.bg;
  return !bg ? "background:linear-gradient(\n\t\t197.24deg,\n\t\trgb(194, 212, 255) 16.45%,\n\t\trgb(251, 241, 255) 39.26%,\n\t\trgb(234, 243, 243) 59.99%\n\t);\n\tbackground-size:0% 0% / cover;" : "background: #fff url(" + bg + ") top left no-repeat;\n\tbackground-size: cover;";
}, function (_ref2) {
  var clickable = _ref2.clickable;
  return clickable ? 'pointer' : 'auto';
});
var offerBannerHeading = styled_components_browser_esm["default"].h3(_templateObject2$3 || (_templateObject2$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n\tcolor: rgb(20, 24, 35);\n\tmargin-bottom: 30px;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var offerBannerSubHeading = styled_components_browser_esm["default"].p(_templateObject3$2 || (_templateObject3$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #4f525a;\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var smooth = (0,styled_components_browser_esm.keyframes)(_templateObject4$2 || (_templateObject4$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose([" {\n\tfrom {\n\t  opacity: 0;\n\t}\n  \n\tto {\n\t  opacity: 2;\n\t}\n  }"])));
var Smooth = styled_components_browser_esm["default"].div(_templateObject5$1 || (_templateObject5$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tanimation: ", ";\n"])), smooth);

var _templateObject$4, _templateObject2$2, _templateObject3$1, _templateObject4$1, _templateObject5, _templateObject6;
var BenefitsContainer = styled_components_browser_esm["default"].ul(_templateObject$4 || (_templateObject$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-top: 15px;\n\tmargin-left: -6px;\n"])));
var BenefitsList = styled_components_browser_esm["default"].li(_templateObject2$2 || (_templateObject2$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 20px;\n\n\t.benefitsList_item_wrapper {\n\t\tflex: 1;\n\t}\n\t.benefitsList_item_IconWrapper {\n\t\twidth: 52px;\n\t\theight: 52px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex-shrink: 0;\n\t\tmargin-right: 20px;\n\t\tmargin-top: -12px;\n\t}\n\n\t.benefitsList_item_IconWrapper.giftIcon {\n\t\tmargin-top: -24px;\n\t}\n\n\t.icGoCash {\n\t\twidth: 73px;\n\t\theight: 44px;\n\t\tbackground: url(https://gos3.ibcdn.com/go-cash-icon-1674207238.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n\n\t.icGoTribe {\n\t\twidth: 52px;\n\t\theight: 15px;\n\t\tbackground: url(https://gos3.ibcdn.com/gotribe-logo-1674203779.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n\n\t.icGiftBlue {\n\t\twidth: 37px;\n\t\theight: 42px;\n\t\tbackground: url(https://gos3.ibcdn.com/surprice-offer-icon-1674203743.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n"])));
var BenifitsImage = styled_components_browser_esm["default"].div(_templateObject3$1 || (_templateObject3$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 52px;\n\theight: 52px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n\tmargin-right: 20px;\n\tbackground: url(", ");\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tcursor: pointer;\n\tmargin-top: -10px;\n"])), function (props) {
  return props.imgUrl;
});
var BenefitsContainerHeading = styled_components_browser_esm["default"].div(_templateObject4$1 || (_templateObject4$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n\tmargin-bottom: 6px;\n"])), growth_design_system_esm/* headingSizes.Small */.$G.Small);
var BenefitsContainerSubHeading = styled_components_browser_esm["default"].div(_templateObject5 || (_templateObject5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n\t&.lastChild {\n\t\tborder-bottom: none;\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var BenifitsDivider = styled_components_browser_esm["default"].div(_templateObject6 || (_templateObject6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tborder-bottom: 1px solid #cdcdcd;\n\tmargin-top: 20px;\n"])));

var OfferBenefits = function OfferBenefits(props) {
  var _props$benefitsList = props.benefitsList,
    benefitsList = _props$benefitsList === void 0 ? [] : _props$benefitsList;
  return /*#__PURE__*/react.createElement(BenefitsContainer, null, benefitsList.map(function (benefit) {
    return /*#__PURE__*/react.createElement(BenefitsList, {
      key: benefit.id
    }, /*#__PURE__*/react.createElement(BenifitsImage, {
      imgUrl: benefit.imgUrl
    }), /*#__PURE__*/react.createElement("div", {
      className: "benefitsList_item_wrapper"
    }, /*#__PURE__*/react.createElement(BenefitsContainerHeading, null, benefit.heading, " "), /*#__PURE__*/react.createElement(BenefitsContainerSubHeading, null, benefit.subHeading, " "), /*#__PURE__*/react.createElement(BenifitsDivider, null)));
  }));
};

var _templateObject$3, _templateObject2$1, _templateObject3, _templateObject4;
var OfferBanner$1 = styled_components_browser_esm["default"].div(_templateObject$3 || (_templateObject$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tbackground: rgb(255, 255, 255);\n\tbox-shadow: rgba(0, 0, 0, 0.08) 2px 4px 8px;\n\tborder-radius: 2px;\n\tpadding: 10px 20px;\n\tborder-left: 6px solid rgb(28, 114, 226);\n\twidth: 303px;\n"])));
var OfferBannerHeading = styled_components_browser_esm["default"].p(_templateObject2$1 || (_templateObject2$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(79, 82, 90);\n\tmargin-bottom: 5px;\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var OfferBannerSubHeading = styled_components_browser_esm["default"].p(_templateObject3 || (_templateObject3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(101, 102, 104);\n\tmargin-bottom: 5px;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var OfferBannerCouponCode = styled_components_browser_esm["default"].p(_templateObject4 || (_templateObject4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(28, 114, 226);\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);

var OfferBanner = function OfferBanner(props) {
  var heading = props.heading,
    subHeading = props.subHeading,
    couponCode = props.couponCode;
  return /*#__PURE__*/react.createElement(OfferBanner$1, null, /*#__PURE__*/react.createElement(OfferBannerHeading, null, heading), /*#__PURE__*/react.createElement(OfferBannerSubHeading, null, subHeading), /*#__PURE__*/react.createElement(OfferBannerCouponCode, null, couponCode));
};

var _templateObject$2, growth_gi_dweb_auth_esm_templateObject2;
var Wrap = styled_components_browser_esm["default"].div(_templateObject$2 || (_templateObject$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n"])));
var Bg = styled_components_browser_esm["default"].div(growth_gi_dweb_auth_esm_templateObject2 || (growth_gi_dweb_auth_esm_templateObject2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 44px;\n\twidth: 44px;\n\tjustify-content: center;\n\talign-items: center;\n\tdisplay: flex;\n\tbox-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);\n\tborder-radius: 50px;\n"])));
var Loader = function Loader() {
  return /*#__PURE__*/react.createElement(Wrap, null, /*#__PURE__*/react.createElement(Bg, null, /*#__PURE__*/react.createElement(growth_loader_esm/* CircularLoader */.V, null)));
};

var DEFAULT_CONFIG = {
  loginPopover: {
    signUp: {
      ctaText: 'Login/Sign Up',
      coupon: 'Use Coupon : WELCOME'
    }
  },
  loginCtaLabels: [{
    text: 'LOGIN / SIGNUP',
    id: 'text_1'
  }, {
    text: 'Exclusive Offers',
    id: 'text_2'
  }, {
    text: 'Earn goCash',
    id: 'text_3'
  }, {
    text: 'Manage Your Trips',
    id: 'text_4'
  }, {
    text: 'LOGIN / SIGNUP',
    id: 'text_5'
  }],
  bookingOffers: {
    growth: {
      title: 'FLAT 12% OFF*',
      subTitle: 'on your first Flight booking'
    },
    flights: {
      title: 'FLAT 12% OFF*',
      subTitle: 'on your first Flight booking'
    },
    hotels: {
      title: 'FLAT 25% OFF* ',
      subTitle: 'on your first Hotel booking'
    },
    bus: {
      title: 'FLAT 10% OFF*',
      subTitle: 'on your first Bus booking'
    },
    cabs: {
      title: 'Upto 10% OFF*',
      subTitle: 'on your first Cab booking'
    },
    trains: {
      title: 'Zero service fees',
      subTitle: 'on your first Train booking'
    }
  },
  loginDialog: {
    heading: 'Unlock these benefits',
    subHeading: '',
    salesOffers: {},
    benefits: [{
      id: 1,
      heading: 'Earn goCash',
      subHeading: '100 on Sign Up & Cashback on Bookings',
      imgUrl: 'https://gos3.ibcdn.com/go-cash-icon-1674207238.png'
    }, {
      id: 2,
      heading: 'Loyalty Benefits',
      subHeading: 'Extra Discounts, Free Seat Selection etc.',
      imgUrl: 'https://gos3.ibcdn.com/gotribe-logo-1674203779.png'
    }, {
      id: 3,
      heading: 'Exclusive Offers',
      subHeading: 'Daily Steal Deals & Special Discounts',
      imgUrl: 'https://gos3.ibcdn.com/surprice-offer-icon-1674203743.png'
    }]
  }
};

var AuthOfferBanner = function AuthOfferBanner(props) {
  var _D4, _D5, _D6, _D7;
  var lobName = props.lobName,
    showBanner = props.showBanner;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _ref = useConfigStore(),
    data = _ref.data,
    loading = _ref.loading,
    error = _ref.error,
    loaded = _ref.loaded;
  var configData = function configData() {
    var _data$COMMON;
    var d = data == null || (_data$COMMON = data.COMMON) == null || (_data$COMMON = _data$COMMON[CONFIG_KEY_DWEB_AUTH]) == null ? void 0 : _data$COMMON.data;
    if (loaded && !error && d) {
      return d;
    }
    return DEFAULT_CONFIG;
  };
  var _ref2 = configData(),
    loginDialog = _ref2.loginDialog,
    bookingOffers = _ref2.bookingOffers;
  var _ref3 = loginDialog || {},
    benefits = _ref3.benefits,
    salesOffers = _ref3.salesOffers,
    heading = _ref3.heading,
    subHeading = _ref3.subHeading;
  var D;
  if (showBanner && (salesOffers || bookingOffers)) {
    D = {
      salesOffers: salesOffers == null ? void 0 : salesOffers[lobName],
      bookingOffers: bookingOffers == null ? void 0 : bookingOffers[lobName]
    };
  }
  var hasSalesOffersExpired = function hasSalesOffersExpired() {
    var _D, _D2;
    if ((_D = D) != null && (_D = _D.salesOffers) != null && _D.imgUrl && (_D2 = D) != null && (_D2 = _D2.salesOffers) != null && _D2.expiry) {
      // expire date format: MM/DD/YYYY
      return (0,growth_date_utils_esm/* isDateExpired */.Zz)({
        now: new Date().getTime(),
        expire: new Date(D.salesOffers.expiry).getTime()
      });
    }
    return true;
  };
  var shouldShowSalesImage = !hasSalesOffersExpired();
  var handleSalesImageClick = function handleSalesImageClick() {
    var _D3;
    adobe.track('ctaClick', {
      cta: {
        name: "Sale_Banner_Clicked",
        type: 'itemClick',
        componentName: "GI_USER_ONBOARDING"
      }
    });
    if (shouldShowSalesImage && (_D3 = D) != null && (_D3 = _D3.salesOffers) != null && _D3.ctaUrl) {
      window.open(D.salesOffers.ctaUrl, '_blank');
    }
  };
  (0,react.useEffect)(function () {
    if (loaded) {
      if (shouldShowSalesImage) {
        // send event when sales has to be display
        adobe.track('ctaClick', {
          cta: {
            name: 'Sale_Banner_loaded',
            type: "itemLoaded",
            componentName: "GI_USER_ONBOARDING"
          }
        });
      }
      (0,growth_pdt_push_esm/* pdtPush */.g)("login_leaflet_load", {
        event_detail: {
          event_type: "load_event|onboarding_click",
          event_value: "" + (shouldShowSalesImage ? "sale_flow" : "onboarding_flow")
        }
      });
    }
  }, [loaded, shouldShowSalesImage]);
  if (!showBanner) {
    return null;
  }
  return /*#__PURE__*/react.createElement(AuthOfferStyle, {
    className: "gr-home",
    "data-id": "auth-offer-banner",
    bg: shouldShowSalesImage ? (_D4 = D) == null || (_D4 = _D4.salesOffers) == null ? void 0 : _D4.imgUrl : '',
    onClick: handleSalesImageClick,
    clickable: !!shouldShowSalesImage
  }, loading ? /*#__PURE__*/react.createElement(Loader, null) : /*#__PURE__*/react.createElement(Smooth, null, heading && !shouldShowSalesImage && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(offerBannerHeading, {
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), /*#__PURE__*/react.createElement(offerBannerSubHeading, null, subHeading), /*#__PURE__*/react.createElement(OfferBenefits, {
    benefitsList: benefits
  })), /*#__PURE__*/react.createElement(OfferBanner, {
    heading: (_D5 = D) == null || (_D5 = _D5.bookingOffers) == null ? void 0 : _D5.title,
    subHeading: (_D6 = D) == null || (_D6 = _D6.bookingOffers) == null ? void 0 : _D6.subTitle,
    couponCode: (_D7 = D) == null || (_D7 = _D7.bookingOffers) == null ? void 0 : _D7.coupon
  }))));
};

var _templateObject$1;
var ToastContainer = styled_components_browser_esm["default"].div(_templateObject$1 || (_templateObject$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\ttext-align: left;\n\n\t.icSuccessBig {\n\t\tmargin-right: 40px;\n\t}\n\n\t.successMsg__title {\n\t\t", "\n\t\tcolor: #00962d;\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.successMsg__subTitle {\n\t\t", "\n\t\tcolor: #4f525a;\n\t}\n\n\t.closeIcon {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tright: 20px;\n\t\ttop: 20px;\n\t}\n"])), growth_design_system_esm/* headingSizes.MediumW1 */.$G.MediumW1, growth_design_system_esm/* textSizes.LargeW2 */.iH.LargeW2);

var ProfileCompletedToast = function ProfileCompletedToast(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Toast, {
    style: {
      'width': '600px',
      'background': '#fff',
      'padding': '30px 40px',
      'alignItems': 'center',
      'borderRadius': '10px',
      'maxHeight': 'unset',
      'zIndex': ' 1025'
    },
    autoHideDuration: 3000,
    onClose: onClose
  }, /*#__PURE__*/react.createElement(ToastContainer, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSuccessBig"
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h3", {
    className: "successMsg__title"
  }, "Congratulations"), /*#__PURE__*/react.createElement("p", {
    className: "successMsg__subTitle"
  }, "You have successfully logged in")), /*#__PURE__*/react.createElement("span", {
    className: " closeIcon logSprite icClose"
  }))));
};

var AuthVerificationFlow = function AuthVerificationFlow(props) {
  var _props$showCloseButto = props.showCloseButton,
    showCloseButton = _props$showCloseButto === void 0 ? true : _props$showCloseButto,
    onClose = props.onClose,
    screenName = props.screenName,
    lobName = props.lobName,
    onLoginSuccess = props.onLoginSuccess,
    prefillMobileNumber = props.prefillMobileNumber,
    isMobileNumberDisabled = props.isMobileNumberDisabled,
    skipMobileScreen = props.skipMobileScreen;
  var _useAuthFlow = useAuthFlow(function (state) {
      return {
        activeAuthFlow: state.activeAuthFlow,
        setActiveAuthFlow: state.setActiveAuthFlow
      };
    }, shallow/* shallow */.X),
    activeAuthFlow = _useAuthFlow.activeAuthFlow,
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useState = (0,react.useState)(false),
    showSuccessToast = _useState[0],
    setShowSuccessToast = _useState[1];
  (0,react.useEffect)(function () {
    if (screenName) setActiveAuthFlow(screenName);
  }, [screenName]);
  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'Login_Popup_Load',
        type: "itemLoaded",
        componentName: "GI_USER_ONBOARDING"
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_load", {
      event_detail: {
        event_type: "load_event|onboarding_click",
        event_Value: "onboarding_flow|" + lobName
      }
    });
  }, []);
  var closeAuth = function closeAuth() {
    adobe.track('ctaClick', {
      cta: {
        name: "Close Modal",
        type: "itemClick|flow:" + activeAuthFlow,
        componentName: "GI_USER_ONBOARDING"
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_close", {
      event_detail: {
        event_type: "click_event",
        event_Value: "onboarding_flow|flow:" + activeAuthFlow
      }
    });
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
    if (onClose) onClose();
  };
  var onProfileComplete = function onProfileComplete() {
    setShowSuccessToast(true);
    if (onLoginSuccess) onLoginSuccess();
  };
  var closeAndLogin = function closeAndLogin() {
    var _window$GI;
    /** works on older header, gi-happy-header */
    /** @deprecated */
    if ((_window$GI = window.GI) != null && _window$GI.HeaderEvent) {
      window.GI.HeaderEvent.trigger('LOGIN_SUCCESS');
    }
    growth_dom_event_emitter_esm/* default.emit */.Z.emit(growth_auth_helpers_esm/* LOGIN_SUCCESS */.XP);
    if (onLoginSuccess) onLoginSuccess();
    if (onClose) onClose();
  };
  var onLoginComplete = function onLoginComplete() {
    closeAndLogin();
  };
  if (showSuccessToast) {
    return /*#__PURE__*/react.createElement(ProfileCompletedToast, {
      onClose: onLoginComplete
    });
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(AuthOfferBanner, {
    lobName: lobName,
    showBanner: activeAuthFlow !== AUTH_FLOW_STEPS.STEP_POST_AUTH
  }), /*#__PURE__*/react.createElement(AuthVerificationFlowSection, {
    height: activeAuthFlow === AUTH_FLOW_STEPS.STEP_POST_AUTH ? '486px' : undefined,
    "data-id": "auth-flow-section"
  }, showCloseButton && activeAuthFlow !== AUTH_FLOW_STEPS.STEP_POST_AUTH ? /*#__PURE__*/react.createElement(CloseIcon, {
    closeAuth: closeAuth
  }) : null, activeAuthFlow === AUTH_FLOW_STEPS.STEP_MOBILE && /*#__PURE__*/react.createElement(LoginWithMobile, {
    prefillMobileNumber: prefillMobileNumber,
    isMobileNumberDisabled: isMobileNumberDisabled,
    skipMobileScreen: skipMobileScreen
  }), activeAuthFlow === AUTH_FLOW_STEPS.STEP_OTP && /*#__PURE__*/react.createElement(LoginWithOtp, {
    isMobileNumberDisabled: isMobileNumberDisabled
  }), activeAuthFlow === AUTH_FLOW_STEPS.STEP_POST_AUTH && /*#__PURE__*/react.createElement(UpdateProfile, {
    closeAndLogin: closeAndLogin,
    onProfileComplete: onProfileComplete,
    onLoginComplete: onLoginComplete
  })));
};

var AuthContainer = function AuthContainer(props) {
  var configData = props.configData;

  /** Memorize b/c we don't want to call the setData again if there in no change in configData */
  (0,react.useMemo)(function () {
    if (configData) (0,growth_config_store_browser_esm/* setData */.a_)(useConfigStore, configData);
  }, [configData]);
  var _useConfigStore = useConfigStore(function (s) {
      return {
        fetchConfigStore: s.fetch
      };
    }, shallow/* shallow */.X),
    fetchConfigStore = _useConfigStore.fetchConfigStore;
  (0,react.useEffect)(function () {
    fetchConfigStore({
      keys: CONFIG_KEY_DWEB_AUTH,
      lobs: 'COMMON',
      initData: configData
    });
  }, []);
  return /*#__PURE__*/react.createElement(AuthContainer$1, {
    "data-id": "auth-container"
  }, /*#__PURE__*/react.createElement(AuthVerificationFlow, props));
};

var growth_gi_dweb_auth_esm_templateObject;
var CommonSpriteStyle = (0,styled_components_browser_esm.createGlobalStyle)(growth_gi_dweb_auth_esm_templateObject || (growth_gi_dweb_auth_esm_templateObject = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\n  .logSprite {\n    background: url(https://gos3.ibcdn.com/happy-sprite-1608708553.png) no-repeat;\n    display: inline-block;\n    background-size: 300px 300px;\n    font-size: 0;\n    flex-shrink: 0;\n  }\n\n  .logSprite.icGift {\n    width: 42px;\n    height: 42px;\n    background-position: -10px -9px;\n  }\n\n  .logSprite.icClose {\n    width: 16px;\n    height: 16px;\n    background-position: -180px -8px;\n    cursor: pointer;\n  }\n\n  .logSprite.icSuccessBig {\n    width: 41px;\n    height: 40px;\n    background-position: -60px -11px;\n  }\n\n  .logSprite.icSuccessSmall {\n    width: 19px;\n    height: 18px;\n    background-position: -132px -33px;\n  }\n\n  .logSprite.icShowPassword {\n    width: 17px;\n    height: 15px;\n    background-position: -105px -9px;\n    cursor: pointer;\n  }\n\n  .logSprite.icSms {\n    width: 13px;\n    height: 12px;\n    background-position: -110px -39px;\n  }\n\n  .logSprite.icWhatsapp {\n    width: 13px;\n    height: 12px;\n    background-position: -157px -11px;\n  }\n\n  .logSprite.icInfoPink {\n    width: 18px;\n    height: 19px;\n    background-position: -131px -9px;\n    cursor: pointer;\n  }\n\n  .logSprite.icEdit {\n    width: 17px;\n    height: 17px;\n    background-position: -157px -34px;\n    cursor: pointer;\n  }\n\n  .logSprite.icOrangeTick {\n    width: 23px;\n    height: 23px;\n    background-position: -179px -29px;\n    cursor: pointer;\n  }\n\n  .ldrShimmer {\n    animation-duration: 1.5s;\n    animation-fill-mode: forwards;\n    animation-iteration-count: infinite;\n    animation-name: shimmer;\n    animation-timing-function: linear;\n    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);\n    background-size: 800px 104px;\n    position: relative;\n  }\n\n\n\n"])));

var Container = function Container(_ref) {
  var prefillMobileNumber = _ref.prefillMobileNumber,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
    onClose = _ref.onClose,
    lobName = _ref.lobName,
    onLoginSuccess = _ref.onLoginSuccess,
    _ref$debug = _ref.debug,
    debug = _ref$debug === void 0 ? false : _ref$debug,
    _ref$isMobileNumberDi = _ref.isMobileNumberDisabled,
    isMobileNumberDisabled = _ref$isMobileNumberDi === void 0 ? false : _ref$isMobileNumberDi,
    _ref$skipMobileScreen = _ref.skipMobileScreen,
    skipMobileScreen = _ref$skipMobileScreen === void 0 ? false : _ref$skipMobileScreen,
    configData = _ref.configData;
  var _useState = (0,react.useState)(false),
    isOnClient = _useState[0],
    setIsOnClient = _useState[1];
  (0,react.useEffect)(function () {
    setIsOnClient(true);
  }, []);
  if (isOnClient) {
    var _initAnalytics = initAnalytics({
        lobName: lobName,
        debug: debug
      }),
      adobeInstance = _initAnalytics.adobeInstance;
    return /*#__PURE__*/react.createElement(styled_components_browser_esm.ThemeProvider, {
      theme: growth_app_theme_esm/* defaultTheme */.uH
    }, /*#__PURE__*/react.createElement(CommonSpriteStyle, null), /*#__PURE__*/react.createElement(growth_use_analytics_esm/* AnalyticsContextProvider */.nx, {
      adobeInstance: adobeInstance
    }, /*#__PURE__*/react.createElement(AuthContainer, {
      lobName: lobName,
      onLoginSuccess: onLoginSuccess,
      onClose: onClose,
      showCloseButton: showCloseButton,
      prefillMobileNumber: prefillMobileNumber,
      isMobileNumberDisabled: isMobileNumberDisabled,
      skipMobileScreen: skipMobileScreen,
      configData: configData
    })));
  }
  return null;
};




/***/ }),

/***/ 305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ CircularLoader; }
});

// UNUSED EXPORTS: FullPageLoaderMweb

;// CONCATENATED MODULE: ../../node_modules/@growth/loader/dist/taggedTemplateLiteralLoose-8a80a17d.esm.js
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../node_modules/@growth/loader/dist/growth-loader.esm.js




var _templateObject$1, _templateObject2$1;
var Loader = styled_components_browser_esm["default"].div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  width: 60px;\n  margin: 0 auto;\n  border-radius: 10px;\n  position: relative;\n  background: #d1e5ff;\n  height: 4px;\n  top: ", ";\n"])), function (props) {
  return props.top ? props.top : '12px';
});
var LoaderBar = styled_components_browser_esm["default"].div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  border-radius: 10px;\n  top: 0;\n  right: 100%;\n  bottom: 0;\n  left: 0;\n  background: #2276e3;\n  width: 0;\n  animation: borealisBar 1s linear infinite;\n\n  @keyframes borealisBar {\n    0% {\n      left: 0%;\n      right: 100%;\n      width: 0%;\n    }\n    10% {\n      left: 0%;\n      right: 54%;\n      width: 46%;\n    }\n    90% {\n      right: 54%;\n      width: 15%;\n    }\n    100% {\n      left: 100%;\n      right: 0%;\n      width: 0%;\n    }\n  }\n"])));

var FullPageLoaderMweb = function FullPageLoaderMweb(_ref) {
  var top = _ref.top;
  return /*#__PURE__*/react.createElement(Loader, {
    top: top
  }, /*#__PURE__*/react.createElement(LoaderBar, null));
};

FullPageLoaderMweb.defaultProps = {
  top: '200px'
};

var _templateObject, _templateObject2;
var LoaderWrap = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n"])));
var Spinner = styled_components_browser_esm["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 22px;\n\theight: 22px;\n\tborder: solid 3px transparent;\n\tborder-top-color: #2276e3;\n\tborder-left-color: #2276e3;\n\tborder-right-color: #2276e3;\n\tborder-radius: 34px;\n\tanimation: loading-spinner 700ms linear infinite;\n\n\t@keyframes loading-spinner {\n\t\t0% {\n\t\t\ttransform: rotate(0deg);\n\t\t}\n\t\t100% {\n\t\t\ttransform: rotate(360deg);\n\t\t}\n\t}\n"])));

var CircularLoader = function CircularLoader() {
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LoaderWrap, null, /*#__PURE__*/react.createElement(Spinner, null, "\xA0")));
};




/***/ }),

/***/ 810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ getQueryParam; }
/* harmony export */ });
/* unused harmony exports getAllQueryStrings, getLocationPathName, isMatchesCurrentHost, navigateWindowBack */
var getAllQueryStrings = function getAllQueryStrings() {
  var searchParams = new URLSearchParams(window.location.search);
  return searchParams;
};

var getQueryParam = function getQueryParam(param) {
  if (!param) {
    console.warn('Missing argument param for getQueryParam');
    return null;
  }

  var searchParams = getAllQueryStrings();
  if (searchParams && searchParams.get) return searchParams.get(param);
  return null;
};

var getLocationPathName = function getLocationPathName() {
  return window.location.pathname;
};

var isMatchesCurrentHost = function isMatchesCurrentHost(url, whileListedHost) {
  var currentHost = window.location.hostname;

  try {
    var matchHost = new URL(url).hostname;
    var isMatchHostWhitelisted = whileListedHost == null ? void 0 : whileListedHost.some(function (item) {
      return typeof item === 'string' ? item === matchHost : item.test(matchHost);
    });
    if (isMatchHostWhitelisted) return true;
    return currentHost === matchHost;
  } catch (_unused) {
    return false;
  }
};

var navigateWindowBack = function navigateWindowBack(opts) {
  var _ref = opts || {},
      beforeNavigate = _ref.beforeNavigate;

  var _document = document,
      referrer = _document.referrer;
  beforeNavigate == null ? void 0 : beforeNavigate();

  if (referrer && isMatchesCurrentHost(referrer)) {
    window.location.href = referrer;
  } else {
    window.location.href = '/';
  }
};




/***/ }),

/***/ 7106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I8": function() { return /* binding */ deepClone; },
/* harmony export */   "RH": function() { return /* binding */ deepMerge; },
/* harmony export */   "ks": function() { return /* binding */ removeEmptyValues; }
/* harmony export */ });
/* unused harmony exports isEmptyObject, safeParse, safeStringify */
/**
 *
 * @param obj
 *
 * return boolean
 *
 * this method check if object is empty or not
 */
var isEmptyObject = function isEmptyObject(obj) {
  if (obj) {
    return Object.keys(obj).length === 0;
  }

  return true;
};
/**
 *
 * @param obj1
 * @param originalPayload
 *
 * this function will update the original payload
 */


var deepMerge = function deepMerge(obj1, originalPayload) {
  if (isEmptyObject(obj1)) {
    return originalPayload || {};
  }

  var recurse = function recurse(obj, current) {
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];
      var newKey = current;

      if (newKey[key] && typeof newKey[key] === 'object') {
        recurse(value, newKey[key]); // it's a nested object, so do it again
      } else {
        newKey[key] = value; // it's not an object, so set the property
      }
    });
  };

  (function (obj) {
    return recurse(obj, originalPayload);
  })(obj1);

  return originalPayload;
};

function removeEmptyValues(obj) {
  var newObj = Array.isArray(obj) ? [] : {};
  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      var value = removeEmptyValues(obj[key]);

      if (Object.keys(value).length !== 0 || Array.isArray(value) && value.length !== 0) {
        newObj[key] = value;
      }
    } else if (obj[key] !== '' && obj[key] !== null && obj[key] !== undefined) {
      newObj[key] = obj[key];
    }
  });
  return newObj;
}

var safeStringify = function safeStringify(o) {
  try {
    return JSON.stringify(o);
  } catch (e) {
    return '';
  }
};

var safeParse = function safeParse(s) {
  try {
    return JSON.parse(s);
  } catch (e) {
    return null;
  }
};

var deepClone = function deepClone(data) {
  if (typeof structuredClone === 'function') {
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
    try {
      return structuredClone(data);
    } catch (e) {
      return null;
    }
  }

  return safeParse(JSON.stringify(data));
};




/***/ }),

/***/ 3488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ pdtPush; }
/* harmony export */ });
/* unused harmony export pdtUpdate */
/* harmony import */ var _growth_location__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(810);


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var pdtPush = function pdtPush(eventName, details) {
  if (details === void 0) {
    details = {};
  }

  window.pdtLayer = window.pdtLayer || [];
  var optsNew = {
    campaign_details: {
      campaign_name: (0,_growth_location__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)('utm_campaign') + "|" + (0,_growth_location__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)('utm_medium') + "|" + (0,_growth_location__WEBPACK_IMPORTED_MODULE_0__/* .getQueryParam */ .Ph)('utm_source'),
      campaign_key: "utm_campaign|utm_medium|utm_source"
    }
  };
  window.pdtLayer.push(_extends({}, details, {
    event_detail: _extends({
      event_name: eventName,
      event_timestamp: Date.now()
    }, details.event_detail),
    campaign_details: _extends({}, details.campaign_details, optsNew.campaign_details)
  }));
};

var pdtUpdate = function pdtUpdate(opts) {
  var _window$__PdtInstance;

  if (opts) (_window$__PdtInstance = window.__PdtInstance__) == null ? void 0 : _window$__PdtInstance.update(opts);
};




/***/ }),

/***/ 1917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BK": function() { return /* binding */ isOnClient; },
/* harmony export */   "l_": function() { return /* binding */ getBaseHostName; }
/* harmony export */ });
/* unused harmony exports getHostPathName, getOriginUrl */
var globalAny = __webpack_require__.g;
/** Usage: Whether rendering is on client side or not */

var isOnClient = function f() {
  return typeof window !== 'undefined';
}();

var getBaseHostName = function getBaseHostName(hostname) {
  var host;
  host = '';

  if (isOnClient) {
    host = window.location.hostname;
  } else if (hostname) {
    host = hostname;
  } else if (!isOnClient && typeof __webpack_require__.g !== 'undefined') {
    host = globalAny == null ? void 0 : globalAny.hostname;
  }

  return host;
};

var getOriginUrl = function getOriginUrl() {
  var origin = '';

  if (isOnClient) {
    origin = window.location.origin;
  } else if (!isOnClient && typeof __webpack_require__.g !== 'undefined') {
    origin = globalAny == null ? void 0 : globalAny.origin;
  }

  return origin;
};

var getHostPathName = function getHostPathName() {
  var pathname = '';

  if (isOnClient) {
    pathname = window.location.pathname;
  } else if (!isOnClient && typeof __webpack_require__.g !== 'undefined') {
    pathname = globalAny == null ? void 0 : globalAny.pathname;
  }

  return pathname;
};




/***/ }),

/***/ 6880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ DEFAULT_STATE; },
/* harmony export */   "x": function() { return /* binding */ fetchSetter; }
/* harmony export */ });
function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchSetter = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var set, fetchFun, onError, onSuccess, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            set = _ref.set, fetchFun = _ref.fetchFun, onError = _ref.onError, onSuccess = _ref.onSuccess;
            set({
              loading: true
            });
            _context.prev = 2;
            _context.next = 5;
            return fetchFun();

          case 5:
            res = _context.sent;
            set(function (state) {
              return {
                data: _extends({}, state.data, res),
                loaded: true,
                loading: false,
                error: false
              };
            });
            onSuccess == null ? void 0 : onSuccess(res);
            return _context.abrupt("return", res);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            set({
              loaded: true,
              loading: false,
              error: _context.t0
            });
            onError == null ? void 0 : onError(_context.t0);

          case 15:
            return _context.abrupt("return", {});

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 11]]);
  }));

  return function fetchSetter(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var DEFAULT_STATE = {
  data: {},
  loading: false,
  loaded: false,
  error: null
};




/***/ }),

/***/ 7792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ToolTip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);



function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;
var Tooltip = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    padding: 10px;\n    border-radius: 6px;\n    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);\n    background-color: #fff;\n    position: absolute;\n    border: 1px solid #efefef;\n\n  .left::after,\n  .left::before {\n    bottom: 100%;\n    left: 20%;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .left::after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #fff;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n\n  .left::before {\n    border-color: rgba(239, 239, 239, 0);\n    border-bottom-color: #efefef;\n    border-width: 9px;\n    margin-left: -9px;\n  }\n\n  .right::after,\n  .right::before {\n    bottom: 100%;\n    left: 80%;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .right::after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #fff;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n\n  .right::before {\n    border-color: rgba(239, 239, 239, 0);\n    border-bottom-color: #efefef;\n    border-width: 9px;\n    margin-left: -9px;\n  }\n\n  .middle::after,\n  .middle::before {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .middle::after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #fff;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n\n  .middle::before {\n    border-color: rgba(239, 239, 239, 0);\n    border-bottom-color: #efefef;\n    border-width: 9px;\n    margin-left: -9px;\n  }\n\n"])));

var ToolTip = function ToolTip(props) {
  var customClass = props.customClass,
      notchPosition = props.notchPosition,
      customStyle = props.customStyle,
      children = props.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tooltip, {
    className: (customClass || '') + " " + (notchPosition || ''),
    style: customStyle
  }, children);
};




/***/ }),

/***/ 2390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nx": function() { return /* binding */ AnalyticsContextProvider; },
/* harmony export */   "z$": function() { return /* binding */ useAnalytics; }
/* harmony export */ });
/* unused harmony export analyticsState */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var analyticsState = {
  ga: {
    initialize: function initialize() {},
    setUserVars: function setUserVars() {},
    track: function track() {}
  },
  pdt: {
    initialize: function initialize() {},
    setUserVars: function setUserVars() {},
    track: function track() {}
  },
  adobe: {
    initialize: function initialize() {
      return console.log('Adobe initialize is not available');
    },
    track: function track() {
      return console.log('Adobe track is not initialized');
    },
    pageView: function pageView() {
      return console.log('Adobe pageView is not initialized');
    }
  },
  analyticsTrackAll: function analyticsTrackAll() {}
};
var AnalyticsContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(analyticsState);

var AnalyticsContextProvider = function AnalyticsContextProvider(props) {
  var children = props.children,
      gaInstance = props.gaInstance,
      pdtInstance = props.pdtInstance,
      adobeInstance = props.adobeInstance;

  var analyticsTrackAll = function analyticsTrackAll(eventName, obj) {
    if (gaInstance) gaInstance.track(eventName, obj);
    if (pdtInstance) pdtInstance.track(eventName, obj);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AnalyticsContext.Provider, {
    value: {
      ga: gaInstance,
      pdt: pdtInstance,
      adobe: adobeInstance || analyticsState.adobe,
      analyticsTrackAll: analyticsTrackAll
    }
  }, children);
};

var useAnalytics = function useAnalytics() {
  var state = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AnalyticsContext);
  return _extends({}, state);
};




/***/ }),

/***/ 6253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pk": function() { return /* binding */ isAndroidClient; },
/* harmony export */   "hf": function() { return /* binding */ getBrowserDetails; },
/* harmony export */   "qF": function() { return /* binding */ isIOSSafariBrowser; }
/* harmony export */ });
/* unused harmony exports ClientNames, getClientOS, getDeviceType, isIOSClient, isLightHouseAgent, isMobileDevice */
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1917);


/* eslint-disable prefer-destructuring */
var ClientNames;

(function (ClientNames) {
  ClientNames["ANDROID"] = "android";
  ClientNames["IOS"] = "ios";
  ClientNames["SAFARI"] = "safari";
  ClientNames["LIGHTHOUSE"] = "lighthouse";
  ClientNames["OTHER"] = "other";
  ClientNames["LINUX"] = "linux";
  ClientNames["MAC"] = "mac";
  ClientNames["WINDOWS"] = "windows";
})(ClientNames || (ClientNames = {}));

var getClientOS = function getClientOS(userAgent) {
  /* const clientStrings = [
  		{ s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
  		{ s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
  		{ s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
  		{ s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
  		{ s: 'Windows Vista', r: /Windows NT 6.0/ },
  		{ s: 'Windows Server 2003', r: /Windows NT 5.2/ },
  		{ s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
  		{ s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
  		{ s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
  		{ s: 'Windows 98', r: /(Windows 98|Win98)/ },
  		{ s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
  		{ s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
  		{ s: 'Windows CE', r: /Windows CE/ },
  		{ s: 'Windows 3.11', r: /Win16/ },
  		{ s: 'Android', r: /Android/ },
  		{ s: 'Open BSD', r: /OpenBSD/ },
  		{ s: 'Sun OS', r: /SunOS/ },
  		{ s: 'Linux', r: /(Linux|X11)/ },
  		{ s: 'iOS', r: /(iPhone|iPad|iPod)/ },
  		{ s: 'Mac OS X', r: /Mac OS X/ },
  		{ s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
  		{ s: 'QNX', r: /QNX/ },
  		{ s: 'UNIX', r: /UNIX/ },
  		{ s: 'BeOS', r: /BeOS/ },
  		{ s: 'OS/2', r: /OS\/2/ },
  		{ s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ },
  	];
  */
  var ua = userAgent || '';
  if (_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK && !ua) ua = window.navigator.userAgent || window.navigator.vendor; // add more if requires
  // ...

  if (/Android/.test(ua)) return ClientNames.ANDROID;
  if (/(iPhone|iPad|iPod)/.test(ua)) return ClientNames.IOS;
  if (/iPhone|iPad|iPod/.test(ua) && /Safari/.test(ua)) return ClientNames.SAFARI;
  if (/Linux/i.test(ua)) return ClientNames.LINUX;
  if (/Mac/i.test(ua)) return ClientNames.MAC;
  if (/Windows/i.test(ua)) return ClientNames.WINDOWS;
  return ClientNames.OTHER;
};

var isIOSClient = function isIOSClient(userAgent) {
  return getClientOS(userAgent) === ClientNames.IOS;
};

var isAndroidClient = function isAndroidClient(userAgent) {
  return getClientOS(userAgent) === ClientNames.ANDROID;
};

var isIOSSafariBrowser = function isIOSSafariBrowser(userAgent) {
  return getClientOS(userAgent) === ClientNames.SAFARI;
};

var isLightHouseAgent = function isLightHouseAgent(userAgent) {
  var ua = userAgent;
  if (isOnClient && !userAgent) ua = window.navigator.userAgent || window.navigator.vendor;

  if (typeof ua === 'string') {
    return /Chrome-Lighthouse/.test(ua);
  }

  return false;
};

var getDeviceType = function getDeviceType() {
  if (isIOSClient()) return ClientNames.IOS;
  if (isAndroidClient()) return ClientNames.ANDROID;
  return ClientNames.OTHER;
};

var getBrowserDetails = function getBrowserDetails() {
  var _navigator = navigator,
      userAgent = _navigator.userAgent;
  var browserName;
  var browserVersion;

  if (/opera|opr/i.test(userAgent)) {
    // Opera browser
    browserName = 'Opera';
    var operaVersion = userAgent.match(/(?:opera|opr)[\s/](\d+(\.\d+)?)/i);

    if (operaVersion) {
      browserVersion = operaVersion[1];
    }
  } else if (/edge|edg/i.test(userAgent)) {
    // Microsoft Edge browser
    browserName = 'Microsoft Edge';
    var edgeVersion = userAgent.match(/(?:edge|edg)\/(\d+(\.\d+)?)/i);

    if (edgeVersion) {
      browserVersion = edgeVersion[1];
    }
  } else if (/chrome|crios/i.test(userAgent)) {
    // Chrome browser
    browserName = 'Chrome';
    var chromeVersion = userAgent.match(/(?:chrome|crios)\/(\d+(\.\d+)?)/i);

    if (chromeVersion) {
      browserVersion = chromeVersion[1];
    }
  } else if (/safari/i.test(userAgent)) {
    // Safari browser
    browserName = 'Safari';
    var safariVersion = userAgent.match(/version\/(\d+(\.\d+)?)/i);

    if (safariVersion) {
      browserVersion = safariVersion[1];
    }
  } else if (/firefox|fxios/i.test(userAgent)) {
    // Firefox browser
    browserName = 'Firefox';
    var firefoxVersion = userAgent.match(/(?:firefox|fxios)\/(\d+(\.\d+)?)/i);

    if (firefoxVersion) {
      browserVersion = firefoxVersion[1];
    }
  } else if (/msie|trident/i.test(userAgent)) {
    // Internet Explorer browser
    browserName = 'Internet Explorer';
    var ieVersion = userAgent.match(/(?:msie |rv:)(\d+(\.\d+)?)/i);

    if (ieVersion) {
      browserVersion = ieVersion[1];
    }
  } else {
    browserName = 'Unknown';
    browserVersion = 'Unknown';
  }

  return {
    browserName: browserName,
    browserVersion: browserVersion
  };
};

var isMobileDevice = function isMobileDevice(userAgent) {
  return /Mobi/i.test(userAgent || window.navigator.userAgent);
};




/***/ }),

/***/ 6939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "im": function() { return /* reexport */ helper_bc63c3dd_esm_generateVid; },
  "MI": function() { return /* binding */ getVisitorIdBrowser; }
});

// UNUSED EXPORTS: config, visitorIdBrowser

// EXTERNAL MODULE: ../../node_modules/@growth/cookies/dist/growth-cookies.esm.js
var growth_cookies_esm = __webpack_require__(2048);
;// CONCATENATED MODULE: ../../node_modules/@growth/visitor-id/dist/helper-bc63c3dd.esm.js
// constant
var helper_bc63c3dd_esm_C = {
  CookieName: '__gi_vid',
  MaxAgeDay: 365,
  // 1 year
  Domain: '.goibibo.com'
}; // vid generator function

var helper_bc63c3dd_esm_generateVid = function generateVid() {
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    /* eslint-disable-next-line no-bitwise */
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    /* eslint-disable-next-line no-bitwise */

    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};



;// CONCATENATED MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js




function visitorIdBrowser(options) {
  var opts = options || {}; // if vid cookie is present

  if (getItem(C.CookieName)) {
    if (opts.debug) console.info('DEBUG visitorIdBrowser: visitorId cookie is already present in browser');
    return true;
  } // if vid is not present in cookie


  var vid = generateVid();
  setItem(C.CookieName, vid, {
    expires: C.MaxAgeDay * 24 * 60 * 60,
    path: "/",
    domain: C.Domain,
    secure: true
  });
  if (opts.debug) console.info('DEBUG visitorIdBrowser: new visitorId cookie has been set to browser');
  return true;
}

var getVisitorIdBrowser = function getVisitorIdBrowser() {
  var vid = (0,growth_cookies_esm/* getItem */.rV)(helper_bc63c3dd_esm_C.CookieName);
  return vid || undefined;
};




/***/ }),

/***/ 2019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WebAnalytics; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var WebAnalytics = /*#__PURE__*/function () {
  function WebAnalytics() {}

  var _proto = WebAnalytics.prototype;

  // ! a not null assertion
  _proto.initialize = function initialize(O) {
    this.plugin = O.plugin;
    this.eventNames = O.eventNames;
    this.globalProperties = O.globalProperties;
    this.debug = O.debug;
    this.globalVars = _extends({}, O.globalProperties);
    this.plugin.init();
  };

  _proto.setUserVars = function setUserVars(globalVars) {
    this.globalVars = _extends({}, this.globalVars, globalVars);
    return this.globalVars;
  };

  _proto.track = function track(eventName, properties) {
    try {
      if (!eventName || typeof eventName !== 'string') {
        throw new TypeError('eventName is missing or invalid in webAnalytics().track()');
      }

      if (this.eventNames && !this.eventNames.has(eventName)) {
        throw new TypeError("unknown track webAalyticsEventName \"" + eventName + "\"");
      }

      if (this.debug) {
        /* eslint-disable-next-line no-console */
        console.log("webAnalytics " + this.plugin.name, 'track', {
          event: eventName,
          eventProperties: properties,
          globalProperties: this.globalVars
        });
      }

      var payload = {
        event: eventName,
        eventProperties: properties,
        globalProperties: this.globalVars
      };
      return this.plugin.track({
        payload: payload
      });
    } catch (e) {
      if (this.debug) console.log(e);
      return e;
    }
  };

  _proto.pageView = function pageView(pageName, properties) {
    if (!this.plugin.pageView) {
      throw new Error(this.plugin.name + " plugin does not support pageView property");
    }

    if (!pageName) {
      throw new Error('pageName is mandatory to send page view event');
    }

    var payload = {
      eventProperties: _extends({}, properties),
      globalProperties: this.globalVars
    };

    if (this.debug) {
      /* eslint-disable-next-line no-console */
      console.log("webAnalytics " + this.plugin.name, 'page', _extends({}, payload));
    }

    if (this.plugin.pageView) this.plugin.pageView(pageName, payload);
  };

  return WebAnalytics;
}();




/***/ }),

/***/ 5618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Anchor": function() { return /* binding */ Anchor; },
/* harmony export */   "AnchorTagStyle": function() { return /* binding */ AnchorTagStyle; },
/* harmony export */   "BottomRightTextContainer": function() { return /* binding */ BottomRightTextContainer; },
/* harmony export */   "Button": function() { return /* binding */ Button; },
/* harmony export */   "Checkbox": function() { return /* binding */ Checkbox; },
/* harmony export */   "Container": function() { return /* binding */ Container; },
/* harmony export */   "DesignSystem": function() { return /* binding */ DesignSystem; },
/* harmony export */   "Dropdown": function() { return /* binding */ Dropdown; },
/* harmony export */   "ErrorStateText": function() { return /* binding */ ErrorStateText; },
/* harmony export */   "FloatingTextField": function() { return /* binding */ FloatingTextField; },
/* harmony export */   "FormattedText": function() { return /* binding */ FormattedText; },
/* harmony export */   "GlobalStyles": function() { return /* binding */ GlobalStyles; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H1Style": function() { return /* binding */ H1Style; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H2Style": function() { return /* binding */ H2Style; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H3Style": function() { return /* binding */ H3Style; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "H4Style": function() { return /* binding */ H4Style; },
/* harmony export */   "H5": function() { return /* binding */ H5; },
/* harmony export */   "H5Style": function() { return /* binding */ H5Style; },
/* harmony export */   "HeaderWrapper": function() { return /* binding */ HeaderWrapper; },
/* harmony export */   "Heading": function() { return /* binding */ Heading; },
/* harmony export */   "IconContainer": function() { return /* binding */ IconContainer; },
/* harmony export */   "Image": function() { return /* binding */ Image; },
/* harmony export */   "ImageTagStyle": function() { return /* binding */ ImageTagStyle; },
/* harmony export */   "InputStyle": function() { return /* binding */ InputStyle; },
/* harmony export */   "InputWpr": function() { return /* binding */ InputWpr; },
/* harmony export */   "InputWrap": function() { return /* binding */ InputWrap; },
/* harmony export */   "LabelWrapper": function() { return /* binding */ LabelWrapper; },
/* harmony export */   "Modal": function() { return /* binding */ Modal; },
/* harmony export */   "ModalBackdrop": function() { return /* binding */ ModalBackdrop; },
/* harmony export */   "ModalWrapper": function() { return /* binding */ ModalWrapper; },
/* harmony export */   "ParaStyle": function() { return /* binding */ ParaStyle; },
/* harmony export */   "ParaTag": function() { return /* binding */ ParaTag; },
/* harmony export */   "RadioButton": function() { return /* binding */ RadioButton; },
/* harmony export */   "RadioButtonStyle": function() { return /* binding */ RadioButtonStyle; },
/* harmony export */   "RightTextContainer": function() { return /* binding */ RightTextContainer; },
/* harmony export */   "ScrollContainer": function() { return /* binding */ ScrollContainer; },
/* harmony export */   "ScrollContainerFullPage": function() { return /* binding */ ScrollContainerFullPage; },
/* harmony export */   "SearchInput": function() { return /* binding */ SearchInput; },
/* harmony export */   "Shimmer": function() { return /* binding */ Shimmer; },
/* harmony export */   "SlickArrow": function() { return /* binding */ SlickArrow; },
/* harmony export */   "Slider": function() { return /* binding */ Slider; },
/* harmony export */   "SnackBar": function() { return /* binding */ SnackBar; },
/* harmony export */   "SpanStyle": function() { return /* binding */ SpanStyle; },
/* harmony export */   "Spinner": function() { return /* binding */ Spinner; },
/* harmony export */   "SpinnerCont": function() { return /* binding */ SpinnerCont; },
/* harmony export */   "StyledButton": function() { return /* binding */ StyledButton; },
/* harmony export */   "SubHeading": function() { return /* binding */ SubHeading; },
/* harmony export */   "Switch": function() { return /* binding */ Switch; },
/* harmony export */   "SwitchContainer": function() { return /* binding */ SwitchContainer; },
/* harmony export */   "SwitchInput": function() { return /* binding */ SwitchInput; },
/* harmony export */   "Toast": function() { return /* binding */ Toast; },
/* harmony export */   "ToolTip": function() { return /* binding */ ToolTip; },
/* harmony export */   "ToolTipCont": function() { return /* binding */ ToolTipCont; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5505);
/* harmony import */ var _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8772);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





const StyledDesignSystem = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "design-system__StyledDesignSystem",
  componentId: "sc-8b4jxl-0"
})(["color:pink;"]);
function DesignSystem() {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDesignSystem, {
    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
      children: ["Welcome to DesignSystem! ", _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.GI]
    })
  });
}

const ImageTagStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].img.withConfig({
  displayName: "Imagestyle__ImageTagStyle",
  componentId: "xwa4kr-0"
})(["flex-shrink:0;", " ", " ", " ", " object-fit:contain;"], props => props.width && `width: ${props.width};`, props => props.height && `height: ${props.height};`, props => props.showCursorPointer && ` cursor: pointer;`, props => props.margin && `margin: ${props.margin};`);

const Image = ({
  src,
  width,
  alt: _alt = 'image-tag',
  height,
  showCursorPointer: _showCursorPointer = false,
  id,
  onClick,
  className,
  margin
}) => {
  if (!src) return null;
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTagStyle, {
    src: src,
    width: width,
    height: height,
    showCursorPointer: _showCursorPointer,
    alt: _alt,
    id: id,
    onClick: onClick,
    loading: "lazy",
    className: className,
    margin: margin
  });
};

const H1Style = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h1.withConfig({
  displayName: "H1style__H1Style",
  componentId: "sc-1llksyg-0"
})(["", ""], props => {
  const {
    margin,
    color
  } = props;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " font-weight:", ";font-family:", ";color:", ";", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.FONT_SIZE_KEYS.FONT32, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), props.theme.fontWeight.bold, props.theme.fontFamily, color || props.theme.colors.highEmphasis, margin && `margin: ${margin};`);
});

const H1 = ({
  children,
  color,
  margin,
  id,
  dangerousText
}) => {
  return dangerousText ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H1Style, {
    id: id,
    margin: margin,
    color: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H1Style, {
    id: id,
    margin: margin,
    color: color,
    children: children
  });
};

const H2Style = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h2.withConfig({
  displayName: "H2style__H2Style",
  componentId: "xuqcvw-0"
})(["", ""], props => {
  const {
    margin,
    color
  } = props;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " font-weight:", ";font-family:", ";color:", ";", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.FONT_SIZE_KEYS.FONT24, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), props.theme.fontWeight.bold, props.theme.fontFamily, color || props.theme.colors.highEmphasis, margin && `margin: ${margin};`);
});

const H2 = ({
  children,
  color,
  margin,
  id,
  dangerousText
}) => {
  return dangerousText ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H2Style, {
    id: id,
    margin: margin,
    color: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H2Style, {
    id: id,
    margin: margin,
    color: color,
    children: children
  });
};

const H3Style = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h3.withConfig({
  displayName: "H3style__H3Style",
  componentId: "zg5cb1-0"
})(["", ""], props => {
  const {
    margin,
    color
  } = props;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " font-weight:", ";font-family:", ";color:", ";", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.FONT_SIZE_KEYS.FONT22, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), props.theme.fontWeight.bold, props.theme.fontFamily, color || props.theme.colors.highEmphasis, margin && `margin: ${margin};`);
});

const H3 = ({
  children,
  color,
  margin,
  id,
  dangerousText
}) => {
  return dangerousText ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H3Style, {
    id: id,
    margin: margin,
    color: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H3Style, {
    id: id,
    margin: margin,
    color: color,
    children: children
  });
};

const H4Style = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h4.withConfig({
  displayName: "H4style__H4Style",
  componentId: "sc-153qf2g-0"
})(["", ""], props => {
  const {
    margin,
    color
  } = props;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " font-weight:", ";font-family:", ";color:", ";", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.FONT_SIZE_KEYS.FONT18, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), props.theme.fontWeight.bold, props.theme.fontFamily, color || props.theme.colors.highEmphasis, margin && `margin: ${margin};`);
});

const H4 = ({
  children,
  color,
  margin,
  id,
  dangerousText
}) => {
  return dangerousText ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H4Style, {
    id: id,
    margin: margin,
    color: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H4Style, {
    id: id,
    margin: margin,
    color: color,
    children: children
  });
};

const H5Style = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h5.withConfig({
  displayName: "H5style__H5Style",
  componentId: "qfcp3t-0"
})(["", ""], props => {
  const {
    margin,
    color
  } = props;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " font-weight:", ";font-family:", ";color:", ";", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.FONT_SIZE_KEYS.FONT16, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), props.theme.fontWeight.bold, props.theme.fontFamily, color || props.theme.colors.highEmphasis, margin && `margin: ${margin};`);
});

const H5 = ({
  children,
  color,
  margin,
  id,
  dangerousText
}) => {
  return dangerousText ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H5Style, {
    id: id,
    margin: margin,
    color: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    }
  }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(H5Style, {
    id: id,
    margin: margin,
    color: color,
    children: children
  });
};

let _ = t => t,
  _t;
const GlobalStyles = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.createGlobalStyle)(_t || (_t = _` 
html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
  background: ${0};
  color: ${0};
  font-size: ${0};
  line-height: ${0};
  font-family: ${0};
  font-weight: ${0};
}

*::-webkit-scrollbar {
  display: none;
}

*,
html {
  box-sizing: border-box;
  scroll-behavior: smooth;
}
*, *:before, *:after {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  -webkit-font-smoothing: antialiased;
}
img {
  max-width: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
a {
  color: ${0};
  text-decoration: none;
  cursor: pointer;
}
a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}
code {
  font-family: ${0};
}

input, textarea, button {font-family: inherit; border: none; outline: none;}

@font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wXiWtFCc.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  
    @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwiPGQ3q5d0.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50XSwiPGQ3q5d0.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4iFV0U1dYPFkZVO.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

@font-face {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-NYiFV0U1dYPFkZVO.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

  @font-face {
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-4I-FV0U1dYPFkZVO.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
`), props => props.theme.colors.bodyBg, props => props.theme.colors.highEmphasis, props => props.theme.fontSize.font14, props => props.theme.lineHeight.lh16, props => props.theme.fontFamily, props => props.theme.fontWeight.regular, props => props.theme.colors.primaryAccent, props => props.theme.fontFamily);

const AnchorTagStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].a.withConfig({
  displayName: "Anchorstyle__AnchorTagStyle",
  componentId: "sc-1kebx5m-0"
})(["", ""], props => {
  const {
    theme,
    margin,
    color,
    textUnderline,
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW2
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["display:inline-block;", " ", " font-family:", ";color:", ";", " ", ""], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`, theme.fontFamily, color || props.theme.colors.primaryAccent, margin && `margin: ${margin};`, textUnderline && ` text-decoration-line: ${textUnderline};`);
});

const Anchor = ({
  children,
  color,
  onClick,
  href,
  margin,
  onMouseEnter,
  onMouseLeave,
  target,
  id,
  textUnderline,
  typography,
  className
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnchorTagStyle, {
    typography: typography,
    color: color,
    onClick: onClick,
    href: href,
    margin: margin,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    target: target,
    id: id,
    textUnderline: textUnderline,
    className: className,
    children: children
  });
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$d = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$c = fails$d;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$c(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$b = fails$d;

var functionBindNative = !fails$b(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$9 = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var functionCall = NATIVE_BIND$1 ? call$9.bind(call$9) : function () {
  return call$9.apply(call$9, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$4 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var call$8 = FunctionPrototype$1.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype$1.bind.bind(call$8, call$8);

var functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$8.apply(fn, arguments);
  };
};

var uncurryThis$c = functionUncurryThis;

var toString$4 = uncurryThis$c({}.toString);
var stringSlice$1 = uncurryThis$c(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$1(toString$4(it), 8, -1);
};

var uncurryThis$b = functionUncurryThis;
var fails$a = fails$d;
var classof$2 = classofRaw$1;

var $Object$4 = Object;
var split = uncurryThis$b(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$a(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$2(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$1 = isNullOrUndefined$2;

var $TypeError$8 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$4 = function (it) {
  if (isNullOrUndefined$1(it)) throw new $TypeError$8("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$3 = requireObjectCoercible$4;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$3(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$f = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$e = isCallable$f;

var isObject$8 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$e(it);
};

var globalThis$f = globalThis_1;
var isCallable$d = isCallable$f;

var aFunction = function (argument) {
  return isCallable$d(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis$f[namespace]) : globalThis$f[namespace] && globalThis$f[namespace][method];
};

var uncurryThis$a = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$a({}.isPrototypeOf);

var globalThis$e = globalThis_1;

var navigator = globalThis$e.navigator;
var userAgent$1 = navigator && navigator.userAgent;

var environmentUserAgent = userAgent$1 ? String(userAgent$1) : '';

var globalThis$d = globalThis_1;
var userAgent = environmentUserAgent;

var process = globalThis$d.process;
var Deno = globalThis$d.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = environmentV8Version;
var fails$9 = fails$d;
var globalThis$c = globalThis_1;

var $String$5 = globalThis$c.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$9(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1 &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$3;
var isCallable$c = isCallable$f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$c($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$b = isCallable$f;
var tryToString = tryToString$1;

var $TypeError$7 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$3 = function (argument) {
  if (isCallable$b(argument)) return argument;
  throw new $TypeError$7(tryToString(argument) + ' is not a function');
};

var aCallable$2 = aCallable$3;
var isNullOrUndefined = isNullOrUndefined$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable$2(func);
};

var call$7 = functionCall;
var isCallable$a = isCallable$f;
var isObject$7 = isObject$8;

var $TypeError$6 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$a(fn = input.toString) && !isObject$7(val = call$7(fn, input))) return val;
  if (isCallable$a(fn = input.valueOf) && !isObject$7(val = call$7(fn, input))) return val;
  if (pref !== 'string' && isCallable$a(fn = input.toString) && !isObject$7(val = call$7(fn, input))) return val;
  throw new $TypeError$6("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var globalThis$b = globalThis_1;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(globalThis$b, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis$b[key] = value;
  } return value;
};

var globalThis$a = globalThis_1;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$a[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.43.0',
  mode: 'global',
  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.43.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var sharedStoreExports = sharedStore.exports;

var store$2 = sharedStoreExports;

var shared$3 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$2 = requireObjectCoercible$4;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return $Object$2(requireObjectCoercible$2(argument));
};

var uncurryThis$9 = functionUncurryThis;
var toObject$2 = toObject$3;

var hasOwnProperty = uncurryThis$9({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$2(it), key);
};

var uncurryThis$8 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$3 = uncurryThis$8(1.1.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$3(++id + postfix, 36);
};

var globalThis$9 = globalThis_1;
var shared$2 = shared$3;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$2 = globalThis$9.Symbol;
var WellKnownSymbolsStore = shared$2('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$a = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$9(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$6 = functionCall;
var isObject$6 = isObject$8;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$9 = wellKnownSymbol$a;

var $TypeError$5 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$9('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$6(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$6(exoticToPrim, input, pref);
    if (!isObject$6(result) || isSymbol$1(result)) return result;
    throw new $TypeError$5("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var globalThis$8 = globalThis_1;
var isObject$5 = isObject$8;

var document$1 = globalThis$8.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$5(document$1) && isObject$5(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$b = descriptors;
var fails$8 = fails$d;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$b && !fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$a = descriptors;
var call$5 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$3 = createPropertyDescriptor$4;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$a ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$8(O, P)) return createPropertyDescriptor$3(!call$5(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$9 = descriptors;
var fails$7 = fails$d;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$9 && fails$7(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$4 = isObject$8;

var $String$3 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$8 = function (argument) {
  if (isObject$4(argument)) return argument;
  throw new $TypeError$4($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$8 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$7 = anObject$8;
var toPropertyKey = toPropertyKey$2;

var $TypeError$3 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$8 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$7(O);
  P = toPropertyKey(P);
  anObject$7(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$7(O);
  P = toPropertyKey(P);
  anObject$7(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$3('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$7 = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$4;

var createNonEnumerableProperty$5 = DESCRIPTORS$7 ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$6 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$6 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$6 || (DESCRIPTORS$6 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$7 = functionUncurryThis;
var isCallable$9 = isCallable$f;
var store$1 = sharedStoreExports;

var functionToString = uncurryThis$7(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$9(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var globalThis$7 = globalThis_1;
var isCallable$8 = isCallable$f;

var WeakMap$1 = globalThis$7.WeakMap;

var weakMapBasicDetection = isCallable$8(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$1 = shared$3;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var globalThis$6 = globalThis_1;
var isObject$3 = isObject$8;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$6 = hasOwnProperty_1;
var shared = sharedStoreExports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = globalThis$6.TypeError;
var WeakMap = globalThis$6.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$3(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$6(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$6(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$6(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$6 = functionUncurryThis;
var fails$6 = fails$d;
var isCallable$7 = isCallable$f;
var hasOwn$5 = hasOwnProperty_1;
var DESCRIPTORS$5 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$2 = internalState;

var enforceInternalState = InternalStateModule$2.enforce;
var getInternalState$1 = InternalStateModule$2.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice = uncurryThis$6(''.slice);
var replace$1 = uncurryThis$6(''.replace);
var join = uncurryThis$6([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$5 && !fails$6(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$1($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$5(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$5) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$5(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$5(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$5) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$5(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$7(this) && getInternalState$1(this).source || inspectSource(this);
}, 'toString');

var makeBuiltInExports = makeBuiltIn$3.exports;

var isCallable$6 = isCallable$f;
var definePropertyModule$3 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltInExports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$4 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$6(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$3.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var uncurryThis$5 = functionUncurryThis;
var hasOwn$4 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push = uncurryThis$5([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$4(hiddenKeys$2, key) && hasOwn$4(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$4(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$3;
var uncurryThis$4 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$6 = anObject$8;

var concat$1 = uncurryThis$4([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$6(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$5 = fails$d;
var isCallable$5 = isCallable$f;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$5(detection) ? fails$5(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var globalThis$5 = globalThis_1;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var defineBuiltIn$3 = defineBuiltIn$4;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis$5;
  } else if (STATIC) {
    target = globalThis$5[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis$5[TARGET] && globalThis$5[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$3(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$4 = descriptors;
var uncurryThis$3 = functionUncurryThis;
var call$4 = functionCall;
var fails$4 = fails$d;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$1 = toObject$3;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$4 = Object.defineProperty;
var concat = uncurryThis$3([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$4(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$4 && $assign({ b: 1 }, $assign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys$1($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$4 || call$4(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$4 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$4({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const baseButtonStyles = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["display:inline-flex;align-items:center;justify-content:center;padding:12px 24px;margin:", ";width:100%;border-radius:", ";cursor:pointer;background:", ";border:", ";", ""], ({
  margin: _margin = '0px'
}) => _margin, ({
  theme
}) => theme.borderRadius.br8, ({
  variant,
  theme
}) => variant === 'contained' ? theme.gradientColors.buttonBgColor : 'transparent', ({
  variant,
  theme
}) => variant === 'outlined' ? `1px solid ${theme.colors.primaryAccent}` : 'none', ({
  isDisabled,
  variant,
  theme
}) => isDisabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["background:", ";border-color:", ";pointer-events:none;cursor:default;"], variant === 'contained' ? `${theme.colors.disabledBg}` : 'transparent', theme.colors.disabled));
const StyledButton = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].button.withConfig({
  displayName: "Buttonstyles__StyledButton",
  componentId: "xq2e5g-0"
})(["", ""], baseButtonStyles);
const IconWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Buttonstyles__IconWrapper",
  componentId: "xq2e5g-1"
})(["display:inline-flex;align-items:center;justify-content:center;margin:", ";"], ({
  position
}) => position === 'left' ? '0 4px 0 0' : '0 0 0 4px');
const LabelWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Buttonstyles__LabelWrapper",
  componentId: "xq2e5g-2"
})(["", ""], ({
  theme,
  variant,
  typography: _typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.mediumW3,
  isDisabled
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_typography, theme.partner);
  return `
      ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-family: ${theme.fontFamily};
      color: ${variant === 'contained' ? theme.colors.white : theme.colors.primaryAccent};
      ${isDisabled ? `color: ${theme.colors.disabled};` : ''}
    `;
});

const Button = _a => {
  var {
      id,
      variant = 'contained',
      disabled = false,
      onClick,
      startIcon,
      endIcon,
      margin,
      leftImageWidth = '24px',
      rightImageWidth = '24px',
      label,
      className,
      typography
    } = _a,
    restProps = __rest(_a, ["id", "variant", "disabled", "onClick", "startIcon", "endIcon", "margin", "leftImageWidth", "rightImageWidth", "label", "className", "typography"]);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledButton, Object.assign({
    id: id,
    variant: variant,
    isDisabled: disabled,
    onClick: onClick,
    margin: margin,
    className: className
  }, restProps, {
    children: [startIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
      position: "left",
      children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
        src: startIcon,
        width: leftImageWidth
      })
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LabelWrapper, {
      variant: variant,
      isDisabled: disabled,
      typography: typography,
      children: label
    }), endIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
      position: "right",
      children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
        src: endIcon,
        width: rightImageWidth
      })
    })]
  }));
};

const RadioButtonStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "RadioButtonstyle__RadioButtonStyle",
  componentId: "bcndwf-0"
})(["display:block;margin:", ";", " [type='radio']:checked,[type='radio']:not(:checked){position:absolute;left:-9999px;}[type='radio']:checked + label,[type='radio']:not(:checked) + label{position:relative;padding-left:28px;cursor:pointer;display:inline-block;color:", ";width:100%;", " ", "}[type='radio']:checked + label:before,[type='radio']:not(:checked) + label:before{content:'';position:absolute;left:0;top:2px;width:18px;height:18px;border:1px solid ", ";border-radius:100%;background:", ";", "}[type='radio']:checked + label:before{border:", ";}[type='radio']:checked + label:after,[type='radio']:not(:checked) + label:after{content:'';width:12px;height:12px;background:", ";position:absolute;top:5px;left:3px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;", "}[type='radio']:not(:checked) + label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}[type='radio']:checked + label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}"], ({
  margin
}) => margin, ({
  showLabel
}) => showLabel && `
        width: 100%;
`, ({
  theme
}) => theme.colors.mediumEmphasis, ({
  theme,
  typography: _typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW1
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_typography, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  showLabel
}) => !showLabel && `
        margin-top:-17px
`, ({
  disabled,
  theme
}) => disabled ? theme.colors.lowEmphasis : theme.colors.lowEmphasis, ({
  theme
}) => theme.colors.white, ({
  showLabel
}) => !showLabel && `
        margin-top:-17px
`, ({
  theme
}) => `1px solid ${theme.colors.primaryAccent}`, ({
  theme
}) => theme.colors.primaryAccent, p => !p.showLabel && `
        margin-top:-17px
`);

const RadioButton = ({
  children,
  isChecked,
  onClick,
  inputIndex,
  inputId,
  showLabel: _showLabel = true,
  id,
  disabled: _disabled = false,
  margin,
  typography
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RadioButtonStyle, {
    onClick: onClick ? () => onClick(inputIndex) : undefined,
    showLabel: _showLabel,
    id: id,
    disabled: _disabled,
    margin: margin,
    typography: typography,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
      type: "radio",
      checked: isChecked,
      id: inputId,
      disabled: !_showLabel
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
      htmlFor: inputId,
      children: children
    })]
  });
};

var objectDefineProperties = {};

var DESCRIPTORS$3 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$1 = objectDefineProperty;
var anObject$5 = anObject$8;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$3 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$5(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$3;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$4 = anObject$8;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$4(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$8 = wellKnownSymbol$a;
var create$2 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$8('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$3(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$3 = fails$d;

var correctPrototypeGetter = !fails$3(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$2 = hasOwnProperty_1;
var isCallable$4 = isCallable$f;
var toObject = toObject$3;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$4(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$2 = fails$d;
var isCallable$3 = isCallable$f;
var isObject$2 = isObject$8;
var getPrototypeOf$2 = objectGetPrototypeOf;
var defineBuiltIn$2 = defineBuiltIn$4;
var wellKnownSymbol$7 = wellKnownSymbol$a;

var ITERATOR$4 = wellKnownSymbol$7('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$4, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$2(getPrototypeOf$2(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$4 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$2(IteratorPrototype$4) || fails$2(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$4[ITERATOR$4].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$4 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$3(IteratorPrototype$4[ITERATOR$4])) {
  defineBuiltIn$2(IteratorPrototype$4, ITERATOR$4, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$4,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$6 = wellKnownSymbol$a;

var TO_STRING_TAG$4 = wellKnownSymbol$6('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$1(target, TO_STRING_TAG$4)) {
    defineProperty$2(target, TO_STRING_TAG$4, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$3 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$4;
var setToStringTag$2 = setToStringTag$3;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$3, { next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$2 = functionUncurryThis;
var aCallable$1 = aCallable$3;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$2(aCallable$1(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$1 = isObject$8;

var isPossiblePrototype$1 = function (argument) {
  return isObject$1(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$1 = String;
var $TypeError$2 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$2("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject = isObject$8;
var requireObjectCoercible$1 = requireObjectCoercible$4;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$1(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$3 = _export;
var call$3 = functionCall;
var FunctionName = functionName;
var isCallable$2 = isCallable$f;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var defineBuiltIn$1 = defineBuiltIn$4;
var wellKnownSymbol$5 = wellKnownSymbol$a;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype$2 = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$3 = wellKnownSymbol$5('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$3]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$1(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable$2(CurrentIteratorPrototype[ITERATOR$3])) {
          defineBuiltIn$1(CurrentIteratorPrototype, ITERATOR$3, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$3(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$3({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$3] !== defaultIterator) {
    defineBuiltIn$1(IterablePrototype, ITERATOR$3, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$2 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$1;
var Iterators = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$2;
var DESCRIPTORS$2 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject$1(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$1(index, false);
    case 'values': return createIterResultObject$1(target[index], false);
  } return createIterResultObject$1([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$2 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var globalThis$4 = globalThis_1;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var setToStringTag = setToStringTag$3;
var wellKnownSymbol$4 = wellKnownSymbol$a;

var ITERATOR$2 = wellKnownSymbol$4('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis$4[COLLECTION_NAME] && globalThis$4[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const getArrowStyles = (arrowDirection, bgColor, theme, arrowPosition) => {
  const arrowColor = bgColor ? bgColor : theme.colors.positive;
  const position = arrowPosition ? arrowPosition : '50%';
  switch (arrowDirection) {
    case 'up':
      return `
          ::after {
              bottom: 100%;
              left: ${position};
              border-bottom-color: ${arrowColor};
              margin-left: -8px;
          }
        `;
    case 'down':
      return `
          ::after {
              top: 100%;
              left: ${position};
              border-top-color: ${arrowColor};
              margin-left: -8px;
          }
        `;
    case 'right':
      return `
          ::after {
              left: 100%;
              top: ${position};
              border-left-color: ${arrowColor};
              margin-top: -8px;
          }
        `;
    case 'left':
      return `
          ::after {
              right: 100%;
              top: ${position};
              border-right-color: ${arrowColor};
              margin-top: -8px;
          }
        `;
    default:
      return '';
  }
};
const ToolTipCont = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "ToolTipstyles__ToolTipCont",
  componentId: "mfvufu-0"
})(["width:", ";background-color:", ";padding:8px;border-radius:", ";position:absolute;::after{bottom:100%;border:solid transparent;content:'';height:0;width:0;position:absolute;pointer-events:none;border-color:rgba(0,87,86,0);border-width:8px;}", ""], props => props.width ? props.width : '400px', props => props.bgColor ? props.bgColor : props.theme.colors.positive, props => props.theme.borderRadius.br8, props => getArrowStyles(props.arrowDirection, props.bgColor, props.theme, props.arrowPosition));

const ToolTip = ({
  width,
  children,
  bgColor,
  arrowDirection: _arrowDirection = 'down',
  arrowPosition,
  style,
  id,
  className,
  autoDismiss: _autoDismiss = false,
  dismissDuration: _dismissDuration = 3000,
  // default 3 seconds
  'data-testid': dataTestId
}) => {
  const [isVisible, setIsVisible] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    let timer = null;
    if (_autoDismiss) {
      timer = setTimeout(() => {
        setIsVisible(false);
      }, _dismissDuration);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [_autoDismiss, _dismissDuration]);
  if (!isVisible) return null;
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ToolTipCont, {
    width: width,
    arrowDirection: _arrowDirection,
    arrowPosition: arrowPosition,
    bgColor: bgColor,
    style: style,
    id: id,
    className: className,
    "data-testid": dataTestId,
    children: children
  });
};

const BREAKPOINTS = {
  MOBILE: 768
};

const deviceType = {
  mobile: `(max-width: ${BREAKPOINTS.MOBILE}px)`
};

const modalAnim = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.keyframes)(["from{bottom:-600px;}to{bottom:0;}"]);
const fullModalAnim = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.keyframes)(["from{top:100vh;}to{top:0;}"]);
const ModalWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__ModalWrapper",
  componentId: "qs43y7-0"
})(["overflow:hidden;width:", ";background-color:", ";border-radius:", ";position:fixed;z-index:15;padding:20px 30px 30px 30px;@media ", "{padding:20px 20px 30px 20px;}", " ", " ", ""], ({
  modalWidth
}) => modalWidth ? `${modalWidth}px` : '420px', ({
  theme
}) => theme.colors.white, ({
  theme
}) => theme.borderRadius.br12, deviceType.mobile, ({
  modalType
}) => modalType === 'centered' && `
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    `, ({
  modalType,
  stickToTop,
  theme
}) => modalType === 'bottomSheet' && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["left:0;width:100%;border-radius:", " ", " 0 0;animation:", " 0.6s;max-height:calc(100vh);", ""], theme.borderRadius.br20, theme.borderRadius.br20, modalAnim, stickToTop ? 'top: 0; height: 100%;' : 'bottom: 0;'), ({
  modalType
}) => modalType === 'fullPage' && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["left:0;top:0;width:100%;height:100%;border-radius:0;animation:", " 0.8s;"], fullModalAnim));
const Container = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__Container",
  componentId: "qs43y7-1"
})(["display:flex;flex-direction:row;align-items:center;margin:0px 0px 24px 0px;"]);
const BackButtonWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Modalstyle__BackButtonWrapper",
  componentId: "qs43y7-2"
})([""]);
const HeaderWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__HeaderWrapper",
  componentId: "qs43y7-3"
})(["display:flex;flex-direction:column;margin:", ";flex:1;"], ({
  hasBackBtn
}) => hasBackBtn ? '0px 0px 0px 20px' : '0px');
const Heading = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
  displayName: "Modalstyle__Heading",
  componentId: "qs43y7-4"
})(["", ""], props => {
  const {
    color,
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.medium,
    theme
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
     font-family: ${theme.fontFamily};
      color: ${color || theme.colors.highEmphasis};
    `;
});
const SubHeading = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
  displayName: "Modalstyle__SubHeading",
  componentId: "qs43y7-5"
})(["", ""], props => {
  const {
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW1,
    color,
    theme
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
     font-family: ${theme.fontFamily};
      color: ${color || theme.colors.lowEmphasis};
      margin-top: 4px;
    `;
});
const CloseButtonWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Modalstyle__CloseButtonWrapper",
  componentId: "qs43y7-6"
})(["margin-left:auto;cursor:pointer;"]);
const ScrollContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__ScrollContainer",
  componentId: "qs43y7-7"
})(["overflow-y:scroll;max-height:", ";@media ", "{max-height:", ";}"], props => props.modalMaxHeight ? `${props.modalMaxHeight}` : 'calc(100vh - 204px)', deviceType.mobile, props => props.modalMaxHeight ? `${props.modalMaxHeight}` : 'calc(100vh - 300px)');
const ScrollContainerFullPage = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__ScrollContainerFullPage",
  componentId: "qs43y7-8"
})(["overflow-y:scroll;max-height:calc(100vh - 100px);"]);
const ModalBackdrop = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Modalstyle__ModalBackdrop",
  componentId: "qs43y7-9"
})(["width:100%;height:100%;background-color:", ";position:fixed;left:0;top:0;z-index:13;"], ({
  theme
}) => theme.colors.overlay);

const Modal = ({
  modalId,
  backBtnId,
  closeBtnId,
  modalType: _modalType = 'centered',
  modalWidth,
  stickToTop,
  backBtn,
  onModalClose,
  heading,
  headingStyles,
  children,
  subHeading,
  subHeadingStyles,
  headingComp,
  modalMaxHeight,
  closeButton: _closeButton = (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
    src: 'https://tripmoneycmsimgak.mmtcdn.com/img/Close_d8b254dd9a.png',
    height: "32px",
    width: "32px"
  }),
  className,
  showCloseButton: _showCloseButton = true,
  'data-testid': dataTestId
}) => {
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__.ThemeContext);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ModalWrapper, {
      id: modalId,
      modalType: _modalType,
      modalWidth: modalWidth,
      stickToTop: stickToTop,
      className: className,
      "data-testid": dataTestId,
      children: [_modalType === 'fullPage' ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        children: [backBtn && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BackButtonWrapper, {
          id: backBtnId,
          onClick: onModalClose,
          children: backBtn
        }), (heading || subHeading) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HeaderWrapper, {
          hasBackBtn: !!backBtn,
          children: [heading && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
            color: (headingStyles === null || headingStyles === void 0 ? void 0 : headingStyles.color) || theme.colors.mediumEmphasis,
            dangerouslySetInnerHTML: {
              __html: heading
            },
            typography: (headingStyles === null || headingStyles === void 0 ? void 0 : headingStyles.typography) || _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.mediumW2
          }), subHeading && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubHeading, {
            typography: subHeadingStyles === null || subHeadingStyles === void 0 ? void 0 : subHeadingStyles.typography,
            color: subHeadingStyles === null || subHeadingStyles === void 0 ? void 0 : subHeadingStyles.color,
            dangerouslySetInnerHTML: {
              __html: subHeading
            }
          })]
        }), headingComp && headingComp]
      }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        children: [backBtn && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BackButtonWrapper, {
          id: backBtnId,
          onClick: onModalClose,
          children: backBtn
        }), (heading || subHeading) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HeaderWrapper, {
          hasBackBtn: !!backBtn,
          children: [heading && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
            color: headingStyles === null || headingStyles === void 0 ? void 0 : headingStyles.color,
            dangerouslySetInnerHTML: {
              __html: heading
            },
            typography: headingStyles === null || headingStyles === void 0 ? void 0 : headingStyles.typography
          }), subHeading && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubHeading, {
            typography: subHeadingStyles === null || subHeadingStyles === void 0 ? void 0 : subHeadingStyles.typography,
            color: subHeadingStyles === null || subHeadingStyles === void 0 ? void 0 : subHeadingStyles.color,
            dangerouslySetInnerHTML: {
              __html: subHeading
            }
          })]
        }), _showCloseButton && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseButtonWrapper, {
          id: closeBtnId,
          onClick: onModalClose,
          children: _closeButton
        }), headingComp && headingComp]
      }), _modalType === 'fullPage' ? (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollContainerFullPage, {
        children: children
      }) : (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollContainer, {
        modalMaxHeight: modalMaxHeight,
        children: children
      })]
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalBackdrop, {
      onClick: onModalClose
    })]
  });
};

const CheckboxWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].label.withConfig({
  displayName: "Checkboxstyles__CheckboxWrapper",
  componentId: "sc-1oh74xo-0"
})(["display:flex;align-items:center;cursor:pointer;font-family:", ";margin:", ";width:max-content;"], ({
  theme
}) => theme.fontFamily, ({
  margin: _margin = '0px'
}) => _margin);
const StyledCheckbox = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "Checkboxstyles__StyledCheckbox",
  componentId: "sc-1oh74xo-1"
})(["width:18px;height:18px;background:", ";border:1px solid ", ";border-radius:", ";position:relative;appearance:none;&::before{content:'';display:", ";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:12px;height:12px;background-image:url('https://tripmoneycmsimgak.mmtcdn.com/img/tick_1753282273.png');background-size:contain;background-repeat:no-repeat;}&:disabled{border-color:", ";}"], ({
  theme,
  checked
}) => checked ? theme.colors.primaryAccent : theme.colors.white, ({
  checked,
  theme
}) => !checked ? theme.colors.lowEmphasis : 'unset', ({
  theme
}) => theme.borderRadius.br4, ({
  checked
}) => checked ? 'block' : 'none', ({
  theme
}) => theme.colors.disabled);
const Label = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Checkboxstyles__Label",
  componentId: "sc-1oh74xo-2"
})(["", ""], ({
  theme,
  typography: _typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.mediumW1,
  fontColor
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_typography, theme.partner);
  return `
      ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
       margin-left: 8px;
      color: ${fontColor || theme.colors.highEmphasis};
    `;
});

const Checkbox = ({
  id,
  label,
  checked,
  onChange,
  disabled,
  margin,
  typography,
  className,
  fontColor
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CheckboxWrapper, {
    className: className,
    id: id,
    margin: margin,
    disabled: disabled,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCheckbox, {
      checked: checked,
      onChange: onChange,
      disabled: disabled
    }), label && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
      fontColor: fontColor,
      typography: typography,
      children: label
    })]
  });
};

const SwitchContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].label.withConfig({
  displayName: "Switchstyles__SwitchContainer",
  componentId: "sc-1fgbbu5-0"
})(["position:relative;display:inline-block;width:52px;height:32px;margin:", ";cursor:", ";opacity:", ";"], ({
  margin: _margin = '0px'
}) => _margin, ({
  disabled
}) => disabled ? 'default' : 'pointer', ({
  theme,
  disabled,
  checked
}) => checked && disabled || theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.GI && disabled ? 0.6 : 1);
const SwitchInput = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({
  displayName: "Switchstyles__SwitchInput",
  componentId: "sc-1fgbbu5-1"
})(["opacity:0;width:0;height:0;"]);
const Slider = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Switchstyles__Slider",
  componentId: "sc-1fgbbu5-2"
})(["position:absolute;top:0;left:0;right:0;bottom:0;border-radius:35px;background-color:", ";border:", ";transition:background-color 0.4s ease;&::before{position:absolute;content:'';width:24px;height:24px;top:", ";left:", ";border-radius:50%;background-color:", ";transition:left 0.4s ease;}"], ({
  checked,
  disabled,
  theme
}) => {
  if (disabled) {
    return checked ? theme.colors.primaryAccent : theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? theme.colors.screenBg : theme.colors.disabledBg;
  }
  return checked ? theme.colors.primaryAccent : theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? theme.colors.lightBlue : theme.colors.disabledBg;
}, ({
  checked,
  theme
}) => !checked && theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? `2px solid ${theme.colors.disabledBg}` : 'none', ({
  checked,
  theme
}) => !checked && theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? '2px' : '4px', ({
  checked
}) => checked ? '24px' : '4px', ({
  checked,
  disabled,
  theme
}) => {
  if (checked) return theme.colors.white;
  if (disabled) return theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? theme.colors.disabledBg : theme.colors.white;
  return theme.partner === _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? theme.colors.disabled : theme.colors.white;
});

const Switch = ({
  id,
  checked,
  onChange,
  disabled: _disabled = false,
  margin
}) => {
  const handleChange = () => {
    if (onChange) {
      onChange(!checked);
    }
  };
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SwitchContainer, {
    id: id,
    disabled: _disabled,
    margin: margin,
    checked: checked,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SwitchInput, {
      type: "checkbox",
      checked: checked,
      onChange: handleChange,
      disabled: _disabled
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Slider, {
      checked: checked,
      disabled: _disabled
    })]
  });
};

var wellKnownSymbol$3 = wellKnownSymbol$a;

var TO_STRING_TAG$3 = wellKnownSymbol$3('toStringTag');
var test = {};

test[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$f;
var classofRaw = classofRaw$1;
var wellKnownSymbol$2 = wellKnownSymbol$a;

var TO_STRING_TAG$2 = wellKnownSymbol$2('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
};

var classof = classof$1;

var $String = String;

var toString$2 = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$1 = functionUncurryThis;
var requireObjectCoercible = requireObjectCoercible$4;
var toString$1 = toString$2;
var whitespaces$1 = whitespaces$2;

var replace = uncurryThis$1(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var globalThis$3 = globalThis_1;
var fails$1 = fails$d;
var uncurryThis = functionUncurryThis;
var toString = toString$2;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt$1 = globalThis$3.parseInt;
var Symbol$1 = globalThis$3.Symbol;
var ITERATOR$1 = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED$2 = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$1 && !fails$1(function () { $parseInt$1(Object(ITERATOR$1)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$2 ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt$1(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$2 = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$2({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});

var isPrototypeOf = objectIsPrototypeOf;

var $TypeError$1 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError$1('Incorrect invocation');
};

var makeBuiltIn = makeBuiltInExports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor$1 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

var DESCRIPTORS$1 = descriptors;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$4;

var createProperty$1 = function (object, key, value) {
  if (DESCRIPTORS$1) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};

var $$1 = _export;
var globalThis$2 = globalThis_1;
var anInstance = anInstance$1;
var anObject$3 = anObject$8;
var isCallable = isCallable$f;
var getPrototypeOf = objectGetPrototypeOf;
var defineBuiltInAccessor = defineBuiltInAccessor$1;
var createProperty = createProperty$1;
var fails = fails$d;
var hasOwn = hasOwnProperty_1;
var wellKnownSymbol$1 = wellKnownSymbol$a;
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var DESCRIPTORS = descriptors;

var CONSTRUCTOR = 'constructor';
var ITERATOR = 'Iterator';
var TO_STRING_TAG$1 = wellKnownSymbol$1('toStringTag');

var $TypeError = TypeError;
var NativeIterator = globalThis$2[ITERATOR];

// FF56- have non-standard global helper `Iterator`
var FORCED$1 = !isCallable(NativeIterator)
  || NativeIterator.prototype !== IteratorPrototype$1
  // FF44- non-standard `Iterator` passes previous tests
  || !fails(function () { NativeIterator({}); });

var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype$1);
  if (getPrototypeOf(this) === IteratorPrototype$1) throw new $TypeError('Abstract class Iterator not directly constructable');
};

var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS) {
    defineBuiltInAccessor(IteratorPrototype$1, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject$3(this);
        if (this === IteratorPrototype$1) throw new $TypeError("You can't redefine this property");
        if (hasOwn(this, key)) this[key] = replacement;
        else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype$1[key] = value;
};

if (!hasOwn(IteratorPrototype$1, TO_STRING_TAG$1)) defineIteratorPrototypeAccessor(TO_STRING_TAG$1, ITERATOR);

if (FORCED$1 || !hasOwn(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype$1;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$$1({ global: true, constructor: true, forced: FORCED$1 }, {
  Iterator: IteratorConstructor
});

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
var getIteratorDirect$1 = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};

var defineBuiltIn = defineBuiltIn$4;

var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

var call$2 = functionCall;
var anObject$2 = anObject$8;
var getMethod$1 = getMethod$3;

var iteratorClose$4 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$2(iterator);
  try {
    innerResult = getMethod$1(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$2(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$2(innerResult);
  return value;
};

var iteratorClose$3 = iteratorClose$4;

var iteratorCloseAll$1 = function (iters, kind, value) {
  for (var i = iters.length - 1; i >= 0; i--) {
    if (iters[i] === undefined) continue;
    try {
      value = iteratorClose$3(iters[i].iterator, kind, value);
    } catch (error) {
      kind = 'throw';
      value = error;
    }
  }
  if (kind === 'throw') throw value;
  return value;
};

var call$1 = functionCall;
var create = objectCreate;
var createNonEnumerableProperty = createNonEnumerableProperty$5;
var defineBuiltIns = defineBuiltIns$1;
var wellKnownSymbol = wellKnownSymbol$a;
var InternalStateModule = internalState;
var getMethod = getMethod$3;
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var createIterResultObject = createIterResultObject$2;
var iteratorClose$2 = iteratorClose$4;
var iteratorCloseAll = iteratorCloseAll$1;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var NORMAL = 'normal';
var THROW = 'throw';
var setInternalState = InternalStateModule.set;

var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);

  return defineBuiltIns(create(IteratorPrototype), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      if (state.done) return createIterResultObject(undefined, true);
      try {
        var result = state.nextHandler();
        return state.returnHandlerResult ? result : createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod(iterator, 'return');
        return returnMethod ? call$1(returnMethod, iterator) : createIterResultObject(undefined, true);
      }
      if (state.inner) try {
        iteratorClose$2(state.inner.iterator, NORMAL);
      } catch (error) {
        return iteratorClose$2(iterator, THROW, error);
      }
      if (state.openIters) try {
        iteratorCloseAll(state.openIters, NORMAL);
      } catch (error) {
        return iteratorClose$2(iterator, THROW, error);
      }
      if (iterator) iteratorClose$2(iterator, NORMAL);
      return createIterResultObject(undefined, true);
    }
  });
};

var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);

createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');

var iteratorCreateProxy = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState(this, state);
  };

  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;

  return IteratorProxy;
};

var anObject$1 = anObject$8;
var iteratorClose$1 = iteratorClose$4;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$1(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$1(iterator, 'throw', error);
  }
};

// Should throw an error on invalid iterator
// https://issues.chromium.org/issues/336839115
var iteratorHelperThrowsOnInvalidIterator$1 = function (methodName, argument) {
  // eslint-disable-next-line es/no-iterator -- required for testing
  var method = typeof Iterator == 'function' && Iterator.prototype[methodName];
  if (method) try {
    method.call({ next: null }, argument).next();
  } catch (error) {
    return true;
  }
};

var globalThis$1 = globalThis_1;

// https://github.com/tc39/ecma262/pull/3467
var iteratorHelperWithoutClosingOnEarlyError$1 = function (METHOD_NAME, ExpectedError) {
  var Iterator = globalThis$1.Iterator;
  var IteratorPrototype = Iterator && Iterator.prototype;
  var method = IteratorPrototype && IteratorPrototype[METHOD_NAME];

  var CLOSED = false;

  if (method) try {
    method.call({
      next: function () { return { done: true }; },
      'return': function () { CLOSED = true; }
    }, -1);
  } catch (error) {
    // https://bugs.webkit.org/show_bug.cgi?id=291195
    if (!(error instanceof ExpectedError)) CLOSED = false;
  }

  if (!CLOSED) return method;
};

var $ = _export;
var call = functionCall;
var aCallable = aCallable$3;
var anObject = anObject$8;
var getIteratorDirect = getIteratorDirect$1;
var createIteratorProxy = iteratorCreateProxy;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var iteratorClose = iteratorClose$4;
var iteratorHelperThrowsOnInvalidIterator = iteratorHelperThrowsOnInvalidIterator$1;
var iteratorHelperWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError$1;

var MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('map', function () { /* empty */ });
var mapWithoutClosingOnEarlyError = !MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR
  && iteratorHelperWithoutClosingOnEarlyError('map', TypeError);

var FORCED = MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR || mapWithoutClosingOnEarlyError;

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var result = anObject(call(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://tc39.es/ecma262/#sec-iterator.prototype.map
$({ target: 'Iterator', proto: true, real: true, forced: FORCED }, {
  map: function map(mapper) {
    anObject(this);
    try {
      aCallable(mapper);
    } catch (error) {
      iteratorClose(this, 'throw', error);
    }

    if (mapWithoutClosingOnEarlyError) return call(mapWithoutClosingOnEarlyError, this, mapper);

    return new IteratorProxy(getIteratorDirect(this), {
      mapper: mapper
    });
  }
});

const ParaStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
  displayName: "FormattedTextstyles__ParaStyle",
  componentId: "sc-1vtotqd-0"
})(["", ""], props => {
  const {
    theme,
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW1,
    color,
    gradient,
    numberOfLines,
    margin
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  // Gradient text styles - use CSS gradient string from BFF
  const gradientStyles = gradient ? `
      background: ${gradient};
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    ` : `
      color: ${color || theme.colors.highEmphasis};
    `;
  return `
      ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
      font-family: ${theme.fontFamily};
      ${gradientStyles}
      ${margin && `margin: ${margin};`}
      ${numberOfLines && `
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: ${numberOfLines};
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: nowrap;
      `}
    `;
});
const SpanStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "FormattedTextstyles__SpanStyle",
  componentId: "sc-1vtotqd-1"
})(["", ""], props => {
  const {
    theme,
    typography = _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW1,
    color,
    gradient,
    cursor,
    underline
  } = props;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  // Gradient text styles - use CSS gradient string from BFF
  const gradientStyles = gradient ? `
      background: ${gradient};
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    ` : `
      color: ${color || theme.colors.highEmphasis};
    `;
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", " ", " font-family:", ";", " ", " pointer-events:", ";text-decoration:", ";"], (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB), fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`, theme.fontFamily, gradientStyles, cursor && `cursor: ${cursor};`, cursor === 'pointer' ? 'auto' : 'none', underline ? 'underline' : 'none');
});

const FormattedText = ({
  numberOfLines,
  text,
  onClick,
  color,
  gradient,
  typography,
  margin,
  className,
  isDisabled,
  isbreakAllowed
}) => {
  if (!text || Array.isArray(text) && !text.length) return null;
  // Helper for text item click
  const getTextItemOnClick = textItem => {
    if (isDisabled) return undefined;
    if ((textItem === null || textItem === void 0 ? void 0 : textItem.clickable) && onClick) {
      return event => onClick(textItem, event);
    }
    return undefined;
  };
  // Helper for icon item click
  const getIconItemOnClick = iconItem => {
    if (isDisabled) return undefined;
    if ((iconItem === null || iconItem === void 0 ? void 0 : iconItem.clickable) && onClick) {
      return () => onClick(iconItem);
    }
    return undefined;
  };
  const getTextItemCursor = textItem => isDisabled ? 'inherit' : (textItem === null || textItem === void 0 ? void 0 : textItem.clickable) ? 'pointer' : 'inherit';
  const renderTextItem = (item, index, isbreakAllowed = true) => {
    if (!item) return null;
    if (item.type === 'text' && item.text) {
      const textItem = item;
      return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SpanStyle, {
          typography: textItem.typography || typography,
          color: textItem.color,
          gradient: textItem.gradient,
          onClick: getTextItemOnClick(textItem),
          cursor: getTextItemCursor(textItem),
          underline: textItem === null || textItem === void 0 ? void 0 : textItem.underline,
          children: textItem.text
        }), isbreakAllowed && '\u00A0']
      }, index);
    }
    if (item.type === 'icon' && item.iconUrl) {
      const iconItem = item;
      return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
          src: iconItem.iconUrl,
          width: iconItem.iconSize || '24px',
          height: iconItem.iconSize || '24px',
          onClick: getIconItemOnClick(iconItem),
          showCursorPointer: isDisabled ? false : iconItem === null || iconItem === void 0 ? void 0 : iconItem.clickable
        }), "\u00A0"]
      }, index);
    }
    return null;
  };
  const isTextItem = obj => obj && obj.type === 'text';
  const isIconItem = obj => obj && obj.type === 'icon';
  const getTextType = text => {
    if (typeof text === 'string') return 'string';
    if (Array.isArray(text)) return 'array';
    if (isTextItem(text) || isIconItem(text)) return 'item';
    return 'unknown';
  };
  const renderTextContent = ({
    isbreakAllowed
  }) => {
    switch (getTextType(text)) {
      case 'string':
        return text;
      case 'array':
        return text.map((item, index) => renderTextItem(item, index, isbreakAllowed));
      case 'item':
        return renderTextItem(text, 0);
      default:
        return null;
    }
  };
  // For the main ParaStyle
  const paraStyleOnClick = typeof text === 'string' && !isDisabled ? onClick : undefined;
  const paraStyleCursor = isDisabled ? {
    cursor: 'not-allowed'
  } : undefined;
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParaStyle, {
    color: color,
    gradient: gradient,
    typography: typography,
    margin: margin,
    numberOfLines: numberOfLines,
    onClick: paraStyleOnClick,
    className: className,
    style: paraStyleCursor,
    children: renderTextContent({
      isbreakAllowed: isbreakAllowed !== null && isbreakAllowed !== void 0 ? isbreakAllowed : true
    })
  });
};

const InputWrap = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "FloatingTextFieldstyles__InputWrap",
  componentId: "unethj-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";flex-shrink:0;label{font-family:", ";", " color:", ";display:block;transition:all 0.3s ease;display:inline-block;position:absolute;left:", ";top:50%;transform-origin:left;transform:translateY(-50%);text-transform:uppercase;pointer-events:none;", " ", " ", "}"], ({
  margin
}) => margin, ({
  theme
}) => theme.fontFamily, ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW2, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  theme
}) => theme.colors.mediumEmphasis, ({
  leftIcon
}) => leftIcon ? '44px' : '10px', ({
  errorState,
  theme
}) => errorState && `
        color: ${theme.colors.error}; 
      `, ({
  placeholder,
  theme
}) => placeholder && `
        color: ${theme.colors.disabled}; 
        transform: translateY(-20px) scale(0.8);
      `, ({
  disableState,
  theme
}) => disableState && `
      pointer-events: none;
      color: ${theme.colors.disabled}; 
    `);
const InputStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({
  displayName: "FloatingTextFieldstyles__InputStyle",
  componentId: "unethj-1"
})(["background:", ";border:", ";border-radius:", ";width:100%;padding:", ";", " &::placeholder{color:", ";}&:focus + label{color:", ";background:", ";transform:translateY(-20px) scale(0.8);left:", ";", "}&:valid + label{color:", ";left:", ";background:", ";transform:translateY(-20px) scale(0.8);", " ", " ", " ", "}", " ", " &:focus{outline:none;border:", ";background:", ";}&:valid{outline:none;background:", ";border:", ";", "}::-webkit-inner-spin-button,::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}"], ({
  theme
}) => theme.colors.screenBg, ({
  theme
}) => `1px solid ${theme.colors.cardBorder}`, ({
  theme
}) => theme.borderRadius.br8, ({
  leftIcon,
  rightIcon,
  rightEndText,
  paddingRight,
  paddingLeft
}) => leftIcon && rightIcon ? `20px ${paddingRight} 8px ${paddingLeft}` : leftIcon && rightEndText ? `20px ${paddingRight} 8px 44px` : rightEndText ? `20px ${paddingRight} 8px 12px` : leftIcon ? `20px 12px 8px ${paddingLeft}` : rightIcon ? `20px ${paddingRight || '44px'} 8px 12px` : '20px 10px 8px', ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.mediumW3, theme.partner);
  return `
      ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
    `;
}, ({
  theme
}) => theme.colors.disabled, ({
  theme
}) => theme.colors.primaryAccent, ({
  theme
}) => theme.colors.lightBlue, ({
  leftIcon
}) => leftIcon ? '12px' : '10px', ({
  errorState,
  theme
}) => errorState && `color: ${theme.colors.error};
       background: ${theme.colors.errorBg};`, ({
  theme
}) => theme.colors.lowEmphasis, ({
  leftIcon
}) => leftIcon ? '12px' : '10px', ({
  theme
}) => theme.colors.screenBg, ({
  isActive,
  theme
}) => isActive && `
      color: ${theme.colors.primaryAccent};
      background: ${theme.colors.lightBlue};
    `, ({
  placeholder,
  theme
}) => placeholder && `
    color: ${theme.colors.primaryAccent}; 
    background: ${theme.colors.lightBlue};
    `, ({
  errorState,
  theme
}) => errorState && `color: ${theme.colors.error}; background: ${theme.colors.errorBg};`, ({
  disableState,
  theme
}) => disableState && `color: ${theme.colors.disabled}; background: ${theme.colors.screenBg};`, ({
  disableState,
  theme
}) => disableState && `
    pointer-events: none;
    color: ${theme.colors.disabled}; 
    background: ${theme.colors.white}; 
  `, ({
  errorState,
  theme
}) => errorState && `
   border: 1px solid ${theme.colors.error} !important;
    background: ${theme.colors.errorBg} !important;
  `, ({
  theme
}) => `1px solid ${theme.colors.primaryAccent}`, ({
  theme
}) => theme.colors.lightBlue, ({
  theme
}) => theme.colors.screenBg, ({
  theme
}) => `1px solid ${theme.colors.cardBorder}`, ({
  isActive,
  theme
}) => isActive && `
      border: 1px solid ${theme.colors.primaryAccent};
      background: ${theme.colors.lightBlue};
    `);
const BottomRightTextContainer = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(FormattedText).withConfig({
  displayName: "FloatingTextFieldstyles__BottomRightTextContainer",
  componentId: "unethj-2"
})(["position:absolute;bottom:27px;right:10px;"]);
const RightTextContainer = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(FormattedText).withConfig({
  displayName: "FloatingTextFieldstyles__RightTextContainer",
  componentId: "unethj-3"
})(["position:absolute;right:0;top:12px;display:flex;"]);
const InputWpr = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "FloatingTextFieldstyles__InputWpr",
  componentId: "unethj-4"
})(["position:relative;width:", ";"], ({
  width
}) => width);
const IconContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "FloatingTextFieldstyles__IconContainer",
  componentId: "unethj-5"
})(["position:absolute;top:", ";display:block;", " transform:translateY(-50%);transition:all 0.3s ease-in-out;cursor:pointer;"], ({
  isFocus,
  value
}) => isFocus || value ? '65%' : '50%', ({
  direction
}) => direction === 'left' ? 'left: 12px;' : 'right: 12px;');
const ErrorStateText = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(FormattedText).withConfig({
  displayName: "FloatingTextFieldstyles__ErrorStateText",
  componentId: "unethj-6"
})(["color:", ";"], ({
  theme
}) => theme.colors.error);
const ParaTag = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
  displayName: "FloatingTextFieldstyles__ParaTag",
  componentId: "unethj-7"
})(["margin:", ";color:", ";", ""], ({
  margin
}) => margin || '0', ({
  color
}) => color, ({
  theme,
  errorStateText
}) => {
  const typography = errorStateText ? _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1 : _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW2;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
});

const FloatingTextField = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(({
  placeholderTxt,
  labelTxt,
  disableState,
  margin,
  errorState,
  value,
  onChange,
  rightEndText,
  rightEndTextColor,
  maxLength,
  onFocus,
  onBlur,
  inputMode,
  onRightIconClick,
  onLeftIconClick,
  inputWprId,
  inputId,
  rightIcon,
  leftIcon,
  errorStateText,
  leftIconStyle: _leftIconStyle = {
    height: '24px',
    width: '24px'
  },
  rightIconStyle: _rightIconStyle = {
    height: '24px',
    width: '24px'
  },
  autoFocus,
  className,
  verifiedText,
  bottomRightText,
  inputContainerWidth
}, ref) => {
  const [isFocus, setIsFocus] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  const [rightEndTextWidth, setRightEndTextWidth] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__.ThemeContext);
  const rightEndTextRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  const bottomRightTextMargin = bottomRightText ? '27px' : '12px ';
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (rightEndTextRef.current) {
      const width = rightEndTextRef.current.offsetWidth;
      setRightEndTextWidth(width);
    }
  }, [rightEndText]);
  const handleFocus = event => {
    setIsFocus(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  };
  const handleBlur = event => {
    setIsFocus(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  };
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputWrap, {
    disableState: disableState,
    margin: margin,
    placeholder: placeholderTxt,
    id: inputWprId,
    errorState: errorState,
    leftIcon: leftIcon,
    className: className,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputWpr, {
      width: inputContainerWidth,
      children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputStyle, {
        ref: ref,
        id: inputId,
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        isActive: isFocus,
        inputMode: inputMode,
        onChange: onChange,
        value: value,
        errorState: errorState,
        onBlur: handleBlur,
        disableState: disableState,
        onFocus: handleFocus,
        autoFocus: autoFocus,
        placeholder: placeholderTxt,
        spellCheck: false,
        maxLength: maxLength,
        required: true,
        rightEndText: rightEndText,
        paddingRight: rightEndTextWidth ? `${rightEndTextWidth + 10}px` : rightIcon && (_rightIconStyle === null || _rightIconStyle === void 0 ? void 0 : _rightIconStyle.width) ? `${parseInt(_rightIconStyle.width, 10) + 20}px` : '84px',
        paddingLeft: leftIcon && (_leftIconStyle === null || _leftIconStyle === void 0 ? void 0 : _leftIconStyle.width) ? `${parseInt(_leftIconStyle.width, 10) + 20}px` : '44px'
      }), labelTxt && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        htmlFor: inputId,
        children: labelTxt
      }), rightEndText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightTextContainer, {
        text: rightEndText,
        color: rightEndTextColor,
        margin: `12px 8px ${bottomRightTextMargin} 16px`,
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1
      }), bottomRightText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BottomRightTextContainer, {
        text: bottomRightText,
        typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW2,
        color: theme.colors.mediumEmphasis,
        margin: "4px 0px 0px 12px"
      }), leftIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
        isFocus: isFocus,
        direction: "left",
        onClick: onLeftIconClick,
        value: value,
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
          src: leftIcon,
          height: _leftIconStyle.height,
          width: _leftIconStyle.width
        })
      }), rightIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
        rightEndText: rightEndText,
        direction: "right",
        onClick: onRightIconClick,
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
          src: rightIcon,
          height: _rightIconStyle.height,
          width: _rightIconStyle.width
        })
      })]
    }), errorStateText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ErrorStateText, {
      text: errorStateText,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.error,
      margin: "4px 0px 0px 0px"
    })
    // TODO : Check if this change doesnt affect lisitng page
    // <ParaTag
    //   margin="4px 0px 0px 12px"
    //   errorStateText={errorStateText}
    //   color={theme.colors.error}
    // >
    //   {errorStateText}
    // </ParaTag>
    , verifiedText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormattedText, {
      text: verifiedText,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.mediumEmphasis,
      margin: "4px 0px 0px 0px"
    })]
  });
});

const DropdownInputWrap = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Dropdownstyles__DropdownInputWrap",
  componentId: "sc-164spb4-0"
})(["font-family:", ";position:relative;display:flex;flex-direction:row;margin:", ";width:100%;border:1px solid ", ";border-radius:", ";background:", ";", " ", " ", " label{font-family:", ";", " color:", ";display:block;transition:all 0.3s ease;display:inline-block;position:absolute;left:", ";top:50%;transform-origin:left;transform:translateY(-50%);text-transform:uppercase;pointer-events:none;", " ", " ", " ", "}"], ({
  theme
}) => theme.fontFamily, ({
  margin
}) => margin, ({
  theme
}) => theme.colors.cardBorder, ({
  theme
}) => theme.borderRadius.br8, ({
  theme
}) => theme.colors.screenBg, ({
  isFocused,
  errorState,
  theme
}) => isFocused && !errorState && `
    background: ${theme.colors.lightBlue};
     border-color: ${theme.colors.primaryAccent};
   `, ({
  errorState,
  theme
}) => errorState && `
      border-color: ${theme.colors.error}; 
      background: ${theme.colors.errorBg}; 
      `, ({
  disableState,
  value,
  theme
}) => disableState && `
    pointer-events: none;
    background: ${value ? theme.colors.screenBg : theme.colors.white}; 
  `, ({
  theme
}) => theme.fontFamily, ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW2, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  theme
}) => theme.colors.mediumEmphasis, ({
  leftIcon,
  paddingLeft
}) => leftIcon ? paddingLeft : '12px', ({
  errorState,
  theme
}) => errorState && `
        color: ${theme.colors.error}; 
      `, ({
  placeholder,
  value,
  theme
}) => placeholder && !value && `
      
        color: ${theme.colors.disabled}; 
        transform: translateY(-20px) scale(0.8);
      `, ({
  value,
  leftIcon,
  theme
}) => value && `
        transform: translateY(-20px) scale(0.8);
         left:  ${leftIcon && '12px'};
         top:${leftIcon && '43%'}
      `, ({
  disableState,
  theme
}) => disableState && `
      pointer-events: none;
      color: ${theme.colors.disabled}; 
     
    `);
const DropdownInputStyle = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Dropdownstyles__DropdownInputStyle",
  componentId: "sc-164spb4-1"
})(["display:inline-block;outline:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;user-select:text;color:", ";", " padding:", ";width:100%;", " ", ""], ({
  theme
}) => theme.colors.highEmphasis, ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.smallW3, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  leftIcon,
  rightIcon,
  rightEndText,
  paddingRight,
  paddingLeft,
  value,
  placeholder
}) => {
  const topPadding = '24px';
  const innerPadding = value || placeholder ? '8px' : '24px';
  const defaultLeftPadding = '12px';
  const defaultRightPadding = '12px';
  if (leftIcon && rightIcon) {
    return `${topPadding} ${paddingRight} ${innerPadding} ${paddingLeft}`;
  }
  if (leftIcon && rightEndText) {
    return `${topPadding} ${paddingRight} ${innerPadding} 44px`;
  }
  if (rightEndText) {
    return `${topPadding} ${paddingRight} ${innerPadding} ${defaultRightPadding}`;
  }
  if (leftIcon) {
    return `${topPadding} 4px ${innerPadding} ${paddingLeft}`;
  }
  if (rightIcon) {
    return `${topPadding} ${paddingRight || '44px'} ${innerPadding} ${defaultLeftPadding}`;
  }
  return `${topPadding} 4px ${innerPadding} ${defaultLeftPadding}`;
}, ({
  disableState,
  theme
}) => disableState && `color: ${theme.colors.disabled};
   `, ({
  placeholder,
  value,
  theme
}) => placeholder && !value && `color: ${theme.colors.disabled};
   `);
const DropdownRightTextContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Dropdownstyles__DropdownRightTextContainer",
  componentId: "sc-164spb4-2"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);text-align:right;"]);
const DropdownInputWpr = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Dropdownstyles__DropdownInputWpr",
  componentId: "sc-164spb4-3"
})([""]);
const DropdownIconContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Dropdownstyles__DropdownIconContainer",
  componentId: "sc-164spb4-4"
})(["position:absolute;top:", ";display:block;", " transform:translateY(-50%);transition:all 0.3s ease-in-out;cursor:pointer;"], ({
  value
}) => value ? '65%' : '50%', ({
  direction
}) => direction === 'left' ? 'left: 12px;' : 'right: 12px;');
const DropdownParaTag = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
  displayName: "Dropdownstyles__DropdownParaTag",
  componentId: "sc-164spb4-5"
})(["margin:", ";color:", ";", " max-width:", ";top:", ";position:", ";"], ({
  margin
}) => margin || '0', ({
  color
}) => color, ({
  theme,
  rightEndText
}) => {
  const typography = rightEndText ? _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW2 : _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1;
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(typography, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  maxWidth
}) => maxWidth, ({
  errorState
}) => errorState && '100%', ({
  errorState
}) => errorState && 'absolute');
const AdjacentTextSpan = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Dropdownstyles__AdjacentTextSpan",
  componentId: "sc-164spb4-6"
})(["color:", ";position:absolute;", " top:66%;transform:translateY(-50%);", ""], ({
  theme,
  disableState,
  placeholder,
  value
}) => disableState || placeholder && !value ? theme.colors.disabled : theme.colors.mediumEmphasis, ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1, theme.partner);
  return `
    ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
    ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
  `;
}, ({
  disableState,
  theme
}) => disableState && `
      pointer-events: none;
      color: ${theme.colors.disabled}; 
     
    `);

const Dropdown = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(({
  placeholderTxt,
  labelTxt,
  disableState,
  inputWidth,
  margin,
  errorState,
  value,
  rightEndText,
  onRightElementClick,
  onLeftIconClick,
  handleDropdownPress,
  inputWprId,
  subLabelTxt,
  rightIcon,
  leftIcon,
  leftIconStyle: _leftIconStyle = {
    height: '24px',
    width: '24px'
  },
  rightIconStyle: _rightIconStyle = {
    height: '24px',
    width: '24px'
  },
  rightEndTextColor,
  adjacentText,
  rightEndTextMaxWidth: _rightEndTextMaxWidth = '60px',
  className
}, ref) => {
  const [isFocused, setIsFocused] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__.ThemeContext);
  const handleFocus = () => {
    setIsFocused(true);
  };
  const handleBlur = () => {
    setIsFocused(false);
  };
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DropdownInputWrap, {
    className: className,
    disableState: disableState,
    margin: margin,
    inputWidth: inputWidth,
    placeholder: placeholderTxt,
    id: inputWprId,
    errorState: errorState,
    leftIcon: leftIcon,
    onClick: handleDropdownPress,
    value: value,
    isFocused: isFocused,
    tabIndex: 0,
    onFocus: handleFocus,
    onBlur: handleBlur,
    paddingLeft: leftIcon && (_leftIconStyle === null || _leftIconStyle === void 0 ? void 0 : _leftIconStyle.width) ? `${parseInt(_leftIconStyle.width, 10) + 20}px` : '44px',
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DropdownInputWpr, {
      children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownInputStyle, {
        isFocused: isFocused,
        value: value,
        disableState: disableState,
        rightEndText: rightEndText,
        errorState: errorState,
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        placeholder: placeholderTxt,
        paddingRight: '4px',
        paddingLeft: leftIcon && (_leftIconStyle === null || _leftIconStyle === void 0 ? void 0 : _leftIconStyle.width) ? `${parseInt(_leftIconStyle.width, 10) + 20}px` : '44px',
        children: value || placeholderTxt
      }), labelTxt && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        children: [labelTxt, subLabelTxt && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
          style: {
            fontSize: '10px',
            marginLeft: '2px',
            fontWeight: theme.fontWeight.regular,
            color: disableState || placeholderTxt && !value ? theme.colors.disabled : theme.colors.mediumEmphasis
          },
          children: subLabelTxt
        })]
      }), value && adjacentText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AdjacentTextSpan, {
        value: value,
        disableState: disableState,
        placeholder: placeholderTxt,
        children: adjacentText
      }), rightEndText && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownRightTextContainer, {
        onClick: event => {
          event.stopPropagation();
          onRightElementClick === null || onRightElementClick === void 0 ? void 0 : onRightElementClick();
        },
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownParaTag, {
          margin: "12px 0px 12px 16px",
          color: rightEndTextColor,
          maxWidth: _rightEndTextMaxWidth,
          rightEndText: rightEndText,
          children: rightEndText
        })
      }), leftIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownIconContainer, {
        isFocus: isFocused,
        direction: "left",
        onClick: onLeftIconClick,
        value: value,
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
          src: leftIcon,
          height: _leftIconStyle.height,
          width: _leftIconStyle.width
        })
      }), rightIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownIconContainer, {
        direction: "right",
        onClick: event => {
          event.stopPropagation();
          onRightElementClick === null || onRightElementClick === void 0 ? void 0 : onRightElementClick();
        },
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
          src: rightIcon,
          height: _rightIconStyle.height,
          width: _rightIconStyle.width
        })
      })]
    }), errorState && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropdownParaTag, {
      margin: "4px 0px 0px 12px",
      color: theme.colors.error,
      errorState: errorState,
      children: errorState
    })]
  });
});

const ArrowCont = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "SlickArrowstyles__ArrowCont",
  componentId: "h2nhfg-0"
})(["width:68px;padding:0 5px;height:30px;background-color:", ";box-shadow:0px 0 6px rgba(0,0,0,0.1);border-radius:20px;display:flex;flex-shrink:0;align-items:center;justify-content:space-between;"], ({
  theme
}) => theme.colors.white);
const ArrowBtn = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].button.withConfig({
  displayName: "SlickArrowstyles__ArrowBtn",
  componentId: "h2nhfg-1"
})(["width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;position:relative;outline:none;border:0;background-color:transparent;cursor:pointer;position:relative;&::before{display:inline-block;content:'';border:solid ", ";border-width:0 2px 2px 0;padding:3.5px;}&.disabled{cursor:not-allowed;opacity:0.5;}&::before{transform:", ";}"], ({
  theme
}) => theme.colors.primaryAccent, ({
  buttonType
}) => buttonType === 'next' ? 'rotate(-45deg)' : 'rotate(135deg)');

const SlickArrow = ({
  sliderRef,
  isFirstSlide,
  isLastSlide
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ArrowCont, {
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
      buttonType: "prev",
      onClick: () => {
        var _a;
        (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickPrev();
      },
      disabled: isFirstSlide,
      className: isFirstSlide ? 'disabled' : ''
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
      buttonType: "next",
      onClick: () => {
        var _a;
        return (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickNext();
      },
      disabled: isLastSlide,
      className: isLastSlide ? 'disabled' : ''
    })]
  });
};

const rotate = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
const SpinnerCont = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "Spinnerstyles__SpinnerCont",
  componentId: "sc-6mckxy-0"
})(["display:inline-block;animation:", " 1s linear infinite;border-radius:50%;flex-shrink:0;", ""], rotate, ({
  spinnerWidth,
  spinnerColor,
  thickness
}) => (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["width:", "px;height:", "px;border:", ";border-right-color:transparent;"], spinnerWidth, spinnerWidth, ({
  theme
}) => `${thickness}px solid ${spinnerColor || theme.colors.primaryAccent}`));

const Spinner = ({
  spinnerWidth: _spinnerWidth = 22,
  spinnerColor,
  thickness: _thickness = 2,
  className
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SpinnerCont, {
    spinnerWidth: _spinnerWidth,
    spinnerColor: spinnerColor,
    thickness: _thickness,
    className: className
  });
};

const InputWrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "SearchInputstyles__InputWrapper",
  componentId: "sc-1ieln6g-0"
})(["display:flex;align-items:center;background-color:#fff;column-gap:9px;"]);
const InputStyles = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({
  displayName: "SearchInputstyles__InputStyles",
  componentId: "sc-1ieln6g-1"
})(["color:", ";width:100%;background-color:transparent;border:none;caret-color:", ";", "::placeholder{color:", ";}"], ({
  theme
}) => theme.colors.highEmphasis, ({
  theme
}) => theme.colors.primaryAccent, ({
  theme
}) => {
  const fontStyles = (0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getTypographyStyles)(_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.mediumW2, theme.partner);
  return `
      ${(0,_lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.getFontSizeStyles)(fontStyles.fontSize, _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.DEVICE.WEB)}
      ${fontStyles.fontWeight && `font-weight: ${fontStyles.fontWeight};`}
    `;
}, ({
  theme
}) => theme.colors.disabled);

const SearchInput = ({
  value,
  onChange,
  placeholder,
  src,
  ImageWidth,
  ImageHeight,
  className,
  autoFocus: _autoFocus = false
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputWrapper, {
    className: className,
    children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
      src: src,
      width: ImageWidth,
      height: ImageHeight
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputStyles, {
      value: value,
      onChange: onChange,
      placeholder: placeholder,
      autoFocus: _autoFocus
    })]
  });
};

const shimmer = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__.keyframes)(["0%{background-position:50% 0;}100%{background-position:-50% 0;}"]);
const ShimmerComp = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Shimmerstyles__ShimmerComp",
  componentId: "sc-1d3ucui-0"
})(["animation:", " 1s linear infinite;background:linear-gradient(to right,#e2e2e2 8%,#f6f6f6 18%,#e2e2e2 33%);position:relative;background-size:800px 104px;border-radius:4px;width:", ";height:", ";margin:", ";position:relative;flex-shrink:0;display:flex;align-items:flex-end;"], shimmer, ({
  width
}) => width || '100%', ({
  height
}) => height || '14px', ({
  margin
}) => margin || '');

const Shimmer = ({
  width,
  height,
  margin
}) => {
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShimmerComp, {
    width: width,
    height: height,
    margin: margin
  });
};

const ToastContainer = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "Toaststyles__ToastContainer",
  componentId: "sc-10qaa2n-0"
})(["display:flex;align-items:center;border-radius:", ";font-size:14px;margin:8px 0;position:fixed;bottom:50px;left:40%;z-index:20;padding:12px 16px;background:", ";"], ({
  theme
}) => theme.borderRadius.br8, ({
  theme
}) => theme.colors.mediumEmphasis);
const Message = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(FormattedText).withConfig({
  displayName: "Toaststyles__Message",
  componentId: "sc-10qaa2n-1"
})(["max-width:402px;padding:2px 16px 2px 8px;"]);
const ToastIcon = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Image).withConfig({
  displayName: "Toaststyles__ToastIcon",
  componentId: "sc-10qaa2n-2"
})(["padding:2px 0px;cursor:pointer;"]);
const RightTextAction = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(FormattedText).withConfig({
  displayName: "Toaststyles__RightTextAction",
  componentId: "sc-10qaa2n-3"
})(["cursor:pointer;padding:9px 8px;"]);

const Toast = ({
  showCrossIcon: _showCrossIcon = false,
  message,
  type,
  duration: _duration = 5000,
  toastIcon,
  rightText,
  onToastIconClick,
  onRightTextActionClick,
  onClose,
  className
}) => {
  const [visible, setVisible] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__.ThemeContext);
  const timerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    setVisible(true);
    startTimer();
    return () => clearTimer();
  }, [_duration]);
  const startTimer = () => {
    timerRef.current = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, _duration);
  };
  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };
  if (!visible) return null;
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ToastContainer, {
    type: type,
    className: className,
    children: [_showCrossIcon && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ToastIcon, {
      src: toastIcon || 'https://tripmoneycmsimgak.mmtcdn.com/img/Vector_1_83cdc73532.png',
      height: "20px",
      width: "20px",
      onClick: onToastIconClick
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Message, {
      text: message,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW1,
      color: theme.colors.white
    }), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightTextAction, {
      text: rightText,
      typography: _lib_design_tokens__WEBPACK_IMPORTED_MODULE_1__.TYPOGRAPHY_KEYS.baseW2,
      color: theme.colors.white,
      onClick: onRightTextActionClick
    })]
  });
};

const SnackBarCont = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
  displayName: "SnackBarstyles__SnackBarCont",
  componentId: "sc-109egym-0"
})(["margin:", ";background:", ";padding:8px 12px;border-radius:", ";width:", ";"], ({
  margin
}) => margin, ({
  theme,
  backGroundColor
}) => backGroundColor || theme.colors.errorSnackBg, ({
  theme
}) => theme.borderRadius.br8, ({
  width
}) => width || '100%');

const SnackBar = ({
  backGroundColor,
  width,
  margin,
  text,
  typography,
  className,
  color
}) => {
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__.ThemeContext);
  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SnackBarCont, {
    className: className,
    backGroundColor: backGroundColor,
    margin: margin,
    width: width,
    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormattedText, {
      text: text,
      color: color || theme.colors.mediumEmphasis,
      typography: typography
    })
  });
};




/***/ }),

/***/ 8772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BORDER_RADIUS_KEYS": function() { return /* binding */ BORDER_RADIUS_KEYS; },
/* harmony export */   "DEVICE": function() { return /* binding */ DEVICE; },
/* harmony export */   "FONT_FAMILY": function() { return /* binding */ FONT_FAMILY; },
/* harmony export */   "FONT_SIZE_KEYS": function() { return /* binding */ FONT_SIZE_KEYS; },
/* harmony export */   "FONT_WEIGHTS": function() { return /* binding */ FONT_WEIGHTS; },
/* harmony export */   "PARTNER": function() { return /* binding */ PARTNER; },
/* harmony export */   "TYPOGRAPHY_KEYS": function() { return /* binding */ TYPOGRAPHY_KEYS; },
/* harmony export */   "getFontSizeStyles": function() { return /* binding */ getFontSizeStyles; },
/* harmony export */   "getTheme": function() { return /* binding */ getTheme; },
/* harmony export */   "getTypographyStyles": function() { return /* binding */ getTypographyStyles; }
/* harmony export */ });
function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var FONT_FAMILY;
(function(FONT_FAMILY) {
    FONT_FAMILY["LATO"] = "Lato";
    FONT_FAMILY["RUBIK"] = "Rubik";
})(FONT_FAMILY || (FONT_FAMILY = {}));
var PARTNER;
(function(PARTNER) {
    PARTNER["MMT"] = "mmt";
    PARTNER["GI"] = "gi";
})(PARTNER || (PARTNER = {}));
var DEVICE;
(function(DEVICE) {
    DEVICE["WEB"] = "web";
    DEVICE["APP"] = "app";
})(DEVICE || (DEVICE = {}));
var FONT_SIZE_KEYS;
(function(FONT_SIZE_KEYS) {
    FONT_SIZE_KEYS["FONT32"] = "font32";
    FONT_SIZE_KEYS["FONT30"] = "font30";
    FONT_SIZE_KEYS["FONT24"] = "font24";
    FONT_SIZE_KEYS["FONT22"] = "font22";
    FONT_SIZE_KEYS["FONT18"] = "font18";
    FONT_SIZE_KEYS["FONT16"] = "font16";
    FONT_SIZE_KEYS["FONT14"] = "font14";
    FONT_SIZE_KEYS["FONT12"] = "font12";
})(FONT_SIZE_KEYS || (FONT_SIZE_KEYS = {}));
var BORDER_RADIUS_KEYS;
(function(BORDER_RADIUS_KEYS) {
    BORDER_RADIUS_KEYS["BR2"] = "br2";
    BORDER_RADIUS_KEYS["BR4"] = "br4";
    BORDER_RADIUS_KEYS["BR6"] = "br6";
    BORDER_RADIUS_KEYS["BR8"] = "br8";
    BORDER_RADIUS_KEYS["BR10"] = "br10";
    BORDER_RADIUS_KEYS["BR12"] = "br12";
    BORDER_RADIUS_KEYS["BR16"] = "br16";
    BORDER_RADIUS_KEYS["BR20"] = "br20";
})(BORDER_RADIUS_KEYS || (BORDER_RADIUS_KEYS = {}));
var FONT_WEIGHTS;
(function(FONT_WEIGHTS) {
    FONT_WEIGHTS[FONT_WEIGHTS["REGULAR"] = 400] = "REGULAR";
    FONT_WEIGHTS[FONT_WEIGHTS["MEDIUM"] = 500] = "MEDIUM";
    FONT_WEIGHTS[FONT_WEIGHTS["SEMIBOLD"] = 600] = "SEMIBOLD";
    FONT_WEIGHTS[FONT_WEIGHTS["BOLD"] = 700] = "BOLD";
    FONT_WEIGHTS[FONT_WEIGHTS["EXTRABOLD"] = 900] = "EXTRABOLD";
})(FONT_WEIGHTS || (FONT_WEIGHTS = {}));

const BORDER_RADIUS = {
    [BORDER_RADIUS_KEYS.BR2]: 2,
    [BORDER_RADIUS_KEYS.BR4]: 4,
    [BORDER_RADIUS_KEYS.BR6]: 6,
    [BORDER_RADIUS_KEYS.BR8]: 8,
    [BORDER_RADIUS_KEYS.BR10]: 8,
    [BORDER_RADIUS_KEYS.BR12]: 12,
    [BORDER_RADIUS_KEYS.BR16]: 16,
    [BORDER_RADIUS_KEYS.BR20]: 20
};

// Common color definitions
const COMMON_COLORS$1 = {
    white: '#FFFFFF',
    bodyBg: '#F2F2F2',
    overlay: 'rgba(0, 0, 0, 0.5)',
    shadow: 'rgba(0, 0, 0, 0.2)',
    danger: '#EB2026',
    positiveBg: '#E6FFF9',
    bgLight: '#FCEDD4',
    blueCardBorder: `#CCE8FF`,
    verticalDividerLightBlue: '#d6e7fa',
    bulletPointBlueColor: '#16477f',
    borderBottomGreyColor: '#E8E8E8',
    errorSnackBg: '#FCDADB',
    greyBorder: '#d9d9d9',
    borderColor: '#e7e7e7',
    violetColor: '#8A50C7',
    lightGreenBg: '#e4fbf4',
    royalBlue: '#3543BF',
    lightPastelBlue: '#EFF1FF',
    brightGray: '#ECECEC',
    lightPeach: '#FFEDD1'
};
// MMT and GI-specific overrides
const MMT_COLOR_OVERRIDES$1 = {
    screenBg: '#F6F6F6',
    highEmphasis: '#000000',
    mediumEmphasis: '#4A4A4A',
    lowEmphasis: '#757575',
    disabled: 'rgba(0, 0, 0, 0.3)',
    positive: '#007E7D',
    warning: '#CF8100',
    error: '#EC2127',
    errorBg: '#FFFAFA',
    primaryAccent: '#008CFF',
    lightBlue: '#EAF5FF',
    cardBorder: '#D8D8D8',
    disabledBg: '#CBCBCB',
    lightPurple: '#f3f4fe',
    darkPurple: '#3023AE'
};
const GI_COLOR_OVERRIDES$1 = {
    screenBg: '#F7F7F7',
    highEmphasis: '#222222',
    mediumEmphasis: '#717171',
    lowEmphasis: '#B0B0B0',
    disabled: '#E6E6E6',
    positive: '#156128',
    warning: '#714D0A',
    error: '#FF3A5C',
    errorBg: '#FFEDED',
    primaryAccent: '#2276E3',
    lightBlue: '#E5F3FF',
    cardBorder: '#E4E4E4',
    disabledBg: '#E6E6E6',
    lightPurple: '#f3f4fe',
    darkPurple: '#3023AE'
};
// Utility function to generate color configurations
const createColorConfig$1 = (brandColors)=>_extends({}, COMMON_COLORS$1, brandColors);
// Generate MMT and GI color configurations using the utility function
const MMT_COLORS = createColorConfig$1(MMT_COLOR_OVERRIDES$1);
const GI_COLORS = createColorConfig$1(GI_COLOR_OVERRIDES$1);

// Common color definitions
const COMMON_COLORS = {
    orderNudge: 'linear-gradient(225deg, #3023AE 0%, #C86DD7 100%)'
};
// MMT and GI-specific overrides
const MMT_COLOR_OVERRIDES = {
    buttonBgColor: 'linear-gradient(90deg, rgba(83, 178, 254, 1) 0%, rgba(6, 90, 243, 1) 100%)'
};
const GI_COLOR_OVERRIDES = {
    buttonBgColor: '#FF6D38'
};
// Utility function to generate color configurations
const createColorConfig = (brandColors)=>_extends({}, COMMON_COLORS, brandColors);
// Generate MMT and GI color configurations using the utility function
const MMT_GRADIENT_COLORS = createColorConfig(MMT_COLOR_OVERRIDES);
const GI_GRADIENT_COLORS = createColorConfig(GI_COLOR_OVERRIDES);

const MMT_FONT_WEIGHT = {
    regular: FONT_WEIGHTS.REGULAR,
    medium: FONT_WEIGHTS.BOLD,
    bold: FONT_WEIGHTS.EXTRABOLD
};
const GI_FONT_WEIGHT = {
    regular: FONT_WEIGHTS.REGULAR,
    medium: FONT_WEIGHTS.MEDIUM,
    bold: FONT_WEIGHTS.BOLD
};

const LINE_HEIGHTS = {
    lh38: 38,
    lh36: 36,
    lh28: 28,
    lh26: 26,
    lh21: 21,
    lh18: 18,
    lh16: 16,
    lh14: 14
};

const FONT_SIZES = {
    [FONT_SIZE_KEYS.FONT32]: 32,
    [FONT_SIZE_KEYS.FONT30]: 30,
    [FONT_SIZE_KEYS.FONT24]: 24,
    [FONT_SIZE_KEYS.FONT22]: 22,
    [FONT_SIZE_KEYS.FONT18]: 18,
    [FONT_SIZE_KEYS.FONT16]: 16,
    [FONT_SIZE_KEYS.FONT14]: 14,
    [FONT_SIZE_KEYS.FONT12]: 12
};

const FONT_SIZE_STYLES = {
    [FONT_SIZE_KEYS.FONT32]: {
        fontSize: FONT_SIZES.font32,
        lineHeight: LINE_HEIGHTS.lh38
    },
    [FONT_SIZE_KEYS.FONT30]: {
        fontSize: FONT_SIZES.font30,
        lineHeight: LINE_HEIGHTS.lh36
    },
    [FONT_SIZE_KEYS.FONT24]: {
        fontSize: FONT_SIZES.font24,
        lineHeight: LINE_HEIGHTS.lh28
    },
    [FONT_SIZE_KEYS.FONT22]: {
        fontSize: FONT_SIZES.font22,
        lineHeight: LINE_HEIGHTS.lh26
    },
    [FONT_SIZE_KEYS.FONT18]: {
        fontSize: FONT_SIZES.font18,
        lineHeight: LINE_HEIGHTS.lh21
    },
    [FONT_SIZE_KEYS.FONT16]: {
        fontSize: FONT_SIZES.font16,
        lineHeight: LINE_HEIGHTS.lh18
    },
    [FONT_SIZE_KEYS.FONT14]: {
        fontSize: FONT_SIZES.font14,
        lineHeight: LINE_HEIGHTS.lh16
    },
    [FONT_SIZE_KEYS.FONT12]: {
        fontSize: FONT_SIZES.font12,
        lineHeight: LINE_HEIGHTS.lh14
    }
};
const getFontSizeStyles = (fontSize, device)=>{
    const { fontSize: fs, lineHeight: lh } = FONT_SIZE_STYLES[fontSize] || FONT_SIZE_STYLES[FONT_SIZE_KEYS.FONT14];
    if (device === DEVICE.WEB) {
        return `
      font-size: ${fs}px;
      line-height: ${lh}px;
    `;
    }
    return {
        fontSize: fs,
        lineHeight: lh
    };
};

// Utility function to add "px" suffix to values
const addPxToValues = (obj)=>{
    return Object.fromEntries(Object.entries(obj).map(([key, value])=>[
            key,
            `${value}px`
        ]));
};

// Helper function to get the font weight based on partner
const getFontWeight = (partner, weightType)=>{
    return partner === PARTNER.MMT ? MMT_FONT_WEIGHT[weightType] : GI_FONT_WEIGHT[weightType];
};
const TYPOGRAPHY_KEYS = {
    xLarge: 'xLarge',
    large30: 'large30',
    large: 'large',
    medium: 'medium',
    small: 'small',
    base: 'base',
    largeW1: 'labelLargeW1',
    largeW2: 'labelLargeW2',
    largeW3: 'labelLargeW3',
    mediumW1: 'labelMediumW1',
    mediumW2: 'labelMediumW2',
    mediumW3: 'labelMediumW3',
    smallW1: 'labelSmallW1',
    smallW2: 'labelSmallW2',
    smallW3: 'labelSmallW3',
    baseW1: 'labelBaseW1',
    baseW2: 'labelBaseW2',
    baseW3: 'labelBaseW3'
};
const typographyMap = {
    [TYPOGRAPHY_KEYS.xLarge]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT32,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.large30]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT30,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.large]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT24,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.medium]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT22,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.small]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT18,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.base]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT16,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.largeW1]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT18,
            fontWeight: getFontWeight(partner, 'regular')
        }),
    [TYPOGRAPHY_KEYS.largeW2]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT18,
            fontWeight: getFontWeight(partner, 'medium')
        }),
    [TYPOGRAPHY_KEYS.largeW3]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT18,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.mediumW1]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT16,
            fontWeight: getFontWeight(partner, 'regular')
        }),
    [TYPOGRAPHY_KEYS.mediumW2]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT16,
            fontWeight: getFontWeight(partner, 'medium')
        }),
    [TYPOGRAPHY_KEYS.mediumW3]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT16,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.smallW1]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT14,
            fontWeight: getFontWeight(partner, 'regular')
        }),
    [TYPOGRAPHY_KEYS.smallW2]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT14,
            fontWeight: getFontWeight(partner, 'medium')
        }),
    [TYPOGRAPHY_KEYS.smallW3]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT14,
            fontWeight: getFontWeight(partner, 'bold')
        }),
    [TYPOGRAPHY_KEYS.baseW1]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT12,
            fontWeight: getFontWeight(partner, 'regular')
        }),
    [TYPOGRAPHY_KEYS.baseW2]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT12,
            fontWeight: getFontWeight(partner, 'medium')
        }),
    [TYPOGRAPHY_KEYS.baseW3]: (partner)=>({
            fontSize: FONT_SIZE_KEYS.FONT12,
            fontWeight: getFontWeight(partner, 'bold')
        })
};
const getTypographyStyles = (typography, partner)=>{
    const styleFunction = typographyMap[typography];
    return styleFunction ? styleFunction(partner) : {
        fontSize: FONT_SIZE_KEYS.FONT14,
        fontWeight: getFontWeight(partner, 'regular')
    };
};

const getTheme = (partner, device)=>{
    const isMMT = partner === PARTNER.MMT;
    const baseTheme = {
        colors: isMMT ? MMT_COLORS : GI_COLORS,
        borderRadius: BORDER_RADIUS,
        fontSize: FONT_SIZES,
        lineHeight: LINE_HEIGHTS,
        partner
    };
    if (device === DEVICE.WEB) {
        return _extends({}, baseTheme, {
            borderRadius: addPxToValues(baseTheme.borderRadius),
            fontSize: addPxToValues(baseTheme.fontSize),
            lineHeight: addPxToValues(baseTheme.lineHeight),
            gradientColors: isMMT ? MMT_GRADIENT_COLORS : GI_GRADIENT_COLORS,
            fontFamily: isMMT ? FONT_FAMILY.LATO : FONT_FAMILY.RUBIK,
            fontWeight: isMMT ? MMT_FONT_WEIGHT : GI_FONT_WEIGHT
        });
    }
    return baseTheme;
};




/***/ }),

/***/ 2391:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const track_1 = __webpack_require__(7169);
const Utils_1 = __webpack_require__(7817);
const isOnClient = typeof window !== 'undefined';
class CaptureWebVitals {
    // init: ((async: boolean, defer: boolean, appendOnBody: boolean) => void) | undefined
    /**
     *
     * @param moduleName This name will be used for PDT event name for ex if name is FLIGHTS_WEB_VITALS then log would be like FLIGHTS_WEB_VITALS_FCP, FLIGHTS_WEB_VITALS_LCP etc.
     * @param sampleSize sample size, by default this would be 1% of overall traffic
     */
    constructor(moduleName, sampleSize = 100, templateId, templateName) {
        this.addToQueue = (metric) => {
            const payload = (0, Utils_1.createPayload)(metric, this.moduleName, this.templateId, this.templateName);
            this.queue.add(payload);
        };
        this.initiatePDTCall = () => {
            const body = Array.from(this.queue);
            body.forEach((payload) => {
                (0, track_1.trackEvent)(payload);
            });
        };
        this.flushQueue = () => {
            if (this.queue.size > 0) {
                this.initiatePDTCall();
                this.queue.clear();
            }
        };
        this.handleOnload = () => {
            const webVitals = window.webVitals;
            ['onFCP', 'onLCP', 'onCLS', 'onFID', 'onINP', 'onTTFB'].forEach(event => {
                webVitals[event](this.addToQueue);
            });
        };
        this.addScript = (src, async = true, defer = true, onLoad = () => { }, appendOnBody = false) => {
            if (src) {
                const newScript = document.createElement('script');
                newScript.type = 'text/javascript';
                newScript.async = async;
                newScript.defer = defer;
                newScript.src = src;
                newScript.id = 'core_web_vitals';
                newScript.onload = onLoad;
                appendOnBody ? document.body.appendChild(newScript) : document.head.appendChild(newScript);
            }
        };
        this.init = (async = true, defer = true, appendOnBody = true) => {
            const existingScript = document.getElementById('core_web_vitals');
            const num = Math.floor(Math.random() * 1000);
            if (num > this.sampleSize * 10 || existingScript)
                return;
            this.addScript('https://unpkg.com/web-vitals@3/dist/web-vitals.attribution.iife.js', async, defer, this.handleOnload, appendOnBody);
            if (isOnClient) {
                window.addEventListener('visibilitychange', () => {
                    if (document.visibilityState === 'hidden') {
                        this.flushQueue();
                    }
                });
                window.addEventListener('pagehide', this.flushQueue);
            }
        };
        this.moduleName = moduleName;
        this.queue = new Set();
        this.sampleSize = sampleSize;
        this.templateId = templateId || 52317;
        this.templateName = templateName || 'mmt_commons_b2c_pdt_client_logging';
        window.initWebVitals = this.init;
    }
}
exports["default"] = CaptureWebVitals;


/***/ }),

/***/ 7169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.trackEvent = void 0;
const event_logger_1 = __webpack_require__(1099);
const AnalyticsSdk = (0, event_logger_1.initAndGetAnalyticsSdk)({});
function trackEvent(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        AnalyticsSdk.track(Object.assign({}, payload), 'common');
    });
}
exports.trackEvent = trackEvent;


/***/ }),

/***/ 7817:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createPayload = exports.detectOS = void 0;
const NOT_AVAILABLE = 'NA';
function detectOS() {
    var _a;
    const platform = window.navigator.platform || '';
    if (/(Macintosh|MacIntel|MacPPC|Mac68K)/.test(platform))
        return 'Mac OS';
    if (/(iPhone|iPad|iPod)/.test(platform))
        return 'iOS';
    if (/(Win32|Win64|Windows|WinCE)/.test(platform))
        return 'Windows';
    if (/Android/.test((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent))
        return 'Android';
    if (/Linux/.test(platform))
        return 'Linux';
    return '';
}
exports.detectOS = detectOS;
function getTimeZone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || NOT_AVAILABLE;
    }
    catch (e) {
        return NOT_AVAILABLE;
    }
}
function readCookieValue(cookieString, cookieName) {
    const match = cookieString.match(new RegExp(cookieName + '=(.*?)($|;)'));
    return match ? match[1] : null;
}
function getDeviceName() {
    const parts = ((navigator === null || navigator === void 0 ? void 0 : navigator.userAgent.match(/\((.*?)\)/)) || ['', ''])[1].split(" ");
    return (parts[3] + ' ' + parts[4]) || '';
}
const createPayload = (input, moduleName, templateId, templateName) => {
    var _a, _b;
    const { name, value, attribution } = input;
    const event_detail = {
        event_name: `${moduleName}_${name}`,
        event_type: 'action',
        event_value: value,
        event_id: '',
        event_timestamp: new Date().getTime(),
    };
    const device_context = {
        device_id: readCookieValue(document.cookie, 'dvid') || NOT_AVAILABLE,
        os_version: ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || NOT_AVAILABLE,
        platform: ((_b = window.navigator) === null || _b === void 0 ? void 0 : _b.userAgent.includes('Mobi')) ? 'pwa' : 'desktop',
        os: detectOS() || NOT_AVAILABLE,
        network_type: navigator.connection.effectiveType,
        model: getDeviceName(),
        time_zone: getTimeZone(),
        app_ver: NOT_AVAILABLE,
        build_ver: NOT_AVAILABLE,
        ip_addr: NOT_AVAILABLE,
    };
    switch (name) {
        case 'CLS':
            event_detail.event_id = attribution.largestShiftTarget;
            break;
        case 'LCP':
            event_detail.event_id = attribution.element;
            break;
        case 'FID':
        case 'INP':
            event_detail.event_id = attribution.eventTarget;
            // event_detail.inp_type = attribution.eventType;
            // event_detail.inp_time = attribution.eventTime;
            // event_detail.inp_load_state = attribution.loadState;
            break;
        default:
            break;
    }
    const payload = {
        page_context: {
            page_name: window.location.href || '',
        },
        event_tracking_context: {
            template_id: templateId,
            topic_name: templateName,
            session_visit_number: 1,
            env: 'prod',
            funnel_source: 'mmt',
        },
        context: {
            template_id: templateId,
            topic_name: templateName
        }
    };
    console.log("payload will be ", payload);
    return Object.assign(Object.assign({}, payload), { event_detail, device_context });
};
exports.createPayload = createPayload;


/***/ }),

/***/ 807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.Z = void 0;
var captureWebVitals_1 = __webpack_require__(2391);
Object.defineProperty(exports, "Z", ({ enumerable: true, get: function () { return captureWebVitals_1.default; } }));


/***/ }),

/***/ 8456:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(()=>(()=>{"use strict";var e={d:(t,r)=>{for(var o in r)e.o(r,o)&&!e.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:r[o]})},o:(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r:e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})}},t={};e.r(t),e.d(t,{SS_LIST:()=>b,addKeyConfigMapping:()=>m,getItemBySession:()=>C,itemType:()=>a,removeItemBySession:()=>F,setItemBySession:()=>S});const r="undefined"!=typeof window;var o="awefewfuihewfhewfuhiebc",i="limitedConsent",n="enct-",a={ES:"essential",N_ES:"nonEssential"};function s(e){return s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s(e)}function l(e,t,r){return(t=function(e){var t=function(e,t){if("object"!=s(e)||!e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var o=r.call(e,"string");if("object"!=s(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return"symbol"==s(t)?t:t+""}(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}var u="GI",c="IGO",f="AFFCGOBIZMMTAIX",d=(l(l(l({},u,{colors:{base:{primary:"#016eff"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],family:"'Quicksand', sans-serif",familyHeading:"'Quicksand', sans-serif"}}),c,{colors:{base:{primary:"#00228E"},button:{primary:{bg:"linear-gradient(93deg, #00228E, #00228E)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),f,{colors:{base:{primary:"#FF6423"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),l(l({},u,{ACCOUNTS_TERMS_CONDITION:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",TERMS_OF_SERVICE:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"}),c,{ACCOUNTS_TERMS_CONDITION:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",TERMS_OF_SERVICE:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"}),function(e){var t,o=e||"";r&&(o=(null===(t=window)||void 0===t||null===(t=t.location)||void 0===t?void 0:t.hostname)||"");var i="";return o&&(-1!==o.indexOf("giholidays")?i=u:-1!==o.indexOf("6eholidays")?i=c:-1!==o.indexOf("hdfcsmartbuyholidays")||-1!==o.indexOf("hdfcsmartbuyrailways")?i="HDFC_SB":-1!==o.indexOf("airindiaexpressholidays")?i=f:-1!==o.indexOf("flightsexpert.goibibo")?i="AFFCGOBIZGIFLTEXP":-1!==o.indexOf("flightsexpert.makemytrip")||-1!==o.indexOf("holidaysexpert.makemytrip")?i="AFFCGOBIZMMTFLTEXP":-1!==o.indexOf("forexexpert.makemytrip")?i="AFFTMFXMMTFOREXEXP":-1!==o.indexOf("forexexpert.goibibo")&&(i="AFFTMFXGIFOREXEXP")),i}),y={},m=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};y[e]=t},p=function(e,t,o,i){var n,s,l=o,u=i,c=(null==y?void 0:y[e])||{};return r&&(l=void 0===o?(null===(n=c[t])||void 0===n?void 0:n.type)||a.N_ES:o,u=void 0===i?(null===(s=c[t])||void 0===s?void 0:s.isPiiData)||!1:i),{essential:l=l===a.ES,piiData:u}},g=function(e){var t,r,o=function(e){return new RegExp("(?:^|;\\s*)".concat(e,"\\s*=\\s*([^;]*)"))}((t=e,(r=d(undefined).toLowerCase())?"".concat(t,"-").concat(r):t)),i=o.exec(document.cookie);return null!==i?decodeURIComponent(i[1]):null},h=function(){var e,t,r,o;return"1"!==g("isGdprRegion")||(e=g("myBusinessSubscription"),r=null==(t=g("mmt-auth"))?void 0:t.charAt(t.length-1),!!(e&&"b2b"===e||"C"===r)||(!(o=g("GDPR_C"))||"IS"!==o&&"11"!==o?"fullConsent":i)!==i)},b="sessionList",v=function(e){return new TypeError("Valid key & value is required for sessionStorage ".concat(e))},S=function(e,t,i,a){try{if(!r||!sessionStorage)return!1;if(!e||void 0===t)throw v("get");var s,l=(i||{}).isPiiData,u=(i||{}).shouldStringifyJson,c=p(b,e,a,l);if(s=c.essential,l=c.piiData,!s&&!h())return!1;var f=u?function(e){try{return JSON.stringify(e)}catch(e){return null}}(t):t;if(f&&l){var d=function(e,t){try{var r="",o=0;if(!t)throw new Error("Key is empty");for(var i=0;i<e.length;i+=1){var n=e.charCodeAt(i)^t.charCodeAt(o);r+=String.fromCharCode(n),o=(o+1)%t.length}return r}catch(e){return console.error("An error occurred during encryption:",e),null}}(f,o);if(!d)return!1;f="".concat(n).concat(d)}return sessionStorage.setItem(e,f),!0}catch(e){return!1}},F=function(e){try{if(!r||!sessionStorage)return!1;if(!e)throw v("get");return sessionStorage.removeItem(e),!0}catch(e){return!1}},C=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2?arguments[2]:void 0;try{var a;if(!r||!sessionStorage)return null;if(!e)throw v("get");var s,l=(t||{}).isPiiData,u=(t||{}).shouldParseJson,c=p(b,e,i,l);if(s=c.essential,l=c.piiData,!s&&!h())return null;var f=sessionStorage.getItem(e);if(l&&null!==(a=f)&&void 0!==a&&a.includes(n)){var d=new RegExp("^".concat(n));f=function(e,t){try{var r="",o=0;if(!t)throw new Error("Key is empty");for(var i=0;i<e.length;i+=1){var n=e.charCodeAt(i)^t.charCodeAt(o);r+=String.fromCharCode(n),o=(o+1)%t.length}return r}catch(e){return console.error("An error occurred during the decryption process:",e),null}}(f=f.replace(d,""),o)}return u&&(f=function(e){try{return JSON.parse(e)}catch(e){return null}}(f)),f}catch(e){return!1}};return t})()));

/***/ }),

/***/ 9785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 2765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 5027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(6522);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(9785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isDate/index.js


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return value instanceof Date || (0,esm_typeof/* default */.Z)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(6700);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  return !isNaN(Number(date));
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(2765);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var timestamp = (0,toDate/* default */.Z)(dirtyDate).getTime();
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js


function startOfUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js



function getUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0,toDate/* default */.Z)(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 9800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sub; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(6522);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(2765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(6700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(9785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addDays/index.js



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subDays/index.js



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subMonths/index.js



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/sub/index.js





/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */
function sub(date, duration) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  if (!duration || (0,esm_typeof/* default */.Z)(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? (0,toInteger/* default */.Z)(duration.years) : 0;
  var months = duration.months ? (0,toInteger/* default */.Z)(duration.months) : 0;
  var weeks = duration.weeks ? (0,toInteger/* default */.Z)(duration.weeks) : 0;
  var days = duration.days ? (0,toInteger/* default */.Z)(duration.days) : 0;
  var hours = duration.hours ? (0,toInteger/* default */.Z)(duration.hours) : 0;
  var minutes = duration.minutes ? (0,toInteger/* default */.Z)(duration.minutes) : 0;
  var seconds = duration.seconds ? (0,toInteger/* default */.Z)(duration.seconds) : 0;

  // Subtract years and months
  var dateWithoutMonths = subMonths(date, months + years * 12);

  // Subtract weeks and days
  var dateWithoutDays = subDays(dateWithoutMonths, days + weeks * 7);

  // Subtract hours, minutes and seconds
  var minutestoSub = minutes + hours * 60;
  var secondstoSub = seconds + minutestoSub * 60;
  var mstoSub = secondstoSub * 1000;
  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}

/***/ }),

/***/ 6700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6522);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9785);


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/***/ }),

/***/ 5480:
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
	 true ? factory(exports) :
	0;
}(this, (function (exports) { 'use strict';

	/*!
	 * ScrollTrigger 3.8.0
	 * https://greensock.com
	 *
	 * @license Copyright 2008-2021, GreenSock. All rights reserved.
	 * Subject to the terms at https://greensock.com/standard-license or for
	 * Club GreenSock members, the agreement issued with that membership.
	 * @author: Jack Doyle, jack@greensock.com
	*/
	var gsap,
	    _coreInitted,
	    _win,
	    _doc,
	    _docEl,
	    _body,
	    _root,
	    _resizeDelay,
	    _raf,
	    _request,
	    _toArray,
	    _clamp,
	    _time2,
	    _syncInterval,
	    _refreshing,
	    _pointerIsDown,
	    _transformProp,
	    _i,
	    _prevWidth,
	    _prevHeight,
	    _autoRefresh,
	    _sort,
	    _suppressOverwrites,
	    _ignoreResize,
	    _limitCallbacks,
	    _startup = 1,
	    _proxies = [],
	    _scrollers = [],
	    _getTime = Date.now,
	    _time1 = _getTime(),
	    _lastScrollTime = 0,
	    _enabled = 1,
	    _passThrough = function _passThrough(v) {
	  return v;
	},
	    _getTarget = function _getTarget(t) {
	  return _toArray(t)[0] || (_isString(t) ? console.warn("Element not found:", t) : null);
	},
	    _round = function _round(value) {
	  return Math.round(value * 100000) / 100000 || 0;
	},
	    _windowExists = function _windowExists() {
	  return typeof window !== "undefined";
	},
	    _getGSAP = function _getGSAP() {
	  return gsap || _windowExists() && (gsap = window.gsap) && gsap.registerPlugin && gsap;
	},
	    _isViewport = function _isViewport(e) {
	  return !!~_root.indexOf(e);
	},
	    _getProxyProp = function _getProxyProp(element, property) {
	  return ~_proxies.indexOf(element) && _proxies[_proxies.indexOf(element) + 1][property];
	},
	    _getScrollFunc = function _getScrollFunc(element, _ref) {
	  var s = _ref.s,
	      sc = _ref.sc;

	  var i = _scrollers.indexOf(element),
	      offset = sc === _vertical.sc ? 1 : 2;

	  !~i && (i = _scrollers.push(element) - 1);
	  return _scrollers[i + offset] || (_scrollers[i + offset] = _getProxyProp(element, s) || (_isViewport(element) ? sc : function (value) {
	    return arguments.length ? element[s] = value : element[s];
	  }));
	},
	    _getBoundsFunc = function _getBoundsFunc(element) {
	  return _getProxyProp(element, "getBoundingClientRect") || (_isViewport(element) ? function () {
	    _winOffsets.width = _win.innerWidth;
	    _winOffsets.height = _win.innerHeight;
	    return _winOffsets;
	  } : function () {
	    return _getBounds(element);
	  });
	},
	    _getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref2) {
	  var d = _ref2.d,
	      d2 = _ref2.d2,
	      a = _ref2.a;
	  return (a = _getProxyProp(scroller, "getBoundingClientRect")) ? function () {
	    return a()[d];
	  } : function () {
	    return (isViewport ? _win["inner" + d2] : scroller["client" + d2]) || 0;
	  };
	},
	    _getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
	  return !isViewport || ~_proxies.indexOf(element) ? _getBoundsFunc(element) : function () {
	    return _winOffsets;
	  };
	},
	    _maxScroll = function _maxScroll(element, _ref3) {
	  var s = _ref3.s,
	      d2 = _ref3.d2,
	      d = _ref3.d,
	      a = _ref3.a;
	  return (s = "scroll" + d2) && (a = _getProxyProp(element, s)) ? a() - _getBoundsFunc(element)()[d] : _isViewport(element) ? (_body[s] || _docEl[s]) - (_win["inner" + d2] || _docEl["client" + d2] || _body["client" + d2]) : element[s] - element["offset" + d2];
	},
	    _iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
	  for (var i = 0; i < _autoRefresh.length; i += 3) {
	    (!events || ~events.indexOf(_autoRefresh[i + 1])) && func(_autoRefresh[i], _autoRefresh[i + 1], _autoRefresh[i + 2]);
	  }
	},
	    _isString = function _isString(value) {
	  return typeof value === "string";
	},
	    _isFunction = function _isFunction(value) {
	  return typeof value === "function";
	},
	    _isNumber = function _isNumber(value) {
	  return typeof value === "number";
	},
	    _isObject = function _isObject(value) {
	  return typeof value === "object";
	},
	    _callIfFunc = function _callIfFunc(value) {
	  return _isFunction(value) && value();
	},
	    _combineFunc = function _combineFunc(f1, f2) {
	  return function () {
	    var result1 = _callIfFunc(f1),
	        result2 = _callIfFunc(f2);

	    return function () {
	      _callIfFunc(result1);

	      _callIfFunc(result2);
	    };
	  };
	},
	    _endAnimation = function _endAnimation(animation, reversed, pause) {
	  return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
	},
	    _callback = function _callback(self, func) {
	  var result = func(self);
	  result && result.totalTime && (self.callbackAnimation = result);
	},
	    _abs = Math.abs,
	    _scrollLeft = "scrollLeft",
	    _scrollTop = "scrollTop",
	    _left = "left",
	    _top = "top",
	    _right = "right",
	    _bottom = "bottom",
	    _width = "width",
	    _height = "height",
	    _Right = "Right",
	    _Left = "Left",
	    _Top = "Top",
	    _Bottom = "Bottom",
	    _padding = "padding",
	    _margin = "margin",
	    _Width = "Width",
	    _Height = "Height",
	    _px = "px",
	    _horizontal = {
	  s: _scrollLeft,
	  p: _left,
	  p2: _Left,
	  os: _right,
	  os2: _Right,
	  d: _width,
	  d2: _Width,
	  a: "x",
	  sc: function sc(value) {
	    return arguments.length ? _win.scrollTo(value, _vertical.sc()) : _win.pageXOffset || _doc[_scrollLeft] || _docEl[_scrollLeft] || _body[_scrollLeft] || 0;
	  }
	},
	    _vertical = {
	  s: _scrollTop,
	  p: _top,
	  p2: _Top,
	  os: _bottom,
	  os2: _Bottom,
	  d: _height,
	  d2: _Height,
	  a: "y",
	  op: _horizontal,
	  sc: function sc(value) {
	    return arguments.length ? _win.scrollTo(_horizontal.sc(), value) : _win.pageYOffset || _doc[_scrollTop] || _docEl[_scrollTop] || _body[_scrollTop] || 0;
	  }
	},
	    _getComputedStyle = function _getComputedStyle(element) {
	  return _win.getComputedStyle(element);
	},
	    _makePositionable = function _makePositionable(element) {
	  var position = _getComputedStyle(element).position;

	  element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
	},
	    _setDefaults = function _setDefaults(obj, defaults) {
	  for (var p in defaults) {
	    p in obj || (obj[p] = defaults[p]);
	  }

	  return obj;
	},
	    _getBounds = function _getBounds(element, withoutTransforms) {
	  var tween = withoutTransforms && _getComputedStyle(element)[_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && gsap.to(element, {
	    x: 0,
	    y: 0,
	    xPercent: 0,
	    yPercent: 0,
	    rotation: 0,
	    rotationX: 0,
	    rotationY: 0,
	    scale: 1,
	    skewX: 0,
	    skewY: 0
	  }).progress(1),
	      bounds = element.getBoundingClientRect();
	  tween && tween.progress(0).kill();
	  return bounds;
	},
	    _getSize = function _getSize(element, _ref4) {
	  var d2 = _ref4.d2;
	  return element["offset" + d2] || element["client" + d2] || 0;
	},
	    _getLabelRatioArray = function _getLabelRatioArray(timeline) {
	  var a = [],
	      labels = timeline.labels,
	      duration = timeline.duration(),
	      p;

	  for (p in labels) {
	    a.push(labels[p] / duration);
	  }

	  return a;
	},
	    _getClosestLabel = function _getClosestLabel(animation) {
	  return function (value) {
	    return gsap.utils.snap(_getLabelRatioArray(animation), value);
	  };
	},
	    _snapDirectional = function _snapDirectional(snapIncrementOrArray) {
	  var snap = gsap.utils.snap(snapIncrementOrArray),
	      a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function (a, b) {
	    return a - b;
	  });
	  return a ? function (value, direction) {
	    var i;

	    if (!direction) {
	      return snap(value);
	    }

	    if (direction > 0) {
	      value -= 1e-4;

	      for (i = 0; i < a.length; i++) {
	        if (a[i] >= value) {
	          return a[i];
	        }
	      }

	      return a[i - 1];
	    } else {
	      i = a.length;
	      value += 1e-4;

	      while (i--) {
	        if (a[i] <= value) {
	          return a[i];
	        }
	      }
	    }

	    return a[0];
	  } : function (value, direction) {
	    var snapped = snap(value);
	    return !direction || Math.abs(snapped - value) < 0.001 || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
	  };
	},
	    _getLabelAtDirection = function _getLabelAtDirection(timeline) {
	  return function (value, st) {
	    return _snapDirectional(_getLabelRatioArray(timeline))(value, st.direction);
	  };
	},
	    _multiListener = function _multiListener(func, element, types, callback) {
	  return types.split(",").forEach(function (type) {
	    return func(element, type, callback);
	  });
	},
	    _addListener = function _addListener(element, type, func) {
	  return element.addEventListener(type, func, {
	    passive: true
	  });
	},
	    _removeListener = function _removeListener(element, type, func) {
	  return element.removeEventListener(type, func);
	},
	    _markerDefaults = {
	  startColor: "green",
	  endColor: "red",
	  indent: 0,
	  fontSize: "16px",
	  fontWeight: "normal"
	},
	    _defaults = {
	  toggleActions: "play",
	  anticipatePin: 0
	},
	    _keywords = {
	  top: 0,
	  left: 0,
	  center: 0.5,
	  bottom: 1,
	  right: 1
	},
	    _offsetToPx = function _offsetToPx(value, size) {
	  if (_isString(value)) {
	    var eqIndex = value.indexOf("="),
	        relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;

	    if (~eqIndex) {
	      value.indexOf("%") > eqIndex && (relative *= size / 100);
	      value = value.substr(0, eqIndex - 1);
	    }

	    value = relative + (value in _keywords ? _keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
	  }

	  return value;
	},
	    _createMarker = function _createMarker(type, name, container, direction, _ref5, offset, matchWidthEl, containerAnimation) {
	  var startColor = _ref5.startColor,
	      endColor = _ref5.endColor,
	      fontSize = _ref5.fontSize,
	      indent = _ref5.indent,
	      fontWeight = _ref5.fontWeight;

	  var e = _doc.createElement("div"),
	      useFixedPosition = _isViewport(container) || _getProxyProp(container, "pinType") === "fixed",
	      isScroller = type.indexOf("scroller") !== -1,
	      parent = useFixedPosition ? _body : container,
	      isStart = type.indexOf("start") !== -1,
	      color = isStart ? startColor : endColor,
	      css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";

	  css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
	  (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === _vertical ? _right : _bottom) + ":" + (offset + parseFloat(indent)) + "px;");
	  matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
	  e._isStart = isStart;
	  e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
	  e.style.cssText = css;
	  e.innerText = name || name === 0 ? type + "-" + name : type;
	  parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
	  e._offset = e["offset" + direction.op.d2];

	  _positionMarker(e, 0, direction, isStart);

	  return e;
	},
	    _positionMarker = function _positionMarker(marker, start, direction, flipped) {
	  var vars = {
	    display: "block"
	  },
	      side = direction[flipped ? "os2" : "p2"],
	      oppositeSide = direction[flipped ? "p2" : "os2"];
	  marker._isFlipped = flipped;
	  vars[direction.a + "Percent"] = flipped ? -100 : 0;
	  vars[direction.a] = flipped ? "1px" : 0;
	  vars["border" + side + _Width] = 1;
	  vars["border" + oppositeSide + _Width] = 0;
	  vars[direction.p] = start + "px";
	  gsap.set(marker, vars);
	},
	    _triggers = [],
	    _ids = {},
	    _sync = function _sync() {
	  return _getTime() - _lastScrollTime > 20 && _updateAll();
	},
	    _onScroll = function _onScroll() {
	  var time = _getTime();

	  if (_lastScrollTime !== time) {
	    _updateAll();

	    _lastScrollTime || _dispatch("scrollStart");
	    _lastScrollTime = time;
	  } else if (!_request) {
	    _request = _raf(_updateAll);
	  }
	},
	    _onResize = function _onResize() {
	  return !_refreshing && !_ignoreResize && !_doc.fullscreenElement && _resizeDelay.restart(true);
	},
	    _listeners = {},
	    _emptyArray = [],
	    _media = [],
	    _creatingMedia,
	    _lastMediaTick,
	    _onMediaChange = function _onMediaChange(e) {
	  var tick = gsap.ticker.frame,
	      matches = [],
	      i = 0,
	      index;

	  if (_lastMediaTick !== tick || _startup) {
	    _revertAll();

	    for (; i < _media.length; i += 4) {
	      index = _win.matchMedia(_media[i]).matches;

	      if (index !== _media[i + 3]) {
	        _media[i + 3] = index;
	        index ? matches.push(i) : _revertAll(1, _media[i]) || _isFunction(_media[i + 2]) && _media[i + 2]();
	      }
	    }

	    _revertRecorded();

	    for (i = 0; i < matches.length; i++) {
	      index = matches[i];
	      _creatingMedia = _media[index];
	      _media[index + 2] = _media[index + 1](e);
	    }

	    _creatingMedia = 0;
	    _coreInitted && _refreshAll(0, 1);
	    _lastMediaTick = tick;

	    _dispatch("matchMedia");
	  }
	},
	    _softRefresh = function _softRefresh() {
	  return _removeListener(ScrollTrigger, "scrollEnd", _softRefresh) || _refreshAll(true);
	},
	    _dispatch = function _dispatch(type) {
	  return _listeners[type] && _listeners[type].map(function (f) {
	    return f();
	  }) || _emptyArray;
	},
	    _savedStyles = [],
	    _revertRecorded = function _revertRecorded(media) {
	  for (var i = 0; i < _savedStyles.length; i += 5) {
	    if (!media || _savedStyles[i + 4] === media) {
	      _savedStyles[i].style.cssText = _savedStyles[i + 1];
	      _savedStyles[i].getBBox && _savedStyles[i].setAttribute("transform", _savedStyles[i + 2] || "");
	      _savedStyles[i + 3].uncache = 1;
	    }
	  }
	},
	    _revertAll = function _revertAll(kill, media) {
	  var trigger;

	  for (_i = 0; _i < _triggers.length; _i++) {
	    trigger = _triggers[_i];

	    if (!media || trigger.media === media) {
	      if (kill) {
	        trigger.kill(1);
	      } else {
	        trigger.revert();
	      }
	    }
	  }

	  media && _revertRecorded(media);
	  media || _dispatch("revert");
	},
	    _clearScrollMemory = function _clearScrollMemory() {
	  return _scrollers.forEach(function (obj) {
	    return typeof obj === "function" && (obj.rec = 0);
	  });
	},
	    _refreshingAll,
	    _refreshAll = function _refreshAll(force, skipRevert) {
	  if (_lastScrollTime && !force) {
	    _addListener(ScrollTrigger, "scrollEnd", _softRefresh);

	    return;
	  }

	  _refreshingAll = true;

	  var refreshInits = _dispatch("refreshInit");

	  _sort && ScrollTrigger.sort();
	  skipRevert || _revertAll();

	  _triggers.forEach(function (t) {
	    return t.refresh();
	  });

	  refreshInits.forEach(function (result) {
	    return result && result.render && result.render(-1);
	  });

	  _clearScrollMemory();

	  _resizeDelay.pause();

	  _refreshingAll = false;

	  _dispatch("refresh");
	},
	    _lastScroll = 0,
	    _direction = 1,
	    _updateAll = function _updateAll() {
	  if (!_refreshingAll) {
	    var l = _triggers.length,
	        time = _getTime(),
	        recordVelocity = time - _time1 >= 50,
	        scroll = l && _triggers[0].scroll();

	    _direction = _lastScroll > scroll ? -1 : 1;
	    _lastScroll = scroll;

	    if (recordVelocity) {
	      if (_lastScrollTime && !_pointerIsDown && time - _lastScrollTime > 200) {
	        _lastScrollTime = 0;

	        _dispatch("scrollEnd");
	      }

	      _time2 = _time1;
	      _time1 = time;
	    }

	    if (_direction < 0) {
	      _i = l;

	      while (_i-- > 0) {
	        _triggers[_i] && _triggers[_i].update(0, recordVelocity);
	      }

	      _direction = 1;
	    } else {
	      for (_i = 0; _i < l; _i++) {
	        _triggers[_i] && _triggers[_i].update(0, recordVelocity);
	      }
	    }

	    _request = 0;
	  }
	},
	    _propNamesToCopy = [_left, _top, _bottom, _right, _margin + _Bottom, _margin + _Right, _margin + _Top, _margin + _Left, "display", "flexShrink", "float", "zIndex", "grid-column-start", "grid-column-end", "grid-row-start", "grid-row-end", "grid-area", "justify-self", "align-self", "place-self"],
	    _stateProps = _propNamesToCopy.concat([_width, _height, "boxSizing", "max" + _Width, "max" + _Height, "position", _margin, _padding, _padding + _Top, _padding + _Right, _padding + _Bottom, _padding + _Left]),
	    _swapPinOut = function _swapPinOut(pin, spacer, state) {
	  _setState(state);

	  var cache = pin._gsap;

	  if (cache.spacerIsNative) {
	    _setState(cache.spacerState);
	  } else if (pin.parentNode === spacer) {
	    var parent = spacer.parentNode;

	    if (parent) {
	      parent.insertBefore(pin, spacer);
	      parent.removeChild(spacer);
	    }
	  }
	},
	    _swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
	  if (pin.parentNode !== spacer) {
	    var i = _propNamesToCopy.length,
	        spacerStyle = spacer.style,
	        pinStyle = pin.style,
	        p;

	    while (i--) {
	      p = _propNamesToCopy[i];
	      spacerStyle[p] = cs[p];
	    }

	    spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
	    cs.display === "inline" && (spacerStyle.display = "inline-block");
	    pinStyle[_bottom] = pinStyle[_right] = "auto";
	    spacerStyle.overflow = "visible";
	    spacerStyle.boxSizing = "border-box";
	    spacerStyle[_width] = _getSize(pin, _horizontal) + _px;
	    spacerStyle[_height] = _getSize(pin, _vertical) + _px;
	    spacerStyle[_padding] = pinStyle[_margin] = pinStyle[_top] = pinStyle[_left] = "0";

	    _setState(spacerState);

	    pinStyle[_width] = pinStyle["max" + _Width] = cs[_width];
	    pinStyle[_height] = pinStyle["max" + _Height] = cs[_height];
	    pinStyle[_padding] = cs[_padding];
	    pin.parentNode.insertBefore(spacer, pin);
	    spacer.appendChild(pin);
	  }
	},
	    _capsExp = /([A-Z])/g,
	    _setState = function _setState(state) {
	  if (state) {
	    var style = state.t.style,
	        l = state.length,
	        i = 0,
	        p,
	        value;
	    (state.t._gsap || gsap.core.getCache(state.t)).uncache = 1;

	    for (; i < l; i += 2) {
	      value = state[i + 1];
	      p = state[i];

	      if (value) {
	        style[p] = value;
	      } else if (style[p]) {
	        style.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
	      }
	    }
	  }
	},
	    _getState = function _getState(element) {
	  var l = _stateProps.length,
	      style = element.style,
	      state = [],
	      i = 0;

	  for (; i < l; i++) {
	    state.push(_stateProps[i], style[_stateProps[i]]);
	  }

	  state.t = element;
	  return state;
	},
	    _copyState = function _copyState(state, override, omitOffsets) {
	  var result = [],
	      l = state.length,
	      i = omitOffsets ? 8 : 0,
	      p;

	  for (; i < l; i += 2) {
	    p = state[i];
	    result.push(p, p in override ? override[p] : state[i + 1]);
	  }

	  result.t = state.t;
	  return result;
	},
	    _winOffsets = {
	  left: 0,
	  top: 0
	},
	    _parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation) {
	  _isFunction(value) && (value = value(self));

	  if (_isString(value) && value.substr(0, 3) === "max") {
	    value = scrollerMax + (value.charAt(4) === "=" ? _offsetToPx("0" + value.substr(3), scrollerSize) : 0);
	  }

	  var time = containerAnimation ? containerAnimation.time() : 0,
	      p1,
	      p2,
	      element;
	  containerAnimation && containerAnimation.seek(0);

	  if (!_isNumber(value)) {
	    _isFunction(trigger) && (trigger = trigger(self));
	    var offsets = value.split(" "),
	        bounds,
	        localOffset,
	        globalOffset,
	        display;
	    element = _getTarget(trigger) || _body;
	    bounds = _getBounds(element) || {};

	    if ((!bounds || !bounds.left && !bounds.top) && _getComputedStyle(element).display === "none") {
	      display = element.style.display;
	      element.style.display = "block";
	      bounds = _getBounds(element);
	      display ? element.style.display = display : element.style.removeProperty("display");
	    }

	    localOffset = _offsetToPx(offsets[0], bounds[direction.d]);
	    globalOffset = _offsetToPx(offsets[1] || "0", scrollerSize);
	    value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
	    markerScroller && _positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
	    scrollerSize -= scrollerSize - globalOffset;
	  } else if (markerScroller) {
	    _positionMarker(markerScroller, scrollerSize, direction, true);
	  }

	  if (marker) {
	    var position = value + scrollerSize,
	        isStart = marker._isStart;
	    p1 = "scroll" + direction.d2;

	    _positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max(_body[p1], _docEl[p1]) : marker.parentNode[p1]) <= position + 1);

	    if (useFixedPosition) {
	      scrollerBounds = _getBounds(markerScroller);
	      useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + _px);
	    }
	  }

	  if (containerAnimation && element) {
	    p1 = _getBounds(element);
	    containerAnimation.seek(scrollerMax);
	    p2 = _getBounds(element);
	    containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
	    value = value / containerAnimation._caScrollDist * scrollerMax;
	  }

	  containerAnimation && containerAnimation.seek(time);
	  return containerAnimation ? value : Math.round(value);
	},
	    _prefixExp = /(?:webkit|moz|length|cssText|inset)/i,
	    _reparent = function _reparent(element, parent, top, left) {
	  if (element.parentNode !== parent) {
	    var style = element.style,
	        p,
	        cs;

	    if (parent === _body) {
	      element._stOrig = style.cssText;
	      cs = _getComputedStyle(element);

	      for (p in cs) {
	        if (!+p && !_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") {
	          style[p] = cs[p];
	        }
	      }

	      style.top = top;
	      style.left = left;
	    } else {
	      style.cssText = element._stOrig;
	    }

	    gsap.core.getCache(element).uncache = 1;
	    parent.appendChild(element);
	  }
	},
	    _getTweenCreator = function _getTweenCreator(scroller, direction) {
	  var getScroll = _getScrollFunc(scroller, direction),
	      prop = "_scroll" + direction.p2,
	      lastScroll1,
	      lastScroll2,
	      getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
	    var tween = getTween.tween,
	        onComplete = vars.onComplete,
	        modifiers = {};
	    tween && tween.kill();
	    lastScroll1 = Math.round(initialValue);
	    vars[prop] = scrollTo;
	    vars.modifiers = modifiers;

	    modifiers[prop] = function (value) {
	      value = _round(getScroll());

	      if (value !== lastScroll1 && value !== lastScroll2 && Math.abs(value - lastScroll1) > 2) {
	        tween.kill();
	        getTween.tween = 0;
	      } else {
	        value = initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio;
	      }

	      lastScroll2 = lastScroll1;
	      return lastScroll1 = _round(value);
	    };

	    vars.onComplete = function () {
	      getTween.tween = 0;
	      onComplete && onComplete.call(tween);
	    };

	    tween = getTween.tween = gsap.to(scroller, vars);
	    return tween;
	  };

	  scroller[prop] = getScroll;
	  scroller.addEventListener("wheel", function () {
	    return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
	  }, {
	    passive: true
	  });
	  return getTween;
	};

	_horizontal.op = _vertical;
	var ScrollTrigger = function () {
	  function ScrollTrigger(vars, animation) {
	    _coreInitted || ScrollTrigger.register(gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
	    this.init(vars, animation);
	  }

	  var _proto = ScrollTrigger.prototype;

	  _proto.init = function init(vars, animation) {
	    this.progress = this.start = 0;
	    this.vars && this.kill(1);

	    if (!_enabled) {
	      this.update = this.refresh = this.kill = _passThrough;
	      return;
	    }

	    vars = _setDefaults(_isString(vars) || _isNumber(vars) || vars.nodeType ? {
	      trigger: vars
	    } : vars, _defaults);

	    var _vars = vars,
	        onUpdate = _vars.onUpdate,
	        toggleClass = _vars.toggleClass,
	        id = _vars.id,
	        onToggle = _vars.onToggle,
	        onRefresh = _vars.onRefresh,
	        scrub = _vars.scrub,
	        trigger = _vars.trigger,
	        pin = _vars.pin,
	        pinSpacing = _vars.pinSpacing,
	        invalidateOnRefresh = _vars.invalidateOnRefresh,
	        anticipatePin = _vars.anticipatePin,
	        onScrubComplete = _vars.onScrubComplete,
	        onSnapComplete = _vars.onSnapComplete,
	        once = _vars.once,
	        snap = _vars.snap,
	        pinReparent = _vars.pinReparent,
	        pinSpacer = _vars.pinSpacer,
	        containerAnimation = _vars.containerAnimation,
	        fastScrollEnd = _vars.fastScrollEnd,
	        preventOverlaps = _vars.preventOverlaps,
	        direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? _horizontal : _vertical,
	        isToggle = !scrub && scrub !== 0,
	        scroller = _getTarget(vars.scroller || _win),
	        scrollerCache = gsap.core.getCache(scroller),
	        isViewport = _isViewport(scroller),
	        useFixedPosition = ("pinType" in vars ? vars.pinType : _getProxyProp(scroller, "pinType") || isViewport && "fixed") === "fixed",
	        callbacks = [vars.onEnter, vars.onLeave, vars.onEnterBack, vars.onLeaveBack],
	        toggleActions = isToggle && vars.toggleActions.split(" "),
	        markers = "markers" in vars ? vars.markers : _defaults.markers,
	        borderWidth = isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0,
	        self = this,
	        onRefreshInit = vars.onRefreshInit && function () {
	      return vars.onRefreshInit(self);
	    },
	        getScrollerSize = _getSizeFunc(scroller, isViewport, direction),
	        getScrollerOffsets = _getOffsetsFunc(scroller, isViewport),
	        lastSnap = 0,
	        scrollFunc = _getScrollFunc(scroller, direction),
	        tweenTo,
	        pinCache,
	        snapFunc,
	        scroll1,
	        scroll2,
	        start,
	        end,
	        markerStart,
	        markerEnd,
	        markerStartTrigger,
	        markerEndTrigger,
	        markerVars,
	        change,
	        pinOriginalState,
	        pinActiveState,
	        pinState,
	        spacer,
	        offset,
	        pinGetter,
	        pinSetter,
	        pinStart,
	        pinChange,
	        spacingStart,
	        spacerState,
	        markerStartSetter,
	        markerEndSetter,
	        cs,
	        snap1,
	        snap2,
	        scrubTween,
	        scrubSmooth,
	        snapDurClamp,
	        snapDelayedCall,
	        prevProgress,
	        prevScroll,
	        prevAnimProgress,
	        caMarkerSetter;

	    self.media = _creatingMedia;
	    anticipatePin *= 45;
	    self.scroller = scroller;
	    self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
	    scroll1 = scrollFunc();
	    self.vars = vars;
	    animation = animation || vars.animation;
	    "refreshPriority" in vars && (_sort = 1);
	    scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
	      top: _getTweenCreator(scroller, _vertical),
	      left: _getTweenCreator(scroller, _horizontal)
	    };
	    self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];

	    if (animation) {
	      animation.vars.lazy = false;
	      animation._initted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.render(0, true, true);
	      self.animation = animation.pause();
	      animation.scrollTrigger = self;
	      scrubSmooth = _isNumber(scrub) && scrub;
	      scrubSmooth && (scrubTween = gsap.to(animation, {
	        ease: "power3",
	        duration: scrubSmooth,
	        onComplete: function onComplete() {
	          return onScrubComplete && onScrubComplete(self);
	        }
	      }));
	      snap1 = 0;
	      id || (id = animation.vars.id);
	    }

	    _triggers.push(self);

	    if (snap) {
	      if (!_isObject(snap) || snap.push) {
	        snap = {
	          snapTo: snap
	        };
	      }

	      "scrollBehavior" in _body.style && gsap.set(isViewport ? [_body, _docEl] : scroller, {
	        scrollBehavior: "auto"
	      });
	      snapFunc = _isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? _getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? _getLabelAtDirection(animation) : snap.directional !== false ? function (value, st) {
	        return _snapDirectional(snap.snapTo)(value, st.direction);
	      } : gsap.utils.snap(snap.snapTo);
	      snapDurClamp = snap.duration || {
	        min: 0.1,
	        max: 2
	      };
	      snapDurClamp = _isObject(snapDurClamp) ? _clamp(snapDurClamp.min, snapDurClamp.max) : _clamp(snapDurClamp, snapDurClamp);
	      snapDelayedCall = gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function () {
	        if (Math.abs(self.getVelocity()) < 10 && !_pointerIsDown && lastSnap !== scrollFunc()) {
	          var totalProgress = animation && !isToggle ? animation.totalProgress() : self.progress,
	              velocity = (totalProgress - snap2) / (_getTime() - _time2) * 1000 || 0,
	              change1 = gsap.utils.clamp(-self.progress, 1 - self.progress, _abs(velocity / 2) * velocity / 0.185),
	              naturalEnd = self.progress + (snap.inertia === false ? 0 : change1),
	              endValue = _clamp(0, 1, snapFunc(naturalEnd, self)),
	              scroll = scrollFunc(),
	              endScroll = Math.round(start + endValue * change),
	              _snap = snap,
	              onStart = _snap.onStart,
	              _onInterrupt = _snap.onInterrupt,
	              _onComplete = _snap.onComplete,
	              tween = tweenTo.tween;

	          if (scroll <= end && scroll >= start && endScroll !== scroll) {
	            if (tween && !tween._initted && tween.data <= _abs(endScroll - scroll)) {
	              return;
	            }

	            if (snap.inertia === false) {
	              change1 = endValue - self.progress;
	            }

	            tweenTo(endScroll, {
	              duration: snapDurClamp(_abs(Math.max(_abs(naturalEnd - totalProgress), _abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
	              ease: snap.ease || "power3",
	              data: _abs(endScroll - scroll),
	              onInterrupt: function onInterrupt() {
	                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
	              },
	              onComplete: function onComplete() {
	                lastSnap = scrollFunc();
	                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
	                onSnapComplete && onSnapComplete(self);
	                _onComplete && _onComplete(self);
	              }
	            }, scroll, change1 * change, endScroll - scroll - change1 * change);
	            onStart && onStart(self, tweenTo.tween);
	          }
	        } else if (self.isActive) {
	          snapDelayedCall.restart(true);
	        }
	      }).pause();
	    }

	    id && (_ids[id] = self);
	    trigger = self.trigger = _getTarget(trigger || pin);
	    pin = pin === true ? trigger : _getTarget(pin);
	    _isString(toggleClass) && (toggleClass = {
	      targets: trigger,
	      className: toggleClass
	    });

	    if (pin) {
	      pinSpacing === false || pinSpacing === _margin || (pinSpacing = !pinSpacing && _getComputedStyle(pin.parentNode).display === "flex" ? false : _padding);
	      self.pin = pin;
	      vars.force3D !== false && gsap.set(pin, {
	        force3D: true
	      });
	      pinCache = gsap.core.getCache(pin);

	      if (!pinCache.spacer) {
	        if (pinSpacer) {
	          pinSpacer = _getTarget(pinSpacer);
	          pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement);
	          pinCache.spacerIsNative = !!pinSpacer;
	          pinSpacer && (pinCache.spacerState = _getState(pinSpacer));
	        }

	        pinCache.spacer = spacer = pinSpacer || _doc.createElement("div");
	        spacer.classList.add("pin-spacer");
	        id && spacer.classList.add("pin-spacer-" + id);
	        pinCache.pinState = pinOriginalState = _getState(pin);
	      } else {
	        pinOriginalState = pinCache.pinState;
	      }

	      self.spacer = spacer = pinCache.spacer;
	      cs = _getComputedStyle(pin);
	      spacingStart = cs[pinSpacing + direction.os2];
	      pinGetter = gsap.getProperty(pin);
	      pinSetter = gsap.quickSetter(pin, direction.a, _px);

	      _swapPinIn(pin, spacer, cs);

	      pinState = _getState(pin);
	    }

	    if (markers) {
	      markerVars = _isObject(markers) ? _setDefaults(markers, _markerDefaults) : _markerDefaults;
	      markerStartTrigger = _createMarker("scroller-start", id, scroller, direction, markerVars, 0);
	      markerEndTrigger = _createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
	      offset = markerStartTrigger["offset" + direction.op.d2];
	      markerStart = _createMarker("start", id, scroller, direction, markerVars, offset, 0, containerAnimation);
	      markerEnd = _createMarker("end", id, scroller, direction, markerVars, offset, 0, containerAnimation);
	      containerAnimation && (caMarkerSetter = gsap.quickSetter([markerStart, markerEnd], direction.a, _px));

	      if (!useFixedPosition && !(_proxies.length && _getProxyProp(scroller, "fixedMarkers") === true)) {
	        _makePositionable(isViewport ? _body : scroller);

	        gsap.set([markerStartTrigger, markerEndTrigger], {
	          force3D: true
	        });
	        markerStartSetter = gsap.quickSetter(markerStartTrigger, direction.a, _px);
	        markerEndSetter = gsap.quickSetter(markerEndTrigger, direction.a, _px);
	      }
	    }

	    if (containerAnimation) {
	      var oldOnUpdate = containerAnimation.vars.onUpdate,
	          oldParams = containerAnimation.vars.onUpdateParams;
	      containerAnimation.eventCallback("onUpdate", function () {
	        self.update(0, 0, 1);
	        oldOnUpdate && oldOnUpdate.apply(oldParams || []);
	      });
	    }

	    self.previous = function () {
	      return _triggers[_triggers.indexOf(self) - 1];
	    };

	    self.next = function () {
	      return _triggers[_triggers.indexOf(self) + 1];
	    };

	    self.revert = function (revert) {
	      var r = revert !== false || !self.enabled,
	          prevRefreshing = _refreshing;

	      if (r !== self.isReverted) {
	        if (r) {
	          self.scroll.rec || (self.scroll.rec = scrollFunc());
	          prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0);
	          prevProgress = self.progress;
	          prevAnimProgress = animation && animation.progress();
	        }

	        markerStart && [markerStart, markerEnd, markerStartTrigger, markerEndTrigger].forEach(function (m) {
	          return m.style.display = r ? "none" : "block";
	        });
	        r && (_refreshing = 1);
	        self.update(r);
	        _refreshing = prevRefreshing;
	        pin && (r ? _swapPinOut(pin, spacer, pinOriginalState) : (!pinReparent || !self.isActive) && _swapPinIn(pin, spacer, _getComputedStyle(pin), spacerState));
	        self.isReverted = r;
	      }
	    };

	    self.refresh = function (soft, force) {
	      if ((_refreshing || !self.enabled) && !force) {
	        return;
	      }

	      if (pin && soft && _lastScrollTime) {
	        _addListener(ScrollTrigger, "scrollEnd", _softRefresh);

	        return;
	      }

	      _refreshing = 1;
	      scrubTween && scrubTween.pause();
	      invalidateOnRefresh && animation && animation.progress(0).invalidate();
	      self.isReverted || self.revert();

	      var size = getScrollerSize(),
	          scrollerBounds = getScrollerOffsets(),
	          max = containerAnimation ? containerAnimation.duration() : _maxScroll(scroller, direction),
	          offset = 0,
	          otherPinOffset = 0,
	          parsedEnd = vars.end,
	          parsedEndTrigger = vars.endTrigger || trigger,
	          parsedStart = vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"),
	          pinnedContainer = vars.pinnedContainer && _getTarget(vars.pinnedContainer),
	          triggerIndex = trigger && Math.max(0, _triggers.indexOf(self)) || 0,
	          i = triggerIndex,
	          cs,
	          bounds,
	          scroll,
	          isVertical,
	          override,
	          curTrigger,
	          curPin,
	          oppositeScroll,
	          initted,
	          revertedPins;

	      while (i--) {
	        curTrigger = _triggers[i];
	        curTrigger.end || curTrigger.refresh(0, 1) || (_refreshing = 1);
	        curPin = curTrigger.pin;

	        if (curPin && (curPin === trigger || curPin === pin) && !curTrigger.isReverted) {
	          revertedPins || (revertedPins = []);
	          revertedPins.unshift(curTrigger);
	          curTrigger.revert();
	        }
	      }

	      _isFunction(parsedStart) && (parsedStart = parsedStart(self));
	      start = _parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation) || (pin ? -0.001 : 0);
	      _isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));

	      if (_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
	        if (~parsedEnd.indexOf(" ")) {
	          parsedEnd = (_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
	        } else {
	          offset = _offsetToPx(parsedEnd.substr(2), size);
	          parsedEnd = _isString(parsedStart) ? parsedStart : start + offset;
	          parsedEndTrigger = trigger;
	        }
	      }

	      end = Math.max(start, _parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation)) || -0.001;
	      change = end - start || (start -= 0.01) && 0.001;
	      offset = 0;
	      i = triggerIndex;

	      while (i--) {
	        curTrigger = _triggers[i];
	        curPin = curTrigger.pin;

	        if (curPin && curTrigger.start - curTrigger._pinPush < start && !containerAnimation) {
	          cs = curTrigger.end - curTrigger.start;
	          (curPin === trigger || curPin === pinnedContainer) && !_isNumber(parsedStart) && (offset += cs);
	          curPin === pin && (otherPinOffset += cs);
	        }
	      }

	      start += offset;
	      end += offset;
	      self._pinPush = otherPinOffset;

	      if (markerStart && offset) {
	        cs = {};
	        cs[direction.a] = "+=" + offset;
	        pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
	        gsap.set([markerStart, markerEnd], cs);
	      }

	      if (pin) {
	        cs = _getComputedStyle(pin);
	        isVertical = direction === _vertical;
	        scroll = scrollFunc();
	        pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
	        !max && end > 1 && ((isViewport ? _body : scroller).style["overflow-" + direction.a] = "scroll");

	        _swapPinIn(pin, spacer, cs);

	        pinState = _getState(pin);
	        bounds = _getBounds(pin, true);
	        oppositeScroll = useFixedPosition && _getScrollFunc(scroller, isVertical ? _horizontal : _vertical)();

	        if (pinSpacing) {
	          spacerState = [pinSpacing + direction.os2, change + otherPinOffset + _px];
	          spacerState.t = spacer;
	          i = pinSpacing === _padding ? _getSize(pin, direction) + change + otherPinOffset : 0;
	          i && spacerState.push(direction.d, i + _px);

	          _setState(spacerState);

	          useFixedPosition && scrollFunc(prevScroll);
	        }

	        if (useFixedPosition) {
	          override = {
	            top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + _px,
	            left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + _px,
	            boxSizing: "border-box",
	            position: "fixed"
	          };
	          override[_width] = override["max" + _Width] = Math.ceil(bounds.width) + _px;
	          override[_height] = override["max" + _Height] = Math.ceil(bounds.height) + _px;
	          override[_margin] = override[_margin + _Top] = override[_margin + _Right] = override[_margin + _Bottom] = override[_margin + _Left] = "0";
	          override[_padding] = cs[_padding];
	          override[_padding + _Top] = cs[_padding + _Top];
	          override[_padding + _Right] = cs[_padding + _Right];
	          override[_padding + _Bottom] = cs[_padding + _Bottom];
	          override[_padding + _Left] = cs[_padding + _Left];
	          pinActiveState = _copyState(pinOriginalState, override, pinReparent);
	        }

	        if (animation) {
	          initted = animation._initted;

	          _suppressOverwrites(1);

	          animation.render(animation.duration(), true, true);
	          pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
	          change !== pinChange && pinActiveState.splice(pinActiveState.length - 2, 2);
	          animation.render(0, true, true);
	          initted || animation.invalidate();

	          _suppressOverwrites(0);
	        } else {
	          pinChange = change;
	        }
	      } else if (trigger && scrollFunc() && !containerAnimation) {
	        bounds = trigger.parentNode;

	        while (bounds && bounds !== _body) {
	          if (bounds._pinOffset) {
	            start -= bounds._pinOffset;
	            end -= bounds._pinOffset;
	          }

	          bounds = bounds.parentNode;
	        }
	      }

	      revertedPins && revertedPins.forEach(function (t) {
	        return t.revert(false);
	      });
	      self.start = start;
	      self.end = end;
	      scroll1 = scroll2 = scrollFunc();

	      if (!containerAnimation) {
	        scroll1 < prevScroll && scrollFunc(prevScroll);
	        self.scroll.rec = 0;
	      }

	      self.revert(false);
	      _refreshing = 0;
	      animation && isToggle && animation._initted && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress, true).render(animation.time(), true, true);

	      if (prevProgress !== self.progress) {
	        animation && !isToggle && animation.totalProgress(prevProgress, true);
	        self.progress = prevProgress;
	        self.update(0, 0, 1);
	      }

	      pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
	      onRefresh && onRefresh(self);
	    };

	    self.getVelocity = function () {
	      return (scrollFunc() - scroll2) / (_getTime() - _time2) * 1000 || 0;
	    };

	    self.endAnimation = function () {
	      _endAnimation(self.callbackAnimation);

	      if (animation) {
	        scrubTween ? scrubTween.progress(1) : !animation.paused() ? _endAnimation(animation, animation.reversed()) : isToggle || _endAnimation(animation, self.direction < 0, 1);
	      }
	    };

	    self.getTrailing = function (name) {
	      var i = _triggers.indexOf(self),
	          a = self.direction > 0 ? _triggers.slice(0, i).reverse() : _triggers.slice(i + 1);

	      return _isString(name) ? a.filter(function (t) {
	        return t.vars.preventOverlaps === name;
	      }) : a;
	    };

	    self.update = function (reset, recordVelocity, forceFake) {
	      if (containerAnimation && !forceFake && !reset) {
	        return;
	      }

	      var scroll = self.scroll(),
	          p = reset ? 0 : (scroll - start) / change,
	          clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0,
	          prevProgress = self.progress,
	          isActive,
	          wasActive,
	          toggleState,
	          action,
	          stateChanged,
	          toggled,
	          isAtMax,
	          isTakingAction;

	      if (recordVelocity) {
	        scroll2 = scroll1;
	        scroll1 = containerAnimation ? scrollFunc() : scroll;

	        if (snap) {
	          snap2 = snap1;
	          snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
	        }
	      }

	      anticipatePin && !clipped && pin && !_refreshing && !_startup && _lastScrollTime && start < scroll + (scroll - scroll2) / (_getTime() - _time2) * anticipatePin && (clipped = 0.0001);

	      if (clipped !== prevProgress && self.enabled) {
	        isActive = self.isActive = !!clipped && clipped < 1;
	        wasActive = !!prevProgress && prevProgress < 1;
	        toggled = isActive !== wasActive;
	        stateChanged = toggled || !!clipped !== !!prevProgress;
	        self.direction = clipped > prevProgress ? 1 : -1;
	        self.progress = clipped;

	        if (stateChanged && !_refreshing) {
	          toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3;

	          if (isToggle) {
	            action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState];
	            isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
	          }
	        }

	        preventOverlaps && toggled && (isTakingAction || scrub || !animation) && (_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function (t) {
	          return t.endAnimation();
	        }));

	        if (!isToggle) {
	          if (scrubTween && !_refreshing && !_startup) {
	            scrubTween.vars.totalProgress = clipped;
	            scrubTween.invalidate().restart();
	          } else if (animation) {
	            animation.totalProgress(clipped, !!_refreshing);
	          }
	        }

	        if (pin) {
	          reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);

	          if (!useFixedPosition) {
	            pinSetter(pinStart + pinChange * clipped);
	          } else if (stateChanged) {
	            isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= _maxScroll(scroller, direction);

	            if (pinReparent) {
	              if (!reset && (isActive || isAtMax)) {
	                var bounds = _getBounds(pin, true),
	                    _offset = scroll - start;

	                _reparent(pin, _body, bounds.top + (direction === _vertical ? _offset : 0) + _px, bounds.left + (direction === _vertical ? 0 : _offset) + _px);
	              } else {
	                _reparent(pin, spacer);
	              }
	            }

	            _setState(isActive || isAtMax ? pinActiveState : pinState);

	            pinChange !== change && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
	          }
	        }

	        snap && !tweenTo.tween && !_refreshing && !_startup && snapDelayedCall.restart(true);
	        toggleClass && (toggled || once && clipped && (clipped < 1 || !_limitCallbacks)) && _toArray(toggleClass.targets).forEach(function (el) {
	          return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
	        });
	        onUpdate && !isToggle && !reset && onUpdate(self);

	        if (stateChanged && !_refreshing) {
	          if (isToggle) {
	            if (isTakingAction) {
	              if (action === "complete") {
	                animation.pause().totalProgress(1);
	              } else if (action === "reset") {
	                animation.restart(true).pause();
	              } else if (action === "restart") {
	                animation.restart(true);
	              } else {
	                animation[action]();
	              }
	            }

	            onUpdate && onUpdate(self);
	          }

	          if (toggled || !_limitCallbacks) {
	            onToggle && toggled && _callback(self, onToggle);
	            callbacks[toggleState] && _callback(self, callbacks[toggleState]);
	            once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0);

	            if (!toggled) {
	              toggleState = clipped === 1 ? 1 : 3;
	              callbacks[toggleState] && _callback(self, callbacks[toggleState]);
	            }
	          }

	          if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > (_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
	            _endAnimation(self.callbackAnimation);

	            scrubTween ? scrubTween.progress(1) : _endAnimation(animation, !clipped, 1);
	          }
	        } else if (isToggle && onUpdate && !_refreshing) {
	          onUpdate(self);
	        }
	      }

	      if (markerEndSetter) {
	        var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
	        markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
	        markerEndSetter(n);
	      }

	      caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
	    };

	    self.enable = function (reset, refresh) {
	      if (!self.enabled) {
	        self.enabled = true;

	        _addListener(scroller, "resize", _onResize);

	        _addListener(scroller, "scroll", _onScroll);

	        onRefreshInit && _addListener(ScrollTrigger, "refreshInit", onRefreshInit);

	        if (reset !== false) {
	          self.progress = prevProgress = 0;
	          scroll1 = scroll2 = lastSnap = scrollFunc();
	        }

	        refresh !== false && self.refresh();
	      }
	    };

	    self.getTween = function (snap) {
	      return snap && tweenTo ? tweenTo.tween : scrubTween;
	    };

	    self.disable = function (reset, allowAnimation) {
	      if (self.enabled) {
	        reset !== false && self.revert();
	        self.enabled = self.isActive = false;
	        allowAnimation || scrubTween && scrubTween.pause();
	        prevScroll = 0;
	        pinCache && (pinCache.uncache = 1);
	        onRefreshInit && _removeListener(ScrollTrigger, "refreshInit", onRefreshInit);

	        if (snapDelayedCall) {
	          snapDelayedCall.pause();
	          tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
	        }

	        if (!isViewport) {
	          var i = _triggers.length;

	          while (i--) {
	            if (_triggers[i].scroller === scroller && _triggers[i] !== self) {
	              return;
	            }
	          }

	          _removeListener(scroller, "resize", _onResize);

	          _removeListener(scroller, "scroll", _onScroll);
	        }
	      }
	    };

	    self.kill = function (revert, allowAnimation) {
	      self.disable(revert, allowAnimation);
	      scrubTween && scrubTween.kill();
	      id && delete _ids[id];

	      var i = _triggers.indexOf(self);

	      _triggers.splice(i, 1);

	      i === _i && _direction > 0 && _i--;
	      i = 0;

	      _triggers.forEach(function (t) {
	        return t.scroller === self.scroller && (i = 1);
	      });

	      i || (self.scroll.rec = 0);

	      if (animation) {
	        animation.scrollTrigger = null;
	        revert && animation.render(-1);
	        allowAnimation || animation.kill();
	      }

	      markerStart && [markerStart, markerEnd, markerStartTrigger, markerEndTrigger].forEach(function (m) {
	        return m.parentNode && m.parentNode.removeChild(m);
	      });

	      if (pin) {
	        pinCache && (pinCache.uncache = 1);
	        i = 0;

	        _triggers.forEach(function (t) {
	          return t.pin === pin && i++;
	        });

	        i || (pinCache.spacer = 0);
	      }
	    };

	    self.enable(false, false);
	    !animation || !animation.add || change ? self.refresh() : gsap.delayedCall(0.01, function () {
	      return start || end || self.refresh();
	    }) && (change = 0.01) && (start = end = 0);
	  };

	  ScrollTrigger.register = function register(core) {
	    if (!_coreInitted) {
	      gsap = core || _getGSAP();

	      if (_windowExists() && window.document) {
	        _win = window;
	        _doc = document;
	        _docEl = _doc.documentElement;
	        _body = _doc.body;
	      }

	      if (gsap) {
	        _toArray = gsap.utils.toArray;
	        _clamp = gsap.utils.clamp;
	        _suppressOverwrites = gsap.core.suppressOverwrites || _passThrough;
	        gsap.core.globals("ScrollTrigger", ScrollTrigger);

	        if (_body) {
	          _raf = _win.requestAnimationFrame || function (f) {
	            return setTimeout(f, 16);
	          };

	          _addListener(_win, "wheel", _onScroll);

	          _root = [_win, _doc, _docEl, _body];

	          _addListener(_doc, "scroll", _onScroll);

	          var bodyStyle = _body.style,
	              border = bodyStyle.borderTopStyle,
	              bounds;
	          bodyStyle.borderTopStyle = "solid";
	          bounds = _getBounds(_body);
	          _vertical.m = Math.round(bounds.top + _vertical.sc()) || 0;
	          _horizontal.m = Math.round(bounds.left + _horizontal.sc()) || 0;
	          border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
	          _syncInterval = setInterval(_sync, 200);
	          gsap.delayedCall(0.5, function () {
	            return _startup = 0;
	          });

	          _addListener(_doc, "touchcancel", _passThrough);

	          _addListener(_body, "touchstart", _passThrough);

	          _multiListener(_addListener, _doc, "pointerdown,touchstart,mousedown", function () {
	            return _pointerIsDown = 1;
	          });

	          _multiListener(_addListener, _doc, "pointerup,touchend,mouseup", function () {
	            return _pointerIsDown = 0;
	          });

	          _transformProp = gsap.utils.checkPrefix("transform");

	          _stateProps.push(_transformProp);

	          _coreInitted = _getTime();
	          _resizeDelay = gsap.delayedCall(0.2, _refreshAll).pause();
	          _autoRefresh = [_doc, "visibilitychange", function () {
	            var w = _win.innerWidth,
	                h = _win.innerHeight;

	            if (_doc.hidden) {
	              _prevWidth = w;
	              _prevHeight = h;
	            } else if (_prevWidth !== w || _prevHeight !== h) {
	              _onResize();
	            }
	          }, _doc, "DOMContentLoaded", _refreshAll, _win, "load", function () {
	            return _lastScrollTime || _refreshAll();
	          }, _win, "resize", _onResize];

	          _iterateAutoRefresh(_addListener);
	        }
	      }
	    }

	    return _coreInitted;
	  };

	  ScrollTrigger.defaults = function defaults(config) {
	    for (var p in config) {
	      _defaults[p] = config[p];
	    }
	  };

	  ScrollTrigger.kill = function kill() {
	    _enabled = 0;

	    _triggers.slice(0).forEach(function (trigger) {
	      return trigger.kill(1);
	    });
	  };

	  ScrollTrigger.config = function config(vars) {
	    "limitCallbacks" in vars && (_limitCallbacks = !!vars.limitCallbacks);
	    var ms = vars.syncInterval;
	    ms && clearInterval(_syncInterval) || (_syncInterval = ms) && setInterval(_sync, ms);

	    if ("autoRefreshEvents" in vars) {
	      _iterateAutoRefresh(_removeListener) || _iterateAutoRefresh(_addListener, vars.autoRefreshEvents || "none");
	      _ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
	    }
	  };

	  ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
	    var t = _getTarget(target),
	        i = _scrollers.indexOf(t),
	        isViewport = _isViewport(t);

	    if (~i) {
	      _scrollers.splice(i, isViewport ? 6 : 2);
	    }

	    isViewport ? _proxies.unshift(_win, vars, _body, vars, _docEl, vars) : _proxies.unshift(t, vars);
	  };

	  ScrollTrigger.matchMedia = function matchMedia(vars) {
	    var mq, p, i, func, result;

	    for (p in vars) {
	      i = _media.indexOf(p);
	      func = vars[p];
	      _creatingMedia = p;

	      if (p === "all") {
	        func();
	      } else {
	        mq = _win.matchMedia(p);

	        if (mq) {
	          mq.matches && (result = func());

	          if (~i) {
	            _media[i + 1] = _combineFunc(_media[i + 1], func);
	            _media[i + 2] = _combineFunc(_media[i + 2], result);
	          } else {
	            i = _media.length;

	            _media.push(p, func, result);

	            mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
	          }

	          _media[i + 3] = mq.matches;
	        }
	      }

	      _creatingMedia = 0;
	    }

	    return _media;
	  };

	  ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
	    query || (_media.length = 0);
	    query = _media.indexOf(query);
	    query >= 0 && _media.splice(query, 4);
	  };

	  ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
	    var bounds = (_isString(element) ? _getTarget(element) : element).getBoundingClientRect(),
	        offset = bounds[horizontal ? _width : _height] * ratio || 0;
	    return horizontal ? bounds.right - offset > 0 && bounds.left + offset < _win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < _win.innerHeight;
	  };

	  ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
	    _isString(element) && (element = _getTarget(element));
	    var bounds = element.getBoundingClientRect(),
	        size = bounds[horizontal ? _width : _height],
	        offset = referencePoint == null ? size / 2 : referencePoint in _keywords ? _keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
	    return horizontal ? (bounds.left + offset) / _win.innerWidth : (bounds.top + offset) / _win.innerHeight;
	  };

	  return ScrollTrigger;
	}();
	ScrollTrigger.version = "3.8.0";

	ScrollTrigger.saveStyles = function (targets) {
	  return targets ? _toArray(targets).forEach(function (target) {
	    if (target && target.style) {
	      var i = _savedStyles.indexOf(target);

	      i >= 0 && _savedStyles.splice(i, 5);

	      _savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), gsap.core.getCache(target), _creatingMedia);
	    }
	  }) : _savedStyles;
	};

	ScrollTrigger.revert = function (soft, media) {
	  return _revertAll(!soft, media);
	};

	ScrollTrigger.create = function (vars, animation) {
	  return new ScrollTrigger(vars, animation);
	};

	ScrollTrigger.refresh = function (safe) {
	  return safe ? _onResize() : (_coreInitted || ScrollTrigger.register()) && _refreshAll(true);
	};

	ScrollTrigger.update = _updateAll;
	ScrollTrigger.clearScrollMemory = _clearScrollMemory;

	ScrollTrigger.maxScroll = function (element, horizontal) {
	  return _maxScroll(element, horizontal ? _horizontal : _vertical);
	};

	ScrollTrigger.getScrollFunc = function (element, horizontal) {
	  return _getScrollFunc(_getTarget(element), horizontal ? _horizontal : _vertical);
	};

	ScrollTrigger.getById = function (id) {
	  return _ids[id];
	};

	ScrollTrigger.getAll = function () {
	  return _triggers.slice(0);
	};

	ScrollTrigger.isScrolling = function () {
	  return !!_lastScrollTime;
	};

	ScrollTrigger.snapDirectional = _snapDirectional;

	ScrollTrigger.addEventListener = function (type, callback) {
	  var a = _listeners[type] || (_listeners[type] = []);
	  ~a.indexOf(callback) || a.push(callback);
	};

	ScrollTrigger.removeEventListener = function (type, callback) {
	  var a = _listeners[type],
	      i = a && a.indexOf(callback);
	  i >= 0 && a.splice(i, 1);
	};

	ScrollTrigger.batch = function (targets, vars) {
	  var result = [],
	      varsCopy = {},
	      interval = vars.interval || 0.016,
	      batchMax = vars.batchMax || 1e9,
	      proxyCallback = function proxyCallback(type, callback) {
	    var elements = [],
	        triggers = [],
	        delay = gsap.delayedCall(interval, function () {
	      callback(elements, triggers);
	      elements = [];
	      triggers = [];
	    }).pause();
	    return function (self) {
	      elements.length || delay.restart(true);
	      elements.push(self.trigger);
	      triggers.push(self);
	      batchMax <= elements.length && delay.progress(1);
	    };
	  },
	      p;

	  for (p in vars) {
	    varsCopy[p] = p.substr(0, 2) === "on" && _isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
	  }

	  if (_isFunction(batchMax)) {
	    batchMax = batchMax();

	    _addListener(ScrollTrigger, "refresh", function () {
	      return batchMax = vars.batchMax();
	    });
	  }

	  _toArray(targets).forEach(function (target) {
	    var config = {};

	    for (p in varsCopy) {
	      config[p] = varsCopy[p];
	    }

	    config.trigger = target;
	    result.push(ScrollTrigger.create(config));
	  });

	  return result;
	};

	ScrollTrigger.sort = function (func) {
	  return _triggers.sort(func || function (a, b) {
	    return (a.vars.refreshPriority || 0) * -1e6 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1e6);
	  });
	};

	_getGSAP() && gsap.registerPlugin(ScrollTrigger);

	exports.ScrollTrigger = ScrollTrigger;
	exports.default = ScrollTrigger;

	Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ 4682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ gsapWithCSS; },
  "p8": function() { return /* binding */ gsapWithCSS; }
});

// UNUSED EXPORTS: Back, Bounce, CSSPlugin, Circ, Cubic, Elastic, Expo, Linear, Power0, Power1, Power2, Power3, Power4, Quad, Quart, Quint, Sine, SteppedEase, Strong, TimelineLite, TimelineMax, TweenLite, TweenMax

;// CONCATENATED MODULE: ../../node_modules/gsap/gsap-core.js
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/*!
 * GSAP 3.8.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */
var _config = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
},
    _defaults = {
  duration: .5,
  overwrite: false,
  delay: 0
},
    _suppressOverwrites,
    _bigNum = 1e8,
    _tinyNum = 1 / _bigNum,
    _2PI = Math.PI * 2,
    _HALF_PI = _2PI / 4,
    _gsID = 0,
    _sqrt = Math.sqrt,
    _cos = Math.cos,
    _sin = Math.sin,
    _isString = function _isString(value) {
  return typeof value === "string";
},
    _isFunction = function _isFunction(value) {
  return typeof value === "function";
},
    _isNumber = function _isNumber(value) {
  return typeof value === "number";
},
    _isUndefined = function _isUndefined(value) {
  return typeof value === "undefined";
},
    _isObject = function _isObject(value) {
  return typeof value === "object";
},
    _isNotFalse = function _isNotFalse(value) {
  return value !== false;
},
    _windowExists = function _windowExists() {
  return typeof window !== "undefined";
},
    _isFuncOrString = function _isFuncOrString(value) {
  return _isFunction(value) || _isString(value);
},
    _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function () {},
    // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray,
    _strictNumExp = /(?:-?\.?\d|\.)+/gi,
    //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
    //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
    _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
    //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/,
    _delimitedValueExp = /[^,'"\[\]\s]+/gi,
    // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /[\d.+\-=]+(?:e[-+]\d*)*/i,
    _globalTimeline,
    _win,
    _coreInitted,
    _doc,
    _globals = {},
    _installScope = {},
    _coreReady,
    _install = function _install(scope) {
  return (_installScope = _merge(scope, _globals)) && gsap;
},
    _missingPlugin = function _missingPlugin(property, value) {
  return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
},
    _warn = function _warn(message, suppress) {
  return !suppress && console.warn(message);
},
    _addGlobal = function _addGlobal(name, obj) {
  return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
},
    _emptyFunc = function _emptyFunc() {
  return 0;
},
    _reservedProps = {},
    _lazyTweens = [],
    _lazyLookup = {},
    _lastRenderedFrame,
    _plugins = {},
    _effects = {},
    _nextGCFrame = 30,
    _harnessPlugins = [],
    _callbackNames = "",
    _harness = function _harness(targets) {
  var target = targets[0],
      harnessPlugin,
      i;
  _isObject(target) || _isFunction(target) || (targets = [targets]);

  if (!(harnessPlugin = (target._gsap || {}).harness)) {
    // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
    i = _harnessPlugins.length;

    while (i-- && !_harnessPlugins[i].targetTest(target)) {}

    harnessPlugin = _harnessPlugins[i];
  }

  i = targets.length;

  while (i--) {
    targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
  }

  return targets;
},
    _getCache = function _getCache(target) {
  return target._gsap || _harness(toArray(target))[0]._gsap;
},
    _getProperty = function _getProperty(target, property, v) {
  return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
},
    _forEachName = function _forEachName(names, func) {
  return (names = names.split(",")).forEach(func) || names;
},
    //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
  return Math.round(value * 100000) / 100000 || 0;
},
    _roundPrecise = function _roundPrecise(value) {
  return Math.round(value * 10000000) / 10000000 || 0;
},
    // increased precision mostly for timing values.
_arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
  //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
  var l = toFind.length,
      i = 0;

  for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}

  return i < l;
},
    _lazyRender = function _lazyRender() {
  var l = _lazyTweens.length,
      a = _lazyTweens.slice(0),
      i,
      tween;

  _lazyLookup = {};
  _lazyTweens.length = 0;

  for (i = 0; i < l; i++) {
    tween = a[i];
    tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
  }
},
    _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
  _lazyTweens.length && _lazyRender();
  animation.render(time, suppressEvents, force);
  _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
},
    _numericIfPossible = function _numericIfPossible(value) {
  var n = parseFloat(value);
  return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
},
    _passThrough = function _passThrough(p) {
  return p;
},
    _setDefaults = function _setDefaults(obj, defaults) {
  for (var p in defaults) {
    p in obj || (obj[p] = defaults[p]);
  }

  return obj;
},
    _setKeyframeDefaults = function _setKeyframeDefaults(obj, defaults) {
  for (var p in defaults) {
    p in obj || p === "duration" || p === "ease" || (obj[p] = defaults[p]);
  }
},
    _merge = function _merge(base, toMerge) {
  for (var p in toMerge) {
    base[p] = toMerge[p];
  }

  return base;
},
    _mergeDeep = function _mergeDeep(base, toMerge) {
  for (var p in toMerge) {
    p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
  }

  return base;
},
    _copyExcluding = function _copyExcluding(obj, excluding) {
  var copy = {},
      p;

  for (p in obj) {
    p in excluding || (copy[p] = obj[p]);
  }

  return copy;
},
    _inheritDefaults = function _inheritDefaults(vars) {
  var parent = vars.parent || _globalTimeline,
      func = vars.keyframes ? _setKeyframeDefaults : _setDefaults;

  if (_isNotFalse(vars.inherit)) {
    while (parent) {
      func(vars, parent.vars.defaults);
      parent = parent.parent || parent._dp;
    }
  }

  return vars;
},
    _arraysMatch = function _arraysMatch(a1, a2) {
  var i = a1.length,
      match = i === a2.length;

  while (match && i-- && a1[i] === a2[i]) {}

  return i < 0;
},
    _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = parent[lastProp],
      t;

  if (sortBy) {
    t = child[sortBy];

    while (prev && prev[sortBy] > t) {
      prev = prev._prev;
    }
  }

  if (prev) {
    child._next = prev._next;
    prev._next = child;
  } else {
    child._next = parent[firstProp];
    parent[firstProp] = child;
  }

  if (child._next) {
    child._next._prev = child;
  } else {
    parent[lastProp] = child;
  }

  child._prev = prev;
  child.parent = child._dp = parent;
  return child;
},
    _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = child._prev,
      next = child._next;

  if (prev) {
    prev._next = next;
  } else if (parent[firstProp] === child) {
    parent[firstProp] = next;
  }

  if (next) {
    next._prev = prev;
  } else if (parent[lastProp] === child) {
    parent[lastProp] = prev;
  }

  child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
},
    _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
  child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove(child);
  child._act = 0;
},
    _uncache = function _uncache(animation, child) {
  if (animation && (!child || child._end > animation._dur || child._start < 0)) {
    // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
    var a = animation;

    while (a) {
      a._dirty = 1;
      a = a.parent;
    }
  }

  return animation;
},
    _recacheAncestors = function _recacheAncestors(animation) {
  var parent = animation.parent;

  while (parent && parent.parent) {
    //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
    parent._dirty = 1;
    parent.totalDuration();
    parent = parent.parent;
  }

  return animation;
},
    _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
  return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
},
    _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
  return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
},
    // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
  var whole = Math.floor(tTime /= cycleDuration);
  return tTime && whole === tTime ? whole - 1 : whole;
},
    _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
  return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
},
    _setEnd = function _setEnd(animation) {
  return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
},
    _alignPlayhead = function _alignPlayhead(animation, totalTime) {
  // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
  var parent = animation._dp;

  if (parent && parent.smoothChildTiming && animation._ts) {
    animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));

    _setEnd(animation);

    parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
  }

  return animation;
},

/*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/
_postAddChecks = function _postAddChecks(timeline, child) {
  var t;

  if (child._time || child._initted && !child._dur) {
    //in case, for example, the _start is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
    t = _parentToChildTotalTime(timeline.rawTime(), child);

    if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
      child.render(t, true);
    }
  } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.


  if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
    //in case any of the ancestors had completed but should now be enabled...
    if (timeline._dur < timeline.duration()) {
      t = timeline;

      while (t._dp) {
        t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.

        t = t._dp;
      }
    }

    timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
  }
},
    _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
  child.parent && _removeFromParent(child);
  child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
  child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));

  _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);

  _isFromOrFromStart(child) || (timeline._recent = child);
  skipChecks || _postAddChecks(timeline, child);
  return timeline;
},
    _scrollTrigger = function _scrollTrigger(animation, trigger) {
  return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
},
    _attemptInitTween = function _attemptInitTween(tween, totalTime, force, suppressEvents) {
  _initTween(tween, totalTime);

  if (!tween._initted) {
    return 1;
  }

  if (!force && tween._pt && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
    _lazyTweens.push(tween);

    tween._lazy = [totalTime, suppressEvents];
    return 1;
  }
},
    _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
  var parent = _ref.parent;
  return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
},
    // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
  var data = _ref2.data;
  return data === "isFromStart" || data === "isStart";
},
    _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
  var prevRatio = tween.ratio,
      ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1,
      // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
  repeatDelay = tween._rDelay,
      tTime = 0,
      pt,
      iteration,
      prevIteration;

  if (repeatDelay && tween._repeat) {
    // in case there's a zero-duration tween that has a repeat with a repeatDelay
    tTime = _clamp(0, tween._tDur, totalTime);
    iteration = _animationCycle(tTime, repeatDelay);
    prevIteration = _animationCycle(tween._tTime, repeatDelay);
    tween._yoyo && iteration & 1 && (ratio = 1 - ratio);

    if (iteration !== prevIteration) {
      prevRatio = 1 - ratio;
      tween.vars.repeatRefresh && tween._initted && tween.invalidate();
    }
  }

  if (ratio !== prevRatio || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
    if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents)) {
      // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
      return;
    }

    prevIteration = tween._zTime;
    tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

    suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.

    tween.ratio = ratio;
    tween._from && (ratio = 1 - ratio);
    tween._time = 0;
    tween._tTime = tTime;
    pt = tween._pt;

    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }

    tween._startAt && totalTime < 0 && tween._startAt.render(totalTime, true, true);
    tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
    tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");

    if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
      ratio && _removeFromParent(tween, 1);

      if (!suppressEvents) {
        _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);

        tween._prom && tween._prom();
      }
    }
  } else if (!tween._zTime) {
    tween._zTime = totalTime;
  }
},
    _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
  var child;

  if (time > prevTime) {
    child = animation._first;

    while (child && child._start <= time) {
      if (!child._dur && child.data === "isPause" && child._start > prevTime) {
        return child;
      }

      child = child._next;
    }
  } else {
    child = animation._last;

    while (child && child._start >= time) {
      if (!child._dur && child.data === "isPause" && child._start < prevTime) {
        return child;
      }

      child = child._prev;
    }
  }
},
    _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
  var repeat = animation._repeat,
      dur = _roundPrecise(duration) || 0,
      totalProgress = animation._tTime / animation._tDur;
  totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
  animation._dur = dur;
  animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
  totalProgress && !leavePlayhead ? _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress) : animation.parent && _setEnd(animation);
  skipUncache || _uncache(animation.parent, animation);
  return animation;
},
    _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
  return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
},
    _zeroPosition = {
  _start: 0,
  endTime: _emptyFunc,
  totalDuration: _emptyFunc
},
    _parsePosition = function _parsePosition(animation, position, percentAnimation) {
  var labels = animation.labels,
      recent = animation._recent || _zeroPosition,
      clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur,
      //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
  i,
      offset,
      isPercent;

  if (_isString(position) && (isNaN(position) || position in labels)) {
    //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
    offset = position.charAt(0);
    isPercent = position.substr(-1) === "%";
    i = position.indexOf("=");

    if (offset === "<" || offset === ">") {
      i >= 0 && (position = position.replace(/=/, ""));
      return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
    }

    if (i < 0) {
      position in labels || (labels[position] = clippedDuration);
      return labels[position];
    }

    offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));

    if (isPercent && percentAnimation) {
      offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
    }

    return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
  }

  return position == null ? clippedDuration : +position;
},
    _createTweenType = function _createTweenType(type, params, timeline) {
  var isLegacy = _isNumber(params[1]),
      varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
      vars = params[varsIndex],
      irVars,
      parent;

  isLegacy && (vars.duration = params[1]);
  vars.parent = timeline;

  if (type) {
    irVars = vars;
    parent = timeline;

    while (parent && !("immediateRender" in irVars)) {
      // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
      irVars = parent.vars.defaults || {};
      parent = _isNotFalse(parent.vars.inherit) && parent.parent;
    }

    vars.immediateRender = _isNotFalse(irVars.immediateRender);
    type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
  }

  return new Tween(params[0], vars, params[varsIndex + 1]);
},
    _conditionalReturn = function _conditionalReturn(value, func) {
  return value || value === 0 ? func(value) : func;
},
    _clamp = function _clamp(min, max, value) {
  return value < min ? min : value > max ? max : value;
},
    getUnit = function getUnit(value) {
  if (typeof value !== "string") {
    return "";
  }

  var v = _unitExp.exec(value);

  return v ? value.substr(v.index + v[0].length) : "";
},
    // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
  return _conditionalReturn(value, function (v) {
    return _clamp(min, max, v);
  });
},
    _slice = [].slice,
    _isArrayLike = function _isArrayLike(value, nonEmpty) {
  return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
},
    _flatten = function _flatten(ar, leaveStrings, accumulator) {
  if (accumulator === void 0) {
    accumulator = [];
  }

  return ar.forEach(function (value) {
    var _accumulator;

    return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
  }) || accumulator;
},
    //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
  return _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
},
    selector = function selector(value) {
  value = toArray(value)[0] || _warn("Invalid scope") || {};
  return function (v) {
    var el = value.current || value.nativeElement || value;
    return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
  };
},
    shuffle = function shuffle(a) {
  return a.sort(function () {
    return .5 - Math.random();
  });
},
    // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
  if (_isFunction(v)) {
    return v;
  }

  var vars = _isObject(v) ? v : {
    each: v
  },
      //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
  ease = _parseEase(vars.ease),
      from = vars.from || 0,
      base = parseFloat(vars.base) || 0,
      cache = {},
      isDecimal = from > 0 && from < 1,
      ratios = isNaN(from) || isDecimal,
      axis = vars.axis,
      ratioX = from,
      ratioY = from;

  if (_isString(from)) {
    ratioX = ratioY = {
      center: .5,
      edges: .5,
      end: 1
    }[from] || 0;
  } else if (!isDecimal && ratios) {
    ratioX = from[0];
    ratioY = from[1];
  }

  return function (i, target, a) {
    var l = (a || vars).length,
        distances = cache[l],
        originX,
        originY,
        x,
        y,
        d,
        j,
        max,
        min,
        wrapAt;

    if (!distances) {
      wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum])[1];

      if (!wrapAt) {
        max = -_bigNum;

        while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}

        wrapAt--;
      }

      distances = cache[l] = [];
      originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
      originY = ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
      max = 0;
      min = _bigNum;

      for (j = 0; j < l; j++) {
        x = j % wrapAt - originX;
        y = originY - (j / wrapAt | 0);
        distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
        d > max && (max = d);
        d < min && (min = d);
      }

      from === "random" && shuffle(distances);
      distances.max = max - min;
      distances.min = min;
      distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
      distances.b = l < 0 ? base - l : base;
      distances.u = getUnit(vars.amount || vars.each) || 0; //unit

      ease = ease && l < 0 ? _invertEase(ease) : ease;
    }

    l = (distances[i] - distances.min) / distances.max || 0;
    return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
  };
},
    _roundModifier = function _roundModifier(v) {
  //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
  var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())

  return function (raw) {
    var n = Math.round(parseFloat(raw) / v) * v * p;
    return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
  };
},
    snap = function snap(snapTo, value) {
  var isArray = _isArray(snapTo),
      radius,
      is2D;

  if (!isArray && _isObject(snapTo)) {
    radius = isArray = snapTo.radius || _bigNum;

    if (snapTo.values) {
      snapTo = toArray(snapTo.values);

      if (is2D = !_isNumber(snapTo[0])) {
        radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
      }
    } else {
      snapTo = _roundModifier(snapTo.increment);
    }
  }

  return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
    is2D = snapTo(raw);
    return Math.abs(is2D - raw) <= radius ? is2D : raw;
  } : function (raw) {
    var x = parseFloat(is2D ? raw.x : raw),
        y = parseFloat(is2D ? raw.y : 0),
        min = _bigNum,
        closest = 0,
        i = snapTo.length,
        dx,
        dy;

    while (i--) {
      if (is2D) {
        dx = snapTo[i].x - x;
        dy = snapTo[i].y - y;
        dx = dx * dx + dy * dy;
      } else {
        dx = Math.abs(snapTo[i] - x);
      }

      if (dx < min) {
        min = dx;
        closest = i;
      }
    }

    closest = !radius || min <= radius ? snapTo[closest] : raw;
    return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
  });
},
    random = function random(min, max, roundingIncrement, returnFunction) {
  return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
    return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
  });
},
    pipe = function pipe() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function (value) {
    return functions.reduce(function (v, f) {
      return f(v);
    }, value);
  };
},
    unitize = function unitize(func, unit) {
  return function (value) {
    return func(parseFloat(value)) + (unit || getUnit(value));
  };
},
    normalize = function normalize(min, max, value) {
  return mapRange(min, max, 0, 1, value);
},
    _wrapArray = function _wrapArray(a, wrapper, value) {
  return _conditionalReturn(value, function (index) {
    return a[~~wrapper(index)];
  });
},
    wrap = function wrap(min, max, value) {
  // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
  var range = max - min;
  return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
    return (range + (value - min) % range) % range + min;
  });
},
    wrapYoyo = function wrapYoyo(min, max, value) {
  var range = max - min,
      total = range * 2;
  return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
    value = (total + (value - min) % total) % total || 0;
    return min + (value > range ? total - value : value);
  });
},
    _replaceRandom = function _replaceRandom(value) {
  //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
  var prev = 0,
      s = "",
      i,
      nums,
      end,
      isArray;

  while (~(i = value.indexOf("random(", prev))) {
    end = value.indexOf(")", i);
    isArray = value.charAt(i + 7) === "[";
    nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
    s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
    prev = end + 1;
  }

  return s + value.substr(prev, value.length - prev);
},
    mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
  var inRange = inMax - inMin,
      outRange = outMax - outMin;
  return _conditionalReturn(value, function (value) {
    return outMin + ((value - inMin) / inRange * outRange || 0);
  });
},
    interpolate = function interpolate(start, end, progress, mutate) {
  var func = isNaN(start + end) ? 0 : function (p) {
    return (1 - p) * start + p * end;
  };

  if (!func) {
    var isString = _isString(start),
        master = {},
        p,
        i,
        interpolators,
        l,
        il;

    progress === true && (mutate = 1) && (progress = null);

    if (isString) {
      start = {
        p: start
      };
      end = {
        p: end
      };
    } else if (_isArray(start) && !_isArray(end)) {
      interpolators = [];
      l = start.length;
      il = l - 2;

      for (i = 1; i < l; i++) {
        interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
      }

      l--;

      func = function func(p) {
        p *= l;
        var i = Math.min(il, ~~p);
        return interpolators[i](p - i);
      };

      progress = end;
    } else if (!mutate) {
      start = _merge(_isArray(start) ? [] : {}, start);
    }

    if (!interpolators) {
      for (p in end) {
        _addPropTween.call(master, start, p, "get", end[p]);
      }

      func = function func(p) {
        return _renderPropTweens(p, master) || (isString ? start.p : start);
      };
    }
  }

  return _conditionalReturn(progress, func);
},
    _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
  //used for nextLabel() and previousLabel()
  var labels = timeline.labels,
      min = _bigNum,
      p,
      distance,
      label;

  for (p in labels) {
    distance = labels[p] - fromTime;

    if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
      label = p;
      min = distance;
    }
  }

  return label;
},
    _callback = function _callback(animation, type, executeLazyFirst) {
  var v = animation.vars,
      callback = v[type],
      params,
      scope;

  if (!callback) {
    return;
  }

  params = v[type + "Params"];
  scope = v.callbackScope || animation;
  executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.

  return params ? callback.apply(scope, params) : callback.call(scope);
},
    _interrupt = function _interrupt(animation) {
  _removeFromParent(animation);

  animation.scrollTrigger && animation.scrollTrigger.kill(false);
  animation.progress() < 1 && _callback(animation, "onInterrupt");
  return animation;
},
    _quickTween,
    _createPlugin = function _createPlugin(config) {
  config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.

  var name = config.name,
      isFunc = _isFunction(config),
      Plugin = name && !isFunc && config.init ? function () {
    this._props = [];
  } : config,
      //in case someone passes in an object that's not a plugin, like CustomEase
  instanceDefaults = {
    init: _emptyFunc,
    render: _renderPropTweens,
    add: _addPropTween,
    kill: _killPropTweensOf,
    modifier: _addPluginModifier,
    rawVars: 0
  },
      statics = {
    targetTest: 0,
    get: 0,
    getSetter: _getSetter,
    aliases: {},
    register: 0
  };

  _wake();

  if (config !== Plugin) {
    if (_plugins[name]) {
      return;
    }

    _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods


    _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods


    _plugins[Plugin.prop = name] = Plugin;

    if (config.targetTest) {
      _harnessPlugins.push(Plugin);

      _reservedProps[name] = 1;
    }

    name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
  }

  _addGlobal(name, Plugin);

  config.register && config.register(gsap, Plugin, PropTween);
},

/*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */
_255 = 255,
    _colorLookup = {
  aqua: [0, _255, _255],
  lime: [0, _255, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, _255],
  navy: [0, 0, 128],
  white: [_255, _255, _255],
  olive: [128, 128, 0],
  yellow: [_255, _255, 0],
  orange: [_255, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [_255, 0, 0],
  pink: [_255, 192, 203],
  cyan: [0, _255, _255],
  transparent: [_255, _255, _255, 0]
},
    _hue = function _hue(h, m1, m2) {
  h = h < 0 ? h + 1 : h > 1 ? h - 1 : h;
  return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
},
    splitColor = function splitColor(v, toHSL, forceAlpha) {
  var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
      r,
      g,
      b,
      h,
      s,
      l,
      max,
      min,
      d,
      wasHSL;

  if (!a) {
    if (v.substr(-1) === ",") {
      //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
      v = v.substr(0, v.length - 1);
    }

    if (_colorLookup[v]) {
      a = _colorLookup[v];
    } else if (v.charAt(0) === "#") {
      if (v.length < 6) {
        //for shorthand like #9F0 or #9F0F (could have alpha)
        r = v.charAt(1);
        g = v.charAt(2);
        b = v.charAt(3);
        v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
      }

      if (v.length === 9) {
        // hex with alpha, like #fd5e53ff
        a = parseInt(v.substr(1, 6), 16);
        return [a >> 16, a >> 8 & _255, a & _255, parseInt(v.substr(7), 16) / 255];
      }

      v = parseInt(v.substr(1), 16);
      a = [v >> 16, v >> 8 & _255, v & _255];
    } else if (v.substr(0, 3) === "hsl") {
      a = wasHSL = v.match(_strictNumExp);

      if (!toHSL) {
        h = +a[0] % 360 / 360;
        s = +a[1] / 100;
        l = +a[2] / 100;
        g = l <= .5 ? l * (s + 1) : l + s - l * s;
        r = l * 2 - g;
        a.length > 3 && (a[3] *= 1); //cast as number

        a[0] = _hue(h + 1 / 3, r, g);
        a[1] = _hue(h, r, g);
        a[2] = _hue(h - 1 / 3, r, g);
      } else if (~v.indexOf("=")) {
        //if relative values are found, just return the raw strings with the relative prefixes in place.
        a = v.match(_numExp);
        forceAlpha && a.length < 4 && (a[3] = 1);
        return a;
      }
    } else {
      a = v.match(_strictNumExp) || _colorLookup.transparent;
    }

    a = a.map(Number);
  }

  if (toHSL && !wasHSL) {
    r = a[0] / _255;
    g = a[1] / _255;
    b = a[2] / _255;
    max = Math.max(r, g, b);
    min = Math.min(r, g, b);
    l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h *= 60;
    }

    a[0] = ~~(h + .5);
    a[1] = ~~(s * 100 + .5);
    a[2] = ~~(l * 100 + .5);
  }

  forceAlpha && a.length < 4 && (a[3] = 1);
  return a;
},
    _colorOrderData = function _colorOrderData(v) {
  // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
  var values = [],
      c = [],
      i = -1;
  v.split(_colorExp).forEach(function (v) {
    var a = v.match(_numWithUnitExp) || [];
    values.push.apply(values, a);
    c.push(i += a.length + 1);
  });
  values.c = c;
  return values;
},
    _formatColors = function _formatColors(s, toHSL, orderMatchData) {
  var result = "",
      colors = (s + result).match(_colorExp),
      type = toHSL ? "hsla(" : "rgba(",
      i = 0,
      c,
      shell,
      d,
      l;

  if (!colors) {
    return s;
  }

  colors = colors.map(function (color) {
    return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
  });

  if (orderMatchData) {
    d = _colorOrderData(s);
    c = orderMatchData.c;

    if (c.join(result) !== d.c.join(result)) {
      shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
      l = shell.length - 1;

      for (; i < l; i++) {
        result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
      }
    }
  }

  if (!shell) {
    shell = s.split(_colorExp);
    l = shell.length - 1;

    for (; i < l; i++) {
      result += shell[i] + colors[i];
    }
  }

  return result + shell[l];
},
    _colorExp = function () {
  var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
      //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
  p;

  for (p in _colorLookup) {
    s += "|" + p + "\\b";
  }

  return new RegExp(s + ")", "gi");
}(),
    _hslExp = /hsl[a]?\(/,
    _colorStringFilter = function _colorStringFilter(a) {
  var combined = a.join(" "),
      toHSL;
  _colorExp.lastIndex = 0;

  if (_colorExp.test(combined)) {
    toHSL = _hslExp.test(combined);
    a[1] = _formatColors(a[1], toHSL);
    a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.

    return true;
  }
},

/*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */
_tickerActive,
    _ticker = function () {
  var _getTime = Date.now,
      _lagThreshold = 500,
      _adjustedLag = 33,
      _startTime = _getTime(),
      _lastUpdate = _startTime,
      _gap = 1000 / 240,
      _nextTime = _gap,
      _listeners = [],
      _id,
      _req,
      _raf,
      _self,
      _delta,
      _i,
      _tick = function _tick(v) {
    var elapsed = _getTime() - _lastUpdate,
        manual = v === true,
        overlap,
        dispatch,
        time,
        frame;

    elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
    _lastUpdate += elapsed;
    time = _lastUpdate - _startTime;
    overlap = time - _nextTime;

    if (overlap > 0 || manual) {
      frame = ++_self.frame;
      _delta = time - _self.time * 1000;
      _self.time = time = time / 1000;
      _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
      dispatch = 1;
    }

    manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.

    if (dispatch) {
      for (_i = 0; _i < _listeners.length; _i++) {
        // use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
      }
    }
  };

  _self = {
    time: 0,
    frame: 0,
    tick: function tick() {
      _tick(true);
    },
    deltaRatio: function deltaRatio(fps) {
      return _delta / (1000 / (fps || 60));
    },
    wake: function wake() {
      if (_coreReady) {
        if (!_coreInitted && _windowExists()) {
          _win = _coreInitted = window;
          _doc = _win.document || {};
          _globals.gsap = gsap;
          (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);

          _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});

          _raf = _win.requestAnimationFrame;
        }

        _id && _self.sleep();

        _req = _raf || function (f) {
          return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
        };

        _tickerActive = 1;

        _tick(2);
      }
    },
    sleep: function sleep() {
      (_raf ? _win.cancelAnimationFrame : clearTimeout)(_id);
      _tickerActive = 0;
      _req = _emptyFunc;
    },
    lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
      _lagThreshold = threshold || 1 / _tinyNum; //zero should be interpreted as basically unlimited

      _adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
    },
    fps: function fps(_fps) {
      _gap = 1000 / (_fps || 240);
      _nextTime = _self.time * 1000 + _gap;
    },
    add: function add(callback) {
      _listeners.indexOf(callback) < 0 && _listeners.push(callback);

      _wake();
    },
    remove: function remove(callback) {
      var i;
      ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
    },
    _listeners: _listeners
  };
  return _self;
}(),
    _wake = function _wake() {
  return !_tickerActive && _ticker.wake();
},
    //also ensures the core classes are initialized.

/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/
_easeMap = {},
    _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
    _quotesExp = /["']/g,
    _parseObjectInString = function _parseObjectInString(value) {
  //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
  var obj = {},
      split = value.substr(1, value.length - 3).split(":"),
      key = split[0],
      i = 1,
      l = split.length,
      index,
      val,
      parsedVal;

  for (; i < l; i++) {
    val = split[i];
    index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
    parsedVal = val.substr(0, index);
    obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
    key = val.substr(index + 1).trim();
  }

  return obj;
},
    _valueInParentheses = function _valueInParentheses(value) {
  var open = value.indexOf("(") + 1,
      close = value.indexOf(")"),
      nested = value.indexOf("(", open);
  return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
},
    _configEaseFromString = function _configEaseFromString(name) {
  //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
  var split = (name + "").split("("),
      ease = _easeMap[split[0]];
  return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
},
    _invertEase = function _invertEase(ease) {
  return function (p) {
    return 1 - ease(1 - p);
  };
},
    // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
  var child = timeline._first,
      ease;

  while (child) {
    if (child instanceof Timeline) {
      _propagateYoyoEase(child, isYoyo);
    } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
      if (child.timeline) {
        _propagateYoyoEase(child.timeline, isYoyo);
      } else {
        ease = child._ease;
        child._ease = child._yEase;
        child._yEase = ease;
        child._yoyo = isYoyo;
      }
    }

    child = child._next;
  }
},
    _parseEase = function _parseEase(ease, defaultEase) {
  return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
},
    _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
  if (easeOut === void 0) {
    easeOut = function easeOut(p) {
      return 1 - easeIn(1 - p);
    };
  }

  if (easeInOut === void 0) {
    easeInOut = function easeInOut(p) {
      return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
  }

  var ease = {
    easeIn: easeIn,
    easeOut: easeOut,
    easeInOut: easeInOut
  },
      lowercaseName;

  _forEachName(names, function (name) {
    _easeMap[name] = _globals[name] = ease;
    _easeMap[lowercaseName = name.toLowerCase()] = easeOut;

    for (var p in ease) {
      _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    }
  });

  return ease;
},
    _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
  return function (p) {
    return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
  };
},
    _configElastic = function _configElastic(type, amplitude, period) {
  var p1 = amplitude >= 1 ? amplitude : 1,
      //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
  p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
      p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
      easeOut = function easeOut(p) {
    return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  p2 = _2PI / p2; //precalculate to optimize

  ease.config = function (amplitude, period) {
    return _configElastic(type, amplitude, period);
  };

  return ease;
},
    _configBack = function _configBack(type, overshoot) {
  if (overshoot === void 0) {
    overshoot = 1.70158;
  }

  var easeOut = function easeOut(p) {
    return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  ease.config = function (overshoot) {
    return _configBack(type, overshoot);
  };

  return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };


_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
  var power = i < 5 ? i + 1 : i;

  _insertEase(name + ",Power" + (power - 1), i ? function (p) {
    return Math.pow(p, power);
  } : function (p) {
    return p;
  }, function (p) {
    return 1 - Math.pow(1 - p, power);
  }, function (p) {
    return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
  });
});

_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;

_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());

(function (n, c) {
  var n1 = 1 / c,
      n2 = 2 * n1,
      n3 = 2.5 * n1,
      easeOut = function easeOut(p) {
    return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
  };

  _insertEase("Bounce", function (p) {
    return 1 - easeOut(1 - p);
  }, easeOut);
})(7.5625, 2.75);

_insertEase("Expo", function (p) {
  return p ? Math.pow(2, 10 * (p - 1)) : 0;
});

_insertEase("Circ", function (p) {
  return -(_sqrt(1 - p * p) - 1);
});

_insertEase("Sine", function (p) {
  return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});

_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());

_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
  config: function config(steps, immediateStart) {
    if (steps === void 0) {
      steps = 1;
    }

    var p1 = 1 / steps,
        p2 = steps + (immediateStart ? 0 : 1),
        p3 = immediateStart ? 1 : 0,
        max = 1 - _tinyNum;
    return function (p) {
      return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
    };
  }
};
_defaults.ease = _easeMap["quad.out"];

_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
  return _callbackNames += name + "," + name + "Params,";
});
/*
 * --------------------------------------------------------------------------------------
 * CACHE
 * --------------------------------------------------------------------------------------
 */


var GSCache = function GSCache(target, harness) {
  this.id = _gsID++;
  target._gsap = this;
  this.target = target;
  this.harness = harness;
  this.get = harness ? harness.get : _getProperty;
  this.set = harness ? harness.getSetter : _getSetter;
};
/*
 * --------------------------------------------------------------------------------------
 * ANIMATION
 * --------------------------------------------------------------------------------------
 */

var Animation = /*#__PURE__*/function () {
  function Animation(vars) {
    this.vars = vars;
    this._delay = +vars.delay || 0;

    if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
      // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
      this._rDelay = vars.repeatDelay || 0;
      this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
    }

    this._ts = 1;

    _setDuration(this, +vars.duration, 1, 1);

    this.data = vars.data;
    _tickerActive || _ticker.wake();
  }

  var _proto = Animation.prototype;

  _proto.delay = function delay(value) {
    if (value || value === 0) {
      this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
      this._delay = value;
      return this;
    }

    return this._delay;
  };

  _proto.duration = function duration(value) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
  };

  _proto.totalDuration = function totalDuration(value) {
    if (!arguments.length) {
      return this._tDur;
    }

    this._dirty = 0;
    return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
  };

  _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
    _wake();

    if (!arguments.length) {
      return this._tTime;
    }

    var parent = this._dp;

    if (parent && parent.smoothChildTiming && this._ts) {
      _alignPlayhead(this, _totalTime);

      !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
      //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.

      while (parent && parent.parent) {
        if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
          parent.totalTime(parent._tTime, true);
        }

        parent = parent.parent;
      }

      if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
        //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
        _addToTimeline(this._dp, this, this._start - this._delay);
      }
    }

    if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
      // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
      this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
      //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
      //   this._lock = 1;

      _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
      //}

    }

    return this;
  };

  _proto.time = function time(value, suppressEvents) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
  };

  _proto.totalProgress = function totalProgress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
  };

  _proto.progress = function progress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
  };

  _proto.iteration = function iteration(value, suppressEvents) {
    var cycleDuration = this.duration() + this._rDelay;

    return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
  } // potential future addition:
  // isPlayingBackwards() {
  // 	let animation = this,
  // 		orientation = 1; // 1 = forward, -1 = backward
  // 	while (animation) {
  // 		orientation *= animation.reversed() || (animation.repeat() && !(animation.iteration() & 1)) ? -1 : 1;
  // 		animation = animation.parent;
  // 	}
  // 	return orientation < 0;
  // }
  ;

  _proto.timeScale = function timeScale(value) {
    if (!arguments.length) {
      return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
    }

    if (this._rts === value) {
      return this;
    }

    var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
    // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
    //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
    // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.

    this._rts = +value || 0;
    this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.

    _recacheAncestors(this.totalTime(_clamp(-this._delay, this._tDur, tTime), true));

    _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.


    return this;
  };

  _proto.paused = function paused(value) {
    if (!arguments.length) {
      return this._ps;
    }

    if (this._ps !== value) {
      this._ps = value;

      if (value) {
        this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.

        this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
      } else {
        _wake();

        this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.

        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
      }
    }

    return this;
  };

  _proto.startTime = function startTime(value) {
    if (arguments.length) {
      this._start = value;
      var parent = this.parent || this._dp;
      parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
      return this;
    }

    return this._start;
  };

  _proto.endTime = function endTime(includeRepeats) {
    return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  };

  _proto.rawTime = function rawTime(wrapRepeats) {
    var parent = this.parent || this._dp; // _dp = detached parent

    return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
  };

  _proto.globalTime = function globalTime(rawTime) {
    var animation = this,
        time = arguments.length ? rawTime : animation.rawTime();

    while (animation) {
      time = animation._start + time / (animation._ts || 1);
      animation = animation._dp;
    }

    return time;
  };

  _proto.repeat = function repeat(value) {
    if (arguments.length) {
      this._repeat = value === Infinity ? -2 : value;
      return _onUpdateTotalDuration(this);
    }

    return this._repeat === -2 ? Infinity : this._repeat;
  };

  _proto.repeatDelay = function repeatDelay(value) {
    if (arguments.length) {
      var time = this._time;
      this._rDelay = value;

      _onUpdateTotalDuration(this);

      return time ? this.time(time) : this;
    }

    return this._rDelay;
  };

  _proto.yoyo = function yoyo(value) {
    if (arguments.length) {
      this._yoyo = value;
      return this;
    }

    return this._yoyo;
  };

  _proto.seek = function seek(position, suppressEvents) {
    return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
  };

  _proto.restart = function restart(includeDelay, suppressEvents) {
    return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
  };

  _proto.play = function play(from, suppressEvents) {
    from != null && this.seek(from, suppressEvents);
    return this.reversed(false).paused(false);
  };

  _proto.reverse = function reverse(from, suppressEvents) {
    from != null && this.seek(from || this.totalDuration(), suppressEvents);
    return this.reversed(true).paused(false);
  };

  _proto.pause = function pause(atTime, suppressEvents) {
    atTime != null && this.seek(atTime, suppressEvents);
    return this.paused(true);
  };

  _proto.resume = function resume() {
    return this.paused(false);
  };

  _proto.reversed = function reversed(value) {
    if (arguments.length) {
      !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.

      return this;
    }

    return this._rts < 0;
  };

  _proto.invalidate = function invalidate() {
    this._initted = this._act = 0;
    this._zTime = -_tinyNum;
    return this;
  };

  _proto.isActive = function isActive() {
    var parent = this.parent || this._dp,
        start = this._start,
        rawTime;
    return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
  };

  _proto.eventCallback = function eventCallback(type, callback, params) {
    var vars = this.vars;

    if (arguments.length > 1) {
      if (!callback) {
        delete vars[type];
      } else {
        vars[type] = callback;
        params && (vars[type + "Params"] = params);
        type === "onUpdate" && (this._onUpdate = callback);
      }

      return this;
    }

    return vars[type];
  };

  _proto.then = function then(onFulfilled) {
    var self = this;
    return new Promise(function (resolve) {
      var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
          _resolve = function _resolve() {
        var _then = self.then;
        self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)

        _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
        resolve(f);
        self.then = _then;
      };

      if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
        _resolve();
      } else {
        self._prom = _resolve;
      }
    });
  };

  _proto.kill = function kill() {
    _interrupt(this);
  };

  return Animation;
}();

_setDefaults(Animation.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: false,
  parent: null,
  _initted: false,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -_tinyNum,
  _prom: 0,
  _ps: false,
  _rts: 1
});
/*
 * -------------------------------------------------
 * TIMELINE
 * -------------------------------------------------
 */


var Timeline = /*#__PURE__*/function (_Animation) {
  _inheritsLoose(Timeline, _Animation);

  function Timeline(vars, position) {
    var _this;

    if (vars === void 0) {
      vars = {};
    }

    _this = _Animation.call(this, vars) || this;
    _this.labels = {};
    _this.smoothChildTiming = !!vars.smoothChildTiming;
    _this.autoRemoveChildren = !!vars.autoRemoveChildren;
    _this._sort = _isNotFalse(vars.sortChildren);
    _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
    vars.reversed && _this.reverse();
    vars.paused && _this.paused(true);
    vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
    return _this;
  }

  var _proto2 = Timeline.prototype;

  _proto2.to = function to(targets, vars, position) {
    _createTweenType(0, arguments, this);

    return this;
  };

  _proto2.from = function from(targets, vars, position) {
    _createTweenType(1, arguments, this);

    return this;
  };

  _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
    _createTweenType(2, arguments, this);

    return this;
  };

  _proto2.set = function set(targets, vars, position) {
    vars.duration = 0;
    vars.parent = this;
    _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
    vars.immediateRender = !!vars.immediateRender;
    new Tween(targets, vars, _parsePosition(this, position), 1);
    return this;
  };

  _proto2.call = function call(callback, params, position) {
    return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
  } //ONLY for backward compatibility! Maybe delete?
  ;

  _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.duration = duration;
    vars.stagger = vars.stagger || stagger;
    vars.onComplete = onCompleteAll;
    vars.onCompleteParams = onCompleteAllParams;
    vars.parent = this;
    new Tween(targets, vars, _parsePosition(this, position));
    return this;
  };

  _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.runBackwards = 1;
    _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
    return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
    toVars.startAt = fromVars;
    _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
    return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._dirty ? this.totalDuration() : this._tDur,
        dur = this._dur,
        tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime),
        // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
    crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
        time,
        child,
        next,
        iteration,
        cycleDuration,
        prevPaused,
        pauseTween,
        timeScale,
        prevStart,
        prevIteration,
        yoyo,
        isYoyo;
    this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);

    if (tTime !== this._tTime || force || crossingStart) {
      if (prevTime !== this._time && dur) {
        //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
        tTime += this._time - prevTime;
        totalTime += this._time - prevTime;
      }

      time = tTime;
      prevStart = this._start;
      timeScale = this._ts;
      prevPaused = !timeScale;

      if (crossingStart) {
        dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

        (totalTime || !suppressEvents) && (this._zTime = totalTime);
      }

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        yoyo = this._yoyo;
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);
        !prevTime && this._tTime && prevIteration !== iteration && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005

        if (yoyo && iteration & 1) {
          time = dur - time;
          isYoyo = 1;
        }
        /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */


        if (iteration !== prevIteration && !this._lock) {
          var rewinding = yoyo && prevIteration & 1,
              doesWrap = rewinding === (yoyo && iteration & 1);
          iteration < prevIteration && (rewinding = !rewinding);
          prevTime = rewinding ? 0 : dur;
          this._lock = 1;
          this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
          this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.

          !suppressEvents && this.parent && _callback(this, "onRepeat");
          this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);

          if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
            // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
            return this;
          }

          dur = this._dur; // in case the duration changed in the onRepeat

          tDur = this._tDur;

          if (doesWrap) {
            this._lock = 2;
            prevTime = rewinding ? dur : -0.0001;
            this.render(prevTime, true);
            this.vars.repeatRefresh && !isYoyo && this.invalidate();
          }

          this._lock = 0;

          if (!this._ts && !prevPaused) {
            return this;
          } //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.


          _propagateYoyoEase(this, isYoyo);
        }
      }

      if (this._hasPause && !this._forcing && this._lock < 2) {
        pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));

        if (pauseTween) {
          tTime -= time - (time = pauseTween._start);
        }
      }

      this._tTime = tTime;
      this._time = time;
      this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

      if (!this._initted) {
        this._onUpdate = this.vars.onUpdate;
        this._initted = 1;
        this._zTime = totalTime;
        prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
      }

      if (!prevTime && time && !suppressEvents) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      if (time >= prevTime && totalTime >= 0) {
        child = this._first;

        while (child) {
          next = child._next;

          if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      } else {
        child = this._last;
        var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.

        while (child) {
          next = child._prev;

          if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force);

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      }

      if (pauseTween && !suppressEvents) {
        this.pause();
        pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;

        if (this._ts) {
          //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
          this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.

          _setEnd(this);

          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
      if (tTime === tDur && tDur >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
          _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto2.add = function add(child, position) {
    var _this2 = this;

    _isNumber(position) || (position = _parsePosition(this, position, child));

    if (!(child instanceof Animation)) {
      if (_isArray(child)) {
        child.forEach(function (obj) {
          return _this2.add(obj, position);
        });
        return this;
      }

      if (_isString(child)) {
        return this.addLabel(child, position);
      }

      if (_isFunction(child)) {
        child = Tween.delayedCall(0, child);
      } else {
        return this;
      }
    }

    return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
  };

  _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
    if (nested === void 0) {
      nested = true;
    }

    if (tweens === void 0) {
      tweens = true;
    }

    if (timelines === void 0) {
      timelines = true;
    }

    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = -_bigNum;
    }

    var a = [],
        child = this._first;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        if (child instanceof Tween) {
          tweens && a.push(child);
        } else {
          timelines && a.push(child);
          nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
        }
      }

      child = child._next;
    }

    return a;
  };

  _proto2.getById = function getById(id) {
    var animations = this.getChildren(1, 1, 1),
        i = animations.length;

    while (i--) {
      if (animations[i].vars.id === id) {
        return animations[i];
      }
    }
  };

  _proto2.remove = function remove(child) {
    if (_isString(child)) {
      return this.removeLabel(child);
    }

    if (_isFunction(child)) {
      return this.killTweensOf(child);
    }

    _removeLinkedListItem(this, child);

    if (child === this._recent) {
      this._recent = this._last;
    }

    return _uncache(this);
  };

  _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
    if (!arguments.length) {
      return this._tTime;
    }

    this._forcing = 1;

    if (!this._dp && this._ts) {
      //special case for the global timeline (or any other that has no parent or detached parent).
      this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
    }

    _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);

    this._forcing = 0;
    return this;
  };

  _proto2.addLabel = function addLabel(label, position) {
    this.labels[label] = _parsePosition(this, position);
    return this;
  };

  _proto2.removeLabel = function removeLabel(label) {
    delete this.labels[label];
    return this;
  };

  _proto2.addPause = function addPause(position, callback, params) {
    var t = Tween.delayedCall(0, callback || _emptyFunc, params);
    t.data = "isPause";
    this._hasPause = 1;
    return _addToTimeline(this, t, _parsePosition(this, position));
  };

  _proto2.removePause = function removePause(position) {
    var child = this._first;
    position = _parsePosition(this, position);

    while (child) {
      if (child._start === position && child.data === "isPause") {
        _removeFromParent(child);
      }

      child = child._next;
    }
  };

  _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    var tweens = this.getTweensOf(targets, onlyActive),
        i = tweens.length;

    while (i--) {
      _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
    }

    return this;
  };

  _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
    var a = [],
        parsedTargets = toArray(targets),
        child = this._first,
        isGlobalTime = _isNumber(onlyActive),
        // a number is interpreted as a global time. If the animation spans
    children;

    while (child) {
      if (child instanceof Tween) {
        if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
          // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
          a.push(child);
        }
      } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
        a.push.apply(a, children);
      }

      child = child._next;
    }

    return a;
  } // potential future feature - targets() on timelines
  // targets() {
  // 	let result = [];
  // 	this.getChildren(true, true, false).forEach(t => result.push(...t.targets()));
  // 	return result.filter((v, i) => result.indexOf(v) === i);
  // }
  ;

  _proto2.tweenTo = function tweenTo(position, vars) {
    vars = vars || {};

    var tl = this,
        endTime = _parsePosition(tl, position),
        _vars = vars,
        startAt = _vars.startAt,
        _onStart = _vars.onStart,
        onStartParams = _vars.onStartParams,
        immediateRender = _vars.immediateRender,
        initted,
        tween = Tween.to(tl, _setDefaults({
      ease: vars.ease || "none",
      lazy: false,
      immediateRender: false,
      time: endTime,
      overwrite: "auto",
      duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
      onStart: function onStart() {
        tl.pause();

        if (!initted) {
          var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
          tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
          initted = 1;
        }

        _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
      }
    }, vars));

    return immediateRender ? tween.render(0) : tween;
  };

  _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
    return this.tweenTo(toPosition, _setDefaults({
      startAt: {
        time: _parsePosition(this, fromPosition)
      }
    }, vars));
  };

  _proto2.recent = function recent() {
    return this._recent;
  };

  _proto2.nextLabel = function nextLabel(afterTime) {
    if (afterTime === void 0) {
      afterTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, afterTime));
  };

  _proto2.previousLabel = function previousLabel(beforeTime) {
    if (beforeTime === void 0) {
      beforeTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
  };

  _proto2.currentLabel = function currentLabel(value) {
    return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
  };

  _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = 0;
    }

    var child = this._first,
        labels = this.labels,
        p;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        child._start += amount;
        child._end += amount;
      }

      child = child._next;
    }

    if (adjustLabels) {
      for (p in labels) {
        if (labels[p] >= ignoreBeforeTime) {
          labels[p] += amount;
        }
      }
    }

    return _uncache(this);
  };

  _proto2.invalidate = function invalidate() {
    var child = this._first;
    this._lock = 0;

    while (child) {
      child.invalidate();
      child = child._next;
    }

    return _Animation.prototype.invalidate.call(this);
  };

  _proto2.clear = function clear(includeLabels) {
    if (includeLabels === void 0) {
      includeLabels = true;
    }

    var child = this._first,
        next;

    while (child) {
      next = child._next;
      this.remove(child);
      child = next;
    }

    this._dp && (this._time = this._tTime = this._pTime = 0);
    includeLabels && (this.labels = {});
    return _uncache(this);
  };

  _proto2.totalDuration = function totalDuration(value) {
    var max = 0,
        self = this,
        child = self._last,
        prevStart = _bigNum,
        prev,
        start,
        parent;

    if (arguments.length) {
      return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
    }

    if (self._dirty) {
      parent = self.parent;

      while (child) {
        prev = child._prev; //record it here in case the tween changes position in the sequence...

        child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.

        start = child._start;

        if (start > prevStart && self._sort && child._ts && !self._lock) {
          //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
          self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().

          _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
        } else {
          prevStart = start;
        }

        if (start < 0 && child._ts) {
          //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
          max -= start;

          if (!parent && !self._dp || parent && parent.smoothChildTiming) {
            self._start += start / self._ts;
            self._time -= start;
            self._tTime -= start;
          }

          self.shiftChildren(-start, false, -1e999);
          prevStart = 0;
        }

        child._end > max && child._ts && (max = child._end);
        child = prev;
      }

      _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);

      self._dirty = 0;
    }

    return self._tDur;
  };

  Timeline.updateRoot = function updateRoot(time) {
    if (_globalTimeline._ts) {
      _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));

      _lastRenderedFrame = _ticker.frame;
    }

    if (_ticker.frame >= _nextGCFrame) {
      _nextGCFrame += _config.autoSleep || 120;
      var child = _globalTimeline._first;
      if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
        while (child && !child._ts) {
          child = child._next;
        }

        child || _ticker.sleep();
      }
    }
  };

  return Timeline;
}(Animation);

_setDefaults(Timeline.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});

var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
  //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
      index = 0,
      matchIndex = 0,
      result,
      startNums,
      color,
      endNum,
      chunk,
      startNum,
      hasRandom,
      a;
  pt.b = start;
  pt.e = end;
  start += ""; //ensure values are strings

  end += "";

  if (hasRandom = ~end.indexOf("random(")) {
    end = _replaceRandom(end);
  }

  if (stringFilter) {
    a = [start, end];
    stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.

    start = a[0];
    end = a[1];
  }

  startNums = start.match(_complexStringNumExp) || [];

  while (result = _complexStringNumExp.exec(end)) {
    endNum = result[0];
    chunk = end.substring(index, result.index);

    if (color) {
      color = (color + 1) % 5;
    } else if (chunk.substr(-5) === "rgba(") {
      color = 1;
    }

    if (endNum !== startNums[matchIndex++]) {
      startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.

      pt._pt = {
        _next: pt._pt,
        p: chunk || matchIndex === 1 ? chunk : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: startNum,
        c: endNum.charAt(1) === "=" ? parseFloat(endNum.substr(2)) * (endNum.charAt(0) === "-" ? -1 : 1) : parseFloat(endNum) - startNum,
        m: color && color < 4 ? Math.round : 0
      };
      index = _complexStringNumExp.lastIndex;
    }
  }

  pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)

  pt.fp = funcParam;

  if (_relExp.test(end) || hasRandom) {
    pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
  }

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam) {
  _isFunction(end) && (end = end(index || 0, target, targets));
  var currentValue = target[prop],
      parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
      setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
      pt;

  if (_isString(end)) {
    if (~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }

    if (end.charAt(1) === "=") {
      pt = parseFloat(parsedStart) + parseFloat(end.substr(2)) * (end.charAt(0) === "-" ? -1 : 1) + (getUnit(parsedStart) || 0);

      if (pt || pt === 0) {
        // to avoid isNaN, like if someone passes in a value like "!= whatever"
        end = pt;
      }
    }
  }

  if (parsedStart !== end) {
    if (!isNaN(parsedStart * end) && end !== "") {
      // fun fact: any number multiplied by "" is evaluated as the number 0!
      pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
      funcParam && (pt.fp = funcParam);
      modifier && pt.modifier(modifier, this, target);
      return this._pt = pt;
    }

    !currentValue && !(prop in target) && _missingPlugin(prop, end);
    return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
  }
},
    //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
  _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));

  if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
    return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
  }

  var copy = {},
      p;

  for (p in vars) {
    copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
  }

  return copy;
},
    _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
  var plugin, pt, ptLookup, i;

  if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
    tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);

    if (tween !== _quickTween) {
      ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.

      i = plugin._props.length;

      while (i--) {
        ptLookup[plugin._props[i]] = pt;
      }
    }
  }

  return plugin;
},
    _overwritingTween,
    //store a reference temporarily so we can avoid overwriting itself.
_initTween = function _initTween(tween, time) {
  var vars = tween.vars,
      ease = vars.ease,
      startAt = vars.startAt,
      immediateRender = vars.immediateRender,
      lazy = vars.lazy,
      onUpdate = vars.onUpdate,
      onUpdateParams = vars.onUpdateParams,
      callbackScope = vars.callbackScope,
      runBackwards = vars.runBackwards,
      yoyoEase = vars.yoyoEase,
      keyframes = vars.keyframes,
      autoRevert = vars.autoRevert,
      dur = tween._dur,
      prevStartAt = tween._startAt,
      targets = tween._targets,
      parent = tween.parent,
      fullTargets = parent && parent.data === "nested" ? parent.parent._targets : targets,
      autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites,
      tl = tween.timeline,
      cleanVars,
      i,
      p,
      pt,
      target,
      hasPriority,
      gsData,
      harness,
      plugin,
      ptLookup,
      index,
      harnessVars,
      overwritten;
  tl && (!keyframes || !ease) && (ease = "none");
  tween._ease = _parseEase(ease, _defaults.ease);
  tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;

  if (yoyoEase && tween._yoyo && !tween._repeat) {
    //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
    yoyoEase = tween._yEase;
    tween._yEase = tween._ease;
    tween._ease = yoyoEase;
  }

  tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.

  if (!tl) {
    //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
    harness = targets[0] ? _getCache(targets[0]).harness : 0;
    harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.

    cleanVars = _copyExcluding(vars, _reservedProps);
    prevStartAt && prevStartAt.render(-1, true).kill();

    if (startAt) {
      _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
        data: "isStart",
        overwrite: false,
        parent: parent,
        immediateRender: true,
        lazy: _isNotFalse(lazy),
        startAt: null,
        delay: 0,
        onUpdate: onUpdate,
        onUpdateParams: onUpdateParams,
        callbackScope: callbackScope,
        stagger: 0
      }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);


      time < 0 && !immediateRender && !autoRevert && tween._startAt.render(-1, true); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.

      if (immediateRender) {
        time > 0 && !autoRevert && (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.

        if (dur && time <= 0) {
          time && (tween._zTime = time);
          return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
        } // if (time > 0) {
        // 	autoRevert || (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.
        // } else if (dur && !(time < 0 && prevStartAt)) {
        // 	time && (tween._zTime = time);
        // 	return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
        // }

      } else if (autoRevert === false) {
        tween._startAt = 0;
      }
    } else if (runBackwards && dur) {
      //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
      if (prevStartAt) {
        !autoRevert && (tween._startAt = 0);
      } else {
        time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0

        p = _setDefaults({
          overwrite: false,
          data: "isFromStart",
          //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
          lazy: immediateRender && _isNotFalse(lazy),
          immediateRender: immediateRender,
          //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
          stagger: 0,
          parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y:gsap.utils.wrap([-100,100])})

        }, cleanVars);
        harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})

        _removeFromParent(tween._startAt = Tween.set(targets, p));

        time < 0 && tween._startAt.render(-1, true); // rare edge case, like if a render is forced in the negative direction of a non-initted from() tween.

        if (!immediateRender) {
          _initTween(tween._startAt, _tinyNum); //ensures that the initial values are recorded

        } else if (!time) {
          return;
        }
      }
    }

    tween._pt = 0;
    lazy = dur && _isNotFalse(lazy) || lazy && !dur;

    for (i = 0; i < targets.length; i++) {
      target = targets[i];
      gsData = target._gsap || _harness(targets)[i]._gsap;
      tween._ptLookup[i] = ptLookup = {};
      _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)

      index = fullTargets === targets ? i : fullTargets.indexOf(target);

      if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);

        plugin._props.forEach(function (name) {
          ptLookup[name] = pt;
        });

        plugin.priority && (hasPriority = 1);
      }

      if (!harness || harnessVars) {
        for (p in cleanVars) {
          if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
            plugin.priority && (hasPriority = 1);
          } else {
            ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
          }
        }
      }

      tween._op && tween._op[i] && tween.kill(target, tween._op[i]);

      if (autoOverwrite && tween._pt) {
        _overwritingTween = tween;

        _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!


        overwritten = !tween.parent;
        _overwritingTween = 0;
      }

      tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
    }

    hasPriority && _sortPropTweensByPriority(tween);
    tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
  }

  tween._onUpdate = onUpdate;
  tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
},
    _addAliasesToVars = function _addAliasesToVars(targets, vars) {
  var harness = targets[0] ? _getCache(targets[0]).harness : 0,
      propertyAliases = harness && harness.aliases,
      copy,
      p,
      i,
      aliases;

  if (!propertyAliases) {
    return vars;
  }

  copy = _merge({}, vars);

  for (p in propertyAliases) {
    if (p in copy) {
      aliases = propertyAliases[p].split(",");
      i = aliases.length;

      while (i--) {
        copy[aliases[i]] = copy[p];
      }
    }
  }

  return copy;
},
    _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
  return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
},
    _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase",
    _staggerPropsToSkip = (_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger").split(",");
/*
 * --------------------------------------------------------------------------------------
 * TWEEN
 * --------------------------------------------------------------------------------------
 */


var Tween = /*#__PURE__*/function (_Animation2) {
  _inheritsLoose(Tween, _Animation2);

  function Tween(targets, vars, position, skipInherit) {
    var _this3;

    if (typeof vars === "number") {
      position.duration = vars;
      vars = position;
      position = null;
    }

    _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
    var _this3$vars = _this3.vars,
        duration = _this3$vars.duration,
        delay = _this3$vars.delay,
        immediateRender = _this3$vars.immediateRender,
        stagger = _this3$vars.stagger,
        overwrite = _this3$vars.overwrite,
        keyframes = _this3$vars.keyframes,
        defaults = _this3$vars.defaults,
        scrollTrigger = _this3$vars.scrollTrigger,
        yoyoEase = _this3$vars.yoyoEase,
        parent = vars.parent || _globalTimeline,
        parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets),
        tl,
        i,
        copy,
        l,
        p,
        curTarget,
        staggerFunc,
        staggerVarsToMerge;
    _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://greensock.com", !_config.nullTargetWarn) || [];
    _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property

    _this3._overwrite = overwrite;

    if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
      vars = _this3.vars;
      tl = _this3.timeline = new Timeline({
        data: "nested",
        defaults: defaults || {}
      });
      tl.kill();
      tl.parent = tl._dp = _assertThisInitialized(_this3);
      tl._start = 0;

      if (keyframes) {
        _inheritDefaults(_setDefaults(tl.vars.defaults, {
          ease: "none"
        }));

        stagger ? parsedTargets.forEach(function (t, i) {
          return keyframes.forEach(function (frame, j) {
            return tl.to(t, frame, j ? ">" : i * stagger);
          });
        }) : keyframes.forEach(function (frame) {
          return tl.to(parsedTargets, frame, ">");
        });
      } else {
        l = parsedTargets.length;
        staggerFunc = stagger ? distribute(stagger) : _emptyFunc;

        if (_isObject(stagger)) {
          //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
          for (p in stagger) {
            if (~_staggerTweenProps.indexOf(p)) {
              staggerVarsToMerge || (staggerVarsToMerge = {});
              staggerVarsToMerge[p] = stagger[p];
            }
          }
        }

        for (i = 0; i < l; i++) {
          copy = {};

          for (p in vars) {
            if (_staggerPropsToSkip.indexOf(p) < 0) {
              copy[p] = vars[p];
            }
          }

          copy.stagger = 0;
          yoyoEase && (copy.yoyoEase = yoyoEase);
          staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
          curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.

          copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
          copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;

          if (!stagger && l === 1 && copy.delay) {
            // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
            _this3._delay = delay = copy.delay;
            _this3._start += delay;
            copy.delay = 0;
          }

          tl.to(curTarget, copy, staggerFunc(i, curTarget, parsedTargets));
        }

        tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
      }

      duration || _this3.duration(duration = tl.duration());
    } else {
      _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
    }

    if (overwrite === true && !_suppressOverwrites) {
      _overwritingTween = _assertThisInitialized(_this3);

      _globalTimeline.killTweensOf(parsedTargets);

      _overwritingTween = 0;
    }

    _addToTimeline(parent, _assertThisInitialized(_this3), position);

    vars.reversed && _this3.reverse();
    vars.paused && _this3.paused(true);

    if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
      _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)

      _this3.render(Math.max(0, -delay)); //in case delay is negative

    }

    scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
    return _this3;
  }

  var _proto3 = Tween.prototype;

  _proto3.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._tDur,
        dur = this._dur,
        tTime = totalTime > tDur - _tinyNum && totalTime >= 0 ? tDur : totalTime < _tinyNum ? 0 : totalTime,
        time,
        pt,
        iteration,
        cycleDuration,
        prevIteration,
        isYoyo,
        ratio,
        timeline,
        yoyoEase;

    if (!dur) {
      _renderZeroDurationTween(this, totalTime, suppressEvents, force);
    } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== totalTime < 0) {
      //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
      time = tTime;
      timeline = this.timeline;

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        isYoyo = this._yoyo && iteration & 1;

        if (isYoyo) {
          yoyoEase = this._yEase;
          time = dur - time;
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);

        if (time === prevTime && !force && this._initted) {
          //could be during the repeatDelay part. No need to render and fire callbacks.
          return this;
        }

        if (iteration !== prevIteration) {
          timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality

          if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
            this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.

            this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
          }
        }
      }

      if (!this._initted) {
        if (_attemptInitTween(this, totalTime < 0 ? totalTime : time, force, suppressEvents)) {
          this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.

          return this;
        }

        if (dur !== this._dur) {
          // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._tTime = tTime;
      this._time = time;

      if (!this._act && this._ts) {
        this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

        this._lazy = 0;
      }

      this.ratio = ratio = (yoyoEase || this._ease)(time / dur);

      if (this._from) {
        this.ratio = ratio = 1 - ratio;
      }

      if (time && !prevTime && !suppressEvents) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      pt = this._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -_tinyNum : timeline._dur * ratio, suppressEvents, force) || this._startAt && (this._zTime = totalTime);

      if (this._onUpdate && !suppressEvents) {
        totalTime < 0 && this._startAt && this._startAt.render(totalTime, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.

        _callback(this, "onUpdate");
      }

      this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");

      if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
        totalTime < 0 && this._startAt && !this._onUpdate && this._startAt.render(totalTime, true, true);
        (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
          // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
          _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto3.targets = function targets() {
    return this._targets;
  };

  _proto3.invalidate = function invalidate() {
    this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0;
    this._ptLookup = [];
    this.timeline && this.timeline.invalidate();
    return _Animation2.prototype.invalidate.call(this);
  };

  _proto3.kill = function kill(targets, vars) {
    if (vars === void 0) {
      vars = "all";
    }

    if (!targets && (!vars || vars === "all")) {
      this._lazy = this._pt = 0;
      return this.parent ? _interrupt(this) : this;
    }

    if (this.timeline) {
      var tDur = this.timeline.totalDuration();
      this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.

      this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.

      return this;
    }

    var parsedTargets = this._targets,
        killingTargets = targets ? toArray(targets) : parsedTargets,
        propTweenLookup = this._ptLookup,
        firstPT = this._pt,
        overwrittenProps,
        curLookup,
        curOverwriteProps,
        props,
        p,
        pt,
        i;

    if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
      vars === "all" && (this._pt = 0);
      return _interrupt(this);
    }

    overwrittenProps = this._op = this._op || [];

    if (vars !== "all") {
      //so people can pass in a comma-delimited list of property names
      if (_isString(vars)) {
        p = {};

        _forEachName(vars, function (name) {
          return p[name] = 1;
        });

        vars = p;
      }

      vars = _addAliasesToVars(parsedTargets, vars);
    }

    i = parsedTargets.length;

    while (i--) {
      if (~killingTargets.indexOf(parsedTargets[i])) {
        curLookup = propTweenLookup[i];

        if (vars === "all") {
          overwrittenProps[i] = vars;
          props = curLookup;
          curOverwriteProps = {};
        } else {
          curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
          props = vars;
        }

        for (p in props) {
          pt = curLookup && curLookup[p];

          if (pt) {
            if (!("kill" in pt.d) || pt.d.kill(p) === true) {
              _removeLinkedListItem(this, pt, "_pt");
            }

            delete curLookup[p];
          }

          if (curOverwriteProps !== "all") {
            curOverwriteProps[p] = 1;
          }
        }
      }
    }

    this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.

    return this;
  };

  Tween.to = function to(targets, vars) {
    return new Tween(targets, vars, arguments[2]);
  };

  Tween.from = function from(targets, vars) {
    return _createTweenType(1, arguments);
  };

  Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
    return new Tween(callback, 0, {
      immediateRender: false,
      lazy: false,
      overwrite: false,
      delay: delay,
      onComplete: callback,
      onReverseComplete: callback,
      onCompleteParams: params,
      onReverseCompleteParams: params,
      callbackScope: scope
    });
  };

  Tween.fromTo = function fromTo(targets, fromVars, toVars) {
    return _createTweenType(2, arguments);
  };

  Tween.set = function set(targets, vars) {
    vars.duration = 0;
    vars.repeatDelay || (vars.repeat = 0);
    return new Tween(targets, vars);
  };

  Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    return _globalTimeline.killTweensOf(targets, props, onlyActive);
  };

  return Tween;
}(Animation);

_setDefaults(Tween.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.


_forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
  Tween[name] = function () {
    var tl = new Timeline(),
        params = _slice.call(arguments, 0);

    params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
    return tl[name].apply(tl, params);
  };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */


var _setterPlain = function _setterPlain(target, property, value) {
  return target[property] = value;
},
    _setterFunc = function _setterFunc(target, property, value) {
  return target[property](value);
},
    _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
  return target[property](data.fp, value);
},
    _setterAttribute = function _setterAttribute(target, property, value) {
  return target.setAttribute(property, value);
},
    _getSetter = function _getSetter(target, property) {
  return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
},
    _renderPlain = function _renderPlain(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
},
    _renderBoolean = function _renderBoolean(ratio, data) {
  return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
},
    _renderComplexString = function _renderComplexString(ratio, data) {
  var pt = data._pt,
      s = "";

  if (!ratio && data.b) {
    //b = beginning string
    s = data.b;
  } else if (ratio === 1 && data.e) {
    //e = ending string
    s = data.e;
  } else {
    while (pt) {
      s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.

      pt = pt._next;
    }

    s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
  }

  data.set(data.t, data.p, s, data);
},
    _renderPropTweens = function _renderPropTweens(ratio, data) {
  var pt = data._pt;

  while (pt) {
    pt.r(ratio, pt.d);
    pt = pt._next;
  }
},
    _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
  var pt = this._pt,
      next;

  while (pt) {
    next = pt._next;
    pt.p === property && pt.modifier(modifier, tween, target);
    pt = next;
  }
},
    _killPropTweensOf = function _killPropTweensOf(property) {
  var pt = this._pt,
      hasNonDependentRemaining,
      next;

  while (pt) {
    next = pt._next;

    if (pt.p === property && !pt.op || pt.op === property) {
      _removeLinkedListItem(this, pt, "_pt");
    } else if (!pt.dep) {
      hasNonDependentRemaining = 1;
    }

    pt = next;
  }

  return !hasNonDependentRemaining;
},
    _setterWithModifier = function _setterWithModifier(target, property, value, data) {
  data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
},
    _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
  var pt = parent._pt,
      next,
      pt2,
      first,
      last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)

  while (pt) {
    next = pt._next;
    pt2 = first;

    while (pt2 && pt2.pr > pt.pr) {
      pt2 = pt2._next;
    }

    if (pt._prev = pt2 ? pt2._prev : last) {
      pt._prev._next = pt;
    } else {
      first = pt;
    }

    if (pt._next = pt2) {
      pt2._prev = pt;
    } else {
      last = pt;
    }

    pt = next;
  }

  parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)


var PropTween = /*#__PURE__*/function () {
  function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
    this.t = target;
    this.s = start;
    this.c = change;
    this.p = prop;
    this.r = renderer || _renderPlain;
    this.d = data || this;
    this.set = setter || _setterPlain;
    this.pr = priority || 0;
    this._next = next;

    if (next) {
      next._prev = this;
    }
  }

  var _proto4 = PropTween.prototype;

  _proto4.modifier = function modifier(func, tween, target) {
    this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)

    this.set = _setterWithModifier;
    this.m = func;
    this.mt = target; //modifier target

    this.tween = tween;
  };

  return PropTween;
}(); //Initialization tasks

_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (name) {
  return _reservedProps[name] = 1;
});

_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
  sortChildren: false,
  defaults: _defaults,
  autoRemoveChildren: true,
  id: "root",
  smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */

var _gsap = {
  registerPlugin: function registerPlugin() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    args.forEach(function (config) {
      return _createPlugin(config);
    });
  },
  timeline: function timeline(vars) {
    return new Timeline(vars);
  },
  getTweensOf: function getTweensOf(targets, onlyActive) {
    return _globalTimeline.getTweensOf(targets, onlyActive);
  },
  getProperty: function getProperty(target, property, unit, uncache) {
    _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in

    var getter = _getCache(target || {}).get,
        format = unit ? _passThrough : _numericIfPossible;

    unit === "native" && (unit = "");
    return !target ? target : !property ? function (property, unit, uncache) {
      return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
  },
  quickSetter: function quickSetter(target, property, unit) {
    target = toArray(target);

    if (target.length > 1) {
      var setters = target.map(function (t) {
        return gsap.quickSetter(t, property, unit);
      }),
          l = setters.length;
      return function (value) {
        var i = l;

        while (i--) {
          setters[i](value);
        }
      };
    }

    target = target[0] || {};

    var Plugin = _plugins[property],
        cache = _getCache(target),
        p = cache.harness && (cache.harness.aliases || {})[property] || property,
        // in case it's an alias, like "rotate" for "rotation".
    setter = Plugin ? function (value) {
      var p = new Plugin();
      _quickTween._pt = 0;
      p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
      p.render(1, p);
      _quickTween._pt && _renderPropTweens(1, _quickTween);
    } : cache.set(target, p);

    return Plugin ? setter : function (value) {
      return setter(target, p, unit ? value + unit : value, cache, 1);
    };
  },
  isTweening: function isTweening(targets) {
    return _globalTimeline.getTweensOf(targets, true).length > 0;
  },
  defaults: function defaults(value) {
    value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
    return _mergeDeep(_defaults, value || {});
  },
  config: function config(value) {
    return _mergeDeep(_config, value || {});
  },
  registerEffect: function registerEffect(_ref3) {
    var name = _ref3.name,
        effect = _ref3.effect,
        plugins = _ref3.plugins,
        defaults = _ref3.defaults,
        extendTimeline = _ref3.extendTimeline;
    (plugins || "").split(",").forEach(function (pluginName) {
      return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
    });

    _effects[name] = function (targets, vars, tl) {
      return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
    };

    if (extendTimeline) {
      Timeline.prototype[name] = function (targets, vars, position) {
        return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
      };
    }
  },
  registerEase: function registerEase(name, ease) {
    _easeMap[name] = _parseEase(ease);
  },
  parseEase: function parseEase(ease, defaultEase) {
    return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
  },
  getById: function getById(id) {
    return _globalTimeline.getById(id);
  },
  exportRoot: function exportRoot(vars, includeDelayedCalls) {
    if (vars === void 0) {
      vars = {};
    }

    var tl = new Timeline(vars),
        child,
        next;
    tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);

    _globalTimeline.remove(tl);

    tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).

    tl._time = tl._tTime = _globalTimeline._time;
    child = _globalTimeline._first;

    while (child) {
      next = child._next;

      if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
        _addToTimeline(tl, child, child._start - child._delay);
      }

      child = next;
    }

    _addToTimeline(_globalTimeline, tl, 0);

    return tl;
  },
  utils: {
    wrap: wrap,
    wrapYoyo: wrapYoyo,
    distribute: distribute,
    random: random,
    snap: snap,
    normalize: normalize,
    getUnit: getUnit,
    clamp: clamp,
    splitColor: splitColor,
    toArray: toArray,
    selector: selector,
    mapRange: mapRange,
    pipe: pipe,
    unitize: unitize,
    interpolate: interpolate,
    shuffle: shuffle
  },
  install: _install,
  effects: _effects,
  ticker: _ticker,
  updateRoot: Timeline.updateRoot,
  plugins: _plugins,
  globalTimeline: _globalTimeline,
  core: {
    PropTween: PropTween,
    globals: _addGlobal,
    Tween: Tween,
    Timeline: Timeline,
    Animation: Animation,
    getCache: _getCache,
    _removeLinkedListItem: _removeLinkedListItem,
    suppressOverwrites: function suppressOverwrites(value) {
      return _suppressOverwrites = value;
    }
  }
};

_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
  return _gsap[name] = Tween[name];
});

_ticker.add(Timeline.updateRoot);

_quickTween = _gsap.to({}, {
  duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------

var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
  var pt = plugin._pt;

  while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
    pt = pt._next;
  }

  return pt;
},
    _addModifiers = function _addModifiers(tween, modifiers) {
  var targets = tween._targets,
      p,
      i,
      pt;

  for (p in modifiers) {
    i = targets.length;

    while (i--) {
      pt = tween._ptLookup[i][p];

      if (pt && (pt = pt.d)) {
        if (pt._pt) {
          // is a plugin
          pt = _getPluginPropTween(pt, p);
        }

        pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
      }
    }
  }
},
    _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
  return {
    name: name,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function init(target, vars, tween) {
      tween._onInit = function (tween) {
        var temp, p;

        if (_isString(vars)) {
          temp = {};

          _forEachName(vars, function (name) {
            return temp[name] = 1;
          }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.


          vars = temp;
        }

        if (modifier) {
          temp = {};

          for (p in vars) {
            temp[p] = modifier(vars[p]);
          }

          vars = temp;
        }

        _addModifiers(tween, vars);
      };
    }
  };
}; //register core plugins


var gsap = _gsap.registerPlugin({
  name: "attr",
  init: function init(target, vars, tween, index, targets) {
    var p, pt;

    for (p in vars) {
      pt = this.add(target, "setAttribute", (target.getAttribute(p) || 0) + "", vars[p], index, targets, 0, 0, p);
      pt && (pt.op = p);

      this._props.push(p);
    }
  }
}, {
  name: "endArray",
  init: function init(target, value) {
    var i = value.length;

    while (i--) {
      this.add(target, i, target[i] || 0, value[i]);
    }
  }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.

Tween.version = Timeline.version = gsap.version = "3.8.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0,
    Power1 = _easeMap.Power1,
    Power2 = _easeMap.Power2,
    Power3 = _easeMap.Power3,
    Power4 = _easeMap.Power4,
    Linear = _easeMap.Linear,
    Quad = _easeMap.Quad,
    Cubic = _easeMap.Cubic,
    Quart = _easeMap.Quart,
    Quint = _easeMap.Quint,
    Strong = _easeMap.Strong,
    Elastic = _easeMap.Elastic,
    Back = _easeMap.Back,
    SteppedEase = _easeMap.SteppedEase,
    Bounce = _easeMap.Bounce,
    Sine = _easeMap.Sine,
    Expo = _easeMap.Expo,
    Circ = _easeMap.Circ;

 //export some internal methods/orojects for use in CSSPlugin so that we can externalize that file and allow custom builds that exclude it.


;// CONCATENATED MODULE: ../../node_modules/gsap/CSSPlugin.js
/*!
 * CSSPlugin 3.8.0
 * https://greensock.com
 *
 * Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */


var CSSPlugin_win,
    CSSPlugin_doc,
    _docElement,
    _pluginInitted,
    _tempDiv,
    _tempDivStyler,
    _recentSetterPlugin,
    CSSPlugin_windowExists = function _windowExists() {
  return typeof window !== "undefined";
},
    _transformProps = {},
    _RAD2DEG = 180 / Math.PI,
    _DEG2RAD = Math.PI / 180,
    _atan2 = Math.atan2,
    CSSPlugin_bigNum = 1e8,
    _capsExp = /([A-Z])/g,
    _horizontalExp = /(?:left|right|width|margin|padding|x)/i,
    _complexExp = /[\s,\(]\S/,
    _propertyAliases = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
},
    _renderCSSProp = function _renderCSSProp(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
  return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
  return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
},
    //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
  var value = data.s + data.c * ratio;
  data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
},
    _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
  return data.set(data.t, data.p, ratio ? data.e : data.b, data);
},
    _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
  return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
},
    _setterCSSStyle = function _setterCSSStyle(target, property, value) {
  return target.style[property] = value;
},
    _setterCSSProp = function _setterCSSProp(target, property, value) {
  return target.style.setProperty(property, value);
},
    _setterTransform = function _setterTransform(target, property, value) {
  return target._gsap[property] = value;
},
    _setterScale = function _setterScale(target, property, value) {
  return target._gsap.scaleX = target._gsap.scaleY = value;
},
    _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache.scaleX = cache.scaleY = value;
  cache.renderTransform(ratio, cache);
},
    _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache[property] = value;
  cache.renderTransform(ratio, cache);
},
    _transformProp = "transform",
    _transformOriginProp = _transformProp + "Origin",
    _supports3D,
    _createElement = function _createElement(type, ns) {
  var e = CSSPlugin_doc.createElementNS ? CSSPlugin_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : CSSPlugin_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.

  return e.style ? e : CSSPlugin_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
},
    _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
  var cs = getComputedStyle(target);
  return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
},
    _prefixes = "O,Moz,ms,Ms,Webkit".split(","),
    _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
  var e = element || _tempDiv,
      s = e.style,
      i = 5;

  if (property in s && !preferPrefix) {
    return property;
  }

  property = property.charAt(0).toUpperCase() + property.substr(1);

  while (i-- && !(_prefixes[i] + property in s)) {}

  return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
},
    _initCore = function _initCore() {
  if (CSSPlugin_windowExists() && window.document) {
    CSSPlugin_win = window;
    CSSPlugin_doc = CSSPlugin_win.document;
    _docElement = CSSPlugin_doc.documentElement;
    _tempDiv = _createElement("div") || {
      style: {}
    };
    _tempDivStyler = _createElement("div");
    _transformProp = _checkPropPrefix(_transformProp);
    _transformOriginProp = _transformProp + "Origin";
    _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.

    _supports3D = !!_checkPropPrefix("perspective");
    _pluginInitted = 1;
  }
},
    _getBBoxHack = function _getBBoxHack(swapIfPossible) {
  //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
  var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
      oldParent = this.parentNode,
      oldSibling = this.nextSibling,
      oldCSS = this.style.cssText,
      bbox;

  _docElement.appendChild(svg);

  svg.appendChild(this);
  this.style.display = "block";

  if (swapIfPossible) {
    try {
      bbox = this.getBBox();
      this._gsapBBox = this.getBBox; //store the original

      this.getBBox = _getBBoxHack;
    } catch (e) {}
  } else if (this._gsapBBox) {
    bbox = this._gsapBBox();
  }

  if (oldParent) {
    if (oldSibling) {
      oldParent.insertBefore(this, oldSibling);
    } else {
      oldParent.appendChild(this);
    }
  }

  _docElement.removeChild(svg);

  this.style.cssText = oldCSS;
  return bbox;
},
    _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
  var i = attributesArray.length;

  while (i--) {
    if (target.hasAttribute(attributesArray[i])) {
      return target.getAttribute(attributesArray[i]);
    }
  }
},
    _getBBox = function _getBBox(target) {
  var bounds;

  try {
    bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
  } catch (error) {
    bounds = _getBBoxHack.call(target, true);
  }

  bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.

  return bounds && !bounds.width && !bounds.x && !bounds.y ? {
    x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
    y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : bounds;
},
    _isSVG = function _isSVG(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
},
    //reports if the element is an SVG on which getBBox() actually works
_removeProperty = function _removeProperty(target, property) {
  if (property) {
    var style = target.style;

    if (property in _transformProps && property !== _transformOriginProp) {
      property = _transformProp;
    }

    if (style.removeProperty) {
      if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") {
        //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
        property = "-" + property;
      }

      style.removeProperty(property.replace(_capsExp, "-$1").toLowerCase());
    } else {
      //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
      style.removeAttribute(property);
    }
  }
},
    _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
  var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
  plugin._pt = pt;
  pt.b = beginning;
  pt.e = end;

  plugin._props.push(property);

  return pt;
},
    _nonConvertibleUnits = {
  deg: 1,
  rad: 1,
  turn: 1
},
    //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
_convertToUnit = function _convertToUnit(target, property, value, unit) {
  var curValue = parseFloat(value) || 0,
      curUnit = (value + "").trim().substr((curValue + "").length) || "px",
      // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
  style = _tempDiv.style,
      horizontal = _horizontalExp.test(property),
      isRootSVG = target.tagName.toLowerCase() === "svg",
      measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
      amount = 100,
      toPixels = unit === "px",
      toPercent = unit === "%",
      px,
      parent,
      cache,
      isSVG;

  if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
    return curValue;
  }

  curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
  isSVG = target.getCTM && _isSVG(target);

  if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
    px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
    return _round(toPercent ? curValue / px * amount : curValue / 100 * px);
  }

  style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
  parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;

  if (isSVG) {
    parent = (target.ownerSVGElement || {}).parentNode;
  }

  if (!parent || parent === CSSPlugin_doc || !parent.appendChild) {
    parent = CSSPlugin_doc.body;
  }

  cache = parent._gsap;

  if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time) {
    return _round(curValue / cache.width * amount);
  } else {
    (toPercent || curUnit === "%") && (style.position = _getComputedProperty(target, "position"));
    parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.

    parent.appendChild(_tempDiv);
    px = _tempDiv[measureProperty];
    parent.removeChild(_tempDiv);
    style.position = "absolute";

    if (horizontal && toPercent) {
      cache = _getCache(parent);
      cache.time = _ticker.time;
      cache.width = parent[measureProperty];
    }
  }

  return _round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
},
    _get = function _get(target, property, unit, uncache) {
  var value;
  _pluginInitted || _initCore();

  if (property in _propertyAliases && property !== "transform") {
    property = _propertyAliases[property];

    if (~property.indexOf(",")) {
      property = property.split(",")[0];
    }
  }

  if (_transformProps[property] && property !== "transform") {
    value = _parseTransform(target, uncache);
    value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
  } else {
    value = target.style[property];

    if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
      value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
  }

  return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
},
    _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
  //note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  if (!start || start === "none") {
    // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
    var p = _checkPropPrefix(prop, target, 1),
        s = p && _getComputedProperty(target, p, 1);

    if (s && s !== start) {
      prop = p;
      start = s;
    } else if (prop === "borderColor") {
      start = _getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
  }

  var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString),
      index = 0,
      matchIndex = 0,
      a,
      result,
      startValues,
      startNum,
      color,
      startValue,
      endValue,
      endNum,
      chunk,
      endUnit,
      startUnit,
      relative,
      endValues;
  pt.b = start;
  pt.e = end;
  start += ""; //ensure values are strings

  end += "";

  if (end === "auto") {
    target.style[prop] = end;
    end = _getComputedProperty(target, prop) || end;
    target.style[prop] = start;
  }

  a = [start, end];

  _colorStringFilter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().


  start = a[0];
  end = a[1];
  startValues = start.match(_numWithUnitExp) || [];
  endValues = end.match(_numWithUnitExp) || [];

  if (endValues.length) {
    while (result = _numWithUnitExp.exec(end)) {
      endValue = result[0];
      chunk = end.substring(index, result.index);

      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
        color = 1;
      }

      if (endValue !== (startValue = startValues[matchIndex++] || "")) {
        startNum = parseFloat(startValue) || 0;
        startUnit = startValue.substr((startNum + "").length);
        relative = endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;

        if (relative) {
          endValue = endValue.substr(2);
        }

        endNum = parseFloat(endValue);
        endUnit = endValue.substr((endNum + "").length);
        index = _numWithUnitExp.lastIndex - endUnit.length;

        if (!endUnit) {
          //if something like "perspective:300" is passed in and we must add a unit to the end
          endUnit = endUnit || _config.units[prop] || startUnit;

          if (index === end.length) {
            end += endUnit;
            pt.e += endUnit;
          }
        }

        if (startUnit !== endUnit) {
          startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
        } //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.


        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
          s: startNum,
          c: relative ? relative * endNum : endNum - startNum,
          m: color && color < 4 || prop === "zIndex" ? Math.round : 0
        };
      }
    }

    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
  } else {
    pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
  }

  _relExp.test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _keywordToPercent = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
},
    _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
  var split = value.split(" "),
      x = split[0],
      y = split[1] || "50%";

  if (x === "top" || x === "bottom" || y === "left" || y === "right") {
    //the user provided them in the wrong order, so flip them
    value = x;
    x = y;
    y = value;
  }

  split[0] = _keywordToPercent[x] || x;
  split[1] = _keywordToPercent[y] || y;
  return split.join(" ");
},
    _renderClearProps = function _renderClearProps(ratio, data) {
  if (data.tween && data.tween._time === data.tween._dur) {
    var target = data.t,
        style = target.style,
        props = data.u,
        cache = target._gsap,
        prop,
        clearTransforms,
        i;

    if (props === "all" || props === true) {
      style.cssText = "";
      clearTransforms = 1;
    } else {
      props = props.split(",");
      i = props.length;

      while (--i > -1) {
        prop = props[i];

        if (_transformProps[prop]) {
          clearTransforms = 1;
          prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
        }

        _removeProperty(target, prop);
      }
    }

    if (clearTransforms) {
      _removeProperty(target, _transformProp);

      if (cache) {
        cache.svg && target.removeAttribute("transform");

        _parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.


        cache.uncache = 1;
      }
    }
  }
},
    // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
_specialProps = {
  clearProps: function clearProps(plugin, target, property, endValue, tween) {
    if (tween.data !== "isFromStart") {
      var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
      pt.u = endValue;
      pt.pr = -10;
      pt.tween = tween;

      plugin._props.push(property);

      return 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://greensock.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */

},

/*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */
_identity2DMatrix = [1, 0, 0, 1, 0, 0],
    _rotationalProperties = {},
    _isNullTransform = function _isNullTransform(value) {
  return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
},
    _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
  var matrixString = _getComputedProperty(target, _transformProp);

  return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
},
    _getMatrix = function _getMatrix(target, force2D) {
  var cache = target._gsap || _getCache(target),
      style = target.style,
      matrix = _getComputedTransformMatrixAsArray(target),
      parent,
      nextSibling,
      temp,
      addedToDOM;

  if (cache.svg && target.getAttribute("transform")) {
    temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.

    matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
    return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
  } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
    //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
    temp = style.display;
    style.display = "block";
    parent = target.parentNode;

    if (!parent || !target.offsetParent) {
      // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
      addedToDOM = 1; //flag

      nextSibling = target.nextSibling;

      _docElement.appendChild(target); //we must add it to the DOM in order to get values properly

    }

    matrix = _getComputedTransformMatrixAsArray(target);
    temp ? style.display = temp : _removeProperty(target, "display");

    if (addedToDOM) {
      nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
    }
  }

  return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
},
    _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
  var cache = target._gsap,
      matrix = matrixArray || _getMatrix(target, true),
      xOriginOld = cache.xOrigin || 0,
      yOriginOld = cache.yOrigin || 0,
      xOffsetOld = cache.xOffset || 0,
      yOffsetOld = cache.yOffset || 0,
      a = matrix[0],
      b = matrix[1],
      c = matrix[2],
      d = matrix[3],
      tx = matrix[4],
      ty = matrix[5],
      originSplit = origin.split(" "),
      xOrigin = parseFloat(originSplit[0]) || 0,
      yOrigin = parseFloat(originSplit[1]) || 0,
      bounds,
      determinant,
      x,
      y;

  if (!originIsAbsolute) {
    bounds = _getBBox(target);
    xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
    yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
  } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
    //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
    x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
    y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
    xOrigin = x;
    yOrigin = y;
  }

  if (smooth || smooth !== false && cache.smooth) {
    tx = xOrigin - xOriginOld;
    ty = yOrigin - yOriginOld;
    cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
    cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
  } else {
    cache.xOffset = cache.yOffset = 0;
  }

  cache.xOrigin = xOrigin;
  cache.yOrigin = yOrigin;
  cache.smooth = !!smooth;
  cache.origin = origin;
  cache.originIsAbsolute = !!originIsAbsolute;
  target.style[_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).

  if (pluginToAddPropTweensTo) {
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
  }

  target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
},
    _parseTransform = function _parseTransform(target, uncache) {
  var cache = target._gsap || new GSCache(target);

  if ("x" in cache && !uncache && !cache.uncache) {
    return cache;
  }

  var style = target.style,
      invertedScaleX = cache.scaleX < 0,
      px = "px",
      deg = "deg",
      origin = _getComputedProperty(target, _transformOriginProp) || "0",
      x,
      y,
      z,
      scaleX,
      scaleY,
      rotation,
      rotationX,
      rotationY,
      skewX,
      skewY,
      perspective,
      xOrigin,
      yOrigin,
      matrix,
      angle,
      cos,
      sin,
      a,
      b,
      c,
      d,
      a12,
      a22,
      t1,
      t2,
      t3,
      a13,
      a23,
      a33,
      a42,
      a43,
      a32;
  x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
  scaleX = scaleY = 1;
  cache.svg = !!(target.getCTM && _isSVG(target));
  matrix = _getMatrix(target, cache.svg);

  if (cache.svg) {
    t1 = (!cache.uncache || origin === "0px 0px") && !uncache && target.getAttribute("data-svg-origin"); // if origin is 0,0 and cache.uncache is true, let the recorded data-svg-origin stay. Otherwise, whenever we set cache.uncache to true, we'd need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.

    _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
  }

  xOrigin = cache.xOrigin || 0;
  yOrigin = cache.yOrigin || 0;

  if (matrix !== _identity2DMatrix) {
    a = matrix[0]; //a11

    b = matrix[1]; //a21

    c = matrix[2]; //a31

    d = matrix[3]; //a41

    x = a12 = matrix[4];
    y = a22 = matrix[5]; //2D matrix

    if (matrix.length === 6) {
      scaleX = Math.sqrt(a * a + b * b);
      scaleY = Math.sqrt(d * d + c * c);
      rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).

      skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
      skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));

      if (cache.svg) {
        x -= xOrigin - (xOrigin * a + yOrigin * c);
        y -= yOrigin - (xOrigin * b + yOrigin * d);
      } //3D matrix

    } else {
      a32 = matrix[6];
      a42 = matrix[7];
      a13 = matrix[8];
      a23 = matrix[9];
      a33 = matrix[10];
      a43 = matrix[11];
      x = matrix[12];
      y = matrix[13];
      z = matrix[14];
      angle = _atan2(a32, a33);
      rotationX = angle * _RAD2DEG; //rotationX

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a12 * cos + a13 * sin;
        t2 = a22 * cos + a23 * sin;
        t3 = a32 * cos + a33 * sin;
        a13 = a12 * -sin + a13 * cos;
        a23 = a22 * -sin + a23 * cos;
        a33 = a32 * -sin + a33 * cos;
        a43 = a42 * -sin + a43 * cos;
        a12 = t1;
        a22 = t2;
        a32 = t3;
      } //rotationY


      angle = _atan2(-c, a33);
      rotationY = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a * cos - a13 * sin;
        t2 = b * cos - a23 * sin;
        t3 = c * cos - a33 * sin;
        a43 = d * sin + a43 * cos;
        a = t1;
        b = t2;
        c = t3;
      } //rotationZ


      angle = _atan2(b, a);
      rotation = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(angle);
        sin = Math.sin(angle);
        t1 = a * cos + b * sin;
        t2 = a12 * cos + a22 * sin;
        b = b * cos - a * sin;
        a22 = a22 * cos - a12 * sin;
        a = t1;
        a12 = t2;
      }

      if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
        //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
        rotationX = rotation = 0;
        rotationY = 180 - rotationY;
      }

      scaleX = _round(Math.sqrt(a * a + b * b + c * c));
      scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
      angle = _atan2(a12, a22);
      skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
      perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
    }

    if (cache.svg) {
      //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
      t1 = target.getAttribute("transform");
      cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
      t1 && target.setAttribute("transform", t1);
    }
  }

  if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
    if (invertedScaleX) {
      scaleX *= -1;
      skewX += rotation <= 0 ? 180 : -180;
      rotation += rotation <= 0 ? 180 : -180;
    } else {
      scaleY *= -1;
      skewX += skewX <= 0 ? 180 : -180;
    }
  }

  cache.x = x - ((cache.xPercent = x && (cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
  cache.y = y - ((cache.yPercent = y && (cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
  cache.z = z + px;
  cache.scaleX = _round(scaleX);
  cache.scaleY = _round(scaleY);
  cache.rotation = _round(rotation) + deg;
  cache.rotationX = _round(rotationX) + deg;
  cache.rotationY = _round(rotationY) + deg;
  cache.skewX = skewX + deg;
  cache.skewY = skewY + deg;
  cache.transformPerspective = perspective + px;

  if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) {
    style[_transformOriginProp] = _firstTwoOnly(origin);
  }

  cache.xOffset = cache.yOffset = 0;
  cache.force3D = _config.force3D;
  cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
  cache.uncache = 0;
  return cache;
},
    _firstTwoOnly = function _firstTwoOnly(value) {
  return (value = value.split(" "))[0] + " " + value[1];
},
    //for handling transformOrigin values, stripping out the 3rd dimension
_addPxTranslate = function _addPxTranslate(target, start, value) {
  var unit = getUnit(start);
  return _round(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
},
    _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
  cache.z = "0px";
  cache.rotationY = cache.rotationX = "0deg";
  cache.force3D = 0;

  _renderCSSTransforms(ratio, cache);
},
    _zeroDeg = "0deg",
    _zeroPx = "0px",
    _endParenthesis = ") ",
    _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
  var _ref = cache || this,
      xPercent = _ref.xPercent,
      yPercent = _ref.yPercent,
      x = _ref.x,
      y = _ref.y,
      z = _ref.z,
      rotation = _ref.rotation,
      rotationY = _ref.rotationY,
      rotationX = _ref.rotationX,
      skewX = _ref.skewX,
      skewY = _ref.skewY,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      transformPerspective = _ref.transformPerspective,
      force3D = _ref.force3D,
      target = _ref.target,
      zOrigin = _ref.zOrigin,
      transforms = "",
      use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)


  if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
    var angle = parseFloat(rotationY) * _DEG2RAD,
        a13 = Math.sin(angle),
        a33 = Math.cos(angle),
        cos;

    angle = parseFloat(rotationX) * _DEG2RAD;
    cos = Math.cos(angle);
    x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
    y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
    z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
  }

  if (transformPerspective !== _zeroPx) {
    transforms += "perspective(" + transformPerspective + _endParenthesis;
  }

  if (xPercent || yPercent) {
    transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
  }

  if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
    transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
  }

  if (rotation !== _zeroDeg) {
    transforms += "rotate(" + rotation + _endParenthesis;
  }

  if (rotationY !== _zeroDeg) {
    transforms += "rotateY(" + rotationY + _endParenthesis;
  }

  if (rotationX !== _zeroDeg) {
    transforms += "rotateX(" + rotationX + _endParenthesis;
  }

  if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
    transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
  }

  if (scaleX !== 1 || scaleY !== 1) {
    transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
  }

  target.style[_transformProp] = transforms || "translate(0, 0)";
},
    _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
  var _ref2 = cache || this,
      xPercent = _ref2.xPercent,
      yPercent = _ref2.yPercent,
      x = _ref2.x,
      y = _ref2.y,
      rotation = _ref2.rotation,
      skewX = _ref2.skewX,
      skewY = _ref2.skewY,
      scaleX = _ref2.scaleX,
      scaleY = _ref2.scaleY,
      target = _ref2.target,
      xOrigin = _ref2.xOrigin,
      yOrigin = _ref2.yOrigin,
      xOffset = _ref2.xOffset,
      yOffset = _ref2.yOffset,
      forceCSS = _ref2.forceCSS,
      tx = parseFloat(x),
      ty = parseFloat(y),
      a11,
      a21,
      a12,
      a22,
      temp;

  rotation = parseFloat(rotation);
  skewX = parseFloat(skewX);
  skewY = parseFloat(skewY);

  if (skewY) {
    //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
    skewY = parseFloat(skewY);
    skewX += skewY;
    rotation += skewY;
  }

  if (rotation || skewX) {
    rotation *= _DEG2RAD;
    skewX *= _DEG2RAD;
    a11 = Math.cos(rotation) * scaleX;
    a21 = Math.sin(rotation) * scaleX;
    a12 = Math.sin(rotation - skewX) * -scaleY;
    a22 = Math.cos(rotation - skewX) * scaleY;

    if (skewX) {
      skewY *= _DEG2RAD;
      temp = Math.tan(skewX - skewY);
      temp = Math.sqrt(1 + temp * temp);
      a12 *= temp;
      a22 *= temp;

      if (skewY) {
        temp = Math.tan(skewY);
        temp = Math.sqrt(1 + temp * temp);
        a11 *= temp;
        a21 *= temp;
      }
    }

    a11 = _round(a11);
    a21 = _round(a21);
    a12 = _round(a12);
    a22 = _round(a22);
  } else {
    a11 = scaleX;
    a22 = scaleY;
    a21 = a12 = 0;
  }

  if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
    tx = _convertToUnit(target, "x", x, "px");
    ty = _convertToUnit(target, "y", y, "px");
  }

  if (xOrigin || yOrigin || xOffset || yOffset) {
    tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
    ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
  }

  if (xPercent || yPercent) {
    //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
    temp = target.getBBox();
    tx = _round(tx + xPercent / 100 * temp.width);
    ty = _round(ty + yPercent / 100 * temp.height);
  }

  temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
  target.setAttribute("transform", temp);
  forceCSS && (target.style[_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the  transform attribute changes!)
},
    _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue, relative) {
  var cap = 360,
      isString = _isString(endValue),
      endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
      change = relative ? endNum * relative : endNum - startNum,
      finalValue = startNum + change + "deg",
      direction,
      pt;

  if (isString) {
    direction = endValue.split("_")[1];

    if (direction === "short") {
      change %= cap;

      if (change !== change % (cap / 2)) {
        change += change < 0 ? cap : -cap;
      }
    }

    if (direction === "cw" && change < 0) {
      change = (change + cap * CSSPlugin_bigNum) % cap - ~~(change / cap) * cap;
    } else if (direction === "ccw" && change > 0) {
      change = (change - cap * CSSPlugin_bigNum) % cap - ~~(change / cap) * cap;
    }
  }

  plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
  pt.e = finalValue;
  pt.u = "deg";

  plugin._props.push(property);

  return pt;
},
    _assign = function _assign(target, source) {
  // Internet Explorer doesn't have Object.assign(), so we recreate it here.
  for (var p in source) {
    target[p] = source[p];
  }

  return target;
},
    _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
  //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
  var startCache = _assign({}, target._gsap),
      exclude = "perspective,force3D,transformOrigin,svgOrigin",
      style = target.style,
      endCache,
      p,
      startValue,
      endValue,
      startNum,
      endNum,
      startUnit,
      endUnit;

  if (startCache.svg) {
    startValue = target.getAttribute("transform");
    target.setAttribute("transform", "");
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);

    _removeProperty(target, _transformProp);

    target.setAttribute("transform", startValue);
  } else {
    startValue = getComputedStyle(target)[_transformProp];
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    style[_transformProp] = startValue;
  }

  for (p in _transformProps) {
    startValue = startCache[p];
    endValue = endCache[p];

    if (startValue !== endValue && exclude.indexOf(p) < 0) {
      //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
      startUnit = getUnit(startValue);
      endUnit = getUnit(endValue);
      startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
      endNum = parseFloat(endValue);
      plugin._pt = new PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
      plugin._pt.u = endUnit || 0;

      plugin._props.push(p);
    }
  }

  _assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.


_forEachName("padding,margin,Width,Radius", function (name, index) {
  var t = "Top",
      r = "Right",
      b = "Bottom",
      l = "Left",
      props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
    return index < 2 ? name + side : "border" + side + name;
  });

  _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
    var a, vars;

    if (arguments.length < 4) {
      // getter, passed target, property, and unit (from _get())
      a = props.map(function (prop) {
        return _get(plugin, prop, property);
      });
      vars = a.join(" ");
      return vars.split(a[0]).length === 5 ? a[0] : vars;
    }

    a = (endValue + "").split(" ");
    vars = {};
    props.forEach(function (prop, i) {
      return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
    });
    plugin.init(target, vars, tween);
  };
});

var CSSPlugin = {
  name: "css",
  register: _initCore,
  targetTest: function targetTest(target) {
    return target.style && target.nodeType;
  },
  init: function init(target, vars, tween, index, targets) {
    var props = this._props,
        style = target.style,
        startAt = tween.vars.startAt,
        startValue,
        endValue,
        endNum,
        startNum,
        type,
        specialProp,
        p,
        startUnit,
        endUnit,
        relative,
        isTransformRelated,
        transformPropTween,
        cache,
        smooth,
        hasPriority;
    _pluginInitted || _initCore();

    for (p in vars) {
      if (p === "autoRound") {
        continue;
      }

      endValue = vars[p];

      if (_plugins[p] && _checkPlugin(p, vars, tween, index, target, targets)) {
        // plugins
        continue;
      }

      type = typeof endValue;
      specialProp = _specialProps[p];

      if (type === "function") {
        endValue = endValue.call(tween, index, target, targets);
        type = typeof endValue;
      }

      if (type === "string" && ~endValue.indexOf("random(")) {
        endValue = _replaceRandom(endValue);
      }

      if (specialProp) {
        specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
      } else if (p.substr(0, 2) === "--") {
        //CSS variable
        startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
        endValue += "";
        _colorExp.lastIndex = 0;

        if (!_colorExp.test(startValue)) {
          // colors don't have units
          startUnit = getUnit(startValue);
          endUnit = getUnit(endValue);
        }

        endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
        this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
        props.push(p);
      } else if (type !== "undefined") {
        if (startAt && p in startAt) {
          // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
          startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
          p in _config.units && !getUnit(startValue) && (startValue += _config.units[p]); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.

          _isString(startValue) && ~startValue.indexOf("random(") && (startValue = _replaceRandom(startValue));
          (startValue + "").charAt(1) === "=" && (startValue = _get(target, p)); // can't work with relative values
        } else {
          startValue = _get(target, p);
        }

        startNum = parseFloat(startValue);
        relative = type === "string" && endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
        relative && (endValue = endValue.substr(2));
        endNum = parseFloat(endValue);

        if (p in _propertyAliases) {
          if (p === "autoAlpha") {
            //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
            if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
              //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
              startNum = 0;
            }

            _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
          }

          if (p !== "scale" && p !== "transform") {
            p = _propertyAliases[p];
            ~p.indexOf(",") && (p = p.split(",")[0]);
          }
        }

        isTransformRelated = p in _transformProps; //--- TRANSFORM-RELATED ---

        if (isTransformRelated) {
          if (!transformPropTween) {
            cache = target._gsap;
            cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.

            smooth = vars.smoothOrigin !== false && cache.smooth;
            transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)

            transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
          }

          if (p === "scale") {
            this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? relative * endNum : endNum - cache.scaleY) || 0);
            props.push("scaleY", p);
            p += "X";
          } else if (p === "transformOrigin") {
            endValue = _convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.

            if (cache.svg) {
              _applySVGOrigin(target, endValue, 0, smooth, 0, this);
            } else {
              endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!

              endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);

              _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
            }

            continue;
          } else if (p === "svgOrigin") {
            _applySVGOrigin(target, endValue, 1, smooth, 0, this);

            continue;
          } else if (p in _rotationalProperties) {
            _addRotationalPropTween(this, cache, p, startNum, endValue, relative);

            continue;
          } else if (p === "smoothOrigin") {
            _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);

            continue;
          } else if (p === "force3D") {
            cache[p] = endValue;
            continue;
          } else if (p === "transform") {
            _addRawTransformPTs(this, endValue, target);

            continue;
          }
        } else if (!(p in style)) {
          p = _checkPropPrefix(p) || p;
        }

        if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
          startUnit = (startValue + "").substr((startNum + "").length);
          endNum || (endNum = 0); // protect against NaN

          endUnit = getUnit(endValue) || (p in _config.units ? _config.units[p] : startUnit);
          startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
          this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, relative ? relative * endNum : endNum - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
          this._pt.u = endUnit || 0;

          if (startUnit !== endUnit && endUnit !== "%") {
            //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
            this._pt.b = startValue;
            this._pt.r = _renderCSSPropWithBeginning;
          }
        } else if (!(p in style)) {
          if (p in target) {
            //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
            this.add(target, p, startValue || target[p], endValue, index, targets);
          } else {
            _missingPlugin(p, endValue);

            continue;
          }
        } else {
          _tweenComplexCSSString.call(this, target, p, startValue, endValue);
        }

        props.push(p);
      }
    }

    hasPriority && _sortPropTweensByPriority(this);
  },
  get: _get,
  aliases: _propertyAliases,
  getSetter: function getSetter(target, property, plugin) {
    //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
    var p = _propertyAliases[property];
    p && p.indexOf(",") < 0 && (property = p);
    return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
  },
  core: {
    _removeProperty: _removeProperty,
    _getMatrix: _getMatrix
  }
};
gsap.utils.checkPrefix = _checkPropPrefix;

(function (positionAndScale, rotation, others, aliases) {
  var all = _forEachName(positionAndScale + "," + rotation + "," + others, function (name) {
    _transformProps[name] = 1;
  });

  _forEachName(rotation, function (name) {
    _config.units[name] = "deg";
    _rotationalProperties[name] = 1;
  });

  _propertyAliases[all[13]] = positionAndScale + "," + rotation;

  _forEachName(aliases, function (name) {
    var split = name.split(":");
    _propertyAliases[split[1]] = all[split[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");

_forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
  _config.units[name] = "px";
});

gsap.registerPlugin(CSSPlugin);

;// CONCATENATED MODULE: ../../node_modules/gsap/index.js


var gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap,
    // to protect from tree shaking
TweenMaxWithCSS = gsapWithCSS.core.Tween;


/***/ }),

/***/ 7581:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 2817:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

var _slicedToArray = __webpack_require__(4429);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(5154)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _router = __webpack_require__(7744);

var _addLocale = __webpack_require__(7640);

var _routerContext = __webpack_require__(7258);

var _appRouterContext = __webpack_require__(4117);

var _useIntersection = __webpack_require__(1514);

var _getDomainLocale = __webpack_require__(7581);

var _addBasePath = __webpack_require__(5409);

'use client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options)).catch(function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push'; // Apply `as` if it's provided.

      router[method](as || href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react.default.startTransition(navigate);
  } else {
    navigate();
  }
}
/**
 * React Component that enables client-side transitions between routes.
 */


var Link = /*#__PURE__*/_react.default.forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(true) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react.default.createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react.default.useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react.default.useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react.default.useRef(href);

  var previousAs = _react.default.useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react.default.Children.only(children);
    }
  } else {
    if (false) { var ref; }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react.default.useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react.default.useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react.default.cloneElement(child, childProps) : /*#__PURE__*/_react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 1514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(4429);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(2784);

var _requestIdleCallback = __webpack_require__(1859);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements.delete(element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 4117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

'use client';

var AppRouterContext = _react.default.createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react.default.createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react.default.createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react.default.createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 9097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2817)


/***/ }),

/***/ 530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports Button, Caption, CaptionDropdowns, CaptionLabel, CaptionNavigation, Day, DayContent, DayPicker, DayPickerContext, DayPickerProvider, Dropdown, FocusContext, FocusProvider, Footer, Head, HeadRow, IconDropdown, IconLeft, IconRight, InternalModifier, NavigationContext, NavigationProvider, RootProvider, Row, SelectMultipleContext, SelectMultipleProvider, SelectMultipleProviderInternal, SelectRangeContext, SelectRangeProvider, SelectRangeProviderInternal, SelectSingleContext, SelectSingleProvider, SelectSingleProviderInternal, WeekNumber, addToRange, isDateAfterType, isDateBeforeType, isDateInterval, isDateRange, isDayOfWeekType, isDayPickerDefault, isDayPickerMultiple, isDayPickerRange, isDayPickerSingle, isMatch, useActiveModifiers, useDayPicker, useDayRender, useFocusContext, useInput, useNavigation, useSelectMultiple, useSelectRange, useSelectSingle */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5027);





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/** Returns true when the props are of type {@link DayPickerMultipleProps}. */
function isDayPickerMultiple(props) {
    return props.mode === 'multiple';
}

/** Returns true when the props are of type {@link DayPickerRangeProps}. */
function isDayPickerRange(props) {
    return props.mode === 'range';
}

/** Returns true when the props are of type {@link DayPickerSingleProps}. */
function isDayPickerSingle(props) {
    return props.mode === 'single';
}

/**
 * The name of the default CSS classes.
 */
var defaultClassNames = {
    root: 'rdp',
    multiple_months: 'rdp-multiple_months',
    with_weeknumber: 'rdp-with_weeknumber',
    vhidden: 'rdp-vhidden',
    button_reset: 'rdp-button_reset',
    button: 'rdp-button',
    caption: 'rdp-caption',
    caption_start: 'rdp-caption_start',
    caption_end: 'rdp-caption_end',
    caption_between: 'rdp-caption_between',
    caption_label: 'rdp-caption_label',
    caption_dropdowns: 'rdp-caption_dropdowns',
    dropdown: 'rdp-dropdown',
    dropdown_month: 'rdp-dropdown_month',
    dropdown_year: 'rdp-dropdown_year',
    dropdown_icon: 'rdp-dropdown_icon',
    months: 'rdp-months',
    month: 'rdp-month',
    table: 'rdp-table',
    tbody: 'rdp-tbody',
    tfoot: 'rdp-tfoot',
    head: 'rdp-head',
    head_row: 'rdp-head_row',
    head_cell: 'rdp-head_cell',
    nav: 'rdp-nav',
    nav_button: 'rdp-nav_button',
    nav_button_previous: 'rdp-nav_button_previous',
    nav_button_next: 'rdp-nav_button_next',
    nav_icon: 'rdp-nav_icon',
    row: 'rdp-row',
    weeknumber: 'rdp-weeknumber',
    cell: 'rdp-cell',
    day: 'rdp-day',
    day_today: 'rdp-day_today',
    day_outside: 'rdp-day_outside',
    day_selected: 'rdp-day_selected',
    day_disabled: 'rdp-day_disabled',
    day_hidden: 'rdp-day_hidden',
    day_range_start: 'rdp-day_range_start',
    day_range_end: 'rdp-day_range_end',
    day_range_middle: 'rdp-day_range_middle'
};

/**
 * The default formatter for the caption.
 */
function formatCaption(month, options) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(month, 'LLLL y', options);
}

/**
 * The default formatter for the Day button.
 */
function formatDay(day, options) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(day, 'd', options);
}

/**
 * The default formatter for the Month caption.
 */
function formatMonthCaption(month, options) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(month, 'LLLL', options);
}

/**
 * The default formatter for the week number.
 */
function formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}

/**
 * The default formatter for the name of the weekday.
 */
function formatWeekdayName(weekday, options) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(weekday, 'cccccc', options);
}

/**
 * The default formatter for the Year caption.
 */
function formatYearCaption(year, options) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(year, 'yyyy', options);
}

var formatters = /*#__PURE__*/Object.freeze({
    __proto__: null,
    formatCaption: formatCaption,
    formatDay: formatDay,
    formatMonthCaption: formatMonthCaption,
    formatWeekNumber: formatWeekNumber,
    formatWeekdayName: formatWeekdayName,
    formatYearCaption: formatYearCaption
});

/**
 * The default ARIA label for the day button.
 */
var labelDay = function (day, activeModifiers, options) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(day, 'do MMMM (EEEE)', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelMonthDropdown = function () {
    return 'Month: ';
};

/**
 * The default ARIA label for next month button in navigation
 */
var labelNext = function () {
    return 'Go to next month';
};

/**
 * The default ARIA label for previous month button in navigation
 */
var labelPrevious = function () {
    return 'Go to previous month';
};

/**
 * The default ARIA label for the Weekday element.
 */
var labelWeekday = function (day, options) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(day, 'cccc', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelWeekNumber = function (n) {
    return "Week n. ".concat(n);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelYearDropdown = function () {
    return 'Year: ';
};

var labels = /*#__PURE__*/Object.freeze({
    __proto__: null,
    labelDay: labelDay,
    labelMonthDropdown: labelMonthDropdown,
    labelNext: labelNext,
    labelPrevious: labelPrevious,
    labelWeekNumber: labelWeekNumber,
    labelWeekday: labelWeekday,
    labelYearDropdown: labelYearDropdown
});

/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */
function getDefaultContextValues() {
    var captionLayout = 'buttons';
    var classNames = defaultClassNames;
    var locale = enUS;
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: formatters,
        labels: labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: 'default'
    };
}

/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */
function parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) {
        fromDate = startOfMonth(fromMonth);
    }
    else if (fromYear) {
        fromDate = new Date(fromYear, 0, 1);
    }
    if (toMonth) {
        toDate = endOfMonth(toMonth);
    }
    else if (toYear) {
        toDate = new Date(toYear, 11, 31);
    }
    return {
        fromDate: fromDate ? startOfDay(fromDate) : undefined,
        toDate: toDate ? startOfDay(toDate) : undefined
    };
}

/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */
var DayPickerContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */
function DayPickerProvider(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = getDefaultContextValues();
    var _b = parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== 'buttons' && (!fromDate || !toDate)) {
        // When no from/to dates are set, the caption is always buttons
        captionLayout = 'buttons';
    }
    var onSelect;
    if (isDayPickerSingle(initialProps) ||
        isDayPickerMultiple(initialProps) ||
        isDayPickerRange(initialProps)) {
        onSelect = initialProps.onSelect;
    }
    var value = __assign(__assign(__assign({}, defaultContextValues), initialProps), { captionLayout: captionLayout, classNames: __assign(__assign({}, defaultContextValues.classNames), initialProps.classNames), components: __assign({}, initialProps.components), formatters: __assign(__assign({}, defaultContextValues.formatters), initialProps.formatters), fromDate: fromDate, labels: __assign(__assign({}, defaultContextValues.labels), initialProps.labels), mode: initialProps.mode || defaultContextValues.mode, modifiers: __assign(__assign({}, defaultContextValues.modifiers), initialProps.modifiers), modifiersClassNames: __assign(__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames), onSelect: onSelect, styles: __assign(__assign({}, defaultContextValues.styles), initialProps.styles), toDate: toDate });
    return (React__default.createElement(DayPickerContext.Provider, { value: value }, props.children));
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */
function useDayPicker() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(DayPickerContext);
    if (!context) {
        throw new Error("useDayPicker must be used within a DayPickerProvider.");
    }
    return context;
}

/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */
function CaptionLabel(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (React__default.createElement("div", { className: classNames.caption_label, style: styles.caption_label, "aria-live": "polite", role: "presentation", id: props.id }, formatCaption(props.displayMonth, { locale: locale })));
}

/**
 * Render the icon in the styled drop-down.
 */
function IconDropdown(props) {
    return (React__default.createElement("svg", __assign({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, props),
        React__default.createElement("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" })));
}

/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */
function Dropdown(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = useDayPicker();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : IconDropdown;
    return (React__default.createElement("div", { className: className, style: style },
        React__default.createElement("span", { className: dayPicker.classNames.vhidden }, props['aria-label']),
        React__default.createElement("select", { name: props.name, "aria-label": props['aria-label'], className: dayPicker.classNames.dropdown, style: dayPicker.styles.dropdown, value: value, onChange: onChange }, children),
        React__default.createElement("div", { className: dayPicker.classNames.caption_label, style: dayPicker.styles.caption_label, "aria-hidden": "true" },
            caption,
            React__default.createElement(IconDropdownComponent, { className: dayPicker.classNames.dropdown_icon, style: dayPicker.styles.dropdown_icon }))));
}

/** Render the dropdown to navigate between months. */
function MonthsDropdown(props) {
    var _a;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return React__default.createElement(React__default.Fragment, null);
    if (!toDate)
        return React__default.createElement(React__default.Fragment, null);
    var dropdownMonths = [];
    if (isSameYear(fromDate, toDate)) {
        // only display the months included in the range
        var date = startOfMonth(fromDate);
        for (var month = fromDate.getMonth(); month <= toDate.getMonth(); month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    else {
        // display all the 12 months
        var date = startOfMonth(new Date()); // Any date should be OK, as we just need the year
        for (var month = 0; month <= 11; month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    var handleChange = function (e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = setMonth(startOfMonth(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (React__default.createElement(DropdownComponent, { name: "months", "aria-label": labelMonthDropdown(), className: classNames.dropdown_month, style: styles.dropdown_month, onChange: handleChange, value: props.displayMonth.getMonth(), caption: formatMonthCaption(props.displayMonth, { locale: locale }) }, dropdownMonths.map(function (m) { return (React__default.createElement("option", { key: m.getMonth(), value: m.getMonth() }, formatMonthCaption(m, { locale: locale }))); })));
}

/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */
function YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return React__default.createElement(React__default.Fragment, null);
    if (!toDate)
        return React__default.createElement(React__default.Fragment, null);
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for (var year = fromYear; year <= toYear; year++) {
        years.push(setYear(startOfYear(new Date()), year));
    }
    var handleChange = function (e) {
        var newMonth = setYear(startOfMonth(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (React__default.createElement(DropdownComponent, { name: "years", "aria-label": labelYearDropdown(), className: classNames.dropdown_year, style: styles.dropdown_year, onChange: handleChange, value: displayMonth.getFullYear(), caption: formatYearCaption(displayMonth, { locale: locale }) }, years.map(function (year) { return (React__default.createElement("option", { key: year.getFullYear(), value: year.getFullYear() }, formatYearCaption(year, { locale: locale }))); })));
}

/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */
function useControlledValue(defaultValue, controlledValue) {
    var _a = useState(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [value, setValue];
}

/** Return the initial month according to the given options. */
function getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && differenceInCalendarMonths(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = addMonths(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && differenceInCalendarMonths(initialMonth, fromDate) < 0) {
        initialMonth = fromDate;
    }
    return startOfMonth(initialMonth);
}

/** Controls the navigation state. */
function useNavigationState() {
    var context = useDayPicker();
    var initialMonth = getInitialMonth(context);
    var _a = useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function (date) {
        var _a;
        if (context.disableNavigation)
            return;
        var month = startOfMonth(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 ? void 0 : _a.call(context, month);
    };
    return [month, goToMonth];
}

/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */
function getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = startOfMonth(month);
    var end = startOfMonth(addMonths(start, numberOfMonths));
    var monthsDiff = differenceInCalendarMonths(end, start);
    var months = [];
    for (var i = 0; i < monthsDiff; i++) {
        var nextMonth = addMonths(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths)
        months = months.reverse();
    return months;
}

/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */
function getNextMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!toDate) {
        return addMonths(month, offset);
    }
    var monthsDiff = differenceInCalendarMonths(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) {
        return undefined;
    }
    // Jump forward as the number of months when paged navigation
    return addMonths(month, offset);
}

/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */
function getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!fromDate) {
        return addMonths(month, -offset);
    }
    var monthsDiff = differenceInCalendarMonths(month, fromDate);
    if (monthsDiff <= 0) {
        return undefined;
    }
    // Jump back as the number of months when paged navigation
    return addMonths(month, -offset);
}

/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */
var NavigationContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */
function NavigationProvider(props) {
    var dayPicker = useDayPicker();
    var _a = useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = getNextMonth(currentMonth, dayPicker);
    var previousMonth = getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function (date) {
        return displayMonths.some(function (displayMonth) {
            return isSameMonth(date, displayMonth);
        });
    };
    var goToDate = function (date, refDate) {
        if (isDateDisplayed(date)) {
            return;
        }
        if (refDate && isBefore(date, refDate)) {
            goToMonth(addMonths(date, 1 + dayPicker.numberOfMonths * -1));
        }
        else {
            goToMonth(date);
        }
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (React__default.createElement(NavigationContext.Provider, { value: value }, props.children));
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useNavigation() {
    var context = useContext(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}

/**
 * Render a caption with the dropdowns to navigate between months and years.
 */
function CaptionDropdowns(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = useNavigation().goToMonth;
    var handleMonthChange = function (newMonth) {
        goToMonth(newMonth);
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var captionLabel = (React__default.createElement(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    return (React__default.createElement("div", { className: classNames.caption_dropdowns, style: styles.caption_dropdowns },
        React__default.createElement("div", { className: classNames.vhidden }, captionLabel),
        React__default.createElement(MonthsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth }),
        React__default.createElement(YearsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth })));
}

/**
 * Render the "previous month" button in the navigation.
 */
function IconLeft(props) {
    return (React__default.createElement("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props),
        React__default.createElement("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" })));
}

/**
 * Render the "next month" button in the navigation.
 */
function IconRight(props) {
    return (React__default.createElement("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props),
        React__default.createElement("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" })));
}

/** Render a button HTML element applying the reset class name. */
var Button = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [classNames.button_reset, classNames.button];
    if (props.className) {
        classNamesArr.push(props.className);
    }
    var className = classNamesArr.join(' ');
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) {
        Object.assign(style, props.style);
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", __assign({}, props, { ref: ref, type: "button", className: className, style: style })));
});

/** A component rendering the navigation buttons or the drop-downs. */
function Navigation(props) {
    var _a, _b;
    var _c = useDayPicker(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) {
        return React__default.createElement(React__default.Fragment, null);
    }
    var previousLabel = labelPrevious(props.previousMonth, { locale: locale });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var nextLabel = labelNext(props.nextMonth, { locale: locale });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(' ');
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : IconRight;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : IconLeft;
    return (React__default.createElement("div", { className: classNames.nav, style: styles.nav },
        !props.hidePrevious && (React__default.createElement(Button, { name: "previous-month", "aria-label": previousLabel, className: previousClassName, style: styles.nav_button_previous, disabled: !props.previousMonth, onClick: props.onPreviousClick }, dir === 'rtl' ? (React__default.createElement(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (React__default.createElement(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })))),
        !props.hideNext && (React__default.createElement(Button, { name: "next-month", "aria-label": nextLabel, className: nextClassName, style: styles.nav_button_next, disabled: !props.nextMonth, onClick: props.onNextClick }, dir === 'rtl' ? (React__default.createElement(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (React__default.createElement(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon }))))));
}

/**
 * Render a caption with a button-based navigation.
 */
function CaptionNavigation(props) {
    var numberOfMonths = useDayPicker().numberOfMonths;
    var _a = useNavigation(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function (month) {
        return isSameMonth(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function () {
        if (!previousMonth)
            return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function () {
        if (!nextMonth)
            return;
        goToMonth(nextMonth);
    };
    return (React__default.createElement(Navigation, { displayMonth: props.displayMonth, hideNext: hideNext, hidePrevious: hidePrevious, nextMonth: nextMonth, previousMonth: previousMonth, onPreviousClick: handlePreviousClick, onNextClick: handleNextClick }));
}

/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */
function Caption(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var caption;
    if (disableNavigation) {
        caption = (React__default.createElement(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    }
    else if (captionLayout === 'dropdown') {
        caption = (React__default.createElement(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id }));
    }
    else if (captionLayout === 'dropdown-buttons') {
        caption = (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id }),
            React__default.createElement(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })));
    }
    else {
        caption = (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }),
            React__default.createElement(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })));
    }
    return (React__default.createElement("div", { className: classNames.caption, style: styles.caption }, caption));
}

/** Render the Footer component (empty as default).*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Footer(props) {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer)
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement("tfoot", { className: tfoot, style: styles.tfoot },
        React__default.createElement("tr", null,
            React__default.createElement("td", { colSpan: 8 }, footer))));
}

/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */
function getWeekdays(locale, 
/** The index of the first day of the week (0 - Sunday). */
weekStartsOn, 
/** Use ISOWeek instead of locale/ */
ISOWeek) {
    var start = ISOWeek
        ? startOfISOWeek(new Date())
        : startOfWeek(new Date(), { locale: locale, weekStartsOn: weekStartsOn });
    var days = [];
    for (var i = 0; i < 7; i++) {
        var day = addDays(start, i);
        days.push(day);
    }
    return days;
}

/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */
function HeadRow() {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = getWeekdays(locale, weekStartsOn, ISOWeek);
    return (React__default.createElement("tr", { style: styles.head_row, className: classNames.head_row },
        showWeekNumber && (React__default.createElement("td", { style: styles.head_cell, className: classNames.head_cell })),
        weekdays.map(function (weekday, i) { return (React__default.createElement("th", { key: i, scope: "col", className: classNames.head_cell, style: styles.head_cell, "aria-label": labelWeekday(weekday, { locale: locale }) }, formatWeekdayName(weekday, { locale: locale }))); })));
}

/** Render the table head. */
function Head() {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (React__default.createElement("thead", { style: styles.head, className: classNames.head },
        React__default.createElement(HeadRowComponent, null)));
}

/** Render the content of the day cell. */
function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return React__default.createElement(React__default.Fragment, null, formatDay(props.date, { locale: locale }));
}

/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */
var SelectMultipleContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */
function SelectMultipleProvider(props) {
    if (!isDayPickerMultiple(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (React__default.createElement(SelectMultipleContext.Provider, { value: emptyContextValue }, props.children));
    }
    return (React__default.createElement(SelectMultipleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectMultipleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) {
            return;
        }
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) {
            return;
        }
        var selectedDays = selected ? __spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function (selectedDay) {
                return isSameDay(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        }
        else {
            selectedDays.push(day);
        }
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) {
        modifiers.disabled.push(function (day) {
            var isMaxSelected = max && selected.length > max - 1;
            var isSelected = selected.some(function (selectedDay) {
                return isSameDay(selectedDay, day);
            });
            return Boolean(isMaxSelected && !isSelected);
        });
    }
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (React__default.createElement(SelectMultipleContext.Provider, { value: contextValue }, children));
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectMultiple() {
    var context = useContext(SelectMultipleContext);
    if (!context) {
        throw new Error('useSelectMultiple must be used within a SelectMultipleProvider');
    }
    return context;
}

/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */
function addToRange(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (!from) {
        return { from: day, to: undefined };
    }
    if (!to && isSameDay(from, day)) {
        return { from: from, to: day };
    }
    if (!to && isBefore(day, from)) {
        return { from: day, to: from };
    }
    if (!to) {
        return { from: from, to: day };
    }
    if (isSameDay(to, day) && isSameDay(from, day)) {
        return undefined;
    }
    if (isSameDay(to, day)) {
        return { from: to, to: undefined };
    }
    if (isSameDay(from, day)) {
        return undefined;
    }
    if (isAfter(from, day)) {
        return { from: day, to: to };
    }
    return { from: from, to: day };
}

/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */
var SelectRangeContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */
function SelectRangeProvider(props) {
    if (!isDayPickerRange(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (React__default.createElement(SelectRangeContext.Provider, { value: emptyContextValue }, props.children));
    }
    return (React__default.createElement(SelectRangeProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectRangeProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var newRange = addToRange(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [selectedFrom];
        if (!selectedTo) {
            modifiers.range_end = [selectedFrom];
        }
        else {
            modifiers.range_end = [selectedTo];
            if (!isSameDay(selectedFrom, selectedTo)) {
                modifiers.range_middle = [
                    {
                        after: selectedFrom,
                        before: selectedTo
                    }
                ];
            }
        }
    }
    if (min) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                after: subDays(selectedFrom, min - 1),
                before: addDays(selectedFrom, min - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: selectedFrom,
                before: addDays(selectedFrom, min - 1)
            });
        }
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: addDays(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: addDays(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = differenceInCalendarDays(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: subDays(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: addDays(selectedTo, offset)
            });
        }
    }
    return (React__default.createElement(SelectRangeContext.Provider, { value: { selected: selected, onDayClick: onDayClick, modifiers: modifiers } }, children));
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectRange() {
    var context = useContext(SelectRangeContext);
    if (!context) {
        throw new Error('useSelectRange must be used within a SelectRangeProvider');
    }
    return context;
}

/** Normalize to array a matcher input. */
function matcherToArray(matcher) {
    if (Array.isArray(matcher)) {
        return __spreadArray([], matcher, true);
    }
    else if (matcher !== undefined) {
        return [matcher];
    }
    else {
        return [];
    }
}

/** Create CustomModifiers from dayModifiers */
function getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function (_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = matcherToArray(matcher);
    });
    return customModifiers;
}

/** The name of the modifiers that are used internally by DayPicker. */
var InternalModifier;
(function (InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */
    InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */
    InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */
    InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */
    InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */
    InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */
    InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */
    InternalModifier["RangeMiddle"] = "range_middle";
})(InternalModifier || (InternalModifier = {}));

var Selected = InternalModifier.Selected, Disabled = InternalModifier.Disabled, Hidden = InternalModifier.Hidden, Today = InternalModifier.Today, RangeEnd = InternalModifier.RangeEnd, RangeMiddle = InternalModifier.RangeMiddle, RangeStart = InternalModifier.RangeStart, Outside = InternalModifier.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */
function getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {},
        _a[Selected] = matcherToArray(dayPicker.selected),
        _a[Disabled] = matcherToArray(dayPicker.disabled),
        _a[Hidden] = matcherToArray(dayPicker.hidden),
        _a[Today] = [dayPicker.today],
        _a[RangeEnd] = [],
        _a[RangeMiddle] = [],
        _a[RangeStart] = [],
        _a[Outside] = [],
        _a);
    if (dayPicker.fromDate) {
        internalModifiers[Disabled].push({ before: dayPicker.fromDate });
    }
    if (dayPicker.toDate) {
        internalModifiers[Disabled].push({ after: dayPicker.toDate });
    }
    if (isDayPickerMultiple(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectMultiple.modifiers[Disabled]);
    }
    else if (isDayPickerRange(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectRange.modifiers[Disabled]);
        internalModifiers[RangeStart] = selectRange.modifiers[RangeStart];
        internalModifiers[RangeMiddle] = selectRange.modifiers[RangeMiddle];
        internalModifiers[RangeEnd] = selectRange.modifiers[RangeEnd];
    }
    return internalModifiers;
}

/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */
var ModifiersContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */
function ModifiersProvider(props) {
    var dayPicker = useDayPicker();
    var selectMultiple = useSelectMultiple();
    var selectRange = useSelectRange();
    var internalModifiers = getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = getCustomModifiers(dayPicker.modifiers);
    var modifiers = __assign(__assign({}, internalModifiers), customModifiers);
    return (React__default.createElement(ModifiersContext.Provider, { value: modifiers }, props.children));
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */
function useModifiers() {
    var context = useContext(ModifiersContext);
    if (!context) {
        throw new Error('useModifiers must be used within a ModifiersProvider');
    }
    return context;
}

/** Returns true if `matcher` is of type {@link DateInterval}. */
function isDateInterval(matcher) {
    return Boolean(matcher &&
        typeof matcher === 'object' &&
        'before' in matcher &&
        'after' in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */
function isDateRange(value) {
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */
function isDateAfterType(value) {
    return Boolean(value && typeof value === 'object' && 'after' in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */
function isDateBeforeType(value) {
    return Boolean(value && typeof value === 'object' && 'before' in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */
function isDayOfWeekType(value) {
    return Boolean(value && typeof value === 'object' && 'dayOfWeek' in value);
}

/** Return `true` whether `date` is inside `range`. */
function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (!from) {
        return false;
    }
    if (!to && isSameDay(from, date)) {
        return true;
    }
    if (!to) {
        return false;
    }
    var isRangeInverted = differenceInCalendarDays(to, from) < 0;
    if (isRangeInverted) {
        _a = [to, from], from = _a[0], to = _a[1];
    }
    var isInRange = differenceInCalendarDays(date, from) >= 0 &&
        differenceInCalendarDays(to, date) >= 0;
    return isInRange;
}

/** Returns true if `value` is a Date type. */
function isDateType(value) {
    return isDate(value);
}
/** Returns true if `value` is an array of valid dates. */
function isArrayOfDates(value) {
    return Array.isArray(value) && value.every(isDate);
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */
function isMatch(day, matchers) {
    return matchers.some(function (matcher) {
        if (typeof matcher === 'boolean') {
            return matcher;
        }
        if (isDateType(matcher)) {
            return isSameDay(day, matcher);
        }
        if (isArrayOfDates(matcher)) {
            return matcher.includes(day);
        }
        if (isDateRange(matcher)) {
            return isDateInRange(day, matcher);
        }
        if (isDayOfWeekType(matcher)) {
            return matcher.dayOfWeek.includes(day.getDay());
        }
        if (isDateInterval(matcher)) {
            var diffBefore = differenceInCalendarDays(matcher.before, day);
            var diffAfter = differenceInCalendarDays(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = isAfter(matcher.before, matcher.after);
            if (isClosedInterval) {
                return isDayAfter && isDayBefore;
            }
            else {
                return isDayBefore || isDayAfter;
            }
        }
        if (isDateAfterType(matcher)) {
            return differenceInCalendarDays(day, matcher.after) > 0;
        }
        if (isDateBeforeType(matcher)) {
            return differenceInCalendarDays(matcher.before, day) > 0;
        }
        if (typeof matcher === 'function') {
            return matcher(day);
        }
        return false;
    });
}

/** Return the active modifiers for the given day. */
function getActiveModifiers(day, 
/** The modifiers to match for the given date. */
modifiers, 
/** The month where the day is displayed, to add the "outside" modifiers.  */
displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function (result, key) {
        var modifier = modifiers[key];
        if (isMatch(day, modifier)) {
            result.push(key);
        }
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function (modifier) { return (activeModifiers[modifier] = true); });
    if (displayMonth && !isSameMonth(day, displayMonth)) {
        activeModifiers.outside = true;
    }
    return activeModifiers;
}

/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */
function getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = startOfMonth(displayMonths[0]);
    var lastDayInMonth = endOfMonth(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while (date <= lastDayInMonth) {
        var activeModifiers = getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = addDays(date, 1);
            continue;
        }
        if (activeModifiers.selected) {
            return date;
        }
        if (activeModifiers.today && !today) {
            today = date;
        }
        if (!firstFocusableDay) {
            firstFocusableDay = date;
        }
        date = addDays(date, 1);
    }
    if (today) {
        return today;
    }
    else {
        return firstFocusableDay;
    }
}

var MAX_RETRY = 365;
/** Return the next date to be focused. */
function getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? { count: 0, lastFocused: focusedDay } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: addDays,
        week: addWeeks,
        month: addMonths,
        year: addYears,
        startOfWeek: function (date) {
            return context.ISOWeek
                ? startOfISOWeek(date)
                : startOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        },
        endOfWeek: function (date) {
            return context.ISOWeek
                ? endOfISOWeek(date)
                : endOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === 'after' ? 1 : -1);
    if (direction === 'before' && fromDate) {
        newFocusedDay = max([fromDate, newFocusedDay]);
    }
    else if (direction === 'after' && toDate) {
        newFocusedDay = min([toDate, newFocusedDay]);
    }
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) {
        return newFocusedDay;
    }
    else {
        if (retry.count > MAX_RETRY) {
            return retry.lastFocused;
        }
        return getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: __assign(__assign({}, retry), { count: retry.count + 1 })
        });
    }
}

/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */
var FocusContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
/** The provider for the {@link FocusContext}. */
function FocusProvider(props) {
    var navigation = useNavigation();
    var modifiers = useModifiers();
    var _a = useState(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = useState(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : (lastFocused && navigation.isDateDisplayed(lastFocused)))
        ? lastFocused
        : initialFocusTarget;
    var blur = function () {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function (date) {
        setFocusedDay(date);
    };
    var context = useDayPicker();
    var moveFocus = function (moveBy, direction) {
        if (!focusedDay)
            return;
        var nextFocused = getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if (isSameDay(focusedDay, nextFocused))
            return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function () { return moveFocus('day', 'after'); },
        focusDayBefore: function () { return moveFocus('day', 'before'); },
        focusWeekAfter: function () { return moveFocus('week', 'after'); },
        focusWeekBefore: function () { return moveFocus('week', 'before'); },
        focusMonthBefore: function () { return moveFocus('month', 'before'); },
        focusMonthAfter: function () { return moveFocus('month', 'after'); },
        focusYearBefore: function () { return moveFocus('year', 'before'); },
        focusYearAfter: function () { return moveFocus('year', 'after'); },
        focusStartOfWeek: function () { return moveFocus('startOfWeek', 'before'); },
        focusEndOfWeek: function () { return moveFocus('endOfWeek', 'after'); }
    };
    return (React__default.createElement(FocusContext.Provider, { value: value }, props.children));
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useFocusContext() {
    var context = useContext(FocusContext);
    if (!context) {
        throw new Error('useFocusContext must be used within a FocusProvider');
    }
    return context;
}

/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */
function useActiveModifiers(day, 
/**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */
displayMonth) {
    var modifiers = useModifiers();
    var activeModifiers = getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}

/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */
var SelectSingleContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */
function SelectSingleProvider(props) {
    if (!isDayPickerSingle(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (React__default.createElement(SelectSingleContext.Provider, { value: emptyContextValue }, props.children));
    }
    return (React__default.createElement(SelectSingleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectSingleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 ? void 0 : _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (React__default.createElement(SelectSingleContext.Provider, { value: contextValue }, children));
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectSingle() {
    var context = useContext(SelectSingleContext);
    if (!context) {
        throw new Error('useSelectSingle must be used within a SelectSingleProvider');
    }
    return context;
}

/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */
function useDayEventHandlers(date, activeModifiers) {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var _a = useFocusContext(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function (e) {
        var _a, _b, _c, _d;
        if (isDayPickerSingle(dayPicker)) {
            (_a = single.onDayClick) === null || _a === void 0 ? void 0 : _a.call(single, date, activeModifiers, e);
        }
        else if (isDayPickerMultiple(dayPicker)) {
            (_b = multiple.onDayClick) === null || _b === void 0 ? void 0 : _b.call(multiple, date, activeModifiers, e);
        }
        else if (isDayPickerRange(dayPicker)) {
            (_c = range.onDayClick) === null || _c === void 0 ? void 0 : _c.call(range, date, activeModifiers, e);
        }
        else {
            (_d = dayPicker.onDayClick) === null || _d === void 0 ? void 0 : _d.call(dayPicker, date, activeModifiers, e);
        }
    };
    var onFocus = function (e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function (e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function (e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function (e) {
        var _a;
        switch (e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayAfter() : focusDayBefore();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayBefore() : focusDayAfter();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case 'PageUp':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case 'PageDown':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}

/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */
function useSelectedDays() {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var selectedDays = isDayPickerSingle(dayPicker)
        ? single.selected
        : isDayPickerMultiple(dayPicker)
            ? multiple.selected
            : isDayPickerRange(dayPicker)
                ? range.selected
                : undefined;
    return selectedDays;
}

function isInternalModifier(modifier) {
    return Object.values(InternalModifier).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */
function getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [dayPicker.classNames.day];
    Object.keys(activeModifiers).forEach(function (modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) {
            classNames.push(customClassName);
        }
        else if (isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) {
                classNames.push(internalClassName);
            }
        }
    });
    return classNames;
}

/** Return the style for the Day element, according to the given active modifiers. */
function getDayStyle(dayPicker, activeModifiers) {
    var style = __assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function (modifier) {
        var _a;
        style = __assign(__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}

/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */
function useDayRender(
/** The date to render. */
day, 
/** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */
displayMonth, 
/** A ref to the button element that will be target of focus when rendered (if required). */
buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var activeModifiers = useActiveModifiers(day, displayMonth);
    var eventHandlers = useDayEventHandlers(day, activeModifiers);
    var selectedDays = useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== 'default');
    // Focus the button if the day is focused according to the focus context
    useEffect(function () {
        var _a;
        if (activeModifiers.outside)
            return;
        if (!focusContext.focusedDay)
            return;
        if (!isButton)
            return;
        if (isSameDay(focusContext.focusedDay, day)) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = getDayClassNames(dayPicker, activeModifiers).join(' ');
    var style = getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean((activeModifiers.outside && !dayPicker.showOutsideDays) ||
        activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : DayContent;
    var children = (React__default.createElement(DayContentComponent, { date: day, displayMonth: displayMonth, activeModifiers: activeModifiers }));
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: 'gridcell'
    };
    var isFocusTarget = focusContext.focusTarget &&
        isSameDay(focusContext.focusTarget, day) &&
        !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && isSameDay(focusContext.focusedDay, day);
    var buttonProps = __assign(__assign(__assign({}, divProps), (_a = { disabled: activeModifiers.disabled, role: 'gridcell' }, _a['aria-selected'] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}

/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
function Day(props) {
    var buttonRef = useRef(null);
    var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) {
        return React__default.createElement("div", { role: "gridcell" });
    }
    if (!dayRender.isButton) {
        return React__default.createElement("div", __assign({}, dayRender.divProps));
    }
    return React__default.createElement(Button, __assign({ name: "day", ref: buttonRef }, dayRender.buttonProps));
}

/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */
function WeekNumber(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = useDayPicker(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), { locale: locale });
    if (!onWeekNumberClick) {
        return (React__default.createElement("span", { className: classNames.weeknumber, style: styles.weeknumber }, content));
    }
    var label = labelWeekNumber(Number(weekNumber), { locale: locale });
    var handleClick = function (e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (React__default.createElement(Button, { name: "week-number", "aria-label": label, className: classNames.weeknumber, style: styles.weeknumber, onClick: handleClick }, content));
}

/** Render a row in the calendar, with the days and the week number. */
function Row(props) {
    var _a, _b;
    var _c = useDayPicker(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : Day;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : WeekNumber;
    var weekNumberCell;
    if (showWeekNumber) {
        weekNumberCell = (React__default.createElement("td", { className: classNames.cell, style: styles.cell },
            React__default.createElement(WeeknumberComponent, { number: props.weekNumber, dates: props.dates })));
    }
    return (React__default.createElement("tr", { className: classNames.row, style: styles.row },
        weekNumberCell,
        props.dates.map(function (date) { return (React__default.createElement("td", { className: classNames.cell, style: styles.cell, key: getUnixTime(date), role: "presentation" },
            React__default.createElement(DayComponent, { displayMonth: props.displayMonth, date: date }))); })));
}

/** Return the weeks between two dates.  */
function daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? endOfISOWeek(toDate)
        : endOfWeek(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? startOfISOWeek(fromDate)
        : startOfWeek(fromDate, options);
    var nOfDays = differenceInCalendarDays(toWeek, fromWeek);
    var days = [];
    for (var i = 0; i <= nOfDays; i++) {
        days.push(addDays(fromWeek, i));
    }
    var weeksInMonth = days.reduce(function (result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek)
            ? getISOWeek(date)
            : getWeek(date, options);
        var existingWeek = result.find(function (value) { return value.weekNumber === weekNumber; });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [date]
        });
        return result;
    }, []);
    return weeksInMonth;
}

/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */
function getMonthWeeks(month, options) {
    var weeksInMonth = daysToMonthWeeks(startOfMonth(month), endOfMonth(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = getWeeksInMonth(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = addWeeks(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = daysToMonthWeeks(addWeeks(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}

/** Render the table with the calendar. */
function Table(props) {
    var _a, _b, _c;
    var _d = useDayPicker(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : Head;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : Row;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : Footer;
    return (React__default.createElement("table", { className: classNames.table, style: styles.table, role: "grid", "aria-labelledby": props['aria-labelledby'] },
        !hideHead && React__default.createElement(HeadComponent, null),
        React__default.createElement("tbody", { className: classNames.tbody, style: styles.tbody, role: "rowgroup" }, weeks.map(function (week) { return (React__default.createElement(RowComponent, { displayMonth: props.displayMonth, key: week.weekNumber, dates: week.dates, weekNumber: week.weekNumber })); })),
        React__default.createElement(FooterComponent, { displayMonth: props.displayMonth })));
}

/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
function canUseDOM() {
    return !!(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */
var useIsomorphicLayoutEffect = canUseDOM()
    ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect
    : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
var serverHandoffComplete = false;
var id = 0;
function genId() {
    return "react-day-picker-".concat(++id);
}
function useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : (serverHandoffComplete ? genId() : null);
    var _b = React.useState(initialId), id = _b[0], setId = _b[1];
    useIsomorphicLayoutEffect(function () {
        if (id === null) {
            // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
            // rendering flicker, though it'll make the first render slower (unlikely
            // to matter, but you're welcome to measure your app and let us know if
            // it's a problem).
            setId(genId());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(function () {
        if (serverHandoffComplete === false) {
            // Flag all future uses of `useId` to skip the update dance. This is in
            // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
            // accidentally bail out of the patch-up dance prematurely.
            serverHandoffComplete = true;
        }
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}

/** Render a month. */
function Month(props) {
    var _a;
    var _b;
    var dayPicker = useDayPicker();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = useNavigation().displayMonths;
    var captionId = useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var className = [classNames.month];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === 'rtl') {
        _a = [isStart, isEnd], isEnd = _a[0], isStart = _a[1];
    }
    if (isStart) {
        className.push(classNames.caption_start);
        style = __assign(__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = __assign(__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = __assign(__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : Caption;
    return (React__default.createElement("div", { key: props.displayIndex, className: className.join(' '), style: style },
        React__default.createElement(CaptionComponent, { id: captionId, displayMonth: props.displayMonth }),
        React__default.createElement(Table, { "aria-labelledby": captionId, displayMonth: props.displayMonth })));
}

/** Render the container with the months according to the number of months to display. */
function Root(_a) {
    var initialProps = _a.initialProps;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var navigation = useNavigation();
    var _b = useState(false), hasInitialFocus = _b[0], setHasInitialFocus = _b[1];
    // Focus the focus target when initialFocus is passed in
    useEffect(function () {
        if (!dayPicker.initialFocus)
            return;
        if (!focusContext.focusTarget)
            return;
        if (hasInitialFocus)
            return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [dayPicker.classNames.root, dayPicker.className];
    if (dayPicker.numberOfMonths > 1) {
        classNames.push(dayPicker.classNames.multiple_months);
    }
    if (dayPicker.showWeekNumber) {
        classNames.push(dayPicker.classNames.with_weeknumber);
    }
    var style = __assign(__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps)
        .filter(function (key) { return key.startsWith('data-'); })
        .reduce(function (attrs, key) {
        var _a;
        return __assign(__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    return (React__default.createElement("div", __assign({ className: classNames.join(' '), style: style, dir: dayPicker.dir, id: dayPicker.id }, dataAttributes),
        React__default.createElement("div", { className: dayPicker.classNames.months, style: dayPicker.styles.months }, navigation.displayMonths.map(function (month, i) { return (React__default.createElement(Month, { key: i, displayIndex: i, displayMonth: month })); }))));
}

/** Provide the value for all the context providers. */
function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, ["children"]);
    return (React__default.createElement(DayPickerProvider, { initialProps: initialProps },
        React__default.createElement(NavigationProvider, null,
            React__default.createElement(SelectSingleProvider, { initialProps: initialProps },
                React__default.createElement(SelectMultipleProvider, { initialProps: initialProps },
                    React__default.createElement(SelectRangeProvider, { initialProps: initialProps },
                        React__default.createElement(ModifiersProvider, null,
                            React__default.createElement(FocusProvider, null, children))))))));
}

/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */
function DayPicker(props) {
    return (React__default.createElement(RootProvider, __assign({}, props),
        React__default.createElement(Root, { initialProps: props })));
}

/** @private */
function isValidDate(day) {
    return !isNaN(day.getTime());
}

/** Return props and setters for binding an input field to DayPicker. */
function useInput(options) {
    if (options === void 0) { options = {}; }
    var _a = options.locale, locale = _a === void 0 ? enUS : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? 'PP' : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function (value) { return parse(value, format$1, today, { locale: locale }); };
    // Initialize states
    var _e = useState(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = useState(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected
        ? format(defaultSelected, format$1, { locale: locale })
        : '';
    var _g = useState(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function () {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : '');
    };
    var setSelected = function (date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? format(date, format$1, { locale: locale }) : '');
    };
    var handleDayClick = function (day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue('');
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? format(day, format$1, { locale: locale }) : '');
    };
    var handleMonthChange = function (month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function (e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && differenceInCalendarDays(fromDate, day) > 0;
        var isAfter = toDate && differenceInCalendarDays(day, toDate) > 0;
        if (!isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function (e) {
        var day = parseValue(e.target.value);
        if (!isValidDate(day)) {
            reset();
        }
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function (e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if (isValidDate(day)) {
            setMonth(day);
        }
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: format(new Date(), format$1, { locale: locale })
    };
    return { dayPickerProps: dayPickerProps, inputProps: inputProps, reset: reset, setSelected: setSelected };
}

/** Returns true when the props are of type {@link DayPickerDefaultProps}. */
function isDayPickerDefault(props) {
    return props.mode === undefined || props.mode === 'default';
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 4607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _react=_interopRequireWildcard(__webpack_require__(2784));var _excluded=["placeholder","separator","isLastChild","inputStyle","focus","isDisabled","hasErrored","errorStyle","focusStyle","disabledStyle","shouldAutoFocus","isInputNum","index","value","className","isInputSecure"];function _getRequireWildcardCache(nodeInterop){if(typeof WeakMap!=="function")return null;var cacheBabelInterop=new WeakMap();var cacheNodeInterop=new WeakMap();return(_getRequireWildcardCache=function _getRequireWildcardCache(nodeInterop){return nodeInterop?cacheNodeInterop:cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj,nodeInterop){if(!nodeInterop&&obj&&obj.__esModule){return obj;}if(obj===null||_typeof(obj)!=="object"&&typeof obj!=="function"){return{"default":obj};}var cache=_getRequireWildcardCache(nodeInterop);if(cache&&cache.has(obj)){return cache.get(obj);}var newObj={};var hasPropertyDescriptor=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var key in obj){if(key!=="default"&&Object.prototype.hasOwnProperty.call(obj,key)){var desc=hasPropertyDescriptor?Object.getOwnPropertyDescriptor(obj,key):null;if(desc&&(desc.get||desc.set)){Object.defineProperty(newObj,key,desc);}else{newObj[key]=obj[key];}}}newObj["default"]=obj;if(cache){cache.set(obj,newObj);}return newObj;}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _objectWithoutProperties(source,excluded){if(source==null)return{};var target=_objectWithoutPropertiesLoose(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return{};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}var BACKSPACE=8;var LEFT_ARROW=37;var RIGHT_ARROW=39;var DELETE=46;var SPACEBAR=32;var isStyleObject=function isStyleObject(obj){return _typeof(obj)==='object';};var SingleOtpInput=function(_PureComponent){_inherits(SingleOtpInput,_PureComponent);var _super=_createSuper(SingleOtpInput);function SingleOtpInput(props){var _this;_classCallCheck(this,SingleOtpInput);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getClasses",function(){for(var _len=arguments.length,classes=new Array(_len),_key=0;_key<_len;_key++){classes[_key]=arguments[_key];}return classes.filter(function(c){return!isStyleObject(c)&&c!==false;}).join(' ');});_defineProperty(_assertThisInitialized(_this),"getType",function(){var _this$props=_this.props,isInputSecure=_this$props.isInputSecure,isInputNum=_this$props.isInputNum;if(isInputSecure){return'password';}if(isInputNum){return'tel';}return'text';});_this.input=_react["default"].createRef();return _this;}_createClass(SingleOtpInput,[{key:"componentDidMount",value:function componentDidMount(){var _this$props2=this.props,focus=_this$props2.focus,shouldAutoFocus=_this$props2.shouldAutoFocus;var inputEl=this.input.current;if(inputEl&&focus&&shouldAutoFocus){inputEl.focus();}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var focus=this.props.focus;var inputEl=this.input.current;if(prevProps.focus!==focus&&inputEl&&focus){inputEl.focus();inputEl.select();}}},{key:"render",value:function render(){var _this$props3=this.props,placeholder=_this$props3.placeholder,separator=_this$props3.separator,isLastChild=_this$props3.isLastChild,inputStyle=_this$props3.inputStyle,focus=_this$props3.focus,isDisabled=_this$props3.isDisabled,hasErrored=_this$props3.hasErrored,errorStyle=_this$props3.errorStyle,focusStyle=_this$props3.focusStyle,disabledStyle=_this$props3.disabledStyle,shouldAutoFocus=_this$props3.shouldAutoFocus,isInputNum=_this$props3.isInputNum,index=_this$props3.index,value=_this$props3.value,className=_this$props3.className,isInputSecure=_this$props3.isInputSecure,rest=_objectWithoutProperties(_this$props3,_excluded);return _react["default"].createElement("div",{className:className,style:{display:'flex',alignItems:'center'}},_react["default"].createElement("input",_extends({"aria-label":"".concat(index===0?'Please enter verification code. ':'').concat(isInputNum?'Digit':'Character'," ").concat(index+1),autoComplete:"off",style:Object.assign({width:'1em',textAlign:'center'},isStyleObject(inputStyle)&&inputStyle,focus&&isStyleObject(focusStyle)&&focusStyle,isDisabled&&isStyleObject(disabledStyle)&&disabledStyle,hasErrored&&isStyleObject(errorStyle)&&errorStyle),placeholder:placeholder,className:this.getClasses(inputStyle,focus&&focusStyle,isDisabled&&disabledStyle,hasErrored&&errorStyle),type:this.getType(),maxLength:"1",ref:this.input,disabled:isDisabled,value:value?value:''},rest)),!isLastChild&&separator);}}]);return SingleOtpInput;}(_react.PureComponent);var OtpInput=function(_Component){_inherits(OtpInput,_Component);var _super2=_createSuper(OtpInput);function OtpInput(){var _this2;_classCallCheck(this,OtpInput);for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}_this2=_super2.call.apply(_super2,[this].concat(args));_defineProperty(_assertThisInitialized(_this2),"state",{activeInput:0});_defineProperty(_assertThisInitialized(_this2),"getOtpValue",function(){return _this2.props.value?_this2.props.value.toString().split(''):[];});_defineProperty(_assertThisInitialized(_this2),"getPlaceholderValue",function(){var _this2$props=_this2.props,placeholder=_this2$props.placeholder,numInputs=_this2$props.numInputs;if(typeof placeholder==='string'){if(placeholder.length===numInputs){return placeholder;}if(placeholder.length>0){console.error('Length of the placeholder should be equal to the number of inputs.');}}});_defineProperty(_assertThisInitialized(_this2),"handleOtpChange",function(otp){var onChange=_this2.props.onChange;var otpValue=otp.join('');onChange(otpValue);});_defineProperty(_assertThisInitialized(_this2),"isInputValueValid",function(value){var isTypeValid=_this2.props.isInputNum?!isNaN(parseInt(value,10)):typeof value==='string';return isTypeValid&&value.trim().length===1;});_defineProperty(_assertThisInitialized(_this2),"focusInput",function(input){var numInputs=_this2.props.numInputs;var activeInput=Math.max(Math.min(numInputs-1,input),0);_this2.setState({activeInput:activeInput});});_defineProperty(_assertThisInitialized(_this2),"focusNextInput",function(){var activeInput=_this2.state.activeInput;_this2.focusInput(activeInput+1);});_defineProperty(_assertThisInitialized(_this2),"focusPrevInput",function(){var activeInput=_this2.state.activeInput;_this2.focusInput(activeInput-1);});_defineProperty(_assertThisInitialized(_this2),"changeCodeAtFocus",function(value){var activeInput=_this2.state.activeInput;var otp=_this2.getOtpValue();otp[activeInput]=value[0];_this2.handleOtpChange(otp);});_defineProperty(_assertThisInitialized(_this2),"handleOnPaste",function(e){e.preventDefault();var activeInput=_this2.state.activeInput;var _this2$props2=_this2.props,numInputs=_this2$props2.numInputs,isDisabled=_this2$props2.isDisabled;if(isDisabled){return;}var otp=_this2.getOtpValue();var nextActiveInput=activeInput;var pastedData=e.clipboardData.getData('text/plain').slice(0,numInputs-activeInput).split('');for(var pos=0;pos<numInputs;++pos){if(pos>=activeInput&&pastedData.length>0){otp[pos]=pastedData.shift();nextActiveInput++;}}_this2.setState({activeInput:nextActiveInput},function(){_this2.focusInput(nextActiveInput);_this2.handleOtpChange(otp);});});_defineProperty(_assertThisInitialized(_this2),"handleOnChange",function(e){var value=e.target.value;if(_this2.isInputValueValid(value)){_this2.changeCodeAtFocus(value);}});_defineProperty(_assertThisInitialized(_this2),"handleOnKeyDown",function(e){if(e.keyCode===BACKSPACE||e.key==='Backspace'){e.preventDefault();_this2.changeCodeAtFocus('');_this2.focusPrevInput();}else if(e.keyCode===DELETE||e.key==='Delete'){e.preventDefault();_this2.changeCodeAtFocus('');}else if(e.keyCode===LEFT_ARROW||e.key==='ArrowLeft'){e.preventDefault();_this2.focusPrevInput();}else if(e.keyCode===RIGHT_ARROW||e.key==='ArrowRight'){e.preventDefault();_this2.focusNextInput();}else if(e.keyCode===SPACEBAR||e.key===' '||e.key==='Spacebar'||e.key==='Space'){e.preventDefault();}});_defineProperty(_assertThisInitialized(_this2),"handleOnInput",function(e){if(_this2.isInputValueValid(e.target.value)){_this2.focusNextInput();}else{if(!_this2.props.isInputNum){var nativeEvent=e.nativeEvent;if(nativeEvent.data===null&&nativeEvent.inputType==='deleteContentBackward'){e.preventDefault();_this2.changeCodeAtFocus('');_this2.focusPrevInput();}}}});_defineProperty(_assertThisInitialized(_this2),"renderInputs",function(){var activeInput=_this2.state.activeInput;var _this2$props3=_this2.props,numInputs=_this2$props3.numInputs,inputStyle=_this2$props3.inputStyle,focusStyle=_this2$props3.focusStyle,separator=_this2$props3.separator,isDisabled=_this2$props3.isDisabled,disabledStyle=_this2$props3.disabledStyle,hasErrored=_this2$props3.hasErrored,errorStyle=_this2$props3.errorStyle,shouldAutoFocus=_this2$props3.shouldAutoFocus,isInputNum=_this2$props3.isInputNum,isInputSecure=_this2$props3.isInputSecure,className=_this2$props3.className;var inputs=[];var otp=_this2.getOtpValue();var placeholder=_this2.getPlaceholderValue();var dataCy=_this2.props['data-cy'];var dataTestId=_this2.props['data-testid'];var _loop=function _loop(i){inputs.push(_react["default"].createElement(SingleOtpInput,{placeholder:placeholder&&placeholder[i],key:i,index:i,focus:activeInput===i,value:otp&&otp[i],onChange:_this2.handleOnChange,onKeyDown:_this2.handleOnKeyDown,onInput:_this2.handleOnInput,onPaste:_this2.handleOnPaste,onFocus:function onFocus(e){_this2.setState({activeInput:i});e.target.select();},onBlur:function onBlur(){return _this2.setState({activeInput:-1});},separator:separator,inputStyle:inputStyle,focusStyle:focusStyle,isLastChild:i===numInputs-1,isDisabled:isDisabled,disabledStyle:disabledStyle,hasErrored:hasErrored,errorStyle:errorStyle,shouldAutoFocus:shouldAutoFocus,isInputNum:isInputNum,isInputSecure:isInputSecure,className:className,"data-cy":dataCy&&"".concat(dataCy,"-").concat(i),"data-testid":dataTestId&&"".concat(dataTestId,"-").concat(i)}));};for(var i=0;i<numInputs;i++){_loop(i);}return inputs;});return _this2;}_createClass(OtpInput,[{key:"render",value:function render(){var containerStyle=this.props.containerStyle;return _react["default"].createElement("div",{style:Object.assign({display:'flex'},isStyleObject(containerStyle)&&containerStyle),className:!isStyleObject(containerStyle)?containerStyle:''},this.renderInputs());}}]);return OtpInput;}(_react.Component);_defineProperty(OtpInput,"defaultProps",{numInputs:4,onChange:function onChange(otp){return console.log(otp);},isDisabled:false,shouldAutoFocus:false,value:'',isInputSecure:false});var _default=OtpInput;exports.Z=_default;

/***/ }),

/***/ 3420:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: ArrowKeyStepper, AutoSizer, CellMeasurer, CellMeasurerCache, Collection, Column, ColumnSizer, Grid, InfiniteLoader, List, Masonry, MultiGrid, ScrollSync, SortDirection, SortIndicator, Table, WindowScroller, accessibilityOverscanIndicesGetter, createMasonryCellPositioner, createTableMultiSort, defaultCellRangeRenderer, defaultOverscanIndicesGetter, defaultTableCellDataGetter, defaultTableCellRenderer, defaultTableHeaderRenderer, defaultTableHeaderRowRenderer, defaultTableRowRenderer

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function classCallCheck_classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js + 1 modules
var toPropertyKey = __webpack_require__(2802);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,toPropertyKey/* default */.Z)(o.key), o);
  }
}
function createClass_createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(6522);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,esm_typeof/* default */.Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(6666);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
;// CONCATENATED MODULE: ../../node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/calculateSizeAndPositionDataAndUpdateScrollOffset.js
/**
 * Helper method that determines when to recalculate row or column metadata.
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.

    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1461);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,objectWithoutPropertiesLoose/* default */.Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/types.js


var bpfrpt_proptype_CellPosition =  true ? null : 0;
var bpfrpt_proptype_CellRendererParams =  true ? null : 0;
var bpfrpt_proptype_CellRenderer =  true ? null : 0;
var bpfrpt_proptype_CellCache =  true ? null : 0;
var bpfrpt_proptype_StyleCache =  true ? null : 0;
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : 0;
var bpfrpt_proptype_CellRangeRenderer =  true ? null : 0;
var bpfrpt_proptype_CellSizeGetter =  true ? null : 0;
var bpfrpt_proptype_CellSize =  true ? null : 0;
var bpfrpt_proptype_NoContentRenderer =  true ? null : 0;
var bpfrpt_proptype_Scroll =  true ? null : 0;
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : 0;
var bpfrpt_proptype_RenderedSection =  true ? null : 0;
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : 0;
var bpfrpt_proptype_OverscanIndices =  true ? null : 0;
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : 0;
var bpfrpt_proptype_Alignment =  true ? null : 0;
var bpfrpt_proptype_VisibleCellRange =  true ? null : 0;



















;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/CellSizeAndPositionManager.js




/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager =
/*#__PURE__*/
function () {
  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
  // Used in deferred mode to track which cells have been queued for measurement.
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    classCallCheck_classCallCheck(this, CellSizeAndPositionManager);

    (0,defineProperty/* default */.Z)(this, "_cellSizeAndPositionData", {});

    (0,defineProperty/* default */.Z)(this, "_lastMeasuredIndex", -1);

    (0,defineProperty/* default */.Z)(this, "_lastBatchedIndex", -1);

    (0,defineProperty/* default */.Z)(this, "_cellCount", void 0);

    (0,defineProperty/* default */.Z)(this, "_cellSizeGetter", void 0);

    (0,defineProperty/* default */.Z)(this, "_estimatedCellSize", void 0);

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  createClass_createClass(CellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var size = this._cellSizeGetter({
            index: i
          }); // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.


          if (size === undefined || isNaN(size)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
          } else if (size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: 0
            };
            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: size
            };
            offset += size;
            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;

        case 'end':
          idealOffset = minOffset;
          break;

        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;

        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;
      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;

      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;
      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;
        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      } // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.


      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();





;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/maxElementSize.js
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }

  return DEFAULT_MAX_ELEMENT_SIZE;
};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/ScalingCellSizeAndPositionManager.js







/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager =
/*#__PURE__*/
function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === void 0 ? getMaxElementSize() : _ref$maxScrollSize,
        params = _objectWithoutProperties(_ref, ["maxScrollSize"]);

    classCallCheck_classCallCheck(this, ScalingCellSizeAndPositionManager);

    (0,defineProperty/* default */.Z)(this, "_cellSizeAndPositionManager", void 0);

    (0,defineProperty/* default */.Z)(this, "_maxScrollSize", void 0);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new CellSizeAndPositionManager(params);
    this._maxScrollSize = maxScrollSize;
  }

  createClass_createClass(ScalingCellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;
      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();





;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/createCallbackMemoizer.js
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var cachedIndices = {};
  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;
    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });
    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/defaultOverscanIndicesGetter.js
var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/updateScrollIndexHelper.js

/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.

  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/defaultCellRangeRenderer.js
/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;
  var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.

  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.

      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };
      var renderedCell = void 0; // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028

      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {}

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {}
}


;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/canUseDOM.js
/* harmony default export */ var canUseDOM = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));
;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/animationFrame.js
// Properly handle server-side rendering.
var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
} // requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/


var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/requestAnimationTimeout.js

var bpfrpt_proptype_AnimationTimeoutId =  true ? null : 0;
var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return caf(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */

var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start; // wait for end of processing current event handler, because event handler may be long

  Promise.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = raf(timeout);
    }
  };

  var frame = {
    id: raf(timeout)
  };
  return frame;
};


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/Grid.js









var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    var _this;

    classCallCheck_classCallCheck(this, Grid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Grid).call(this, props));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onGridRenderedMemoizer", createCallbackMemoizer());

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScrollMemoizer", createCallbackMemoizer(false));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_deferredInvalidateColumnIndex", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_deferredInvalidateRowIndex", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_recomputeScrollLeftFlag", false);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_recomputeScrollTopFlag", false);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_horizontalScrollBarSize", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_verticalScrollBarSize", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_scrollbarPresenceChanged", false);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_scrollingContainer", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_childrenToDisplay", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_columnStartIndex", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_columnStopIndex", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_rowStartIndex", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_rowStopIndex", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderedColumnStartIndex", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderedColumnStopIndex", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderedRowStartIndex", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderedRowStopIndex", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_initialScrollTop", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_initialScrollLeft", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_disablePointerEventsTimeoutId", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_styleCache", {});

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_cellCache", {});

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_debounceScrollEndedCallback", function () {
      _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache

      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_invokeOnGridRenderedHelper", function () {
      var onSectionRendered = _this.props.onSectionRendered;

      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    });

    var columnSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: SCROLL_DIRECTION_FORWARD,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }

    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }

    return _this;
  }
  /**
   * Gets offsets for a given cell and alignment.
   */


  createClass_createClass(Grid, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = _objectSpread({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }
    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      this._debounceScrollEnded();

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          autoWidth = _this$props.autoWidth,
          height = _this$props.height,
          width = _this$props.width;
      var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;

      var _this$props3 = this.props,
          scrollToColumn = _this$props3.scrollToColumn,
          scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.

      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.

      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */

  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.

      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(_objectSpread({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(_objectSpread({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          getScrollbarSize = _this$props4.getScrollbarSize,
          height = _this$props4.height,
          scrollLeft = _this$props4.scrollLeft,
          scrollToColumn = _this$props4.scrollToColumn,
          scrollTop = _this$props4.scrollTop,
          scrollToRow = _this$props4.scrollToRow,
          width = _this$props4.width;
      var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.


      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = _objectSpread({}, prevState, {
            needToResetStyleCache: false
          });

          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      } // refs don't work in `react-test-renderer`


      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }

        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.


      var sizeIsBiggerThanZero = height > 0 && width > 0;

      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }

      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      } // Update onRowsRendered callback


      this._invokeOnGridRenderedHelper(); // Initialize onScroll callback


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props5 = this.props,
          autoHeight = _this$props5.autoHeight,
          autoWidth = _this$props5.autoWidth,
          columnCount = _this$props5.columnCount,
          height = _this$props5.height,
          rowCount = _this$props5.rowCount,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToColumn = _this$props5.scrollToColumn,
          scrollToRow = _this$props5.scrollToRow,
          width = _this$props5.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
          scrollTop = _this$state.scrollTop,
          instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218


      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.


      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?

      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;

        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;

        this._updateScrollTopForScrollToRow(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners


      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoContainerWidth = _this$props6.autoContainerWidth,
          autoHeight = _this$props6.autoHeight,
          autoWidth = _this$props6.autoWidth,
          className = _this$props6.className,
          containerProps = _this$props6.containerProps,
          containerRole = _this$props6.containerRole,
          containerStyle = _this$props6.containerStyle,
          height = _this$props6.height,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          role = _this$props6.role,
          style = _this$props6.style,
          tabIndex = _this$props6.tabIndex,
          width = _this$props6.width;
      var _this$state2 = this.state,
          instanceProps = _this$state2.instanceProps,
          needToResetStyleCache = _this$state2.needToResetStyleCache;

      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      } // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset


      if (!this.state.isScrolling) {
        this._resetStyleCache();
      } // calculate children to render here


      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      } // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23


      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return react.createElement("div", (0,esm_extends/* default */.Z)({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props['aria-label'],
        "aria-readonly": this.props['aria-readonly'],
        className: clsx_m('ReactVirtualized__Grid', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: _objectSpread({}, gridStyle, {}, style),
        tabIndex: tabIndex
      }), childrenToDisplay.length > 0 && react.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: _objectSpread({
          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.

      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        }); // Store for _invokeOnGridRenderedHelper()

        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        }); // Store for _invokeOnGridRenderedHelper()

        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.

        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          } // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).


          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        }); // update the indices

        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._disablePointerEventsTimeoutId) {
        cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = requestAnimationTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.

      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;

      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      } // If scrolling is controlled outside this component, clear cache when scrolling stops


      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }

      var maybeStateA;
      var maybeStateB;
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)

      instanceProps.scrollbarSize = nextProps.getScrollbarSize();

      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;
      return _objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",

    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }

      return {};
    }
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;

      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }

      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;

      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }

      return {};
    }
  }]);

  return Grid;
}(react.PureComponent), (0,defineProperty/* default */.Z)(_class, "propTypes",  true ? null : 0), _temp);

(0,defineProperty/* default */.Z)(Grid, "defaultProps", {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: defaultCellRangeRenderer,
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: scrollbarSize,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});

polyfill(Grid);
/* harmony default export */ var Grid_Grid = (Grid);















;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/accessibilityOverscanIndicesGetter.js
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_BACKWARD = (/* unused pure expression or super */ null && (-1));
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_FORWARD = 1;
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;
  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/index.js





















;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ArrowKeyStepper/types.js
var bpfrpt_proptype_ScrollIndices =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ArrowKeyStepper/ArrowKeyStepper.js








var ArrowKeyStepper_class, ArrowKeyStepper_temp;

function ArrowKeyStepper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ArrowKeyStepper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ArrowKeyStepper_ownKeys(source, true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ArrowKeyStepper_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = (ArrowKeyStepper_temp = ArrowKeyStepper_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, ArrowKeyStepper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ArrowKeyStepper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", {
      scrollToColumn: 0,
      scrollToRow: 0,
      instanceProps: {
        prevScrollToColumn: 0,
        prevScrollToRow: 0
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_columnStartIndex", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_columnStopIndex", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_rowStartIndex", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_rowStopIndex", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onKeyDown", function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;

      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow; // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;

        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;

        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;

        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onSectionRendered", function (_ref) {
      var columnStartIndex = _ref.columnStartIndex,
          columnStopIndex = _ref.columnStopIndex,
          rowStartIndex = _ref.rowStartIndex,
          rowStopIndex = _ref.rowStopIndex;
      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    });

    return _this;
  }

  createClass_createClass(ArrowKeyStepper, [{
    key: "setScrollIndexes",
    value: function setScrollIndexes(_ref2) {
      var scrollToColumn = _ref2.scrollToColumn,
          scrollToRow = _ref2.scrollToRow;
      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children;

      var _this$_getScrollState3 = this._getScrollState(),
          scrollToColumn = _this$_getScrollState3.scrollToColumn,
          scrollToRow = _this$_getScrollState3.scrollToRow;

      return react.createElement("div", {
        className: className,
        onKeyDown: this._onKeyDown
      }, children({
        onSectionRendered: this._onSectionRendered,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow
      }));
    }
  }, {
    key: "_getScrollState",
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: "_updateScrollState",
    value: function _updateScrollState(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;
      var _this$props3 = this.props,
          isControlled = _this$props3.isControlled,
          onScrollToChange = _this$props3.onScrollToChange;

      if (typeof onScrollToChange === 'function') {
        onScrollToChange({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }

      if (!isControlled) {
        this.setState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return {};
      }

      if (nextProps.scrollToColumn !== prevState.instanceProps.prevScrollToColumn || nextProps.scrollToRow !== prevState.instanceProps.prevScrollToRow) {
        return ArrowKeyStepper_objectSpread({}, prevState, {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow,
          instanceProps: {
            prevScrollToColumn: nextProps.scrollToColumn,
            prevScrollToRow: nextProps.scrollToRow
          }
        });
      }

      return {};
    }
  }]);

  return ArrowKeyStepper;
}(react.PureComponent), (0,defineProperty/* default */.Z)(ArrowKeyStepper_class, "propTypes",  true ? null : 0), ArrowKeyStepper_temp);

(0,defineProperty/* default */.Z)(ArrowKeyStepper, "defaultProps", {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
});

polyfill(ArrowKeyStepper);
/* harmony default export */ var ArrowKeyStepper_ArrowKeyStepper = ((/* unused pure expression or super */ null && (ArrowKeyStepper)));



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ArrowKeyStepper/index.js




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/vendor/detectElementResize.js
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/
function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;

  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = __webpack_require__.g;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };

      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);

      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }

      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;

          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };
    /* Detect CSS Animations support to detect element display/re-attach */


    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');

      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;

        var elementStyle = _window.getComputedStyle(element);

        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }

        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';

        if (window.trustedTypes) {
          var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
            createHTML: function createHTML() {
              return resizeTriggersHtml;
            }
          });
          element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
        } else {
          element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
        }

        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        /* Listen for a css animation to detect element display/re-attach */

        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };

          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }

      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);

      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);

        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);

          element.__resizeTriggers__.__animationListener__ = null;
        }

        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {// Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/AutoSizer/AutoSizer.js








var AutoSizer_class, AutoSizer_temp;

function AutoSizer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AutoSizer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AutoSizer_ownKeys(source, true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AutoSizer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var AutoSizer = (AutoSizer_temp = AutoSizer_class =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AutoSizer, _React$Component);

  function AutoSizer() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, AutoSizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AutoSizer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_parentNode", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_autoSizer", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_window", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_detectElementResize", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onResize", function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;

      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.
        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win = _this._window || window;
        var style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });

          onResize({
            height: height,
            width: width
          });
        }
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_setRef", function (autoSizer) {
      _this._autoSizer = autoSizer;
    });

    return _this;
  }

  createClass_createClass(AutoSizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41

        this._detectElementResize = createDetectElementResize(nonce, this._window);

        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disableHeight = _this$props2.disableHeight,
          disableWidth = _this$props2.disableWidth,
          style = _this$props2.style;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = {
        overflow: 'visible'
      };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }
      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */


      return react.createElement("div", {
        className: className,
        ref: this._setRef,
        style: AutoSizer_objectSpread({}, outerStyle, {}, style)
      }, children(childParams));
    }
  }]);

  return AutoSizer;
}(react.Component), (0,defineProperty/* default */.Z)(AutoSizer_class, "propTypes",  true ? null : 0), AutoSizer_temp);

(0,defineProperty/* default */.Z)(AutoSizer, "defaultProps", {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
});



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/AutoSizer/index.js


// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/types.js
var bpfrpt_proptype_CellMeasureCache =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/CellMeasurer.js








var CellMeasurer_class, CellMeasurer_temp;




/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer_CellMeasurer = (CellMeasurer_temp = CellMeasurer_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, CellMeasurer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CellMeasurer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_child", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_measure", function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('CellMeasurer registerChild expects to be passed Element or null');
      }

      _this._child = element;

      if (element) {
        _this._maybeMeasureCell();
      }
    });

    return _this;
  }

  createClass_createClass(CellMeasurer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return typeof children === 'function' ? children({
        measure: this._measure,
        registerChild: this._registerChild
      }) : children;
    }
  }, {
    key: "_getCellMeasurements",
    value: function _getCellMeasurements() {
      var cache = this.props.cache;
      var node = this._child || (0,react_dom.findDOMNode)(this); // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height; // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.

        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }

        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth); // Reset after measuring to avoid breaking styles; see #660

        if (styleWidth) {
          node.style.width = styleWidth;
        }

        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return {
          height: height,
          width: width
        };
      } else {
        return {
          height: 0,
          width: 0
        };
      }
    }
  }, {
    key: "_maybeMeasureCell",
    value: function _maybeMeasureCell() {
      var _this$props2 = this.props,
          cache = _this$props2.cache,
          _this$props2$columnIn = _this$props2.columnIndex,
          columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn,
          parent = _this$props2.parent,
          _this$props2$rowIndex = _this$props2.rowIndex,
          rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;

      if (!cache.has(rowIndex, columnIndex)) {
        var _this$_getCellMeasure2 = this._getCellMeasurements(),
            height = _this$_getCellMeasure2.height,
            width = _this$_getCellMeasure2.width;

        cache.set(rowIndex, columnIndex, width, height); // If size has changed, let Grid know to re-render.

        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(react.PureComponent), (0,defineProperty/* default */.Z)(CellMeasurer_class, "propTypes",  true ? null : 0), CellMeasurer_temp); // Used for DEV mode warning check

(0,defineProperty/* default */.Z)(CellMeasurer_CellMeasurer, "__internalCellMeasurerFlag", false);



if (false) {}



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/CellMeasurerCache.js



var DEFAULT_HEIGHT = 30;
var DEFAULT_WIDTH = 100; // Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache =
/*#__PURE__*/
(/* unused pure expression or super */ null && (function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CellMeasurerCache);

    _defineProperty(this, "_cellHeightCache", {});

    _defineProperty(this, "_cellWidthCache", {});

    _defineProperty(this, "_columnWidthCache", {});

    _defineProperty(this, "_rowHeightCache", {});

    _defineProperty(this, "_defaultHeight", void 0);

    _defineProperty(this, "_defaultWidth", void 0);

    _defineProperty(this, "_minHeight", void 0);

    _defineProperty(this, "_minWidth", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    _defineProperty(this, "_hasFixedHeight", void 0);

    _defineProperty(this, "_hasFixedWidth", void 0);

    _defineProperty(this, "_columnCount", 0);

    _defineProperty(this, "_rowCount", 0);

    _defineProperty(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
    });

    _defineProperty(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
    });

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;
    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;
    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {}
  }

  _createClass(CellMeasurerCache, [{
    key: "clear",
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache[key] !== undefined;
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }

      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      } // Size is cached per cell so we don't have to re-measure if cells are re-ordered.


      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "_updateCachedColumnAndRowSizes",
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;

        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }

        var columnKey = this._keyMapper(0, columnIndex);

        this._columnWidthCache[columnKey] = columnWidth;
      }

      if (!this._hasFixedHeight) {
        var rowHeight = 0;

        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }

        var rowKey = this._keyMapper(rowIndex, 0);

        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}()));



function defaultKeyMapper(rowIndex, columnIndex) {
  return "".concat(rowIndex, "-").concat(columnIndex);
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/index.js


/* harmony default export */ var es_CellMeasurer = ((/* unused pure expression or super */ null && (CellMeasurer)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/CollectionView.js








function CollectionView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CollectionView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CollectionView_ownKeys(source, true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CollectionView_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






 // @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var IS_SCROLLING_TIMEOUT = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

var CollectionView_SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};
/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CollectionView, _React$PureComponent);

  // Invokes callbacks only when their values have changed.
  function CollectionView() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, CollectionView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CollectionView)).call.apply(_getPrototypeOf2, [this].concat(args))); // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_calculateSizeAndPositionDataOnNextUpdate", false);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onSectionRenderedMemoizer", createCallbackMemoizer());

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScrollMemoizer", createCallbackMemoizer(false));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_invokeOnSectionRenderedHelper", function () {
      var _this$props = _this.props,
          cellLayoutManager = _this$props.cellLayoutManager,
          onSectionRendered = _this$props.onSectionRendered;

      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_updateScrollPositionForScrollToCell", function () {
      var _this$props2 = _this.props,
          cellLayoutManager = _this$props2.cellLayoutManager,
          height = _this$props2.height,
          scrollToAlignment = _this$props2.scrollToAlignment,
          scrollToCell = _this$props2.scrollToCell,
          width = _this$props2.width;
      var _this$state = _this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;

      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      _this._enablePointerEventsAfterDelay(); // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.


      var _this$props3 = _this.props,
          cellLayoutManager = _this$props3.cellLayoutManager,
          height = _this$props3.height,
          isScrollingChange = _this$props3.isScrollingChange,
          width = _this$props3.width;
      var scrollbarSize = _this._scrollbarSize;

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop)); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? CollectionView_SCROLL_POSITION_CHANGE_REASONS.OBSERVED : CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED; // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)

        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    });

    _this._scrollbarSize = scrollbarSize();

    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }

    return _this;
  }
  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  createClass_createClass(CollectionView, [{
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }
    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          cellLayoutManager = _this$props4.cellLayoutManager,
          scrollLeft = _this$props4.scrollLeft,
          scrollToCell = _this$props4.scrollToCell,
          scrollTop = _this$props4.scrollTop; // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = scrollbarSize();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      } // Update onSectionRendered callback.


      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width; // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props5 = this.props,
          height = _this$props5.height,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToCell = _this$props5.scrollToCell,
          width = _this$props5.width;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollPositionChangeReason = _this$state2.scrollPositionChangeReason,
          scrollTop = _this$state2.scrollTop; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Update scroll offsets if the current :scrollToCell values requires it


      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoHeight = _this$props6.autoHeight,
          cellCount = _this$props6.cellCount,
          cellLayoutManager = _this$props6.cellLayoutManager,
          className = _this$props6.className,
          height = _this$props6.height,
          horizontalOverscanSize = _this$props6.horizontalOverscanSize,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          style = _this$props6.style,
          verticalOverscanSize = _this$props6.verticalOverscanSize,
          width = _this$props6.width;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollLeft = _this$state3.scrollLeft,
          scrollTop = _this$state3.scrollTop; // Memoization reset

      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;
        cellLayoutManager.calculateSizeAndPositionData();
      }

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width; // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];
      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      }; // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0; // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23

      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      return react.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: clsx_m('ReactVirtualized__Collection', className),
        id: id,
        onScroll: this._onScroll,
        role: "grid",
        style: CollectionView_objectSpread({}, collectionStyle, {}, style),
        tabIndex: 0
      }, cellCount > 0 && react.createElement("div", {
        className: "ReactVirtualized__Collection__innerScrollContainer",
        style: {
          height: totalHeight,
          maxHeight: totalHeight,
          maxWidth: totalWidth,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          width: totalWidth
        }
      }, childrenToDisplay), cellCount === 0 && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_enablePointerEventsAfterDelay",
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;
        isScrollingChange(false);
        _this2._disablePointerEventsTimeoutId = null;

        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref) {
      var _this3 = this;

      var scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          totalHeight = _ref.totalHeight,
          totalWidth = _ref.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref2) {
          var scrollLeft = _ref2.scrollLeft,
              scrollTop = _ref2.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_setScrollPosition",
    value: function _setScrollPosition(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;
      var newState = {
        scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0,
          scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop,
          scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
      }

      return null;
    }
  }]);

  return CollectionView;
}(react.PureComponent);

(0,defineProperty/* default */.Z)(CollectionView, "defaultProps", {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
});

CollectionView.propTypes =  false ? 0 : {};
polyfill(CollectionView);
/* harmony default export */ var Collection_CollectionView = (CollectionView);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/types.js
var bpfrpt_proptype_Index =  true ? null : 0;
var bpfrpt_proptype_PositionInfo =  true ? null : 0;
var bpfrpt_proptype_ScrollPosition =  true ? null : 0;
var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : 0;
var bpfrpt_proptype_SizeInfo =  true ? null : 0;






;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/Section.js



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section =
/*#__PURE__*/
function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    classCallCheck_classCallCheck(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;
    this._indexMap = {};
    this._indices = [];
  }
  /** Add a cell to this section. */


  createClass_createClass(Section, [{
    key: "addCellIndex",
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;

        this._indices.push(index);
      }
    }
    /** Get all cell indices that have been added to this section. */

  }, {
    key: "getCellIndices",
    value: function getCellIndices() {
      return this._indices;
    }
    /** Intended for debugger/test purposes only */

  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
    }
  }]);

  return Section;
}();




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/SectionManager.js



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */

var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager =
/*#__PURE__*/
function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    classCallCheck_classCallCheck(this, SectionManager);

    this._sectionSize = sectionSize;
    this._cellMetadata = [];
    this._sections = {};
  }
  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  createClass_createClass(SectionManager, [{
    key: "getCellIndices",
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;
      var indices = {};
      this.getSections({
        height: height,
        width: width,
        x: x,
        y: y
      }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      }); // Object keys are strings; this function returns numbers

      return Object.keys(indices).map(function (index) {
        return indices[index];
      });
    }
    /** Get size and position information for the cell specified. */

  }, {
    key: "getCellMetadata",
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;
      return this._cellMetadata[index];
    }
    /** Get all Sections overlapping the specified region. */

  }, {
    key: "getSections",
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;
      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = "".concat(sectionX, ".").concat(sectionY);

          if (!this._sections[key]) {
            this._sections[key] = new Section({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }
    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: "getTotalSectionCount",
    value: function getTotalSectionCount() {
      return Object.keys(this._sections).length;
    }
    /** Intended for debugger/test purposes only */

  }, {
    key: "toString",
    value: function toString() {
      var _this = this;

      return Object.keys(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }
    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: "registerCell",
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;
      this._cellMetadata[index] = cellMetadatum;
      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({
          index: index
        });
      });
    }
  }]);

  return SectionManager;
}();




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/utils/calculateSizeAndPositionData.js

function calculateSizeAndPositionData_calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;
  var cellMetadata = [];
  var sectionManager = new SectionManager(sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({
      index: index
    });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error("Invalid metadata returned for cell ".concat(index, ":\n        x:").concat(cellMetadatum.x, ", y:").concat(cellMetadatum.y, ", width:").concat(cellMetadatum.width, ", height:").concat(cellMetadatum.height));
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/getUpdatedOffsetForIndex.js
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;
  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;

    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/Collection.js














/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection_Collection =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Collection, _React$PureComponent);

  function Collection(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, Collection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collection).call(this, props, context));
    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = []; // Cell cache during scroll (for performance)

    _this._cellCache = [];
    _this._isScrollingChange = _this._isScrollingChange.bind(_assertThisInitialized(_this));
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(Collection, [{
    key: "forceUpdate",
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }
    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];

      this._collectionView.recomputeCellSizesAndPositions();
    }
    /** React lifecycle methods */

  }, {
    key: "render",
    value: function render() {
      var props = (0,esm_extends/* default */.Z)({}, this.props);

      return react.createElement(Collection_CollectionView, (0,esm_extends/* default */.Z)({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }
    /** CellLayoutManager interface */

  }, {
    key: "calculateSizeAndPositionData",
    value: function calculateSizeAndPositionData() {
      var _this$props = this.props,
          cellCount = _this$props.cellCount,
          cellSizeAndPositionGetter = _this$props.cellSizeAndPositionGetter,
          sectionSize = _this$props.sectionSize;

      var data = calculateSizeAndPositionData_calculateSizeAndPositionData({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }
    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: "getLastRenderedIndices",
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }
    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: "getScrollPositionForCell",
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;

      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];
        scrollLeft = getUpdatedOffsetForIndex({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });
        scrollTop = getUpdatedOffsetForIndex({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: "cellRenderers",
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _this$props2 = this.props,
          cellGroupRenderer = _this$props2.cellGroupRenderer,
          cellRenderer = _this$props2.cellRenderer; // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });
      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({
            index: index
          });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: "_isScrollingChange",
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: "_setCollectionViewRef",
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(react.PureComponent);

(0,defineProperty/* default */.Z)(Collection_Collection, "defaultProps", {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
});


Collection_Collection.propTypes =  false ? 0 : {};

function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;
  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({
      index: index
    });
    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    }; // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.

    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/index.js

/* harmony default export */ var es_Collection = ((/* unused pure expression or super */ null && (Collection)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ColumnSizer/ColumnSizer.js








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer_ColumnSizer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ColumnSizer, _React$PureComponent);

  function ColumnSizer(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, ColumnSizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColumnSizer).call(this, props, context));
    _this._registerChild = _this._registerChild.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(ColumnSizer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          columnMaxWidth = _this$props.columnMaxWidth,
          columnMinWidth = _this$props.columnMinWidth,
          columnCount = _this$props.columnCount,
          width = _this$props.width;

      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          columnMaxWidth = _this$props2.columnMaxWidth,
          columnMinWidth = _this$props2.columnMinWidth,
          columnCount = _this$props2.columnCount,
          width = _this$props2.width;
      var safeColumnMinWidth = columnMinWidth || 1;
      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);
      var adjustedWidth = Math.min(width, columnWidth * columnCount);
      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(react.PureComponent);


ColumnSizer_ColumnSizer.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ColumnSizer/index.js

/* harmony default export */ var es_ColumnSizer = ((/* unused pure expression or super */ null && (ColumnSizer)));

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/InfiniteLoader/InfiniteLoader.js











/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader_InfiniteLoader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(InfiniteLoader, _React$PureComponent);

  function InfiniteLoader(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, InfiniteLoader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InfiniteLoader).call(this, props, context));
    _this._loadMoreRowsMemoizer = createCallbackMemoizer();
    _this._onRowsRendered = _this._onRowsRendered.bind(_assertThisInitialized(_this));
    _this._registerChild = _this._registerChild.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(InfiniteLoader, [{
    key: "resetLoadMoreRowsCache",
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = createCallbackMemoizer();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;
      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);

        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: "_onRowsRendered",
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;
      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: "_doStuff",
    value: function _doStuff(startIndex, stopIndex) {
      var _ref2,
          _this3 = this;

      var _this$props = this.props,
          isRowLoaded = _this$props.isRowLoaded,
          minimumBatchSize = _this$props.minimumBatchSize,
          rowCount = _this$props.rowCount,
          threshold = _this$props.threshold;
      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      }); // For memoize comparison

      var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(unloadedRanges.map(function (_ref3) {
        var startIndex = _ref3.startIndex,
            stopIndex = _ref3.stopIndex;
        return [startIndex, stopIndex];
      })));

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: {
          squashedUnloadedRanges: squashedUnloadedRanges
        }
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(react.PureComponent);
/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


(0,defineProperty/* default */.Z)(InfiniteLoader_InfiniteLoader, "defaultProps", {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
});


InfiniteLoader_InfiniteLoader.propTypes =  false ? 0 : {};
function isRangeVisible(_ref4) {
  var lastRenderedStartIndex = _ref4.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref4.lastRenderedStopIndex,
      startIndex = _ref4.startIndex,
      stopIndex = _ref4.stopIndex;
  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */

function scanForUnloadedRanges(_ref5) {
  var isRowLoaded = _ref5.isRowLoaded,
      minimumBatchSize = _ref5.minimumBatchSize,
      rowCount = _ref5.rowCount,
      startIndex = _ref5.startIndex,
      stopIndex = _ref5.stopIndex;
  var unloadedRanges = [];
  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({
      index: index
    });

    if (!loaded) {
      rangeStopIndex = index;

      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });
      rangeStartIndex = rangeStopIndex = null;
    }
  } // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.


  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({
        index: _index
      })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  } // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.


  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({
        index: _index2
      })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}
/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */

function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/InfiniteLoader/index.js

/* harmony default export */ var es_InfiniteLoader = ((/* unused pure expression or super */ null && (InfiniteLoader)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/List/types.js

var bpfrpt_proptype_RowRendererParams =  true ? null : 0;
var bpfrpt_proptype_RowRenderer =  true ? null : 0;
var bpfrpt_proptype_RenderedRows =  true ? null : 0;
var types_bpfrpt_proptype_Scroll =  true ? null : 0;





;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/List/List.js









var List_class, List_temp;




/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = (List_temp = List_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(List, _React$PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(List)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "Grid", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_cellRenderer", function (_ref) {
      var parent = _ref.parent,
          rowIndex = _ref.rowIndex,
          style = _ref.style,
          isScrolling = _ref.isScrolling,
          isVisible = _ref.isVisible,
          key = _ref.key;
      var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');

      if (widthDescriptor && widthDescriptor.writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_setRef", function (ref) {
      _this.Grid = ref;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScroll", function (_ref2) {
      var clientHeight = _ref2.clientHeight,
          scrollHeight = _ref2.scrollHeight,
          scrollTop = _ref2.scrollTop;
      var onScroll = _this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onSectionRendered", function (_ref3) {
      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref3.rowOverscanStopIndex,
          rowStartIndex = _ref3.rowStartIndex,
          rowStopIndex = _ref3.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });

    return _this;
  }

  createClass_createClass(List, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4) {
      var alignment = _ref4.alignment,
          index = _ref4.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$columnIndex = _ref6.columnIndex,
          columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
          _ref6$rowIndex = _ref6.rowIndex,
          rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          noRowsRenderer = _this$props.noRowsRenderer,
          scrollToIndex = _this$props.scrollToIndex,
          width = _this$props.width;
      var classNames = clsx_m('ReactVirtualized__List', className);
      return react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(react.PureComponent), (0,defineProperty/* default */.Z)(List_class, "propTypes",  true ? null : 0), List_temp);

(0,defineProperty/* default */.Z)(List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});














;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/List/index.js




;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/vendor/binarySearchBounds.js
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/
function _GEA(a, l, h, y) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function _GEP(a, l, h, y, c) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function _GTP(a, l, h, y, c) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function _LTP(a, l, h, y, c) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function _LEP(a, l, h, y, c) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return -1;
}

function _EQP(a, l, h, y, c) {
  l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);

    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return -1;
}

function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ var binarySearchBounds = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/vendor/intervalTree.js
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);

  if (idx < 0) {
    return NOT_FOUND;
  }

  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);

  if (this.left) {
    this.left.intervals(result);
  }

  if (this.right) {
    this.right.intervals(result);
  }

  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;

  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = binarySearchBounds.ge(this.leftPoints, interval, compareBegin);
    var r = binarySearchBounds.ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;

  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }

    var rw = this.right ? this.right.count : 0;

    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }

    var r = this.left.remove(interval);

    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }

    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }

    var lw = this.left ? this.left.count : 0;

    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }

    var r = this.right.remove(interval);

    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }

    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }

    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;

        while (n.right) {
          p = n;
          n = n.right;
        }

        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }

        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }

      return SUCCESS;
    }

    for (var l = binarySearchBounds.ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }

      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);

        for (var r = binarySearchBounds.ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }

    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);

      if (r) {
        return r;
      }
    }

    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);

      if (r) {
        return r;
      }
    }

    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);

    if (r) {
      return r;
    }
  }

  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);

    if (r) {
      return r;
    }
  }

  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];

  if (d) {
    return d;
  }

  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];

  if (d) {
    return d;
  }

  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }

  var pts = [];

  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }

  pts.sort(compareNumbers);
  var mid = pts[pts.length >> 1];
  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];

  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];

    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  } //Split center intervals


  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);
  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
} //User friendly wrapper that makes it possible to support empty trees


function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);

    if (r === EMPTY) {
      this.root = null;
    }

    return r !== NOT_FOUND;
  }

  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }

    return 0;
  }
});
Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }

    return [];
  }
});
function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }

  return new IntervalTree(createIntervalTree(intervals));
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/PositionCache.js






// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache =
/*#__PURE__*/
function () {
  function PositionCache() {
    classCallCheck_classCallCheck(this, PositionCache);

    (0,defineProperty/* default */.Z)(this, "_columnSizeMap", {});

    (0,defineProperty/* default */.Z)(this, "_intervalTree", createWrapper());

    (0,defineProperty/* default */.Z)(this, "_leftMap", {});
  }

  createClass_createClass(PositionCache, [{
    key: "estimateTotalHeight",
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    } // Render all cells visible within the viewport range defined.

  }, {
    key: "range",
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);

      this._leftMap[index] = left;
      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];

      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: "count",
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: "shortestColumnSize",
    get: function get() {
      var columnSizeMap = this._columnSizeMap;
      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: "tallestColumnSize",
    get: function get() {
      var columnSizeMap = this._columnSizeMap;
      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/Masonry.js








var Masonry_class, Masonry_temp;

function Masonry_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Masonry_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Masonry_ownKeys(source, true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Masonry_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var emptyObject = {};
/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var Masonry_DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry_Masonry = (Masonry_temp = Masonry_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Masonry, _React$PureComponent);

  function Masonry() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, Masonry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Masonry)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", {
      isScrolling: false,
      scrollTop: 0
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_debounceResetIsScrollingId", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_invalidateOnUpdateStartIndex", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_invalidateOnUpdateStopIndex", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_positionCache", new PositionCache());

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_startIndex", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_startIndexMemoized", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_stopIndex", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_stopIndexMemoized", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_debounceResetIsScrollingCallback", function () {
      _this.setState({
        isScrolling: false
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScroll", function (event) {
      var height = _this.props.height;
      var eventScrollTop = event.currentTarget.scrollTop; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop); // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.

      if (eventScrollTop !== scrollTop) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      _this._debounceResetIsScrolling(); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.


      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    });

    return _this;
  }

  createClass_createClass(Masonry, [{
    key: "clearCellPositions",
    value: function clearCellPositions() {
      this._positionCache = new PositionCache();
      this.forceUpdate();
    } // HACK This method signature was intended for Grid

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref) {
      var index = _ref.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: "recomputeCellPositions",
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;
      this._positionCache = new PositionCache();

      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();

      this._invokeOnScrollCallback();

      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();

      this._invokeOnScrollCallback();

      this._invokeOnCellsRenderedCallback();

      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          cellCount = _this$props.cellCount,
          cellMeasurerCache = _this$props.cellMeasurerCache,
          cellRenderer = _this$props.cellRenderer,
          className = _this$props.className,
          height = _this$props.height,
          id = _this$props.id,
          keyMapper = _this$props.keyMapper,
          overscanByPixels = _this$props.overscanByPixels,
          role = _this$props.role,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex,
          width = _this$props.width,
          rowDirection = _this$props.rowDirection;
      var _this$state = this.state,
          isScrolling = _this$state.isScrolling,
          scrollTop = _this$state.scrollTop;
      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;
      var startIndex = 0;
      var stopIndex;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        var _style;

        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: (_style = {
            height: cellMeasurerCache.getHeight(index)
          }, (0,defineProperty/* default */.Z)(_style, rowDirection === 'ltr' ? 'left' : 'right', left), (0,defineProperty/* default */.Z)(_style, "position", 'absolute'), (0,defineProperty/* default */.Z)(_style, "top", top), (0,defineProperty/* default */.Z)(_style, "width", cellMeasurerCache.getWidth(index)), _style)
        }));
      }); // We need to measure additional cells for this layout


      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;
          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;
      return react.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: clsx_m('ReactVirtualized__Masonry', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: Masonry_objectSpread({
          boxSizing: 'border-box',
          direction: 'ltr',
          height: autoHeight ? 'auto' : height,
          overflowX: 'hidden',
          overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
          position: 'relative',
          width: width,
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform'
        }, style),
        tabIndex: tabIndex
      }, react.createElement("div", {
        className: "ReactVirtualized__Masonry__innerScrollContainer",
        style: {
          width: '100%',
          height: estimateTotalHeight,
          maxWidth: '100%',
          maxHeight: estimateTotalHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }
      }, children));
    }
  }, {
    key: "_checkInvalidateOnUpdate",
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var startIndex = this._invalidateOnUpdateStartIndex;
        var stopIndex = this._invalidateOnUpdateStopIndex;
        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null; // Query external layout logic for position of newly-measured cells

        this._populatePositionCache(startIndex, stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: "_debounceResetIsScrolling",
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._debounceResetIsScrollingId) {
        cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = requestAnimationTimeout(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_getEstimatedTotalHeight",
    value: function _getEstimatedTotalHeight() {
      var _this$props2 = this.props,
          cellCount = _this$props2.cellCount,
          cellMeasurerCache = _this$props2.cellMeasurerCache,
          width = _this$props2.width;
      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: "_invokeOnScrollCallback",
    value: function _invokeOnScrollCallback() {
      var _this$props3 = this.props,
          height = _this$props3.height,
          onScroll = _this$props3.onScroll;
      var scrollTop = this.state.scrollTop;

      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });
        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: "_invokeOnCellsRenderedCallback",
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var onCellsRendered = this.props.onCellsRendered;
        onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });
        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: "_populatePositionCache",
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _this$props4 = this.props,
          cellMeasurerCache = _this$props4.cellMeasurerCache,
          cellPositioner = _this$props4.cellPositioner;

      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            left = _cellPositioner.left,
            top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, left, top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }

      return null;
    }
  }]);

  return Masonry;
}(react.PureComponent), (0,defineProperty/* default */.Z)(Masonry_class, "propTypes",  true ? null : 0), Masonry_temp);

(0,defineProperty/* default */.Z)(Masonry_Masonry, "defaultProps", {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: Masonry_DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
});

function identity(value) {
  return value;
}

function noop() {}

var bpfrpt_proptype_CellMeasurerCache =  true ? null : 0;
polyfill(Masonry_Masonry);
/* harmony default export */ var es_Masonry_Masonry = ((/* unused pure expression or super */ null && (Masonry_Masonry)));
var bpfrpt_proptype_Positioner =  true ? null : 0;




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/createCellPositioner.js
function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === void 0 ? 0 : _ref$spacer;
  var columnHeights;
  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;

    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;
    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;
    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];

    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;
    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;
  return cellPositioner;
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/index.js


/* harmony default export */ var es_Masonry = ((/* unused pure expression or super */ null && (Masonry)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/MultiGrid/CellMeasurerCacheDecorator.js





/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator =
/*#__PURE__*/
function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    classCallCheck_classCallCheck(this, CellMeasurerCacheDecorator);

    (0,defineProperty/* default */.Z)(this, "_cellMeasurerCache", void 0);

    (0,defineProperty/* default */.Z)(this, "_columnIndexOffset", void 0);

    (0,defineProperty/* default */.Z)(this, "_rowIndexOffset", void 0);

    (0,defineProperty/* default */.Z)(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    });

    (0,defineProperty/* default */.Z)(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    });

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === void 0 ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === void 0 ? 0 : _params$rowIndexOffse;
    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  createClass_createClass(CellMeasurerCacheDecorator, [{
    key: "clear",
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/MultiGrid/MultiGrid.js










function MultiGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MultiGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MultiGrid_ownKeys(source, true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MultiGrid_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var SCROLLBAR_SIZE_BUFFER = 20;
/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid_MultiGrid =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MultiGrid, _React$PureComponent);

  function MultiGrid(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, MultiGrid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiGrid).call(this, props, context));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", {
      scrollLeft: 0,
      scrollTop: 0,
      scrollbarSize: 0,
      showHorizontalScrollbar: false,
      showVerticalScrollbar: false
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_deferredInvalidateColumnIndex", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_deferredInvalidateRowIndex", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_bottomLeftGridRef", function (ref) {
      _this._bottomLeftGrid = ref;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_bottomRightGridRef", function (ref) {
      _this._bottomRightGrid = ref;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_cellRendererBottomLeftGrid", function (_ref) {
      var rowIndex = _ref.rowIndex,
          rest = _objectWithoutProperties(_ref, ["rowIndex"]);

      var _this$props = _this.props,
          cellRenderer = _this$props.cellRenderer,
          fixedRowCount = _this$props.fixedRowCount,
          rowCount = _this$props.rowCount;

      if (rowIndex === rowCount - fixedRowCount) {
        return react.createElement("div", {
          key: rest.key,
          style: MultiGrid_objectSpread({}, rest.style, {
            height: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(MultiGrid_objectSpread({}, rest, {
          parent: _assertThisInitialized(_this),
          rowIndex: rowIndex + fixedRowCount
        }));
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_cellRendererBottomRightGrid", function (_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex,
          rest = _objectWithoutProperties(_ref2, ["columnIndex", "rowIndex"]);

      var _this$props2 = _this.props,
          cellRenderer = _this$props2.cellRenderer,
          fixedColumnCount = _this$props2.fixedColumnCount,
          fixedRowCount = _this$props2.fixedRowCount;
      return cellRenderer(MultiGrid_objectSpread({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: _assertThisInitialized(_this),
        rowIndex: rowIndex + fixedRowCount
      }));
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_cellRendererTopRightGrid", function (_ref3) {
      var columnIndex = _ref3.columnIndex,
          rest = _objectWithoutProperties(_ref3, ["columnIndex"]);

      var _this$props3 = _this.props,
          cellRenderer = _this$props3.cellRenderer,
          columnCount = _this$props3.columnCount,
          fixedColumnCount = _this$props3.fixedColumnCount;

      if (columnIndex === columnCount - fixedColumnCount) {
        return react.createElement("div", {
          key: rest.key,
          style: MultiGrid_objectSpread({}, rest.style, {
            width: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(MultiGrid_objectSpread({}, rest, {
          columnIndex: columnIndex + fixedColumnCount,
          parent: _assertThisInitialized(_this)
        }));
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_columnWidthRightGrid", function (_ref4) {
      var index = _ref4.index;
      var _this$props4 = _this.props,
          columnCount = _this$props4.columnCount,
          fixedColumnCount = _this$props4.fixedColumnCount,
          columnWidth = _this$props4.columnWidth;
      var _this$state = _this.state,
          scrollbarSize = _this$state.scrollbarSize,
          showHorizontalScrollbar = _this$state.showHorizontalScrollbar; // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
        return scrollbarSize;
      }

      return typeof columnWidth === 'function' ? columnWidth({
        index: index + fixedColumnCount
      }) : columnWidth;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScroll", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft,
          scrollTop = scrollInfo.scrollTop;

      _this.setState({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      var onScroll = _this.props.onScroll;

      if (onScroll) {
        onScroll(scrollInfo);
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScrollbarPresenceChange", function (_ref5) {
      var horizontal = _ref5.horizontal,
          size = _ref5.size,
          vertical = _ref5.vertical;
      var _this$state2 = _this.state,
          showHorizontalScrollbar = _this$state2.showHorizontalScrollbar,
          showVerticalScrollbar = _this$state2.showVerticalScrollbar;

      if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
        _this.setState({
          scrollbarSize: size,
          showHorizontalScrollbar: horizontal,
          showVerticalScrollbar: vertical
        });

        var onScrollbarPresenceChange = _this.props.onScrollbarPresenceChange;

        if (typeof onScrollbarPresenceChange === 'function') {
          onScrollbarPresenceChange({
            horizontal: horizontal,
            size: size,
            vertical: vertical
          });
        }
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScrollLeft", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft;

      _this._onScroll({
        scrollLeft: scrollLeft,
        scrollTop: _this.state.scrollTop
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onScrollTop", function (scrollInfo) {
      var scrollTop = scrollInfo.scrollTop;

      _this._onScroll({
        scrollTop: scrollTop,
        scrollLeft: _this.state.scrollLeft
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_rowHeightBottomGrid", function (_ref6) {
      var index = _ref6.index;
      var _this$props5 = _this.props,
          fixedRowCount = _this$props5.fixedRowCount,
          rowCount = _this$props5.rowCount,
          rowHeight = _this$props5.rowHeight;
      var _this$state3 = _this.state,
          scrollbarSize = _this$state3.scrollbarSize,
          showVerticalScrollbar = _this$state3.showVerticalScrollbar; // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
        return scrollbarSize;
      }

      return typeof rowHeight === 'function' ? rowHeight({
        index: index + fixedRowCount
      }) : rowHeight;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_topLeftGridRef", function (ref) {
      _this._topLeftGrid = ref;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_topRightGridRef", function (ref) {
      _this._topRightGrid = ref;
    });

    var deferredMeasurementCache = props.deferredMeasurementCache,
        _fixedColumnCount = props.fixedColumnCount,
        _fixedRowCount = props.fixedRowCount;

    _this._maybeCalculateCachedStyles(true);

    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = _fixedRowCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheBottomRightGrid = _fixedColumnCount > 0 || _fixedRowCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheTopRightGrid = _fixedColumnCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }

    return _this;
  }

  createClass_createClass(MultiGrid, [{
    key: "forceUpdateGrids",
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }
    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === void 0 ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === void 0 ? 0 : _ref7$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref8$columnIndex = _ref8.columnIndex,
          columnIndex = _ref8$columnIndex === void 0 ? 0 : _ref8$columnIndex,
          _ref8$rowIndex = _ref8.rowIndex,
          rowIndex = _ref8$rowIndex === void 0 ? 0 : _ref8$rowIndex;

      var _this$props6 = this.props,
          fixedColumnCount = _this$props6.fixedColumnCount,
          fixedRowCount = _this$props6.fixedRowCount;
      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });
      this._leftGridWidth = null;
      this._topGridHeight = null;

      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
          scrollLeft = _this$props7.scrollLeft,
          scrollTop = _this$props7.scrollTop;

      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }

      this._handleInvalidatedGridSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          onScroll = _this$props8.onScroll,
          onSectionRendered = _this$props8.onSectionRendered,
          onScrollbarPresenceChange = _this$props8.onScrollbarPresenceChange,
          scrollLeftProp = _this$props8.scrollLeft,
          scrollToColumn = _this$props8.scrollToColumn,
          scrollTopProp = _this$props8.scrollTop,
          scrollToRow = _this$props8.scrollToRow,
          rest = _objectWithoutProperties(_this$props8, ["onScroll", "onSectionRendered", "onScrollbarPresenceChange", "scrollLeft", "scrollToColumn", "scrollTop", "scrollToRow"]);

      this._prepareForRender(); // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.


      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      } // scrollTop and scrollLeft props are explicitly filtered out and ignored


      var _this$state4 = this.state,
          scrollLeft = _this$state4.scrollLeft,
          scrollTop = _this$state4.scrollTop;
      return react.createElement("div", {
        style: this._containerOuterStyle
      }, react.createElement("div", {
        style: this._containerTopStyle
      }, this._renderTopLeftGrid(rest), this._renderTopRightGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        scrollLeft: scrollLeft
      }))), react.createElement("div", {
        style: this._containerBottomStyle
      }, this._renderBottomLeftGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        scrollTop: scrollTop
      })), this._renderBottomRightGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        onSectionRendered: onSectionRendered,
        scrollLeft: scrollLeft,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow,
        scrollTop: scrollTop
      }))));
    }
  }, {
    key: "_getBottomGridHeight",
    value: function _getBottomGridHeight(props) {
      var height = props.height;

      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: "_getLeftGridWidth",
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;

      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({
              index: index
            });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: "_getRightGridWidth",
    value: function _getRightGridWidth(props) {
      var width = props.width;

      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: "_getTopGridHeight",
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;

      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({
              index: index
            });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }
    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: "_maybeCalculateCachedStyles",
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _this$props9 = this.props,
          columnWidth = _this$props9.columnWidth,
          enableFixedColumnScroll = _this$props9.enableFixedColumnScroll,
          enableFixedRowScroll = _this$props9.enableFixedRowScroll,
          height = _this$props9.height,
          fixedColumnCount = _this$props9.fixedColumnCount,
          fixedRowCount = _this$props9.fixedRowCount,
          rowHeight = _this$props9.rowHeight,
          style = _this$props9.style,
          styleBottomLeftGrid = _this$props9.styleBottomLeftGrid,
          styleBottomRightGrid = _this$props9.styleBottomRightGrid,
          styleTopLeftGrid = _this$props9.styleTopLeftGrid,
          styleTopRightGrid = _this$props9.styleTopRightGrid,
          width = _this$props9.width;
      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;

      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = MultiGrid_objectSpread({
          height: height,
          overflow: 'visible',
          // Let :focus outline show through
          width: width
        }, style);
      }

      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };
        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible',
          // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = MultiGrid_objectSpread({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = MultiGrid_objectSpread({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = MultiGrid_objectSpread({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = MultiGrid_objectSpread({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }

      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: "_prepareForRender",
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles();

      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: "_renderBottomLeftGrid",
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;

      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
          height = this._getBottomGridHeight(props),
          width = this._getLeftGridWidth(props),
          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;

      var bottomLeftGrid = react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));

      if (hideBottomLeftGridScrollbar) {
        return react.createElement("div", {
          className: "BottomLeftGrid_ScrollWrapper",
          style: MultiGrid_objectSpread({}, this._bottomLeftGridStyle, {
            height: height,
            width: width,
            overflowY: 'hidden'
          })
        }, bottomLeftGrid);
      }

      return bottomLeftGrid;
    }
  }, {
    key: "_renderBottomRightGrid",
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;
      return react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopLeftGrid",
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;

      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopRightGrid",
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft,
          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _this$state5 = this.state,
          showHorizontalScrollbar = _this$state5.showHorizontalScrollbar,
          scrollbarSize = _this$state5.scrollbarSize;

      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
          height = this._getTopGridHeight(props),
          width = this._getRightGridWidth(props),
          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;

      var gridHeight = height,
          style = this._topRightGridStyle;

      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = MultiGrid_objectSpread({}, this._topRightGridStyle, {
          left: 0
        });
      }

      var topRightGrid = react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));

      if (hideTopRightGridScrollbar) {
        return react.createElement("div", {
          className: "TopRightGrid_ScrollWrapper",
          style: MultiGrid_objectSpread({}, this._topRightGridStyle, {
            height: height,
            width: width,
            overflowX: 'hidden'
          })
        }, topRightGrid);
      }

      return topRightGrid;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return MultiGrid;
}(react.PureComponent);

(0,defineProperty/* default */.Z)(MultiGrid_MultiGrid, "defaultProps", {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
});

MultiGrid_MultiGrid.propTypes =  false ? 0 : {};
polyfill(MultiGrid_MultiGrid);
/* harmony default export */ var es_MultiGrid_MultiGrid = ((/* unused pure expression or super */ null && (MultiGrid_MultiGrid)));
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/MultiGrid/index.js

/* harmony default export */ var es_MultiGrid = ((/* unused pure expression or super */ null && (MultiGrid)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ScrollSync/ScrollSync.js








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync_ScrollSync =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ScrollSync, _React$PureComponent);

  function ScrollSync(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, ScrollSync);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollSync).call(this, props, context));
    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };
    _this._onScroll = _this._onScroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(ScrollSync, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          clientHeight = _this$state.clientHeight,
          clientWidth = _this$state.clientWidth,
          scrollHeight = _this$state.scrollHeight,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop,
          scrollWidth = _this$state.scrollWidth;
      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;
      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(react.PureComponent);


ScrollSync_ScrollSync.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ScrollSync/index.js

/* harmony default export */ var es_ScrollSync = ((/* unused pure expression or super */ null && (ScrollSync)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/types.js
var bpfrpt_proptype_CellDataGetterParams =  true ? null : 0;
var types_bpfrpt_proptype_CellRendererParams =  true ? null : 0;
var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : 0;
var bpfrpt_proptype_HeaderRendererParams =  true ? null : 0;
var types_bpfrpt_proptype_RowRendererParams =  true ? null : 0;






;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultCellDataGetter.js
/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultCellRenderer.js
/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultHeaderRowRenderer.js

function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;
  return react.createElement("div", {
    className: className,
    role: "row",
    style: style
  }, columns);
}
defaultHeaderRowRenderer.propTypes =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/SortDirection.js
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};
/* harmony default export */ var Table_SortDirection = (SortDirection);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/SortIndicator.js




/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */

function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;
  var classNames = clsx_m('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === Table_SortDirection.ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === Table_SortDirection.DESC
  });
  return react.createElement("svg", {
    className: classNames,
    width: 18,
    height: 18,
    viewBox: "0 0 24 24"
  }, sortDirection === Table_SortDirection.ASC ? react.createElement("path", {
    d: "M7 14l5-5 5 5z"
  }) : react.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), react.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}
SortIndicator.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultHeaderRenderer.js



/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;
  var showSortIndicator = sortBy === dataKey;
  var children = [react.createElement("span", {
    className: "ReactVirtualized__Table__headerTruncatedText",
    key: "label",
    title: typeof label === 'string' ? label : null
  }, label)];

  if (showSortIndicator) {
    children.push(react.createElement(SortIndicator, {
      key: "SortIndicator",
      sortDirection: sortDirection
    }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultRowRenderer.js



/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;
  var a11yProps = {
    'aria-rowindex': index + 1
  };

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }
  }

  return react.createElement("div", (0,esm_extends/* default */.Z)({}, a11yProps, {
    className: className,
    key: key,
    role: "row",
    style: style
  }), columns);
}
defaultRowRenderer.propTypes =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/Column.js











/**
 * Describes the header and cell contents of a table column.
 */

var Column =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Column, _React$Component);

  function Column() {
    classCallCheck_classCallCheck(this, Column);

    return _possibleConstructorReturn(this, _getPrototypeOf(Column).apply(this, arguments));
  }

  return Column;
}(react.Component);

(0,defineProperty/* default */.Z)(Column, "defaultProps", {
  cellDataGetter: defaultCellDataGetter,
  cellRenderer: defaultCellRenderer,
  defaultSortDirection: Table_SortDirection.ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: defaultHeaderRenderer,
  style: {}
});


Column.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/Table.js









function Table_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Table_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Table_ownKeys(source, true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Table_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table_Table =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Table, _React$PureComponent);

  function Table(props) {
    var _this;

    classCallCheck_classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));
    _this.state = {
      scrollbarWidth: 0
    };
    _this._createColumn = _this._createColumn.bind(_assertThisInitialized(_this));
    _this._createRow = _this._createRow.bind(_assertThisInitialized(_this));
    _this._onScroll = _this._onScroll.bind(_assertThisInitialized(_this));
    _this._onSectionRendered = _this._onSectionRendered.bind(_assertThisInitialized(_this));
    _this._setRef = _this._setRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(Table, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === void 0 ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === void 0 ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "getScrollbarWidth",
    value: function getScrollbarWidth() {
      if (this.Grid) {
        var _Grid = (0,react_dom.findDOMNode)(this.Grid);

        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        return offsetWidth - clientWidth;
      }

      return 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disableHeader = _this$props.disableHeader,
          gridClassName = _this$props.gridClassName,
          gridStyle = _this$props.gridStyle,
          headerHeight = _this$props.headerHeight,
          headerRowRenderer = _this$props.headerRowRenderer,
          height = _this$props.height,
          id = _this$props.id,
          noRowsRenderer = _this$props.noRowsRenderer,
          rowClassName = _this$props.rowClassName,
          rowStyle = _this$props.rowStyle,
          scrollToIndex = _this$props.scrollToIndex,
          style = _this$props.style,
          width = _this$props.width;
      var scrollbarWidth = this.state.scrollbarWidth;
      var availableRowsHeight = disableHeader ? height : height - headerHeight;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: -1
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: -1
      }) : rowStyle; // Precompute and cache column styles before rendering rows and columns to speed things up

      this._cachedColumnStyles = [];
      react.Children.toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = Table_objectSpread({
          overflow: 'hidden'
        }, flexStyles);
      }); // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.

      return react.createElement("div", {
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-colcount": react.Children.toArray(children).length,
        "aria-rowcount": this.props.rowCount,
        className: clsx_m('ReactVirtualized__Table', className),
        id: id,
        role: "grid",
        style: style
      }, !disableHeader && headerRowRenderer({
        className: clsx_m('ReactVirtualized__Table__headerRow', rowClass),
        columns: this._getHeaderColumns(),
        style: Table_objectSpread({
          height: headerHeight,
          overflow: 'hidden',
          paddingRight: scrollbarWidth,
          width: width
        }, rowStyleObject)
      }), react.createElement(Grid_Grid, (0,esm_extends/* default */.Z)({}, this.props, {
        "aria-readonly": null,
        autoContainerWidth: true,
        className: clsx_m('ReactVirtualized__Table__Grid', gridClassName),
        cellRenderer: this._createRow,
        columnWidth: width,
        columnCount: 1,
        height: availableRowsHeight,
        id: undefined,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        role: "rowgroup",
        scrollbarWidth: scrollbarWidth,
        scrollToRow: scrollToIndex,
        style: Table_objectSpread({}, gridStyle, {
          overflowX: 'hidden'
        })
      })));
    }
  }, {
    key: "_createColumn",
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var onColumnClick = this.props.onColumnClick;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;
      var cellData = cellDataGetter({
        columnData: columnData,
        dataKey: dataKey,
        rowData: rowData
      });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var onClick = function onClick(event) {
        onColumnClick && onColumnClick({
          columnData: columnData,
          dataKey: dataKey,
          event: event
        });
      };

      var style = this._cachedColumnStyles[columnIndex];
      var title = typeof renderedCell === 'string' ? renderedCell : null; // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942

      return react.createElement("div", {
        "aria-colindex": columnIndex + 1,
        "aria-describedby": id,
        className: clsx_m('ReactVirtualized__Table__rowColumn', className),
        key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
        onClick: onClick,
        role: "gridcell",
        style: style,
        title: title
      }, renderedCell);
    }
  }, {
    key: "_createHeader",
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _this$props2 = this.props,
          headerClassName = _this$props2.headerClassName,
          headerStyle = _this$props2.headerStyle,
          onHeaderClick = _this$props2.onHeaderClick,
          sort = _this$props2.sort,
          sortBy = _this$props2.sortBy,
          sortDirection = _this$props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;
      var sortEnabled = !disableSort && sort;
      var classNames = clsx_m('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });

      var style = this._getFlexStyleForColumn(column, Table_objectSpread({}, headerStyle, {}, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });
      var headerOnClick, headerOnKeyDown, headerTabIndex, headerAriaSort, headerAriaLabel;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey; // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.

        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === Table_SortDirection.DESC ? Table_SortDirection.ASC : Table_SortDirection.DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({
            columnData: columnData,
            dataKey: dataKey,
            event: event
          });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerAriaSort = 'none';
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === Table_SortDirection.ASC ? 'ascending' : 'descending';
      } // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942


      return react.createElement("div", {
        "aria-label": headerAriaLabel,
        "aria-sort": headerAriaSort,
        className: classNames,
        id: id,
        key: 'Header-Col' + index,
        onClick: headerOnClick,
        onKeyDown: headerOnKeyDown,
        role: "columnheader",
        style: style,
        tabIndex: headerTabIndex
      }, renderedHeader);
    }
  }, {
    key: "_createRow",
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _this$props3 = this.props,
          children = _this$props3.children,
          onRowClick = _this$props3.onRowClick,
          onRowDoubleClick = _this$props3.onRowDoubleClick,
          onRowRightClick = _this$props3.onRowRightClick,
          onRowMouseOver = _this$props3.onRowMouseOver,
          onRowMouseOut = _this$props3.onRowMouseOut,
          rowClassName = _this$props3.rowClassName,
          rowGetter = _this$props3.rowGetter,
          rowRenderer = _this$props3.rowRenderer,
          rowStyle = _this$props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: index
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: index
      }) : rowStyle;
      var rowData = rowGetter({
        index: index
      });
      var columns = react.Children.toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });
      var className = clsx_m('ReactVirtualized__Table__row', rowClass);

      var flattenedStyle = Table_objectSpread({}, style, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      }, rowStyleObject);

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }
    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: "_getFlexStyleForColumn",
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var flexValue = "".concat(column.props.flexGrow, " ").concat(column.props.flexShrink, " ").concat(column.props.width, "px");

      var style = Table_objectSpread({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: "_getHeaderColumns",
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          disableHeader = _this$props4.disableHeader;
      var items = disableHeader ? [] : react.Children.toArray(children);
      return items.map(function (column, index) {
        return _this4._createHeader({
          column: column,
          index: index
        });
      });
    }
  }, {
    key: "_getRowHeight",
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;
      return typeof rowHeight === 'function' ? rowHeight({
        index: rowIndex
      }) : rowHeight;
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    }
  }, {
    key: "_onSectionRendered",
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: "_setRef",
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: "_setScrollbarWidth",
    value: function _setScrollbarWidth() {
      var scrollbarWidth = this.getScrollbarWidth();
      this.setState({
        scrollbarWidth: scrollbarWidth
      });
    }
  }]);

  return Table;
}(react.PureComponent);

(0,defineProperty/* default */.Z)(Table_Table, "defaultProps", {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  rowRenderer: defaultRowRenderer,
  headerRowRenderer: defaultHeaderRowRenderer,
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});


Table_Table.propTypes =  false ? 0 : {};

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/index.js










/* harmony default export */ var es_Table = ((/* unused pure expression or super */ null && (Table)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/utils/onScroll.js

var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    cancelAnimationTimeout(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });
  disablePointerEventsTimeoutId = requestAnimationTimeout(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;
    document.body.style.pointerEvents = 'none';
  }

  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }

  mountedInstances.push(component);
}
function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });

  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);

    if (disablePointerEventsTimeoutId) {
      cancelAnimationTimeout(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/utils/dimensions.js
/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */
// TODO Move this into WindowScroller and import from there
var isWindow = function isWindow(element) {
  return element === window;
};

var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;
    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}
/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */

function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);

    var _elementRect = getBoundingBox(element);

    var _containerRect = getBoundingBox(container);

    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}
/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */

function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/WindowScroller.js








var WindowScroller_class, WindowScroller_temp;

function WindowScroller_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function WindowScroller_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WindowScroller_ownKeys(source, true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WindowScroller_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var WindowScroller_IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller_WindowScroller = (WindowScroller_temp = WindowScroller_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, WindowScroller);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WindowScroller)).call.apply(_getPrototypeOf2, [this].concat(args)));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_window", getWindow());

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_isMounted", false);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_positionFromTop", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_positionFromLeft", 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_detectElementResize", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_child", void 0);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", WindowScroller_objectSpread({}, getDimensions(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }

      _this._child = element;

      _this.updatePosition();
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onChildScroll", function (_ref) {
      var scrollTop = _ref.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;

      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_registerResizeListener", function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_unregisterResizeListener", function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_onResize", function () {
      _this.updatePosition();
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "__handleWindowScrollEvent", function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;
      var scrollElement = _this.props.scrollElement;

      if (scrollElement) {
        var scrollOffset = getScrollOffset(scrollElement);
        var scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        onScroll({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "__resetIsScrolling", function () {
      _this.setState({
        isScrolling: false
      });
    });

    return _this;
  }

  createClass_createClass(WindowScroller, [{
    key: "updatePosition",
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width;
      var thisNode = this._child || react_dom.findDOMNode(this);

      if (thisNode instanceof Element && scrollElement) {
        var offset = getPositionOffset(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = getDimensions(scrollElement, this.props);

      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;
      this._detectElementResize = createDetectElementResize();
      this.updatePosition(scrollElement);

      if (scrollElement) {
        registerScrollListener(this, scrollElement);

        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;

      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);
        unregisterScrollListener(this, prevScrollElement);
        registerScrollListener(this, scrollElement);

        this._unregisterResizeListener(prevScrollElement);

        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;

      if (scrollElement) {
        unregisterScrollListener(this, scrollElement);

        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state2 = this.state,
          isScrolling = _this$state2.isScrolling,
          scrollTop = _this$state2.scrollTop,
          scrollLeft = _this$state2.scrollLeft,
          height = _this$state2.height,
          width = _this$state2.width;
      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }
  }]);

  return WindowScroller;
}(react.PureComponent), (0,defineProperty/* default */.Z)(WindowScroller_class, "propTypes",  true ? null : 0), WindowScroller_temp);

(0,defineProperty/* default */.Z)(WindowScroller_WindowScroller, "defaultProps", {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: WindowScroller_IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
});



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/index.js

/* harmony default export */ var es_WindowScroller = ((/* unused pure expression or super */ null && (WindowScroller)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/index.js














/***/ }),

/***/ 6353:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.38
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '1.0.38',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 500;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK    = 'Facebook',
        CHROMIUM_OS = 'Chromium OS',
        MAC_OS  = 'Mac OS';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    if (!regex[j]) { break; }
                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bop(?:rg)?x\/([\w\.]+)/i                                          // Opera GX
            ], [VERSION, [NAME, OPERA+' GX']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i            // Baidu
            ], [VERSION, [NAME, 'Baidu']], [
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // Heytap/Ovi
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /\bddg\/([\w\.]+)/i                                                 // DuckDuckGo
            ], [VERSION, [NAME, 'DuckDuckGo']], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /slbrowser\/([\w\.]+)/i                                             // Smart Lenovo Browser
            ], [VERSION, [NAME, 'Smart Lenovo '+BROWSER]], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 ' + BROWSER]], [
            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [                    // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
            /samsungbrowser\/([\w\.]+)/i                                        // Samsung Internet
            ], [VERSION, [NAME, SAMSUNG + ' Internet']], [
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /metasr[\/ ]?([\d\.]+)/i                                            // Sogou Explorer
            ], [VERSION, [NAME, 'Sogou Explorer']], [
            /(sogou)mo\w+\/([\d\.]+)/i                                          // Sogou Mobile
            ], [[NAME, 'Sogou Mobile'], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i                        // QQBrowser/2345 Browser
            ], [NAME, VERSION], [
            /(lbbrowser)/i,                                                     // LieBao Browser
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /(Klarna)\/([\w\.]+)/i,                                             // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(alipay)client\/([\w\.]+)/i,                                       // Alipay
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,                               // Twitter
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i                     // Chromium/Instagram/Snapchat
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
            ], [VERSION, [NAME, 'TikTok']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i,                                             // Links
            /panasonic;(viera)/i                                                // Panasonic Viera
            ], [NAME, VERSION], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,                  // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,        // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,                     // Redmi Pad
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
            /\b(opd2\d{3}a?) bui/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, TABLET]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,                             // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
                
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(kobo)\s(ereader|touch)/i,                                         // Kobo
            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w+)( bui|\))/i                                         // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( \d| pro)?)/i                                               // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [
            /(aeobc)\b/i                                                        // Echo Dot
            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i    // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
            /\b(libweb)/i
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i             // Windows Phone
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /windows nt 6\.2; (arm)/i,                                        // Windows RT
            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
            ], [VERSION, [NAME, 'watchOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
            ], [[NAME, CHROMIUM_OS], VERSION],[

            // Smart TVs
            /panasonic;(viera)/i,                                               // Panasonic Viera
            /(netrange)mmh/i,                                                   // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined;
        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
                _browser[NAME] = 'Brave';
            }
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
                _device[TYPE] = MOBILE;
            }
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') {
                _os[NAME] = _uach.platform  
                                    .replace(/chrome os/i, CHROMIUM_OS)
                                    .replace(/macos/i, MAC_OS);           // backward compatibility
            }
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__.amdO) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ 3205:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(4406);
var Pe=Object.defineProperty;var Nt=Object.getOwnPropertyDescriptor;var jt=Object.getOwnPropertyNames;var Ft=Object.prototype.hasOwnProperty;var Vt=(e,t)=>{for(var r in t)Pe(e,r,{get:t[r],enumerable:!0})},Me=(e,t,r,n)=>{if(t&&typeof t=="object"||typeof t=="function")for(let o of jt(t))!Ft.call(e,o)&&o!==r&&Pe(e,o,{get:()=>t[o],enumerable:!(n=Nt(t,o))||n.enumerable});return e},R=(e,t,r)=>(Me(e,t,"default"),r&&Me(r,t,"default"));var _t=e=>Me(Pe({},"__esModule",{value:!0}),e);var x={};Vt(x,{ReducerType:()=>We,SHOULD_AUTOBATCH:()=>ce,TaskAbortError:()=>b,Tuple:()=>j,addListener:()=>Re,asyncThunkCreator:()=>ut,autoBatchEnhancer:()=>de,buildCreateSlice:()=>ze,clearAllListeners:()=>qe,combineSlices:()=>Ot,configureStore:()=>st,createAction:()=>P,createActionCreatorInvariantMiddleware:()=>Qe,createAsyncThunk:()=>ye,createDraftSafeSelector:()=>ne,createDraftSafeSelectorCreator:()=>be,createDynamicMiddleware:()=>vt,createEntityAdapter:()=>At,createImmutableStateInvariantMiddleware:()=>Ze,createListenerMiddleware:()=>bt,createNextState:()=>D.produce,createReducer:()=>le,createSelector:()=>W.createSelector,createSelectorCreator:()=>W.createSelectorCreator,createSerializableStateInvariantMiddleware:()=>nt,createSlice:()=>lt,current:()=>D.current,findNonSerializableValue:()=>Ne,formatProdErrorMessage:()=>k,freeze:()=>D.freeze,isActionCreator:()=>oe,isAllOf:()=>G,isAnyOf:()=>V,isAsyncThunkAction:()=>_e,isDraft:()=>D.isDraft,isFluxStandardAction:()=>ae,isFulfilled:()=>Ve,isImmutableDefault:()=>Ye,isPending:()=>je,isPlain:()=>Oe,isRejected:()=>q,isRejectedWithValue:()=>Fe,lruMemoize:()=>W.lruMemoize,miniSerializeError:()=>Le,nanoid:()=>v,original:()=>D.original,prepareAutoBatched:()=>at,removeListener:()=>we,unwrapResult:()=>Ue,weakMapMemoize:()=>W.weakMapMemoize});module.exports=_t(x);R(x,__webpack_require__(2274),module.exports);var D=__webpack_require__(7476),W=__webpack_require__(6562);var ee=__webpack_require__(7476),te=__webpack_require__(6562),be=(...e)=>{let t=(0,te.createSelectorCreator)(...e),r=Object.assign((...n)=>{let o=t(...n),a=(s,...u)=>o((0,ee.isDraft)(s)?(0,ee.current)(s):s,...u);return Object.assign(a,o),a},{withTypes:()=>r});return r},ne=be(te.weakMapMemoize);var I=__webpack_require__(2274);var Ie=__webpack_require__(2274),Je=typeof window<"u"&&window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__:function(){if(arguments.length!==0)return typeof arguments[0]=="object"?Ie.compose:Ie.compose.apply(null,arguments)},gn=typeof window<"u"&&window.__REDUX_DEVTOOLS_EXTENSION__?window.__REDUX_DEVTOOLS_EXTENSION__:function(){return function(e){return e}};var se=__webpack_require__(3330);var ve=__webpack_require__(2274);var re=e=>e&&typeof e.match=="function";function P(e,t){function r(...n){if(t){let o=t(...n);if(!o)throw new Error(k(0));return{type:e,payload:o.payload,..."meta"in o&&{meta:o.meta},..."error"in o&&{error:o.error}}}return{type:e,payload:n[0]}}return r.toString=()=>`${e}`,r.type=e,r.match=n=>(0,ve.isAction)(n)&&n.type===e,r}function oe(e){return typeof e=="function"&&"type"in e&&re(e)}function ae(e){return(0,ve.isAction)(e)&&Object.keys(e).every(Lt)}function Lt(e){return["type","payload","error","meta"].indexOf(e)>-1}function Ut(e){let t=e?`${e}`.split("/"):[],r=t[t.length-1]||"actionCreator";return`Detected an action creator with type "${e||"unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${r}())\` instead of \`dispatch(${r})\`. This is necessary even if the action has no payload.`}function Qe(e={}){return()=>r=>n=>r(n)}var ie=__webpack_require__(7476);var j=class e extends Array{constructor(...t){super(...t),Object.setPrototypeOf(this,e.prototype)}static get[Symbol.species](){return e}concat(...t){return super.concat.apply(this,t)}prepend(...t){return t.length===1&&Array.isArray(t[0])?new e(...t[0].concat(this)):new e(...t.concat(this))}};function De(e){return(0,ie.isDraftable)(e)?(0,ie.produce)(e,()=>{}):e}function F(e,t,r){return e.has(t)?e.get(t):e.set(t,r(t)).get(t)}function Ye(e){return typeof e!="object"||e==null||Object.isFrozen(e)}function Ze(e={}){if(true)return()=>n=>o=>n(o);var t,r}var et=__webpack_require__(2274);function Oe(e){let t=typeof e;return e==null||t==="string"||t==="boolean"||t==="number"||Array.isArray(e)||(0,et.isPlainObject)(e)}function Ne(e,t="",r=Oe,n,o=[],a){let s;if(!r(e))return{keyPath:t||"<root>",value:e};if(typeof e!="object"||e===null||a?.has(e))return!1;let u=n!=null?n(e):Object.entries(e),c=o.length>0;for(let[A,i]of u){let d=t?t+"."+A:A;if(!(c&&o.some(g=>g instanceof RegExp?g.test(d):d===g))){if(!r(i))return{keyPath:d,value:i};if(typeof i=="object"&&(s=Ne(i,d,r,n,o,a),s))return s}}return a&&tt(e)&&a.add(e),!1}function tt(e){if(!Object.isFrozen(e))return!1;for(let t of Object.values(e))if(!(typeof t!="object"||t===null)&&!tt(t))return!1;return!0}function nt(e={}){return()=>t=>r=>t(r)}function Wt(e){return typeof e=="boolean"}var rt=()=>function(t){let{thunk:r=!0,immutableCheck:n=!0,serializableCheck:o=!0,actionCreatorCheck:a=!0}=t??{},s=new j;return r&&(Wt(r)?s.push(se.thunk):s.push((0,se.withExtraArgument)(r.extraArgument))),s};var ce="RTK_autoBatch",at=()=>e=>({payload:e,meta:{[ce]:!0}}),ot=e=>t=>{setTimeout(t,e)},de=(e={type:"raf"})=>t=>(...r)=>{let n=t(...r),o=!0,a=!1,s=!1,u=new Set,c=e.type==="tick"?queueMicrotask:e.type==="raf"?typeof window<"u"&&window.requestAnimationFrame?window.requestAnimationFrame:ot(10):e.type==="callback"?e.queueNotification:ot(e.timeout),A=()=>{s=!1,a&&(a=!1,u.forEach(i=>i()))};return Object.assign({},n,{subscribe(i){let d=()=>o&&i(),T=n.subscribe(d);return u.add(i),()=>{T(),u.delete(i)}},dispatch(i){try{return o=!i?.meta?.[ce],a=!o,a&&(s||(s=!0,c(A))),n.dispatch(i)}finally{o=!0}}})};var it=e=>function(r){let{autoBatch:n=!0}=r??{},o=new j(e);return n&&o.push(de(typeof n=="object"?n:void 0)),o};function st(e){let t=rt(),{reducer:r=void 0,middleware:n,devTools:o=!0,preloadedState:a=void 0,enhancers:s=void 0}=e||{},u;if(typeof r=="function")u=r;else if((0,I.isPlainObject)(r))u=(0,I.combineReducers)(r);else throw new Error(k(1));let c;typeof n=="function"?c=n(t):c=t();let A=I.compose;o&&(A=Je({trace:!1,...typeof o=="object"&&o}));let i=(0,I.applyMiddleware)(...c),d=it(i),T=typeof s=="function"?s(d):d(),g=A(...T);return(0,I.createStore)(u,a,g)}var z=__webpack_require__(7476);function ue(e){let t={},r=[],n,o={addCase(a,s){let u=typeof a=="string"?a:a.type;if(!u)throw new Error(k(28));if(u in t)throw new Error(k(29));return t[u]=s,o},addMatcher(a,s){return r.push({matcher:a,reducer:s}),o},addDefaultCase(a){return n=a,o}};return e(o),[t,r,n]}function zt(e){return typeof e=="function"}function le(e,t){let[r,n,o]=ue(t),a;if(zt(e))a=()=>De(e());else{let u=De(e);a=()=>u}function s(u=a(),c){let A=[r[c.type],...n.filter(({matcher:i})=>i(c)).map(({reducer:i})=>i)];return A.filter(i=>!!i).length===0&&(A=[o]),A.reduce((i,d)=>{if(d)if((0,z.isDraft)(i)){let g=d(i,c);return g===void 0?i:g}else{if((0,z.isDraftable)(i))return(0,z.produce)(i,T=>d(T,c));{let T=d(i,c);if(T===void 0){if(i===null)return i;throw Error("A case reducer on a non-draftable value must not return undefined")}return T}}return i},u)}return s.getInitialState=a,s}var ct=(e,t)=>re(e)?e.match(t):e(t);function V(...e){return t=>e.some(r=>ct(r,t))}function G(...e){return t=>e.every(r=>ct(r,t))}function pe(e,t){if(!e||!e.meta)return!1;let r=typeof e.meta.requestId=="string",n=t.indexOf(e.meta.requestStatus)>-1;return r&&n}function $(e){return typeof e[0]=="function"&&"pending"in e[0]&&"fulfilled"in e[0]&&"rejected"in e[0]}function je(...e){return e.length===0?t=>pe(t,["pending"]):$(e)?V(...e.map(t=>t.pending)):je()(e[0])}function q(...e){return e.length===0?t=>pe(t,["rejected"]):$(e)?V(...e.map(t=>t.rejected)):q()(e[0])}function Fe(...e){let t=r=>r&&r.meta&&r.meta.rejectedWithValue;return e.length===0?G(q(...e),t):$(e)?G(q(...e),t):Fe()(e[0])}function Ve(...e){return e.length===0?t=>pe(t,["fulfilled"]):$(e)?V(...e.map(t=>t.fulfilled)):Ve()(e[0])}function _e(...e){return e.length===0?t=>pe(t,["pending","fulfilled","rejected"]):$(e)?V(...e.flatMap(t=>[t.pending,t.rejected,t.fulfilled])):_e()(e[0])}var Gt="ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW",v=(e=21)=>{let t="",r=e;for(;r--;)t+=Gt[Math.random()*64|0];return t};var Bt=["name","message","stack","code"],X=class{constructor(t,r){this.payload=t;this.meta=r}_type},fe=class{constructor(t,r){this.payload=t;this.meta=r}_type},Le=e=>{if(typeof e=="object"&&e!==null){let t={};for(let r of Bt)typeof e[r]=="string"&&(t[r]=e[r]);return t}return{message:String(e)}},ye=(()=>{function e(t,r,n){let o=P(t+"/fulfilled",(c,A,i,d)=>({payload:c,meta:{...d||{},arg:i,requestId:A,requestStatus:"fulfilled"}})),a=P(t+"/pending",(c,A,i)=>({payload:void 0,meta:{...i||{},arg:A,requestId:c,requestStatus:"pending"}})),s=P(t+"/rejected",(c,A,i,d,T)=>({payload:d,error:(n&&n.serializeError||Le)(c||"Rejected"),meta:{...T||{},arg:i,requestId:A,rejectedWithValue:!!d,requestStatus:"rejected",aborted:c?.name==="AbortError",condition:c?.name==="ConditionError"}}));function u(c){return(A,i,d)=>{let T=n?.idGenerator?n.idGenerator(c):v(),g=new AbortController,p,h;function l(y){h=y,g.abort()}let f=async function(){let y;try{let S=n?.condition?.(c,{getState:i,extra:d});if(Kt(S)&&(S=await S),S===!1||g.signal.aborted)throw{name:"ConditionError",message:"Aborted due to condition callback returning false."};let M=new Promise((C,E)=>{p=()=>{E({name:"AbortError",message:h||"Aborted"})},g.signal.addEventListener("abort",p)});A(a(T,c,n?.getPendingMeta?.({requestId:T,arg:c},{getState:i,extra:d}))),y=await Promise.race([M,Promise.resolve(r(c,{dispatch:A,getState:i,extra:d,requestId:T,signal:g.signal,abort:l,rejectWithValue:(C,E)=>new X(C,E),fulfillWithValue:(C,E)=>new fe(C,E)})).then(C=>{if(C instanceof X)throw C;return C instanceof fe?o(C.payload,T,c,C.meta):o(C,T,c)})])}catch(S){y=S instanceof X?s(null,T,c,S.payload,S.meta):s(S,T,c)}finally{p&&g.signal.removeEventListener("abort",p)}return n&&!n.dispatchConditionRejection&&s.match(y)&&y.meta.condition||A(y),y}();return Object.assign(f,{abort:l,requestId:T,arg:c,unwrap(){return f.then(Ue)}})}}return Object.assign(u,{pending:a,rejected:s,fulfilled:o,settled:V(s,o),typePrefix:t})}return e.withTypes=()=>e,e})();function Ue(e){if(e.meta&&e.meta.rejectedWithValue)throw e.payload;if(e.error)throw e.error;return e.payload}function Kt(e){return e!==null&&typeof e=="object"&&typeof e.then=="function"}var dt=Symbol.for("rtk-slice-createasyncthunk"),ut={[dt]:ye},We=(n=>(n.reducer="reducer",n.reducerWithPrepare="reducerWithPrepare",n.asyncThunk="asyncThunk",n))(We||{});function Ht(e,t){return`${e}/${t}`}function ze({creators:e}={}){let t=e?.asyncThunk?.[dt];return function(n){let{name:o,reducerPath:a=o}=n;if(!o)throw new Error(k(11));typeof process<"u";let s=(typeof n.reducers=="function"?n.reducers($t()):n.reducers)||{},u=Object.keys(s),c={sliceCaseReducersByName:{},sliceCaseReducersByType:{},actionCreators:{},sliceMatchers:[]},A={addCase(y,m){let S=typeof y=="string"?y:y.type;if(!S)throw new Error(k(12));if(S in c.sliceCaseReducersByType)throw new Error(k(13));return c.sliceCaseReducersByType[S]=m,A},addMatcher(y,m){return c.sliceMatchers.push({matcher:y,reducer:m}),A},exposeAction(y,m){return c.actionCreators[y]=m,A},exposeCaseReducer(y,m){return c.sliceCaseReducersByName[y]=m,A}};u.forEach(y=>{let m=s[y],S={reducerName:y,type:Ht(o,y),createNotation:typeof n.reducers=="function"};Jt(m)?Yt(S,m,A,t):Xt(S,m,A)});function i(){let[y={},m=[],S=void 0]=typeof n.extraReducers=="function"?ue(n.extraReducers):[n.extraReducers],M={...y,...c.sliceCaseReducersByType};return le(n.initialState,C=>{for(let E in M)C.addCase(E,M[E]);for(let E of c.sliceMatchers)C.addMatcher(E.matcher,E.reducer);for(let E of m)C.addMatcher(E.matcher,E.reducer);S&&C.addDefaultCase(S)})}let d=y=>y,T=new Map,g;function p(y,m){return g||(g=i()),g(y,m)}function h(){return g||(g=i()),g.getInitialState()}function l(y,m=!1){function S(C){let E=C[y];return typeof E>"u"&&m&&(E=h()),E}function M(C=d){let E=F(T,m,()=>new WeakMap);return F(E,C,()=>{let O={};for(let[Y,Z]of Object.entries(n.selectors??{}))O[Y]=qt(Z,C,h,m);return O})}return{reducerPath:y,getSelectors:M,get selectors(){return M(S)},selectSlice:S}}let f={name:o,reducer:p,actions:c.actionCreators,caseReducers:c.sliceCaseReducersByName,getInitialState:h,...l(a),injectInto(y,{reducerPath:m,...S}={}){let M=m??a;return y.inject({reducerPath:M,reducer:p},S),{...f,...l(M,!0)}}};return f}}function qt(e,t,r,n){function o(a,...s){let u=t(a);return typeof u>"u"&&n&&(u=r()),e(u,...s)}return o.unwrapped=e,o}var lt=ze();function $t(){function e(t,r){return{_reducerDefinitionType:"asyncThunk",payloadCreator:t,...r}}return e.withTypes=()=>e,{reducer(t){return Object.assign({[t.name](...r){return t(...r)}}[t.name],{_reducerDefinitionType:"reducer"})},preparedReducer(t,r){return{_reducerDefinitionType:"reducerWithPrepare",prepare:t,reducer:r}},asyncThunk:e}}function Xt({type:e,reducerName:t,createNotation:r},n,o){let a,s;if("reducer"in n){if(r&&!Qt(n))throw new Error(k(17));a=n.reducer,s=n.prepare}else a=n;o.addCase(e,a).exposeCaseReducer(t,a).exposeAction(t,s?P(e,s):P(e))}function Jt(e){return e._reducerDefinitionType==="asyncThunk"}function Qt(e){return e._reducerDefinitionType==="reducerWithPrepare"}function Yt({type:e,reducerName:t},r,n,o){if(!o)throw new Error(k(18));let{payloadCreator:a,fulfilled:s,pending:u,rejected:c,settled:A,options:i}=r,d=o(e,a,i);n.exposeAction(t,d),s&&n.addCase(d.fulfilled,s),u&&n.addCase(d.pending,u),c&&n.addCase(d.rejected,c),A&&n.addMatcher(d.settled,A),n.exposeCaseReducer(t,{fulfilled:s||he,pending:u||he,rejected:c||he,settled:A||he})}function he(){}function Zt(){return{ids:[],entities:{}}}function pt(e){function t(r={},n){let o=Object.assign(Zt(),r);return n?e.setAll(o,n):o}return{getInitialState:t}}function ft(){function e(t,r={}){let{createSelector:n=ne}=r,o=d=>d.ids,a=d=>d.entities,s=n(o,a,(d,T)=>d.map(g=>T[g])),u=(d,T)=>T,c=(d,T)=>d[T],A=n(o,d=>d.length);if(!t)return{selectIds:o,selectEntities:a,selectAll:s,selectTotal:A,selectById:n(a,u,c)};let i=n(t,a);return{selectIds:n(t,o),selectEntities:i,selectAll:n(t,s),selectTotal:n(t,A),selectById:n(i,u,c)}}return{getSelectors:e}}var Ae=__webpack_require__(7476);var en=Ae.isDraft;function yt(e){let t=w((r,n)=>e(n));return function(n){return t(n,void 0)}}function w(e){return function(r,n){function o(s){return ae(s)}let a=s=>{o(n)?e(n.payload,s):e(n,s)};return en(r)?(a(r),r):(0,Ae.produce)(r,a)}}var Te=__webpack_require__(7476);function _(e,t){return t(e)}function N(e){return Array.isArray(e)||(e=Object.values(e)),e}function J(e){return(0,Te.isDraft)(e)?(0,Te.current)(e):e}function me(e,t,r){e=N(e);let n=J(r.ids),o=new Set(n),a=[],s=[];for(let u of e){let c=_(u,t);o.has(c)?s.push({id:c,changes:u}):a.push(u)}return[a,s,n]}function Se(e){function t(p,h){let l=_(p,e);l in h.entities||(h.ids.push(l),h.entities[l]=p)}function r(p,h){p=N(p);for(let l of p)t(l,h)}function n(p,h){let l=_(p,e);l in h.entities||h.ids.push(l),h.entities[l]=p}function o(p,h){p=N(p);for(let l of p)n(l,h)}function a(p,h){p=N(p),h.ids=[],h.entities={},r(p,h)}function s(p,h){return u([p],h)}function u(p,h){let l=!1;p.forEach(f=>{f in h.entities&&(delete h.entities[f],l=!0)}),l&&(h.ids=h.ids.filter(f=>f in h.entities))}function c(p){Object.assign(p,{ids:[],entities:{}})}function A(p,h,l){let f=l.entities[h.id];if(f===void 0)return!1;let y=Object.assign({},f,h.changes),m=_(y,e),S=m!==h.id;return S&&(p[h.id]=m,delete l.entities[h.id]),l.entities[m]=y,S}function i(p,h){return d([p],h)}function d(p,h){let l={},f={};p.forEach(m=>{m.id in h.entities&&(f[m.id]={id:m.id,changes:{...f[m.id]?.changes,...m.changes}})}),p=Object.values(f),p.length>0&&p.filter(S=>A(l,S,h)).length>0&&(h.ids=Object.values(h.entities).map(S=>_(S,e)))}function T(p,h){return g([p],h)}function g(p,h){let[l,f]=me(p,e,h);d(f,h),r(l,h)}return{removeAll:yt(c),addOne:w(t),addMany:w(r),setOne:w(n),setMany:w(o),setAll:w(a),updateOne:w(i),updateMany:w(d),upsertOne:w(T),upsertMany:w(g),removeOne:w(s),removeMany:w(u)}}function tn(e,t,r){let n=0,o=e.length;for(;n<o;){let a=n+o>>>1,s=e[a];r(t,s)>=0?n=a+1:o=a}return n}function nn(e,t,r){let n=tn(e,t,r);return e.splice(n,0,t),e}function ht(e,t){let{removeOne:r,removeMany:n,removeAll:o}=Se(e);function a(l,f){return s([l],f)}function s(l,f,y){l=N(l);let m=new Set(y??J(f.ids)),S=l.filter(M=>!m.has(_(M,e)));S.length!==0&&h(f,S)}function u(l,f){return c([l],f)}function c(l,f){if(l=N(l),l.length!==0){for(let y of l)delete f.entities[e(y)];h(f,l)}}function A(l,f){l=N(l),f.entities={},f.ids=[],s(l,f,[])}function i(l,f){return d([l],f)}function d(l,f){let y=!1,m=!1;for(let S of l){let M=f.entities[S.id];if(!M)continue;y=!0,Object.assign(M,S.changes);let C=e(M);if(S.id!==C){m=!0,delete f.entities[S.id];let E=f.ids.indexOf(S.id);f.ids[E]=C,f.entities[C]=M}}y&&h(f,[],y,m)}function T(l,f){return g([l],f)}function g(l,f){let[y,m,S]=me(l,e,f);m.length&&d(m,f),y.length&&s(y,f,S)}function p(l,f){if(l.length!==f.length)return!1;for(let y=0;y<l.length;y++)if(l[y]!==f[y])return!1;return!0}let h=(l,f,y,m)=>{let S=J(l.entities),M=J(l.ids),C=l.entities,E=M;m&&(E=new Set(M));let O=[];for(let H of E){let Xe=S[H];Xe&&O.push(Xe)}let Y=O.length===0;for(let H of f)C[e(H)]=H,Y||nn(O,H,t);Y?O=f.slice().sort(t):y&&O.sort(t);let Z=O.map(e);p(M,Z)||(l.ids=Z)};return{removeOne:r,removeMany:n,removeAll:o,addOne:w(a),updateOne:w(i),upsertOne:w(T),setOne:w(u),setMany:w(c),setAll:w(A),addMany:w(s),updateMany:w(d),upsertMany:w(g)}}function At(e={}){let{selectId:t,sortComparer:r}={sortComparer:!1,selectId:s=>s.id,...e},n=r?ht(t,r):Se(t),o=pt(n),a=ft();return{selectId:t,sortComparer:r,...o,...a,...n}}var wt=__webpack_require__(2274);var rn="task",Tt="listener",mt="completed",Ge="cancelled",St=`task-${Ge}`,gt=`task-${mt}`,ge=`${Tt}-${Ge}`,kt=`${Tt}-${mt}`,b=class{constructor(t){this.code=t;this.message=`${rn} ${Ge} (reason: ${t})`}name="TaskAbortError";message};var ke=(e,t)=>{if(typeof e!="function")throw new TypeError(k(32))},B=()=>{},xe=(e,t=B)=>(e.catch(t),e),Ce=(e,t)=>(e.addEventListener("abort",t,{once:!0}),()=>e.removeEventListener("abort",t)),L=(e,t)=>{let r=e.signal;r.aborted||("reason"in r||Object.defineProperty(r,"reason",{enumerable:!0,value:t,configurable:!0,writable:!0}),e.abort(t))};var U=e=>{if(e.aborted){let{reason:t}=e;throw new b(t)}};function Be(e,t){let r=B;return new Promise((n,o)=>{let a=()=>o(new b(e.reason));if(e.aborted){a();return}r=Ce(e,a),t.finally(()=>r()).then(n,o)}).finally(()=>{r=B})}var xt=async(e,t)=>{try{return await Promise.resolve(),{status:"ok",value:await e()}}catch(r){return{status:r instanceof b?"cancelled":"rejected",error:r}}finally{t?.()}},Q=e=>t=>xe(Be(e,t).then(r=>(U(e),r))),Ke=e=>{let t=Q(e);return r=>t(new Promise(n=>setTimeout(n,r)))};var{assign:K}=Object,Ct={},Ee="listenerMiddleware",on=(e,t)=>{let r=n=>Ce(e,()=>L(n,e.reason));return(n,o)=>{ke(n,"taskExecutor");let a=new AbortController;r(a);let s=xt(async()=>{U(e),U(a.signal);let u=await n({pause:Q(a.signal),delay:Ke(a.signal),signal:a.signal});return U(a.signal),u},()=>L(a,gt));return o?.autoJoin&&t.push(s.catch(B)),{result:Q(e)(s),cancel(){L(a,St)}}}},an=(e,t)=>{let r=async(n,o)=>{U(t);let a=()=>{},u=[new Promise((c,A)=>{let i=e({predicate:n,effect:(d,T)=>{T.unsubscribe(),c([d,T.getState(),T.getOriginalState()])}});a=()=>{i(),A()}})];o!=null&&u.push(new Promise(c=>setTimeout(c,o,null)));try{let c=await Be(t,Promise.race(u));return U(t),c}finally{a()}};return(n,o)=>xe(r(n,o))},Mt=e=>{let{type:t,actionCreator:r,matcher:n,predicate:o,effect:a}=e;if(t)o=P(t).match;else if(r)t=r.type,o=r.match;else if(n)o=n;else if(!o)throw new Error(k(21));return ke(a,"options.listener"),{predicate:o,type:t,effect:a}},Pt=K(e=>{let{type:t,predicate:r,effect:n}=Mt(e);return{id:v(),effect:n,type:t,predicate:r,pending:new Set,unsubscribe:()=>{throw new Error(k(22))}}},{withTypes:()=>Pt}),Et=(e,t)=>{let{type:r,effect:n,predicate:o}=Mt(t);return Array.from(e.values()).find(a=>(typeof r=="string"?a.type===r:a.predicate===o)&&a.effect===n)},He=e=>{e.pending.forEach(t=>{L(t,ge)})},sn=e=>()=>{e.forEach(He),e.clear()},Rt=(e,t,r)=>{try{e(t,r)}catch(n){setTimeout(()=>{throw n},0)}},Re=K(P(`${Ee}/add`),{withTypes:()=>Re}),qe=P(`${Ee}/removeAll`),we=K(P(`${Ee}/remove`),{withTypes:()=>we}),cn=(...e)=>{console.error(`${Ee}/error`,...e)},bt=(e={})=>{let t=new Map,{extra:r,onError:n=cn}=e;ke(n,"onError");let o=i=>(i.unsubscribe=()=>t.delete(i.id),t.set(i.id,i),d=>{i.unsubscribe(),d?.cancelActive&&He(i)}),a=i=>{let d=Et(t,i)??Pt(i);return o(d)};K(a,{withTypes:()=>a});let s=i=>{let d=Et(t,i);return d&&(d.unsubscribe(),i.cancelActive&&He(d)),!!d};K(s,{withTypes:()=>s});let u=async(i,d,T,g)=>{let p=new AbortController,h=an(a,p.signal),l=[];try{i.pending.add(p),await Promise.resolve(i.effect(d,K({},T,{getOriginalState:g,condition:(f,y)=>h(f,y).then(Boolean),take:h,delay:Ke(p.signal),pause:Q(p.signal),extra:r,signal:p.signal,fork:on(p.signal,l),unsubscribe:i.unsubscribe,subscribe:()=>{t.set(i.id,i)},cancelActiveListeners:()=>{i.pending.forEach((f,y,m)=>{f!==p&&(L(f,ge),m.delete(f))})},cancel:()=>{L(p,ge),i.pending.delete(p)},throwIfCancelled:()=>{U(p.signal)}})))}catch(f){f instanceof b||Rt(n,f,{raisedBy:"effect"})}finally{await Promise.all(l),L(p,kt),i.pending.delete(p)}},c=sn(t);return{middleware:i=>d=>T=>{if(!(0,wt.isAction)(T))return d(T);if(Re.match(T))return a(T.payload);if(qe.match(T)){c();return}if(we.match(T))return s(T.payload);let g=i.getState(),p=()=>{if(g===Ct)throw new Error(k(23));return g},h;try{if(h=d(T),t.size>0){let l=i.getState(),f=Array.from(t.values());for(let y of f){let m=!1;try{m=y.predicate(T,l,g)}catch(S){m=!1,Rt(n,S,{raisedBy:"predicate"})}m&&u(y,T,i,p)}}}finally{g=Ct}return h},startListening:a,stopListening:s,clearListeners:c}};var It=__webpack_require__(2274);var dn=e=>({middleware:e,applied:new Map}),un=e=>t=>t?.meta?.instanceId===e,vt=()=>{let e=v(),t=new Map,r=Object.assign(P("dynamicMiddleware/add",(...u)=>({payload:u,meta:{instanceId:e}})),{withTypes:()=>r}),n=Object.assign(function(...c){c.forEach(A=>{F(t,A,dn)})},{withTypes:()=>n}),o=u=>{let c=Array.from(t.values()).map(A=>F(A.applied,u,A.middleware));return(0,It.compose)(...c)},a=G(r,un(e));return{middleware:u=>c=>A=>a(A)?(n(...A.payload),u.dispatch):o(u)(c)(A),addMiddleware:n,withMiddleware:r,instanceId:e}};var Dt=__webpack_require__(2274);var ln=e=>"reducerPath"in e&&typeof e.reducerPath=="string",pn=e=>e.flatMap(t=>ln(t)?[[t.reducerPath,t.reducer]]:Object.entries(t)),$e=Symbol.for("rtk-state-proxy-original"),fn=e=>!!e&&!!e[$e],yn=new WeakMap,hn=(e,t)=>F(yn,e,()=>new Proxy(e,{get:(r,n,o)=>{if(n===$e)return r;let a=Reflect.get(r,n,o);if(typeof a>"u"){let s=t[n.toString()];if(s){let u=s(void 0,{type:v()});if(typeof u>"u")throw new Error(k(24));return u}}return a}})),An=e=>{if(!fn(e))throw new Error(k(25));return e[$e]},Tn=(e={})=>e;function Ot(...e){let t=Object.fromEntries(pn(e)),r=()=>Object.keys(t).length?(0,Dt.combineReducers)(t):Tn,n=r();function o(u,c){return n(u,c)}o.withLazyLoadedSlices=()=>o;let a=(u,c={})=>{let{reducerPath:A,reducer:i}=u,d=t[A];return!c.overrideExisting&&d&&d!==i?(typeof process<"u",o):(t[A]=i,n=r(),o)},s=Object.assign(function(c,A){return function(d,...T){return c(hn(A?A(d,...T):d,t),...T)}},{original:An});return Object.assign(o,{inject:a,selector:s})}function k(e){return`Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `}0&&(0);
//# sourceMappingURL=redux-toolkit.production.min.cjs.map

/***/ }),

/***/ 3330:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  thunk: () => thunk,
  withExtraArgument: () => withExtraArgument
});
module.exports = __toCommonJS(src_exports);
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 2274:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  __DO_NOT_USE__ActionTypes: () => actionTypes_default,
  applyMiddleware: () => applyMiddleware,
  bindActionCreators: () => bindActionCreators,
  combineReducers: () => combineReducers,
  compose: () => compose,
  createStore: () => createStore,
  isAction: () => isAction,
  isPlainObject: () => isPlainObject,
  legacy_createStore: () => legacy_createStore
});
module.exports = __toCommonJS(src_exports);

// src/utils/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
  return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;

// src/utils/actionTypes.ts
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;

// src/utils/isPlainObject.ts
function isPlainObject(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}

// src/utils/kindOf.ts
function miniKindOf(val) {
  if (val === void 0)
    return "undefined";
  if (val === null)
    return "null";
  const type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val))
    return "array";
  if (isDate(val))
    return "date";
  if (isError(val))
    return "error";
  const constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
  if (val instanceof Date)
    return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  let typeOfVal = typeof val;
  if (false) {}
  return typeOfVal;
}

// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }
    if (typeof action.type === "undefined") {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }
    if (typeof action.type !== "string") {
      throw new Error( true ? formatProdErrorMessage(17) : 0);
    }
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store = {
    dispatch,
    subscribe,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store;
}
function legacy_createStore(reducer, preloadedState, enhancer) {
  return createStore(reducer, preloadedState, enhancer);
}

// src/utils/warning.ts
function warning(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e) {
  }
}

// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  const reducerKeys = Object.keys(reducers);
  const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (reducerKeys.length === 0) {
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  }
  if (!isPlainObject(inputState)) {
    return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
  }
  const unexpectedKeys = Object.keys(inputState).filter((key) => !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
  unexpectedKeys.forEach((key) => {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === actionTypes_default.REPLACE)
    return;
  if (unexpectedKeys.length > 0) {
    return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState === "undefined") {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i = 0; i < reducerKeys.length; i++) {
    const key = reducerKeys[i];
    if (false) {}
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let unexpectedKeyCache;
  if (false) {}
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    if (false) {}
    let hasChanged = false;
    const nextState = {};
    for (let i = 0; i < finalReducerKeys.length; i++) {
      const key = finalReducerKeys[i];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        const actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

// src/bindActionCreators.ts
function bindActionCreator(actionCreator, dispatch) {
  return function(...args) {
    return dispatch(actionCreator.apply(this, args));
  };
}
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === "function") {
    return bindActionCreator(actionCreators, dispatch);
  }
  if (typeof actionCreators !== "object" || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }
  const boundActionCreators = {};
  for (const key in actionCreators) {
    const actionCreator = actionCreators[key];
    if (typeof actionCreator === "function") {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

// src/compose.ts
function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error( true ? formatProdErrorMessage(15) : 0);
    };
    const middlewareAPI = {
      getState: store.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose(...chain)(store.dispatch);
    return {
      ...store,
      dispatch
    };
  };
}

// src/utils/isAction.ts
function isAction(action) {
  return isPlainObject(action) && "type" in action && typeof action.type === "string";
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=redux.cjs.map

/***/ }),

/***/ 6562:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createSelector: () => createSelector,
  createSelectorCreator: () => createSelectorCreator,
  createStructuredSelector: () => createStructuredSelector,
  lruMemoize: () => lruMemoize,
  referenceEqualityCheck: () => referenceEqualityCheck,
  setGlobalDevModeChecks: () => setGlobalDevModeChecks,
  unstable_autotrackMemoize: () => autotrackMemoize,
  weakMapMemoize: () => weakMapMemoize
});
module.exports = __toCommonJS(src_exports);

// src/devModeChecks/identityFunctionCheck.ts
var runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult) => {
  if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
    let isInputSameAsOutput = false;
    try {
      const emptyObject = {};
      if (resultFunc(emptyObject) === emptyObject)
        isInputSameAsOutput = true;
    } catch {
    }
    if (isInputSameAsOutput) {
      let stack = void 0;
      try {
        throw new Error();
      } catch (e) {
        ;
        ({ stack } = e);
      }
      console.warn(
        "The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.",
        { stack }
      );
    }
  }
};

// src/devModeChecks/inputStabilityCheck.ts
var runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs) => {
  const { memoize, memoizeOptions } = options;
  const { inputSelectorResults, inputSelectorResultsCopy } = inputSelectorResultsObject;
  const createAnEmptyObject = memoize(() => ({}), ...memoizeOptions);
  const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
  if (!areInputSelectorResultsEqual) {
    let stack = void 0;
    try {
      throw new Error();
    } catch (e) {
      ;
      ({ stack } = e);
    }
    console.warn(
      "An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`",
      {
        arguments: inputSelectorArgs,
        firstInputs: inputSelectorResults,
        secondInputs: inputSelectorResultsCopy,
        stack
      }
    );
  }
};

// src/devModeChecks/setGlobalDevModeChecks.ts
var globalDevModeChecks = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
var setGlobalDevModeChecks = (devModeChecks) => {
  Object.assign(globalDevModeChecks, devModeChecks);
};

// src/utils.ts
var NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
  if (typeof func !== "function") {
    throw new TypeError(errorMessage);
  }
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
  if (typeof object !== "object") {
    throw new TypeError(errorMessage);
  }
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
  if (!array.every((item) => typeof item === "function")) {
    const itemTypes = array.map(
      (item) => typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item
    ).join(", ");
    throw new TypeError(`${errorMessage}[${itemTypes}]`);
  }
}
var ensureIsArray = (item) => {
  return Array.isArray(item) ? item : [item];
};
function getDependencies(createSelectorArgs) {
  const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
  assertIsArrayOfFunctions(
    dependencies,
    `createSelector expects all input-selectors to be functions, but received the following types: `
  );
  return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
  const inputSelectorResults = [];
  const { length } = dependencies;
  for (let i = 0; i < length; i++) {
    inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
  }
  return inputSelectorResults;
}
var getDevModeChecksExecutionInfo = (firstRun, devModeChecks) => {
  const { identityFunctionCheck, inputStabilityCheck } = {
    ...globalDevModeChecks,
    ...devModeChecks
  };
  return {
    identityFunctionCheck: {
      shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
      run: runIdentityFunctionCheck
    },
    inputStabilityCheck: {
      shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
      run: runInputStabilityCheck
    }
  };
};

// src/autotrackMemoize/autotracking.ts
var $REVISION = 0;
var CURRENT_TRACKER = null;
var Cell = class {
  revision = $REVISION;
  _value;
  _lastValue;
  _isEqual = tripleEq;
  constructor(initialValue, isEqual = tripleEq) {
    this._value = this._lastValue = initialValue;
    this._isEqual = isEqual;
  }
  // Whenever a storage value is read, it'll add itself to the current tracker if
  // one exists, entangling its state with that cache.
  get value() {
    CURRENT_TRACKER?.add(this);
    return this._value;
  }
  // Whenever a storage value is updated, we bump the global revision clock,
  // assign the revision for this storage to the new value, _and_ we schedule a
  // rerender. This is important, and it's what makes autotracking  _pull_
  // based. We don't actively tell the caches which depend on the storage that
  // anything has happened. Instead, we recompute the caches when needed.
  set value(newValue) {
    if (this.value === newValue)
      return;
    this._value = newValue;
    this.revision = ++$REVISION;
  }
};
function tripleEq(a, b) {
  return a === b;
}
var TrackingCache = class {
  _cachedValue;
  _cachedRevision = -1;
  _deps = [];
  hits = 0;
  fn;
  constructor(fn) {
    this.fn = fn;
  }
  clear() {
    this._cachedValue = void 0;
    this._cachedRevision = -1;
    this._deps = [];
    this.hits = 0;
  }
  get value() {
    if (this.revision > this._cachedRevision) {
      const { fn } = this;
      const currentTracker = /* @__PURE__ */ new Set();
      const prevTracker = CURRENT_TRACKER;
      CURRENT_TRACKER = currentTracker;
      this._cachedValue = fn();
      CURRENT_TRACKER = prevTracker;
      this.hits++;
      this._deps = Array.from(currentTracker);
      this._cachedRevision = this.revision;
    }
    CURRENT_TRACKER?.add(this);
    return this._cachedValue;
  }
  get revision() {
    return Math.max(...this._deps.map((d) => d.revision), 0);
  }
};
function getValue(cell) {
  if (!(cell instanceof Cell)) {
    console.warn("Not a valid cell! ", cell);
  }
  return cell.value;
}
function setValue(storage, value) {
  if (!(storage instanceof Cell)) {
    throw new TypeError(
      "setValue must be passed a tracked store created with `createStorage`."
    );
  }
  storage.value = storage._lastValue = value;
}
function createCell(initialValue, isEqual = tripleEq) {
  return new Cell(initialValue, isEqual);
}
function createCache(fn) {
  assertIsFunction(
    fn,
    "the first parameter to `createCache` must be a function"
  );
  return new TrackingCache(fn);
}

// src/autotrackMemoize/tracking.ts
var neverEq = (a, b) => false;
function createTag() {
  return createCell(null, neverEq);
}
function dirtyTag(tag, value) {
  setValue(tag, value);
}
var consumeCollection = (node) => {
  let tag = node.collectionTag;
  if (tag === null) {
    tag = node.collectionTag = createTag();
  }
  getValue(tag);
};
var dirtyCollection = (node) => {
  const tag = node.collectionTag;
  if (tag !== null) {
    dirtyTag(tag, null);
  }
};

// src/autotrackMemoize/proxy.ts
var REDUX_PROXY_LABEL = Symbol();
var nextId = 0;
var proto = Object.getPrototypeOf({});
var ObjectTreeNode = class {
  constructor(value) {
    this.value = value;
    this.value = value;
    this.tag.value = value;
  }
  proxy = new Proxy(this, objectProxyHandler);
  tag = createTag();
  tags = {};
  children = {};
  collectionTag = null;
  id = nextId++;
};
var objectProxyHandler = {
  get(node, key) {
    function calculateResult() {
      const { value } = node;
      const childValue = Reflect.get(value, key);
      if (typeof key === "symbol") {
        return childValue;
      }
      if (key in proto) {
        return childValue;
      }
      if (typeof childValue === "object" && childValue !== null) {
        let childNode = node.children[key];
        if (childNode === void 0) {
          childNode = node.children[key] = createNode(childValue);
        }
        if (childNode.tag) {
          getValue(childNode.tag);
        }
        return childNode.proxy;
      } else {
        let tag = node.tags[key];
        if (tag === void 0) {
          tag = node.tags[key] = createTag();
          tag.value = childValue;
        }
        getValue(tag);
        return childValue;
      }
    }
    const res = calculateResult();
    return res;
  },
  ownKeys(node) {
    consumeCollection(node);
    return Reflect.ownKeys(node.value);
  },
  getOwnPropertyDescriptor(node, prop) {
    return Reflect.getOwnPropertyDescriptor(node.value, prop);
  },
  has(node, prop) {
    return Reflect.has(node.value, prop);
  }
};
var ArrayTreeNode = class {
  constructor(value) {
    this.value = value;
    this.value = value;
    this.tag.value = value;
  }
  proxy = new Proxy([this], arrayProxyHandler);
  tag = createTag();
  tags = {};
  children = {};
  collectionTag = null;
  id = nextId++;
};
var arrayProxyHandler = {
  get([node], key) {
    if (key === "length") {
      consumeCollection(node);
    }
    return objectProxyHandler.get(node, key);
  },
  ownKeys([node]) {
    return objectProxyHandler.ownKeys(node);
  },
  getOwnPropertyDescriptor([node], prop) {
    return objectProxyHandler.getOwnPropertyDescriptor(node, prop);
  },
  has([node], prop) {
    return objectProxyHandler.has(node, prop);
  }
};
function createNode(value) {
  if (Array.isArray(value)) {
    return new ArrayTreeNode(value);
  }
  return new ObjectTreeNode(value);
}
function updateNode(node, newValue) {
  const { value, tags, children } = node;
  node.value = newValue;
  if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) {
    dirtyCollection(node);
  } else {
    if (value !== newValue) {
      let oldKeysSize = 0;
      let newKeysSize = 0;
      let anyKeysAdded = false;
      for (const _key in value) {
        oldKeysSize++;
      }
      for (const key in newValue) {
        newKeysSize++;
        if (!(key in value)) {
          anyKeysAdded = true;
          break;
        }
      }
      const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
      if (isDifferent) {
        dirtyCollection(node);
      }
    }
  }
  for (const key in tags) {
    const childValue = value[key];
    const newChildValue = newValue[key];
    if (childValue !== newChildValue) {
      dirtyCollection(node);
      dirtyTag(tags[key], newChildValue);
    }
    if (typeof newChildValue === "object" && newChildValue !== null) {
      delete tags[key];
    }
  }
  for (const key in children) {
    const childNode = children[key];
    const newChildValue = newValue[key];
    const childValue = childNode.value;
    if (childValue === newChildValue) {
      continue;
    } else if (typeof newChildValue === "object" && newChildValue !== null) {
      updateNode(childNode, newChildValue);
    } else {
      deleteNode(childNode);
      delete children[key];
    }
  }
}
function deleteNode(node) {
  if (node.tag) {
    dirtyTag(node.tag, null);
  }
  dirtyCollection(node);
  for (const key in node.tags) {
    dirtyTag(node.tags[key], null);
  }
  for (const key in node.children) {
    deleteNode(node.children[key]);
  }
}

// src/lruMemoize.ts
function createSingletonCache(equals) {
  let entry;
  return {
    get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }
      return NOT_FOUND;
    },
    put(key, value) {
      entry = { key, value };
    },
    getEntries() {
      return entry ? [entry] : [];
    },
    clear() {
      entry = void 0;
    }
  };
}
function createLruCache(maxSize, equals) {
  let entries = [];
  function get(key) {
    const cacheIndex = entries.findIndex((entry) => equals(key, entry.key));
    if (cacheIndex > -1) {
      const entry = entries[cacheIndex];
      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }
      return entry.value;
    }
    return NOT_FOUND;
  }
  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      entries.unshift({ key, value });
      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }
  function getEntries() {
    return entries;
  }
  function clear() {
    entries = [];
  }
  return { get, put, getEntries, clear };
}
var referenceEqualityCheck = (a, b) => a === b;
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    }
    const { length } = prev;
    for (let i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }
    return true;
  };
}
function lruMemoize(func, equalityCheckOrOptions) {
  const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : { equalityCheck: equalityCheckOrOptions };
  const {
    equalityCheck = referenceEqualityCheck,
    maxSize = 1,
    resultEqualityCheck
  } = providedOptions;
  const comparator = createCacheKeyComparator(equalityCheck);
  let resultsCount = 0;
  const cache = maxSize <= 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
  function memoized() {
    let value = cache.get(arguments);
    if (value === NOT_FOUND) {
      value = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        const entries = cache.getEntries();
        const matchingEntry = entries.find(
          (entry) => resultEqualityCheck(entry.value, value)
        );
        if (matchingEntry) {
          value = matchingEntry.value;
          resultsCount !== 0 && resultsCount--;
        }
      }
      cache.put(arguments, value);
    }
    return value;
  }
  memoized.clearCache = () => {
    cache.clear();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = () => resultsCount;
  memoized.resetResultsCount = () => {
    resultsCount = 0;
  };
  return memoized;
}

// src/autotrackMemoize/autotrackMemoize.ts
function autotrackMemoize(func) {
  const node = createNode(
    []
  );
  let lastArgs = null;
  const shallowEqual = createCacheKeyComparator(referenceEqualityCheck);
  const cache = createCache(() => {
    const res = func.apply(null, node.proxy);
    return res;
  });
  function memoized() {
    if (!shallowEqual(lastArgs, arguments)) {
      updateNode(node, arguments);
      lastArgs = arguments;
    }
    return cache.value;
  }
  memoized.clearCache = () => {
    return cache.clear();
  };
  return memoized;
}

// src/weakMapMemoize.ts
var StrongRef = class {
  constructor(value) {
    this.value = value;
  }
  deref() {
    return this.value;
  }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
  return {
    s: UNTERMINATED,
    v: void 0,
    o: null,
    p: null
  };
}
function weakMapMemoize(func, options = {}) {
  let fnNode = createCacheNode();
  const { resultEqualityCheck } = options;
  let lastResult;
  let resultsCount = 0;
  function memoized() {
    let cacheNode = fnNode;
    const { length } = arguments;
    for (let i = 0, l = length; i < l; i++) {
      const arg = arguments[i];
      if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
        let objectCache = cacheNode.o;
        if (objectCache === null) {
          cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
        }
        const objectNode = objectCache.get(arg);
        if (objectNode === void 0) {
          cacheNode = createCacheNode();
          objectCache.set(arg, cacheNode);
        } else {
          cacheNode = objectNode;
        }
      } else {
        let primitiveCache = cacheNode.p;
        if (primitiveCache === null) {
          cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
        }
        const primitiveNode = primitiveCache.get(arg);
        if (primitiveNode === void 0) {
          cacheNode = createCacheNode();
          primitiveCache.set(arg, cacheNode);
        } else {
          cacheNode = primitiveNode;
        }
      }
    }
    const terminatedNode = cacheNode;
    let result;
    if (cacheNode.s === TERMINATED) {
      result = cacheNode.v;
    } else {
      result = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        const lastResultValue = lastResult?.deref?.() ?? lastResult;
        if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
          result = lastResultValue;
          resultsCount !== 0 && resultsCount--;
        }
        const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
        lastResult = needsWeakRef ? new Ref(result) : result;
      }
    }
    terminatedNode.s = TERMINATED;
    terminatedNode.v = result;
    return result;
  }
  memoized.clearCache = () => {
    fnNode = createCacheNode();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = () => resultsCount;
  memoized.resetResultsCount = () => {
    resultsCount = 0;
  };
  return memoized;
}

// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
  const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
    memoize: memoizeOrOptions,
    memoizeOptions: memoizeOptionsFromArgs
  } : memoizeOrOptions;
  const createSelector2 = (...createSelectorArgs) => {
    let recomputations = 0;
    let dependencyRecomputations = 0;
    let lastResult;
    let directlyPassedOptions = {};
    let resultFunc = createSelectorArgs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = createSelectorArgs.pop();
    }
    assertIsFunction(
      resultFunc,
      `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`
    );
    const combinedOptions = {
      ...createSelectorCreatorOptions,
      ...directlyPassedOptions
    };
    const {
      memoize,
      memoizeOptions = [],
      argsMemoize = weakMapMemoize,
      argsMemoizeOptions = [],
      devModeChecks = {}
    } = combinedOptions;
    const finalMemoizeOptions = ensureIsArray(memoizeOptions);
    const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
    const dependencies = getDependencies(createSelectorArgs);
    const memoizedResultFunc = memoize(function recomputationWrapper() {
      recomputations++;
      return resultFunc.apply(
        null,
        arguments
      );
    }, ...finalMemoizeOptions);
    let firstRun = true;
    const selector = argsMemoize(function dependenciesChecker() {
      dependencyRecomputations++;
      const inputSelectorResults = collectInputSelectorResults(
        dependencies,
        arguments
      );
      lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
      if (false) {}
      return lastResult;
    }, ...finalArgsMemoizeOptions);
    return Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      dependencyRecomputations: () => dependencyRecomputations,
      resetDependencyRecomputations: () => {
        dependencyRecomputations = 0;
      },
      lastResult: () => lastResult,
      recomputations: () => recomputations,
      resetRecomputations: () => {
        recomputations = 0;
      },
      memoize,
      argsMemoize
    });
  };
  Object.assign(createSelector2, {
    withTypes: () => createSelector2
  });
  return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);

// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign(
  (inputSelectorsObject, selectorCreator = createSelector) => {
    assertIsObject(
      inputSelectorsObject,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`
    );
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map(
      (key) => inputSelectorsObject[key]
    );
    const structuredSelector = selectorCreator(
      dependencies,
      (...inputSelectorResults) => {
        return inputSelectorResults.reduce((composition, value, index) => {
          composition[inputSelectorKeys[index]] = value;
          return composition;
        }, {});
      }
    );
    return structuredSelector;
  },
  { withTypes: () => createStructuredSelector }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);
//# sourceMappingURL=reselect.cjs.map

/***/ }),

/***/ 3629:
/***/ (function(module) {

"use strict";
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function isArray(value) {
  return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
}

// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
var INFINITY = 1 / 0;
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
function toString(value) {
  return value == null ? '' : baseToString(value);
}
function isString(value) {
  return typeof value === 'string';
}
function isNumber(value) {
  return typeof value === 'number';
}

// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function isBoolean(value) {
  return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
}
function isObject(value) {
  return _typeof(value) === 'object';
}

// Checks if `value` is object-like.
function isObjectLike(value) {
  return isObject(value) && value !== null;
}
function isDefined(value) {
  return value !== undefined && value !== null;
}
function isBlank(value) {
  return !value.trim().length;
}

// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function getTag(value) {
  return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}

var EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
var INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
var LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = function LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key) {
  return "Invalid value for key ".concat(key);
};
var PATTERN_LENGTH_TOO_LARGE = function PATTERN_LENGTH_TOO_LARGE(max) {
  return "Pattern length exceeds max of ".concat(max, ".");
};
var MISSING_KEY_PROPERTY = function MISSING_KEY_PROPERTY(name) {
  return "Missing ".concat(name, " property in key");
};
var INVALID_KEY_WEIGHT_VALUE = function INVALID_KEY_WEIGHT_VALUE(key) {
  return "Property 'weight' in key '".concat(key, "' must be a positive integer");
};

var hasOwn = Object.prototype.hasOwnProperty;
var KeyStore = /*#__PURE__*/function () {
  function KeyStore(keys) {
    var _this = this;
    _classCallCheck(this, KeyStore);
    this._keys = [];
    this._keyMap = {};
    var totalWeight = 0;
    keys.forEach(function (key) {
      var obj = createKey(key);
      _this._keys.push(obj);
      _this._keyMap[obj.id] = obj;
      totalWeight += obj.weight;
    });

    // Normalize weights so that their sum is equal to 1
    this._keys.forEach(function (key) {
      key.weight /= totalWeight;
    });
  }
  _createClass(KeyStore, [{
    key: "get",
    value: function get(keyId) {
      return this._keyMap[keyId];
    }
  }, {
    key: "keys",
    value: function keys() {
      return this._keys;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return JSON.stringify(this._keys);
    }
  }]);
  return KeyStore;
}();
function createKey(key) {
  var path = null;
  var id = null;
  var src = null;
  var weight = 1;
  var getFn = null;
  if (isString(key) || isArray(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, 'name')) {
      throw new Error(MISSING_KEY_PROPERTY('name'));
    }
    var name = key.name;
    src = name;
    if (hasOwn.call(key, 'weight')) {
      weight = key.weight;
      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
      }
    }
    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }
  return {
    path: path,
    id: id,
    weight: weight,
    src: src,
    getFn: getFn
  };
}
function createKeyPath(key) {
  return isArray(key) ? key : key.split('.');
}
function createKeyId(key) {
  return isArray(key) ? key.join('.') : key;
}

function get(obj, path) {
  var list = [];
  var arr = false;
  var deepGet = function deepGet(obj, path, index) {
    if (!isDefined(obj)) {
      return;
    }
    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      var key = path[index];
      var value = obj[key];
      if (!isDefined(value)) {
        return;
      }

      // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list
      if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) {
        list.push(toString(value));
      } else if (isArray(value)) {
        arr = true;
        // Search each item in the array.
        for (var i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  };

  // Backwards compatibility (since path used to be a string)
  deepGet(obj, isString(path) ? path.split('.') : path, 0);
  return arr ? list : list[0];
}

var MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};
var BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: function sortFn(a, b) {
    return a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1;
  }
};
var FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};
var AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};
var Config = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, BasicOptions), MatchOptions), FuzzyOptions), AdvancedOptions);

var SPACE = /[^ ]+/g;

// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function norm() {
  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var mantissa = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var cache = new Map();
  var m = Math.pow(10, mantissa);
  return {
    get: function get(value) {
      var numTokens = value.match(SPACE).length;
      if (cache.has(numTokens)) {
        return cache.get(numTokens);
      }

      // Default function is 1/sqrt(x), weight makes that variable
      var norm = 1 / Math.pow(numTokens, 0.5 * weight);

      // In place of `toFixed(mantissa)`, for faster computation
      var n = parseFloat(Math.round(norm * m) / m);
      cache.set(numTokens, n);
      return n;
    },
    clear: function clear() {
      cache.clear();
    }
  };
}

var FuseIndex = /*#__PURE__*/function () {
  function FuseIndex() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$getFn = _ref.getFn,
      getFn = _ref$getFn === void 0 ? Config.getFn : _ref$getFn,
      _ref$fieldNormWeight = _ref.fieldNormWeight,
      fieldNormWeight = _ref$fieldNormWeight === void 0 ? Config.fieldNormWeight : _ref$fieldNormWeight;
    _classCallCheck(this, FuseIndex);
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;
    this.setIndexRecords();
  }
  _createClass(FuseIndex, [{
    key: "setSources",
    value: function setSources() {
      var docs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.docs = docs;
    }
  }, {
    key: "setIndexRecords",
    value: function setIndexRecords() {
      var records = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.records = records;
    }
  }, {
    key: "setKeys",
    value: function setKeys() {
      var _this = this;
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.keys = keys;
      this._keysMap = {};
      keys.forEach(function (key, idx) {
        _this._keysMap[key.id] = idx;
      });
    }
  }, {
    key: "create",
    value: function create() {
      var _this2 = this;
      if (this.isCreated || !this.docs.length) {
        return;
      }
      this.isCreated = true;

      // List is Array<String>
      if (isString(this.docs[0])) {
        this.docs.forEach(function (doc, docIndex) {
          _this2._addString(doc, docIndex);
        });
      } else {
        // List is Array<Object>
        this.docs.forEach(function (doc, docIndex) {
          _this2._addObject(doc, docIndex);
        });
      }
      this.norm.clear();
    }
    // Adds a doc to the end of the index
  }, {
    key: "add",
    value: function add(doc) {
      var idx = this.size();
      if (isString(doc)) {
        this._addString(doc, idx);
      } else {
        this._addObject(doc, idx);
      }
    }
    // Removes the doc at the specified index of the index
  }, {
    key: "removeAt",
    value: function removeAt(idx) {
      this.records.splice(idx, 1);

      // Change ref index of every subsquent doc
      for (var i = idx, len = this.size(); i < len; i += 1) {
        this.records[i].i -= 1;
      }
    }
  }, {
    key: "getValueForItemAtKeyId",
    value: function getValueForItemAtKeyId(item, keyId) {
      return item[this._keysMap[keyId]];
    }
  }, {
    key: "size",
    value: function size() {
      return this.records.length;
    }
  }, {
    key: "_addString",
    value: function _addString(doc, docIndex) {
      if (!isDefined(doc) || isBlank(doc)) {
        return;
      }
      var record = {
        v: doc,
        i: docIndex,
        n: this.norm.get(doc)
      };
      this.records.push(record);
    }
  }, {
    key: "_addObject",
    value: function _addObject(doc, docIndex) {
      var _this3 = this;
      var record = {
        i: docIndex,
        $: {}
      };

      // Iterate over every key (i.e, path), and fetch the value at that key
      this.keys.forEach(function (key, keyIndex) {
        var value = key.getFn ? key.getFn(doc) : _this3.getFn(doc, key.path);
        if (!isDefined(value)) {
          return;
        }
        if (isArray(value)) {
          var subRecords = [];
          var stack = [{
            nestedArrIndex: -1,
            value: value
          }];
          while (stack.length) {
            var _stack$pop = stack.pop(),
              nestedArrIndex = _stack$pop.nestedArrIndex,
              _value = _stack$pop.value;
            if (!isDefined(_value)) {
              continue;
            }
            if (isString(_value) && !isBlank(_value)) {
              var subRecord = {
                v: _value,
                i: nestedArrIndex,
                n: _this3.norm.get(_value)
              };
              subRecords.push(subRecord);
            } else if (isArray(_value)) {
              _value.forEach(function (item, k) {
                stack.push({
                  nestedArrIndex: k,
                  value: item
                });
              });
            } else ;
          }
          record.$[keyIndex] = subRecords;
        } else if (isString(value) && !isBlank(value)) {
          var _subRecord = {
            v: value,
            n: _this3.norm.get(value)
          };
          record.$[keyIndex] = _subRecord;
        }
      });
      this.records.push(record);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        keys: this.keys,
        records: this.records
      };
    }
  }]);
  return FuseIndex;
}();
function createIndex(keys, docs) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$getFn = _ref2.getFn,
    getFn = _ref2$getFn === void 0 ? Config.getFn : _ref2$getFn,
    _ref2$fieldNormWeight = _ref2.fieldNormWeight,
    fieldNormWeight = _ref2$fieldNormWeight === void 0 ? Config.fieldNormWeight : _ref2$fieldNormWeight;
  var myIndex = new FuseIndex({
    getFn: getFn,
    fieldNormWeight: fieldNormWeight
  });
  myIndex.setKeys(keys.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex;
}
function parseIndex(data) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$getFn = _ref3.getFn,
    getFn = _ref3$getFn === void 0 ? Config.getFn : _ref3$getFn,
    _ref3$fieldNormWeight = _ref3.fieldNormWeight,
    fieldNormWeight = _ref3$fieldNormWeight === void 0 ? Config.fieldNormWeight : _ref3$fieldNormWeight;
  var keys = data.keys,
    records = data.records;
  var myIndex = new FuseIndex({
    getFn: getFn,
    fieldNormWeight: fieldNormWeight
  });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex;
}

function computeScore$1(pattern) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$errors = _ref.errors,
    errors = _ref$errors === void 0 ? 0 : _ref$errors,
    _ref$currentLocation = _ref.currentLocation,
    currentLocation = _ref$currentLocation === void 0 ? 0 : _ref$currentLocation,
    _ref$expectedLocation = _ref.expectedLocation,
    expectedLocation = _ref$expectedLocation === void 0 ? 0 : _ref$expectedLocation,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
    _ref$ignoreLocation = _ref.ignoreLocation,
    ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
  var accuracy = errors / pattern.length;
  if (ignoreLocation) {
    return accuracy;
  }
  var proximity = Math.abs(expectedLocation - currentLocation);
  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
  }
  return accuracy + proximity / distance;
}

function convertMaskToIndices() {
  var matchmask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var minMatchCharLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Config.minMatchCharLength;
  var indices = [];
  var start = -1;
  var end = -1;
  var i = 0;
  for (var len = matchmask.length; i < len; i += 1) {
    var match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }
  return indices;
}

// Machine word size
var MAX_BITS = 32;

function search(text, pattern, patternAlphabet) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? Config.location : _ref$location,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
    _ref$findAllMatches = _ref.findAllMatches,
    findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
    _ref$minMatchCharLeng = _ref.minMatchCharLength,
    minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
    _ref$includeMatches = _ref.includeMatches,
    includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
    _ref$ignoreLocation = _ref.ignoreLocation,
    ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
  }
  var patternLen = pattern.length;
  // Set starting location at beginning text and initialize the alphabet.
  var textLen = text.length;
  // Handle the case when location > text.length
  var expectedLocation = Math.max(0, Math.min(location, textLen));
  // Highest score beyond which we give up.
  var currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  var bestLocation = expectedLocation;

  // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.
  var computeMatches = minMatchCharLength > 1 || includeMatches;
  // A mask of the matches, used for building the indices
  var matchMask = computeMatches ? Array(textLen) : [];
  var index;

  // Get all exact matches, here for speed up
  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    var score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation: expectedLocation,
      distance: distance,
      ignoreLocation: ignoreLocation
    });
    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;
    if (computeMatches) {
      var i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }

  // Reset the best location
  bestLocation = -1;
  var lastBitArr = [];
  var finalScore = 1;
  var binMax = patternLen + textLen;
  var mask = 1 << patternLen - 1;
  for (var _i = 0; _i < patternLen; _i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    var binMin = 0;
    var binMid = binMax;
    while (binMin < binMid) {
      var _score = computeScore$1(pattern, {
        errors: _i,
        currentLocation: expectedLocation + binMid,
        expectedLocation: expectedLocation,
        distance: distance,
        ignoreLocation: ignoreLocation
      });
      if (_score <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }
      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;
    var start = Math.max(1, expectedLocation - binMid + 1);
    var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    var bitArr = Array(finish + 2);
    bitArr[finish + 1] = (1 << _i) - 1;
    for (var j = finish; j >= start; j -= 1) {
      var currentLocation = j - 1;
      var charMatch = patternAlphabet[text.charAt(currentLocation)];
      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      }

      // First pass: exact match
      bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (_i) {
        bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
      }
      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: _i,
          currentLocation: currentLocation,
          expectedLocation: expectedLocation,
          distance: distance,
          ignoreLocation: ignoreLocation
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break;
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    var _score2 = computeScore$1(pattern, {
      errors: _i + 1,
      currentLocation: expectedLocation,
      expectedLocation: expectedLocation,
      distance: distance,
      ignoreLocation: ignoreLocation
    });
    if (_score2 > currentThreshold) {
      break;
    }
    lastBitArr = bitArr;
  }
  var result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };
  if (computeMatches) {
    var indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }
  return result;
}

function createPatternAlphabet(pattern) {
  var mask = {};
  for (var i = 0, len = pattern.length; i < len; i += 1) {
    var _char = pattern.charAt(i);
    mask[_char] = (mask[_char] || 0) | 1 << len - i - 1;
  }
  return mask;
}

var BitapSearch = /*#__PURE__*/function () {
  function BitapSearch(pattern) {
    var _this = this;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$location = _ref.location,
      location = _ref$location === void 0 ? Config.location : _ref$location,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
      _ref$distance = _ref.distance,
      distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
      _ref$includeMatches = _ref.includeMatches,
      includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
      _ref$findAllMatches = _ref.findAllMatches,
      findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
      _ref$minMatchCharLeng = _ref.minMatchCharLength,
      minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
      _ref$isCaseSensitive = _ref.isCaseSensitive,
      isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive,
      _ref$ignoreLocation = _ref.ignoreLocation,
      ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
    _classCallCheck(this, BitapSearch);
    this.options = {
      location: location,
      threshold: threshold,
      distance: distance,
      includeMatches: includeMatches,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      isCaseSensitive: isCaseSensitive,
      ignoreLocation: ignoreLocation
    };
    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.chunks = [];
    if (!this.pattern.length) {
      return;
    }
    var addChunk = function addChunk(pattern, startIndex) {
      _this.chunks.push({
        pattern: pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex: startIndex
      });
    };
    var len = this.pattern.length;
    if (len > MAX_BITS) {
      var i = 0;
      var remainder = len % MAX_BITS;
      var end = len - remainder;
      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }
      if (remainder) {
        var startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }
  _createClass(BitapSearch, [{
    key: "searchIn",
    value: function searchIn(text) {
      var _this$options = this.options,
        isCaseSensitive = _this$options.isCaseSensitive,
        includeMatches = _this$options.includeMatches;
      if (!isCaseSensitive) {
        text = text.toLowerCase();
      }

      // Exact match
      if (this.pattern === text) {
        var _result = {
          isMatch: true,
          score: 0
        };
        if (includeMatches) {
          _result.indices = [[0, text.length - 1]];
        }
        return _result;
      }

      // Otherwise, use Bitap algorithm
      var _this$options2 = this.options,
        location = _this$options2.location,
        distance = _this$options2.distance,
        threshold = _this$options2.threshold,
        findAllMatches = _this$options2.findAllMatches,
        minMatchCharLength = _this$options2.minMatchCharLength,
        ignoreLocation = _this$options2.ignoreLocation;
      var allIndices = [];
      var totalScore = 0;
      var hasMatches = false;
      this.chunks.forEach(function (_ref2) {
        var pattern = _ref2.pattern,
          alphabet = _ref2.alphabet,
          startIndex = _ref2.startIndex;
        var _search = search(text, pattern, alphabet, {
            location: location + startIndex,
            distance: distance,
            threshold: threshold,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            includeMatches: includeMatches,
            ignoreLocation: ignoreLocation
          }),
          isMatch = _search.isMatch,
          score = _search.score,
          indices = _search.indices;
        if (isMatch) {
          hasMatches = true;
        }
        totalScore += score;
        if (isMatch && indices) {
          allIndices = [].concat(_toConsumableArray(allIndices), _toConsumableArray(indices));
        }
      });
      var result = {
        isMatch: hasMatches,
        score: hasMatches ? totalScore / this.chunks.length : 1
      };
      if (hasMatches && includeMatches) {
        result.indices = allIndices;
      }
      return result;
    }
  }]);
  return BitapSearch;
}();

var BaseMatch = /*#__PURE__*/function () {
  function BaseMatch(pattern) {
    _classCallCheck(this, BaseMatch);
    this.pattern = pattern;
  }
  _createClass(BaseMatch, [{
    key: "search",
    value: function search( /*text*/) {}
  }], [{
    key: "isMultiMatch",
    value: function isMultiMatch(pattern) {
      return getMatch(pattern, this.multiRegex);
    }
  }, {
    key: "isSingleMatch",
    value: function isSingleMatch(pattern) {
      return getMatch(pattern, this.singleRegex);
    }
  }]);
  return BaseMatch;
}();
function getMatch(pattern, exp) {
  var matches = pattern.match(exp);
  return matches ? matches[1] : null;
}

var ExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(ExactMatch, _BaseMatch);
  var _super = _createSuper(ExactMatch);
  function ExactMatch(pattern) {
    _classCallCheck(this, ExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(ExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text === this.pattern;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, this.pattern.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^="(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^=(.*)$/;
    }
  }]);
  return ExactMatch;
}(BaseMatch);

var InverseExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(InverseExactMatch, _BaseMatch);
  var _super = _createSuper(InverseExactMatch);
  function InverseExactMatch(pattern) {
    _classCallCheck(this, InverseExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(InverseExactMatch, [{
    key: "search",
    value: function search(text) {
      var index = text.indexOf(this.pattern);
      var isMatch = index === -1;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!(.*)$/;
    }
  }]);
  return InverseExactMatch;
}(BaseMatch);

var PrefixExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(PrefixExactMatch, _BaseMatch);
  var _super = _createSuper(PrefixExactMatch);
  function PrefixExactMatch(pattern) {
    _classCallCheck(this, PrefixExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(PrefixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text.startsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, this.pattern.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'prefix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^\^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^\^(.*)$/;
    }
  }]);
  return PrefixExactMatch;
}(BaseMatch);

var InversePrefixExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(InversePrefixExactMatch, _BaseMatch);
  var _super = _createSuper(InversePrefixExactMatch);
  function InversePrefixExactMatch(pattern) {
    _classCallCheck(this, InversePrefixExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(InversePrefixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = !text.startsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-prefix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!\^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!\^(.*)$/;
    }
  }]);
  return InversePrefixExactMatch;
}(BaseMatch);

var SuffixExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(SuffixExactMatch, _BaseMatch);
  var _super = _createSuper(SuffixExactMatch);
  function SuffixExactMatch(pattern) {
    _classCallCheck(this, SuffixExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(SuffixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text.endsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [text.length - this.pattern.length, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'suffix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^"(.*)"\$$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^(.*)\$$/;
    }
  }]);
  return SuffixExactMatch;
}(BaseMatch);

var InverseSuffixExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(InverseSuffixExactMatch, _BaseMatch);
  var _super = _createSuper(InverseSuffixExactMatch);
  function InverseSuffixExactMatch(pattern) {
    _classCallCheck(this, InverseSuffixExactMatch);
    return _super.call(this, pattern);
  }
  _createClass(InverseSuffixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = !text.endsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-suffix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!"(.*)"\$$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!(.*)\$$/;
    }
  }]);
  return InverseSuffixExactMatch;
}(BaseMatch);

var FuzzyMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(FuzzyMatch, _BaseMatch);
  var _super = _createSuper(FuzzyMatch);
  function FuzzyMatch(pattern) {
    var _this;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$location = _ref.location,
      location = _ref$location === void 0 ? Config.location : _ref$location,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
      _ref$distance = _ref.distance,
      distance = _ref$distance === void 0 ? Config.distance : _ref$distance,
      _ref$includeMatches = _ref.includeMatches,
      includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
      _ref$findAllMatches = _ref.findAllMatches,
      findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
      _ref$minMatchCharLeng = _ref.minMatchCharLength,
      minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
      _ref$isCaseSensitive = _ref.isCaseSensitive,
      isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive,
      _ref$ignoreLocation = _ref.ignoreLocation,
      ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
    _classCallCheck(this, FuzzyMatch);
    _this = _super.call(this, pattern);
    _this._bitapSearch = new BitapSearch(pattern, {
      location: location,
      threshold: threshold,
      distance: distance,
      includeMatches: includeMatches,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      isCaseSensitive: isCaseSensitive,
      ignoreLocation: ignoreLocation
    });
    return _this;
  }
  _createClass(FuzzyMatch, [{
    key: "search",
    value: function search(text) {
      return this._bitapSearch.searchIn(text);
    }
  }], [{
    key: "type",
    get: function get() {
      return 'fuzzy';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^(.*)$/;
    }
  }]);
  return FuzzyMatch;
}(BaseMatch);

var IncludeMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits(IncludeMatch, _BaseMatch);
  var _super = _createSuper(IncludeMatch);
  function IncludeMatch(pattern) {
    _classCallCheck(this, IncludeMatch);
    return _super.call(this, pattern);
  }
  _createClass(IncludeMatch, [{
    key: "search",
    value: function search(text) {
      var location = 0;
      var index;
      var indices = [];
      var patternLen = this.pattern.length;

      // Get all exact matches
      while ((index = text.indexOf(this.pattern, location)) > -1) {
        location = index + patternLen;
        indices.push([index, location - 1]);
      }
      var isMatch = !!indices.length;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: indices
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'include';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^'"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^'(.*)$/;
    }
  }]);
  return IncludeMatch;
}(BaseMatch);

// ❗Order is important. DO NOT CHANGE.
var searchers = [ExactMatch, IncludeMatch, PrefixExactMatch, InversePrefixExactMatch, InverseSuffixExactMatch, SuffixExactMatch, InverseExactMatch, FuzzyMatch];
var searchersLen = searchers.length;

// Regex to split by spaces, but keep anything in quotes together
var SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
var OR_TOKEN = '|';

// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function parseQuery(pattern) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return pattern.split(OR_TOKEN).map(function (item) {
    var query = item.trim().split(SPACE_RE).filter(function (item) {
      return item && !!item.trim();
    });
    var results = [];
    for (var i = 0, len = query.length; i < len; i += 1) {
      var queryItem = query[i];

      // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
      var found = false;
      var idx = -1;
      while (!found && ++idx < searchersLen) {
        var searcher = searchers[idx];
        var token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }
      if (found) {
        continue;
      }

      // 2. Handle single query matches (i.e, once that are *not* quoted)
      idx = -1;
      while (++idx < searchersLen) {
        var _searcher = searchers[idx];
        var _token = _searcher.isSingleMatch(queryItem);
        if (_token) {
          results.push(new _searcher(_token, options));
          break;
        }
      }
    }
    return results;
  });
}

// These extended matchers can return an array of matches, as opposed
// to a singl match
var MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */
var ExtendedSearch = /*#__PURE__*/function () {
  function ExtendedSearch(pattern) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$isCaseSensitive = _ref.isCaseSensitive,
      isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive,
      _ref$includeMatches = _ref.includeMatches,
      includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
      _ref$minMatchCharLeng = _ref.minMatchCharLength,
      minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng,
      _ref$ignoreLocation = _ref.ignoreLocation,
      ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation,
      _ref$findAllMatches = _ref.findAllMatches,
      findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches,
      _ref$location = _ref.location,
      location = _ref$location === void 0 ? Config.location : _ref$location,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold,
      _ref$distance = _ref.distance,
      distance = _ref$distance === void 0 ? Config.distance : _ref$distance;
    _classCallCheck(this, ExtendedSearch);
    this.query = null;
    this.options = {
      isCaseSensitive: isCaseSensitive,
      includeMatches: includeMatches,
      minMatchCharLength: minMatchCharLength,
      findAllMatches: findAllMatches,
      ignoreLocation: ignoreLocation,
      location: location,
      threshold: threshold,
      distance: distance
    };
    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }
  _createClass(ExtendedSearch, [{
    key: "searchIn",
    value: function searchIn(text) {
      var query = this.query;
      if (!query) {
        return {
          isMatch: false,
          score: 1
        };
      }
      var _this$options = this.options,
        includeMatches = _this$options.includeMatches,
        isCaseSensitive = _this$options.isCaseSensitive;
      text = isCaseSensitive ? text : text.toLowerCase();
      var numMatches = 0;
      var allIndices = [];
      var totalScore = 0;

      // ORs
      for (var i = 0, qLen = query.length; i < qLen; i += 1) {
        var searchers = query[i];

        // Reset indices
        allIndices.length = 0;
        numMatches = 0;

        // ANDs
        for (var j = 0, pLen = searchers.length; j < pLen; j += 1) {
          var searcher = searchers[j];
          var _searcher$search = searcher.search(text),
            isMatch = _searcher$search.isMatch,
            indices = _searcher$search.indices,
            score = _searcher$search.score;
          if (isMatch) {
            numMatches += 1;
            totalScore += score;
            if (includeMatches) {
              var type = searcher.constructor.type;
              if (MultiMatchSet.has(type)) {
                allIndices = [].concat(_toConsumableArray(allIndices), _toConsumableArray(indices));
              } else {
                allIndices.push(indices);
              }
            }
          } else {
            totalScore = 0;
            numMatches = 0;
            allIndices.length = 0;
            break;
          }
        }

        // OR condition, so if TRUE, return
        if (numMatches) {
          var result = {
            isMatch: true,
            score: totalScore / numMatches
          };
          if (includeMatches) {
            result.indices = allIndices;
          }
          return result;
        }
      }

      // Nothing was matched
      return {
        isMatch: false,
        score: 1
      };
    }
  }], [{
    key: "condition",
    value: function condition(_, options) {
      return options.useExtendedSearch;
    }
  }]);
  return ExtendedSearch;
}();

var registeredSearchers = [];
function register() {
  registeredSearchers.push.apply(registeredSearchers, arguments);
}
function createSearcher(pattern, options) {
  for (var i = 0, len = registeredSearchers.length; i < len; i += 1) {
    var searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options);
    }
  }
  return new BitapSearch(pattern, options);
}

var LogicalOperator = {
  AND: '$and',
  OR: '$or'
};
var KeyType = {
  PATH: '$path',
  PATTERN: '$val'
};
var isExpression = function isExpression(query) {
  return !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
};
var isPath = function isPath(query) {
  return !!query[KeyType.PATH];
};
var isLeaf = function isLeaf(query) {
  return !isArray(query) && isObject(query) && !isExpression(query);
};
var convertToExplicit = function convertToExplicit(query) {
  return _defineProperty({}, LogicalOperator.AND, Object.keys(query).map(function (key) {
    return _defineProperty({}, key, query[key]);
  }));
};

// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function parse(query, options) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref3$auto = _ref3.auto,
    auto = _ref3$auto === void 0 ? true : _ref3$auto;
  var next = function next(query) {
    var keys = Object.keys(query);
    var isQueryPath = isPath(query);
    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
      return next(convertToExplicit(query));
    }
    if (isLeaf(query)) {
      var key = isQueryPath ? query[KeyType.PATH] : keys[0];
      var pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
      if (!isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
      }
      var obj = {
        keyId: createKeyId(key),
        pattern: pattern
      };
      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }
      return obj;
    }
    var node = {
      children: [],
      operator: keys[0]
    };
    keys.forEach(function (key) {
      var value = query[key];
      if (isArray(value)) {
        value.forEach(function (item) {
          node.children.push(next(item));
        });
      }
    });
    return node;
  };
  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }
  return next(query);
}

// Practical scoring function
function computeScore(results, _ref) {
  var _ref$ignoreFieldNorm = _ref.ignoreFieldNorm,
    ignoreFieldNorm = _ref$ignoreFieldNorm === void 0 ? Config.ignoreFieldNorm : _ref$ignoreFieldNorm;
  results.forEach(function (result) {
    var totalScore = 1;
    result.matches.forEach(function (_ref2) {
      var key = _ref2.key,
        norm = _ref2.norm,
        score = _ref2.score;
      var weight = key ? key.weight : null;
      totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
    });
    result.score = totalScore;
  });
}

function transformMatches(result, data) {
  var matches = result.matches;
  data.matches = [];
  if (!isDefined(matches)) {
    return;
  }
  matches.forEach(function (match) {
    if (!isDefined(match.indices) || !match.indices.length) {
      return;
    }
    var indices = match.indices,
      value = match.value;
    var obj = {
      indices: indices,
      value: value
    };
    if (match.key) {
      obj.key = match.key.src;
    }
    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }
    data.matches.push(obj);
  });
}

function transformScore(result, data) {
  data.score = result.score;
}

function format(results, docs) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$includeMatches = _ref.includeMatches,
    includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches,
    _ref$includeScore = _ref.includeScore,
    includeScore = _ref$includeScore === void 0 ? Config.includeScore : _ref$includeScore;
  var transformers = [];
  if (includeMatches) transformers.push(transformMatches);
  if (includeScore) transformers.push(transformScore);
  return results.map(function (result) {
    var idx = result.idx;
    var data = {
      item: docs[idx],
      refIndex: idx
    };
    if (transformers.length) {
      transformers.forEach(function (transformer) {
        transformer(result, data);
      });
    }
    return data;
  });
}

var Fuse$1 = /*#__PURE__*/function () {
  function Fuse(docs) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var index = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, Fuse);
    this.options = _objectSpread2(_objectSpread2({}, Config), options);
    if (this.options.useExtendedSearch && !true) {}
    this._keyStore = new KeyStore(this.options.keys);
    this.setCollection(docs, index);
  }
  _createClass(Fuse, [{
    key: "setCollection",
    value: function setCollection(docs, index) {
      this._docs = docs;
      if (index && !(index instanceof FuseIndex)) {
        throw new Error(INCORRECT_INDEX_TYPE);
      }
      this._myIndex = index || createIndex(this.options.keys, this._docs, {
        getFn: this.options.getFn,
        fieldNormWeight: this.options.fieldNormWeight
      });
    }
  }, {
    key: "add",
    value: function add(doc) {
      if (!isDefined(doc)) {
        return;
      }
      this._docs.push(doc);
      this._myIndex.add(doc);
    }
  }, {
    key: "remove",
    value: function remove() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function /* doc, idx */ () {
        return false;
      };
      var results = [];
      for (var i = 0, len = this._docs.length; i < len; i += 1) {
        var doc = this._docs[i];
        if (predicate(doc, i)) {
          this.removeAt(i);
          i -= 1;
          len -= 1;
          results.push(doc);
        }
      }
      return results;
    }
  }, {
    key: "removeAt",
    value: function removeAt(idx) {
      this._docs.splice(idx, 1);
      this._myIndex.removeAt(idx);
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this._myIndex;
    }
  }, {
    key: "search",
    value: function search(query) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$limit = _ref.limit,
        limit = _ref$limit === void 0 ? -1 : _ref$limit;
      var _this$options = this.options,
        includeMatches = _this$options.includeMatches,
        includeScore = _this$options.includeScore,
        shouldSort = _this$options.shouldSort,
        sortFn = _this$options.sortFn,
        ignoreFieldNorm = _this$options.ignoreFieldNorm;
      var results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
      computeScore(results, {
        ignoreFieldNorm: ignoreFieldNorm
      });
      if (shouldSort) {
        results.sort(sortFn);
      }
      if (isNumber(limit) && limit > -1) {
        results = results.slice(0, limit);
      }
      return format(results, this._docs, {
        includeMatches: includeMatches,
        includeScore: includeScore
      });
    }
  }, {
    key: "_searchStringList",
    value: function _searchStringList(query) {
      var searcher = createSearcher(query, this.options);
      var records = this._myIndex.records;
      var results = [];

      // Iterate over every string in the index
      records.forEach(function (_ref2) {
        var text = _ref2.v,
          idx = _ref2.i,
          norm = _ref2.n;
        if (!isDefined(text)) {
          return;
        }
        var _searcher$searchIn = searcher.searchIn(text),
          isMatch = _searcher$searchIn.isMatch,
          score = _searcher$searchIn.score,
          indices = _searcher$searchIn.indices;
        if (isMatch) {
          results.push({
            item: text,
            idx: idx,
            matches: [{
              score: score,
              value: text,
              norm: norm,
              indices: indices
            }]
          });
        }
      });
      return results;
    }
  }, {
    key: "_searchLogical",
    value: function _searchLogical(query) {
      var _this = this;
      var expression = parse(query, this.options);
      var evaluate = function evaluate(node, item, idx) {
        if (!node.children) {
          var keyId = node.keyId,
            searcher = node.searcher;
          var matches = _this._findMatches({
            key: _this._keyStore.get(keyId),
            value: _this._myIndex.getValueForItemAtKeyId(item, keyId),
            searcher: searcher
          });
          if (matches && matches.length) {
            return [{
              idx: idx,
              item: item,
              matches: matches
            }];
          }
          return [];
        }
        var res = [];
        for (var i = 0, len = node.children.length; i < len; i += 1) {
          var child = node.children[i];
          var result = evaluate(child, item, idx);
          if (result.length) {
            res.push.apply(res, _toConsumableArray(result));
          } else if (node.operator === LogicalOperator.AND) {
            return [];
          }
        }
        return res;
      };
      var records = this._myIndex.records;
      var resultMap = {};
      var results = [];
      records.forEach(function (_ref3) {
        var item = _ref3.$,
          idx = _ref3.i;
        if (isDefined(item)) {
          var expResults = evaluate(expression, item, idx);
          if (expResults.length) {
            // Dedupe when adding
            if (!resultMap[idx]) {
              resultMap[idx] = {
                idx: idx,
                item: item,
                matches: []
              };
              results.push(resultMap[idx]);
            }
            expResults.forEach(function (_ref4) {
              var _resultMap$idx$matche;
              var matches = _ref4.matches;
              (_resultMap$idx$matche = resultMap[idx].matches).push.apply(_resultMap$idx$matche, _toConsumableArray(matches));
            });
          }
        }
      });
      return results;
    }
  }, {
    key: "_searchObjectList",
    value: function _searchObjectList(query) {
      var _this2 = this;
      var searcher = createSearcher(query, this.options);
      var _this$_myIndex = this._myIndex,
        keys = _this$_myIndex.keys,
        records = _this$_myIndex.records;
      var results = [];

      // List is Array<Object>
      records.forEach(function (_ref5) {
        var item = _ref5.$,
          idx = _ref5.i;
        if (!isDefined(item)) {
          return;
        }
        var matches = [];

        // Iterate over every key (i.e, path), and fetch the value at that key
        keys.forEach(function (key, keyIndex) {
          matches.push.apply(matches, _toConsumableArray(_this2._findMatches({
            key: key,
            value: item[keyIndex],
            searcher: searcher
          })));
        });
        if (matches.length) {
          results.push({
            idx: idx,
            item: item,
            matches: matches
          });
        }
      });
      return results;
    }
  }, {
    key: "_findMatches",
    value: function _findMatches(_ref6) {
      var key = _ref6.key,
        value = _ref6.value,
        searcher = _ref6.searcher;
      if (!isDefined(value)) {
        return [];
      }
      var matches = [];
      if (isArray(value)) {
        value.forEach(function (_ref7) {
          var text = _ref7.v,
            idx = _ref7.i,
            norm = _ref7.n;
          if (!isDefined(text)) {
            return;
          }
          var _searcher$searchIn2 = searcher.searchIn(text),
            isMatch = _searcher$searchIn2.isMatch,
            score = _searcher$searchIn2.score,
            indices = _searcher$searchIn2.indices;
          if (isMatch) {
            matches.push({
              score: score,
              key: key,
              value: text,
              idx: idx,
              norm: norm,
              indices: indices
            });
          }
        });
      } else {
        var text = value.v,
          norm = value.n;
        var _searcher$searchIn3 = searcher.searchIn(text),
          isMatch = _searcher$searchIn3.isMatch,
          score = _searcher$searchIn3.score,
          indices = _searcher$searchIn3.indices;
        if (isMatch) {
          matches.push({
            score: score,
            key: key,
            value: text,
            norm: norm,
            indices: indices
          });
        }
      }
      return matches;
    }
  }]);
  return Fuse;
}();

Fuse$1.version = '7.0.0';
Fuse$1.createIndex = createIndex;
Fuse$1.parseIndex = parseIndex;
Fuse$1.config = Config;
{
  Fuse$1.parseQuery = parse;
}
{
  register(ExtendedSearch);
}
var Fuse = Fuse$1;

module.exports = Fuse;


/***/ }),

/***/ 1099:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BrowserNetworkClient": function() { return /* binding */ Ve; },
/* harmony export */   "PdtNetworkConstants": function() { return /* binding */ Br; },
/* harmony export */   "getAdobeScriptGI": function() { return /* binding */ Gr; },
/* harmony export */   "getAdobeScriptMMT": function() { return /* binding */ Hr; },
/* harmony export */   "getDeviceInfo": function() { return /* binding */ Ne; },
/* harmony export */   "initAdobeDataLayerGI": function() { return /* binding */ Wr; },
/* harmony export */   "initAdobeDataLayerMMT": function() { return /* binding */ Jr; },
/* harmony export */   "initAndGetAnalyticsSdk": function() { return /* binding */ qr; },
/* harmony export */   "runtimeContextProvider": function() { return /* binding */ lt; }
/* harmony export */ });
/* harmony import */ var ua_parser_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6353);
var x;(function(n){n.assertEqual=s=>s;function e(s){}n.assertIs=e;function t(s){throw new Error}n.assertNever=t,n.arrayToEnum=s=>{let a={};for(let i of s)a[i]=i;return a},n.getValidEnumValues=s=>{let a=n.objectKeys(s).filter(o=>typeof s[s[o]]!="number"),i={};for(let o of a)i[o]=s[o];return n.objectValues(i)},n.objectValues=s=>n.objectKeys(s).map(function(a){return s[a]}),n.objectKeys=typeof Object.keys=="function"?s=>Object.keys(s):s=>{let a=[];for(let i in s)Object.prototype.hasOwnProperty.call(s,i)&&a.push(i);return a},n.find=(s,a)=>{for(let i of s)if(a(i))return i},n.isInteger=typeof Number.isInteger=="function"?s=>Number.isInteger(s):s=>typeof s=="number"&&isFinite(s)&&Math.floor(s)===s;function r(s,a=" | "){return s.map(i=>typeof i=="string"?`'${i}'`:i).join(a)}n.joinValues=r,n.jsonStringifyReplacer=(s,a)=>typeof a=="bigint"?a.toString():a})(x||(x={}));var tt;(function(n){n.mergeShapes=(e,t)=>({...e,...t})})(tt||(tt={}));var f=x.arrayToEnum(["string","nan","number","integer","float","boolean","date","bigint","symbol","function","undefined","null","array","object","unknown","promise","void","never","map","set"]),U=n=>{switch(typeof n){case"undefined":return f.undefined;case"string":return f.string;case"number":return isNaN(n)?f.nan:f.number;case"boolean":return f.boolean;case"function":return f.function;case"bigint":return f.bigint;case"symbol":return f.symbol;case"object":return Array.isArray(n)?f.array:n===null?f.null:n.then&&typeof n.then=="function"&&n.catch&&typeof n.catch=="function"?f.promise:typeof Map<"u"&&n instanceof Map?f.map:typeof Set<"u"&&n instanceof Set?f.set:typeof Date<"u"&&n instanceof Date?f.date:f.object;default:return f.unknown}},d=x.arrayToEnum(["invalid_type","invalid_literal","custom","invalid_union","invalid_union_discriminator","invalid_enum_value","unrecognized_keys","invalid_arguments","invalid_return_type","invalid_date","invalid_string","too_small","too_big","invalid_intersection_types","not_multiple_of","not_finite"]),mn=n=>JSON.stringify(n,null,2).replace(/"([^"]+)":/g,"$1:"),C=class n extends Error{get errors(){return this.issues}constructor(e){super(),this.issues=[],this.addIssue=r=>{this.issues=[...this.issues,r]},this.addIssues=(r=[])=>{this.issues=[...this.issues,...r]};let t=new.target.prototype;Object.setPrototypeOf?Object.setPrototypeOf(this,t):this.__proto__=t,this.name="ZodError",this.issues=e}format(e){let t=e||function(a){return a.message},r={_errors:[]},s=a=>{for(let i of a.issues)if(i.code==="invalid_union")i.unionErrors.map(s);else if(i.code==="invalid_return_type")s(i.returnTypeError);else if(i.code==="invalid_arguments")s(i.argumentsError);else if(i.path.length===0)r._errors.push(t(i));else{let o=r,u=0;for(;u<i.path.length;){let c=i.path[u];u===i.path.length-1?(o[c]=o[c]||{_errors:[]},o[c]._errors.push(t(i))):o[c]=o[c]||{_errors:[]},o=o[c],u++}}};return s(this),r}static assert(e){if(!(e instanceof n))throw new Error(`Not a ZodError: ${e}`)}toString(){return this.message}get message(){return JSON.stringify(this.issues,x.jsonStringifyReplacer,2)}get isEmpty(){return this.issues.length===0}flatten(e=t=>t.message){let t={},r=[];for(let s of this.issues)s.path.length>0?(t[s.path[0]]=t[s.path[0]]||[],t[s.path[0]].push(e(s))):r.push(e(s));return{formErrors:r,fieldErrors:t}}get formErrors(){return this.flatten()}};C.create=n=>new C(n);var he=(n,e)=>{let t;switch(n.code){case d.invalid_type:n.received===f.undefined?t="Required":t=`Expected ${n.expected}, received ${n.received}`;break;case d.invalid_literal:t=`Invalid literal value, expected ${JSON.stringify(n.expected,x.jsonStringifyReplacer)}`;break;case d.unrecognized_keys:t=`Unrecognized key(s) in object: ${x.joinValues(n.keys,", ")}`;break;case d.invalid_union:t="Invalid input";break;case d.invalid_union_discriminator:t=`Invalid discriminator value. Expected ${x.joinValues(n.options)}`;break;case d.invalid_enum_value:t=`Invalid enum value. Expected ${x.joinValues(n.options)}, received '${n.received}'`;break;case d.invalid_arguments:t="Invalid function arguments";break;case d.invalid_return_type:t="Invalid function return type";break;case d.invalid_date:t="Invalid date";break;case d.invalid_string:typeof n.validation=="object"?"includes"in n.validation?(t=`Invalid input: must include "${n.validation.includes}"`,typeof n.validation.position=="number"&&(t=`${t} at one or more positions greater than or equal to ${n.validation.position}`)):"startsWith"in n.validation?t=`Invalid input: must start with "${n.validation.startsWith}"`:"endsWith"in n.validation?t=`Invalid input: must end with "${n.validation.endsWith}"`:x.assertNever(n.validation):n.validation!=="regex"?t=`Invalid ${n.validation}`:t="Invalid";break;case d.too_small:n.type==="array"?t=`Array must contain ${n.exact?"exactly":n.inclusive?"at least":"more than"} ${n.minimum} element(s)`:n.type==="string"?t=`String must contain ${n.exact?"exactly":n.inclusive?"at least":"over"} ${n.minimum} character(s)`:n.type==="number"?t=`Number must be ${n.exact?"exactly equal to ":n.inclusive?"greater than or equal to ":"greater than "}${n.minimum}`:n.type==="date"?t=`Date must be ${n.exact?"exactly equal to ":n.inclusive?"greater than or equal to ":"greater than "}${new Date(Number(n.minimum))}`:t="Invalid input";break;case d.too_big:n.type==="array"?t=`Array must contain ${n.exact?"exactly":n.inclusive?"at most":"less than"} ${n.maximum} element(s)`:n.type==="string"?t=`String must contain ${n.exact?"exactly":n.inclusive?"at most":"under"} ${n.maximum} character(s)`:n.type==="number"?t=`Number must be ${n.exact?"exactly":n.inclusive?"less than or equal to":"less than"} ${n.maximum}`:n.type==="bigint"?t=`BigInt must be ${n.exact?"exactly":n.inclusive?"less than or equal to":"less than"} ${n.maximum}`:n.type==="date"?t=`Date must be ${n.exact?"exactly":n.inclusive?"smaller than or equal to":"smaller than"} ${new Date(Number(n.maximum))}`:t="Invalid input";break;case d.custom:t="Invalid input";break;case d.invalid_intersection_types:t="Intersection results could not be merged";break;case d.not_multiple_of:t=`Number must be a multiple of ${n.multipleOf}`;break;case d.not_finite:t="Number must be finite";break;default:t=e.defaultError,x.assertNever(n)}return{message:t}},gt=he;function hn(n){gt=n}function Ze(){return gt}var Ue=n=>{let{data:e,path:t,errorMaps:r,issueData:s}=n,a=[...t,...s.path||[]],i={...s,path:a};if(s.message!==void 0)return{...s,path:a,message:s.message};let o="",u=r.filter(c=>!!c).slice().reverse();for(let c of u)o=c(i,{data:e,defaultError:o}).message;return{...s,path:a,message:o}},gn=[];function l(n,e){let t=Ze(),r=Ue({issueData:e,data:n.data,path:n.path,errorMaps:[n.common.contextualErrorMap,n.schemaErrorMap,t,t===he?void 0:he].filter(s=>!!s)});n.common.issues.push(r)}var w=class n{constructor(){this.value="valid"}dirty(){this.value==="valid"&&(this.value="dirty")}abort(){this.value!=="aborted"&&(this.value="aborted")}static mergeArray(e,t){let r=[];for(let s of t){if(s.status==="aborted")return g;s.status==="dirty"&&e.dirty(),r.push(s.value)}return{status:e.value,value:r}}static async mergeObjectAsync(e,t){let r=[];for(let s of t){let a=await s.key,i=await s.value;r.push({key:a,value:i})}return n.mergeObjectSync(e,r)}static mergeObjectSync(e,t){let r={};for(let s of t){let{key:a,value:i}=s;if(a.status==="aborted"||i.status==="aborted")return g;a.status==="dirty"&&e.dirty(),i.status==="dirty"&&e.dirty(),a.value!=="__proto__"&&(typeof i.value<"u"||s.alwaysSet)&&(r[a.value]=i.value)}return{status:e.value,value:r}}},g=Object.freeze({status:"aborted"}),me=n=>({status:"dirty",value:n}),S=n=>({status:"valid",value:n}),nt=n=>n.status==="aborted",rt=n=>n.status==="dirty",H=n=>n.status==="valid",Ee=n=>typeof Promise<"u"&&n instanceof Promise;function Le(n,e,t,r){if(t==="a"&&!r)throw new TypeError("Private accessor was defined without a getter");if(typeof e=="function"?n!==e||!r:!e.has(n))throw new TypeError("Cannot read private member from an object whose class did not declare it");return t==="m"?r:t==="a"?r.call(n):r?r.value:e.get(n)}function yt(n,e,t,r,s){if(r==="m")throw new TypeError("Private method is not writable");if(r==="a"&&!s)throw new TypeError("Private accessor was defined without a setter");if(typeof e=="function"?n!==e||!s:!e.has(n))throw new TypeError("Cannot write private member to an object whose class did not declare it");return r==="a"?s.call(n,t):s?s.value=t:e.set(n,t),t}var m;(function(n){n.errToObj=e=>typeof e=="string"?{message:e}:e||{},n.toString=e=>typeof e=="string"?e:e?.message})(m||(m={}));var Se,Te,O=class{constructor(e,t,r,s){this._cachedPath=[],this.parent=e,this.data=t,this._path=r,this._key=s}get path(){return this._cachedPath.length||(this._key instanceof Array?this._cachedPath.push(...this._path,...this._key):this._cachedPath.push(...this._path,this._key)),this._cachedPath}},pt=(n,e)=>{if(H(e))return{success:!0,data:e.value};if(!n.common.issues.length)throw new Error("Validation failed but no issues detected.");return{success:!1,get error(){if(this._error)return this._error;let t=new C(n.common.issues);return this._error=t,this._error}}};function v(n){if(!n)return{};let{errorMap:e,invalid_type_error:t,required_error:r,description:s}=n;if(e&&(t||r))throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);return e?{errorMap:e,description:s}:{errorMap:(i,o)=>{var u,c;let{message:p}=n;return i.code==="invalid_enum_value"?{message:p??o.defaultError}:typeof o.data>"u"?{message:(u=p??r)!==null&&u!==void 0?u:o.defaultError}:i.code!=="invalid_type"?{message:o.defaultError}:{message:(c=p??t)!==null&&c!==void 0?c:o.defaultError}},description:s}}var _=class{get description(){return this._def.description}_getType(e){return U(e.data)}_getOrReturnCtx(e,t){return t||{common:e.parent.common,data:e.data,parsedType:U(e.data),schemaErrorMap:this._def.errorMap,path:e.path,parent:e.parent}}_processInputParams(e){return{status:new w,ctx:{common:e.parent.common,data:e.data,parsedType:U(e.data),schemaErrorMap:this._def.errorMap,path:e.path,parent:e.parent}}}_parseSync(e){let t=this._parse(e);if(Ee(t))throw new Error("Synchronous parse encountered promise.");return t}_parseAsync(e){let t=this._parse(e);return Promise.resolve(t)}parse(e,t){let r=this.safeParse(e,t);if(r.success)return r.data;throw r.error}safeParse(e,t){var r;let s={common:{issues:[],async:(r=t?.async)!==null&&r!==void 0?r:!1,contextualErrorMap:t?.errorMap},path:t?.path||[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:U(e)},a=this._parseSync({data:e,path:s.path,parent:s});return pt(s,a)}"~validate"(e){var t,r;let s={common:{issues:[],async:!!this["~standard"].async},path:[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:U(e)};if(!this["~standard"].async)try{let a=this._parseSync({data:e,path:[],parent:s});return H(a)?{value:a.value}:{issues:s.common.issues}}catch(a){!((r=(t=a?.message)===null||t===void 0?void 0:t.toLowerCase())===null||r===void 0)&&r.includes("encountered")&&(this["~standard"].async=!0),s.common={issues:[],async:!0}}return this._parseAsync({data:e,path:[],parent:s}).then(a=>H(a)?{value:a.value}:{issues:s.common.issues})}async parseAsync(e,t){let r=await this.safeParseAsync(e,t);if(r.success)return r.data;throw r.error}async safeParseAsync(e,t){let r={common:{issues:[],contextualErrorMap:t?.errorMap,async:!0},path:t?.path||[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:U(e)},s=this._parse({data:e,path:r.path,parent:r}),a=await(Ee(s)?s:Promise.resolve(s));return pt(r,a)}refine(e,t){let r=s=>typeof t=="string"||typeof t>"u"?{message:t}:typeof t=="function"?t(s):t;return this._refinement((s,a)=>{let i=e(s),o=()=>a.addIssue({code:d.custom,...r(s)});return typeof Promise<"u"&&i instanceof Promise?i.then(u=>u?!0:(o(),!1)):i?!0:(o(),!1)})}refinement(e,t){return this._refinement((r,s)=>e(r)?!0:(s.addIssue(typeof t=="function"?t(r,s):t),!1))}_refinement(e){return new I({schema:this,typeName:h.ZodEffects,effect:{type:"refinement",refinement:e}})}superRefine(e){return this._refinement(e)}constructor(e){this.spa=this.safeParseAsync,this._def=e,this.parse=this.parse.bind(this),this.safeParse=this.safeParse.bind(this),this.parseAsync=this.parseAsync.bind(this),this.safeParseAsync=this.safeParseAsync.bind(this),this.spa=this.spa.bind(this),this.refine=this.refine.bind(this),this.refinement=this.refinement.bind(this),this.superRefine=this.superRefine.bind(this),this.optional=this.optional.bind(this),this.nullable=this.nullable.bind(this),this.nullish=this.nullish.bind(this),this.array=this.array.bind(this),this.promise=this.promise.bind(this),this.or=this.or.bind(this),this.and=this.and.bind(this),this.transform=this.transform.bind(this),this.brand=this.brand.bind(this),this.default=this.default.bind(this),this.catch=this.catch.bind(this),this.describe=this.describe.bind(this),this.pipe=this.pipe.bind(this),this.readonly=this.readonly.bind(this),this.isNullable=this.isNullable.bind(this),this.isOptional=this.isOptional.bind(this),this["~standard"]={version:1,vendor:"zod",validate:t=>this["~validate"](t)}}optional(){return A.create(this,this._def)}nullable(){return M.create(this,this._def)}nullish(){return this.nullable().optional()}array(){return $.create(this)}promise(){return q.create(this,this._def)}or(e){return ee.create([this,e],this._def)}and(e){return te.create(this,e,this._def)}transform(e){return new I({...v(this._def),schema:this,typeName:h.ZodEffects,effect:{type:"transform",transform:e}})}default(e){let t=typeof e=="function"?e:()=>e;return new ie({...v(this._def),innerType:this,defaultValue:t,typeName:h.ZodDefault})}brand(){return new Ce({typeName:h.ZodBranded,type:this,...v(this._def)})}catch(e){let t=typeof e=="function"?e:()=>e;return new oe({...v(this._def),innerType:this,catchValue:t,typeName:h.ZodCatch})}describe(e){let t=this.constructor;return new t({...this._def,description:e})}pipe(e){return Ie.create(this,e)}readonly(){return ce.create(this)}isOptional(){return this.safeParse(void 0).success}isNullable(){return this.safeParse(null).success}},yn=/^c[^\s-]{8,}$/i,vn=/^[0-9a-z]+$/,_n=/^[0-9A-HJKMNP-TV-Z]{26}$/i,xn=/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i,bn=/^[a-z0-9_-]{21}$/i,wn=/^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/,kn=/^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/,Sn=/^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i,Tn="^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$",et,En=/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,Cn=/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/,In=/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/,An=/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/,On=/^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,Pn=/^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/,vt="((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))",Rn=new RegExp(`^${vt}$`);function _t(n){let e="[0-5]\\d";n.precision?e=`${e}\\.\\d{${n.precision}}`:n.precision==null&&(e=`${e}(\\.\\d+)?`);let t=n.precision?"+":"?";return`([01]\\d|2[0-3]):[0-5]\\d(:${e})${t}`}function Dn(n){return new RegExp(`^${_t(n)}$`)}function xt(n){let e=`${vt}T${_t(n)}`,t=[];return t.push(n.local?"Z?":"Z"),n.offset&&t.push("([+-]\\d{2}:?\\d{2})"),e=`${e}(${t.join("|")})`,new RegExp(`^${e}$`)}function Nn(n,e){return!!((e==="v4"||!e)&&En.test(n)||(e==="v6"||!e)&&In.test(n))}function jn(n,e){if(!wn.test(n))return!1;try{let[t]=n.split("."),r=t.replace(/-/g,"+").replace(/_/g,"/").padEnd(t.length+(4-t.length%4)%4,"="),s=JSON.parse(atob(r));return!(typeof s!="object"||s===null||!s.typ||!s.alg||e&&s.alg!==e)}catch{return!1}}function Mn(n,e){return!!((e==="v4"||!e)&&Cn.test(n)||(e==="v6"||!e)&&An.test(n))}var z=class n extends _{_parse(e){if(this._def.coerce&&(e.data=String(e.data)),this._getType(e)!==f.string){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_type,expected:f.string,received:a.parsedType}),g}let r=new w,s;for(let a of this._def.checks)if(a.kind==="min")e.data.length<a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_small,minimum:a.value,type:"string",inclusive:!0,exact:!1,message:a.message}),r.dirty());else if(a.kind==="max")e.data.length>a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_big,maximum:a.value,type:"string",inclusive:!0,exact:!1,message:a.message}),r.dirty());else if(a.kind==="length"){let i=e.data.length>a.value,o=e.data.length<a.value;(i||o)&&(s=this._getOrReturnCtx(e,s),i?l(s,{code:d.too_big,maximum:a.value,type:"string",inclusive:!0,exact:!0,message:a.message}):o&&l(s,{code:d.too_small,minimum:a.value,type:"string",inclusive:!0,exact:!0,message:a.message}),r.dirty())}else if(a.kind==="email")Sn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"email",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="emoji")et||(et=new RegExp(Tn,"u")),et.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"emoji",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="uuid")xn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"uuid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="nanoid")bn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"nanoid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="cuid")yn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"cuid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="cuid2")vn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"cuid2",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="ulid")_n.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"ulid",code:d.invalid_string,message:a.message}),r.dirty());else if(a.kind==="url")try{new URL(e.data)}catch{s=this._getOrReturnCtx(e,s),l(s,{validation:"url",code:d.invalid_string,message:a.message}),r.dirty()}else a.kind==="regex"?(a.regex.lastIndex=0,a.regex.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"regex",code:d.invalid_string,message:a.message}),r.dirty())):a.kind==="trim"?e.data=e.data.trim():a.kind==="includes"?e.data.includes(a.value,a.position)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:{includes:a.value,position:a.position},message:a.message}),r.dirty()):a.kind==="toLowerCase"?e.data=e.data.toLowerCase():a.kind==="toUpperCase"?e.data=e.data.toUpperCase():a.kind==="startsWith"?e.data.startsWith(a.value)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:{startsWith:a.value},message:a.message}),r.dirty()):a.kind==="endsWith"?e.data.endsWith(a.value)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:{endsWith:a.value},message:a.message}),r.dirty()):a.kind==="datetime"?xt(a).test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:"datetime",message:a.message}),r.dirty()):a.kind==="date"?Rn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:"date",message:a.message}),r.dirty()):a.kind==="time"?Dn(a).test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{code:d.invalid_string,validation:"time",message:a.message}),r.dirty()):a.kind==="duration"?kn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"duration",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="ip"?Nn(e.data,a.version)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"ip",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="jwt"?jn(e.data,a.alg)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"jwt",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="cidr"?Mn(e.data,a.version)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"cidr",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="base64"?On.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"base64",code:d.invalid_string,message:a.message}),r.dirty()):a.kind==="base64url"?Pn.test(e.data)||(s=this._getOrReturnCtx(e,s),l(s,{validation:"base64url",code:d.invalid_string,message:a.message}),r.dirty()):x.assertNever(a);return{status:r.value,value:e.data}}_regex(e,t,r){return this.refinement(s=>e.test(s),{validation:t,code:d.invalid_string,...m.errToObj(r)})}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}email(e){return this._addCheck({kind:"email",...m.errToObj(e)})}url(e){return this._addCheck({kind:"url",...m.errToObj(e)})}emoji(e){return this._addCheck({kind:"emoji",...m.errToObj(e)})}uuid(e){return this._addCheck({kind:"uuid",...m.errToObj(e)})}nanoid(e){return this._addCheck({kind:"nanoid",...m.errToObj(e)})}cuid(e){return this._addCheck({kind:"cuid",...m.errToObj(e)})}cuid2(e){return this._addCheck({kind:"cuid2",...m.errToObj(e)})}ulid(e){return this._addCheck({kind:"ulid",...m.errToObj(e)})}base64(e){return this._addCheck({kind:"base64",...m.errToObj(e)})}base64url(e){return this._addCheck({kind:"base64url",...m.errToObj(e)})}jwt(e){return this._addCheck({kind:"jwt",...m.errToObj(e)})}ip(e){return this._addCheck({kind:"ip",...m.errToObj(e)})}cidr(e){return this._addCheck({kind:"cidr",...m.errToObj(e)})}datetime(e){var t,r;return typeof e=="string"?this._addCheck({kind:"datetime",precision:null,offset:!1,local:!1,message:e}):this._addCheck({kind:"datetime",precision:typeof e?.precision>"u"?null:e?.precision,offset:(t=e?.offset)!==null&&t!==void 0?t:!1,local:(r=e?.local)!==null&&r!==void 0?r:!1,...m.errToObj(e?.message)})}date(e){return this._addCheck({kind:"date",message:e})}time(e){return typeof e=="string"?this._addCheck({kind:"time",precision:null,message:e}):this._addCheck({kind:"time",precision:typeof e?.precision>"u"?null:e?.precision,...m.errToObj(e?.message)})}duration(e){return this._addCheck({kind:"duration",...m.errToObj(e)})}regex(e,t){return this._addCheck({kind:"regex",regex:e,...m.errToObj(t)})}includes(e,t){return this._addCheck({kind:"includes",value:e,position:t?.position,...m.errToObj(t?.message)})}startsWith(e,t){return this._addCheck({kind:"startsWith",value:e,...m.errToObj(t)})}endsWith(e,t){return this._addCheck({kind:"endsWith",value:e,...m.errToObj(t)})}min(e,t){return this._addCheck({kind:"min",value:e,...m.errToObj(t)})}max(e,t){return this._addCheck({kind:"max",value:e,...m.errToObj(t)})}length(e,t){return this._addCheck({kind:"length",value:e,...m.errToObj(t)})}nonempty(e){return this.min(1,m.errToObj(e))}trim(){return new n({...this._def,checks:[...this._def.checks,{kind:"trim"}]})}toLowerCase(){return new n({...this._def,checks:[...this._def.checks,{kind:"toLowerCase"}]})}toUpperCase(){return new n({...this._def,checks:[...this._def.checks,{kind:"toUpperCase"}]})}get isDatetime(){return!!this._def.checks.find(e=>e.kind==="datetime")}get isDate(){return!!this._def.checks.find(e=>e.kind==="date")}get isTime(){return!!this._def.checks.find(e=>e.kind==="time")}get isDuration(){return!!this._def.checks.find(e=>e.kind==="duration")}get isEmail(){return!!this._def.checks.find(e=>e.kind==="email")}get isURL(){return!!this._def.checks.find(e=>e.kind==="url")}get isEmoji(){return!!this._def.checks.find(e=>e.kind==="emoji")}get isUUID(){return!!this._def.checks.find(e=>e.kind==="uuid")}get isNANOID(){return!!this._def.checks.find(e=>e.kind==="nanoid")}get isCUID(){return!!this._def.checks.find(e=>e.kind==="cuid")}get isCUID2(){return!!this._def.checks.find(e=>e.kind==="cuid2")}get isULID(){return!!this._def.checks.find(e=>e.kind==="ulid")}get isIP(){return!!this._def.checks.find(e=>e.kind==="ip")}get isCIDR(){return!!this._def.checks.find(e=>e.kind==="cidr")}get isBase64(){return!!this._def.checks.find(e=>e.kind==="base64")}get isBase64url(){return!!this._def.checks.find(e=>e.kind==="base64url")}get minLength(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e}get maxLength(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e}};z.create=n=>{var e;return new z({checks:[],typeName:h.ZodString,coerce:(e=n?.coerce)!==null&&e!==void 0?e:!1,...v(n)})};function Vn(n,e){let t=(n.toString().split(".")[1]||"").length,r=(e.toString().split(".")[1]||"").length,s=t>r?t:r,a=parseInt(n.toFixed(s).replace(".","")),i=parseInt(e.toFixed(s).replace(".",""));return a%i/Math.pow(10,s)}var W=class n extends _{constructor(){super(...arguments),this.min=this.gte,this.max=this.lte,this.step=this.multipleOf}_parse(e){if(this._def.coerce&&(e.data=Number(e.data)),this._getType(e)!==f.number){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_type,expected:f.number,received:a.parsedType}),g}let r,s=new w;for(let a of this._def.checks)a.kind==="int"?x.isInteger(e.data)||(r=this._getOrReturnCtx(e,r),l(r,{code:d.invalid_type,expected:"integer",received:"float",message:a.message}),s.dirty()):a.kind==="min"?(a.inclusive?e.data<a.value:e.data<=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_small,minimum:a.value,type:"number",inclusive:a.inclusive,exact:!1,message:a.message}),s.dirty()):a.kind==="max"?(a.inclusive?e.data>a.value:e.data>=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_big,maximum:a.value,type:"number",inclusive:a.inclusive,exact:!1,message:a.message}),s.dirty()):a.kind==="multipleOf"?Vn(e.data,a.value)!==0&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.not_multiple_of,multipleOf:a.value,message:a.message}),s.dirty()):a.kind==="finite"?Number.isFinite(e.data)||(r=this._getOrReturnCtx(e,r),l(r,{code:d.not_finite,message:a.message}),s.dirty()):x.assertNever(a);return{status:s.value,value:e.data}}gte(e,t){return this.setLimit("min",e,!0,m.toString(t))}gt(e,t){return this.setLimit("min",e,!1,m.toString(t))}lte(e,t){return this.setLimit("max",e,!0,m.toString(t))}lt(e,t){return this.setLimit("max",e,!1,m.toString(t))}setLimit(e,t,r,s){return new n({...this._def,checks:[...this._def.checks,{kind:e,value:t,inclusive:r,message:m.toString(s)}]})}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}int(e){return this._addCheck({kind:"int",message:m.toString(e)})}positive(e){return this._addCheck({kind:"min",value:0,inclusive:!1,message:m.toString(e)})}negative(e){return this._addCheck({kind:"max",value:0,inclusive:!1,message:m.toString(e)})}nonpositive(e){return this._addCheck({kind:"max",value:0,inclusive:!0,message:m.toString(e)})}nonnegative(e){return this._addCheck({kind:"min",value:0,inclusive:!0,message:m.toString(e)})}multipleOf(e,t){return this._addCheck({kind:"multipleOf",value:e,message:m.toString(t)})}finite(e){return this._addCheck({kind:"finite",message:m.toString(e)})}safe(e){return this._addCheck({kind:"min",inclusive:!0,value:Number.MIN_SAFE_INTEGER,message:m.toString(e)})._addCheck({kind:"max",inclusive:!0,value:Number.MAX_SAFE_INTEGER,message:m.toString(e)})}get minValue(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e}get maxValue(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e}get isInt(){return!!this._def.checks.find(e=>e.kind==="int"||e.kind==="multipleOf"&&x.isInteger(e.value))}get isFinite(){let e=null,t=null;for(let r of this._def.checks){if(r.kind==="finite"||r.kind==="int"||r.kind==="multipleOf")return!0;r.kind==="min"?(t===null||r.value>t)&&(t=r.value):r.kind==="max"&&(e===null||r.value<e)&&(e=r.value)}return Number.isFinite(t)&&Number.isFinite(e)}};W.create=n=>new W({checks:[],typeName:h.ZodNumber,coerce:n?.coerce||!1,...v(n)});var G=class n extends _{constructor(){super(...arguments),this.min=this.gte,this.max=this.lte}_parse(e){if(this._def.coerce)try{e.data=BigInt(e.data)}catch{return this._getInvalidInput(e)}if(this._getType(e)!==f.bigint)return this._getInvalidInput(e);let r,s=new w;for(let a of this._def.checks)a.kind==="min"?(a.inclusive?e.data<a.value:e.data<=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_small,type:"bigint",minimum:a.value,inclusive:a.inclusive,message:a.message}),s.dirty()):a.kind==="max"?(a.inclusive?e.data>a.value:e.data>=a.value)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.too_big,type:"bigint",maximum:a.value,inclusive:a.inclusive,message:a.message}),s.dirty()):a.kind==="multipleOf"?e.data%a.value!==BigInt(0)&&(r=this._getOrReturnCtx(e,r),l(r,{code:d.not_multiple_of,multipleOf:a.value,message:a.message}),s.dirty()):x.assertNever(a);return{status:s.value,value:e.data}}_getInvalidInput(e){let t=this._getOrReturnCtx(e);return l(t,{code:d.invalid_type,expected:f.bigint,received:t.parsedType}),g}gte(e,t){return this.setLimit("min",e,!0,m.toString(t))}gt(e,t){return this.setLimit("min",e,!1,m.toString(t))}lte(e,t){return this.setLimit("max",e,!0,m.toString(t))}lt(e,t){return this.setLimit("max",e,!1,m.toString(t))}setLimit(e,t,r,s){return new n({...this._def,checks:[...this._def.checks,{kind:e,value:t,inclusive:r,message:m.toString(s)}]})}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}positive(e){return this._addCheck({kind:"min",value:BigInt(0),inclusive:!1,message:m.toString(e)})}negative(e){return this._addCheck({kind:"max",value:BigInt(0),inclusive:!1,message:m.toString(e)})}nonpositive(e){return this._addCheck({kind:"max",value:BigInt(0),inclusive:!0,message:m.toString(e)})}nonnegative(e){return this._addCheck({kind:"min",value:BigInt(0),inclusive:!0,message:m.toString(e)})}multipleOf(e,t){return this._addCheck({kind:"multipleOf",value:e,message:m.toString(t)})}get minValue(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e}get maxValue(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e}};G.create=n=>{var e;return new G({checks:[],typeName:h.ZodBigInt,coerce:(e=n?.coerce)!==null&&e!==void 0?e:!1,...v(n)})};var Q=class extends _{_parse(e){if(this._def.coerce&&(e.data=!!e.data),this._getType(e)!==f.boolean){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.boolean,received:r.parsedType}),g}return S(e.data)}};Q.create=n=>new Q({typeName:h.ZodBoolean,coerce:n?.coerce||!1,...v(n)});var Y=class n extends _{_parse(e){if(this._def.coerce&&(e.data=new Date(e.data)),this._getType(e)!==f.date){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_type,expected:f.date,received:a.parsedType}),g}if(isNaN(e.data.getTime())){let a=this._getOrReturnCtx(e);return l(a,{code:d.invalid_date}),g}let r=new w,s;for(let a of this._def.checks)a.kind==="min"?e.data.getTime()<a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_small,message:a.message,inclusive:!0,exact:!1,minimum:a.value,type:"date"}),r.dirty()):a.kind==="max"?e.data.getTime()>a.value&&(s=this._getOrReturnCtx(e,s),l(s,{code:d.too_big,message:a.message,inclusive:!0,exact:!1,maximum:a.value,type:"date"}),r.dirty()):x.assertNever(a);return{status:r.value,value:new Date(e.data.getTime())}}_addCheck(e){return new n({...this._def,checks:[...this._def.checks,e]})}min(e,t){return this._addCheck({kind:"min",value:e.getTime(),message:m.toString(t)})}max(e,t){return this._addCheck({kind:"max",value:e.getTime(),message:m.toString(t)})}get minDate(){let e=null;for(let t of this._def.checks)t.kind==="min"&&(e===null||t.value>e)&&(e=t.value);return e!=null?new Date(e):null}get maxDate(){let e=null;for(let t of this._def.checks)t.kind==="max"&&(e===null||t.value<e)&&(e=t.value);return e!=null?new Date(e):null}};Y.create=n=>new Y({checks:[],coerce:n?.coerce||!1,typeName:h.ZodDate,...v(n)});var ge=class extends _{_parse(e){if(this._getType(e)!==f.symbol){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.symbol,received:r.parsedType}),g}return S(e.data)}};ge.create=n=>new ge({typeName:h.ZodSymbol,...v(n)});var K=class extends _{_parse(e){if(this._getType(e)!==f.undefined){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.undefined,received:r.parsedType}),g}return S(e.data)}};K.create=n=>new K({typeName:h.ZodUndefined,...v(n)});var X=class extends _{_parse(e){if(this._getType(e)!==f.null){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.null,received:r.parsedType}),g}return S(e.data)}};X.create=n=>new X({typeName:h.ZodNull,...v(n)});var F=class extends _{constructor(){super(...arguments),this._any=!0}_parse(e){return S(e.data)}};F.create=n=>new F({typeName:h.ZodAny,...v(n)});var L=class extends _{constructor(){super(...arguments),this._unknown=!0}_parse(e){return S(e.data)}};L.create=n=>new L({typeName:h.ZodUnknown,...v(n)});var R=class extends _{_parse(e){let t=this._getOrReturnCtx(e);return l(t,{code:d.invalid_type,expected:f.never,received:t.parsedType}),g}};R.create=n=>new R({typeName:h.ZodNever,...v(n)});var ye=class extends _{_parse(e){if(this._getType(e)!==f.undefined){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.void,received:r.parsedType}),g}return S(e.data)}};ye.create=n=>new ye({typeName:h.ZodVoid,...v(n)});var $=class n extends _{_parse(e){let{ctx:t,status:r}=this._processInputParams(e),s=this._def;if(t.parsedType!==f.array)return l(t,{code:d.invalid_type,expected:f.array,received:t.parsedType}),g;if(s.exactLength!==null){let i=t.data.length>s.exactLength.value,o=t.data.length<s.exactLength.value;(i||o)&&(l(t,{code:i?d.too_big:d.too_small,minimum:o?s.exactLength.value:void 0,maximum:i?s.exactLength.value:void 0,type:"array",inclusive:!0,exact:!0,message:s.exactLength.message}),r.dirty())}if(s.minLength!==null&&t.data.length<s.minLength.value&&(l(t,{code:d.too_small,minimum:s.minLength.value,type:"array",inclusive:!0,exact:!1,message:s.minLength.message}),r.dirty()),s.maxLength!==null&&t.data.length>s.maxLength.value&&(l(t,{code:d.too_big,maximum:s.maxLength.value,type:"array",inclusive:!0,exact:!1,message:s.maxLength.message}),r.dirty()),t.common.async)return Promise.all([...t.data].map((i,o)=>s.type._parseAsync(new O(t,i,t.path,o)))).then(i=>w.mergeArray(r,i));let a=[...t.data].map((i,o)=>s.type._parseSync(new O(t,i,t.path,o)));return w.mergeArray(r,a)}get element(){return this._def.type}min(e,t){return new n({...this._def,minLength:{value:e,message:m.toString(t)}})}max(e,t){return new n({...this._def,maxLength:{value:e,message:m.toString(t)}})}length(e,t){return new n({...this._def,exactLength:{value:e,message:m.toString(t)}})}nonempty(e){return this.min(1,e)}};$.create=(n,e)=>new $({type:n,minLength:null,maxLength:null,exactLength:null,typeName:h.ZodArray,...v(e)});function pe(n){if(n instanceof E){let e={};for(let t in n.shape){let r=n.shape[t];e[t]=A.create(pe(r))}return new E({...n._def,shape:()=>e})}else return n instanceof $?new $({...n._def,type:pe(n.element)}):n instanceof A?A.create(pe(n.unwrap())):n instanceof M?M.create(pe(n.unwrap())):n instanceof j?j.create(n.items.map(e=>pe(e))):n}var E=class n extends _{constructor(){super(...arguments),this._cached=null,this.nonstrict=this.passthrough,this.augment=this.extend}_getCached(){if(this._cached!==null)return this._cached;let e=this._def.shape(),t=x.objectKeys(e);return this._cached={shape:e,keys:t}}_parse(e){if(this._getType(e)!==f.object){let c=this._getOrReturnCtx(e);return l(c,{code:d.invalid_type,expected:f.object,received:c.parsedType}),g}let{status:r,ctx:s}=this._processInputParams(e),{shape:a,keys:i}=this._getCached(),o=[];if(!(this._def.catchall instanceof R&&this._def.unknownKeys==="strip"))for(let c in s.data)i.includes(c)||o.push(c);let u=[];for(let c of i){let p=a[c],b=s.data[c];u.push({key:{status:"valid",value:c},value:p._parse(new O(s,b,s.path,c)),alwaysSet:c in s.data})}if(this._def.catchall instanceof R){let c=this._def.unknownKeys;if(c==="passthrough")for(let p of o)u.push({key:{status:"valid",value:p},value:{status:"valid",value:s.data[p]}});else if(c==="strict")o.length>0&&(l(s,{code:d.unrecognized_keys,keys:o}),r.dirty());else if(c!=="strip")throw new Error("Internal ZodObject error: invalid unknownKeys value.")}else{let c=this._def.catchall;for(let p of o){let b=s.data[p];u.push({key:{status:"valid",value:p},value:c._parse(new O(s,b,s.path,p)),alwaysSet:p in s.data})}}return s.common.async?Promise.resolve().then(async()=>{let c=[];for(let p of u){let b=await p.key,T=await p.value;c.push({key:b,value:T,alwaysSet:p.alwaysSet})}return c}).then(c=>w.mergeObjectSync(r,c)):w.mergeObjectSync(r,u)}get shape(){return this._def.shape()}strict(e){return m.errToObj,new n({...this._def,unknownKeys:"strict",...e!==void 0?{errorMap:(t,r)=>{var s,a,i,o;let u=(i=(a=(s=this._def).errorMap)===null||a===void 0?void 0:a.call(s,t,r).message)!==null&&i!==void 0?i:r.defaultError;return t.code==="unrecognized_keys"?{message:(o=m.errToObj(e).message)!==null&&o!==void 0?o:u}:{message:u}}}:{}})}strip(){return new n({...this._def,unknownKeys:"strip"})}passthrough(){return new n({...this._def,unknownKeys:"passthrough"})}extend(e){return new n({...this._def,shape:()=>({...this._def.shape(),...e})})}merge(e){return new n({unknownKeys:e._def.unknownKeys,catchall:e._def.catchall,shape:()=>({...this._def.shape(),...e._def.shape()}),typeName:h.ZodObject})}setKey(e,t){return this.augment({[e]:t})}catchall(e){return new n({...this._def,catchall:e})}pick(e){let t={};return x.objectKeys(e).forEach(r=>{e[r]&&this.shape[r]&&(t[r]=this.shape[r])}),new n({...this._def,shape:()=>t})}omit(e){let t={};return x.objectKeys(this.shape).forEach(r=>{e[r]||(t[r]=this.shape[r])}),new n({...this._def,shape:()=>t})}deepPartial(){return pe(this)}partial(e){let t={};return x.objectKeys(this.shape).forEach(r=>{let s=this.shape[r];e&&!e[r]?t[r]=s:t[r]=s.optional()}),new n({...this._def,shape:()=>t})}required(e){let t={};return x.objectKeys(this.shape).forEach(r=>{if(e&&!e[r])t[r]=this.shape[r];else{let a=this.shape[r];for(;a instanceof A;)a=a._def.innerType;t[r]=a}}),new n({...this._def,shape:()=>t})}keyof(){return bt(x.objectKeys(this.shape))}};E.create=(n,e)=>new E({shape:()=>n,unknownKeys:"strip",catchall:R.create(),typeName:h.ZodObject,...v(e)});E.strictCreate=(n,e)=>new E({shape:()=>n,unknownKeys:"strict",catchall:R.create(),typeName:h.ZodObject,...v(e)});E.lazycreate=(n,e)=>new E({shape:n,unknownKeys:"strip",catchall:R.create(),typeName:h.ZodObject,...v(e)});var ee=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r=this._def.options;function s(a){for(let o of a)if(o.result.status==="valid")return o.result;for(let o of a)if(o.result.status==="dirty")return t.common.issues.push(...o.ctx.common.issues),o.result;let i=a.map(o=>new C(o.ctx.common.issues));return l(t,{code:d.invalid_union,unionErrors:i}),g}if(t.common.async)return Promise.all(r.map(async a=>{let i={...t,common:{...t.common,issues:[]},parent:null};return{result:await a._parseAsync({data:t.data,path:t.path,parent:i}),ctx:i}})).then(s);{let a,i=[];for(let u of r){let c={...t,common:{...t.common,issues:[]},parent:null},p=u._parseSync({data:t.data,path:t.path,parent:c});if(p.status==="valid")return p;p.status==="dirty"&&!a&&(a={result:p,ctx:c}),c.common.issues.length&&i.push(c.common.issues)}if(a)return t.common.issues.push(...a.ctx.common.issues),a.result;let o=i.map(u=>new C(u));return l(t,{code:d.invalid_union,unionErrors:o}),g}}get options(){return this._def.options}};ee.create=(n,e)=>new ee({options:n,typeName:h.ZodUnion,...v(e)});var Z=n=>n instanceof ne?Z(n.schema):n instanceof I?Z(n.innerType()):n instanceof re?[n.value]:n instanceof se?n.options:n instanceof ae?x.objectValues(n.enum):n instanceof ie?Z(n._def.innerType):n instanceof K?[void 0]:n instanceof X?[null]:n instanceof A?[void 0,...Z(n.unwrap())]:n instanceof M?[null,...Z(n.unwrap())]:n instanceof Ce||n instanceof ce?Z(n.unwrap()):n instanceof oe?Z(n._def.innerType):[],$e=class n extends _{_parse(e){let{ctx:t}=this._processInputParams(e);if(t.parsedType!==f.object)return l(t,{code:d.invalid_type,expected:f.object,received:t.parsedType}),g;let r=this.discriminator,s=t.data[r],a=this.optionsMap.get(s);return a?t.common.async?a._parseAsync({data:t.data,path:t.path,parent:t}):a._parseSync({data:t.data,path:t.path,parent:t}):(l(t,{code:d.invalid_union_discriminator,options:Array.from(this.optionsMap.keys()),path:[r]}),g)}get discriminator(){return this._def.discriminator}get options(){return this._def.options}get optionsMap(){return this._def.optionsMap}static create(e,t,r){let s=new Map;for(let a of t){let i=Z(a.shape[e]);if(!i.length)throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);for(let o of i){if(s.has(o))throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);s.set(o,a)}}return new n({typeName:h.ZodDiscriminatedUnion,discriminator:e,options:t,optionsMap:s,...v(r)})}};function st(n,e){let t=U(n),r=U(e);if(n===e)return{valid:!0,data:n};if(t===f.object&&r===f.object){let s=x.objectKeys(e),a=x.objectKeys(n).filter(o=>s.indexOf(o)!==-1),i={...n,...e};for(let o of a){let u=st(n[o],e[o]);if(!u.valid)return{valid:!1};i[o]=u.data}return{valid:!0,data:i}}else if(t===f.array&&r===f.array){if(n.length!==e.length)return{valid:!1};let s=[];for(let a=0;a<n.length;a++){let i=n[a],o=e[a],u=st(i,o);if(!u.valid)return{valid:!1};s.push(u.data)}return{valid:!0,data:s}}else return t===f.date&&r===f.date&&+n==+e?{valid:!0,data:n}:{valid:!1}}var te=class extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e),s=(a,i)=>{if(nt(a)||nt(i))return g;let o=st(a.value,i.value);return o.valid?((rt(a)||rt(i))&&t.dirty(),{status:t.value,value:o.data}):(l(r,{code:d.invalid_intersection_types}),g)};return r.common.async?Promise.all([this._def.left._parseAsync({data:r.data,path:r.path,parent:r}),this._def.right._parseAsync({data:r.data,path:r.path,parent:r})]).then(([a,i])=>s(a,i)):s(this._def.left._parseSync({data:r.data,path:r.path,parent:r}),this._def.right._parseSync({data:r.data,path:r.path,parent:r}))}};te.create=(n,e,t)=>new te({left:n,right:e,typeName:h.ZodIntersection,...v(t)});var j=class n extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.array)return l(r,{code:d.invalid_type,expected:f.array,received:r.parsedType}),g;if(r.data.length<this._def.items.length)return l(r,{code:d.too_small,minimum:this._def.items.length,inclusive:!0,exact:!1,type:"array"}),g;!this._def.rest&&r.data.length>this._def.items.length&&(l(r,{code:d.too_big,maximum:this._def.items.length,inclusive:!0,exact:!1,type:"array"}),t.dirty());let a=[...r.data].map((i,o)=>{let u=this._def.items[o]||this._def.rest;return u?u._parse(new O(r,i,r.path,o)):null}).filter(i=>!!i);return r.common.async?Promise.all(a).then(i=>w.mergeArray(t,i)):w.mergeArray(t,a)}get items(){return this._def.items}rest(e){return new n({...this._def,rest:e})}};j.create=(n,e)=>{if(!Array.isArray(n))throw new Error("You must pass an array of schemas to z.tuple([ ... ])");return new j({items:n,typeName:h.ZodTuple,rest:null,...v(e)})};var Be=class n extends _{get keySchema(){return this._def.keyType}get valueSchema(){return this._def.valueType}_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.object)return l(r,{code:d.invalid_type,expected:f.object,received:r.parsedType}),g;let s=[],a=this._def.keyType,i=this._def.valueType;for(let o in r.data)s.push({key:a._parse(new O(r,o,r.path,o)),value:i._parse(new O(r,r.data[o],r.path,o)),alwaysSet:o in r.data});return r.common.async?w.mergeObjectAsync(t,s):w.mergeObjectSync(t,s)}get element(){return this._def.valueType}static create(e,t,r){return t instanceof _?new n({keyType:e,valueType:t,typeName:h.ZodRecord,...v(r)}):new n({keyType:z.create(),valueType:e,typeName:h.ZodRecord,...v(t)})}},ve=class extends _{get keySchema(){return this._def.keyType}get valueSchema(){return this._def.valueType}_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.map)return l(r,{code:d.invalid_type,expected:f.map,received:r.parsedType}),g;let s=this._def.keyType,a=this._def.valueType,i=[...r.data.entries()].map(([o,u],c)=>({key:s._parse(new O(r,o,r.path,[c,"key"])),value:a._parse(new O(r,u,r.path,[c,"value"]))}));if(r.common.async){let o=new Map;return Promise.resolve().then(async()=>{for(let u of i){let c=await u.key,p=await u.value;if(c.status==="aborted"||p.status==="aborted")return g;(c.status==="dirty"||p.status==="dirty")&&t.dirty(),o.set(c.value,p.value)}return{status:t.value,value:o}})}else{let o=new Map;for(let u of i){let c=u.key,p=u.value;if(c.status==="aborted"||p.status==="aborted")return g;(c.status==="dirty"||p.status==="dirty")&&t.dirty(),o.set(c.value,p.value)}return{status:t.value,value:o}}}};ve.create=(n,e,t)=>new ve({valueType:e,keyType:n,typeName:h.ZodMap,...v(t)});var _e=class n extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.parsedType!==f.set)return l(r,{code:d.invalid_type,expected:f.set,received:r.parsedType}),g;let s=this._def;s.minSize!==null&&r.data.size<s.minSize.value&&(l(r,{code:d.too_small,minimum:s.minSize.value,type:"set",inclusive:!0,exact:!1,message:s.minSize.message}),t.dirty()),s.maxSize!==null&&r.data.size>s.maxSize.value&&(l(r,{code:d.too_big,maximum:s.maxSize.value,type:"set",inclusive:!0,exact:!1,message:s.maxSize.message}),t.dirty());let a=this._def.valueType;function i(u){let c=new Set;for(let p of u){if(p.status==="aborted")return g;p.status==="dirty"&&t.dirty(),c.add(p.value)}return{status:t.value,value:c}}let o=[...r.data.values()].map((u,c)=>a._parse(new O(r,u,r.path,c)));return r.common.async?Promise.all(o).then(u=>i(u)):i(o)}min(e,t){return new n({...this._def,minSize:{value:e,message:m.toString(t)}})}max(e,t){return new n({...this._def,maxSize:{value:e,message:m.toString(t)}})}size(e,t){return this.min(e,t).max(e,t)}nonempty(e){return this.min(1,e)}};_e.create=(n,e)=>new _e({valueType:n,minSize:null,maxSize:null,typeName:h.ZodSet,...v(e)});var ze=class n extends _{constructor(){super(...arguments),this.validate=this.implement}_parse(e){let{ctx:t}=this._processInputParams(e);if(t.parsedType!==f.function)return l(t,{code:d.invalid_type,expected:f.function,received:t.parsedType}),g;function r(o,u){return Ue({data:o,path:t.path,errorMaps:[t.common.contextualErrorMap,t.schemaErrorMap,Ze(),he].filter(c=>!!c),issueData:{code:d.invalid_arguments,argumentsError:u}})}function s(o,u){return Ue({data:o,path:t.path,errorMaps:[t.common.contextualErrorMap,t.schemaErrorMap,Ze(),he].filter(c=>!!c),issueData:{code:d.invalid_return_type,returnTypeError:u}})}let a={errorMap:t.common.contextualErrorMap},i=t.data;if(this._def.returns instanceof q){let o=this;return S(async function(...u){let c=new C([]),p=await o._def.args.parseAsync(u,a).catch(N=>{throw c.addIssue(r(u,N)),c}),b=await Reflect.apply(i,this,p);return await o._def.returns._def.type.parseAsync(b,a).catch(N=>{throw c.addIssue(s(b,N)),c})})}else{let o=this;return S(function(...u){let c=o._def.args.safeParse(u,a);if(!c.success)throw new C([r(u,c.error)]);let p=Reflect.apply(i,this,c.data),b=o._def.returns.safeParse(p,a);if(!b.success)throw new C([s(p,b.error)]);return b.data})}}parameters(){return this._def.args}returnType(){return this._def.returns}args(...e){return new n({...this._def,args:j.create(e).rest(L.create())})}returns(e){return new n({...this._def,returns:e})}implement(e){return this.parse(e)}strictImplement(e){return this.parse(e)}static create(e,t,r){return new n({args:e||j.create([]).rest(L.create()),returns:t||L.create(),typeName:h.ZodFunction,...v(r)})}},ne=class extends _{get schema(){return this._def.getter()}_parse(e){let{ctx:t}=this._processInputParams(e);return this._def.getter()._parse({data:t.data,path:t.path,parent:t})}};ne.create=(n,e)=>new ne({getter:n,typeName:h.ZodLazy,...v(e)});var re=class extends _{_parse(e){if(e.data!==this._def.value){let t=this._getOrReturnCtx(e);return l(t,{received:t.data,code:d.invalid_literal,expected:this._def.value}),g}return{status:"valid",value:e.data}}get value(){return this._def.value}};re.create=(n,e)=>new re({value:n,typeName:h.ZodLiteral,...v(e)});function bt(n,e){return new se({values:n,typeName:h.ZodEnum,...v(e)})}var se=class n extends _{constructor(){super(...arguments),Se.set(this,void 0)}_parse(e){if(typeof e.data!="string"){let t=this._getOrReturnCtx(e),r=this._def.values;return l(t,{expected:x.joinValues(r),received:t.parsedType,code:d.invalid_type}),g}if(Le(this,Se,"f")||yt(this,Se,new Set(this._def.values),"f"),!Le(this,Se,"f").has(e.data)){let t=this._getOrReturnCtx(e),r=this._def.values;return l(t,{received:t.data,code:d.invalid_enum_value,options:r}),g}return S(e.data)}get options(){return this._def.values}get enum(){let e={};for(let t of this._def.values)e[t]=t;return e}get Values(){let e={};for(let t of this._def.values)e[t]=t;return e}get Enum(){let e={};for(let t of this._def.values)e[t]=t;return e}extract(e,t=this._def){return n.create(e,{...this._def,...t})}exclude(e,t=this._def){return n.create(this.options.filter(r=>!e.includes(r)),{...this._def,...t})}};Se=new WeakMap;se.create=bt;var ae=class extends _{constructor(){super(...arguments),Te.set(this,void 0)}_parse(e){let t=x.getValidEnumValues(this._def.values),r=this._getOrReturnCtx(e);if(r.parsedType!==f.string&&r.parsedType!==f.number){let s=x.objectValues(t);return l(r,{expected:x.joinValues(s),received:r.parsedType,code:d.invalid_type}),g}if(Le(this,Te,"f")||yt(this,Te,new Set(x.getValidEnumValues(this._def.values)),"f"),!Le(this,Te,"f").has(e.data)){let s=x.objectValues(t);return l(r,{received:r.data,code:d.invalid_enum_value,options:s}),g}return S(e.data)}get enum(){return this._def.values}};Te=new WeakMap;ae.create=(n,e)=>new ae({values:n,typeName:h.ZodNativeEnum,...v(e)});var q=class extends _{unwrap(){return this._def.type}_parse(e){let{ctx:t}=this._processInputParams(e);if(t.parsedType!==f.promise&&t.common.async===!1)return l(t,{code:d.invalid_type,expected:f.promise,received:t.parsedType}),g;let r=t.parsedType===f.promise?t.data:Promise.resolve(t.data);return S(r.then(s=>this._def.type.parseAsync(s,{path:t.path,errorMap:t.common.contextualErrorMap})))}};q.create=(n,e)=>new q({type:n,typeName:h.ZodPromise,...v(e)});var I=class extends _{innerType(){return this._def.schema}sourceType(){return this._def.schema._def.typeName===h.ZodEffects?this._def.schema.sourceType():this._def.schema}_parse(e){let{status:t,ctx:r}=this._processInputParams(e),s=this._def.effect||null,a={addIssue:i=>{l(r,i),i.fatal?t.abort():t.dirty()},get path(){return r.path}};if(a.addIssue=a.addIssue.bind(a),s.type==="preprocess"){let i=s.transform(r.data,a);if(r.common.async)return Promise.resolve(i).then(async o=>{if(t.value==="aborted")return g;let u=await this._def.schema._parseAsync({data:o,path:r.path,parent:r});return u.status==="aborted"?g:u.status==="dirty"||t.value==="dirty"?me(u.value):u});{if(t.value==="aborted")return g;let o=this._def.schema._parseSync({data:i,path:r.path,parent:r});return o.status==="aborted"?g:o.status==="dirty"||t.value==="dirty"?me(o.value):o}}if(s.type==="refinement"){let i=o=>{let u=s.refinement(o,a);if(r.common.async)return Promise.resolve(u);if(u instanceof Promise)throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");return o};if(r.common.async===!1){let o=this._def.schema._parseSync({data:r.data,path:r.path,parent:r});return o.status==="aborted"?g:(o.status==="dirty"&&t.dirty(),i(o.value),{status:t.value,value:o.value})}else return this._def.schema._parseAsync({data:r.data,path:r.path,parent:r}).then(o=>o.status==="aborted"?g:(o.status==="dirty"&&t.dirty(),i(o.value).then(()=>({status:t.value,value:o.value}))))}if(s.type==="transform")if(r.common.async===!1){let i=this._def.schema._parseSync({data:r.data,path:r.path,parent:r});if(!H(i))return i;let o=s.transform(i.value,a);if(o instanceof Promise)throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");return{status:t.value,value:o}}else return this._def.schema._parseAsync({data:r.data,path:r.path,parent:r}).then(i=>H(i)?Promise.resolve(s.transform(i.value,a)).then(o=>({status:t.value,value:o})):i);x.assertNever(s)}};I.create=(n,e,t)=>new I({schema:n,typeName:h.ZodEffects,effect:e,...v(t)});I.createWithPreprocess=(n,e,t)=>new I({schema:e,effect:{type:"preprocess",transform:n},typeName:h.ZodEffects,...v(t)});var A=class extends _{_parse(e){return this._getType(e)===f.undefined?S(void 0):this._def.innerType._parse(e)}unwrap(){return this._def.innerType}};A.create=(n,e)=>new A({innerType:n,typeName:h.ZodOptional,...v(e)});var M=class extends _{_parse(e){return this._getType(e)===f.null?S(null):this._def.innerType._parse(e)}unwrap(){return this._def.innerType}};M.create=(n,e)=>new M({innerType:n,typeName:h.ZodNullable,...v(e)});var ie=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r=t.data;return t.parsedType===f.undefined&&(r=this._def.defaultValue()),this._def.innerType._parse({data:r,path:t.path,parent:t})}removeDefault(){return this._def.innerType}};ie.create=(n,e)=>new ie({innerType:n,typeName:h.ZodDefault,defaultValue:typeof e.default=="function"?e.default:()=>e.default,...v(e)});var oe=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r={...t,common:{...t.common,issues:[]}},s=this._def.innerType._parse({data:r.data,path:r.path,parent:{...r}});return Ee(s)?s.then(a=>({status:"valid",value:a.status==="valid"?a.value:this._def.catchValue({get error(){return new C(r.common.issues)},input:r.data})})):{status:"valid",value:s.status==="valid"?s.value:this._def.catchValue({get error(){return new C(r.common.issues)},input:r.data})}}removeCatch(){return this._def.innerType}};oe.create=(n,e)=>new oe({innerType:n,typeName:h.ZodCatch,catchValue:typeof e.catch=="function"?e.catch:()=>e.catch,...v(e)});var xe=class extends _{_parse(e){if(this._getType(e)!==f.nan){let r=this._getOrReturnCtx(e);return l(r,{code:d.invalid_type,expected:f.nan,received:r.parsedType}),g}return{status:"valid",value:e.data}}};xe.create=n=>new xe({typeName:h.ZodNaN,...v(n)});var Zn=Symbol("zod_brand"),Ce=class extends _{_parse(e){let{ctx:t}=this._processInputParams(e),r=t.data;return this._def.type._parse({data:r,path:t.path,parent:t})}unwrap(){return this._def.type}},Ie=class n extends _{_parse(e){let{status:t,ctx:r}=this._processInputParams(e);if(r.common.async)return(async()=>{let a=await this._def.in._parseAsync({data:r.data,path:r.path,parent:r});return a.status==="aborted"?g:a.status==="dirty"?(t.dirty(),me(a.value)):this._def.out._parseAsync({data:a.value,path:r.path,parent:r})})();{let s=this._def.in._parseSync({data:r.data,path:r.path,parent:r});return s.status==="aborted"?g:s.status==="dirty"?(t.dirty(),{status:"dirty",value:s.value}):this._def.out._parseSync({data:s.value,path:r.path,parent:r})}}static create(e,t){return new n({in:e,out:t,typeName:h.ZodPipeline})}},ce=class extends _{_parse(e){let t=this._def.innerType._parse(e),r=s=>(H(s)&&(s.value=Object.freeze(s.value)),s);return Ee(t)?t.then(s=>r(s)):r(t)}unwrap(){return this._def.innerType}};ce.create=(n,e)=>new ce({innerType:n,typeName:h.ZodReadonly,...v(e)});function mt(n,e){let t=typeof n=="function"?n(e):typeof n=="string"?{message:n}:n;return typeof t=="string"?{message:t}:t}function wt(n,e={},t){return n?F.create().superRefine((r,s)=>{var a,i;let o=n(r);if(o instanceof Promise)return o.then(u=>{var c,p;if(!u){let b=mt(e,r),T=(p=(c=b.fatal)!==null&&c!==void 0?c:t)!==null&&p!==void 0?p:!0;s.addIssue({code:"custom",...b,fatal:T})}});if(!o){let u=mt(e,r),c=(i=(a=u.fatal)!==null&&a!==void 0?a:t)!==null&&i!==void 0?i:!0;s.addIssue({code:"custom",...u,fatal:c})}}):F.create()}var Un={object:E.lazycreate},h;(function(n){n.ZodString="ZodString",n.ZodNumber="ZodNumber",n.ZodNaN="ZodNaN",n.ZodBigInt="ZodBigInt",n.ZodBoolean="ZodBoolean",n.ZodDate="ZodDate",n.ZodSymbol="ZodSymbol",n.ZodUndefined="ZodUndefined",n.ZodNull="ZodNull",n.ZodAny="ZodAny",n.ZodUnknown="ZodUnknown",n.ZodNever="ZodNever",n.ZodVoid="ZodVoid",n.ZodArray="ZodArray",n.ZodObject="ZodObject",n.ZodUnion="ZodUnion",n.ZodDiscriminatedUnion="ZodDiscriminatedUnion",n.ZodIntersection="ZodIntersection",n.ZodTuple="ZodTuple",n.ZodRecord="ZodRecord",n.ZodMap="ZodMap",n.ZodSet="ZodSet",n.ZodFunction="ZodFunction",n.ZodLazy="ZodLazy",n.ZodLiteral="ZodLiteral",n.ZodEnum="ZodEnum",n.ZodEffects="ZodEffects",n.ZodNativeEnum="ZodNativeEnum",n.ZodOptional="ZodOptional",n.ZodNullable="ZodNullable",n.ZodDefault="ZodDefault",n.ZodCatch="ZodCatch",n.ZodPromise="ZodPromise",n.ZodBranded="ZodBranded",n.ZodPipeline="ZodPipeline",n.ZodReadonly="ZodReadonly"})(h||(h={}));var Ln=(n,e={message:`Input not instance of ${n.name}`})=>wt(t=>t instanceof n,e),kt=z.create,St=W.create,$n=xe.create,Bn=G.create,Tt=Q.create,zn=Y.create,Fn=ge.create,qn=K.create,Jn=X.create,Hn=F.create,Wn=L.create,Gn=R.create,Qn=ye.create,Yn=$.create,Kn=E.create,Xn=E.strictCreate,er=ee.create,tr=$e.create,nr=te.create,rr=j.create,sr=Be.create,ar=ve.create,ir=_e.create,or=ze.create,cr=ne.create,dr=re.create,ur=se.create,lr=ae.create,fr=q.create,ht=I.create,pr=A.create,mr=M.create,hr=I.createWithPreprocess,gr=Ie.create,yr=()=>kt().optional(),vr=()=>St().optional(),_r=()=>Tt().optional(),xr={string:n=>z.create({...n,coerce:!0}),number:n=>W.create({...n,coerce:!0}),boolean:n=>Q.create({...n,coerce:!0}),bigint:n=>G.create({...n,coerce:!0}),date:n=>Y.create({...n,coerce:!0})},br=g,y=Object.freeze({__proto__:null,defaultErrorMap:he,setErrorMap:hn,getErrorMap:Ze,makeIssue:Ue,EMPTY_PATH:gn,addIssueToContext:l,ParseStatus:w,INVALID:g,DIRTY:me,OK:S,isAborted:nt,isDirty:rt,isValid:H,isAsync:Ee,get util(){return x},get objectUtil(){return tt},ZodParsedType:f,getParsedType:U,ZodType:_,datetimeRegex:xt,ZodString:z,ZodNumber:W,ZodBigInt:G,ZodBoolean:Q,ZodDate:Y,ZodSymbol:ge,ZodUndefined:K,ZodNull:X,ZodAny:F,ZodUnknown:L,ZodNever:R,ZodVoid:ye,ZodArray:$,ZodObject:E,ZodUnion:ee,ZodDiscriminatedUnion:$e,ZodIntersection:te,ZodTuple:j,ZodRecord:Be,ZodMap:ve,ZodSet:_e,ZodFunction:ze,ZodLazy:ne,ZodLiteral:re,ZodEnum:se,ZodNativeEnum:ae,ZodPromise:q,ZodEffects:I,ZodTransformer:I,ZodOptional:A,ZodNullable:M,ZodDefault:ie,ZodCatch:oe,ZodNaN:xe,BRAND:Zn,ZodBranded:Ce,ZodPipeline:Ie,ZodReadonly:ce,custom:wt,Schema:_,ZodSchema:_,late:Un,get ZodFirstPartyTypeKind(){return h},coerce:xr,any:Hn,array:Yn,bigint:Bn,boolean:Tt,date:zn,discriminatedUnion:tr,effect:ht,enum:ur,function:or,instanceof:Ln,intersection:nr,lazy:cr,literal:dr,map:ar,nan:$n,nativeEnum:lr,never:Gn,null:Jn,nullable:mr,number:St,object:Kn,oboolean:_r,onumber:vr,optional:pr,ostring:yr,pipeline:gr,preprocess:hr,promise:fr,record:sr,set:ir,strictObject:Xn,string:kt,symbol:Fn,transformer:ht,tuple:rr,undefined:qn,union:er,unknown:Wn,void:Qn,NEVER:br,ZodIssueCode:d,quotelessJson:mn,ZodError:C});function Et(){let n="",e="abcdefghijklmnopqrstuvwxyz0123456789";for(let t=0;t<36;t++)Math.random()>.8&&t!==0&&t!==35&&n[t-1]!=="-"?n+="-":n+=e.charAt(Math.floor(Math.random()*e.length));return n}var wr=()=>{let n=new Date().getTime();return typeof performance<"u"&&typeof performance.now=="function"&&(n+=performance.now()),"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,e=>{let t=(n+Math.random()*16)%16|0;return n=Math.floor(n/16),(e==="x"?t:t&3|8).toString(16)})},Ae=()=>{try{let n=wr();return n||Et()}catch(n){console.error(n)}return Et()},Ct=()=>Ae(),It=()=>Ae(),At=()=>Ae();var J={GI:"GI",MMT:"MMT"};var at=class n{constructor(){this.settings={}}static getInstance(){return n.instance||(n.instance=new n,Object.freeze(n.instance)),n.instance}setSetting(e,t){this.settings[e]=t}getSetting(e){return this.settings[e]}},D=at.getInstance();function Pt(){return typeof window<"u"}function de(n){let e={};for(let t in n)if(Object.prototype.hasOwnProperty.call(n,t)){let r=n[t];r!=null&&r!=="NA"&&r!==""&&(typeof r!="object"||Object.keys(r).length>0)&&(!Array.isArray(r)||r.length>0)&&(e[t]=r)}return e}function k(n,e){let t=n.split("; ");for(let r=0;r<t.length;r++){let s=t[r];if(s.indexOf(e+"=")===0)return s.substring(e.length+1)}return null}function kr(n,e){try{let t="",r=0;if(!e)throw new Error("Key is empty");for(let s=0;s<n.length;s+=1){let a=n.charCodeAt(s),i=e.charCodeAt(r),o=a^i;t+=String.fromCharCode(o),r=(r+1)%e.length}return t}catch(t){return console.error("An error occurred during the decryption process:",t),null}}function it(n){let e=sessionStorage.getItem("userInfo")||localStorage.getItem("userInfo");if(!e)return console.log("userInfo is not found in sessionStorage"),null;if(n)return JSON.parse(e);let t=new RegExp("^enct-"),r=e.replace(t,""),s=kr(r,"awefewfuihewfhewfuhiebc");if(!s)return console.error("Decryption failed"),null;try{return JSON.parse(s)}catch(a){return console.error("Error parsing JSON:",a),null}}function Rt(){let n="marketingCloudVisitorID",e=window?.s?.marketingCloudVisitorID,t=localStorage.getItem(n),r=k(document?.cookie,"s_ecid");return r?decodeURI(r)?.split("|")[1]:e?(e!=t&&localStorage.setItem(n,e),e):t||"NA"}function Fe(n){return it(n===J.GI)}function Oe(n){if(!n)return null;let{uuid:e="",profile_type:t="PERSONAL"}=n;return t&&e?`${e}/${t.toUpperCase()}`:null}function Sr(n){let t=window.location.search.substring(1).split("&");for(let r=0;r<t.length;r++){let s=t[r].split("="),a=decodeURIComponent(s[0]),i=decodeURIComponent(s[1]);if(a===n)return i}}function ot(){let n=Sr("cmp");return n?{campaign_key:n}:null}function Pe(n){return n?/^https?:\/\//i.test(n)?n:`https://${n}`:`https://pdt.${(typeof window<"u"?window.location.hostname:"")?.split(".")?.slice(-2)?.join(".")||"makemytrip.com"}`}function Dt(n,e){let t=e||(typeof window<"u"?window.location.hostname:""),r={};return Nt(t)&&(r={"entity-name":t&&t.includes(".global")?"global":"india"}),{...n,...r}}var Tr={in:"inr",ae:"aed",sa:"sar"};function Er(){return(typeof window<"u"?window.location.hostname:"").includes("goibibo")}function Nt(n){return(n||(typeof window<"u"?window.location.hostname:"")).includes("makemytrip")}function Cr(){return{entity:"india",currency:"inr",region:"in",user_language:"eng",organisation:"gi"}}function Ot(){let n=typeof window<"u"?window.location.hostname:"",e=n&&n.includes(".global")?"global":"india",t=Re(),{region:r,userCountry:s,language:a,userCurrency:i,currency:o,isWorldwide:u}=t;return{entity:e,currency:o,region:r,user_currency:i,user_country:u?s:r,user_language:a,organisation:"mmt"}}function jt(){return Nt()?Ot():Er()?Cr():Ot()}function Re(){let n=k(document?.cookie,"cc")?.toLowerCase()||"in",e=k(document?.cookie,"ccde")?.toLowerCase()||"in",t=k(document?.cookie,"isWorldwide"),r=k(document?.cookie,"lang")?.toLowerCase()||"eng",s=k(document?.cookie,"userCurrency")?.toLowerCase()||"",a=t?parseInt(t):0;return{currency:e?Tr[e]:"",isWorldwide:a,language:r,region:e,userCountry:n,userCurrency:s}}var B={b2b:"business",b2c:"personal",myPartner:"cta"};function De(){let n=k(document?.cookie,"myBusinessSubscription");return B[n]||B.b2c}function Mt(n){return n===J.GI}function Ir(n){if(!n||typeof n!="string")return{};let e={};return n.split("|").forEach(r=>{let[s,a]=r.split(":");s&&a!==void 0&&(e[s.trim()]=a.trim())}),e}function Vt(){let n=De(),e=Fe();if(n===B.myPartner)return{user_role:e?.userCorpData?.agentRole,org_id:e?.userCorpData?.agencyUUID};if(n===B.b2b){let t=localStorage.getItem("myBizOrgContext")||"";if(!t)return{};let r=Ir(t);return{org_id:e?.userCorpData?.organizationId,org_type:e?.userCorpData?.orgType,verification_status:e?.userCorpData?.employeeStatus,user_role:e?.userCorpData?.employeeType,...r}}return{}}var Zt="4.3.0";var P="NA",Ne=n=>{let{screen:e,navigator:t}=n,r=Re(),{userCountry:s,isWorldwide:a,region:i}=r,o=a?s:i,u="",c=P,p=P;e&&e.width&&(c=e.width?`${e.width}`:P,p=e.height?`${e.height}`:P,u+=`${c}*${p}`);let b=k(document.cookie,"dvid")||k(document.cookie,"__gi_vid")||P,T=P;"connection"in n.navigator&&typeof n.navigator.connection=="object"&&n.navigator.connection&&"effectiveType"in n.navigator.connection&&typeof n.navigator.connection.effectiveType=="string"&&(T=n.navigator.connection.effectiveType);let{browser:N,os:ke,device:V}=ua_parser_js__WEBPACK_IMPORTED_MODULE_0__(t.userAgent),le;switch(V.type?.toLowerCase()){case"mobile":case"tablet":le="pwa";break;default:le="desktop";break}return{deviceId:b,os:ke.name?.toLowerCase()||P,osVersion:ke.version||P,browser:N.name||P,version:Zt||P,userAgent:t.userAgent,screenSize:u,screenWidth:c,screenHeight:p,networkType:T,platform:le,model:V.model||P,manufacturer:V.vendor||P,acquired_country:o}};var Lt="session_info";async function qe(n,e){await e.setItem(Lt,JSON.stringify(n))}async function Pr(n){let e=await n.getItem(Lt);return e?JSON.parse(e):null}var Ut={inActiveThresholdInMins:30,expiryInMins:120};function Rr(n){if(!n)return!1;let e=Date.now(),t=(e-n.createdAt)/6e4>Ut.expiryInMins,r=(e-n.lastUsed)/6e4>Ut.inActiveThresholdInMins;return!t&&!r}async function Dr(n){let e=Date.now(),t={createdAt:e,lastUsed:e,id:At(),isSynced:!1,retry:0};return await qe(t,n),setTimeout(async()=>{await je(!0,void 0,n)},0),t}async function ue(n){let e=await Pr(n);return Rr(e)?e:Dr(n)}var be=class{constructor(e){this.storage=e}async getCurrentSessionId(){return(await ue(this.storage)).id}async updateLastUsed(){let e=await ue(this.storage);await qe({...e,lastUsed:Date.now()},this.storage)}async lastUsed(){return(await ue(this.storage)).lastUsed}async updateSyncStatus(){let e=await ue(this.storage);await qe({...e,isSynced:!e?.isSynced},this.storage)}async getSyncStatus(){return(await ue(this.storage)).isSynced}async getRetryStatus(){return(await ue(this.storage)).retry}async updateRetryStatus(){let e=await ue(this.storage);await qe({...e,retry:e?.retry+1},this.storage)}};var Nr="/fs/w",jr={"Content-Type":"application/json","Request-Data-Encoding":"json"},Mr="NA",Vr="mmt_session_aero_store";async function Zr({userId:n,sessionManager:e,deviceDetails:t}){let r=typeof sessionStorage<"u"?it():null,s=n;if(r!==null&&typeof r=="object"){let{uuid:u,profileType:c}=r,p=Oe({uuid:u,profile_type:c});s=n||p}let a=t?.device_id||k(document.cookie,"dvid")||Mr,i=t?.platform||Ne(window)?.platform,o=await e.getCurrentSessionId();return JSON.stringify([{uuidPT:s,deviceId:a,value:{session_id:o},column:i==="pwa"?"pwa":"desktop",datasetName:Vr}])}var je=async(n,e,t)=>{if(!n)return"success";let r=t||ct(),s=e||new be(r),a=await s.getSyncStatus(),i=await s.getRetryStatus(),o=D.getSetting("userIdPt"),u=D.getSetting("deviceContext");if(a||i>6)return"success";try{let c=D.getSetting("pdtHost"),p=`${Pe(c)}${Nr}`,b=await Zr({userId:o,sessionManager:s,deviceDetails:u}),T=await fetch(p,{method:"POST",body:b,headers:jr,keepalive:!0});if(!T.ok)throw new Error(`HTTP error! status: ${T.status}`);return await s.updateSyncStatus(),"success"}catch(c){return console.log("Failed to sync session ID to PDT DB:",c),s.updateRetryStatus(),"failure"}};var $t=200,dt="error",Me="page-rendered",Bt=y.enum(["mmt","gi"]),zt=y.enum(["india","global"]),Ft=y.enum(["in","ae","sa"]),qt=y.enum(["inr","usd","aed","sar"]),Jt=y.enum(["eng","hin","tam","ara"]),Ht=y.enum(["personal","business","cta","affiliates"]),Wt=y.enum(["desktop","pwa","mobile"]),Gt=y.enum(["android","ios","mac os","windows","linux","blackberry","symbian","nokia","webos","unix","samsung","other"]),Qt=y.enum(["landing","funnel","template","promo"]),Yt=y.enum(["landing","listing","detail","review","payment","thankyou"]),Kt=y.enum(["common","flights","hotels","bus","rails","cabs","holidays","travelinsurance","forex","giftcards","visa","w2g","acme","how2go","travelcard","hostapp","postsales"]),Xt=y.enum(["common","df","if","dh","ih","bus","rails","dom_acabs","dom_ocabs","dom_hrcabs","intl_acabs","intl_ocabs","intl_hrcabs","domhld","intlhld","travelinsurance","forex","pc","cn","nc","giftcards","e-visa","sticker-visa","w2g","dom_acme","intl_acme","how2go","travelcard","hostapp"]),en=y.enum([Me,dt,"search-clicked","sort_by-clicked","filter-applied","filter_all-cleared","content_card_filter-clicked","content_header-filter-clicked","map_filter-clicked","product_card_filter-clicked","popup-rendered","login-succeeded","user-logged-out","signup-completed","chat-interacted","send-quote","price-change"]);var Ur=y.object({webPageDetails:y.object({name:y.string().min(1,{message:"webPageDetails.name cannot be empty"}),pageViews:y.object({value:y.number()}),isErrorPage:y.boolean().optional()})}),Lr=y.object({webInteraction:y.object({name:y.string().nullable(),type:y.string().nullable().optional(),url:y.string().nullable().optional(),linkClicks:y.object({value:y.number()})})}),tn=n=>y.object({event:y.string(),web:n===Me?Ur:Lr}).passthrough();var nn=y.object({entity_info:y.object({organisation:Bt,entity:zt,region:Ft,currency:qt,user_language:Jt}),user_context:y.object({profile_type:Ht}),device_context:y.object({platform:Wt,os:Gt}),page_context:y.object({page_type:Qt,funnel_step:Yt,page_name:y.string().min(1,{message:"page_name cannot be empty"}),lob:Kt,lob_category:Xt}),event_detail:y.object({event_type:y.string().min(1,{message:"event_type cannot be empty"}),event_name:y.string().min(1,{message:"event_name cannot be empty"})})}),Je=n=>n.issues.map(e=>({path:e.path.join("."),message:e.message,code:e.code}));var He=class{constructor(e,t){let r=this.createAdobeSchema(e,t);this.validateAdobeSchema(r),this.adobeSchema=r,this.pushToADL()}createAdobeSchema(e,t){let r=`xdm_${e.event_detail.event_name}`,s;return e.event_detail.event_name===Me?(s={webPageDetails:{name:e.page_context.page_name||window.location.pathname,pageViews:{value:1}}},e?.error_details_list?.length&&(s.webPageDetails.isErrorPage=!0)):(r=en.safeParse(e.event_detail.event_name).success?e.event_detail.event_type===dt?"xdm_error":`xdm_${e.event_detail.event_name}`:"xdm_cta_click",s={webInteraction:{name:e.event_detail.event_name,type:"other",url:t?.destinationUrl||"",linkClicks:{value:1}}}),{event:r,web:s,_makemytrip:e}}validateAdobeSchema(e){try{tn(e._makemytrip.event_detail.event_name).parse(e)}catch(t){if(t instanceof y.ZodError){let r=Je(t);throw new Error(`Adobe Analytics Schema validation failed: ${JSON.stringify(r,null,2)}`)}throw t}}pushToADL(){window.adobeDataLayer||(window.adobeDataLayer=[]);let e=this.adobeSchema;try{e.event==="xdm_cta_click"?setTimeout(()=>{window.adobeDataLayer?.push(e)},$t):window.adobeDataLayer.push(e)}catch(t){let r=t instanceof Error?t.message:"Unknown error";throw new Error(`Failed to push to Adobe Data Layer: ${r}`)}}};var We=class{constructor(e){this.validators=[];this.newCorrelationId=()=>Promise.resolve(Ct());this.newRequestId=()=>Promise.resolve(It());this.getSessionId=()=>Promise.resolve(this.sessionManager.getCurrentSessionId());this.setOptOutStatus=e=>this.optInStateManager.updateOptInStatus(e);this.getOptOutStatus=()=>this.optInStateManager.readOptInStatus();this.track=async(e,t)=>{let r=await this.enrichBaseEventArg(e,t);for await(let s of this.validators)await s.assertValidSchema(r,t);this.jobQueue.pushEvent(r),this.sessionManager.updateLastUsed()};this.pushToPDT=async(e,t)=>{let r=t?.lob||"",s=await this.enrichAndValidateBaseEvent(e,t);for await(let a of this.validators)await a.assertValidSchema(s,r);this.jobQueue.pushEvent(s),this.sessionManager.updateLastUsed()};this.pushToAdobeDataLayer=async(e,t)=>{let r=await this.enrichAndValidateBaseEvent(e,t);new He(r,t)};this.pushToAll=async(e,t)=>{await Promise.all([this.pushToPDT(e),this.pushToAdobeDataLayer(e,t)])};this.flushEvents=()=>{this.jobQueue.flushNow("terminal")};this.stopAutoFlush=()=>{this.flushEvents(),this.jobQueue.shutdown()};this.onAppVisibilityChange=e=>{e==="hidden"&&this.flushEvents()};this.enrichBaseEventArg=async(e,t)=>{let r=await this.getSessionId(),s=await this.newRequestId(),a=this.runtimeContextProvider?.getDeviceContext(),i=this.runtimeContextProvider?.getUserContext(this.org),o=this.runtimeContextProvider?.getUserDetailsContextExtended?.(),u=this.runtimeContextProvider?.getDeviceDetailsContextExtended?.(),c=this.sdkRuntimeProvider?.getDeviceContext(),p=this.sdkRuntimeProvider?.getUserContext(this.org),b=this.sdkRuntimeProvider?.getEventTrackingContext?.(),T=ot();if(D.setSetting("deviceContext",a),i?.uuid&&i?.profile_type){let fe=Oe({uuid:i?.uuid,profile_type:i?.profile_type});D.setSetting("userIdPt",fe)}let N=await this.sessionManager.getRetryStatus();!await this.sessionManager.getSyncStatus()&&N>0&&N<6&&setTimeout(async()=>{await je(!0,this.sessionManager,void 0)},10);let V=Object.freeze({...e,event_detail:{event_id:s,event_timestamp:Date.now(),device_details_extended:{...u},user_details_extended:{...o},...e.event_detail},event_tracking_context:{...b,...e.event_tracking_context,session_id:r},user_context:{...p,...i,...e?.user_context},device_context:{...c,...a,...e?.device_context},campaign_details:e.campaign_details||T}),le=this.validators.map(fe=>fe.assertValidSchema(V,t));return await Promise.all(le),V};this.enrichUpdatedBaseEventArg=async(e,t)=>{let r=await this.getSessionId(),s=await this.newRequestId(),a=this.runtimeContextProvider?.getDeviceContext(),i=this.runtimeContextProvider?.getUserContext(this.org),o=this.runtimeContextProvider?.getUserDetailsContextExtended?.(),u=this.runtimeContextProvider?.getDeviceDetailsContextExtended?.(),c=this.sdkRuntimeProvider?.getDeviceContext(),p=this.sdkRuntimeProvider?.getUserContext(this.org),b=this.sdkRuntimeProvider?.getEventTrackingContext?.(),T=ot(),N=jt(),ke=this.sdkRuntimeProvider?.getUserIdentities?.(this.org);if(D.setSetting("deviceContext",a),i?.uuid&&i?.profile_type){let Xe=Oe({uuid:i?.uuid,profile_type:i?.profile_type});D.setSetting("userIdPt",Xe)}let V=await this.sessionManager.getRetryStatus();!await this.sessionManager.getSyncStatus()&&V>0&&V<6&&setTimeout(async()=>{await je(!0,this.sessionManager,void 0)},10);let fe=De(),ln=fe===B.myPartner||fe===B.b2b,fn=Object.freeze({...e,identities:{...ke,...e?.identities},event_detail:{event_id:s,event_timestamp:Date.now(),device_details_extended:{...u},user_details_extended:{...o},...e?.event_detail},event_tracking_context:{...b,...e?.event_tracking_context,session_id:r},user_context:{...p,...i,...e?.user_context},device_context:{...c,...a,...e?.device_context},campaign_details:e?.campaign_details||T,entity_info:N,...ln&&{organization_context:Vt()}}),ft=de(fn),pn=this.validators.map(Xe=>Xe.assertValidSchema(ft,t));return await Promise.all(pn),ft};let{sessionManager:t,optInStateManager:r,runtimeContextProvider:s,jobQueue:a,sdkRuntimeProvider:i,org:o}=e;this.runtimeContextProvider=s,this.sdkRuntimeProvider=i,this.sessionManager=t,this.optInStateManager=r,this.jobQueue=a,this.jobQueue.start(),this.org=o||J.MMT}addValidator(e){this.validators.push(e)}setRuntimeContextProvider(e){this.runtimeContextProvider=e}async enrichAndValidateBaseEvent(e,t){let r=t?.lob||"",s=await this.enrichUpdatedBaseEventArg(e,r);try{nn.parse(s)}catch(a){if(a instanceof y.ZodError){let i=Je(a);throw console.error("Event Schema:",s),new Error(`Schema Validation Failed: ${JSON.stringify(i,null,2)}`)}throw a}return s}};var rn="analytics_opt_in",Ge=class{constructor(e){this.storage=e}async readOptInStatus(){let e=await this.storage.getItem(rn);return Promise.resolve(e!==null&&JSON.parse(e))}async updateOptInStatus(e){await this.storage.setItem(rn,`${e}`)}};var $r="https://pdt.makemytrip.com",sn="/dts/s/da/n",an={"Content-Type":"application/json","Request-Data-Encoding":"json","Accept-Encoding":"gzip"},Br={PDT_HOST:$r,SEND_EVENT_ENDPOINT:sn,PDT_REQ_HEADERS:an},Ve=class{constructor(e){this._host=e?.host||"",D.setSetting("pdtHost",this._host),this._sendEndpoint=`${Pe(this._host)}${e?.sendEndpoint||sn}`,this._baseHeaders=Dt(e?.baseHeaders||an,Pe(this._host))}async sendEvents(e,t,r){if(r)return r({events:e,priority:t,headers:this._baseHeaders,endpoint:this._sendEndpoint});let s=JSON.stringify(e);return await fetch(this._sendEndpoint,{method:"POST",body:s,headers:this._baseHeaders,keepalive:!0}),Promise.resolve("success")}};var Qe=class{getItem(e){return localStorage.getItem(e)}setItem(e,t){localStorage.setItem(e,String(t))}};var we="NA";function zr(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone}catch{return we}}function ut(){if(!Pt())throw new Error("only browser environment not supported")}var lt={getDeviceContext(){ut();let{os:n,osVersion:e,networkType:t,version:r,browser:s,platform:a,deviceId:i,model:o,userAgent:u,acquired_country:c}=Ne(window),p=zr();return de({app_ver:r,vendor_id:s,device_id:i,os:n,os_version:e,network_type:t,platform:a,time_zone:p,model:o,user_agent:u,acquired_country:c})},getUserContext(n){ut();let e=k(document.cookie,"mmt-auth")||k(document.cookie,"OAUTH-GOIBIBO"),t=k(document.cookie,"gitokenid")||void 0,r=Fe(n),s=Rt();if(Mt(n)){let a={uuid:t,profile_type:B.b2c,is_logged_in:!!e,marketing_cloud_id:s,login_channel:J.GI,login_type:"OTP"};return de(a)}else{let a={},i=localStorage.getItem("walletInfo");if(i){let p=JSON.parse(i),b=p?.loyaltyData||{};b?.status&&(a.loyalty_status=b.status),b?.program&&(a.loyalty_type=b.program),b?.currentTier?.name&&(a.loyalty_level=b.currentTier.name),p?.multiCurrencyDetails?.totalWalletAmount&&(a.wallet_bal=p.multiCurrencyDetails.totalWalletAmount)}let o=localStorage.getItem("channel");o&&(a.login_channel=o);let u=localStorage.getItem("loginType");u&&(a.login_type=u);let c={uuid:r?.uuid,profile_type:De(),is_logged_in:!!e,marketing_cloud_id:s,login_channel:a.login_channel,login_type:a.login_type,nationality:r?.nationality,loyalty_status:a.loyalty_status,loyalty_type:a.loyalty_type,loyalty_level:a.loyalty_level,wallet_bal:a.wallet_bal};return de(c)}},getEventTrackingContext(){ut();let n=Re(),{region:e,currency:t,userCurrency:r,language:s}=n;return de({template_id:0,topic_name:we,env:we,timezone:we,session_id:we,funnel_source:we,session_visit_number:0,region:e,user_preferred_currency:r,domain_country:e,domain_language:s,domain_currency:t})},getUserIdentities(n){let e=Fe(n),t=null,r=null;if(n===J.GI&&e)t=e?.value?.mHash,r=e?.value?.eHash;else if(e?.identities)t=e?.identities?.mHash,r=e?.identities?.eHash;else if(Array.isArray(e?.loginInfoList)){let a=e.loginInfoList.find(o=>o.loginType==="MOBILE"&&o.commId),i=e.loginInfoList.find(o=>o.loginType==="EMAIL"&&o.commId);a&&(t=a.commId),i&&(r=i.commId)}let s={};return t&&(s.phone_number_hash=t),r&&(s.email_address_hash=r),Object.keys(s).length?s:null}};var Ye=class{constructor(){this._store={}}getItem(e){return this._store[e]||null}setItem(e,t){this._store[e]=String(t)}};var Fr=60*1e3,Ke=class n{constructor(e,t,r){this.jobs=[];this._timer=-1;this.networkClient=e,this.storage=t,this.config=r,this.restoreState()}start(){this._timer===-1&&(this._timer=setInterval(()=>this.execute(),this.config.autoFlushIntervalInMs))}shutdown(){clearInterval(this._timer),this._timer=-1}flushNow(e="normal"){this.execute(e)}saveState(){this.storage.setItem("@events/job-queue",JSON.stringify(this.jobs))}restoreState(){let e=this.storage.getItem("@events/job-queue");e&&(this.jobs=JSON.parse(e),this.jobs=this.jobs.map(t=>({...t,status:"pending"})))}static findLast(e,t){for(let r=e.length-1;r>=0;r--){let s=e[r];if(t(s,r))return s}}pushEvent(e){let t=n.findLast(this.jobs,r=>r.status==="pending"&&r.events.length<this.config.maxBatchSize);(!t||t.events.length>=this.config.maxBatchSize)&&(t={events:[],status:"pending",id:Ae(),retryCount:0},this.jobs.push(t)),t.events.push(e),this.saveState()}execute(e="normal"){let t=this.jobs.filter(r=>r.status==="pending");for(let r of t)this.updateJobStatus(r,"running"),this.networkClient.sendEvents(r.events,e,null).then(s=>{s==="success"?this.updateJobStatus(r,"done"):s==="failed"&&this.updateJobStatus(r,"failed")})}updateJobStatus(e,t){let r=this.jobs.map(s=>{if(s.id!==e.id)return s;switch(t){case"done":return{...s,status:"done"};case"running":return{...s,start:Date.now(),status:"running"};case"failed":return{...s,status:s.retryCount<2?"pending":"done",retryCount:s.retryCount+1};default:return s}});r=r.filter(s=>s.status!=="done").filter(s=>!(s.status==="running"&&Date.now()-(s.start||0)>Fr)),this.jobs=r,this.saveState()}};function qr(n){let e=ct(),t=n.networkClient||new Ve,r=n.runtimeContextProvider,s=new Ge(e),a=new be(e),i={assertSchema:!1,autoFlushIntervalInMs:5e3,maxBatchSize:5},o=new We({optInStateManager:s,sessionManager:a,runtimeContextProvider:r,sdkRuntimeProvider:lt,jobQueue:new Ke(t,e,i),...n});return typeof window<"u"&&document.addEventListener("visibilitychange",()=>{document.visibilityState==="hidden"&&o.onAppVisibilityChange("hidden")}),o}function ct(){return(()=>{try{if(typeof window?.localStorage<"u")return!0}catch{}return!1})()?new Qe:new Ye}var on={development:"https://assets.adobedtm.com/a4d1854113f4/2f183a80c856/launch-cc2440d362e4-development.min.js",production:"https://assets.adobedtm.com/a4d1854113f4/2f183a80c856/launch-4aefa0b9df82.min.js"},cn=n=>on[n]||on.production,Jr=(n="development")=>`<script src="${cn(n)}" async></script>`,Hr=(n="development")=>cn(n);var dn={development:"https://assets.adobedtm.com/79483c2c7c00/c269e98139c1/launch-197ba8a65d9c-development.min.js",production:"https://assets.adobedtm.com/79483c2c7c00/c269e98139c1/launch-adcfac9ffc6d.min.js"},un=n=>dn[n]||dn.production,Wr=(n="development")=>`<script src="${un(n)}" async></script>`,Gr=(n="development")=>un(n);
//# sourceMappingURL=index.mjs.map

/***/ }),

/***/ 1183:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
  return _classApplyDescriptorGet(receiver, descriptor);
}
function _classPrivateFieldSet(receiver, privateMap, value) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
  _classApplyDescriptorSet(receiver, descriptor, value);
  return value;
}
function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _classApplyDescriptorSet(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _classPrivateMethodInitSpec(obj, privateSet) {
  _checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}

var list = [
	" daum[ /]",
	" deusu/",
	" yadirectfetcher",
	"(?:^| )site",
	"(?:^|[^g])news",
	"@[a-z]",
	"\\(at\\)[a-z]",
	"\\(github\\.com/",
	"\\[at\\][a-z]",
	"^12345",
	"^<",
	"^[\\w \\.\\-\\(\\)]+(/v?\\d+(\\.\\d+)?(\\.\\d{1,10})?)?$",
	"^[^ ]{50,}$",
	"^active",
	"^ad muncher",
	"^amaya",
	"^anglesharp/",
	"^anonymous",
	"^avsdevicesdk/",
	"^axios/",
	"^bidtellect/",
	"^biglotron",
	"^btwebclient/",
	"^castro",
	"^clamav[ /]",
	"^client/",
	"^cobweb/",
	"^coccoc",
	"^custom",
	"^ddg[_-]android",
	"^discourse",
	"^dispatch/\\d",
	"^downcast/",
	"^duckduckgo",
	"^facebook",
	"^fdm[ /]\\d",
	"^getright/",
	"^gozilla/",
	"^hatena",
	"^hobbit",
	"^hotzonu",
	"^hwcdn/",
	"^jeode/",
	"^jetty/",
	"^jigsaw",
	"^linkdex",
	"^lwp[-: ]",
	"^metauri",
	"^microsoft bits",
	"^movabletype",
	"^mozilla/\\d\\.\\d \\(compatible;?\\)$",
	"^mozilla/\\d\\.\\d \\w*$",
	"^navermailapp",
	"^netsurf",
	"^offline explorer",
	"^php",
	"^postman",
	"^postrank",
	"^python",
	"^read",
	"^reed",
	"^restsharp/",
	"^snapchat",
	"^space bison",
	"^svn",
	"^swcd ",
	"^taringa",
	"^test certificate info",
	"^thumbor/",
	"^tumblr/",
	"^user-agent:mozilla",
	"^valid",
	"^venus/fedoraplanet",
	"^w3c",
	"^webbandit/",
	"^webcopier",
	"^wget",
	"^whatsapp",
	"^xenu link sleuth",
	"^yahoo",
	"^yandex",
	"^zdm/\\d",
	"^zoom marketplace/",
	"^{{.*}}$",
	"adbeat\\.com",
	"appinsights",
	"archive",
	"ask jeeves/teoma",
	"bit\\.ly/",
	"bluecoat drtr",
	"bot",
	"browsex",
	"burpcollaborator",
	"capture",
	"catch",
	"check",
	"chrome-lighthouse",
	"chromeframe",
	"cloud",
	"crawl",
	"cryptoapi",
	"dareboost",
	"datanyze",
	"dataprovider",
	"dejaclick",
	"dmbrowser",
	"download",
	"evc-batch/",
	"feed",
	"firephp",
	"freesafeip",
	"ghost",
	"gomezagent",
	"google",
	"headlesschrome/",
	"http",
	"httrack",
	"hubspot marketing grader",
	"hydra",
	"ibisbrowser",
	"images",
	"iplabel",
	"ips-agent",
	"java",
	"library",
	"mail\\.ru/",
	"manager",
	"monitor",
	"morningscore/",
	"neustar wpm",
	"nutch",
	"offbyone",
	"optimize",
	"pageburst",
	"pagespeed",
	"perl",
	"phantom",
	"pingdom",
	"powermarks",
	"preview",
	"proxy",
	"ptst[ /]\\d",
	"reader",
	"rexx;",
	"rigor",
	"rss",
	"scan",
	"scrape",
	"search",
	"serp ?reputation ?management",
	"server",
	"sogou",
	"sparkler/",
	"speedcurve",
	"spider",
	"statuscake",
	"stumbleupon\\.com",
	"supercleaner",
	"synapse",
	"synthetic",
	"taginspector/",
	"torrent",
	"tracemyfile",
	"transcoder",
	"trendsmapresolver",
	"twingly recon",
	"url",
	"virtuoso",
	"wappalyzer",
	"webglance",
	"webkit2png",
	"websitemetadataretriever",
	"whatcms/",
	"wordpress",
	"zgrab"
];

/**
 * Mutate given list of patter strings
 * @param {string[]} list
 * @returns {string[]}
 */
function amend(list) {
  try {
    // Risk: Uses lookbehind assertion, avoid breakage in parsing by using RegExp constructor
    new RegExp('(?<! cu)bot').test('dangerbot'); // eslint-disable-line prefer-regex-literals
  } catch (error) {
    // Skip regex fixes
    return list;
  }
  [
  // Addresses: Cubot device
  ['bot', '(?<! cu)bot'],
  // Addresses: Android webview
  ['google', '(?<! (?:channel/|google/))google(?!(app|/google| pixel))'],
  // Addresses: libhttp browser
  ['http', '(?<!(?:lib))http'],
  // Addresses: java based browsers
  ['java', 'java(?!;)'],
  // Addresses: Yandex Search App
  ['search', '(?<! ya(?:yandex)?)search']].forEach(_ref => {
    let [search, replace] = _ref;
    const index = list.lastIndexOf(search);
    if (~index) {
      list.splice(index, 1, replace);
    }
  });
  return list;
}

amend(list);
const flags = 'i';

/**
 * Test user agents for matching patterns
 */
var _list = /*#__PURE__*/new WeakMap();
var _pattern = /*#__PURE__*/new WeakMap();
var _update = /*#__PURE__*/new WeakSet();
var _index = /*#__PURE__*/new WeakSet();
class Isbot {
  constructor(patterns) {
    /**
     * Find the first index of an existing rule or -1 if not found
     * @param  {string} rule
     * @returns {number}
     */
    _classPrivateMethodInitSpec(this, _index);
    /**
     * Recreate the pattern from rules list
     */
    _classPrivateMethodInitSpec(this, _update);
    /**
     * @type {string[]}
     */
    _classPrivateFieldInitSpec(this, _list, {
      writable: true,
      value: void 0
    });
    /**
     * @type {RegExp}
     */
    _classPrivateFieldInitSpec(this, _pattern, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _list, patterns || list.slice());
    _classPrivateMethodGet(this, _update, _update2).call(this);
    const isbot = ua => this.test(ua);
    return Object.defineProperties(isbot, Object.entries(Object.getOwnPropertyDescriptors(Isbot.prototype)).reduce((accumulator, _ref) => {
      let [prop, descriptor] = _ref;
      if (typeof descriptor.value === 'function') {
        Object.assign(accumulator, {
          [prop]: {
            value: this[prop].bind(this)
          }
        });
      }
      if (typeof descriptor.get === 'function') {
        Object.assign(accumulator, {
          [prop]: {
            get: () => this[prop]
          }
        });
      }
      return accumulator;
    }, {}));
  }
  /**
   * Get a clone of the pattern
   * @type RegExp
   */
  get pattern() {
    return new RegExp(_classPrivateFieldGet(this, _pattern));
  }

  /**
   * Match given string against out pattern
   * @param  {string} ua User Agent string
   * @returns {boolean}
   */
  test(ua) {
    return Boolean(ua) && _classPrivateFieldGet(this, _pattern).test(ua);
  }

  /**
   * Get the match for strings' known crawler pattern
   * @param  {string} ua User Agent string
   * @returns {string|null}
   */
  find() {
    let ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const match = ua.match(_classPrivateFieldGet(this, _pattern));
    return match && match[0];
  }

  /**
   * Get the patterns that match user agent string if any
   * @param  {string} ua User Agent string
   * @returns {string[]}
   */
  matches() {
    let ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return _classPrivateFieldGet(this, _list).filter(entry => new RegExp(entry, flags).test(ua));
  }

  /**
   * Clear all patterns that match user agent
   * @param  {string} ua User Agent string
   * @returns {void}
   */
  clear() {
    let ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    this.exclude(this.matches(ua));
  }

  /**
   * Extent patterns for known crawlers
   * @param  {string[]} filters
   * @returns {void}
   */
  extend() {
    let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    [].push.apply(_classPrivateFieldGet(this, _list), filters.filter(rule => _classPrivateMethodGet(this, _index, _index2).call(this, rule) === -1).map(filter => filter.toLowerCase()));
    _classPrivateMethodGet(this, _update, _update2).call(this);
  }

  /**
   * Exclude patterns from bot pattern rule
   * @param  {string[]} filters
   * @returns {void}
   */
  exclude() {
    let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let {
      length
    } = filters;
    while (length--) {
      const index = _classPrivateMethodGet(this, _index, _index2).call(this, filters[length]);
      if (index > -1) {
        _classPrivateFieldGet(this, _list).splice(index, 1);
      }
    }
    _classPrivateMethodGet(this, _update, _update2).call(this);
  }

  /**
   * Create a new Isbot instance using given list or self's list
   * @param  {string[]} [list]
   * @returns {Isbot}
   */
  spawn(list) {
    return new Isbot(list || _classPrivateFieldGet(this, _list));
  }
}
function _update2() {
  _classPrivateFieldSet(this, _pattern, new RegExp(_classPrivateFieldGet(this, _list).join('|'), flags));
}
function _index2(rule) {
  return _classPrivateFieldGet(this, _list).indexOf(rule.toLowerCase());
}

const isbot = new Isbot();


//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 2269:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 2746:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(1512);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(7211);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 9381:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ useSWR; }
});

// UNUSED EXPORTS: SWRConfig, mutate, preload, unstable_serialize, useSWRConfig

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(3100);
;// CONCATENATED MODULE: ../../node_modules/swr/_internal/dist/index.mjs


// Global state used to deduplicate requests and store listeners
const SWRGlobalState = new WeakMap();

const EMPTY_CACHE = {};
const INITIAL_CACHE = {};
const noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const UNDEFINED = /*#__NOINLINE__*/ noop();
const OBJECT = Object;
const isUndefined = (v)=>v === UNDEFINED;
const isFunction = (v)=>typeof v == 'function';
const mergeObjects = (a, b)=>({
        ...a,
        ...b
    });
const STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const isWindowDefined = typeof window != STR_UNDEFINED;
const isDocumentDefined = typeof document != STR_UNDEFINED;
const hasRequestAnimationFrame = ()=>isWindowDefined && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
const createCacheHelper = (cache, key)=>{
    const state = SWRGlobalState.get(cache);
    return [
        // Getter
        ()=>!isUndefined(key) && cache.get(key) || EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!isUndefined(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in INITIAL_CACHE)) {
                    INITIAL_CACHE[key] = prev;
                }
                state[5](key, mergeObjects(prev, info), prev || EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!isUndefined(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in INITIAL_CACHE) return INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !isUndefined(key) && cache.get(key) || EMPTY_CACHE;
        }
    ];
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const table = new WeakMap();
// counter of the key
let counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const stableHash = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++){
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            const keys = OBJECT.keys(arg).sort();
            while(!isUndefined(index = keys.pop())){
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    } else {
        result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    }
    return result;
};

/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let online = true;
const isOnline = ()=>online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [onWindowEvent, offWindowEvent] = isWindowDefined && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    noop,
    noop
];
const isVisible = ()=>{
    const visibilityState = isDocumentDefined && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
const initFocus = (callback)=>{
    // focus revalidate
    if (isDocumentDefined) {
        document.addEventListener('visibilitychange', callback);
    }
    onWindowEvent('focus', callback);
    return ()=>{
        if (isDocumentDefined) {
            document.removeEventListener('visibilitychange', callback);
        }
        offWindowEvent('focus', callback);
    };
};
const initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return ()=>{
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
const preset = {
    isOnline,
    isVisible
};
const defaultConfigOptions = {
    initFocus,
    initReconnect
};

const IS_REACT_LEGACY = !react.useId;
const IS_SERVER = !isWindowDefined || 'Deno' in window;
// Polyfill requestAnimationFrame
const rAF = (f)=>hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const useIsomorphicLayoutEffect = IS_SERVER ? react.useEffect : react.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
const navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const slowConnection = !IS_SERVER && navigatorConnection && ([
    'slow-2g',
    '2g'
].includes(navigatorConnection.effectiveType) || navigatorConnection.saveData);

const dist_serialize = (key)=>{
    if (isFunction(key)) {
        try {
            key = key();
        } catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? stableHash(key) : '';
    return [
        key,
        args
    ];
};

// Global timestamp.
let __timestamp = 0;
const getTimestamp = ()=>++__timestamp;

const FOCUS_EVENT = 0;
const RECONNECT_EVENT = 1;
const MUTATE_EVENT = 2;
const ERROR_REVALIDATE_EVENT = 3;

var constants = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT: ERROR_REVALIDATE_EVENT,
  FOCUS_EVENT: FOCUS_EVENT,
  MUTATE_EVENT: MUTATE_EVENT,
  RECONNECT_EVENT: RECONNECT_EVENT
};

async function internalMutate(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = mergeObjects({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const revalidate = options.revalidate !== false;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if (isFunction(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for(let keyIt = it.next(); !keyIt.done; keyIt = it.next()){
            const key = keyIt.value;
            if (// Skip the special useSWRInfinite and useSWRSubscription keys.
            !/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) {
                matchedKeys.push(key);
            }
        }
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = dist_serialize(_k);
        if (!key) return;
        const [get, set] = createCacheHelper(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH] = SWRGlobalState.get(cache);
        const revalidators = EVENT_REVALIDATORS[key];
        const startRevalidate = ()=>{
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                if (revalidators && revalidators[0]) {
                    return revalidators[0](MUTATE_EVENT).then(()=>get().data);
                }
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) {
            // Revalidate and broadcast state.
            return startRevalidate();
        }
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = getTimestamp();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !isUndefined(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = isUndefined(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = isFunction(optimisticData) ? optimisticData(committedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if (isFunction(data)) {
            // `data` is a function, call it passing current cache value.
            try {
                data = data(committedData);
            } catch (err) {
                // If it throws an error synchronously, we shouldn't update the cache.
                error = err;
            }
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && isFunction(data.then)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                data = committedData;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data,
                    _c: UNDEFINED
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if (isFunction(populateCache)) {
                    data = populateCache(data, committedData);
                }
                // Only update cached data if there's no error. Data can be `undefined` here.
                set({
                    data,
                    _c: UNDEFINED
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = getTimestamp();
        // Update existing SWR Hooks' internal states:
        const res = await startRevalidate();
        // The mutation and revalidation are ended, we can clear it since the data is
        // not an optimistic value anymore.
        set({
            _c: UNDEFINED
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return populateCache ? res : data;
    }
}

const revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators){
        if (revalidators[key][0]) revalidators[key][0](type);
    }
};
const initCache = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        const opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = internalMutate.bind(UNDEFINED, provider);
        let unmount = noop;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) {
                for (const fn of subs){
                    fn(value, prev);
                }
            }
        };
        const initProvider = ()=>{
            if (!SWRGlobalState.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                SWRGlobalState.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!IS_SERVER) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        SWRGlobalState.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        SWRGlobalState.get(provider)[4]
    ];
};

// error retry
const onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
const compare = (currentData, newData)=>stableHash(currentData) == stableHash(newData);
// Default cache provider
const [cache, mutate] = initCache(new Map());
// Default config
const defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare,
    isPaused: ()=>false,
    cache,
    mutate,
    fallback: {}
}, // use web preset by default
preset);

const mergeConfigs = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1 , fallback: f1  } = a;
        const { use: u2 , fallback: f2  } = b;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

const SWRConfigContext = (0,react.createContext)({});
const SWRConfig = (props)=>{
    const { value  } = props;
    const parentConfig = (0,react.useContext)(SWRConfigContext);
    const isFunctionalConfig = isFunction(value);
    const config = (0,react.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0,react.useMemo)(()=>isFunctionalConfig ? config : mergeConfigs(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0,react.useRef)(UNDEFINED);
    if (provider && !cacheContextRef.current) {
        cacheContextRef.current = initCache(provider(extendedConfig.cache || cache), config);
    }
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0,react.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

// @ts-expect-error
const enableDevtools = isWindowDefined && window.__SWR_DEVTOOLS_USE__;
const use = enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const setupDevTools = ()=>{
    if (enableDevtools) {
        // @ts-expect-error
        window.__SWR_DEVTOOLS_REACT__ = react;
    }
};

const normalize = (args)=>{
    return isFunction(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};

const useSWRConfig = ()=>{
    return mergeObjects(defaultConfig, (0,react.useContext)(SWRConfigContext));
};

const preload = (key_, fetcher)=>{
    const [key, fnArg] = dist_serialize(key_);
    const [, , , PRELOAD] = SWRGlobalState.get(cache);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = dist_serialize(key_);
            const [, , , PRELOAD] = SWRGlobalState.get(cache);
            const req = PRELOAD[key];
            if (req) {
                delete PRELOAD[key];
                return req;
            }
            return fetcher_(...args);
        });
        return useSWRNext(key_, fetcher, config);
    };

const BUILT_IN_MIDDLEWARE = use.concat(middleware);

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const withArgs = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = useSWRConfig();
        // Normalize arguments.
        const [key, fn, _config] = normalize(args);
        // Merge configurations.
        const config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use  } = config;
        const middleware = (use || []).concat(BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;){
            next = middleware[i](next);
        }
        return next(key, fn || config.fetcher || null, config);
    };
};

/**
 * An implementation of state with dependency-tracking.
 */ const useStateWithDeps = (state)=>{
    const rerender = useState({})[1];
    const unmountedRef = useRef(false);
    const stateRef = useRef(state);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    const stateDependenciesRef = useRef({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ const setState = useCallback((payload)=>{
        let shouldRerender = false;
        const currentState = stateRef.current;
        for(const _ in payload){
            const k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            if (IS_REACT_LEGACY) {
                rerender({});
            } else {
                React.startTransition(()=>rerender({}));
            }
        }
    }, // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    useIsomorphicLayoutEffect(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const subscribeCallback = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

// Create a custom hook with a middleware
const withMiddleware = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = normalize(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};

setupDevTools();



;// CONCATENATED MODULE: ../../node_modules/swr/core/dist/index.mjs





const WITH_DEDUPE = {
    dedupe: true
};
const useSWRHandler = (_key, fetcher, config)=>{
    const { cache , compare , suspense , fallbackData , revalidateOnMount , revalidateIfStale , refreshInterval , refreshWhenHidden , refreshWhenOffline , keepPreviousData  } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH] = SWRGlobalState.get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = dist_serialize(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0,react.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0,react.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0,react.useRef)(key);
    const fetcherRef = (0,react.useRef)(fetcher);
    const configRef = (0,react.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = createCacheHelper(cache, key);
    const stateDependencies = (0,react.useRef)({}).current;
    const fallback = isUndefined(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!isUndefined(prev[t])) {
                        return false;
                    }
                    if (!compare(returnedData, current[t])) {
                        return false;
                    }
                }
            } else {
                if (current[t] !== prev[t]) {
                    return false;
                }
            }
        }
        return true;
    };
    const getSnapshot = (0,react.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!isUndefined(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!isUndefined(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = mergeObjects(state);
            delete snapshot._k;
            if (!shouldStartRequest) {
                return snapshot;
            }
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0,shim.useSyncExternalStore)((0,react.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = isUndefined(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0,react.useRef)(data);
    const returnedData = keepPreviousData ? isUndefined(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !isUndefined(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !isUndefined(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return isUndefined(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return isUndefined(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = isUndefined(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = isUndefined(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0,react.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) {
            return false;
        }
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (IS_REACT_LEGACY) {
                return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            }
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) {
                delete FETCH[key];
            }
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if (isUndefined(getCache().data)) {
            initialState.isLoading = true;
        }
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && isUndefined(getCache().data)) {
                    setTimeout(()=>{
                        if (loading && callbackSafeguard()) {
                            getConfig().onLoadingSlow(key, config);
                        }
                    }, config.loadingTimeout);
                }
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    getTimestamp()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) {
                // If the request isn't interrupted, clean it up after the
                // deduplication interval.
                setTimeout(cleanupState, config.dedupingInterval);
            }
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) {
                        getConfig().onDiscarded(key);
                    }
                }
                return false;
            }
            // Clear error.
            finalState.error = UNDEFINED;
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!isUndefined(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) {
                        getConfig().onDiscarded(key);
                    }
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) {
                    getConfig().onSuccess(newData, key, config);
                }
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError  } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || isFunction(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (isActive()) {
                            // If it's inactive, stop. It will auto-revalidate when
                            // refocusing or reconnecting.
                            // When retrying, deduplication is always enabled.
                            currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                                const revalidators = EVENT_REVALIDATORS[key];
                                if (revalidators && revalidators[0]) {
                                    revalidators[0](constants.ERROR_REVALIDATE_EVENT, _opts);
                                }
                            }, {
                                retryCount: (opts.retryCount || 0) + 1,
                                dedupe: true
                            });
                        }
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const boundMutate = (0,react.useCallback)(// Use callback to make sure `keyRef.current` returns latest result every time
    (...args)=>{
        return internalMutate(cache, keyRef.current, ...args);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // The logic for updating refs.
    useIsomorphicLayoutEffect(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!isUndefined(cachedData)) {
            laggyDataRef.current = cachedData;
        }
    });
    // After mounted or key changed.
    useIsomorphicLayoutEffect(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == constants.FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == constants.RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            } else if (type == constants.MUTATE_EVENT) {
                return revalidate();
            } else if (type == constants.ERROR_REVALIDATE_EVENT) {
                return revalidate(opts);
            }
            return;
        };
        const unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation.
        if (shouldDoInitialRevalidation) {
            if (isUndefined(data) || IS_SERVER) {
                // Revalidate immediately.
                softRevalidate();
            } else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                rAF(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    useIsomorphicLayoutEffect(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = isFunction(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            } else {
                // Schedule the next interval to check again.
                next();
            }
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0,react.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && isUndefined(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!IS_REACT_LEGACY && IS_SERVER) {
            throw new Error('Fallback data is required when using suspense in SSR.');
        }
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const dist_SWRConfig = OBJECT.defineProperty(SWRConfig, 'defaultValue', {
    value: defaultConfig
});
const unstable_serialize = (key)=>serialize(key)[0];
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (!data) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const useSWR = withArgs(useSWRHandler);

// useSWR




/***/ }),

/***/ 624:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ue": function() { return /* binding */ create; }
});

// UNUSED EXPORTS: createStore, default, useStore

;// CONCATENATED MODULE: ../../node_modules/zustand/esm/vanilla.mjs
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if (( false ? 0 : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, subscribe, destroy };
  state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
var vanilla = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'."
    );
  }
  return createStore(createState);
};



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(1110);
;// CONCATENATED MODULE: ../../node_modules/zustand/esm/index.mjs





const { useSyncExternalStoreWithSelector } = with_selector;
let didWarnAboutEqualityFn = false;
function useStore(api, selector = api.getState, equalityFn) {
  if (( false ? 0 : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
    );
    didWarnAboutEqualityFn = true;
  }
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getState,
    selector,
    equalityFn
  );
  (0,react.useDebugValue)(slice);
  return slice;
}
const createImpl = (createState) => {
  if (( false ? 0 : void 0) !== "production" && typeof createState !== "function") {
    console.warn(
      "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
    );
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var esm_react = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
    );
  }
  return create(createState);
};




/***/ }),

/***/ 2532:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ shallow; }
/* harmony export */ });
/* unused harmony export default */
function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  if (objA instanceof Map && objB instanceof Map) {
    if (objA.size !== objB.size)
      return false;
    for (const [key, value] of objA) {
      if (!Object.is(value, objB.get(key))) {
        return false;
      }
    }
    return true;
  }
  if (objA instanceof Set && objB instanceof Set) {
    if (objA.size !== objB.size)
      return false;
    for (const value of objA) {
      if (!objB.has(value)) {
        return false;
      }
    }
    return true;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
var shallow$1 = (objA, objB) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { shallow } from 'zustand/shallow'`."
    );
  }
  return shallow(objA, objB);
};




/***/ })

}]);